import * as React from "react";
import React__default, { useState, useEffect, useCallback, useRef, useLayoutEffect, useMemo, forwardRef, useReducer, createContext, useContext, isValidElement, createElement, useImperativeHandle, Component, memo as memo$2, cloneElement } from "react";
import dayjs from "dayjs";
import { toast } from "react-hot-toast";
import { LngLatBounds, LngLat } from "mapbox-gl";
import * as ReactDOM from "react-dom";
import { createPortal } from "react-dom";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M49.3833 27.4543L33.4583 42.1404C32.925 42.5735 32.425 42.75 32 42.75C31.575 42.75 31.0025 42.572 30.6175 42.2136L14.6175 27.4543C13.8178 26.7244 13.7918 25.433 14.5575 24.7352C15.3179 23.9632 16.5892 23.9381 17.3833 24.6776L32 38.1621L46.6167 24.6871C47.4083 23.9476 48.6817 23.9727 49.4425 24.7447C50.2083 25.433 50.1833 26.7244 49.3833 27.4543Z" }));
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var f = React__default, k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for (b in a) m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: k, type: c, key: e, ref: h, props: d, _owner: n.current };
  }
  reactJsxRuntime_production_min.Fragment = l;
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var React2 = React__default;
      var REACT_ELEMENT_TYPE = Symbol.for("react.element");
      var REACT_PORTAL_TYPE = Symbol.for("react.portal");
      var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
      var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
      var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
      var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
      var REACT_CONTEXT_TYPE = Symbol.for("react.context");
      var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
      var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
      var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
      var REACT_MEMO_TYPE = Symbol.for("react.memo");
      var REACT_LAZY_TYPE = Symbol.for("react.lazy");
      var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
      var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") {
          return null;
        }
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") {
          return maybeIterator;
        }
        return null;
      }
      var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error(format) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
      }
      function printWarning(level, format, args) {
        {
          var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack = ReactDebugCurrentFrame2.getStackAddendum();
          if (stack !== "") {
            format += "%s";
            args = args.concat([stack]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      var enableScopeAPI = false;
      var enableCacheElement = false;
      var enableTransitionTracing = false;
      var enableLegacyHidden = false;
      var enableDebugTracing = false;
      var REACT_MODULE_REFERENCE;
      {
        REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
      }
      function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") {
          return true;
        }
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
          return true;
        }
        if (typeof type === "object" && type !== null) {
          if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== void 0) {
            return true;
          }
        }
        return false;
      }
      function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) {
          return displayName;
        }
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
      }
      function getContextName(type) {
        return type.displayName || "Context";
      }
      function getComponentNameFromType(type) {
        if (type == null) {
          return null;
        }
        {
          if (typeof type.tag === "number") {
            error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
          }
        }
        if (typeof type === "function") {
          return type.displayName || type.name || null;
        }
        if (typeof type === "string") {
          return type;
        }
        switch (type) {
          case REACT_FRAGMENT_TYPE:
            return "Fragment";
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_PROFILER_TYPE:
            return "Profiler";
          case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
          case REACT_SUSPENSE_TYPE:
            return "Suspense";
          case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_CONTEXT_TYPE:
              var context = type;
              return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
              var provider = type;
              return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
              return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
              var outerName = type.displayName || null;
              if (outerName !== null) {
                return outerName;
              }
              return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return getComponentNameFromType(init(payload));
              } catch (x) {
                return null;
              }
            }
          }
        }
        return null;
      }
      var assign = Object.assign;
      var disabledDepth = 0;
      var prevLog;
      var prevInfo;
      var prevWarn;
      var prevError;
      var prevGroup;
      var prevGroupCollapsed;
      var prevGroupEnd;
      function disabledLog() {
      }
      disabledLog.__reactDisabledLog = true;
      function disableLogs() {
        {
          if (disabledDepth === 0) {
            prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd;
            var props = {
              configurable: true,
              enumerable: true,
              value: disabledLog,
              writable: true
            };
            Object.defineProperties(console, {
              info: props,
              log: props,
              warn: props,
              error: props,
              group: props,
              groupCollapsed: props,
              groupEnd: props
            });
          }
          disabledDepth++;
        }
      }
      function reenableLogs() {
        {
          disabledDepth--;
          if (disabledDepth === 0) {
            var props = {
              configurable: true,
              enumerable: true,
              writable: true
            };
            Object.defineProperties(console, {
              log: assign({}, props, {
                value: prevLog
              }),
              info: assign({}, props, {
                value: prevInfo
              }),
              warn: assign({}, props, {
                value: prevWarn
              }),
              error: assign({}, props, {
                value: prevError
              }),
              group: assign({}, props, {
                value: prevGroup
              }),
              groupCollapsed: assign({}, props, {
                value: prevGroupCollapsed
              }),
              groupEnd: assign({}, props, {
                value: prevGroupEnd
              })
            });
          }
          if (disabledDepth < 0) {
            error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
      }
      var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
      var prefix;
      function describeBuiltInComponentFrame(name, source, ownerFn) {
        {
          if (prefix === void 0) {
            try {
              throw Error();
            } catch (x) {
              var match = x.stack.trim().match(/\n( *(at )?)/);
              prefix = match && match[1] || "";
            }
          }
          return "\n" + prefix + name;
        }
      }
      var reentry = false;
      var componentFrameCache;
      {
        var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
        componentFrameCache = new PossiblyWeakMap();
      }
      function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) {
          return "";
        }
        {
          var frame = componentFrameCache.get(fn);
          if (frame !== void 0) {
            return frame;
          }
        }
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var previousDispatcher;
        {
          previousDispatcher = ReactCurrentDispatcher.current;
          ReactCurrentDispatcher.current = null;
          disableLogs();
        }
        try {
          if (construct) {
            var Fake = function() {
              throw Error();
            };
            Object.defineProperty(Fake.prototype, "props", {
              set: function() {
                throw Error();
              }
            });
            if (typeof Reflect === "object" && Reflect.construct) {
              try {
                Reflect.construct(Fake, []);
              } catch (x) {
                control = x;
              }
              Reflect.construct(fn, [], Fake);
            } else {
              try {
                Fake.call();
              } catch (x) {
                control = x;
              }
              fn.call(Fake.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (x) {
              control = x;
            }
            fn();
          }
        } catch (sample) {
          if (sample && control && typeof sample.stack === "string") {
            var sampleLines = sample.stack.split("\n");
            var controlLines = control.stack.split("\n");
            var s = sampleLines.length - 1;
            var c = controlLines.length - 1;
            while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
              c--;
            }
            for (; s >= 1 && c >= 0; s--, c--) {
              if (sampleLines[s] !== controlLines[c]) {
                if (s !== 1 || c !== 1) {
                  do {
                    s--;
                    c--;
                    if (c < 0 || sampleLines[s] !== controlLines[c]) {
                      var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                      if (fn.displayName && _frame.includes("<anonymous>")) {
                        _frame = _frame.replace("<anonymous>", fn.displayName);
                      }
                      {
                        if (typeof fn === "function") {
                          componentFrameCache.set(fn, _frame);
                        }
                      }
                      return _frame;
                    }
                  } while (s >= 1 && c >= 0);
                }
                break;
              }
            }
          }
        } finally {
          reentry = false;
          {
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
          }
          Error.prepareStackTrace = previousPrepareStackTrace;
        }
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        {
          if (typeof fn === "function") {
            componentFrameCache.set(fn, syntheticFrame);
          }
        }
        return syntheticFrame;
      }
      function describeFunctionComponentFrame(fn, source, ownerFn) {
        {
          return describeNativeComponentFrame(fn, false);
        }
      }
      function shouldConstruct(Component2) {
        var prototype = Component2.prototype;
        return !!(prototype && prototype.isReactComponent);
      }
      function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) {
          return "";
        }
        if (typeof type === "function") {
          {
            return describeNativeComponentFrame(type, shouldConstruct(type));
          }
        }
        if (typeof type === "string") {
          return describeBuiltInComponentFrame(type);
        }
        switch (type) {
          case REACT_SUSPENSE_TYPE:
            return describeBuiltInComponentFrame("Suspense");
          case REACT_SUSPENSE_LIST_TYPE:
            return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") {
          switch (type.$$typeof) {
            case REACT_FORWARD_REF_TYPE:
              return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
              return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE: {
              var lazyComponent = type;
              var payload = lazyComponent._payload;
              var init = lazyComponent._init;
              try {
                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
              } catch (x) {
              }
            }
          }
        }
        return "";
      }
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var loggedTypeFailures = {};
      var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame.setExtraStackFrame(null);
          }
        }
      }
      function checkPropTypes(typeSpecs, values, location2, componentName, element) {
        {
          var has = Function.call.bind(hasOwnProperty);
          for (var typeSpecName in typeSpecs) {
            if (has(typeSpecs, typeSpecName)) {
              var error$1 = void 0;
              try {
                if (typeof typeSpecs[typeSpecName] !== "function") {
                  var err = Error((componentName || "React class") + ": " + location2 + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  err.name = "Invariant Violation";
                  throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location2, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (ex) {
                error$1 = ex;
              }
              if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location2, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
              }
              if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location2, error$1.message);
                setCurrentlyValidatingElement(null);
              }
            }
          }
        }
      }
      var isArrayImpl = Array.isArray;
      function isArray(a) {
        return isArrayImpl(a);
      }
      function typeName(value) {
        {
          var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
          var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
          return type;
        }
      }
      function willCoercionThrow(value) {
        {
          try {
            testStringCoercion(value);
            return false;
          } catch (e) {
            return true;
          }
        }
      }
      function testStringCoercion(value) {
        return "" + value;
      }
      function checkKeyStringCoercion(value) {
        {
          if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value);
          }
        }
      }
      var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
      var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
      };
      var specialPropKeyWarningShown;
      var specialPropRefWarningShown;
      function hasValidRef(config) {
        {
          if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.ref !== void 0;
      }
      function hasValidKey(config) {
        {
          if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) {
              return false;
            }
          }
        }
        return config.key !== void 0;
      }
      function warnIfStringRefCannotBeAutoConverted(config, self2) {
        {
          if (typeof config.ref === "string" && ReactCurrentOwner.current && self2) ;
        }
      }
      function defineKeyPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
              specialPropKeyWarningShown = true;
              error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingKey.isReactWarning = true;
          Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
          });
        }
      }
      function defineRefPropWarningGetter(props, displayName) {
        {
          var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
              specialPropRefWarningShown = true;
              error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
          };
          warnAboutAccessingRef.isReactWarning = true;
          Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
          });
        }
      }
      var ReactElement = function(type, key, ref, self2, source, owner, props) {
        var element = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: REACT_ELEMENT_TYPE,
          // Built-in properties that belong on the element
          type,
          key,
          ref,
          props,
          // Record the component responsible for creating this element.
          _owner: owner
        };
        {
          element._store = {};
          Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
          });
          Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self2
          });
          Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
          });
          if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
          }
        }
        return element;
      };
      function jsxDEV(type, config, maybeKey, source, self2) {
        {
          var propName;
          var props = {};
          var key = null;
          var ref = null;
          if (maybeKey !== void 0) {
            {
              checkKeyStringCoercion(maybeKey);
            }
            key = "" + maybeKey;
          }
          if (hasValidKey(config)) {
            {
              checkKeyStringCoercion(config.key);
            }
            key = "" + config.key;
          }
          if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self2);
          }
          for (propName in config) {
            if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
              props[propName] = config[propName];
            }
          }
          if (type && type.defaultProps) {
            var defaultProps2 = type.defaultProps;
            for (propName in defaultProps2) {
              if (props[propName] === void 0) {
                props[propName] = defaultProps2[propName];
              }
            }
          }
          if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) {
              defineKeyPropWarningGetter(props, displayName);
            }
            if (ref) {
              defineRefPropWarningGetter(props, displayName);
            }
          }
          return ReactElement(type, key, ref, self2, source, ReactCurrentOwner.current, props);
        }
      }
      var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
      var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
      function setCurrentlyValidatingElement$1(element) {
        {
          if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
          } else {
            ReactDebugCurrentFrame$1.setExtraStackFrame(null);
          }
        }
      }
      var propTypesMisspellWarningShown;
      {
        propTypesMisspellWarningShown = false;
      }
      function isValidElement2(object) {
        {
          return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
        }
      }
      function getDeclarationErrorAddendum() {
        {
          if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) {
              return "\n\nCheck the render method of `" + name + "`.";
            }
          }
          return "";
        }
      }
      function getSourceInfoErrorAddendum(source) {
        {
          return "";
        }
      }
      var ownerHasKeyUseWarning = {};
      function getCurrentComponentErrorInfo(parentType) {
        {
          var info = getDeclarationErrorAddendum();
          if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) {
              info = "\n\nCheck the top-level render call using <" + parentName + ">.";
            }
          }
          return info;
        }
      }
      function validateExplicitKey(element, parentType) {
        {
          if (!element._store || element._store.validated || element.key != null) {
            return;
          }
          element._store.validated = true;
          var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
          if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
            return;
          }
          ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
          var childOwner = "";
          if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
            childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
          }
          setCurrentlyValidatingElement$1(element);
          error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
          setCurrentlyValidatingElement$1(null);
        }
      }
      function validateChildKeys(node, parentType) {
        {
          if (typeof node !== "object") {
            return;
          }
          if (isArray(node)) {
            for (var i = 0; i < node.length; i++) {
              var child = node[i];
              if (isValidElement2(child)) {
                validateExplicitKey(child, parentType);
              }
            }
          } else if (isValidElement2(node)) {
            if (node._store) {
              node._store.validated = true;
            }
          } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") {
              if (iteratorFn !== node.entries) {
                var iterator = iteratorFn.call(node);
                var step;
                while (!(step = iterator.next()).done) {
                  if (isValidElement2(step.value)) {
                    validateExplicitKey(step.value, parentType);
                  }
                }
              }
            }
          }
        }
      }
      function validatePropTypes(element) {
        {
          var type = element.type;
          if (type === null || type === void 0 || typeof type === "string") {
            return;
          }
          var propTypes;
          if (typeof type === "function") {
            propTypes = type.propTypes;
          } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          type.$$typeof === REACT_MEMO_TYPE)) {
            propTypes = type.propTypes;
          } else {
            return;
          }
          if (propTypes) {
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
          } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true;
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
          }
          if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
            error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
      }
      function validateFragmentProps(fragment) {
        {
          var keys = Object.keys(fragment.props);
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key !== "children" && key !== "key") {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
              setCurrentlyValidatingElement$1(null);
              break;
            }
          }
          if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
          }
        }
      }
      function jsxWithValidation(type, props, key, isStaticChildren, source, self2) {
        {
          var validType = isValidElementType(type);
          if (!validType) {
            var info = "";
            if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
              info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            }
            var sourceInfo = getSourceInfoErrorAddendum();
            if (sourceInfo) {
              info += sourceInfo;
            } else {
              info += getDeclarationErrorAddendum();
            }
            var typeString;
            if (type === null) {
              typeString = "null";
            } else if (isArray(type)) {
              typeString = "array";
            } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
              typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
              info = " Did you accidentally export a JSX literal instead of a component?";
            } else {
              typeString = typeof type;
            }
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
          }
          var element = jsxDEV(type, props, key, source, self2);
          if (element == null) {
            return element;
          }
          if (validType) {
            var children = props.children;
            if (children !== void 0) {
              if (isStaticChildren) {
                if (isArray(children)) {
                  for (var i = 0; i < children.length; i++) {
                    validateChildKeys(children[i], type);
                  }
                  if (Object.freeze) {
                    Object.freeze(children);
                  }
                } else {
                  error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                }
              } else {
                validateChildKeys(children, type);
              }
            }
          }
          if (type === REACT_FRAGMENT_TYPE) {
            validateFragmentProps(element);
          } else {
            validatePropTypes(element);
          }
          return element;
        }
      }
      function jsxWithValidationStatic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, true);
        }
      }
      function jsxWithValidationDynamic(type, props, key) {
        {
          return jsxWithValidation(type, props, key, false);
        }
      }
      var jsx2 = jsxWithValidationDynamic;
      var jsxs2 = jsxWithValidationStatic;
      reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
      reactJsxRuntime_development.jsx = jsx2;
      reactJsxRuntime_development.jsxs = jsxs2;
    })();
  }
  return reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime.exports = requireReactJsxRuntime_production_min();
  } else {
    jsxRuntime.exports = requireReactJsxRuntime_development();
  }
  return jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
const Fragment = jsxRuntimeExports.Fragment;
const jsx = jsxRuntimeExports.jsx;
const jsxs = jsxRuntimeExports.jsxs;
const Accordion = (props) => {
  const {
    header,
    content,
    isOpen: defaultOpen = true,
    onOpenChange,
    isHeaderToggleButton = true,
    collapseIconClasses
  } = props;
  const [isOpen, setIsOpen] = useState(defaultOpen);
  useEffect(() => setIsOpen(defaultOpen), [defaultOpen]);
  const handleToggle = useCallback(() => {
    setIsOpen((prev) => {
      onOpenChange == null ? void 0 : onOpenChange(!prev);
      return !prev;
    });
  }, [onOpenChange]);
  const handleKeyPress = useCallback((event) => {
    event.preventDefault();
    const triggers = ["Space", "Enter"];
    if (triggers.includes(event.code)) {
      handleToggle();
    }
  }, [handleToggle]);
  const formattedHeader = typeof header === "string" ? /* @__PURE__ */ jsx("h3", {
    className: "py-6 text-gray-900",
    children: header
  }) : header;
  return /* @__PURE__ */ jsxs("div", {
    className: "w-full",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex",
      children: [!isHeaderToggleButton && formattedHeader, /* @__PURE__ */ jsxs("button", {
        className: `flex cursor-pointer select-none items-start justify-between ${isHeaderToggleButton ? "w-full" : "ml-auto"} ${typeof header === "string" && !isHeaderToggleButton ? "py-6" : ""}`,
        onClick: handleToggle,
        onKeyDown: handleKeyPress,
        "aria-label": typeof header === "string" ? header : "accordion",
        tabIndex: 0,
        children: [isHeaderToggleButton && formattedHeader, /* @__PURE__ */ jsx(SvgChevronDown, {
          "aria-label": "Collapse content",
          className: `transition-all max-w-8 max-h-8 text-gray-900 fill-current ${isOpen ? "rotate-180	" : "rotate-0"}` + collapseIconClasses
        })]
      })]
    }), isOpen && /* @__PURE__ */ jsx("div", {
      children: content
    })]
  });
};
const itemStyles$2 = {
  base: "box-border p-2 border border-1 border-solid cursor-pointer focus:border-gray-900 hover:border-gray-100",
  unselected: "bg-white focus:bg-white hover:bg-gray-50 border-white",
  selected: "focus:bg-jungle-50 hover:bg-jungle-100 bg-jungle-50 border-jungle-50"
};
const iconStyles$1 = {
  base: "h-4 w-12 inline",
  unselected: "fill-transparent",
  selected: "fill-gray-900"
};
const highlight = (str, highlighted) => {
  if (!highlighted || highlighted == "" || !str.toLowerCase().includes(highlighted.toLowerCase())) return str;
  const parts = str.split(new RegExp(`(${highlighted})`, "gi")).map((value, index2) => ({
    value,
    key: value.slice(0, index2) + str + index2
  }));
  return /* @__PURE__ */ jsx(Fragment, {
    children: parts.map((part) => /* @__PURE__ */ jsx("span", {
      className: part.value.toLowerCase() === highlighted.toLowerCase() ? "font-bold text-primary" : "",
      children: part.value
    }, part.key))
  });
};
const matchesSearch$1 = (item, searchTerm) => {
  var _a;
  const search = searchTerm.toLowerCase();
  return item.label.toLowerCase().includes(search) || item.value.toLowerCase().includes(search) || ((_a = item.tagText) == null ? void 0 : _a.toLowerCase().includes(search));
};
const defaultRenderListItem = (item, isSelected) => /* @__PURE__ */ jsxs(Fragment, {
  children: [/* @__PURE__ */ jsx(SvgCheckMark, {
    className: addStyles([iconStyles$1.base, isSelected ? iconStyles$1.selected : iconStyles$1.unselected])
  }), highlight(item.label, item.textToHighlight)]
});
const renderListItemWithTag = (item, isSelected) => /* @__PURE__ */ jsxs("div", {
  className: "flex items-start",
  children: [/* @__PURE__ */ jsx("div", {
    className: "w-10",
    children: /* @__PURE__ */ jsx(SvgCheckMark, {
      className: "h-4 inline mt-1 " + (isSelected ? "fill-gray-900" : "fill-transparent")
    })
  }), /* @__PURE__ */ jsxs("div", {
    className: "grow pl-3",
    children: [/* @__PURE__ */ jsx("div", {
      children: highlight(item.label, item.textToHighlight)
    }), /* @__PURE__ */ jsx("div", {
      className: "pt-1 text-xs text-gray-700",
      children: item.subtext
    })]
  }), /* @__PURE__ */ jsx("div", {
    className: "whitespace-nowrap",
    children: /* @__PURE__ */ jsx(TableTag, {
      type: "default",
      className: "rounded",
      text: item.tagText ?? "",
      leftIcon: item.tagLeftIcon,
      leftIconClassName: "h-4 w-4 mr-1 inline"
    })
  })]
});
const FilterComboBoxMenuItem = (props) => {
  const {
    item,
    className,
    onSelect,
    defaultSelection,
    renderItem = defaultRenderListItem
  } = props;
  const [isSelected, setIsSelected] = useState(defaultSelection ?? false);
  const ref = useRef(null);
  useEffect(() => setIsSelected(defaultSelection === true), [defaultSelection]);
  const onClick = useCallback((e) => {
    onSelect(item, !isSelected);
    setIsSelected(!isSelected);
    e.stopPropagation();
  }, [isSelected, item, onSelect]);
  return /* @__PURE__ */ jsx("div", {
    role: "menuitem",
    tabIndex: 0,
    ref,
    onClick,
    title: item.label,
    onMouseUp: () => {
      ref.current.blur();
    },
    onMouseLeave: () => {
      ref.current.blur();
    },
    className: mergeStyles([itemStyles$2.base, itemStyles$2[isSelected ? "selected" : "unselected"], className]),
    children: /* @__PURE__ */ jsx("span", {
      className: "select-none",
      children: renderItem(item, isSelected)
    })
  });
};
const sides = ["top", "right", "bottom", "left"];
const alignments = ["start", "end"];
const placements = /* @__PURE__ */ sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min$1 = Math.min;
const max$1 = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v) => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max$1(start, min$1(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  return {
    ...rect,
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
      continue;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options2) {
  var _await$platform$isEle;
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    x,
    y,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options2, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    ...rects.floating,
    x,
    y
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const arrow$1 = (options2) => ({
  name: "arrow",
  options: options2,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform: platform2,
      elements
    } = state;
    const {
      element,
      padding = 0
    } = evaluate(options2, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min$1(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min$1(paddingObject[maxProp], largestPossiblePadding);
    const min$1$1 = minPadding;
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset2 = clamp(min$1$1, center, max2);
    const shouldAddOffset = getAlignment(placement) != null && center != offset2 && rects.reference[length] / 2 - (center < min$1$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1$1 ? min$1$1 - center : max2 - center : 0;
    return {
      [axis]: coords[axis] - alignmentOffset,
      data: {
        [axis]: offset2,
        centerOffset: center - offset2 + alignmentOffset
      }
    };
  }
});
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter((placement) => getAlignment(placement) === alignment), ...allowedPlacements.filter((placement) => getAlignment(placement) !== alignment)] : allowedPlacements.filter((placement) => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter((placement) => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
const autoPlacement = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "autoPlacement",
    options: options2,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform: platform2,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options2, state);
      const placements$1 = alignment !== void 0 || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)));
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [], {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map((d) => {
        const alignment2 = getAlignment(d.placement);
        return [d.placement, alignment2 && crossAxis ? (
          // Check along the mainAxis and main crossAxis side.
          d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0)
        ) : (
          // Check only the mainAxis.
          d.overflows[0]
        ), d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d) => d[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        getAlignment(d[0]) ? 2 : 3
      ).every((v) => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};
async function convertValueToCoords(state, options2) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options2, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset = function(options2) {
  if (options2 === void 0) {
    options2 = 0;
  }
  return {
    name: "offset",
    options: options2,
    async fn(state) {
      const {
        x,
        y
      } = state;
      const diffCoords = await convertValueToCoords(state, options2);
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: diffCoords
      };
    }
  };
};
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const webkit = isWebKit();
  const css = getComputedStyle$1(element);
  return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || ["transform", "perspective", "filter"].some((value) => (css.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
  return ["html", "body", "#document"].includes(getNodeName(node));
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor));
}
function getCssDimensions(element) {
  const css = getComputedStyle$1(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;
  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentIFrame = win.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== win) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentIFrame = getWindow(currentIFrame).frameElement;
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  if (offsetParent === documentElement) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max$1(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max$1(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === "rtl") {
    x += max$1(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      ...clippingAncestor,
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max$1(rect.top, accRect.top);
    accRect.right = min$1(rect.right, accRect.right);
    accRect.bottom = min$1(rect.bottom, accRect.bottom);
    accRect.left = max$1(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  return getCssDimensions(element);
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  return element.offsetParent;
}
function getOffsetParent(element, polyfill) {
  const window2 = getWindow(element);
  if (!isHTMLElement(element)) {
    return window2;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static" && !isContainingBlock(offsetParent))) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
const getElementRects = async function(_ref) {
  let {
    reference,
    floating,
    strategy
  } = _ref;
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  return {
    reference: getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
    floating: {
      x: 0,
      y: 0,
      ...await getDimensionsFn(floating)
    }
  };
};
function isRTL(element) {
  return getComputedStyle$1(element).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function observeMove(element, onMove) {
  let io = null;
  let timeoutId2;
  const root = getDocumentElement(element);
  function cleanup() {
    clearTimeout(timeoutId2);
    io && io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options2 = {
      rootMargin,
      threshold: max$1(0, min$1(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId2 = setTimeout(() => {
            refresh(false, 1e-7);
          }, 100);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options2,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options2);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options2;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          resizeObserver && resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo && cleanupIo();
    resizeObserver && resizeObserver.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const computePosition = (reference, floating, options2) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options2
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
const arrow = (options2) => {
  function isRef2(value) {
    return {}.hasOwnProperty.call(value, "current");
  }
  return {
    name: "arrow",
    options: options2,
    fn(state) {
      const {
        element,
        padding
      } = typeof options2 === "function" ? options2(state) : options2;
      if (element && isRef2(element)) {
        if (element.current != null) {
          return arrow$1({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      } else if (element) {
        return arrow$1({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};
var index$2 = typeof document !== "undefined" ? useLayoutEffect : useEffect;
function deepEqual$1(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === "function" && a.toString() === b.toString()) {
    return true;
  }
  let length, i, keys;
  if (a && b && typeof a == "object") {
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0; ) {
        if (!deepEqual$1(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i = length; i-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b, keys[i])) {
        return false;
      }
    }
    for (i = length; i-- !== 0; ) {
      const key = keys[i];
      if (key === "_owner" && a.$$typeof) {
        continue;
      }
      if (!deepEqual$1(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
function getDPR(element) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef$1(value) {
  const ref = React.useRef(value);
  index$2(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating$1(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options2;
  const [data, setData] = React.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React.useState(middleware);
  if (!deepEqual$1(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React.useState(null);
  const [_floating, _setFloating] = React.useState(null);
  const setReference = React.useCallback((node) => {
    if (node != referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, [_setReference]);
  const setFloating = React.useCallback((node) => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, [_setFloating]);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React.useRef(null);
  const floatingRef = React.useRef(null);
  const dataRef = React.useRef(data);
  const whileElementsMountedRef = useLatestRef$1(whileElementsMounted);
  const platformRef = useLatestRef$1(platform2);
  const update = React.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition(referenceRef.current, floatingRef.current, config).then((data2) => {
      const fullData = {
        ...data2,
        isPositioned: true
      };
      if (isMountedRef.current && !deepEqual$1(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef]);
  index$2(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => ({
        ...data2,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React.useRef(false);
  index$2(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index$2(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      } else {
        update();
      }
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef]);
  const refs = React.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...getDPR(elements.floating) >= 1.5 && {
          willChange: "transform"
        }
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}
function activeElement(doc) {
  let activeElement2 = doc.activeElement;
  while (((_activeElement = activeElement2) == null ? void 0 : (_activeElement$shadow = _activeElement.shadowRoot) == null ? void 0 : _activeElement$shadow.activeElement) != null) {
    var _activeElement, _activeElement$shadow;
    activeElement2 = activeElement2.shadowRoot.activeElement;
  }
  return activeElement2;
}
function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  }
  if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      next = next.parentNode || next.host;
    }
  }
  return false;
}
function getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map((_ref) => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function isVirtualClick(event) {
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  const androidRe = /Android/i;
  if ((androidRe.test(getPlatform()) || androidRe.test(getUserAgent())) && event.pointerType) {
    return event.type === "click" && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
  return event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType !== "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0;
}
function isSafari$1() {
  return /apple/i.test(navigator.vendor);
}
function isMouseLikePointerType(pointerType, strict) {
  const values = ["mouse", "pen"];
  if (!strict) {
    values.push("", void 0);
  }
  return values.includes(pointerType);
}
function isReactEvent(event) {
  return "nativeEvent" in event;
}
function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ("composedPath" in event) {
    return event.composedPath().includes(node);
  }
  const e = event;
  return e.target != null && node.contains(e.target);
}
function getTarget(event) {
  if ("composedPath" in event) {
    return event.composedPath()[0];
  }
  return event.target;
}
const TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(element) {
  return isHTMLElement(element) && element.matches(TYPEABLE_SELECTOR);
}
function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}
var getDefaultParent = function(originalTarget) {
  if (typeof document === "undefined") {
    return null;
  }
  var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
  return sampleTarget.ownerDocument.body;
};
var counterMap = /* @__PURE__ */ new WeakMap();
var uncontrolledNodes = /* @__PURE__ */ new WeakMap();
var markerMap = {};
var lockCount = 0;
var unwrapHost = function(node) {
  return node && (node.host || unwrapHost(node.parentNode));
};
var correctTargets = function(parent, targets) {
  return targets.map(function(target) {
    if (parent.contains(target)) {
      return target;
    }
    var correctedTarget = unwrapHost(target);
    if (correctedTarget && parent.contains(correctedTarget)) {
      return correctedTarget;
    }
    console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
    return null;
  }).filter(function(x) {
    return Boolean(x);
  });
};
var applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
  var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */ new WeakMap();
  }
  var markerCounter = markerMap[markerName];
  var hiddenNodes = [];
  var elementsToKeep = /* @__PURE__ */ new Set();
  var elementsToStop = new Set(targets);
  var keep = function(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    keep(el.parentNode);
  };
  targets.forEach(keep);
  var deep = function(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    Array.prototype.forEach.call(parent.children, function(node) {
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        var attr = node.getAttribute(controlAttribute);
        var alreadyHidden = attr !== null && attr !== "false";
        var counterValue = (counterMap.get(node) || 0) + 1;
        var markerValue = (markerCounter.get(node) || 0) + 1;
        counterMap.set(node, counterValue);
        markerCounter.set(node, markerValue);
        hiddenNodes.push(node);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledNodes.set(node, true);
        }
        if (markerValue === 1) {
          node.setAttribute(markerName, "true");
        }
        if (!alreadyHidden) {
          node.setAttribute(controlAttribute, "true");
        }
      }
    });
  };
  deep(parentNode);
  elementsToKeep.clear();
  lockCount++;
  return function() {
    hiddenNodes.forEach(function(node) {
      var counterValue = counterMap.get(node) - 1;
      var markerValue = markerCounter.get(node) - 1;
      counterMap.set(node, counterValue);
      markerCounter.set(node, markerValue);
      if (!counterValue) {
        if (!uncontrolledNodes.has(node)) {
          node.removeAttribute(controlAttribute);
        }
        uncontrolledNodes.delete(node);
      }
      if (!markerValue) {
        node.removeAttribute(markerName);
      }
    });
    lockCount--;
    if (!lockCount) {
      counterMap = /* @__PURE__ */ new WeakMap();
      counterMap = /* @__PURE__ */ new WeakMap();
      uncontrolledNodes = /* @__PURE__ */ new WeakMap();
      markerMap = {};
    }
  };
};
var hideOthers = function(originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = "data-aria-hidden";
  }
  var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
  var activeParentNode = parentNode || getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function() {
      return null;
    };
  }
  targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
  return applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var inertOthers = function(originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = "data-inert-ed";
  }
  var activeParentNode = parentNode || getDefaultParent(originalTarget);
  if (!activeParentNode) {
    return function() {
      return null;
    };
  }
  return applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var supportsInert = function() {
  return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var suppressOthers = function(originalTarget, parentNode, markerName) {
  if (markerName === void 0) {
    markerName = "data-suppressed";
  }
  return (supportsInert() ? inertOthers : hideOthers)(originalTarget, parentNode, markerName);
};
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
var isInert = function isInert2(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
  var inert = inertAtt === "" || inertAtt === "true";
  var result = inert || lookUp && node && isInert2(node.parentNode);
  return result;
};
var isContentEditable = function isContentEditable2(node) {
  var _node$getAttribute2;
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
  return attValue === "" || attValue === "true";
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options2) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      continue;
    }
    if (element.tagName === "SLOT") {
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively2(content, true, options2);
      if (options2.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options2.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }
      var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
      typeof options2.getShadowRoot === "function" && options2.getShadowRoot(element);
      var validShadowRoot = !isInert(shadowRoot, false) && (!options2.shadowRootFilter || options2.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options2);
        if (options2.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var hasTabIndex = function hasTabIndex2(node) {
  return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
var getTabIndex = function getTabIndex2(node) {
  if (!node) {
    throw new Error("No node provided");
  }
  if (node.tabIndex < 0) {
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
      return 0;
    }
  }
  return node.tabIndex;
};
var getSortOrderTabIndex = function getSortOrderTabIndex2(node, isScope) {
  var tabIndex = getTabIndex(node);
  if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
  return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
  return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
  var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
    return child.tagName === "SUMMARY";
  });
  return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};
var isTabbableRadio = function isTabbableRadio2(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios2(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
  return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
  return isRadio(node) && !isTabbableRadio(node);
};
var isNodeAttached = function isNodeAttached2(node) {
  var _nodeRoot;
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea2(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
  var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
  if (getComputedStyle(node).visibility === "hidden") {
    return true;
  }
  var isDirectSummary = matches.call(node, "details>summary:first-of-type");
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
    return true;
  }
  if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
    if (typeof getShadowRoot === "function") {
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) {
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          node = rootNode.host;
        } else {
          node = parentElement;
        }
      }
      node = originalNode;
    }
    if (isNodeAttached(node)) {
      return !node.getClientRects().length;
    }
    if (displayCheck !== "legacy-full") {
      return true;
    }
  } else if (displayCheck === "non-zero-area") {
    return isZeroArea(node);
  }
  return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    while (parentNode) {
      if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i);
          if (child.tagName === "LEGEND") {
            return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
          }
        }
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options2, node) {
  if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options2) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options2, node) {
  if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options2, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  return false;
};
var sortByOrder = function sortByOrder2(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function(item, i) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? sortByOrder2(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item,
        isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(container, options2) {
  options2 = options2 || {};
  var candidates;
  if (options2.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options2.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options2),
      flatten: false,
      getShadowRoot: options2.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container, options2.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options2));
  }
  return sortByOrder(candidates);
};
var index$1 = typeof document !== "undefined" ? useLayoutEffect : useEffect;
let serverHandoffComplete = false;
let count$1 = 0;
const genId = () => "floating-ui-" + count$1++;
function useFloatingId() {
  const [id, setId] = React.useState(() => serverHandoffComplete ? genId() : void 0);
  index$1(() => {
    if (id == null) {
      setId(genId());
    }
  }, []);
  React.useEffect(() => {
    if (!serverHandoffComplete) {
      serverHandoffComplete = true;
    }
  }, []);
  return id;
}
const useReactId = React[/* @__PURE__ */ "useId".toString()];
const useId = useReactId || useFloatingId;
const FloatingArrow = /* @__PURE__ */ React.forwardRef(function FloatingArrow2(_ref, ref) {
  let {
    context: {
      placement,
      elements: {
        floating
      },
      middlewareData: {
        arrow: arrow2
      }
    },
    width = 14,
    height = 7,
    tipRadius = 0,
    strokeWidth = 0,
    staticOffset,
    stroke,
    d,
    style: {
      transform,
      ...restStyle
    } = {},
    ...rest
  } = _ref;
  if (process.env.NODE_ENV !== "production") {
    if (!ref) {
      console.warn("Floating UI: The `ref` prop is required for the `FloatingArrow`", "component.");
    }
  }
  const clipPathId = useId();
  if (!floating) {
    return null;
  }
  strokeWidth *= 2;
  const halfStrokeWidth = strokeWidth / 2;
  const svgX = width / 2 * (tipRadius / -8 + 1);
  const svgY = height / 2 * tipRadius / 4;
  const [side, alignment] = placement.split("-");
  const isRTL2 = platform.isRTL(floating);
  const isCustomShape = !!d;
  const isVerticalSide = side === "top" || side === "bottom";
  const yOffsetProp = staticOffset && alignment === "end" ? "bottom" : "top";
  let xOffsetProp = staticOffset && alignment === "end" ? "right" : "left";
  if (staticOffset && isRTL2) {
    xOffsetProp = alignment === "end" ? "left" : "right";
  }
  const arrowX = (arrow2 == null ? void 0 : arrow2.x) != null ? staticOffset || arrow2.x : "";
  const arrowY = (arrow2 == null ? void 0 : arrow2.y) != null ? staticOffset || arrow2.y : "";
  const dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
  const rotation = {
    top: isCustomShape ? "rotate(180deg)" : "",
    left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: isCustomShape ? "" : "rotate(180deg)",
    right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
  }[side];
  return /* @__PURE__ */ jsxs("svg", {
    ...rest,
    "aria-hidden": true,
    ref,
    width: isCustomShape ? width : width + strokeWidth,
    height: width,
    viewBox: "0 0 " + width + " " + (height > width ? height : width),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [xOffsetProp]: arrowX,
      [yOffsetProp]: arrowY,
      [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + strokeWidth / 2 + "px)",
      transform: "" + rotation + (transform != null ? transform : ""),
      ...restStyle
    },
    children: [strokeWidth > 0 && /* @__PURE__ */ jsx("path", {
      clipPath: "url(#" + clipPathId + ")",
      fill: "none",
      stroke,
      strokeWidth: strokeWidth + (d ? 0 : 1),
      d: dValue
    }), /* @__PURE__ */ jsx("path", {
      stroke: strokeWidth && !d ? rest.fill : "none",
      d: dValue
    }), /* @__PURE__ */ jsx("clipPath", {
      id: clipPathId,
      children: /* @__PURE__ */ jsx("rect", {
        x: -halfStrokeWidth,
        y: halfStrokeWidth * (isCustomShape ? -1 : 1),
        width: width + strokeWidth,
        height: width
      })
    })]
  });
});
function createPubSub() {
  const map = /* @__PURE__ */ new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null ? void 0 : _map$get.forEach((handler) => handler(data));
    },
    on(event, listener) {
      map.set(event, [...map.get(event) || [], listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l) => l !== listener)) || []);
    }
  };
}
const FloatingNodeContext = /* @__PURE__ */ React.createContext(null);
const FloatingTreeContext = /* @__PURE__ */ React.createContext(null);
const useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = React.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
const useFloatingTree = () => React.useContext(FloatingTreeContext);
function useFloatingNodeId(customParentId) {
  const id = useId();
  const tree = useFloatingTree();
  const reactParentId = useFloatingParentNodeId();
  const parentId = customParentId || reactParentId;
  index$1(() => {
    const node = {
      id,
      parentId
    };
    tree == null ? void 0 : tree.addNode(node);
    return () => {
      tree == null ? void 0 : tree.removeNode(node);
    };
  }, [tree, id, parentId]);
  return id;
}
function FloatingNode(_ref) {
  let {
    children,
    id
  } = _ref;
  const parentId = useFloatingParentNodeId();
  return /* @__PURE__ */ jsx(FloatingNodeContext.Provider, {
    value: React.useMemo(() => ({
      id,
      parentId
    }), [id, parentId]),
    children
  });
}
function FloatingTree(_ref2) {
  let {
    children
  } = _ref2;
  const nodesRef = React.useRef([]);
  const addNode = React.useCallback((node) => {
    nodesRef.current = [...nodesRef.current, node];
  }, []);
  const removeNode = React.useCallback((node) => {
    nodesRef.current = nodesRef.current.filter((n) => n !== node);
  }, []);
  const events = React.useState(() => createPubSub())[0];
  return /* @__PURE__ */ jsx(FloatingTreeContext.Provider, {
    value: React.useMemo(() => ({
      nodesRef,
      addNode,
      removeNode,
      events
    }), [nodesRef, addNode, removeNode, events]),
    children
  });
}
function createAttribute(name) {
  return "data-floating-ui-" + name;
}
function useLatestRef(value) {
  const ref = useRef(value);
  index$1(() => {
    ref.current = value;
  });
  return ref;
}
const safePolygonIdentifier = /* @__PURE__ */ createAttribute("safe-polygon");
function getDelay(value, prop, pointerType) {
  if (pointerType && !isMouseLikePointerType(pointerType)) {
    return 0;
  }
  if (typeof value === "number") {
    return value;
  }
  return value == null ? void 0 : value[prop];
}
function useHover(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    events,
    elements: {
      domReference,
      floating
    },
    refs
  } = context;
  const {
    enabled = true,
    delay = 0,
    handleClose = null,
    mouseOnly = false,
    restMs = 0,
    move = true
  } = props;
  const tree = useFloatingTree();
  const parentId = useFloatingParentNodeId();
  const handleCloseRef = useLatestRef(handleClose);
  const delayRef = useLatestRef(delay);
  const pointerTypeRef = React.useRef();
  const timeoutRef = React.useRef();
  const handlerRef = React.useRef();
  const restTimeoutRef = React.useRef();
  const blockMouseMoveRef = React.useRef(true);
  const performedPointerEventsMutationRef = React.useRef(false);
  const unbindMouseMoveRef = React.useRef(() => {
  });
  const isHoverOpen = React.useCallback(() => {
    var _dataRef$current$open;
    const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
    return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
  }, [dataRef]);
  React.useEffect(() => {
    if (!enabled) {
      return;
    }
    function onDismiss() {
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      blockMouseMoveRef.current = true;
    }
    events.on("dismiss", onDismiss);
    return () => {
      events.off("dismiss", onDismiss);
    };
  }, [enabled, events]);
  React.useEffect(() => {
    if (!enabled || !handleCloseRef.current || !open) {
      return;
    }
    function onLeave(event) {
      if (isHoverOpen()) {
        onOpenChange(false, event);
      }
    }
    const html = getDocument(floating).documentElement;
    html.addEventListener("mouseleave", onLeave);
    return () => {
      html.removeEventListener("mouseleave", onLeave);
    };
  }, [floating, open, onOpenChange, enabled, handleCloseRef, dataRef, isHoverOpen]);
  const closeWithDelay = React.useCallback(function(event, runElseBranch) {
    if (runElseBranch === void 0) {
      runElseBranch = true;
    }
    const closeDelay = getDelay(delayRef.current, "close", pointerTypeRef.current);
    if (closeDelay && !handlerRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => onOpenChange(false, event), closeDelay);
    } else if (runElseBranch) {
      clearTimeout(timeoutRef.current);
      onOpenChange(false, event);
    }
  }, [delayRef, onOpenChange]);
  const cleanupMouseMoveHandler = React.useCallback(() => {
    unbindMouseMoveRef.current();
    handlerRef.current = void 0;
  }, []);
  const clearPointerEvents = React.useCallback(() => {
    if (performedPointerEventsMutationRef.current) {
      const body = getDocument(refs.floating.current).body;
      body.style.pointerEvents = "";
      body.removeAttribute(safePolygonIdentifier);
      performedPointerEventsMutationRef.current = false;
    }
  }, [refs]);
  React.useEffect(() => {
    if (!enabled) {
      return;
    }
    function isClickLikeOpenEvent() {
      return dataRef.current.openEvent ? ["click", "mousedown"].includes(dataRef.current.openEvent.type) : false;
    }
    function onMouseEnter(event) {
      clearTimeout(timeoutRef.current);
      blockMouseMoveRef.current = false;
      if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current) || restMs > 0 && getDelay(delayRef.current, "open") === 0) {
        return;
      }
      const openDelay = getDelay(delayRef.current, "open", pointerTypeRef.current);
      if (openDelay) {
        timeoutRef.current = setTimeout(() => {
          onOpenChange(true, event);
        }, openDelay);
      } else {
        onOpenChange(true, event);
      }
    }
    function onMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        return;
      }
      unbindMouseMoveRef.current();
      const doc = getDocument(floating);
      clearTimeout(restTimeoutRef.current);
      if (handleCloseRef.current) {
        if (!open) {
          clearTimeout(timeoutRef.current);
        }
        handlerRef.current = handleCloseRef.current({
          ...context,
          tree,
          x: event.clientX,
          y: event.clientY,
          onClose() {
            clearPointerEvents();
            cleanupMouseMoveHandler();
            closeWithDelay(event);
          }
        });
        const handler = handlerRef.current;
        doc.addEventListener("mousemove", handler);
        unbindMouseMoveRef.current = () => {
          doc.removeEventListener("mousemove", handler);
        };
        return;
      }
      const shouldClose = pointerTypeRef.current === "touch" ? !contains(floating, event.relatedTarget) : true;
      if (shouldClose) {
        closeWithDelay(event);
      }
    }
    function onScrollMouseLeave(event) {
      if (isClickLikeOpenEvent()) {
        return;
      }
      handleCloseRef.current == null ? void 0 : handleCloseRef.current({
        ...context,
        tree,
        x: event.clientX,
        y: event.clientY,
        onClose() {
          clearPointerEvents();
          cleanupMouseMoveHandler();
          closeWithDelay(event);
        }
      })(event);
    }
    if (isElement(domReference)) {
      const ref = domReference;
      open && ref.addEventListener("mouseleave", onScrollMouseLeave);
      floating == null ? void 0 : floating.addEventListener("mouseleave", onScrollMouseLeave);
      move && ref.addEventListener("mousemove", onMouseEnter, {
        once: true
      });
      ref.addEventListener("mouseenter", onMouseEnter);
      ref.addEventListener("mouseleave", onMouseLeave);
      return () => {
        open && ref.removeEventListener("mouseleave", onScrollMouseLeave);
        floating == null ? void 0 : floating.removeEventListener("mouseleave", onScrollMouseLeave);
        move && ref.removeEventListener("mousemove", onMouseEnter);
        ref.removeEventListener("mouseenter", onMouseEnter);
        ref.removeEventListener("mouseleave", onMouseLeave);
      };
    }
  }, [domReference, floating, enabled, context, mouseOnly, restMs, move, closeWithDelay, cleanupMouseMoveHandler, clearPointerEvents, onOpenChange, open, tree, delayRef, handleCloseRef, dataRef]);
  index$1(() => {
    var _handleCloseRef$curre;
    if (!enabled) {
      return;
    }
    if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
      const body = getDocument(floating).body;
      body.setAttribute(safePolygonIdentifier, "");
      body.style.pointerEvents = "none";
      performedPointerEventsMutationRef.current = true;
      if (isElement(domReference) && floating) {
        var _tree$nodesRef$curren, _tree$nodesRef$curren2;
        const ref = domReference;
        const parentFloating = tree == null ? void 0 : (_tree$nodesRef$curren = tree.nodesRef.current.find((node) => node.id === parentId)) == null ? void 0 : (_tree$nodesRef$curren2 = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren2.elements.floating;
        if (parentFloating) {
          parentFloating.style.pointerEvents = "";
        }
        ref.style.pointerEvents = "auto";
        floating.style.pointerEvents = "auto";
        return () => {
          ref.style.pointerEvents = "";
          floating.style.pointerEvents = "";
        };
      }
    }
  }, [enabled, open, parentId, floating, domReference, tree, handleCloseRef, dataRef, isHoverOpen]);
  index$1(() => {
    if (!open) {
      pointerTypeRef.current = void 0;
      cleanupMouseMoveHandler();
      clearPointerEvents();
    }
  }, [open, cleanupMouseMoveHandler, clearPointerEvents]);
  React.useEffect(() => {
    return () => {
      cleanupMouseMoveHandler();
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      clearPointerEvents();
    };
  }, [enabled, domReference, cleanupMouseMoveHandler, clearPointerEvents]);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }
    function setPointerRef(event) {
      pointerTypeRef.current = event.pointerType;
    }
    return {
      reference: {
        onPointerDown: setPointerRef,
        onPointerEnter: setPointerRef,
        onMouseMove(event) {
          if (open || restMs === 0) {
            return;
          }
          clearTimeout(restTimeoutRef.current);
          restTimeoutRef.current = setTimeout(() => {
            if (!blockMouseMoveRef.current) {
              onOpenChange(true, event.nativeEvent);
            }
          }, restMs);
        }
      },
      floating: {
        onMouseEnter() {
          clearTimeout(timeoutRef.current);
        },
        onMouseLeave(event) {
          events.emit("dismiss", {
            type: "mouseLeave",
            data: {
              returnFocus: false
            }
          });
          closeWithDelay(event.nativeEvent, false);
        }
      }
    };
  }, [events, enabled, restMs, open, onOpenChange, closeWithDelay]);
}
let rafId = 0;
function enqueueFocus(el, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    preventScroll = false,
    cancelPrevious = true,
    sync = false
  } = options2;
  cancelPrevious && cancelAnimationFrame(rafId);
  const exec = () => el == null ? void 0 : el.focus({
    preventScroll
  });
  if (sync) {
    exec();
  } else {
    rafId = requestAnimationFrame(exec);
  }
}
function getAncestors(nodes, id) {
  var _nodes$find;
  let allAncestors = [];
  let currentParentId = (_nodes$find = nodes.find((node) => node.id === id)) == null ? void 0 : _nodes$find.parentId;
  while (currentParentId) {
    const currentNode = nodes.find((node) => node.id === currentParentId);
    currentParentId = currentNode == null ? void 0 : currentNode.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}
function getChildren(nodes, id) {
  let allChildren = nodes.filter((node) => {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  });
  let currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter((node) => {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n) => {
        var _node$context2;
        return node.parentId === n.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    });
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}
const getTabbableOptions = () => ({
  getShadowRoot: true,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function getTabbableIn(container, direction) {
  const allTabbable = tabbable(container, getTabbableOptions());
  if (direction === "prev") {
    allTabbable.reverse();
  }
  const activeIndex = allTabbable.indexOf(activeElement(getDocument(container)));
  const nextTabbableElements = allTabbable.slice(activeIndex + 1);
  return nextTabbableElements[0];
}
function getNextTabbable() {
  return getTabbableIn(document.body, "next");
}
function getPreviousTabbable() {
  return getTabbableIn(document.body, "prev");
}
function isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  const tabbableElements = tabbable(container, getTabbableOptions());
  tabbableElements.forEach((element) => {
    element.dataset.tabindex = element.getAttribute("tabindex") || "";
    element.setAttribute("tabindex", "-1");
  });
}
function enableFocusInside(container) {
  const elements = container.querySelectorAll("[data-tabindex]");
  elements.forEach((element) => {
    const tabindex = element.dataset.tabindex;
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute("tabindex", tabindex);
    } else {
      element.removeAttribute("tabindex");
    }
  });
}
const HIDDEN_STYLES = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let timeoutId;
function setActiveElementOnTab(event) {
  if (event.key === "Tab") {
    event.target;
    clearTimeout(timeoutId);
  }
}
const FocusGuard = /* @__PURE__ */ React.forwardRef(function FocusGuard2(props, ref) {
  const [role, setRole] = React.useState();
  index$1(() => {
    if (isSafari$1()) {
      setRole("button");
    }
    document.addEventListener("keydown", setActiveElementOnTab);
    return () => {
      document.removeEventListener("keydown", setActiveElementOnTab);
    };
  }, []);
  const restProps = {
    ref,
    tabIndex: 0,
    // Role is only for VoiceOver
    role,
    "aria-hidden": role ? void 0 : true,
    [createAttribute("focus-guard")]: "",
    style: HIDDEN_STYLES
  };
  return /* @__PURE__ */ jsx("span", {
    ...props,
    ...restProps
  });
});
const PortalContext = /* @__PURE__ */ React.createContext(null);
function useFloatingPortalNode(_temp) {
  let {
    id,
    root
  } = _temp === void 0 ? {} : _temp;
  const [portalNode, setPortalNode] = React.useState(null);
  const uniqueId = useId();
  const portalContext = usePortalContext();
  const data = React.useMemo(() => ({
    id,
    root,
    portalContext,
    uniqueId
  }), [id, root, portalContext, uniqueId]);
  const dataRef = React.useRef();
  index$1(() => {
    return () => {
      portalNode == null ? void 0 : portalNode.remove();
    };
  }, [portalNode, data]);
  index$1(() => {
    if (dataRef.current === data) return;
    dataRef.current = data;
    const {
      id: id2,
      root: root2,
      portalContext: portalContext2,
      uniqueId: uniqueId2
    } = data;
    const existingIdRoot = id2 ? document.getElementById(id2) : null;
    const attr = createAttribute("portal");
    if (existingIdRoot) {
      const subRoot = document.createElement("div");
      subRoot.id = uniqueId2;
      subRoot.setAttribute(attr, "");
      existingIdRoot.appendChild(subRoot);
      setPortalNode(subRoot);
    } else {
      let container = root2 || (portalContext2 == null ? void 0 : portalContext2.portalNode);
      if (container && !isElement(container)) container = container.current;
      container = container || document.body;
      let idWrapper = null;
      if (id2) {
        idWrapper = document.createElement("div");
        idWrapper.id = id2;
        container.appendChild(idWrapper);
      }
      const subRoot = document.createElement("div");
      subRoot.id = uniqueId2;
      subRoot.setAttribute(attr, "");
      container = idWrapper || container;
      container.appendChild(subRoot);
      setPortalNode(subRoot);
    }
  }, [data]);
  return portalNode;
}
function FloatingPortal(_ref) {
  let {
    children,
    id,
    root = null,
    preserveTabOrder = true
  } = _ref;
  const portalNode = useFloatingPortalNode({
    id,
    root
  });
  const [focusManagerState, setFocusManagerState] = React.useState(null);
  const beforeOutsideRef = React.useRef(null);
  const afterOutsideRef = React.useRef(null);
  const beforeInsideRef = React.useRef(null);
  const afterInsideRef = React.useRef(null);
  const shouldRenderGuards = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode)
  );
  React.useEffect(() => {
    if (!portalNode || !preserveTabOrder || focusManagerState != null && focusManagerState.modal) {
      return;
    }
    function onFocus(event) {
      if (portalNode && isOutsideEvent(event)) {
        const focusing = event.type === "focusin";
        const manageFocus = focusing ? enableFocusInside : disableFocusInside;
        manageFocus(portalNode);
      }
    }
    portalNode.addEventListener("focusin", onFocus, true);
    portalNode.addEventListener("focusout", onFocus, true);
    return () => {
      portalNode.removeEventListener("focusin", onFocus, true);
      portalNode.removeEventListener("focusout", onFocus, true);
    };
  }, [portalNode, preserveTabOrder, focusManagerState == null ? void 0 : focusManagerState.modal]);
  return /* @__PURE__ */ jsxs(PortalContext.Provider, {
    value: React.useMemo(() => ({
      preserveTabOrder,
      beforeOutsideRef,
      afterOutsideRef,
      beforeInsideRef,
      afterInsideRef,
      portalNode,
      setFocusManagerState
    }), [preserveTabOrder, portalNode]),
    children: [shouldRenderGuards && portalNode && /* @__PURE__ */ jsx(FocusGuard, {
      "data-type": "outside",
      ref: beforeOutsideRef,
      onFocus: (event) => {
        if (isOutsideEvent(event, portalNode)) {
          var _beforeInsideRef$curr;
          (_beforeInsideRef$curr = beforeInsideRef.current) == null ? void 0 : _beforeInsideRef$curr.focus();
        } else {
          const prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
          prevTabbable == null ? void 0 : prevTabbable.focus();
        }
      }
    }), shouldRenderGuards && portalNode && /* @__PURE__ */ jsx("span", {
      "aria-owns": portalNode.id,
      style: HIDDEN_STYLES
    }), portalNode && /* @__PURE__ */ createPortal(children, portalNode), shouldRenderGuards && portalNode && /* @__PURE__ */ jsx(FocusGuard, {
      "data-type": "outside",
      ref: afterOutsideRef,
      onFocus: (event) => {
        if (isOutsideEvent(event, portalNode)) {
          var _afterInsideRef$curre;
          (_afterInsideRef$curre = afterInsideRef.current) == null ? void 0 : _afterInsideRef$curre.focus();
        } else {
          const nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
          nextTabbable == null ? void 0 : nextTabbable.focus();
          (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null ? void 0 : focusManagerState.onOpenChange(false, event.nativeEvent));
        }
      }
    })]
  });
}
const usePortalContext = () => React.useContext(PortalContext);
const VisuallyHiddenDismiss = /* @__PURE__ */ React.forwardRef(function VisuallyHiddenDismiss2(props, ref) {
  return /* @__PURE__ */ jsx("button", {
    ...props,
    type: "button",
    ref,
    tabIndex: -1,
    style: HIDDEN_STYLES
  });
});
function FloatingFocusManager(props) {
  const {
    context,
    children,
    disabled = false,
    order = ["content"],
    guards: _guards = true,
    initialFocus = 0,
    returnFocus = true,
    modal = true,
    visuallyHiddenDismiss = false,
    closeOnFocusOut = true
  } = props;
  const {
    open,
    refs,
    nodeId,
    onOpenChange,
    events,
    dataRef,
    elements: {
      domReference,
      floating
    }
  } = context;
  const guards = supportsInert() ? _guards : true;
  const orderRef = useLatestRef(order);
  const initialFocusRef = useLatestRef(initialFocus);
  const returnFocusRef = useLatestRef(returnFocus);
  const tree = useFloatingTree();
  const portalContext = usePortalContext();
  const ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
  const startDismissButtonRef = React.useRef(null);
  const endDismissButtonRef = React.useRef(null);
  const preventReturnFocusRef = React.useRef(false);
  const previouslyFocusedElementRef = React.useRef(null);
  const isPointerDownRef = React.useRef(false);
  const isInsidePortal = portalContext != null;
  const isTypeableCombobox = domReference && domReference.getAttribute("role") === "combobox" && isTypeableElement(domReference);
  const getTabbableContent = React.useCallback(function(container) {
    if (container === void 0) {
      container = floating;
    }
    return container ? tabbable(container, getTabbableOptions()) : [];
  }, [floating]);
  const getTabbableElements = React.useCallback((container) => {
    const content = getTabbableContent(container);
    return orderRef.current.map((type) => {
      if (domReference && type === "reference") {
        return domReference;
      }
      if (floating && type === "floating") {
        return floating;
      }
      return content;
    }).filter(Boolean).flat();
  }, [domReference, floating, orderRef, getTabbableContent]);
  React.useEffect(() => {
    if (disabled || !modal) return;
    function onKeyDown(event) {
      if (event.key === "Tab") {
        if (contains(floating, activeElement(getDocument(floating))) && getTabbableContent().length === 0 && !isTypeableCombobox) {
          stopEvent(event);
        }
        const els = getTabbableElements();
        const target = getTarget(event);
        if (orderRef.current[0] === "reference" && target === domReference) {
          stopEvent(event);
          if (event.shiftKey) {
            enqueueFocus(els[els.length - 1]);
          } else {
            enqueueFocus(els[1]);
          }
        }
        if (orderRef.current[1] === "floating" && target === floating && event.shiftKey) {
          stopEvent(event);
          enqueueFocus(els[0]);
        }
      }
    }
    const doc = getDocument(floating);
    doc.addEventListener("keydown", onKeyDown);
    return () => {
      doc.removeEventListener("keydown", onKeyDown);
    };
  }, [disabled, domReference, floating, modal, orderRef, refs, isTypeableCombobox, getTabbableContent, getTabbableElements]);
  React.useEffect(() => {
    if (disabled || !closeOnFocusOut) return;
    function handlePointerDown() {
      isPointerDownRef.current = true;
      setTimeout(() => {
        isPointerDownRef.current = false;
      });
    }
    function handleFocusOutside(event) {
      const relatedTarget = event.relatedTarget;
      queueMicrotask(() => {
        const movedToUnrelatedNode = !(contains(domReference, relatedTarget) || contains(floating, relatedTarget) || contains(relatedTarget, floating) || contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute("focus-guard")) || tree && (getChildren(tree.nodesRef.current, nodeId).find((node) => {
          var _node$context, _node$context2;
          return contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
        }) || getAncestors(tree.nodesRef.current, nodeId).find((node) => {
          var _node$context3, _node$context4;
          return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
        })));
        if (relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        relatedTarget !== previouslyFocusedElementRef.current) {
          preventReturnFocusRef.current = true;
          onOpenChange(false, event);
        }
      });
    }
    if (floating && isHTMLElement(domReference)) {
      domReference.addEventListener("focusout", handleFocusOutside);
      domReference.addEventListener("pointerdown", handlePointerDown);
      !modal && floating.addEventListener("focusout", handleFocusOutside);
      return () => {
        domReference.removeEventListener("focusout", handleFocusOutside);
        domReference.removeEventListener("pointerdown", handlePointerDown);
        !modal && floating.removeEventListener("focusout", handleFocusOutside);
      };
    }
  }, [disabled, domReference, floating, modal, nodeId, tree, portalContext, onOpenChange, closeOnFocusOut]);
  React.useEffect(() => {
    var _portalContext$portal;
    if (disabled) return;
    const portalNodes = Array.from((portalContext == null ? void 0 : (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute("portal") + "]")) || []);
    if (floating && modal) {
      const insideNodes = [floating, ...portalNodes, startDismissButtonRef.current, endDismissButtonRef.current].filter((x) => x != null);
      const suppressorFn = guards ? hideOthers : suppressOthers;
      const cleanup = suppressorFn(orderRef.current.includes("reference") || isTypeableCombobox ? insideNodes.concat(domReference || []) : insideNodes, void 0, createAttribute("inert"));
      return () => {
        cleanup();
      };
    }
  }, [disabled, domReference, floating, modal, orderRef, portalContext, isTypeableCombobox, guards]);
  index$1(() => {
    if (disabled || !floating) return;
    const doc = getDocument(floating);
    const previouslyFocusedElement = activeElement(doc);
    queueMicrotask(() => {
      const focusableElements = getTabbableElements(floating);
      const initialFocusValue = initialFocusRef.current;
      const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floating;
      const focusAlreadyInsideFloatingEl = contains(floating, previouslyFocusedElement);
      if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) {
        enqueueFocus(elToFocus, {
          preventScroll: elToFocus === floating
        });
      }
    });
  }, [disabled, open, floating, ignoreInitialFocus, getTabbableElements, initialFocusRef]);
  index$1(() => {
    if (disabled || !floating) return;
    let preventReturnFocusScroll = false;
    const doc = getDocument(floating);
    const previouslyFocusedElement = activeElement(doc);
    const contextData = dataRef.current;
    previouslyFocusedElementRef.current = previouslyFocusedElement;
    function onDismiss(payload) {
      if (payload.type === "escapeKey" && refs.domReference.current) {
        previouslyFocusedElementRef.current = refs.domReference.current;
      }
      if (["referencePress", "escapeKey"].includes(payload.type)) {
        return;
      }
      const returnFocus2 = payload.data.returnFocus;
      if (typeof returnFocus2 === "object") {
        preventReturnFocusRef.current = false;
        preventReturnFocusScroll = returnFocus2.preventScroll;
      } else {
        preventReturnFocusRef.current = !returnFocus2;
      }
    }
    events.on("dismiss", onDismiss);
    return () => {
      events.off("dismiss", onDismiss);
      const activeEl = activeElement(doc);
      const shouldFocusReference = contains(floating, activeEl) || tree && getChildren(tree.nodesRef.current, nodeId).some((node) => {
        var _node$context5;
        return contains((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
      }) || contextData.openEvent && ["click", "mousedown"].includes(contextData.openEvent.type);
      if (shouldFocusReference && refs.domReference.current) {
        previouslyFocusedElementRef.current = refs.domReference.current;
      }
      if (
        // eslint-disable-next-line react-hooks/exhaustive-deps
        returnFocusRef.current && isHTMLElement(previouslyFocusedElementRef.current) && !preventReturnFocusRef.current
      ) {
        enqueueFocus(previouslyFocusedElementRef.current, {
          // When dismissing nested floating elements, by the time the rAF has
          // executed, the menus will all have been unmounted. When they try
          // to get focused, the calls get ignored — leaving the root
          // reference focused as desired.
          cancelPrevious: false,
          preventScroll: preventReturnFocusScroll
        });
      }
    };
  }, [disabled, floating, returnFocusRef, dataRef, refs, events, tree, nodeId]);
  index$1(() => {
    if (disabled || !portalContext) return;
    portalContext.setFocusManagerState({
      ...context,
      modal,
      closeOnFocusOut,
      open
    });
    return () => {
      portalContext.setFocusManagerState(null);
    };
  }, [disabled, portalContext, modal, open, closeOnFocusOut, context]);
  index$1(() => {
    if (disabled) return;
    if (floating && typeof MutationObserver === "function") {
      const handleMutation = () => {
        const tabIndex = floating.getAttribute("tabindex");
        if (orderRef.current.includes("floating") || activeElement(getDocument(floating)) !== refs.domReference.current && getTabbableContent().length === 0) {
          if (tabIndex !== "0") {
            floating.setAttribute("tabindex", "0");
          }
        } else if (tabIndex !== "-1") {
          floating.setAttribute("tabindex", "-1");
        }
      };
      handleMutation();
      const observer = new MutationObserver(handleMutation);
      observer.observe(floating, {
        childList: true,
        subtree: true,
        attributes: true
      });
      return () => {
        observer.disconnect();
      };
    }
  }, [disabled, floating, refs, orderRef, getTabbableContent]);
  function renderDismissButton(location2) {
    if (disabled || !visuallyHiddenDismiss || !modal) {
      return null;
    }
    return /* @__PURE__ */ jsx(VisuallyHiddenDismiss, {
      ref: location2 === "start" ? startDismissButtonRef : endDismissButtonRef,
      onClick: (event) => onOpenChange(false, event.nativeEvent),
      children: typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss"
    });
  }
  const shouldRenderGuards = !disabled && guards && !isTypeableCombobox && (isInsidePortal || modal);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [shouldRenderGuards && /* @__PURE__ */ jsx(FocusGuard, {
      "data-type": "inside",
      ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
      onFocus: (event) => {
        if (modal) {
          const els = getTabbableElements();
          enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
        } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
          preventReturnFocusRef.current = false;
          if (isOutsideEvent(event, portalContext.portalNode)) {
            const nextTabbable = getNextTabbable() || domReference;
            nextTabbable == null ? void 0 : nextTabbable.focus();
          } else {
            var _portalContext$before;
            (_portalContext$before = portalContext.beforeOutsideRef.current) == null ? void 0 : _portalContext$before.focus();
          }
        }
      }
    }), !isTypeableCombobox && renderDismissButton("start"), children, renderDismissButton("end"), shouldRenderGuards && /* @__PURE__ */ jsx(FocusGuard, {
      "data-type": "inside",
      ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
      onFocus: (event) => {
        if (modal) {
          enqueueFocus(getTabbableElements()[0]);
        } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
          if (closeOnFocusOut) {
            preventReturnFocusRef.current = true;
          }
          if (isOutsideEvent(event, portalContext.portalNode)) {
            const prevTabbable = getPreviousTabbable() || domReference;
            prevTabbable == null ? void 0 : prevTabbable.focus();
          } else {
            var _portalContext$afterO;
            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null ? void 0 : _portalContext$afterO.focus();
          }
        }
      }
    })]
  });
}
const identifier = /* @__PURE__ */ createAttribute("scroll-lock");
const FloatingOverlay = /* @__PURE__ */ React.forwardRef(function FloatingOverlay2(_ref, ref) {
  let {
    lockScroll = false,
    ...rest
  } = _ref;
  index$1(() => {
    var _window$visualViewpor, _window$visualViewpor2;
    if (!lockScroll) {
      return;
    }
    const alreadyLocked = document.body.hasAttribute(identifier);
    if (alreadyLocked) {
      return;
    }
    document.body.setAttribute(identifier, "");
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (!/iP(hone|ad|od)|iOS/.test(getPlatform())) {
      Object.assign(document.body.style, {
        overflow: "hidden",
        [paddingProp]: scrollbarWidth + "px"
      });
      return () => {
        document.body.removeAttribute(identifier);
        Object.assign(document.body.style, {
          overflow: "",
          [paddingProp]: ""
        });
      };
    }
    const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
    const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
    const scrollX = window.pageXOffset;
    const scrollY = window.pageYOffset;
    Object.assign(document.body.style, {
      position: "fixed",
      overflow: "hidden",
      top: -(scrollY - Math.floor(offsetTop)) + "px",
      left: -(scrollX - Math.floor(offsetLeft)) + "px",
      right: "0",
      [paddingProp]: scrollbarWidth + "px"
    });
    return () => {
      Object.assign(document.body.style, {
        position: "",
        overflow: "",
        top: "",
        left: "",
        right: "",
        [paddingProp]: ""
      });
      document.body.removeAttribute(identifier);
      window.scrollTo(scrollX, scrollY);
    };
  }, [lockScroll]);
  return /* @__PURE__ */ jsx("div", {
    ref,
    ...rest,
    style: {
      position: "fixed",
      overflow: "auto",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...rest.style
    }
  });
});
function isButtonTarget(event) {
  return isHTMLElement(event.target) && event.target.tagName === "BUTTON";
}
function isSpaceIgnored(element) {
  return isTypeableElement(element);
}
function useClick(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    elements: {
      domReference
    }
  } = context;
  const {
    enabled = true,
    event: eventOption = "click",
    toggle = true,
    ignoreMouse = false,
    keyboardHandlers = true
  } = props;
  const pointerTypeRef = React.useRef();
  const didKeyDownRef = React.useRef(false);
  return React.useMemo(() => {
    if (!enabled) return {};
    return {
      reference: {
        onPointerDown(event) {
          pointerTypeRef.current = event.pointerType;
        },
        onMouseDown(event) {
          if (event.button !== 0) {
            return;
          }
          if (isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) {
            return;
          }
          if (eventOption === "click") {
            return;
          }
          if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "mousedown" : true)) {
            onOpenChange(false, event.nativeEvent);
          } else {
            event.preventDefault();
            onOpenChange(true, event.nativeEvent);
          }
        },
        onClick(event) {
          if (eventOption === "mousedown" && pointerTypeRef.current) {
            pointerTypeRef.current = void 0;
            return;
          }
          if (isMouseLikePointerType(pointerTypeRef.current, true) && ignoreMouse) {
            return;
          }
          if (open && toggle && (dataRef.current.openEvent ? dataRef.current.openEvent.type === "click" : true)) {
            onOpenChange(false, event.nativeEvent);
          } else {
            onOpenChange(true, event.nativeEvent);
          }
        },
        onKeyDown(event) {
          pointerTypeRef.current = void 0;
          if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) {
            return;
          }
          if (event.key === " " && !isSpaceIgnored(domReference)) {
            event.preventDefault();
            didKeyDownRef.current = true;
          }
          if (event.key === "Enter") {
            if (open && toggle) {
              onOpenChange(false, event.nativeEvent);
            } else {
              onOpenChange(true, event.nativeEvent);
            }
          }
        },
        onKeyUp(event) {
          if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) {
            return;
          }
          if (event.key === " " && didKeyDownRef.current) {
            didKeyDownRef.current = false;
            if (open && toggle) {
              onOpenChange(false, event.nativeEvent);
            } else {
              onOpenChange(true, event.nativeEvent);
            }
          }
        }
      }
    };
  }, [enabled, dataRef, eventOption, ignoreMouse, keyboardHandlers, domReference, toggle, open, onOpenChange]);
}
const useInsertionEffect = React[/* @__PURE__ */ "useInsertionEffect".toString()];
const useSafeInsertionEffect = useInsertionEffect || ((fn) => fn());
function useEffectEvent(callback) {
  const ref = React.useRef(() => {
    if (process.env.NODE_ENV !== "production") {
      throw new Error("Cannot call an event handler while rendering.");
    }
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return React.useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}
const bubbleHandlerKeys = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
};
const captureHandlerKeys = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
};
const normalizeBubblesProp = (bubbles) => {
  var _bubbles$escapeKey, _bubbles$outsidePress;
  return {
    escapeKeyBubbles: typeof bubbles === "boolean" ? bubbles : (_bubbles$escapeKey = bubbles == null ? void 0 : bubbles.escapeKey) != null ? _bubbles$escapeKey : false,
    outsidePressBubbles: typeof bubbles === "boolean" ? bubbles : (_bubbles$outsidePress = bubbles == null ? void 0 : bubbles.outsidePress) != null ? _bubbles$outsidePress : true
  };
};
function useDismiss(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    events,
    nodeId,
    elements: {
      reference,
      domReference,
      floating
    },
    dataRef
  } = context;
  const {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = "pointerdown",
    referencePress = false,
    referencePressEvent = "pointerdown",
    ancestorScroll = false,
    bubbles
  } = props;
  const tree = useFloatingTree();
  const nested = useFloatingParentNodeId() != null;
  const outsidePressFn = useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
  const insideReactTreeRef = React.useRef(false);
  const {
    escapeKeyBubbles,
    outsidePressBubbles
  } = normalizeBubblesProp(bubbles);
  const closeOnEscapeKeyDown = useEffectEvent((event) => {
    if (!open || !enabled || !escapeKey || event.key !== "Escape") {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (!escapeKeyBubbles) {
      event.stopPropagation();
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach((child) => {
          var _child$context;
          if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
    }
    events.emit("dismiss", {
      type: "escapeKey",
      data: {
        returnFocus: {
          preventScroll: false
        }
      }
    });
    onOpenChange(false, isReactEvent(event) ? event.nativeEvent : event);
  });
  const closeOnPressOutside = useEffectEvent((event) => {
    const insideReactTree = insideReactTreeRef.current;
    insideReactTreeRef.current = false;
    if (insideReactTree) {
      return;
    }
    if (typeof outsidePress === "function" && !outsidePress(event)) {
      return;
    }
    const target = getTarget(event);
    if (isHTMLElement(target) && floating) {
      const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
      const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
      let xCond = canScrollY && event.offsetX > target.clientWidth;
      if (canScrollY) {
        const isRTL2 = getComputedStyle$1(target).direction === "rtl";
        if (isRTL2) {
          xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
        }
      }
      if (xCond || canScrollX && event.offsetY > target.clientHeight) {
        return;
      }
    }
    const targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some((node) => {
      var _node$context;
      return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
    });
    if (isEventTargetWithin(event, floating) || isEventTargetWithin(event, domReference) || targetIsInsideChildren) {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (children.length > 0) {
      let shouldDismiss = true;
      children.forEach((child) => {
        var _child$context2;
        if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
          shouldDismiss = false;
          return;
        }
      });
      if (!shouldDismiss) {
        return;
      }
    }
    events.emit("dismiss", {
      type: "outsidePress",
      data: {
        returnFocus: nested ? {
          preventScroll: true
        } : isVirtualClick(event) || isVirtualPointerEvent(event)
      }
    });
    onOpenChange(false, event);
  });
  React.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    function onScroll(event) {
      onOpenChange(false, event);
    }
    const doc = getDocument(floating);
    escapeKey && doc.addEventListener("keydown", closeOnEscapeKeyDown);
    outsidePress && doc.addEventListener(outsidePressEvent, closeOnPressOutside);
    let ancestors = [];
    if (ancestorScroll) {
      if (isElement(domReference)) {
        ancestors = getOverflowAncestors(domReference);
      }
      if (isElement(floating)) {
        ancestors = ancestors.concat(getOverflowAncestors(floating));
      }
      if (!isElement(reference) && reference && reference.contextElement) {
        ancestors = ancestors.concat(getOverflowAncestors(reference.contextElement));
      }
    }
    ancestors = ancestors.filter((ancestor) => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach((ancestor) => {
      ancestor.addEventListener("scroll", onScroll, {
        passive: true
      });
    });
    return () => {
      escapeKey && doc.removeEventListener("keydown", closeOnEscapeKeyDown);
      outsidePress && doc.removeEventListener(outsidePressEvent, closeOnPressOutside);
      ancestors.forEach((ancestor) => {
        ancestor.removeEventListener("scroll", onScroll);
      });
    };
  }, [dataRef, floating, domReference, reference, escapeKey, outsidePress, outsidePressEvent, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, closeOnPressOutside]);
  React.useEffect(() => {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  return React.useMemo(() => {
    if (!enabled) {
      return {};
    }
    return {
      reference: {
        onKeyDown: closeOnEscapeKeyDown,
        [bubbleHandlerKeys[referencePressEvent]]: (event) => {
          if (referencePress) {
            events.emit("dismiss", {
              type: "referencePress",
              data: {
                returnFocus: false
              }
            });
            onOpenChange(false, event.nativeEvent);
          }
        }
      },
      floating: {
        onKeyDown: closeOnEscapeKeyDown,
        [captureHandlerKeys[outsidePressEvent]]: () => {
          insideReactTreeRef.current = true;
        }
      }
    };
  }, [enabled, events, referencePress, outsidePressEvent, referencePressEvent, onOpenChange, closeOnEscapeKeyDown]);
}
let devMessageSet;
if (process.env.NODE_ENV !== "production") {
  devMessageSet = /* @__PURE__ */ new Set();
}
function useFloating(options2) {
  var _options$elements2;
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    open = false,
    onOpenChange: unstable_onOpenChange,
    nodeId
  } = options2;
  if (process.env.NODE_ENV !== "production") {
    var _devMessageSet;
    const err = "Floating UI: Cannot pass a virtual element to the `elements.reference` option, as it must be a real DOM element. Use `refs.setPositionReference` instead.";
    if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(err))) {
      var _devMessageSet2, _options$elements;
      (_devMessageSet2 = devMessageSet) == null ? void 0 : _devMessageSet2.add(err);
      if ((_options$elements = options2.elements) != null && _options$elements.reference && !isElement(options2.elements.reference)) {
        console.error(err);
      }
    }
  }
  const [_domReference, setDomReference] = React.useState(null);
  const domReference = ((_options$elements2 = options2.elements) == null ? void 0 : _options$elements2.reference) || _domReference;
  const position = useFloating$1(options2);
  const tree = useFloatingTree();
  const onOpenChange = useEffectEvent((open2, event) => {
    if (open2) {
      dataRef.current.openEvent = event;
    }
    unstable_onOpenChange == null ? void 0 : unstable_onOpenChange(open2, event);
  });
  const domReferenceRef = React.useRef(null);
  const dataRef = React.useRef({});
  const events = React.useState(() => createPubSub())[0];
  const floatingId = useId();
  const setPositionReference = React.useCallback((node) => {
    const positionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    position.refs.setReference(positionReference);
  }, [position.refs]);
  const setReference = React.useCallback((node) => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = React.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = React.useMemo(() => ({
    ...position.elements,
    domReference
  }), [position.elements, domReference]);
  const context = React.useMemo(() => ({
    ...position,
    refs,
    elements,
    dataRef,
    nodeId,
    floatingId,
    events,
    open,
    onOpenChange
  }), [position, nodeId, floatingId, events, open, onOpenChange, refs, elements]);
  index$1(() => {
    const node = tree == null ? void 0 : tree.nodesRef.current.find((node2) => node2.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return React.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}
function mergeProps(userProps, propsList, elementKey) {
  const map = /* @__PURE__ */ new Map();
  return {
    ...elementKey === "floating" && {
      tabIndex: -1
    },
    ...userProps,
    ...propsList.map((value) => value ? value[elementKey] : null).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach((_ref) => {
        let [key, value] = _ref;
        if (key.indexOf("on") === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === "function") {
            var _map$get;
            (_map$get = map.get(key)) == null ? void 0 : _map$get.push(value);
            acc[key] = function() {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn) => fn(...args)).find((val) => val !== void 0);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  const deps = propsList;
  const getReferenceProps = React.useCallback(
    (userProps) => mergeProps(userProps, propsList, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps
  );
  const getFloatingProps = React.useCallback(
    (userProps) => mergeProps(userProps, propsList, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps
  );
  const getItemProps = React.useCallback(
    (userProps) => mergeProps(userProps, propsList, "item"),
    // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    propsList.map((key) => key == null ? void 0 : key.item)
  );
  return React.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}
function useRole(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    floatingId
  } = context;
  const {
    enabled = true,
    role = "dialog"
  } = props;
  const referenceId = useId();
  return React.useMemo(() => {
    const floatingProps = {
      id: floatingId,
      role
    };
    if (!enabled) {
      return {};
    }
    if (role === "tooltip") {
      return {
        reference: {
          "aria-describedby": open ? floatingId : void 0
        },
        floating: floatingProps
      };
    }
    return {
      reference: {
        "aria-expanded": open ? "true" : "false",
        "aria-haspopup": role === "alertdialog" ? "dialog" : role,
        "aria-controls": open ? floatingId : void 0,
        ...role === "listbox" && {
          role: "combobox"
        },
        ...role === "menu" && {
          id: referenceId
        }
      },
      floating: {
        ...floatingProps,
        ...role === "menu" && {
          "aria-labelledby": referenceId
        }
      }
    };
  }, [enabled, role, open, floatingId, referenceId]);
}
const camelCaseToKebabCase = (str) => str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs) => (ofs ? "-" : "") + $.toLowerCase());
function execWithArgsOrReturn(valueOrFn, args) {
  return typeof valueOrFn === "function" ? valueOrFn(args) : valueOrFn;
}
function useDelayUnmount(open, durationMs) {
  const [isMounted, setIsMounted] = React.useState(open);
  if (open && !isMounted) {
    setIsMounted(true);
  }
  React.useEffect(() => {
    if (!open) {
      const timeout = setTimeout(() => setIsMounted(false), durationMs);
      return () => clearTimeout(timeout);
    }
  }, [open, durationMs]);
  return isMounted;
}
function useTransitionStatus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    elements: {
      floating
    }
  } = context;
  const {
    duration = 250
  } = props;
  const isNumberDuration = typeof duration === "number";
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [initiated, setInitiated] = React.useState(false);
  const [status, setStatus] = React.useState("unmounted");
  const isMounted = useDelayUnmount(open, closeDuration);
  index$1(() => {
    if (initiated && !isMounted) {
      setStatus("unmounted");
    }
  }, [initiated, isMounted]);
  index$1(() => {
    if (!floating) return;
    if (open) {
      setStatus("initial");
      const frame = requestAnimationFrame(() => {
        setStatus("open");
      });
      return () => {
        cancelAnimationFrame(frame);
      };
    } else {
      setInitiated(true);
      setStatus("close");
    }
  }, [open, floating]);
  return {
    isMounted,
    status
  };
}
function useTransitionStyles(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    initial: unstable_initial = {
      opacity: 0
    },
    open: unstable_open,
    close: unstable_close,
    common: unstable_common,
    duration = 250
  } = props;
  const placement = context.placement;
  const side = placement.split("-")[0];
  const fnArgs = React.useMemo(() => ({
    side,
    placement
  }), [side, placement]);
  const isNumberDuration = typeof duration === "number";
  const openDuration = (isNumberDuration ? duration : duration.open) || 0;
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [styles2, setStyles] = React.useState(() => ({
    ...execWithArgsOrReturn(unstable_common, fnArgs),
    ...execWithArgsOrReturn(unstable_initial, fnArgs)
  }));
  const {
    isMounted,
    status
  } = useTransitionStatus(context, {
    duration
  });
  const initialRef = useLatestRef(unstable_initial);
  const openRef = useLatestRef(unstable_open);
  const closeRef = useLatestRef(unstable_close);
  const commonRef = useLatestRef(unstable_common);
  index$1(() => {
    const initialStyles = execWithArgsOrReturn(initialRef.current, fnArgs);
    const closeStyles = execWithArgsOrReturn(closeRef.current, fnArgs);
    const commonStyles = execWithArgsOrReturn(commonRef.current, fnArgs);
    const openStyles = execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key) => {
      acc[key] = "";
      return acc;
    }, {});
    if (status === "initial") {
      setStyles((styles3) => ({
        transitionProperty: styles3.transitionProperty,
        ...commonStyles,
        ...initialStyles
      }));
    }
    if (status === "open") {
      setStyles({
        transitionProperty: Object.keys(openStyles).map(camelCaseToKebabCase).join(","),
        transitionDuration: openDuration + "ms",
        ...commonStyles,
        ...openStyles
      });
    }
    if (status === "close") {
      const styles3 = closeStyles || initialStyles;
      setStyles({
        transitionProperty: Object.keys(styles3).map(camelCaseToKebabCase).join(","),
        transitionDuration: closeDuration + "ms",
        ...commonStyles,
        ...styles3
      });
    }
  }, [closeDuration, closeRef, initialRef, openRef, commonRef, openDuration, status, fnArgs]);
  return {
    isMounted,
    styles: styles2
  };
}
const options$d = {
  popover: {
    wrapper: "divide-y rounded-lg divide-gray-300 shadow-dark bg-white border-white origin-top-right p-0 z-50",
    title: "text-sm font-bold border-b py-1 px-4 leading-6",
    innerContent: "text-sm py-3 px-4 min-w-[177px] empty:p-0"
  }
};
const cssConfig = {
  svgArrowWidthInPx: 14,
  remInPx: 16,
  borderRadiusInRem: 0.5
  // set in 'rounded-lg' class
};
function PopoverComponent(props) {
  const {
    title = "",
    content = "",
    trigger = "click",
    children = /* @__PURE__ */ jsx(Fragment, {}),
    placement = "bottom-start",
    autoPlacementOptions,
    open: controlledOpen,
    showArrow = true,
    arrowFill = "white",
    overlayStyle = {},
    overlayClassName = "",
    innerContentClassName,
    overlayInnerStyle,
    offsetOptions = {
      mainAxis: cssConfig.svgArrowWidthInPx / 2
    },
    onOpenChange: setControlledOpen,
    transitionDuration = 0,
    role = "dialog",
    containerClassName,
    parentId,
    enabled = true,
    isDismissBubbleEnabled = false
  } = props;
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
  const arrowRef = useRef(null);
  const nodeId = useFloatingNodeId(parentId);
  const open = useMemo(() => controlledOpen ?? uncontrolledOpen, [controlledOpen, uncontrolledOpen]);
  const setOpen = setControlledOpen ?? setUncontrolledOpen;
  const middleware = [arrow({
    element: arrowRef,
    padding: cssConfig.remInPx * cssConfig.borderRadiusInRem
  }), offset(offsetOptions)];
  if (autoPlacementOptions) middleware.push(autoPlacement(autoPlacementOptions));
  const {
    refs,
    floatingStyles,
    context
  } = useFloating({
    nodeId,
    placement,
    open,
    onOpenChange: setOpen,
    whileElementsMounted: autoUpdate,
    middleware
  });
  const clickEnabled = trigger.includes("click") && enabled;
  const hoverEnabled = trigger.includes("hover") && enabled;
  const click = useClick(context, {
    enabled: clickEnabled,
    toggle: false
  });
  const hover = useHover(context, {
    enabled: hoverEnabled,
    move: false,
    delay: {
      open: 0,
      close: 100
    }
  });
  const dismiss = useDismiss(context, {
    bubbles: isDismissBubbleEnabled,
    referencePress: false
  });
  const roleInteraction = useRole(context, {
    role
  });
  const {
    getReferenceProps,
    getFloatingProps
  } = useInteractions([click, hover, dismiss, roleInteraction]);
  const {
    isMounted,
    styles: styles2
  } = useTransitionStyles(context, {
    duration: transitionDuration
  });
  const className = `${overlayClassName} ${options$d.popover.wrapper}`;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      ref: refs.setReference,
      className: `popover inline-flex ${containerClassName}`,
      ...getReferenceProps(),
      children
    }), /* @__PURE__ */ jsx(FloatingNode, {
      id: nodeId,
      children: open && isMounted && /* @__PURE__ */ jsx(FloatingPortal, {
        root: portalElement(),
        children: /* @__PURE__ */ jsxs("div", {
          className,
          ref: refs.setFloating,
          style: {
            ...floatingStyles,
            ...overlayStyle,
            ...styles2
          },
          ...getFloatingProps(),
          children: [showArrow && /* @__PURE__ */ jsx(FloatingArrow, {
            ref: arrowRef,
            context,
            fill: arrowFill,
            className: "z-50"
          }), /* @__PURE__ */ jsxs("div", {
            className: "overflow-hidden border-none",
            style: (
              // when arrow present in top and bottom placements, prevent it from overhanging border radius
              // also includes an anti-nullish-coalescing-operator check on innerContentClassName,
              //      due to default popover.innerContent classes
              !(innerContentClassName === null || innerContentClassName === void 0) && showArrow && (placement.startsWith("top") || placement.startsWith("bottom")) ? {
                minWidth: `${cssConfig.svgArrowWidthInPx + 2 * cssConfig.borderRadiusInRem * cssConfig.remInPx}px`,
                textAlign: "center"
              } : {}
            ),
            children: [title && /* @__PURE__ */ jsx("div", {
              className: options$d.popover.title,
              children: title
            }), /* @__PURE__ */ jsx("div", {
              style: overlayInnerStyle,
              className: innerContentClassName ?? options$d.popover.innerContent,
              children: content
            })]
          })]
        })
      })
    })]
  });
}
function Popover(props) {
  const parentId = useFloatingParentNodeId();
  if (parentId === null) {
    return /* @__PURE__ */ jsx(FloatingTree, {
      children: /* @__PURE__ */ jsx(PopoverComponent, {
        ...props,
        parentId: parentId ?? void 0
      })
    });
  }
  return /* @__PURE__ */ jsx(PopoverComponent, {
    ...props
  });
}
const wrapperClasses$3 = "flex flex-nowrap items-center text-sm leading-6 text-primary font-medium cursor-pointer";
const BatchAction = ({
  type = "custom",
  ...props
}) => {
  const {
    name,
    icon,
    onClick
  } = props;
  const label = {
    export: "Export results",
    custom: name,
    customize: "Customize",
    saveView: "Save view",
    import: "Import",
    group: "Group"
  }[type];
  const actionIcon = {
    export: SvgFileExport,
    custom: icon,
    customize: SvgTable,
    saveView: SvgFloppyDisk,
    import: SvgPlus,
    group: SvgListTree
  }[type];
  const styles2 = {
    export: " mr-8",
    custom: " mr-8",
    customize: " ml-auto",
    saveView: " mr-8",
    import: " mr-8",
    group: " mr-8"
  }[type];
  return /* @__PURE__ */ jsxs("div", {
    "data-testid": "batch-action",
    className: wrapperClasses$3 + styles2,
    onClick,
    children: [/* @__PURE__ */ jsx("div", {
      className: "pr-2",
      children: actionIcon && actionIcon({
        className: "w-5 h-4 text-primary fill-current"
      })
    }), label]
  });
};
const GroupAction = (props) => {
  const {
    onChange,
    options: options2,
    value
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const renderOptions = useMemo(() => [...options2, "No groups"].map((option) => {
    const item = {
      label: option,
      value: option
    };
    return /* @__PURE__ */ jsx(FilterComboBoxMenuItem, {
      item,
      defaultSelection: option === "No groups" ? value === void 0 : value === option,
      className: " pr-5 text-sm",
      onSelect: ({
        value: value2
      }) => {
        setIsOpen(false);
        onChange(value2 === "No groups" ? void 0 : value2);
      }
    }, option);
  }), [options2, value, onChange]);
  return /* @__PURE__ */ jsx(Popover, {
    content: renderOptions,
    showArrow: false,
    innerContentClassName: "flex-col max-h-60 overflow-y-auto rounded-md border-t border-t-gray-300 shadow-dark",
    trigger: "external",
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: "bottom-end",
    children: /* @__PURE__ */ jsx(BatchAction, {
      type: "group",
      onClick: () => {
        setIsOpen(true);
      }
    })
  });
};
function getNumDigits(numToFormat, props) {
  let minDigits, maxDigits;
  if (props.style == "currency") {
    minDigits = numToFormat % 1 == 0 ? maxDigits = 0 : 2;
  }
  return [minDigits, maxDigits];
}
function getFormatted$1(props) {
  if (typeof props.children !== "string" && typeof props.children !== "number") {
    return props.children;
  }
  const numToFormat = Number.parseFloat(props.children.toString());
  const [minDigits, maxDigits] = getNumDigits(numToFormat, props);
  if (Number.isNaN(numToFormat)) return props.children;
  return Intl.NumberFormat(props.locales, {
    minimumFractionDigits: props.minimumFractionDigits ?? minDigits,
    maximumFractionDigits: props.maximumFractionDigits ?? maxDigits,
    ...props
  }).format(numToFormat).toLowerCase();
}
const FormattedNumber = ({
  locales = "en-us",
  currency = "USD",
  ...props
}) => {
  const formatted = useMemo(() => {
    return getFormatted$1({
      locales,
      currency,
      ...props
    });
  }, [locales, currency, props]);
  return /* @__PURE__ */ jsx(Fragment, {
    children: formatted
  });
};
const innerStyles = "text-white text-sm leading-6 py-1.5 px-2 bg-gray-900 rounded-lg border-none overflow-hidden";
function Tooltip({
  placement = "bottom-start",
  arrowPointAtCenter = false,
  ...props
}) {
  const {
    innerContentClassName = "",
    title,
    ...rest
  } = props;
  return /* @__PURE__ */ jsx(Popover, {
    arrowFill: "#212121",
    trigger: "hover",
    enabled: !!title,
    content: title,
    role: "tooltip",
    transitionDuration: 250,
    innerContentClassName: `${innerStyles} ${innerContentClassName}`,
    placement,
    arrowPointAtCenter,
    ...rest
  });
}
const wrapperClasses$2 = "p-2 border-b border-b-gray-300 border-solid bg-white h-14 text-sm leading-6 flex items-center";
const countDisplayClasses = "ml-2 mr-8";
const skeletonClasses$1 = "h-6 w-25 bg-gray-100 rounded-lg mb-1";
const getShowBatchActions = (numSelected, isLoading) => {
  return numSelected > 0 && !isLoading;
};
const CountDisplay = ({
  count: count2,
  numSelected = 0,
  isLoading,
  itemText,
  selectionHelperText
}) => {
  return isLoading ? /* @__PURE__ */ jsx("div", {
    "data-testid": "skeleton",
    className: skeletonClasses$1
  }) : /* @__PURE__ */ jsx("div", {
    className: countDisplayClasses,
    children: numSelected > 0 ? /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(FormattedNumber, {
        children: numSelected
      }), " ", selectionHelperText ?? "selected"]
    }) : /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(FormattedNumber, {
        children: count2
      }), " ", itemText]
    })
  });
};
const fileExportStart = (fileExportCallback) => {
  if (fileExportCallback) fileExportCallback();
};
const ExportBatchAction = ({
  isLoading,
  fileExportCallback,
  showExportResults
}) => {
  return isLoading || !showExportResults ? /* @__PURE__ */ jsx(Fragment, {}) : /* @__PURE__ */ jsx(BatchAction, {
    type: "export",
    onClick: () => {
      fileExportStart(fileExportCallback);
    }
  });
};
const ImportBatchAction = ({
  isLoading,
  importCallback,
  showImport
}) => {
  return isLoading || !showImport ? /* @__PURE__ */ jsx(Fragment, {}) : /* @__PURE__ */ jsx(BatchAction, {
    type: "import",
    onClick: () => {
      if (importCallback) importCallback();
    }
  });
};
const customizeClick = (customizeCallback) => () => {
  if (customizeCallback) {
    customizeCallback();
  }
};
const CustomizeButton = ({
  numSelected = 0,
  isLoading,
  showCustomize,
  customizeCallback
}) => {
  const showCustomizeAction = !showCustomize || numSelected > 0 && !isLoading;
  return showCustomizeAction ? /* @__PURE__ */ jsx(Fragment, {}) : /* @__PURE__ */ jsx(BatchAction, {
    type: "customize",
    onClick: customizeClick(customizeCallback)
  });
};
const SaveViewButton = ({
  numSelected = 0,
  isLoading,
  showSaveView,
  onSaveView
}) => {
  const handleSaveViewClick = () => {
    if (onSaveView) {
      onSaveView();
    }
  };
  return numSelected > 0 && !isLoading || !showSaveView ? /* @__PURE__ */ jsx(Fragment, {}) : /* @__PURE__ */ jsx(BatchAction, {
    type: "saveView",
    onClick: handleSaveViewClick
  });
};
const ActionBar = ({
  numSelected = 0,
  isLoading = false,
  children,
  showGroup,
  groupProps,
  itemText = "items",
  count: count2 = 0,
  showCustomize = true,
  showExportResults = true,
  ...props
}) => {
  const showBatchActions = getShowBatchActions(numSelected, isLoading);
  return /* @__PURE__ */ jsxs("div", {
    className: wrapperClasses$2,
    children: [/* @__PURE__ */ jsx(CountDisplay, {
      ...props,
      numSelected,
      isLoading,
      itemText,
      count: count2
    }), /* @__PURE__ */ jsx(ImportBatchAction, {
      ...props,
      isLoading
    }), /* @__PURE__ */ jsx(ExportBatchAction, {
      ...props,
      isLoading,
      showExportResults
    }), showBatchActions ? children : /* @__PURE__ */ jsx(Fragment, {}), /* @__PURE__ */ jsxs("div", {
      className: "ml-auto flex",
      children: [/* @__PURE__ */ jsx(Tooltip, {
        title: "Save current view of columns. Filters are not included.",
        innerContentClassName: "whitespace-nowrap",
        overlayStyle: {
          maxWidth: "none",
          minWidth: "fit-content",
          width: "auto"
        },
        autoPlacementOptions: {
          allowedPlacements: ["bottom-start", "bottom-end"]
        },
        children: /* @__PURE__ */ jsx("div", {
          children: /* @__PURE__ */ jsx(SaveViewButton, {
            ...props,
            numSelected,
            isLoading
          })
        })
      }), showGroup && groupProps && !isLoading && /* @__PURE__ */ jsx(GroupAction, {
        ...groupProps
      }), /* @__PURE__ */ jsx(CustomizeButton, {
        ...props,
        numSelected,
        isLoading,
        showCustomize
      })]
    })]
  });
};
const focusClasses$1 = "outline-none focus-visible:ring-2 focus-visible:ring-midnight-900 focus-visible:ring-offset-2";
const classes$4 = {
  base: "flex flex-row h-min w-fit rounded-lg items-center justify-center cursor-pointer fill-current",
  sizes: {
    large: {
      withLabel: "py-2.5 px-5 gap-x-2",
      withoutLabel: "p-2.5",
      icon: "size-5 m-px"
    },
    medium: {
      withLabel: "py-2 px-4 gap-x-2",
      withoutLabel: "p-2",
      icon: "size-5 m-px"
    },
    small: {
      withLabel: "py-1 px-2 gap-x-2",
      withoutLabel: "p-1",
      icon: "size-5 m-px"
    }
  },
  loading: `bg-jungle-50 text-primary ${focusClasses$1}`,
  variants: {
    default: `bg-white text-black border border-gray-600 hover:bg-jungle-50 hover:text-primary active:text-jungle-900 active:bg-jungle-100 active:border-jungle-900 ${focusClasses$1} focus-visible:text-gray-900 disabled:bg-white disabled:text-gray-600 disabled:border-gray-600`,
    primary: `bg-primary hover:bg-jungle-800 active:bg-jungle-900 text-white ${focusClasses$1} disabled:bg-jungle-400`,
    link: `text-primary hover:bg-gray-100 hover:text-primary active:bg-gray-200 ${focusClasses$1} disabled:bg-transparent`,
    action: `text-primary hover:bg-jungle-200 active:bg-jungle-300 fill-jungle-900 hover:fill-gray-900 ${focusClasses$1} active:fill-gray-900 hover:text-gray-900 active:text-gray-900 border hover:border-jungle-200 active:border-transparent border-transparent disabled:bg-transparent disabled:border-transparent disabled:text-gray-600`,
    text: `text-gray-900 hover:bg-gray-100 active:bg-gray-200 ${focusClasses$1} disabled:bg-transparent`,
    inherit: "",
    danger: `bg-red-500 hover:bg-red-600 active:bg-red-700 text-white ${focusClasses$1} disabled:bg-red-400`
  }
};
const Button$1 = (props) => {
  const {
    icon,
    children,
    className,
    style: style2,
    type = "default",
    size = "large",
    loading,
    disabled,
    htmlType = "button",
    onClick,
    href,
    target = "_blank",
    title
  } = props;
  const classNameMemo = useMemo(() => {
    const sizeClasses = children ? classes$4.sizes[size].withLabel : classes$4.sizes[size].withoutLabel;
    const colorClasses = loading ? classes$4.loading : classes$4.variants[type];
    return addStyles([classes$4.base, colorClasses, sizeClasses, className]);
  }, [type, size, children, className, loading]);
  const contents = /* @__PURE__ */ jsxs(Fragment, {
    children: [icon && !loading && icon({
      className: classes$4.sizes[size].icon,
      title: "ButtonIcon"
    }), loading && /* @__PURE__ */ jsx(Spinner, {
      size: "small"
    }), children]
  });
  return href ? /* @__PURE__ */ jsx("a", {
    title,
    className: classNameMemo,
    style: style2,
    href,
    target,
    children: contents
  }) : /* @__PURE__ */ jsx("button", {
    title,
    className: classNameMemo,
    style: style2,
    type: htmlType,
    disabled,
    onClick,
    children: contents
  });
};
const CLASS_PART_SEPARATOR = "-";
function createClassUtils(config) {
  const classMap = createClassMap(config);
  const {
    conflictingClassGroups,
    conflictingClassGroupModifiers
  } = config;
  function getClassGroupId(className) {
    const classParts = className.split(CLASS_PART_SEPARATOR);
    if (classParts[0] === "" && classParts.length !== 1) {
      classParts.shift();
    }
    return getGroupRecursive(classParts, classMap) || getGroupIdForArbitraryProperty(className);
  }
  function getConflictingClassGroupIds(classGroupId, hasPostfixModifier) {
    const conflicts = conflictingClassGroups[classGroupId] || [];
    if (hasPostfixModifier && conflictingClassGroupModifiers[classGroupId]) {
      return [...conflicts, ...conflictingClassGroupModifiers[classGroupId]];
    }
    return conflicts;
  }
  return {
    getClassGroupId,
    getConflictingClassGroupIds
  };
}
function getGroupRecursive(classParts, classPartObject) {
  var _a;
  if (classParts.length === 0) {
    return classPartObject.classGroupId;
  }
  const currentClassPart = classParts[0];
  const nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
  const classGroupFromNextClassPart = nextClassPartObject ? getGroupRecursive(classParts.slice(1), nextClassPartObject) : void 0;
  if (classGroupFromNextClassPart) {
    return classGroupFromNextClassPart;
  }
  if (classPartObject.validators.length === 0) {
    return void 0;
  }
  const classRest = classParts.join(CLASS_PART_SEPARATOR);
  return (_a = classPartObject.validators.find(({
    validator
  }) => validator(classRest))) == null ? void 0 : _a.classGroupId;
}
const arbitraryPropertyRegex = /^\[(.+)\]$/;
function getGroupIdForArbitraryProperty(className) {
  if (arbitraryPropertyRegex.test(className)) {
    const arbitraryPropertyClassName = arbitraryPropertyRegex.exec(className)[1];
    const property = arbitraryPropertyClassName == null ? void 0 : arbitraryPropertyClassName.substring(0, arbitraryPropertyClassName.indexOf(":"));
    if (property) {
      return "arbitrary.." + property;
    }
  }
}
function createClassMap(config) {
  const {
    theme,
    prefix
  } = config;
  const classMap = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  const prefixedClassGroupEntries = getPrefixedClassGroupEntries(Object.entries(config.classGroups), prefix);
  prefixedClassGroupEntries.forEach(([classGroupId, classGroup]) => {
    processClassesRecursively(classGroup, classMap, classGroupId, theme);
  });
  return classMap;
}
function processClassesRecursively(classGroup, classPartObject, classGroupId, theme) {
  classGroup.forEach((classDefinition) => {
    if (typeof classDefinition === "string") {
      const classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
      classPartObjectToEdit.classGroupId = classGroupId;
      return;
    }
    if (typeof classDefinition === "function") {
      if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
      }
      classPartObject.validators.push({
        validator: classDefinition,
        classGroupId
      });
      return;
    }
    Object.entries(classDefinition).forEach(([key, classGroup2]) => {
      processClassesRecursively(classGroup2, getPart(classPartObject, key), classGroupId, theme);
    });
  });
}
function getPart(classPartObject, path) {
  let currentClassPartObject = classPartObject;
  path.split(CLASS_PART_SEPARATOR).forEach((pathPart) => {
    if (!currentClassPartObject.nextPart.has(pathPart)) {
      currentClassPartObject.nextPart.set(pathPart, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      });
    }
    currentClassPartObject = currentClassPartObject.nextPart.get(pathPart);
  });
  return currentClassPartObject;
}
function isThemeGetter(func) {
  return func.isThemeGetter;
}
function getPrefixedClassGroupEntries(classGroupEntries, prefix) {
  if (!prefix) {
    return classGroupEntries;
  }
  return classGroupEntries.map(([classGroupId, classGroup]) => {
    const prefixedClassGroup = classGroup.map((classDefinition) => {
      if (typeof classDefinition === "string") {
        return prefix + classDefinition;
      }
      if (typeof classDefinition === "object") {
        return Object.fromEntries(Object.entries(classDefinition).map(([key, value]) => [prefix + key, value]));
      }
      return classDefinition;
    });
    return [classGroupId, prefixedClassGroup];
  });
}
function createLruCache(maxCacheSize) {
  if (maxCacheSize < 1) {
    return {
      get: () => void 0,
      set: () => {
      }
    };
  }
  let cacheSize = 0;
  let cache = /* @__PURE__ */ new Map();
  let previousCache = /* @__PURE__ */ new Map();
  function update(key, value) {
    cache.set(key, value);
    cacheSize++;
    if (cacheSize > maxCacheSize) {
      cacheSize = 0;
      previousCache = cache;
      cache = /* @__PURE__ */ new Map();
    }
  }
  return {
    get(key) {
      let value = cache.get(key);
      if (value !== void 0) {
        return value;
      }
      if ((value = previousCache.get(key)) !== void 0) {
        update(key, value);
        return value;
      }
    },
    set(key, value) {
      if (cache.has(key)) {
        cache.set(key, value);
      } else {
        update(key, value);
      }
    }
  };
}
const IMPORTANT_MODIFIER = "!";
function createSplitModifiers(config) {
  const separator = config.separator;
  const isSeparatorSingleCharacter = separator.length === 1;
  const firstSeparatorCharacter = separator[0];
  const separatorLength = separator.length;
  return function splitModifiers(className) {
    const modifiers = [];
    let bracketDepth = 0;
    let modifierStart = 0;
    let postfixModifierPosition;
    for (let index2 = 0; index2 < className.length; index2++) {
      let currentCharacter = className[index2];
      if (bracketDepth === 0) {
        if (currentCharacter === firstSeparatorCharacter && (isSeparatorSingleCharacter || className.slice(index2, index2 + separatorLength) === separator)) {
          modifiers.push(className.slice(modifierStart, index2));
          modifierStart = index2 + separatorLength;
          continue;
        }
        if (currentCharacter === "/") {
          postfixModifierPosition = index2;
          continue;
        }
      }
      if (currentCharacter === "[") {
        bracketDepth++;
      } else if (currentCharacter === "]") {
        bracketDepth--;
      }
    }
    const baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.substring(modifierStart);
    const hasImportantModifier = baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER);
    const baseClassName = hasImportantModifier ? baseClassNameWithImportantModifier.substring(1) : baseClassNameWithImportantModifier;
    const maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
    return {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    };
  };
}
function sortModifiers(modifiers) {
  if (modifiers.length <= 1) {
    return modifiers;
  }
  const sortedModifiers = [];
  let unsortedModifiers = [];
  modifiers.forEach((modifier) => {
    const isArbitraryVariant = modifier[0] === "[";
    if (isArbitraryVariant) {
      sortedModifiers.push(...unsortedModifiers.sort(), modifier);
      unsortedModifiers = [];
    } else {
      unsortedModifiers.push(modifier);
    }
  });
  sortedModifiers.push(...unsortedModifiers.sort());
  return sortedModifiers;
}
function createConfigUtils(config) {
  return {
    cache: createLruCache(config.cacheSize),
    splitModifiers: createSplitModifiers(config),
    ...createClassUtils(config)
  };
}
const SPLIT_CLASSES_REGEX = /\s+/;
function mergeClassList(classList, configUtils) {
  const {
    splitModifiers,
    getClassGroupId,
    getConflictingClassGroupIds
  } = configUtils;
  const classGroupsInConflict = /* @__PURE__ */ new Set();
  return classList.trim().split(SPLIT_CLASSES_REGEX).map((originalClassName) => {
    const {
      modifiers,
      hasImportantModifier,
      baseClassName,
      maybePostfixModifierPosition
    } = splitModifiers(originalClassName);
    let classGroupId = getClassGroupId(maybePostfixModifierPosition ? baseClassName.substring(0, maybePostfixModifierPosition) : baseClassName);
    let hasPostfixModifier = Boolean(maybePostfixModifierPosition);
    if (!classGroupId) {
      if (!maybePostfixModifierPosition) {
        return {
          isTailwindClass: false,
          originalClassName
        };
      }
      classGroupId = getClassGroupId(baseClassName);
      if (!classGroupId) {
        return {
          isTailwindClass: false,
          originalClassName
        };
      }
      hasPostfixModifier = false;
    }
    const variantModifier = sortModifiers(modifiers).join(":");
    const modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
    return {
      isTailwindClass: true,
      modifierId,
      classGroupId,
      originalClassName,
      hasPostfixModifier
    };
  }).reverse().filter((parsed) => {
    if (!parsed.isTailwindClass) {
      return true;
    }
    const {
      modifierId,
      classGroupId,
      hasPostfixModifier
    } = parsed;
    const classId = modifierId + classGroupId;
    if (classGroupsInConflict.has(classId)) {
      return false;
    }
    classGroupsInConflict.add(classId);
    getConflictingClassGroupIds(classGroupId, hasPostfixModifier).forEach((group) => classGroupsInConflict.add(modifierId + group));
    return true;
  }).reverse().map((parsed) => parsed.originalClassName).join(" ");
}
function twJoin() {
  let index2 = 0;
  let argument;
  let resolvedValue;
  let string = "";
  while (index2 < arguments.length) {
    if (argument = arguments[index2++]) {
      if (resolvedValue = toValue(argument)) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}
function toValue(mix) {
  if (typeof mix === "string") {
    return mix;
  }
  let resolvedValue;
  let string = "";
  for (let k = 0; k < mix.length; k++) {
    if (mix[k]) {
      if (resolvedValue = toValue(mix[k])) {
        string && (string += " ");
        string += resolvedValue;
      }
    }
  }
  return string;
}
function createTailwindMerge(createConfigFirst, ...createConfigRest) {
  let configUtils;
  let cacheGet;
  let cacheSet;
  let functionToCall = initTailwindMerge;
  function initTailwindMerge(classList) {
    const config = createConfigRest.reduce((previousConfig, createConfigCurrent) => createConfigCurrent(previousConfig), createConfigFirst());
    configUtils = createConfigUtils(config);
    cacheGet = configUtils.cache.get;
    cacheSet = configUtils.cache.set;
    functionToCall = tailwindMerge;
    return tailwindMerge(classList);
  }
  function tailwindMerge(classList) {
    const cachedResult = cacheGet(classList);
    if (cachedResult) {
      return cachedResult;
    }
    const result = mergeClassList(classList, configUtils);
    cacheSet(classList, result);
    return result;
  }
  return function callTailwindMerge() {
    return functionToCall(twJoin.apply(null, arguments));
  };
}
function fromTheme(key) {
  const themeGetter = (theme) => theme[key] || [];
  themeGetter.isThemeGetter = true;
  return themeGetter;
}
const arbitraryValueRegex = /^\[(?:([a-z-]+):)?(.+)\]$/i;
const fractionRegex = /^\d+\/\d+$/;
const stringLengths = /* @__PURE__ */ new Set(["px", "full", "screen"]);
const tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
const lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
const colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/;
const shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
const imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function isLength(value) {
  return isNumber(value) || stringLengths.has(value) || fractionRegex.test(value);
}
function isArbitraryLength(value) {
  return getIsArbitraryValue(value, "length", isLengthOnly);
}
function isNumber(value) {
  return Boolean(value) && !Number.isNaN(Number(value));
}
function isArbitraryNumber(value) {
  return getIsArbitraryValue(value, "number", isNumber);
}
function isInteger(value) {
  return Boolean(value) && Number.isInteger(Number(value));
}
function isPercent(value) {
  return value.endsWith("%") && isNumber(value.slice(0, -1));
}
function isArbitraryValue(value) {
  return arbitraryValueRegex.test(value);
}
function isTshirtSize(value) {
  return tshirtUnitRegex.test(value);
}
const sizeLabels = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function isArbitrarySize(value) {
  return getIsArbitraryValue(value, sizeLabels, isNever);
}
function isArbitraryPosition(value) {
  return getIsArbitraryValue(value, "position", isNever);
}
const imageLabels = /* @__PURE__ */ new Set(["image", "url"]);
function isArbitraryImage(value) {
  return getIsArbitraryValue(value, imageLabels, isImage);
}
function isArbitraryShadow(value) {
  return getIsArbitraryValue(value, "", isShadow);
}
function isAny() {
  return true;
}
function getIsArbitraryValue(value, label, testValue) {
  const result = arbitraryValueRegex.exec(value);
  if (result) {
    if (result[1]) {
      return typeof label === "string" ? result[1] === label : label.has(result[1]);
    }
    return testValue(result[2]);
  }
  return false;
}
function isLengthOnly(value) {
  return lengthUnitRegex.test(value) && !colorFunctionRegex.test(value);
}
function isNever() {
  return false;
}
function isShadow(value) {
  return shadowRegex.test(value);
}
function isImage(value) {
  return imageRegex.test(value);
}
function getDefaultConfig() {
  const colors = fromTheme("colors");
  const spacing = fromTheme("spacing");
  const blur = fromTheme("blur");
  const brightness = fromTheme("brightness");
  const borderColor = fromTheme("borderColor");
  const borderRadius = fromTheme("borderRadius");
  const borderSpacing = fromTheme("borderSpacing");
  const borderWidth = fromTheme("borderWidth");
  const contrast = fromTheme("contrast");
  const grayscale = fromTheme("grayscale");
  const hueRotate = fromTheme("hueRotate");
  const invert = fromTheme("invert");
  const gap = fromTheme("gap");
  const gradientColorStops = fromTheme("gradientColorStops");
  const gradientColorStopPositions = fromTheme("gradientColorStopPositions");
  const inset = fromTheme("inset");
  const margin = fromTheme("margin");
  const opacity = fromTheme("opacity");
  const padding = fromTheme("padding");
  const saturate = fromTheme("saturate");
  const scale = fromTheme("scale");
  const sepia = fromTheme("sepia");
  const skew = fromTheme("skew");
  const space = fromTheme("space");
  const translate = fromTheme("translate");
  const getOverscroll = () => ["auto", "contain", "none"];
  const getOverflow = () => ["auto", "hidden", "clip", "visible", "scroll"];
  const getSpacingWithAutoAndArbitrary = () => ["auto", isArbitraryValue, spacing];
  const getSpacingWithArbitrary = () => [isArbitraryValue, spacing];
  const getLengthWithEmptyAndArbitrary = () => ["", isLength, isArbitraryLength];
  const getNumberWithAutoAndArbitrary = () => ["auto", isNumber, isArbitraryValue];
  const getPositions = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  const getLineStyles = () => ["solid", "dashed", "dotted", "double", "none"];
  const getBlendModes = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  const getAlign = () => ["start", "end", "center", "between", "around", "evenly", "stretch"];
  const getZeroAndEmpty = () => ["", "0", isArbitraryValue];
  const getBreaks = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  const getNumber = () => [isNumber, isArbitraryNumber];
  const getNumberAndArbitrary = () => [isNumber, isArbitraryValue];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [isAny],
      spacing: [isLength, isArbitraryLength],
      blur: ["none", "", isTshirtSize, isArbitraryValue],
      brightness: getNumber(),
      borderColor: [colors],
      borderRadius: ["none", "", "full", isTshirtSize, isArbitraryValue],
      borderSpacing: getSpacingWithArbitrary(),
      borderWidth: getLengthWithEmptyAndArbitrary(),
      contrast: getNumber(),
      grayscale: getZeroAndEmpty(),
      hueRotate: getNumberAndArbitrary(),
      invert: getZeroAndEmpty(),
      gap: getSpacingWithArbitrary(),
      gradientColorStops: [colors],
      gradientColorStopPositions: [isPercent, isArbitraryLength],
      inset: getSpacingWithAutoAndArbitrary(),
      margin: getSpacingWithAutoAndArbitrary(),
      opacity: getNumber(),
      padding: getSpacingWithArbitrary(),
      saturate: getNumber(),
      scale: getNumber(),
      sepia: getZeroAndEmpty(),
      skew: getNumberAndArbitrary(),
      space: getSpacingWithArbitrary(),
      translate: getSpacingWithArbitrary()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", isArbitraryValue]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [isTshirtSize]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": getBreaks()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": getBreaks()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...getPositions(), isArbitraryValue]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: getOverflow()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": getOverflow()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": getOverflow()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: getOverscroll()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": getOverscroll()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": getOverscroll()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [inset]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [inset]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [inset]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [inset]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [inset]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [inset]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [inset]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [inset]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [inset]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", isInteger, isArbitraryValue]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: getSpacingWithAutoAndArbitrary()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", isArbitraryValue]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: getZeroAndEmpty()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: getZeroAndEmpty()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", isInteger, isArbitraryValue]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [isAny]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [isAny]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [isInteger, isArbitraryValue]
        }, isArbitraryValue]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": getNumberWithAutoAndArbitrary()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", isArbitraryValue]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [gap]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [gap]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [gap]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...getAlign()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...getAlign(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...getAlign(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [padding]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [padding]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [padding]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [padding]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [padding]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [padding]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [padding]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [padding]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [padding]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [margin]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [margin]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [margin]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [margin]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [margin]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [margin]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [margin]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [margin]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [margin]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [space]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [space]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", isArbitraryValue, spacing]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [isArbitraryValue, spacing, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [isArbitraryValue, spacing, "none", "full", "min", "max", "fit", "prose", {
          screen: [isTshirtSize]
        }, isTshirtSize]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [isArbitraryValue, spacing, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [isArbitraryValue, spacing, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [isArbitraryValue, spacing, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [isArbitraryValue, spacing, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", isTshirtSize, isArbitraryLength]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", isArbitraryNumber]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [isAny]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", isArbitraryValue]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", isNumber, isArbitraryNumber]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", isLength, isArbitraryValue]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", isArbitraryValue]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", isArbitraryValue]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [colors]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [opacity]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [colors]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [opacity]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...getLineStyles(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", isLength, isArbitraryLength]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", isLength, isArbitraryValue]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [colors]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: getSpacingWithArbitrary()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", isArbitraryValue]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", isArbitraryValue]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [opacity]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...getPositions(), isArbitraryPosition]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", isArbitrarySize]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, isArbitraryImage]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [colors]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [gradientColorStopPositions]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [gradientColorStops]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [gradientColorStops]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [borderRadius]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [borderRadius]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [borderRadius]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [borderRadius]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [borderRadius]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [borderRadius]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [borderRadius]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [borderRadius]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [borderRadius]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [borderRadius]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [borderRadius]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [borderRadius]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [borderRadius]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [borderRadius]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [borderRadius]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [borderWidth]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [borderWidth]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [borderWidth]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [borderWidth]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [borderWidth]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [borderWidth]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [borderWidth]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [borderWidth]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [borderWidth]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [opacity]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...getLineStyles(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [borderWidth]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [borderWidth]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [opacity]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: getLineStyles()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [borderColor]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [borderColor]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [borderColor]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [borderColor]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [borderColor]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [borderColor]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [borderColor]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [borderColor]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...getLineStyles()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [isLength, isArbitraryValue]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [isLength, isArbitraryLength]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [colors]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: getLengthWithEmptyAndArbitrary()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [colors]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [opacity]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [isLength, isArbitraryLength]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [colors]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", isTshirtSize, isArbitraryShadow]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [isAny]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [opacity]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": getBlendModes()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": getBlendModes()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [blur]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [brightness]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [contrast]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", isTshirtSize, isArbitraryValue]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [grayscale]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [hueRotate]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [invert]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [saturate]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [sepia]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [blur]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [brightness]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [contrast]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [grayscale]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [hueRotate]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [invert]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [opacity]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [saturate]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [sepia]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [borderSpacing]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [borderSpacing]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [borderSpacing]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", isArbitraryValue]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: getNumberAndArbitrary()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", isArbitraryValue]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: getNumberAndArbitrary()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", isArbitraryValue]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [scale]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [scale]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [scale]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [isInteger, isArbitraryValue]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [translate]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [translate]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [skew]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [skew]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", isArbitraryValue]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", colors]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", isArbitraryValue]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [colors]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": getSpacingWithArbitrary()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", isArbitraryValue]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [colors, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [isLength, isArbitraryLength, isArbitraryNumber]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [colors, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const twMerge = /* @__PURE__ */ createTailwindMerge(getDefaultConfig);
const addStyles = (input) => {
  const styles2 = [];
  const splitAndFilter = (str) => {
    for (const cssClass of str.split(" ")) {
      if (!styles2.includes(cssClass)) {
        styles2.push(cssClass.trim());
      }
    }
  };
  if (Array.isArray(input)) {
    for (const str of input.filter((i) => typeof i === "string")) {
      if (str) splitAndFilter(str);
    }
  } else {
    splitAndFilter(input);
  }
  return styles2.join(" ");
};
const mergeStyles = (input) => {
  let mergedStyles = "";
  if (Array.isArray(input)) {
    for (const str of input) {
      mergedStyles = twMerge(mergedStyles, (str == null ? void 0 : str.trim()) ?? "");
    }
  } else {
    mergedStyles = (input == null ? void 0 : input.trim()) ?? "";
  }
  const uniqueInOrderStyles = [...new Set(mergedStyles.split(" "))].sort((a, b) => a.localeCompare(b)).join(" ");
  return uniqueInOrderStyles;
};
const useChildrenWithProps = (children, newProps, indexFieldName, indexFieldOffset = 0) => {
  return React__default.useMemo(() => {
    return React__default.Children.map(children, (child, index2) => {
      if (React__default.isValidElement(child)) {
        return React__default.cloneElement(
          child,
          indexFieldName === void 0 ? newProps : { ...newProps, [indexFieldName]: index2 + indexFieldOffset }
        );
      }
    });
  }, [children, newProps, indexFieldName, indexFieldOffset]);
};
const setInputValue = (element, value) => {
  setHTMLObjectValue(window.HTMLInputElement.prototype, element, value);
  const ev2 = new InputEvent("input", { bubbles: true });
  element.dispatchEvent(ev2);
};
const setHTMLObjectValue = (prototype, element, value) => {
  var _a;
  const nativeInputValueSetter = (_a = Object.getOwnPropertyDescriptor(prototype, "value")) == null ? void 0 : _a.set;
  nativeInputValueSetter == null ? void 0 : nativeInputValueSetter.call(element, value);
};
const useWindowSize = () => {
  const [size, setSize] = React__default.useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const handleResize = () => setSize({ width: window.innerWidth, height: window.innerHeight });
  React__default.useLayoutEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return size;
};
const debounce = (fn, ms = 300) => {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(...args), ms);
  };
};
const portalElement = () => document.querySelector("#dsl-portal") || document.body;
const stopMousePropagation = (e) => e.stopPropagation();
const stopKeyboardEventHandler = (e) => e.stopPropagation();
function toVal(mix) {
  if (typeof mix === "string" || typeof mix === "number") {
    return String(mix);
  }
  if (Array.isArray(mix)) {
    return mix.map((item) => item && toVal(item)).filter(Boolean).join(" ");
  }
  if (typeof mix === "object" && mix !== null) {
    return Object.keys(mix).filter((key) => mix[key]).join(" ");
  }
  return "";
}
function clsx(...args) {
  let i = 0, tmp, x, str = "";
  const len = args.length;
  for (; i < len; i++) {
    tmp = args[i];
    if (tmp && (x = toVal(tmp))) {
      str && (str += " ");
      str += x;
    }
  }
  return str;
}
function cn(...inputs) {
  return twMerge(clsx(...inputs));
}
const options$c = {
  base: "border-0.5 border-l-8 rounded-lg text-gray-900 w-full",
  contentWrapper: "flex items-start gap-2 py-1",
  type: {
    info: "bg-blue-50 border-blue-300 fill-blue-700",
    error: "bg-red-50 border-red-300 fill-red-500",
    warning: "bg-gold-50 border-gold-300 fill-gold-700",
    success: "bg-green-50 border-green-300 fill-green-700"
  },
  size: {
    large: "p-4",
    medium: "p-2 text-sm"
  },
  collapseWrapper: {
    large: "ml-7 mr-9 mt-4",
    medium: "ml-7 mr-9 mt-2"
  }
};
const AlertContent = (props) => {
  const {
    showIcon = true,
    type,
    title,
    content,
    action,
    size
  } = props;
  const icons = {
    info: SvgCircleInfoSolid,
    success: SvgCircleCheckSolid,
    warning: SvgTriangleExclamation,
    error: SvgDiamondExclamation
  };
  return /* @__PURE__ */ jsxs("div", {
    className: options$c.contentWrapper,
    children: [showIcon && /* @__PURE__ */ jsx("div", {
      "data-testid": "Alert icon",
      className: "flex items-center",
      children: icons[type]({
        className: size === "large" ? "size-6 inline-block" : "size-5 inline-block"
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex-start flex flex-1 flex-wrap gap-1",
      children: [title && /* @__PURE__ */ jsx("div", {
        className: "font-bold",
        children: title
      }), /* @__PURE__ */ jsx("div", {
        children: content
      }), /* @__PURE__ */ jsx("div", {
        children: action
      })]
    })]
  });
};
const Alert = (props) => {
  const {
    type,
    className = "",
    title = "",
    collapsibleContent,
    isDismissible = true,
    onVisibleChange,
    onOpenChange,
    isCollapsed = false,
    isVisible: defaultVisibility = true,
    size = "large",
    ...rest
  } = props;
  const [isVisible, setIsVisible] = useState(defaultVisibility);
  useEffect(() => setIsVisible(defaultVisibility), [defaultVisibility]);
  if (!isVisible) return /* @__PURE__ */ jsx(Fragment, {});
  return /* @__PURE__ */ jsx("div", {
    className: addStyles([options$c.base, options$c.type[type], options$c.size[size], className]),
    children: collapsibleContent ? /* @__PURE__ */ jsx(Accordion, {
      isHeaderToggleButton: false,
      onOpenChange,
      isOpen: !isCollapsed,
      header: /* @__PURE__ */ jsx(AlertContent, {
        type,
        title,
        size,
        ...rest
      }),
      content: /* @__PURE__ */ jsx("div", {
        className: options$c.collapseWrapper[size],
        children: collapsibleContent
      }),
      collapseIconClasses: size === "medium" ? "h-7" : "h-8"
    }) : /* @__PURE__ */ jsxs("div", {
      className: "flex w-full",
      children: [/* @__PURE__ */ jsx(AlertContent, {
        type,
        title,
        size,
        ...rest
      }), isDismissible && /* @__PURE__ */ jsx("button", {
        className: "ml-auto flex items-start",
        "aria-label": "Dismiss alert",
        onClick: () => {
          setIsVisible(false);
          onVisibleChange == null ? void 0 : onVisibleChange(false);
        },
        children: /* @__PURE__ */ jsx(SvgXmark, {
          className: `${size === "medium" ? "size-7" : "size-8"} fill-gray-900`
        })
      })]
    })
  });
};
Alert.displayName = "Alert";
const navClasses = "flex";
const breadcrumbListWrapperClasses = "inline-flex items-center space-x-1";
const breadcrumbItemWrapperClasses = "inline-flex items-center space-x-1";
const separatorWrapperClasses = "text-gray-700 font-normal";
const currentItemClasses = "text-gray-900 font-bold";
const linkClasses = "hover:underline flex";
const iconClasses$1 = "h-5 w-5";
const BreadcrumbText = (props) => {
  const {
    item,
    onBreadcrumbClick
  } = props;
  const clickHandler = useCallback((event) => {
    event.preventDefault();
    onBreadcrumbClick(event.currentTarget.dataset.link);
  }, [onBreadcrumbClick]);
  const iconElement = item.icon && item.icon({
    className: iconClasses$1
  });
  return item.current ? /* @__PURE__ */ jsxs("span", {
    role: "link",
    "aria-current": "page",
    className: currentItemClasses,
    children: [iconElement, " ", item.title]
  }) : /* @__PURE__ */ jsxs("a", {
    className: linkClasses,
    href: item.link,
    "data-link": item.link,
    onClick: clickHandler,
    children: [iconElement, " ", item.title]
  });
};
const BreadcrumbListItem = (props) => {
  const {
    item,
    isLastItem,
    separator,
    onBreadcrumbClick
  } = props;
  return /* @__PURE__ */ jsxs("div", {
    className: breadcrumbItemWrapperClasses,
    children: [/* @__PURE__ */ jsx(BreadcrumbText, {
      item,
      onBreadcrumbClick
    }), !isLastItem && /* @__PURE__ */ jsx("span", {
      className: separatorWrapperClasses,
      children: separator
    })]
  });
};
function Breadcrumb({
  separator = "/",
  ...props
}) {
  const {
    items,
    onBreadcrumbClick
  } = props;
  return /* @__PURE__ */ jsx("nav", {
    className: navClasses,
    "aria-label": "Breadcrumb",
    children: /* @__PURE__ */ jsx("div", {
      className: breadcrumbListWrapperClasses,
      children: items.map((item, index2) => /* @__PURE__ */ jsx(BreadcrumbListItem, {
        item,
        isLastItem: index2 === items.length - 1,
        separator,
        onBreadcrumbClick
      }, item.link))
    })
  });
}
const shadowOptions = {
  light: "shadow-light",
  dark: "shadow-dark",
  none: ""
};
const Card = ({
  shadow = "none",
  ...props
}) => {
  const {
    children,
    className,
    role
  } = props;
  return /* @__PURE__ */ jsx("div", {
    role,
    className: addStyles(["flex bg-white rounded-lg overflow-hidden", shadowOptions[shadow], className]),
    children
  });
};
const checkboxClasses = {
  base: "cursor-pointer outline-none ring-offset-0 text-primary rounded-sm checked:bg-primary checked:border-primary disabled:cursor-not-allowed disabled:border-gray-500 disabled:checked:bg-gray-400",
  intermediate: "half-checked box-content size-0 p-1.25 mx-0.5 border-3 border-white bg-jungle-800 border-solid ring-gray-600 ring-2 hover:border-white active:border-white hover:ring-primary",
  notIntermediate: "size-5 ring-0 active:border-primary hover:border-primary border-2 bg-white"
};
function Checkbox({
  hideLabel = false,
  isDisabled = false,
  isChecked = false,
  ...props
}) {
  const {
    label,
    ariaLabel = typeof label === "string" ? label : void 0,
    value,
    name,
    helperText,
    onChange,
    error,
    isPartiallyChecked
  } = props;
  const {
    current: fieldId
  } = useRef("checkbox-" + (Math.random().toString(36) + "00000000000000000").slice(2, 7));
  const [checked, setChecked] = useState(isChecked);
  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);
  const toggleChecked = (event) => {
    setChecked(!checked);
    if (onChange) {
      onChange(event);
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex",
      children: [/* @__PURE__ */ jsx("div", {
        className: "flex items-center",
        children: /* @__PURE__ */ jsx("input", {
          id: fieldId,
          type: "checkbox",
          className: addStyles([checkboxClasses.base, error ? "border-red-600" : "border-gray-600", isPartiallyChecked === true ? checkboxClasses.intermediate : checkboxClasses.notIntermediate]),
          value,
          checked,
          disabled: isDisabled,
          onChange: toggleChecked,
          "aria-label": hideLabel ? ariaLabel : void 0,
          name
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: addStyles(["ml-2", isDisabled ? "text-gray-600" : "text-gray-800"]),
        children: [!hideLabel && /* @__PURE__ */ jsx("label", {
          htmlFor: fieldId,
          className: isDisabled ? "cursor-not-allowed" : "cursor-pointer",
          children: label
        }), helperText && /* @__PURE__ */ jsx("p", {
          className: "text-xs",
          children: helperText
        })]
      })]
    }), /* @__PURE__ */ jsx("div", {
      children: error && /* @__PURE__ */ jsx("p", {
        className: "pt-1 text-red-600",
        children: error
      })
    })]
  });
}
const options$b = {
  layout: {
    vertical: "flex flex-col space-y-4",
    horizontal: "flex flex-row gap-x-8"
  }
};
function CheckboxGroup({
  layout = "vertical",
  ...props
}) {
  const {
    data,
    label,
    onChange
  } = props;
  return /* @__PURE__ */ jsxs("fieldset", {
    className: "checkbox-group",
    children: [label && /* @__PURE__ */ jsx("legend", {
      className: "body-l mb-4",
      children: label
    }), /* @__PURE__ */ jsx("div", {
      className: addStyles([options$b.layout[layout]]),
      children: data.map((checkboxProps, index2) => {
        return /* @__PURE__ */ jsx(Checkbox, {
          ...checkboxProps,
          onChange
        }, index2);
      })
    })]
  });
}
const options$a = {
  container: {
    base: "flex flex-nowrap items-center box-border rounded-lg border-solid border h-min w-fit cursor-pointer pl-5",
    unselected: "border-gray-600 bg-white text-gray-900 pr-5 py-2.5 hover:text-primary hover:fill-primary active:border-primary",
    selected: "border-jungle-600 bg-jungle-50 text-jungle-900 fill-jungle-900"
  },
  text: {
    base: "text-base select-none",
    selected: "pr-1",
    unselected: ""
  },
  icon: {
    base: "h-6 w-6",
    selected: "",
    unselected: ""
  }
};
const getState = (isSelected) => {
  return isSelected ? "selected" : "unselected";
};
const Chip = (props) => {
  const {
    value,
    isSelected,
    onChange,
    icon
  } = props;
  const [selectedState, setSelected] = useState(getState(isSelected));
  const chipSelected = () => {
    return selectedState === "selected";
  };
  const onClick = () => {
    if (!chipSelected()) {
      onChange(true);
      setSelected("selected");
    }
  };
  const onClear = () => {
    onChange(false);
    setSelected("unselected");
  };
  useEffect(() => {
    setSelected(getState(isSelected));
  }, [isSelected]);
  return /* @__PURE__ */ jsxs("div", {
    className: addStyles([options$a.container.base, options$a.container[selectedState]]),
    onClick,
    children: [icon && /* @__PURE__ */ jsx("div", {
      className: "pr-2",
      children: icon({
        className: addStyles([options$a.icon.base, options$a.icon[selectedState]])
      })
    }), /* @__PURE__ */ jsx("span", {
      className: addStyles([options$a.text.base, options$a.text[selectedState]]),
      children: value
    }), chipSelected() && /* @__PURE__ */ jsx(Button$1, {
      icon: SvgXmark,
      onClick: onClear,
      type: "action"
    })]
  });
};
const ComboBoxTag = ({
  item,
  onRightClick,
  tagProps
}) => {
  return /* @__PURE__ */ jsx(Tag, {
    text: item.label,
    baseType: "table",
    rightIcon: SvgXmark,
    onRightClick,
    ...tagProps
  });
};
const ComboBoxInputWithoutRef = (props, ref) => {
  const {
    selectedItems,
    autoFocus,
    placeholder,
    className,
    style: style2,
    size = 20,
    onSearch,
    onDeselect,
    onFocus,
    onBlur,
    value,
    defaultValue,
    tagProps,
    containerSize
  } = props;
  const inputRef = useRef(null);
  const [activeElementWhenWrapperWasSelected, setActiveElementWhenWrapperWasSelected] = useState(void 0);
  const [wrapperWasLastSelected, setWrapperWasLastSelected] = useState(false);
  return /* @__PURE__ */ jsxs("div", {
    "data-testid": "combobox-input-wrapper",
    ref,
    style: style2,
    className: mergeStyles([`combobox-input-wrapper group/comboboxitem size-${containerSize}`, className]),
    onKeyDown: stopKeyboardEventHandler,
    onMouseDown: () => {
      setWrapperWasLastSelected(true);
      setActiveElementWhenWrapperWasSelected(document.activeElement ?? void 0);
    },
    onClick: (e) => {
      var _a, _b;
      if (activeElementWhenWrapperWasSelected !== (inputRef == null ? void 0 : inputRef.current)) (_b = (_a = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a.focus) == null ? void 0 : _b.call(_a);
      stopMousePropagation(e);
    },
    children: [/* @__PURE__ */ jsxs("div", {
      className: "browser-style-none",
      children: [selectedItems.map((item) => {
        const customProps = (typeof tagProps === "function" ? tagProps(item) : tagProps) ?? {};
        return /* @__PURE__ */ jsx(ComboBoxTag, {
          item,
          onRightClick: onDeselect == null ? void 0 : onDeselect(item),
          tagProps: customProps
        }, item.value);
      }), /* @__PURE__ */ jsx("input", {
        ref: inputRef,
        role: "searchbox",
        autoFocus,
        type: "search",
        size,
        className: "ring-0",
        placeholder,
        onMouseDown: stopMousePropagation,
        onFocus: (e) => {
          setWrapperWasLastSelected(false);
          onFocus == null ? void 0 : onFocus(e);
        },
        onBlur: (e) => {
          if (wrapperWasLastSelected) e.target.focus();
          setWrapperWasLastSelected(false);
          onBlur == null ? void 0 : onBlur(e);
        },
        value,
        defaultValue,
        onChange: (e) => onSearch(e.target.value),
        onKeyDown: (e) => {
          if (e.key === "Backspace" && selectedItems.length > 0 && value === "") {
            onDeselect == null ? void 0 : onDeselect(selectedItems[selectedItems.length - 1])();
          }
        }
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "combobox-icon-wrapper",
      children: /* @__PURE__ */ jsx(SvgMagnifyingGlass, {
        className: "size-5 fill-gray-600"
      })
    })]
  });
};
const ComboBoxInput = forwardRef(ComboBoxInputWithoutRef);
const ComboBoxCore = (props) => {
  const {
    data,
    open: initialOpen,
    placeholder = "",
    className,
    size,
    onChange,
    onSearch,
    onFocus,
    onDeselect: onDeselectCallback,
    onBlur,
    renderListItem,
    defaultSelection,
    defaultSearchTerm = "",
    searchTerm: controlledSearchTerm,
    autoFocus,
    bottomOptionsListContent,
    errorProps,
    containerSize = "large",
    menuElement: ComboBoxMenu2,
    menuContent
  } = props;
  const [searchTerm, setSearchTerm] = useState(controlledSearchTerm ?? defaultSearchTerm);
  const [selectedItems, setSelectedItems] = useState(new Map((defaultSelection ?? []).map((i) => [i.value, i])));
  const [open, setOpen] = useState(initialOpen);
  const [width, setWidth] = useState(void 0);
  const ref = useRef(null);
  useEffect(() => setSearchTerm(controlledSearchTerm ?? ""), [controlledSearchTerm]);
  useEffect(() => setOpen(initialOpen), [initialOpen]);
  useEffect(() => {
    if (ref.current) {
      const observer = new ResizeObserver((entries) => {
        setWidth(entries[0].contentRect.width);
      });
      const obj = ref.current;
      observer.observe(obj);
      return () => observer.unobserve(obj);
    }
  }, []);
  const setItemSelectedState = (item, isSelected) => {
    const newSelection = new Map(selectedItems);
    if (isSelected) {
      newSelection.set(item.value, item);
    } else {
      newSelection.delete(item.value);
    }
    setSelectedItems(newSelection);
    onChange == null ? void 0 : onChange([...newSelection.values()]);
  };
  useEffect(() => {
    const newSelection = /* @__PURE__ */ new Map();
    defaultSelection == null ? void 0 : defaultSelection.map((item) => newSelection.set(item.value, item));
    setSelectedItems(newSelection);
  }, [defaultSelection]);
  const onToggleItem = (item) => {
    setItemSelectedState(item, !selectedItems.has(item.value));
  };
  const onDeselect = (item) => {
    return () => {
      setItemSelectedState(item, false);
      onDeselectCallback == null ? void 0 : onDeselectCallback(item);
    };
  };
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      className: mergeStyles(["combobox", className]),
      ref,
      children: /* @__PURE__ */ jsx(Popover, {
        showArrow: false,
        trigger: "external",
        autoPlacementOptions: {
          allowedPlacements: ["top", "bottom"]
        },
        overlayStyle: {
          width
        },
        open,
        onOpenChange: (open2) => setOpen(open2),
        containerClassName: "w-full",
        innerContentClassName: "",
        content: ComboBoxMenu2 ? /* @__PURE__ */ jsx(ComboBoxMenu2, {
          data,
          selectedItems,
          onToggleItem,
          renderListItem,
          bottomContent: bottomOptionsListContent
        }) : menuContent,
        children: /* @__PURE__ */ jsx(ComboBoxInput, {
          selectedItems: [...selectedItems.values()],
          size,
          placeholder: selectedItems.size === 0 ? placeholder : "",
          defaultValue: searchTerm,
          value: searchTerm,
          onSearch: (searchTerm2) => {
            setSearchTerm(searchTerm2);
            onSearch == null ? void 0 : onSearch(searchTerm2);
          },
          onDeselect,
          onFocus: (e) => {
            setOpen(true);
            onFocus == null ? void 0 : onFocus(e);
          },
          onBlur,
          autoFocus,
          containerSize
        })
      })
    }), errorProps && /* @__PURE__ */ jsx(FormHelperText, {
      ...errorProps,
      type: "error",
      size: errorProps.size ?? containerSize
    })]
  });
};
const itemStyles$1 = {
  base: "box-border leading-6 p-2 border border-1 border-solid cursor-pointer hover:bg-gray-50 hover:border-gray-100",
  unselected: "border-white bg-white focus:bg-white focus:border-gray-900",
  selected: "bg-jungle-50 border-jungle-50"
};
const iconStyles = {
  base: "h-4 inline leading-6",
  unselected: "fill-transparent",
  selected: "fill-gray-900"
};
const ComboBoxMenuItem = (props) => {
  const {
    item,
    isSelected,
    className,
    onSelect,
    renderItem = (item2) => /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(SvgCheckMark, {
        title: "checkIcon",
        className: mergeStyles([iconStyles.base, iconStyles[itemState]])
      }), item2.label]
    })
  } = props;
  const [itemState, setItemState] = useState(isSelected ? "selected" : "unselected");
  const ref = useRef(null);
  const itemValue = JSON.stringify(item);
  useEffect(() => {
    setItemState(isSelected ? "selected" : "unselected");
  }, [isSelected, itemValue]);
  return /* @__PURE__ */ jsx("div", {
    role: "menuitem",
    tabIndex: 0,
    ref,
    onClick: (e) => {
      onSelect(item);
      setItemState((curr) => curr === "selected" ? "unselected" : "selected");
      e.stopPropagation();
    },
    onKeyDown: (e) => {
      if (e.key === "Enter") {
        onSelect(item);
        setItemState((curr) => curr === "selected" ? "unselected" : "selected");
      }
      e.stopPropagation();
    },
    onMouseUp: () => {
      ref.current.blur();
    },
    onMouseLeave: () => {
      ref.current.blur();
    },
    className: mergeStyles([itemStyles$1.base, itemStyles$1[itemState], className]),
    children: /* @__PURE__ */ jsx("span", {
      className: "select-none",
      children: renderItem(item)
    })
  });
};
const ComboBoxMenu = (props) => {
  const {
    data,
    selectedItems,
    onToggleItem,
    renderListItem,
    bottomContent
  } = props;
  return /* @__PURE__ */ jsxs("div", {
    role: "menu",
    className: "popover-menu",
    children: [/* @__PURE__ */ jsx("div", {
      className: "popover-menu-content",
      children: data.map((item) => {
        return /* @__PURE__ */ jsx(ComboBoxMenuItem, {
          item,
          isSelected: selectedItems.has(item.value),
          onSelect: onToggleItem,
          renderItem: renderListItem
        }, item.value);
      })
    }), bottomContent && /* @__PURE__ */ jsx("div", {
      className: "popover-menu-bottom-content",
      children: bottomContent
    })]
  });
};
const ComboBox = ({
  open = false,
  ...props
}) => {
  return /* @__PURE__ */ jsx(ComboBoxCore, {
    ...props,
    open,
    menuElement: ComboBoxMenu
  });
};
const iconClass$1 = "size-4 shink-0 hidden group-hover:block";
const CopyToClipboardButton = (props) => {
  const {
    children,
    textToCopy,
    tooltipText = "Copy",
    copyIcon = SvgCopy
  } = props;
  const [isCopied, setIsCopied] = useState(false);
  const onClick = useCallback((e) => {
    e.preventDefault();
    navigator.clipboard.writeText(textToCopy);
    setIsCopied(true);
  }, [textToCopy]);
  useEffect(() => {
    if (isCopied) {
      setTimeout(() => setIsCopied(false), 5e3);
    }
  }, [isCopied]);
  return /* @__PURE__ */ jsxs("div", {
    className: "group flex items-center",
    children: [children, /* @__PURE__ */ jsx(Tooltip, {
      "data-testid": "tooltip",
      title: isCopied ? "Copied" : tooltipText,
      placement: "top",
      arrowPointAtCenter: true,
      className: "ml-1 w-2",
      overlayInnerStyle: {
        fontSize: "0.75rem",
        lineHeight: "1rem",
        minHeight: "1rem"
      },
      children: /* @__PURE__ */ jsx("span", {
        "data-testid": "icon-wrapper",
        onClick,
        children: isCopied ? SvgCircleCheck({
          className: iconClass$1,
          title: "CircleCheckIcon"
        }) : copyIcon({
          className: iconClass$1,
          title: "CopyIcon"
        })
      })
    })]
  });
};
const isTodaysDate = (date) => {
  return date.setHours(0, 0, 0, 0) == (/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0);
};
const areDatesEqual = (date1, date2) => {
  return date1 && date2 && date1.getTime() === date2.getTime();
};
const getLastDateOfMonth = (year, month) => {
  return 32 - new Date(year, month, 32).getDate();
};
const getLastDayOfMonth = (year, month) => {
  return new Date(year, month, getLastDateOfMonth(year, month)).getDay();
};
const getMonthName = (month, format = "long") => {
  return new Date(2023, month, 1).toLocaleString("default", { month: format });
};
const getPreviousMonth = (year, month) => {
  if (month === 0) {
    year--;
    month = 11;
  } else {
    month--;
  }
  return [year, month];
};
const getNextMonth = (year, month) => {
  if (month === 11) {
    year++;
    month = 0;
  } else {
    month++;
  }
  return [year, month];
};
const getLastDateOfPreviousMonth = (year, month) => {
  return getLastDateOfMonth(...getPreviousMonth(year, month));
};
const getIsLeapYear = (year) => {
  return year % 4 == 0 && year % 100 != 0 || year % 400 == 0;
};
const formatDate = (date) => {
  return (date == null ? void 0 : date.toLocaleDateString("en-us", { year: "numeric", month: "2-digit", day: "2-digit" })) ?? "";
};
const getDaysToAppend = (year, month) => {
  const lastDateOfMonth = getLastDateOfMonth(year, month);
  const lastDayOfMonth = new Date(year, month, lastDateOfMonth).getDay();
  if (month === 1) {
    return lastDayOfMonth === 6 && !getIsLeapYear(year) ? 20 : 13;
  }
  const offset2 = lastDateOfMonth == 31 ? 2 : 1;
  return lastDayOfMonth < offset2 ? 6 : 13;
};
const formatRange = (date1, date2) => {
  return date2 ? formatDate(date1) + " - " + formatDate(date2) : formatDate(date1);
};
const splitRange = (range) => {
  if (!range) return [void 0, void 0];
  const spl = range.split(" - ");
  const startDate = verifyValidDate(spl[0]) ? new Date(spl[0]) : void 0;
  const endDate = verifyValidDate(spl[1]) ? new Date(spl[1]) : void 0;
  return [startDate, endDate];
};
const isValidDateInput = (input) => {
  return /^(?:\d{1,2}\/){2}\d{2,4}$/.test(input) && verifyValidDate(input);
};
const verifyValidDate = (dateString) => {
  const dateObj = new Date(dateString);
  return !Number.isNaN(dateObj.getTime()) && // Compares the day in the input string with the day in the date object
  Number.parseInt(dateString.split("/")[1]) === dateObj.getDate();
};
const isValidDateRangeInputString = (input) => {
  return /^(?:\d{1,2}\/){2}\d{4} - (?:\d{1,2}\/){2}\d{4}$/.test(input) && // Verifies that neither date in the range is invalid
  input.split(" - ").filter((dateString) => !verifyValidDate(dateString)).length === 0;
};
const dayContainerClasses = {
  inSelection: "bg-jungle-50",
  notInSelection: ""
};
const dayClasses = {
  base: "text-center text-sm select-none h-8 leading-8 w-full",
  disabled: "bg-gray-100 cursor-not-allowed",
  selected: "bg-primary rounded-lg text-white font-bold",
  selectionStart: "bg-primary rounded-l-lg text-white font-bold",
  selectionEnd: "bg-primary rounded-r-lg text-white font-bold",
  inSelection: "bg-jungle-50 hover:bg-jungle-100",
  notInSelection: "hover:bg-gray-50 rounded-lg",
  currentMonth: "",
  currentDate: "border border-primary rounded-lg",
  otherMonth: "text-gray-600"
};
const GetDatePickerDayClasses = (date, isRangeSelection, isCurrentMonth, isSelectionStart, isSelectionEnd, isBetweenSelection, isDisabled = false) => {
  let classes2 = dayClasses.base + " ";
  if (isDisabled) {
    classes2 += dayClasses.disabled;
    return classes2;
  }
  if (isSelectionStart && (!isRangeSelection || isSelectionEnd)) {
    classes2 += dayClasses.selected;
  } else if (isSelectionStart) {
    classes2 += dayClasses.selectionStart;
  } else if (isSelectionEnd) {
    classes2 += dayClasses.selectionEnd;
  } else if (isCurrentMonth) {
    classes2 += dayClasses.currentMonth;
  } else {
    classes2 += dayClasses.otherMonth;
  }
  if (isTodaysDate(date) && !isSelectionStart && !isSelectionEnd) {
    classes2 += " " + dayClasses.currentDate;
  }
  if (isBetweenSelection) {
    classes2 += " " + dayClasses.inSelection;
  } else if (!isSelectionStart && !isSelectionEnd) {
    classes2 += " " + dayClasses.notInSelection;
  }
  return classes2;
};
const DatePickerDay = (props) => {
  const {
    date,
    selectionStart,
    selectionEnd,
    isRangeSelection,
    isCurrentMonth,
    toggleSelection,
    isDisabled
  } = props;
  const isSelectionStart = selectionStart && areDatesEqual(date, selectionStart);
  const isSelectionEnd = selectionEnd && areDatesEqual(date, selectionEnd);
  const isBetweenSelection = selectionStart && selectionEnd && date > selectionStart && date < selectionEnd;
  const classes2 = GetDatePickerDayClasses(date, isRangeSelection, isCurrentMonth, isSelectionStart, isSelectionEnd, isBetweenSelection, isDisabled);
  const containerClasses2 = isBetweenSelection ? dayContainerClasses.inSelection : dayContainerClasses.notInSelection;
  return /* @__PURE__ */ jsx("div", {
    className: containerClasses2,
    children: /* @__PURE__ */ jsx("button", {
      "aria-disabled": isDisabled,
      className: classes2,
      onClick: () => {
        if (!isDisabled) toggleSelection(date);
      },
      "aria-label": date.toLocaleDateString(),
      children: date.getDate()
    })
  });
};
const calendarClasses = {
  containerClasses: "p-4 bg-white w-fit rounded-lg shadow-dark",
  dayGridClasses: "grid grid-cols-7 w-56",
  monthTextClasses: "font-medium flex-1",
  headerClasses: "pt-0.5 pb-7",
  rowHeaderClasses: "text-center text-sm select-none h-8 leading-8",
  monthButtonClasses: "flex-none ml-6 hover:text-primary fill-current",
  monthButtonIconClasses: "size-6",
  monthGridClasses: "grid grid-cols-3 w-56",
  menuButtonClasses: "py-4 hover:text-primary",
  headerButtonClasses: "hover:text-primary"
};
var DatePickerActionType = /* @__PURE__ */ ((DatePickerActionType2) => {
  DatePickerActionType2["SELECT_DATE"] = "SELECT_DATE";
  DatePickerActionType2["NEXT_MONTH"] = "NEXT_MONTH";
  DatePickerActionType2["PREV_MONTH"] = "PREV_MONTH";
  DatePickerActionType2["SET_RANGE"] = "SET_RANGE";
  DatePickerActionType2["SET_MENU"] = "SET_MENU";
  DatePickerActionType2["SET_MONTH"] = "SET_MONTH";
  DatePickerActionType2["SET_YEAR"] = "SET_YEAR";
  DatePickerActionType2["PREV_YEAR"] = "PREV_YEAR";
  DatePickerActionType2["NEXT_YEAR"] = "NEXT_YEAR";
  return DatePickerActionType2;
})(DatePickerActionType || {});
var CalendarMenuType = /* @__PURE__ */ ((CalendarMenuType2) => {
  CalendarMenuType2["DATE_MENU"] = "DATE_MENU";
  CalendarMenuType2["MONTH_MENU"] = "MONTH_MENU";
  CalendarMenuType2["YEAR_MENU"] = "YEAR_MENU";
  return CalendarMenuType2;
})(CalendarMenuType || {});
const getNewSelection = (date, isRangeSelection, selectionStart, selectionEnd) => {
  const isCurrentDate = selectionStart && areDatesEqual(date, selectionStart);
  if (!isRangeSelection) {
    return [isCurrentDate ? void 0 : date, void 0];
  }
  if (selectionStart && selectionEnd) {
    return [date, void 0];
  } else if (isCurrentDate && selectionEnd === void 0) {
    selectionEnd = selectionStart;
  } else if (selectionStart === void 0) {
    selectionStart = date;
  } else {
    selectionEnd = date;
  }
  if (selectionEnd && selectionStart && selectionStart > selectionEnd) {
    return [selectionEnd, selectionStart];
  }
  return [selectionStart, selectionEnd];
};
const DateMenu = (props) => {
  var _a, _b, _c;
  const {
    state,
    dispatch,
    onChange
  } = props;
  const {
    year,
    month,
    selectionStart,
    selectionEnd,
    isRangeSelection
  } = state;
  const startDayOfMonth = new Date(year, month).getDay();
  const lastDateOfMonth = getLastDateOfMonth(year, month);
  const lastDayOfMonth = getLastDayOfMonth(year, month);
  const lastDateOfPrevMonth = getLastDateOfPreviousMonth(year, month);
  const dayArgs = {
    toggleSelection: (date) => {
      const selection = getNewSelection(date, isRangeSelection, selectionStart, selectionEnd);
      dispatch({
        type: DatePickerActionType.SELECT_DATE,
        payload: selection
      });
      onChange(selection);
    },
    selectionStart,
    selectionEnd,
    isRangeSelection
  };
  const days = [];
  const [prevMonthYear, prevMonth] = getPreviousMonth(year, month);
  for (let d = lastDateOfPrevMonth - startDayOfMonth + 1; d <= lastDateOfPrevMonth; ++d) {
    const date = new Date(prevMonthYear, prevMonth, d);
    const isDisabled = ((_a = props.isDisabledDate) == null ? void 0 : _a.call(props, date)) ?? false;
    days.push(/* @__PURE__ */ jsx(DatePickerDay, {
      ...dayArgs,
      date,
      isCurrentMonth: false,
      isDisabled
    }, date.toString()));
  }
  for (let d = 1; d <= lastDateOfMonth; ++d) {
    const date = new Date(year, month, d);
    const isDisabled = ((_b = props.isDisabledDate) == null ? void 0 : _b.call(props, date)) ?? false;
    days.push(/* @__PURE__ */ jsx(DatePickerDay, {
      ...dayArgs,
      date,
      isCurrentMonth: true,
      isDisabled
    }, date.toString()));
  }
  const [nextMonthYear, nextMonth] = getNextMonth(year, month);
  const daysToAppend = getDaysToAppend(year, month);
  for (let d = 1; d <= daysToAppend - lastDayOfMonth; ++d) {
    const date = new Date(nextMonthYear, nextMonth, d);
    const isDisabled = ((_c = props.isDisabledDate) == null ? void 0 : _c.call(props, date)) ?? false;
    days.push(/* @__PURE__ */ jsx(DatePickerDay, {
      ...dayArgs,
      date,
      isCurrentMonth: false,
      isDisabled
    }, date.toString()));
  }
  return /* @__PURE__ */ jsxs("div", {
    className: calendarClasses.containerClasses,
    children: [/* @__PURE__ */ jsx("div", {
      className: calendarClasses.headerClasses,
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex",
        children: [/* @__PURE__ */ jsxs("div", {
          className: calendarClasses.monthTextClasses,
          children: [/* @__PURE__ */ jsx("button", {
            title: "year menu",
            className: calendarClasses.headerButtonClasses,
            onClick: () => dispatch({
              type: DatePickerActionType.SET_MENU,
              menu: CalendarMenuType.YEAR_MENU
            }),
            children: year
          }), " ", /* @__PURE__ */ jsx("button", {
            title: "month menu",
            className: calendarClasses.headerButtonClasses,
            onClick: () => dispatch({
              type: DatePickerActionType.SET_MENU,
              menu: CalendarMenuType.MONTH_MENU
            }),
            children: getMonthName(month)
          })]
        }), /* @__PURE__ */ jsx("button", {
          title: "prev month",
          className: calendarClasses.monthButtonClasses,
          onClick: () => dispatch({
            type: DatePickerActionType.PREV_MONTH
          }),
          children: /* @__PURE__ */ jsx(SvgChevronLeft, {
            className: calendarClasses.monthButtonIconClasses
          })
        }), /* @__PURE__ */ jsx("button", {
          title: "next month",
          className: calendarClasses.monthButtonClasses,
          onClick: () => dispatch({
            type: DatePickerActionType.NEXT_MONTH
          }),
          children: /* @__PURE__ */ jsx(SvgChevronRight, {
            className: calendarClasses.monthButtonIconClasses
          })
        })]
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: calendarClasses.dayGridClasses,
      children: [/* @__PURE__ */ jsx("div", {
        className: calendarClasses.rowHeaderClasses,
        children: "Su"
      }), /* @__PURE__ */ jsx("div", {
        className: calendarClasses.rowHeaderClasses,
        children: "Mo"
      }), /* @__PURE__ */ jsx("div", {
        className: calendarClasses.rowHeaderClasses,
        children: "Tu"
      }), /* @__PURE__ */ jsx("div", {
        className: calendarClasses.rowHeaderClasses,
        children: "We"
      }), /* @__PURE__ */ jsx("div", {
        className: calendarClasses.rowHeaderClasses,
        children: "Th"
      }), /* @__PURE__ */ jsx("div", {
        className: calendarClasses.rowHeaderClasses,
        children: "Fr"
      }), /* @__PURE__ */ jsx("div", {
        className: calendarClasses.rowHeaderClasses,
        children: "Sa"
      }), days]
    })]
  });
};
const MonthMenu = (props) => {
  const {
    state,
    dispatch
  } = props;
  const months = [];
  for (let i = 0; i < 12; ++i) {
    months.push(/* @__PURE__ */ jsx("button", {
      className: calendarClasses.menuButtonClasses,
      onClick: () => dispatch({
        type: DatePickerActionType.SET_MONTH,
        month: i
      }),
      children: getMonthName(i, "short")
    }, i));
  }
  return /* @__PURE__ */ jsxs("div", {
    className: calendarClasses.containerClasses,
    children: [/* @__PURE__ */ jsx("div", {
      className: calendarClasses.headerClasses,
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex",
        children: [/* @__PURE__ */ jsx("div", {
          className: calendarClasses.monthTextClasses,
          children: /* @__PURE__ */ jsx("button", {
            title: "year menu",
            className: calendarClasses.headerButtonClasses,
            onClick: () => dispatch({
              type: DatePickerActionType.SET_MENU,
              menu: CalendarMenuType.YEAR_MENU
            }),
            children: state.year
          })
        }), /* @__PURE__ */ jsx("button", {
          title: "prev year",
          className: calendarClasses.monthButtonClasses,
          onClick: () => dispatch({
            type: DatePickerActionType.PREV_YEAR
          }),
          children: /* @__PURE__ */ jsx(SvgChevronLeft, {
            className: calendarClasses.monthButtonIconClasses
          })
        }), /* @__PURE__ */ jsx("button", {
          title: "next year",
          className: calendarClasses.monthButtonClasses,
          onClick: () => dispatch({
            type: DatePickerActionType.NEXT_YEAR
          }),
          children: /* @__PURE__ */ jsx(SvgChevronRight, {
            className: calendarClasses.monthButtonIconClasses
          })
        })]
      })
    }), /* @__PURE__ */ jsx("div", {
      className: calendarClasses.monthGridClasses,
      children: months
    })]
  });
};
const YearMenu = (props) => {
  const {
    state,
    dispatch
  } = props;
  const [decade, setDecade] = useState(Math.floor(state.year / 10) * 10);
  const years = [];
  const start = decade - 1;
  const end = decade + 10;
  for (let i = start; i <= end; ++i) {
    years.push(/* @__PURE__ */ jsx("button", {
      className: calendarClasses.menuButtonClasses,
      onClick: () => dispatch({
        type: DatePickerActionType.SET_YEAR,
        year: i
      }),
      children: i
    }, i));
  }
  return /* @__PURE__ */ jsxs("div", {
    className: calendarClasses.containerClasses,
    children: [/* @__PURE__ */ jsx("div", {
      className: calendarClasses.headerClasses,
      children: /* @__PURE__ */ jsxs("div", {
        className: "flex",
        children: [/* @__PURE__ */ jsxs("div", {
          className: calendarClasses.monthTextClasses,
          children: [state.year, " "]
        }), /* @__PURE__ */ jsx("button", {
          title: "prev decade",
          className: calendarClasses.monthButtonClasses,
          onClick: () => setDecade(decade - 10),
          children: /* @__PURE__ */ jsx(SvgChevronLeft, {
            className: calendarClasses.monthButtonIconClasses
          })
        }), /* @__PURE__ */ jsx("button", {
          title: "next decade",
          className: calendarClasses.monthButtonClasses,
          onClick: () => setDecade(decade + 10),
          children: /* @__PURE__ */ jsx(SvgChevronRight, {
            className: calendarClasses.monthButtonIconClasses
          })
        })]
      })
    }), /* @__PURE__ */ jsx("div", {
      className: calendarClasses.monthGridClasses,
      children: years
    })]
  });
};
const datePickerReducer = (state, action) => {
  switch (action.type) {
    case DatePickerActionType.SELECT_DATE: {
      return {
        ...state,
        selectionStart: action.payload[0],
        selectionEnd: action.payload[1]
      };
    }
    case DatePickerActionType.PREV_MONTH: {
      const [newYear, newMonth] = getPreviousMonth(state.year, state.month);
      return {
        ...state,
        year: newYear,
        month: newMonth
      };
    }
    case DatePickerActionType.NEXT_MONTH: {
      const [newYear, newMonth] = getNextMonth(state.year, state.month);
      return {
        ...state,
        year: newYear,
        month: newMonth
      };
    }
    case DatePickerActionType.PREV_YEAR: {
      return {
        ...state,
        year: state.year - 1
      };
    }
    case DatePickerActionType.NEXT_YEAR: {
      return {
        ...state,
        year: state.year + 1
      };
    }
    case DatePickerActionType.SET_MENU: {
      return {
        ...state,
        previousMenu: state.menu,
        menu: action.menu
      };
    }
    case DatePickerActionType.SET_MONTH: {
      return {
        ...state,
        menu: CalendarMenuType.DATE_MENU,
        previousMenu: state.menu,
        month: action.month
      };
    }
    case DatePickerActionType.SET_YEAR: {
      return {
        ...state,
        menu: state.previousMenu,
        year: action.year
      };
    }
  }
  return state;
};
const DatePickerCalendar = (props) => {
  const {
    defaultYear,
    defaultMonth,
    rangeSelection: isRangeSelection = false,
    selectionStart: defaultSelectionStart,
    selectionEnd: defaultSelectionEnd,
    onChange,
    isDisabledDate: isDisabledDate2
  } = props;
  const [state, dispatch] = useReducer(datePickerReducer, {
    year: defaultYear ?? (defaultSelectionStart ?? /* @__PURE__ */ new Date()).getFullYear(),
    month: defaultMonth ?? (defaultSelectionStart ?? /* @__PURE__ */ new Date()).getMonth(),
    selectionStart: defaultSelectionStart,
    selectionEnd: defaultSelectionEnd,
    isRangeSelection,
    menu: CalendarMenuType.DATE_MENU
  }, (state2) => state2);
  useEffect(() => {
    dispatch({
      type: DatePickerActionType.SELECT_DATE,
      payload: [defaultSelectionStart, defaultSelectionEnd]
    });
  }, [defaultSelectionStart, defaultSelectionEnd]);
  switch (state.menu) {
    case CalendarMenuType.MONTH_MENU: {
      return /* @__PURE__ */ jsx(MonthMenu, {
        state,
        dispatch
      });
    }
    case CalendarMenuType.YEAR_MENU: {
      return /* @__PURE__ */ jsx(YearMenu, {
        state,
        dispatch
      });
    }
    default: {
      return /* @__PURE__ */ jsx(DateMenu, {
        state,
        dispatch,
        onChange,
        isDisabledDate: isDisabledDate2
      });
    }
  }
};
const DatePicker = (props) => {
  const {
    onChange,
    selectedDate,
    onOpenChange,
    allowClear,
    errorProps,
    isDisabledDate: isDisabledDate2,
    ...rest
  } = props;
  const ref = useRef();
  const [menuOpen, setMenuOpen] = useState(false);
  const [formattedDate, setFormattedDate] = useState(formatDate(selectedDate));
  const size = rest.containerSize ?? "large";
  useEffect(() => setFormattedDate(formatDate(selectedDate)), [selectedDate]);
  const onChangeCallback = useCallback((selection2) => {
    var _a;
    const formattedDate2 = formatDate(selection2[0]);
    onChange(selection2[0]);
    setFormattedDate(formattedDate2);
    setMenuOpen(false);
    (_a = ref.current) == null ? void 0 : _a.blur();
  }, [onChange]);
  const validate = useCallback((input, isFinishedTyping) => {
    var _a;
    if (!isFinishedTyping) {
      setFormattedDate(input);
      (_a = ref.current) == null ? void 0 : _a.focus();
      return;
    }
    const date2 = new Date(input);
    if (!isValidDateInput(input) || (isDisabledDate2 == null ? void 0 : isDisabledDate2(date2))) {
      onChangeCallback([void 0]);
      return;
    }
    onChangeCallback([date2]);
  }, [isDisabledDate2, onChangeCallback]);
  const onInputChange = useCallback((e) => validate(e.target.value, false), [validate]);
  const setOpen = useCallback((isOpen) => {
    setMenuOpen(isOpen);
    if (isOpen !== menuOpen) onOpenChange == null ? void 0 : onOpenChange(isOpen);
    if (!isOpen) validate(formattedDate, true);
  }, [formattedDate, menuOpen, onOpenChange, validate]);
  const onKeyUp = useCallback((e) => {
    const isOpen = !menuOpen || e.key !== "Enter";
    setOpen(isOpen);
    if (e.key === "Enter") {
      validate(e.target.value, true);
    }
  }, [menuOpen, setOpen, validate]);
  const date = formattedDate && isValidDateInput(formattedDate) ? new Date(formattedDate) : void 0;
  const selection = Number.isNaN(date == null ? void 0 : date.getTime()) ? /* @__PURE__ */ new Date() : date;
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Popover, {
      open: menuOpen,
      trigger: "external",
      innerContentClassName: "",
      showArrow: false,
      onOpenChange: setOpen,
      autoPlacementOptions: {
        autoAlignment: true,
        allowedPlacements: ["bottom", "top"]
      },
      content: /* @__PURE__ */ jsx(DatePickerCalendar, {
        ...rest,
        isDisabledDate: isDisabledDate2,
        selectionStart: selection,
        onChange: onChangeCallback
      }),
      children: /* @__PURE__ */ jsx(Input$1, {
        ref: (thisInput) => ref.current = thisInput,
        type: "date",
        allowClear,
        onKeyUp,
        onFocus: () => setOpen(true),
        value: formattedDate,
        onChange: onInputChange,
        containerSize: rest.containerSize,
        placeholder: "mm/dd/yyyy"
      })
    }), errorProps && /* @__PURE__ */ jsx(FormHelperText, {
      ...errorProps,
      type: "error",
      size: errorProps.size ?? size
    })]
  });
};
const ICON_STYLE = "mr-1 fill-red-600";
const DEFAULT_STYLE = "flex flex-row";
const TEXT_COLOR = {
  error: "text-red-600",
  helper: "text-gray-600"
};
const FONT_SIZE = {
  medium: "text-sm",
  large: "text-base"
};
const PADDING = {
  medium: "py-1",
  large: "py-2"
};
const ICON_SIZE = {
  medium: "size-4 mt-0.5",
  large: "size-4.5 mt-0.75"
};
const FormHelperText = ({
  className,
  showIcon = true,
  size = "medium",
  display = "This field is required",
  visible = true,
  ...props
}) => {
  const {
    type
  } = props;
  const styling = mergeStyles([DEFAULT_STYLE, TEXT_COLOR[type], FONT_SIZE[size], PADDING[size], className]);
  return /* @__PURE__ */ jsx(Fragment, {
    children: visible && /* @__PURE__ */ jsxs("div", {
      className: styling,
      children: [type == "error" && showIcon && /* @__PURE__ */ jsx("div", {
        className: "flex flex-col",
        children: /* @__PURE__ */ jsx(SvgDiamondExclamation, {
          className: `${ICON_STYLE} ${ICON_SIZE[size]}`
        })
      }), /* @__PURE__ */ jsx("div", {
        className: `flex flex-col text-wrap text-left`,
        children: display
      })]
    })
  });
};
const style$5 = {
  datePicker: "flex flex-col gap-2 pl-11 pb-2"
};
const DateFilterAfter = ({
  dateError,
  filter,
  onChange
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: style$5.datePicker,
    children: [/* @__PURE__ */ jsx(DatePicker, {
      selectedDate: filter.startDate,
      onChange: (date) => {
        onChange({
          startDate: date
        });
      },
      containerSize: "large"
    }), (dateError == null ? void 0 : dateError.start) && /* @__PURE__ */ jsx(FormHelperText, {
      type: "error",
      size: "medium",
      display: dateError.start,
      visible: true,
      showIcon: true
    })]
  });
};
const style$4 = {
  datePicker: "flex flex-col gap-2 pl-11 pb-2"
};
const DateFilterBefore = ({
  dateError,
  filter,
  onChange
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: style$4.datePicker,
    children: [/* @__PURE__ */ jsx(DatePicker, {
      selectedDate: filter.endDate,
      onChange: (date) => {
        onChange({
          endDate: date
        });
      },
      containerSize: "large"
    }), (dateError == null ? void 0 : dateError.end) && /* @__PURE__ */ jsx(FormHelperText, {
      type: "error",
      size: "medium",
      display: dateError.end,
      visible: true,
      showIcon: true
    })]
  });
};
const isDisabledDate = (date, type, startDate, endDate) => {
  if (type === "start") {
    return endDate ? date > endDate : false;
  } else {
    return startDate ? date < startDate : false;
  }
};
const isCompleteFilter = (filter) => {
  switch (filter.option) {
    case "between": {
      return !!filter.startDate && !!filter.endDate;
    }
    case "after": {
      return !!filter.startDate;
    }
    case "before": {
      return !!filter.endDate;
    }
    case "within last": {
      return !!filter.period && !!filter.periodQuantity;
    }
    case void 0: {
      return false;
    }
    default: {
      console.error("Unknown filter option while checking if the filter is complete: " + filter.option);
      return false;
    }
  }
};
const CLEARED_FILTER = {
  option: void 0,
  startDate: void 0,
  endDate: void 0,
  period: "days",
  periodQuantity: void 0
};
const CLEARED_FILTER_STATE = {
  tempFilter: { ...CLEARED_FILTER },
  appliedFilter: { ...CLEARED_FILTER },
  errors: {},
  flushTemp: false
};
const dateFilterReducer = (filter, action) => {
  switch (action.action) {
    case "reset": {
      return { ...CLEARED_FILTER_STATE };
    }
    case "resetTempFilter": {
      return { ...filter, tempFilter: { ...CLEARED_FILTER } };
    }
    case "updateTemp": {
      return {
        ...filter,
        tempFilter: { ...filter.tempFilter, ...action.updatedFields },
        flushTemp: true,
        errors: {}
      };
    }
    case "updateErrors": {
      return {
        ...filter,
        errors: { ...filter.errors, ...action.updatedFields }
      };
    }
    case "applyFilter": {
      return {
        ...filter,
        appliedFilter: { ...filter.tempFilter },
        flushTemp: false
      };
    }
    case "setFilter": {
      return {
        ...filter,
        appliedFilter: { ...action.filter },
        tempFilter: { ...action.filter }
      };
    }
  }
};
const useDateFilterState = (onChange, onApply, value) => {
  const [filter, dispatch] = useReducer(dateFilterReducer, { ...CLEARED_FILTER_STATE });
  useEffect(() => {
    if (value && isCompleteFilter(value)) {
      dispatch({ action: "setFilter", filter: value });
    } else {
      dispatch({ action: "reset" });
    }
  }, [value]);
  const reset = useCallback(() => {
    dispatch({ action: "reset" });
    onChange == null ? void 0 : onChange({ ...CLEARED_FILTER });
    onApply == null ? void 0 : onApply({ ...CLEARED_FILTER });
  }, [onChange, onApply]);
  const resetTempFilter = () => {
    dispatch({ action: "resetTempFilter" });
  };
  const apply = useCallback(() => {
    dispatch({ action: "applyFilter" });
    onApply == null ? void 0 : onApply(filter.tempFilter);
    onChange == null ? void 0 : onChange(filter.tempFilter);
  }, [onApply, filter.tempFilter, onChange]);
  const updateTempFilter = (updatedFields) => {
    dispatch({ action: "updateTemp", updatedFields });
  };
  const updateErrors = (updatedFields) => {
    dispatch({ action: "updateErrors", updatedFields });
  };
  return { filter, reset, resetTempFilter, apply, updateTempFilter, updateErrors };
};
const style$3 = {
  dateRangePicker: "flex flex-col gap-2 pl-11 pb-2"
};
const DateFilterBetween = ({
  dateError,
  filter,
  onChange
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: style$3.dateRangePicker,
    children: [/* @__PURE__ */ jsx(DatePicker, {
      selectedDate: filter.startDate,
      onChange: (date) => {
        onChange({
          startDate: date,
          endDate: filter.endDate
        });
      },
      containerSize: "large",
      isDisabledDate: (date) => isDisabledDate(date, "start", filter.startDate, filter.endDate)
    }), (dateError == null ? void 0 : dateError.start) && /* @__PURE__ */ jsx(FormHelperText, {
      type: "error",
      size: "medium",
      display: dateError.start,
      visible: true,
      showIcon: true
    }), "and", /* @__PURE__ */ jsx(DatePicker, {
      selectedDate: filter.endDate,
      onChange: (date) => onChange({
        startDate: filter.startDate,
        endDate: date
      }),
      containerSize: "large",
      isDisabledDate: (date) => isDisabledDate(date, "end", filter.startDate, filter.endDate)
    }), (dateError == null ? void 0 : dateError.end) && /* @__PURE__ */ jsx(FormHelperText, {
      type: "error",
      size: "medium",
      display: dateError.end,
      visible: true,
      showIcon: true
    })]
  });
};
const iconButtonStyle = "absolute top-0 right-0 h-full w-10.5 flex justify-center items-center";
const leftIconClasses = "h-5 fill-gray-600";
const InputContext = createContext(void 0);
const useInputContext = () => {
  const context = useContext(InputContext);
  if (context === void 0) {
    throw new Error("InputContext must be within InputContext.Provider");
  }
  return context;
};
const hasPrefix = (type) => {
  return type === "search" || type === "date";
};
const hasSuffix = (type) => {
  return type === "search" || type === "date";
};
const triggerOnChange = (element, value) => {
  var _a;
  const input = (_a = element.closest(".input-wrapper")) == null ? void 0 : _a.querySelector("input");
  if (input) {
    setInputValue(input, value);
  }
};
const getOnChangeHandler = (setValue, onChange) => {
  return (e) => {
    setValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  };
};
const getInputClasses = (type, error, className, containerSize) => {
  return addStyles(["rounded-lg w-full focus:border-1 focus:border-midnight-900 focus:ring-midnight-900 my-px", containerSize === "medium" ? "h-8" : "h-10.5", error ? "border-red-600" : "border-gray-600", hasPrefix(type) ? "pl-9" : "", hasSuffix(type) ? "pr-7.5 truncate" : "", className]);
};
const getShowXButton = (value, type, allowClear = true) => {
  return allowClear && (type === "search" || type === "date") && value.toString().length > 0;
};
const getInputType = (type, hidden) => {
  if (type === "date") return "text";
  if (type !== "password") return type || "text";
  return hidden ? type : "text";
};
const Label = (props) => {
  const {
    label,
    name
  } = props;
  return /* @__PURE__ */ jsx(Fragment, {
    children: label && /* @__PURE__ */ jsx("label", {
      htmlFor: name,
      className: "pb-2 font-medium text-gray-900",
      children: label
    })
  });
};
const InputLeftIcon = () => {
  const {
    type
  } = useInputContext();
  let icon;
  if (type === "search") icon = /* @__PURE__ */ jsx(SvgMagnifyingGlass, {
    className: leftIconClasses
  });
  else if (type === "date") icon = /* @__PURE__ */ jsx(SvgCalendar, {
    className: leftIconClasses
  });
  return /* @__PURE__ */ jsx(Fragment, {
    children: icon !== void 0 && /* @__PURE__ */ jsx("div", {
      className: "absolute left-0 top-0 flex h-full w-10.5 items-center justify-center",
      children: /* @__PURE__ */ jsx("span", {
        children: icon
      })
    })
  });
};
const XButton = () => {
  const {
    type,
    value,
    setValue,
    allowClear,
    containerSize
  } = useInputContext();
  const showXButton = getShowXButton(value, type, allowClear);
  const handleXClick = (event) => {
    setValue("");
    triggerOnChange(event.currentTarget, "");
  };
  return /* @__PURE__ */ jsx(Fragment, {
    children: showXButton && /* @__PURE__ */ jsx("div", {
      className: iconButtonStyle,
      children: /* @__PURE__ */ jsx(Button$1, {
        icon: SvgXmark,
        title: "Clear selection",
        onClick: (e) => {
          e.stopPropagation();
          handleXClick(e);
        },
        type: "text",
        size: containerSize === "large" ? "medium" : "small"
      })
    })
  });
};
const PasswordEyeWrapper = (props) => {
  const {
    type,
    hidden,
    setHidden
  } = useInputContext();
  const handleToggleVisible = useCallback((event) => {
    event.preventDefault();
    setHidden(!hidden);
  }, [setHidden, hidden]);
  return /* @__PURE__ */ jsx(Fragment, {
    children: type === "password" && /* @__PURE__ */ jsx("div", {
      className: iconButtonStyle,
      children: /* @__PURE__ */ jsx("span", {
        "data-testid": "password-eye",
        onClick: handleToggleVisible,
        className: "cursor-pointer select-none",
        tabIndex: 0,
        children: props.children
      })
    })
  });
};
const PasswordEye = () => {
  const {
    hidden
  } = useInputContext();
  return /* @__PURE__ */ jsx(PasswordEyeWrapper, {
    children: hidden ? /* @__PURE__ */ jsx(SvgEyeInvisible, {
      className: "h-6"
    }) : /* @__PURE__ */ jsx(SvgEye, {
      className: "h-6"
    })
  });
};
const HelperText = () => {
  const {
    helperProps,
    containerSize
  } = useInputContext();
  const size = (helperProps == null ? void 0 : helperProps.size) ?? containerSize ?? "large";
  return /* @__PURE__ */ jsx(Fragment, {
    children: helperProps && /* @__PURE__ */ jsx(FormHelperText, {
      ...helperProps,
      type: "helper",
      size
    })
  });
};
const ErrorText = () => {
  const {
    error,
    errorProps,
    containerSize
  } = useInputContext();
  const props = errorProps || {
    display: error
  };
  const size = (errorProps == null ? void 0 : errorProps.size) ?? containerSize ?? "large";
  return /* @__PURE__ */ jsx(Fragment, {
    children: error || errorProps ? /* @__PURE__ */ jsx(FormHelperText, {
      ...props,
      type: "error",
      size
    }) : void 0
  });
};
const InputWrapper = (props) => {
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "input-wrapper browser-style-none relative",
      children: [/* @__PURE__ */ jsx(InputLeftIcon, {}), props.children, /* @__PURE__ */ jsx(PasswordEye, {}), /* @__PURE__ */ jsx(XButton, {})]
    }), /* @__PURE__ */ jsx(HelperText, {}), /* @__PURE__ */ jsx(ErrorText, {})]
  });
};
const InputContent = forwardRef(function InputContent2(props, ref) {
  const numberScrollRef = useRef(null);
  const {
    onValueChange,
    setValue,
    setHidden,
    allowClear,
    onFocus,
    onKeyUp,
    onWheel,
    className,
    hidden,
    value,
    name,
    label,
    type,
    error,
    errorProps,
    containerSize,
    numberScroll,
    ...rest
  } = useInputContext();
  const inputType = useMemo(() => getInputType(type, hidden), [type, hidden]);
  const inputClasses = useMemo(() => getInputClasses(type, (errorProps == null ? void 0 : errorProps.visible) ?? error, className, containerSize), [type, containerSize, error, errorProps, className]);
  useEffect(() => {
    const element = numberScrollRef.current;
    if (!element) return;
    const disableNumberScrollCallback = (event) => {
      const typeIsNumber = type === "number";
      const inputIsActiveEl = document.activeElement === element;
      const scrollIsDisabled = numberScroll === false;
      if (typeIsNumber && inputIsActiveEl && scrollIsDisabled) event.preventDefault();
    };
    element.addEventListener("wheel", disableNumberScrollCallback, {
      passive: false
    });
    return () => element.removeEventListener("wheel", disableNumberScrollCallback);
  }, [type, numberScroll, numberScrollRef]);
  const setRefs = (element) => {
    if (typeof ref === "function") {
      ref(element);
    } else if (ref) {
      ref.current = element;
    }
    numberScrollRef.current = element;
  };
  return /* @__PURE__ */ jsx(InputWrapper, {
    children: /* @__PURE__ */ jsx("input", {
      "data-testid": "input-field",
      "aria-label": label,
      ...rest,
      ref: setRefs,
      onChange: onValueChange,
      onFocus,
      onKeyUp,
      name,
      type: inputType,
      value,
      className: inputClasses
    })
  });
});
const Input$1 = forwardRef(function Input2(props, ref) {
  const {
    onChange,
    type,
    value: initialValue = "",
    allowClear = true,
    containerSize = "large",
    numberScroll = false,
    ...rest
  } = props;
  const [hidden, setHidden] = useState(type === "password");
  const [value, setValue] = useState(initialValue.toString());
  const onValueChange = useCallback((e) => getOnChangeHandler(setValue, onChange)(e), [setValue, onChange]);
  useEffect(() => {
    setValue(initialValue.toString());
  }, [initialValue]);
  const inputContextValue = useMemo(() => ({
    ...rest,
    type,
    setHidden,
    onChange,
    hidden,
    value,
    setValue,
    onValueChange,
    allowClear,
    containerSize,
    numberScroll
  }), [rest, type, setHidden, onChange, hidden, value, setValue, onValueChange, allowClear, containerSize, numberScroll]);
  return /* @__PURE__ */ jsx(InputContext.Provider, {
    value: inputContextValue,
    children: /* @__PURE__ */ jsxs("div", {
      children: [/* @__PURE__ */ jsx(Label, {
        ...props
      }), /* @__PURE__ */ jsx(InputContent, {
        ref
      })]
    })
  });
});
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options2) {
  return Object.keys(options2).sort().filter((key) => options2[key] !== void 0).map((key) => {
    return `${key}_${key === "root" ? getRootId(options2.root) : options2[key]}`;
  }).toString();
}
function createObserver(options2) {
  const id = optionsToId(options2);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options2.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options2);
    thresholds = observer.thresholds || (Array.isArray(options2.threshold) ? options2.threshold : [options2.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options2 = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options2.threshold === "number" ? options2.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const {
    id,
    observer,
    elements
  } = createObserver(options2);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}
function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef2] = React.useState(null);
  const callback = React.useRef();
  const [state, setState] = React.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  React.useEffect(
    () => {
      if (skip || !ref) return;
      let unobserve;
      unobserve = observe(ref, (inView, entry) => {
        setState({
          inView,
          entry
        });
        if (callback.current) callback.current(inView, entry);
        if (entry.isIntersecting && triggerOnce && unobserve) {
          unobserve();
          unobserve = void 0;
        }
      }, {
        root,
        rootMargin,
        threshold,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      }, fallbackInView);
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = React.useRef();
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef2, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
    if (!getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
  }
  return getRandomValues(rnds8);
}
const byteToHex = [];
for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).slice(1));
}
function unsafeStringify(arr, offset2 = 0) {
  return byteToHex[arr[offset2 + 0]] + byteToHex[arr[offset2 + 1]] + byteToHex[arr[offset2 + 2]] + byteToHex[arr[offset2 + 3]] + "-" + byteToHex[arr[offset2 + 4]] + byteToHex[arr[offset2 + 5]] + "-" + byteToHex[arr[offset2 + 6]] + byteToHex[arr[offset2 + 7]] + "-" + byteToHex[arr[offset2 + 8]] + byteToHex[arr[offset2 + 9]] + "-" + byteToHex[arr[offset2 + 10]] + byteToHex[arr[offset2 + 11]] + byteToHex[arr[offset2 + 12]] + byteToHex[arr[offset2 + 13]] + byteToHex[arr[offset2 + 14]] + byteToHex[arr[offset2 + 15]];
}
const randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const native = {
  randomUUID
};
function v4(options2, buf, offset2) {
  if (native.randomUUID && true && !options2) {
    return native.randomUUID();
  }
  options2 = options2 || {};
  const rnds = options2.random || (options2.rng || rng)();
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  return unsafeStringify(rnds);
}
const styles$2 = {
  inputRight: {
    base: "absolute top-0.5 right-0 flex items-center justify-center",
    size: {
      medium: "size-[calc(2rem-2px)]",
      large: "size-[calc(2.75rem-2px)]"
    },
    clear: {
      medium: "mr-[calc(2rem-2px)]",
      large: "mr-[calc(2.75rem-2px)]"
    },
    dropdown: "mr-px",
    hoverBg: "hover:bg-gray-100 rounded-lg",
    iconBase: "size-5 self-center",
    search: "mr-1",
    searchIcon: "size-7.5 p-2"
  },
  menuItem: {
    selectable: "cursor-pointer truncate",
    notSelectable: "cursor-not-allowed p-2 text-gray-600 text-sm"
  },
  checkMarkIcon: {
    base: "h-4 inline w-4.5 mr-2",
    unselected: "fill-transparent",
    selected: "fill-gray-900"
  }
};
const MenuOpenIcon = (props) => /* @__PURE__ */ jsx("div", {
  className: addStyles([styles$2.inputRight.base, styles$2.inputRight.size[props.size], styles$2.inputRight.dropdown, styles$2.inputRight.hoverBg]),
  onClick: () => {
    var _a;
    return (_a = props.inputRef.current) == null ? void 0 : _a.focus();
  },
  id: `Toggle-${props.inputId}`,
  "data-testid": `Toggle-${props.inputId}`,
  children: /* @__PURE__ */ jsx(SvgChevronDown, {
    className: styles$2.inputRight.iconBase
  })
});
const SearchIcon = (props) => /* @__PURE__ */ jsx("div", {
  className: addStyles([styles$2.inputRight.base, styles$2.inputRight.size[props.size], styles$2.inputRight.search]),
  id: `Search-${props.inputId}`,
  children: /* @__PURE__ */ jsx(SvgMagnifyingGlass, {
    className: styles$2.inputRight.searchIcon
  })
});
const ClearSelectionIcon = (props) => {
  const {
    allowClear,
    inputHasSelection,
    inputId,
    onClearSelection,
    size
  } = props;
  return allowClear && inputHasSelection ? /* @__PURE__ */ jsx("div", {
    className: addStyles([styles$2.inputRight.base, styles$2.inputRight.size[size], styles$2.inputRight.clear[size], styles$2.inputRight.hoverBg]),
    id: `Clear-${inputId}`,
    onClick: (e) => onClearSelection == null ? void 0 : onClearSelection(e),
    children: /* @__PURE__ */ jsx(SvgXmark, {
      className: styles$2.inputRight.iconBase
    })
  }) : /* @__PURE__ */ jsx(Fragment, {});
};
const InputRightIcon = (props) => props.menuOpen ? SearchIcon(props) : MenuOpenIcon(props);
const defaultMenuItemRenderer = (item, isSelected) => {
  return /* @__PURE__ */ jsxs("div", {
    className: styles$2.menuItem.selectable,
    children: [/* @__PURE__ */ jsx(SvgCheckMark, {
      className: addStyles([styles$2.checkMarkIcon.base, isSelected ? styles$2.checkMarkIcon.selected : styles$2.checkMarkIcon.unselected])
    }), /* @__PURE__ */ jsx("span", {
      children: item.label || item.value
    })]
  });
};
const defaultNoMatchMenuItemRenderer = () => {
  return /* @__PURE__ */ jsx("div", {
    className: styles$2.menuItem.notSelectable,
    role: "note",
    children: /* @__PURE__ */ jsx("span", {
      children: "No results found"
    })
  });
};
const styles$1 = {
  base: "rounded-lg focus:border-1 focus:border-midnight-900 focus:ring-midnight-900 my-px placeholder-gray-600 truncate border-gray-600",
  sizes: {
    medium: "h-8 pr-[calc(4.25rem-4px)] text-sm",
    large: "h-11 pr-[calc(5.75rem-4px)] text-base"
  }
};
const SelectInput = forwardRef((props, ref) => {
  const {
    allowClear,
    inputId,
    value,
    contentWidth,
    onClearSelection,
    onSearch,
    containerSize,
    ...rest
  } = props;
  const key = `Input-${inputId}`;
  return /* @__PURE__ */ jsx("input", {
    ref,
    role: "searchbox",
    className: `${styles$1.base} ${styles$1.sizes[containerSize]}`,
    type: "text",
    title: (value == null ? void 0 : value.toString()) ?? "",
    "data-testid": key,
    value: value ?? "",
    onChange: (e) => {
      if (e.target.value.length > 0 || !allowClear) onSearch(e.target.value);
      else onClearSelection == null ? void 0 : onClearSelection(e);
    },
    style: {
      width: contentWidth
    },
    ...rest
  }, key);
});
SelectInput.displayName = "SelectInput";
const classes$3 = {
  wrapper: "inline-block relative",
  popover: {
    root: "origin-top-right absolute z-150 rounded-md",
    base: "flex-col max-h-60 overflow-y-auto rounded-md border-t border-t-gray-300 shadow-dark"
  }
};
const SelectCoreWithoutRef = (props, ref) => {
  var _a;
  const {
    allowClear = true,
    children,
    id,
    onBlur,
    onClearSelection,
    onDropdownVisibleChange,
    onFocus: onFocusCallback,
    onMenuOpen,
    onSearch,
    open,
    popoverClassesBase,
    searchTerm,
    selectedItem,
    width,
    containerSize = "medium",
    placeholder
  } = props;
  const effectiveWidth = (width == null ? void 0 : width.trim()) ? width : "100%";
  const inputRef = useRef(null);
  const onFocus = (e) => {
    onMenuOpen(true);
    onDropdownVisibleChange == null ? void 0 : onDropdownVisibleChange(true);
    onFocusCallback == null ? void 0 : onFocusCallback(e);
  };
  const onMenuOpenChange = (open2) => {
    onMenuOpen(open2);
    onSearch("");
    onBlur == null ? void 0 : onBlur();
  };
  useEffect(() => onDropdownVisibleChange == null ? void 0 : onDropdownVisibleChange(open === true), [onDropdownVisibleChange, open]);
  const popoverWidth = useMemo(
    () => {
      var _a2;
      return effectiveWidth && !effectiveWidth.includes("%") ? effectiveWidth : `${(_a2 = inputRef.current) == null ? void 0 : _a2.clientWidth}px`;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [effectiveWidth, (_a = inputRef.current) == null ? void 0 : _a.clientWidth]
  );
  return /* @__PURE__ */ jsx("div", {
    ref,
    className: classes$3.wrapper,
    style: {
      width: effectiveWidth
    },
    children: /* @__PURE__ */ jsxs(Popover, {
      autoPlacementOptions: {
        allowedPlacements: ["top", "bottom"]
      },
      content: children,
      containerClassName: "w-full",
      innerContentClassName: popoverClassesBase ?? classes$3.popover.base,
      offsetOptions: {
        mainAxis: 0
      },
      onOpenChange: onMenuOpenChange,
      open,
      overlayClassName: classes$3.popover.root,
      overlayStyle: {
        width: popoverWidth
      },
      showArrow: false,
      trigger: "external",
      children: [/* @__PURE__ */ jsx(SelectInput, {
        allowClear,
        inputId: id,
        placeholder,
        value: searchTerm === "" ? selectedItem == null ? void 0 : selectedItem.label : searchTerm,
        contentWidth: effectiveWidth,
        onClearSelection,
        onFocus,
        onSearch,
        ref: inputRef,
        containerSize
      }, `SelectionInput-${id}`), /* @__PURE__ */ jsx(ClearSelectionIcon, {
        inputId: id,
        allowClear,
        inputHasSelection: !!selectedItem || searchTerm !== "",
        onClearSelection,
        size: containerSize
      }), /* @__PURE__ */ jsx(InputRightIcon, {
        inputId: id,
        inputRef,
        menuOpen: open,
        size: containerSize
      })]
    }, `Pop-${id}`)
  });
};
const SelectCore = forwardRef(SelectCoreWithoutRef);
const getMenuItemRenderer = (suppliedFn) => suppliedFn ?? defaultMenuItemRenderer;
const getNoMatchItemRenderer = (suppliedFn) => suppliedFn ?? defaultNoMatchMenuItemRenderer;
const menuItemsSorter = (a, b) => a.label.localeCompare(b.label);
function hasValue(value) {
  return value !== void 0;
}
const useSelectionWithSearch = (props) => {
  const { data, value, defaultValue, defaultSearchTerm, onChange, onSearchCallback, setMenuOpen, onClear } = props;
  const [searchTerm, setSearchTerm] = useState(defaultSearchTerm ?? "");
  const [innerValue, setInnerValue] = useState(() => {
    if (hasValue(value)) {
      return value;
    } else if (hasValue(defaultValue)) {
      return defaultValue;
    }
  });
  const mergedValue = value === void 0 ? innerValue : value;
  const selectedItem = useMemo(() => {
    return data.find((item) => item.value === mergedValue);
  }, [data, mergedValue]);
  const onSearch = useCallback(
    (searchString) => {
      setSearchTerm(searchString);
      onSearchCallback(searchString);
    },
    [onSearchCallback]
  );
  const onToggleItem = useCallback(
    (toggledItem, isSelected) => {
      const newSelection = isSelected ? toggledItem : void 0;
      setInnerValue(newSelection == null ? void 0 : newSelection.value);
      onChange(newSelection, data);
      if (isSelected) {
        setMenuOpen(false);
        onSearch("");
      }
    },
    [onChange, data, setMenuOpen, onSearch]
  );
  const onClearSelection = useCallback(
    (e) => {
      if (selectedItem) {
        onToggleItem(selectedItem, false);
      }
      onSearch("");
      e == null ? void 0 : e.stopPropagation();
      onClear == null ? void 0 : onClear(e);
    },
    [selectedItem, onSearch, onToggleItem, onClear]
  );
  return { searchTerm, selectedItem, onToggleItem, onClearSelection, onSearch };
};
const SelectWithoutRef = (props, ref) => {
  const {
    data,
    onChange,
    open,
    onSearch: onSearchCallback,
    renderListItem,
    renderNoMatchesItem,
    defaultValue,
    value,
    defaultSearchTerm,
    errorProps,
    onScrollToBottom,
    onClearSelection: onClear,
    customSortFn,
    autoSort = true,
    ...rest
  } = props;
  const size = rest.containerSize ?? "medium";
  const {
    current: id
  } = useRef(v4());
  const [menuOpen, setMenuOpen] = useState(open);
  const {
    ref: inViewRef,
    inView
  } = useInView();
  useEffect(() => {
    if (inView) {
      onScrollToBottom == null ? void 0 : onScrollToBottom();
    }
  }, [onScrollToBottom, inView]);
  const {
    searchTerm,
    selectedItem,
    onToggleItem,
    onClearSelection,
    onSearch
  } = useSelectionWithSearch({
    data,
    value,
    defaultValue,
    defaultSearchTerm,
    onChange,
    onSearchCallback,
    setMenuOpen,
    onClear
  });
  const menuItemRenderer = getMenuItemRenderer(renderListItem);
  const noMatchMenuItemRenderer = getNoMatchItemRenderer(renderNoMatchesItem);
  const menuItems = useMemo(() => {
    let matchedItems = data.filter((item) => !searchTerm || matchesSearch$1(item, searchTerm));
    if (autoSort) {
      matchedItems = matchedItems.sort(customSortFn ?? menuItemsSorter);
    }
    return matchedItems.length > 0 ? matchedItems.map((item) => {
      return /* @__PURE__ */ jsx(FilterComboBoxMenuItem, {
        item,
        defaultSelection: (selectedItem == null ? void 0 : selectedItem.value) === item.value,
        onSelect: onToggleItem,
        className: size === "medium" ? "text-sm" : "px-5 py-2.5 text-base",
        renderItem: menuItemRenderer
      }, item.value);
    }) : noMatchMenuItemRenderer();
  }, [data, noMatchMenuItemRenderer, searchTerm, selectedItem == null ? void 0 : selectedItem.value, onToggleItem, size, menuItemRenderer, customSortFn, autoSort]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(SelectCore, {
      ref,
      id: `SelectI-${id}`,
      open: menuOpen,
      onMenuOpen: setMenuOpen,
      searchTerm,
      onSearch,
      ...rest,
      selectedItem,
      onClearSelection,
      value,
      children: /* @__PURE__ */ jsxs("div", {
        role: "menu",
        children: [menuItems, /* @__PURE__ */ jsx("div", {
          ref: inViewRef
        })]
      })
    }), errorProps && /* @__PURE__ */ jsx(FormHelperText, {
      ...errorProps,
      type: "error",
      size: errorProps.size ?? size
    })]
  });
};
const Select = forwardRef(SelectWithoutRef);
const getHelperText = (period, periodQuantity) => {
  if (!period || !periodQuantity) {
    return "";
  }
  const today = dayjs().format("MMM D, YYYY");
  const end = dayjs().subtract(periodQuantity, period).format("MMM D, YYYY");
  return `From ${end} to ${today}`;
};
const DateFilterWithin = ({
  dateError,
  filter,
  onChange
}) => {
  const selectOptions = [{
    value: "days",
    label: "days"
  }, {
    value: "weeks",
    label: "weeks"
  }, {
    value: "months",
    label: "months"
  }, {
    value: "years",
    label: "years"
  }];
  const onInputChange = (e) => {
    const value = e.target.value;
    if (value.length === 0) {
      onChange({
        periodQuantity: void 0
      });
      return;
    }
    onChange({
      periodQuantity: Number.parseInt(value)
    });
  };
  const helperText = getHelperText(filter.period, filter.periodQuantity);
  return /* @__PURE__ */ jsxs("div", {
    className: "pb-2 pl-10.5",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-row",
      children: [/* @__PURE__ */ jsx("span", {
        className: "pr-4",
        children: /* @__PURE__ */ jsx(Input$1, {
          type: "number",
          containerSize: "large",
          onChange: onInputChange,
          value: filter.periodQuantity,
          className: (dateError == null ? void 0 : dateError.period) === void 0 ? "w-24" : "w-24 border-red-600"
        })
      }), /* @__PURE__ */ jsx("span", {
        className: "w-43",
        children: /* @__PURE__ */ jsx(Select, {
          allowClear: false,
          data: selectOptions,
          onChange: (e) => {
            onChange({
              period: e == null ? void 0 : e.value
            });
          },
          onSearch: () => {
          },
          autoSort: false,
          value: filter.period,
          containerSize: "large",
          width: "172px"
        })
      })]
    }), /* @__PURE__ */ jsx(FormHelperText, {
      type: "helper",
      display: helperText,
      visible: helperText.length > 0
    }), /* @__PURE__ */ jsx(FormHelperText, {
      type: "error",
      display: dateError == null ? void 0 : dateError.period,
      visible: (dateError == null ? void 0 : dateError.period) !== void 0
    })]
  });
};
const AVALIABLE_FILTERS = [{
  value: "after",
  component: DateFilterAfter
}, {
  value: "before",
  component: DateFilterBefore
}, {
  value: "between",
  component: DateFilterBetween
}, {
  value: "within last",
  component: DateFilterWithin
}];
const defaultStyles = "cursor-pointer border-1 border-gray-600 hover:border-primary mt-0.5 size-5 bg-none outline-midnight-900";
const hoverStyles = "hover:border-primary";
const disabledStyles = "disabled:checked:shadow-[0px_0px_0px_4px_inset] disabled:border-gray-500 disabled:bg-gray-100 disabled:checked:bg-gray-500 disabled:checked:shadow-white disabled:cursor-not-allowed";
const checkedStyles = "checked:shadow-white checked:shadow-[0px_0px_0px_4px_inset] checked:bg-primary checked:border-primary ";
const getTextSizeClasses = (size) => {
  return size === "medium" ? "text-sm leading-6" : "text-base";
};
const RadioButton = forwardRef(({
  hideLabel = false,
  isDisabled = false,
  ...props
}, ref) => {
  const {
    label,
    name,
    value,
    onChange,
    ariaLabel = label,
    id,
    helperText,
    checked,
    children,
    size = "large"
  } = props;
  return /* @__PURE__ */ jsx("div", {
    className: "flex flex-col",
    children: /* @__PURE__ */ jsx("div", {
      className: "flex items-center ",
      children: /* @__PURE__ */ jsxs("label", {
        className: addStyles(["flex justify-center gap-2.5", isDisabled ? "cursor-not-allowed" : "cursor-pointer"]),
        htmlFor: id,
        children: [/* @__PURE__ */ jsx("input", {
          className: addStyles([defaultStyles, hoverStyles, checkedStyles, disabledStyles]),
          type: "radio",
          onChange,
          value,
          name,
          "aria-label": ariaLabel,
          disabled: isDisabled,
          id,
          checked,
          ref
        }), /* @__PURE__ */ jsxs("div", {
          className: addStyles(["ml-2", isDisabled ? "text-gray-600" : "text-gray-900", getTextSizeClasses(size)]),
          children: [!hideLabel && /* @__PURE__ */ jsx("span", {
            children: label
          }), helperText && /* @__PURE__ */ jsx("p", {
            className: "text-xs text-gray-800",
            children: helperText
          }), children]
        })]
      })
    })
  });
});
RadioButton.displayName = "RadioButton";
const DateFilterMenuContent = ({
  dateError,
  dateFilter,
  onChange,
  onOptionChange
}) => {
  return /* @__PURE__ */ jsx("div", {
    className: "w-88 py-1 pl-2 pr-4.5",
    children: /* @__PURE__ */ jsx("div", {
      children: AVALIABLE_FILTERS.map((filter) => {
        const checked = dateFilter.option === filter.value;
        return /* @__PURE__ */ jsxs("div", {
          children: [/* @__PURE__ */ jsx("div", {
            className: "p-2.5",
            children: /* @__PURE__ */ jsx(RadioButton, {
              checked,
              onChange: () => {
                onOptionChange(filter.value);
              },
              name: filter.value,
              value: filter.value,
              label: filter.value
            })
          }, filter.value), checked && /* @__PURE__ */ jsx(filter.component, {
            onChange,
            dateError,
            filter: dateFilter
          })]
        }, `filter-${filter.value}`);
      })
    })
  });
};
const options$9 = {
  container: {
    base: "flex flex-nowrap items-center box-border rounded-lg border-solid h-min cursor-pointer pl-3",
    unselected: "border-gray-600 bg-white text-gray-900 border",
    selected: "border-midnight-900 bg-white border-2"
  },
  text: {
    base: "text-sm select-none font-medium truncate pr-1",
    selected: "",
    unselected: ""
  },
  selectionText: {
    base: "text-sm select-none truncate pr-1",
    selected: "",
    unselected: ""
  },
  icon: {
    base: "h-6 w-6",
    selected: "",
    unselected: ""
  }
};
const getStyleKey = (isSelected) => {
  return isSelected ? "selected" : "unselected";
};
const FilterChip = (props) => {
  const {
    value,
    numberSelected,
    firstSelection = "",
    isOpen: defaultIsOpen,
    onClearSelection,
    width = "352px",
    menuContent,
    icon,
    onOpen
  } = props;
  const [menuOpen, setMenuOpen] = useState(defaultIsOpen);
  const openMenu = () => {
    if (!menuOpen) {
      setMenuOpen(true);
      onOpen == null ? void 0 : onOpen();
    }
  };
  const isSelected = numberSelected > 0;
  useEffect(() => {
    if (defaultIsOpen) {
      openMenu();
    } else {
      setMenuOpen(false);
    }
  }, [defaultIsOpen]);
  const onOpenChange = useCallback((isOpen) => setMenuOpen(isOpen), [setMenuOpen]);
  const styleKey = getStyleKey(menuOpen);
  const containerStyle = options$9.container.base + " " + options$9.container[styleKey];
  const selectionText = numberSelected > 1 ? `${firstSelection} and ${numberSelected - 1} more` : firstSelection;
  return /* @__PURE__ */ jsx(Popover, {
    open: menuOpen,
    trigger: "click",
    innerContentClassName: "",
    showArrow: false,
    content: menuContent,
    onOpenChange,
    autoPlacementOptions: {
      allowedPlacements: ["top", "bottom"]
    },
    children: /* @__PURE__ */ jsxs("div", {
      onClick: (e) => {
        e.stopPropagation();
        openMenu();
      },
      className: containerStyle,
      style: {
        width,
        maxWidth: width
      },
      children: [icon && /* @__PURE__ */ jsx("div", {
        className: "pr-2",
        children: icon({
          className: addStyles([options$9.icon.base, options$9.icon[styleKey]])
        })
      }), /* @__PURE__ */ jsx("span", {
        className: addStyles([options$9.text.base, options$9.text[styleKey]]),
        children: /* @__PURE__ */ jsx(Tooltip, {
          title: value,
          innerContentClassName: "whitespace-nowrap",
          overlayStyle: {
            maxWidth: "none",
            minWidth: "fit-content",
            width: "auto"
          },
          children: /* @__PURE__ */ jsx("div", {
            className: "truncate",
            children: value
          })
        })
      }), isSelected && /* @__PURE__ */ jsx("span", {
        className: addStyles([options$9.selectionText.base, options$9.selectionText[styleKey]]),
        children: selectionText
      }), /* @__PURE__ */ jsx("div", {
        className: "ml-auto",
        children: /* @__PURE__ */ jsx(Button$1, {
          icon: SvgXmark,
          title: "Clear selection",
          onClick: (e) => {
            e.stopPropagation();
            onClearSelection();
            setMenuOpen(false);
          },
          type: "text",
          size: "small"
        })
      })]
    })
  });
};
const DateFilterChip = ({
  onChange,
  onApply,
  onClear,
  label,
  value,
  isOpen = false
}) => {
  const {
    filter,
    reset,
    resetTempFilter,
    apply,
    updateTempFilter
  } = useDateFilterState(onChange, onApply, value);
  useEffect(() => {
    if (isCompleteFilter(filter.tempFilter) && filter.flushTemp) {
      apply();
    }
  }, [apply, filter.tempFilter, filter.flushTemp]);
  const selectionText = () => {
    let selectionText2 = "";
    switch (filter.appliedFilter.option) {
      case "between": {
        if (filter.appliedFilter.startDate && filter.appliedFilter.endDate) {
          selectionText2 = dayjs(filter.appliedFilter.startDate).format("M/D/YYYY") + " - " + dayjs(filter.appliedFilter.endDate).format("M/D/YYYY");
        }
        break;
      }
      case "within last": {
        let period = filter.appliedFilter.period;
        if (filter.appliedFilter.periodQuantity && filter.appliedFilter.periodQuantity <= 1) {
          period = period == null ? void 0 : period.slice(0, -1);
        }
        selectionText2 = `within last ${filter.appliedFilter.periodQuantity} ${period}`;
        break;
      }
      case "after": {
        if (filter.appliedFilter.startDate) {
          selectionText2 = `after ${dayjs(filter.appliedFilter.startDate).format("M/D/YYYY")}`;
        }
        break;
      }
      case "before": {
        if (filter.appliedFilter.endDate) {
          selectionText2 = `before ${dayjs(filter.appliedFilter.endDate).format("M/D/YYYY")}`;
        }
        break;
      }
    }
    return selectionText2;
  };
  return /* @__PURE__ */ jsx(FilterChip, {
    isOpen,
    onOpen: () => {
      if (isCompleteFilter(filter.appliedFilter)) {
        updateTempFilter({
          ...filter.appliedFilter
        });
      } else {
        resetTempFilter();
      }
    },
    menuContent: /* @__PURE__ */ jsx(Card, {
      shadow: "dark",
      children: /* @__PURE__ */ jsx(DateFilterMenuContent, {
        onChange: (filter2) => {
          updateTempFilter(filter2);
        },
        onOptionChange: (option) => {
          resetTempFilter();
          updateTempFilter({
            option
          });
        },
        dateFilter: filter.tempFilter
      })
    }),
    onClearSelection: () => {
      reset();
      onClear == null ? void 0 : onClear();
    },
    value: label,
    firstSelection: selectionText(),
    numberSelected: isCompleteFilter(filter.appliedFilter) ? 1 : 0
  });
};
const DATE_ERROR_MESSAGE = "Date is required.";
const NUMBER_ERROR_MESSAGE = "Number is required.";
const options$8 = {
  container: {
    base: "flex flex-nowrap items-center box-border rounded-lg border-solid border h-min w-fit cursor-pointer pl-5",
    unselected: "border-gray-600 bg-white text-gray-900 hover:text-primary hover:fill-primary active:border-jungle-900 active:fill-jungle-900 active:text-jungle-900",
    selected: "border-jungle-600 bg-jungle-50 text-jungle-900 fill-jungle-900"
  },
  icon: {
    base: "h-6 w-6",
    selected: "fill-inherit",
    unselected: ""
  }
};
const displayCount = (count2) => {
  return count2 !== void 0 && count2 > 0 ? ` (${count2})` : "";
};
const QuickFilterButton = (props) => {
  const {
    label,
    selectedCount,
    icon,
    isSelected,
    onClick,
    onClose
  } = props;
  return /* @__PURE__ */ jsxs("div", {
    className: addStyles([options$8.container.base, isSelected ? options$8.container.selected : options$8.container.unselected]),
    children: [icon && /* @__PURE__ */ jsx("div", {
      className: "pr-2",
      children: icon({
        className: addStyles([options$8.icon.base, isSelected ? options$8.icon.selected : options$8.icon.unselected])
      })
    }), /* @__PURE__ */ jsxs("button", {
      className: "select-none pr-1 text-base",
      onClick,
      children: [label, displayCount(selectedCount)]
    }), isSelected ? /* @__PURE__ */ jsx(Button$1, {
      icon: SvgXmark,
      onClick: onClose,
      type: "action"
    }) : /* @__PURE__ */ jsx(Button$1, {
      icon: SvgCaretDown,
      onClick,
      type: "inherit"
    })]
  });
};
const DateFilterDropdown = ({
  onChange,
  onApply,
  value,
  label
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const {
    filter,
    reset,
    apply,
    updateTempFilter,
    updateErrors,
    resetTempFilter
  } = useDateFilterState(onChange, onApply, value);
  const handleApply = () => {
    const newErrors = {
      ...filter.errors
    };
    switch (filter.tempFilter.option) {
      case "between": {
        newErrors.start = filter.tempFilter.startDate === void 0 ? DATE_ERROR_MESSAGE : void 0;
        newErrors.end = filter.tempFilter.endDate === void 0 ? DATE_ERROR_MESSAGE : void 0;
        newErrors.period = void 0;
        break;
      }
      case "within last": {
        newErrors.start = void 0;
        newErrors.end = void 0;
        newErrors.period = filter.tempFilter.periodQuantity === void 0 ? NUMBER_ERROR_MESSAGE : void 0;
        break;
      }
      case "after": {
        newErrors.start = filter.tempFilter.startDate === void 0 ? DATE_ERROR_MESSAGE : void 0;
        newErrors.end = void 0;
        newErrors.period = void 0;
        break;
      }
      case "before": {
        newErrors.start = void 0;
        newErrors.end = filter.tempFilter.endDate === void 0 ? DATE_ERROR_MESSAGE : void 0;
        newErrors.period = void 0;
        break;
      }
    }
    updateErrors(newErrors);
    if (Object.values(newErrors).some((error) => error !== void 0)) {
      setIsDropdownOpen(true);
      return;
    }
    apply();
    setIsDropdownOpen(false);
  };
  const handleDropdownToggle = (isOpen) => {
    if (isOpen) {
      updateTempFilter({
        ...filter.appliedFilter
      });
    }
    setIsDropdownOpen(isOpen);
  };
  const popoverContent = /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(DateFilterMenuContent, {
      onChange: (filter2) => {
        updateTempFilter(filter2);
      },
      onOptionChange: (option) => {
        resetTempFilter();
        if (filter.appliedFilter.option === option) {
          updateTempFilter({
            ...filter.appliedFilter
          });
        } else {
          updateTempFilter({
            option
          });
        }
      },
      dateError: filter.errors,
      dateFilter: filter.tempFilter
    }), /* @__PURE__ */ jsx("div", {
      className: "flex flex-col",
      children: /* @__PURE__ */ jsxs("div", {
        className: "border-gray flex w-full flex-row border-t px-5 py-2.5",
        children: [/* @__PURE__ */ jsx("div", {
          className: "flex-1",
          children: /* @__PURE__ */ jsx(Button$1, {
            type: "text",
            onClick: () => {
              reset();
              setIsDropdownOpen(false);
            },
            children: "Reset"
          })
        }), /* @__PURE__ */ jsx(Button$1, {
          type: "primary",
          onClick: handleApply,
          children: "Apply"
        })]
      })
    })]
  });
  return /* @__PURE__ */ jsx(Popover, {
    showArrow: false,
    open: isDropdownOpen,
    content: popoverContent,
    onOpenChange: () => handleDropdownToggle(!isDropdownOpen),
    innerContentClassName: "p-0 min-w-64",
    children: /* @__PURE__ */ jsx(QuickFilterButton, {
      label,
      icon: void 0,
      isSelected: !!filter.appliedFilter.option,
      onClick: () => handleDropdownToggle(!isDropdownOpen),
      onClose: (e) => {
        e.stopPropagation();
        reset();
        setIsDropdownOpen(false);
      }
    })
  });
};
const RangePicker = (props) => {
  const {
    onChange,
    onOpenChange,
    onCalendarChange,
    selectionStart,
    selectionEnd,
    allowClear,
    errorProps,
    ...rest
  } = props;
  const size = rest.containerSize ?? "large";
  const ref = useRef();
  const [menuOpen, setMenuOpen] = useState(false);
  const [formattedDate, setFormattedDate] = useState(formatRange(selectionStart, selectionEnd));
  useEffect(() => {
    setFormattedDate(formatRange(selectionStart, selectionEnd));
  }, [selectionStart, selectionEnd]);
  const onChangeCallback = useCallback((selection) => {
    var _a, _b;
    const formattedDate2 = formatRange(selection[0], selection[1]);
    if (selection[0] !== void 0 === (selection[1] !== void 0)) {
      onChange(selection);
      setFormattedDate(formattedDate2);
      setMenuOpen(false);
      (_a = ref.current) == null ? void 0 : _a.blur();
    } else {
      (_b = ref.current) == null ? void 0 : _b.focus();
      setFormattedDate(formattedDate2);
    }
  }, [onChange]);
  const onCalendarChangeCallback = useCallback((selection) => {
    onChangeCallback(selection);
    onCalendarChange == null ? void 0 : onCalendarChange(selection);
  }, [onChangeCallback, onCalendarChange]);
  const onInputChange = useCallback((e) => {
    if (!e.target.value) {
      onChangeCallback([void 0, void 0]);
      setFormattedDate("");
    } else if (isValidDateRangeInputString(e.target.value)) {
      const [startDate2, endDate2] = splitRange(e.target.value);
      onChangeCallback([startDate2, endDate2]);
    } else {
      setFormattedDate(e.target.value);
    }
  }, [onChangeCallback]);
  const setOpen = useCallback((isOpen) => {
    setMenuOpen(isOpen);
    if (isOpen !== menuOpen) onOpenChange == null ? void 0 : onOpenChange(isOpen);
  }, [menuOpen, onOpenChange]);
  const [startDate, endDate] = splitRange(formattedDate);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Popover, {
      open: menuOpen,
      trigger: "external",
      innerContentClassName: "",
      showArrow: false,
      onOpenChange: setOpen,
      autoPlacementOptions: {
        autoAlignment: true,
        allowedPlacements: ["bottom", "top"]
      },
      content: /* @__PURE__ */ jsx(DatePickerCalendar, {
        ...rest,
        selectionStart: startDate,
        selectionEnd: endDate,
        rangeSelection: true,
        onChange: onCalendarChangeCallback
      }),
      children: /* @__PURE__ */ jsx(Input$1, {
        ref: (thisInput) => ref.current = thisInput,
        type: "date",
        allowClear,
        onKeyUp: (e) => {
          const isOpen = !menuOpen || e.key !== "Enter";
          setOpen(isOpen);
        },
        onFocus: () => setOpen(true),
        value: formattedDate,
        onChange: onInputChange,
        containerSize: rest.containerSize
      })
    }), errorProps && /* @__PURE__ */ jsx(FormHelperText, {
      ...errorProps,
      type: "error",
      size: errorProps.size ?? size
    })]
  });
};
const DescriptionListItem = ({
  title,
  value,
  additionalInfo
}) => {
  const content = useMemo(() => {
    if (isValidElement(value)) {
      return value;
    } else {
      return additionalInfo ? /* @__PURE__ */ jsx(Popover, {
        content: additionalInfo,
        title: value,
        children: /* @__PURE__ */ jsx("span", {
          className: "cursor-pointer text-gray-900 underline decoration-dashed underline-offset-2",
          children: value
        })
      }) : /* @__PURE__ */ jsx("span", {
        className: "text-gray-900",
        children: value
      });
    }
  }, [value, additionalInfo]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      className: "border-b border-r border-gray-300 bg-gray-50 px-6 py-4 text-gray-800",
      children: title
    }), /* @__PURE__ */ jsx("div", {
      className: "border-b border-gray-300 bg-white px-6 py-4",
      children: content
    })]
  });
};
const DescriptionList = ({
  data = []
}) => {
  const items = useMemo(() => data.map((d, index2) => /* @__PURE__ */ jsx(DescriptionListItem, {
    title: d.title,
    value: d.value,
    additionalInfo: d.additionalInfo
  }, index2)), [data]);
  return /* @__PURE__ */ jsx("div", {
    className: "grid grid-cols-[auto_minmax(0,1fr)] overflow-hidden rounded-lg border border-gray-300",
    children: items
  });
};
const options$7 = {
  baseOverlay: "z-30 fixed inset-0",
  baseDrawer: "fixed flex flex-col bg-white bg-clip-padding shadow-lg outline-none text-gray-900 border-none z-40 divide-y divide-gray-300 justify-between transition-all duration-300 delay-100",
  placement: {
    right: "top-0 bottom-0 right-0 md:rounded-l-lg",
    left: "top-0 bottom-0 left-0 md:rounded-r-lg",
    top: "top-0 left-0 right-0 h-2/3 md:rounded-b-lg",
    bottom: "bottom-0 left-0 right-0 h-2/3 md:rounded-t-lg"
  },
  hide: {
    left: "-translate-x-full shadow-none",
    right: "translate-x-full shadow-none",
    top: "-translate-y-full shadow-none",
    bottom: "translate-y-full shadow-none"
  },
  show: {
    left: "translate-x-0",
    right: "translate-x-0",
    top: "translate-y-0",
    bottom: "translate-y-0"
  },
  dimensions: {
    width: "w-full md:w-96"
  }
};
function Drawer({
  open = false,
  overlay = true,
  placement = "right",
  ...props
}) {
  const {
    closeDrawer,
    header,
    body,
    footer,
    showHeaderClose = true,
    width
  } = props;
  useEffect(() => {
    const keyPressed = (e) => {
      if (e.key === "Escape" && open) {
        closeDrawer();
      }
    };
    window.addEventListener("keydown", keyPressed);
    return () => window.removeEventListener("keydown", keyPressed);
  }, [open, closeDrawer]);
  return /* @__PURE__ */ jsxs("div", {
    className: "drawer-wrapper",
    role: "dialog",
    "aria-hidden": !open,
    "aria-label": header,
    children: [overlay && /* @__PURE__ */ jsx("div", {
      role: "presentation",
      className: addStyles([options$7.baseOverlay, open ? "translate-x-0" : "translate-x-full"]),
      onClick: closeDrawer,
      children: /* @__PURE__ */ jsx("div", {
        className: "absolute inset-0 bg-black opacity-50"
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: addStyles([options$7.baseDrawer, options$7.placement[placement], open ? options$7.show[placement] : options$7.hide[placement], width ? void 0 : options$7.dimensions.width]),
      style: {
        width
      },
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex items-center justify-between p-4",
        children: [/* @__PURE__ */ jsx("span", {
          className: "headline-s",
          children: header
        }), showHeaderClose && /* @__PURE__ */ jsx(SvgXmark, {
          width: "2rem",
          height: "2rem",
          onClick: closeDrawer,
          className: "rounded-lg hover:cursor-pointer hover:bg-gray-200"
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "offcanvas-body grow overflow-y-auto p-4",
        children: open && body
      }), footer && /* @__PURE__ */ jsx("div", {
        className: "offcanvas-footer p-4",
        children: footer
      })]
    })]
  });
}
const options$6 = {
  dropdown: {
    base: "divide-y divide-gray-300 rounded-lg shadow-dark bg-white"
  }
};
const Dropdown = (props) => {
  const {
    label,
    menuContent,
    selectedCount,
    isSelected = false,
    defaultOpen = false,
    applyText = "Apply",
    resetText = "Reset",
    onApply,
    onReset,
    renderMenu,
    onOpen,
    buttonProps,
    icon
  } = props;
  const [menuOpen, setMenuOpen] = useState(defaultOpen);
  useEffect(() => {
    setMenuOpen(defaultOpen);
  }, [defaultOpen]);
  const onClick = (e) => {
    e.stopPropagation();
    setMenuOpen((isOpen) => !isOpen);
  };
  const onXClick = (e) => {
    e.stopPropagation();
    setMenuOpen(false);
    onReset();
  };
  const onApplyClick = (e) => {
    e.stopPropagation();
    setMenuOpen(false);
    onApply == null ? void 0 : onApply();
  };
  const selectedOption = isSelected || selectedCount !== void 0 && selectedCount > 0;
  return /* @__PURE__ */ jsx(Popover, {
    showArrow: false,
    open: menuOpen,
    innerContentClassName: "",
    onOpenChange: (isOpen) => {
      setMenuOpen(isOpen);
      onOpen == null ? void 0 : onOpen();
    },
    content: renderMenu === void 0 ? /* @__PURE__ */ jsxs("div", {
      className: options$6.dropdown.base,
      children: [/* @__PURE__ */ jsx("div", {
        children: menuContent
      }), /* @__PURE__ */ jsxs("div", {
        className: "flex flex-row px-5 py-2.5",
        children: [/* @__PURE__ */ jsx("div", {
          className: "flex-1",
          children: /* @__PURE__ */ jsx(Button$1, {
            type: "text",
            onClick: onXClick,
            children: resetText
          })
        }), /* @__PURE__ */ jsx(Button$1, {
          type: "primary",
          onClick: onApplyClick,
          children: applyText
        })]
      })]
    }) : renderMenu(onApplyClick, onXClick),
    children: /* @__PURE__ */ jsx(QuickFilterButton, {
      onClick,
      isSelected: selectedOption,
      icon,
      label,
      onClose: onXClick,
      selectedCount,
      ...buttonProps
    })
  });
};
const options$5 = {
  size: {
    default: "size-8",
    small: "size-4",
    large: "size-16"
  },
  color: {
    primary: "fill-primary",
    secondary: "fill-gray-800"
  }
};
function Spinner({
  size = "default",
  color = "primary",
  inline = false,
  spinning = true,
  ...props
}) {
  const {
    className,
    wrapperClassName,
    children
  } = props;
  if (spinning) {
    return /* @__PURE__ */ jsx("div", {
      "data-testid": "Spinner",
      className: mergeStyles(["box-content", options$5.size[size], inline ? "inline-block" : "", wrapperClassName]),
      children: /* @__PURE__ */ jsxs("svg", {
        role: "status",
        viewBox: "0 0 100 101",
        className: addStyles(["animate-spin", options$5.size[size], options$5.color[color], className]),
        xmlns: "http://www.w3.org/2000/svg",
        children: [/* @__PURE__ */ jsx("path", {
          opacity: "0.1",
          d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        }), /* @__PURE__ */ jsx("path", {
          d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        })]
      })
    });
  } else {
    return children ? /* @__PURE__ */ jsx("div", {
      "data-testid": "Spinner",
      className: "opacity-100",
      children
    }) : /* @__PURE__ */ jsx(Fragment, {});
  }
}
const Toast = (props) => {
  const {
    children,
    context,
    className,
    xmarkClasses
  } = props;
  const handleClose = useCallback(() => {
    toast.dismiss(context.id);
  }, [context]);
  return /* @__PURE__ */ jsxs("div", {
    "data-testid": "toast-wrapper",
    className: addStyles([className ?? "bg-white rounded-lg shadow-dark py-4 px-6 flex gap-12 items-center ", context.visible ? "animate-enter" : "animate-leave"]),
    children: [children, /* @__PURE__ */ jsx("button", {
      "data-testid": "toast-dismiss-button",
      onClick: handleClose,
      children: /* @__PURE__ */ jsx(SvgXmark, {
        className: "size-6 fill-current " + xmarkClasses
      })
    })]
  });
};
const UploadCard = (props) => {
  const {
    file,
    onDelete
  } = props;
  const [image, setImage] = useState();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const reader = new FileReader();
    reader.addEventListener("loadstart", () => {
      setIsLoading(true);
    });
    reader.onloadend = () => {
      setIsLoading(false);
      setImage(reader.result);
    };
    reader.readAsDataURL(file);
  }, [file]);
  return /* @__PURE__ */ jsxs("div", {
    className: "grid grid-cols-[3.125rem_auto_3.125rem] items-center rounded-lg border border-gray-300 bg-white p-2",
    children: [/* @__PURE__ */ jsx("div", {
      className: "flex size-12 items-center justify-center",
      children: isLoading ? /* @__PURE__ */ jsx(Spinner, {}) : /* @__PURE__ */ jsx("img", {
        className: "max-h-full max-w-full",
        src: image,
        alt: file.name
      })
    }), /* @__PURE__ */ jsx("span", {
      className: "overflow-hidden text-ellipsis pl-2 text-primary",
      children: file.name
    }), /* @__PURE__ */ jsx("div", {
      className: "ml-auto flex items-center",
      children: /* @__PURE__ */ jsx("button", {
        "aria-label": `delete ${file.name}`,
        onClick: onDelete,
        children: /* @__PURE__ */ jsx(SvgDelete, {
          className: "size-4 fill-gray-700"
        })
      })
    })]
  });
};
const validateFileSize = (maxSize, file) => {
  const fileSize = file.size;
  return fileSize <= maxSize * 1024 * 1024;
};
const handleUploadError = (error) => {
  toast.custom((t) => /* @__PURE__ */ jsx(Toast, {
    context: t,
    children: error
  }));
};
const uploadParser = (files, allowedFileTypes, maxSize) => {
  let uploads = [];
  for (let i = 0; i < files.length; i++) {
    const file = files.item(i);
    let isValid = true;
    if (file) {
      if (maxSize) {
        isValid = validateFileSize(maxSize, file);
        if (!isValid) {
          handleUploadError(`File size too large. (max size: ${maxSize}MB)`);
          continue;
        }
      }
      uploads = isValid ? [...uploads, file] : [...uploads];
    }
  }
  return uploads;
};
const FileUpload = ({
  buttonLabel = "Upload photo",
  ...props
}) => {
  const {
    onChange,
    allowedFileTypes,
    maxSize,
    label,
    required,
    helperText,
    error,
    disabled,
    multiple,
    name,
    value
  } = props;
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const input = useRef(null);
  const saveUploads = useCallback((uploads) => {
    const existingFileNames = new Set(files.map((file) => file.name));
    const newFiles = uploads.filter((newFile) => !existingFileNames.has(newFile.name));
    const update = [...files, ...newFiles];
    setFiles([...update]);
    if (onChange) {
      onChange([...update]);
    }
    setIsLoading(false);
  }, [onChange, files]);
  const handleChange = useCallback((event) => {
    if (!event.target.files) return;
    setIsLoading(true);
    const uploads = uploadParser(event.target.files, allowedFileTypes, maxSize);
    saveUploads(uploads);
    event.target.value = "";
  }, [saveUploads, allowedFileTypes, maxSize]);
  const handleDrop = useCallback((event) => {
    event.preventDefault();
    if (!event.dataTransfer.files) return;
    setIsLoading(true);
    const uploads = uploadParser(event.dataTransfer.files, allowedFileTypes, maxSize);
    saveUploads(uploads);
  }, [saveUploads, allowedFileTypes, maxSize]);
  const handleDragOver = useCallback((event) => {
    event.preventDefault();
  }, []);
  const handleDeleteFile = useCallback((file) => () => {
    const index2 = files.indexOf(file);
    const newFiles = [...files];
    newFiles.splice(index2, 1);
    setFiles([...newFiles]);
    if (onChange) {
      onChange([...newFiles]);
    }
  }, [files, onChange]);
  const renderFiles = useMemo(() => {
    return files.map((file, index2) => {
      return /* @__PURE__ */ jsx(UploadCard, {
        file,
        onDelete: handleDeleteFile(file)
      }, index2);
    });
  }, [files, handleDeleteFile]);
  useEffect(() => {
    setFiles(value || []);
  }, [value]);
  return /* @__PURE__ */ jsxs("div", {
    className: "text-gray-900",
    onDrop: handleDrop,
    onDragOver: handleDragOver,
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex flex-col pb-2",
      children: [/* @__PURE__ */ jsxs("div", {
        children: [/* @__PURE__ */ jsx("span", {
          className: "font-medium",
          children: label
        }), !required && /* @__PURE__ */ jsx("span", {
          className: "text-gray-700",
          children: " (optional)"
        })]
      }), helperText && /* @__PURE__ */ jsx("span", {
        children: helperText
      }), error && /* @__PURE__ */ jsx("span", {
        className: "text-red-600",
        children: error
      })]
    }), /* @__PURE__ */ jsxs("label", {
      htmlFor: "file-upload",
      children: [/* @__PURE__ */ jsx("input", {
        type: "file",
        className: "hidden",
        id: "file-upload",
        multiple,
        onChange: handleChange,
        ref: input,
        accept: allowedFileTypes ? allowedFileTypes.join(",") : void 0,
        name,
        role: "form"
      }), /* @__PURE__ */ jsx(Button$1, {
        icon: SvgUpload,
        loading: isLoading,
        type: "default",
        onClick: (e) => {
          e.preventDefault();
          if (input.current) {
            input.current.click();
          }
        },
        disabled: disabled || isLoading,
        className: "!w-full items-center justify-center space-x-2",
        children: /* @__PURE__ */ jsx("span", {
          className: "font-normal	",
          children: buttonLabel
        })
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: "mt-2 flex flex-col gap-2",
      children: renderFiles
    })]
  });
};
const classes$2 = {
  wrapper: "inline-block relative",
  input: `bg-white rounded-t-lg py-2 px-3 border-none shadow-dark`,
  popover: {
    root: "origin-top-right absolute z-150 rounded-t-none",
    base: "flex-col max-h-60 overflow-y-auto rounded-t-none border-t border-t-gray-300 shadow-dark",
    clearSelectionButton: "py-2.5 px-5 border-b border-gray-300 text-primary hover:bg-gray-100 active:bg-gray-200 cursor-pointer select-none underline font-medium decoration-primary underline-offset-2 text-sm"
  }
};
const getWidth = (element) => {
  return element == null ? void 0 : element.clientWidth;
};
const FilterComboBoxWrapper = (props) => {
  var _a;
  const {
    placeholder = "Search",
    size,
    width,
    autoFocus,
    open,
    isDropdownEmpty,
    onDropdownVisibleChange,
    onSearch,
    onBlur: onBlurCallback,
    onFocus: onFocusCallback,
    defaultSearchTerm,
    children,
    popoverClassesBase,
    selectedItems = [],
    onDeselect,
    tagProps
  } = props;
  const [isOpen, setIsOpen] = useState(open || false);
  const ref = useRef(null);
  const menuContentRef = useRef(null);
  const onFocus = (e) => {
    setIsOpen(true);
    onDropdownVisibleChange == null ? void 0 : onDropdownVisibleChange(true);
    onFocusCallback == null ? void 0 : onFocusCallback(e);
  };
  useEffect(() => {
    if (open !== void 0) {
      setIsOpen(open);
    }
  }, [open]);
  const contentWidth = width ?? `${(_a = menuContentRef.current) == null ? void 0 : _a.clientWidth}px`;
  return /* @__PURE__ */ jsx("div", {
    ref,
    className: classes$2.wrapper,
    children: /* @__PURE__ */ jsx(Popover, {
      showArrow: false,
      trigger: "external",
      open: isOpen,
      onOpenChange: setIsOpen,
      offsetOptions: {
        mainAxis: 0
      },
      overlayClassName: classes$2.popover.root,
      overlayStyle: {
        width: contentWidth
      },
      innerContentClassName: popoverClassesBase ?? classes$2.popover.base,
      content: children,
      autoPlacementOptions: {
        allowedPlacements: ["top", "bottom"]
      },
      isDismissBubbleEnabled: true,
      children: /* @__PURE__ */ jsx("div", {
        ref: menuContentRef,
        style: {
          width
        },
        children: /* @__PURE__ */ jsx(ComboBoxInput, {
          autoFocus,
          selectedItems,
          size,
          className: addStyles([classes$2.input, !isOpen || isDropdownEmpty ? "rounded-b-lg" : ""]),
          style: {
            width
          },
          placeholder,
          onSearch: debounce(onSearch, 300),
          onDeselect: (item) => () => onDeselect == null ? void 0 : onDeselect(item),
          onBlur: onBlurCallback,
          onFocus,
          defaultValue: defaultSearchTerm,
          tagProps: {
            baseType: "table",
            ...tagProps
          },
          containerSize: "medium"
        })
      })
    })
  });
};
const useFilterComboboxSelection = (defaultValue, onChange, data) => {
  const [selectedItems, setSelectedItems] = useState(Array.isArray(defaultValue) ? defaultValue : [defaultValue]);
  const onToggleItem = useCallback((selectedItem, isSelected) => {
    const newSelection = isSelected ? [...selectedItems, selectedItem] : selectedItems.filter((selectedValue) => selectedValue.value !== selectedItem.value);
    onChange(newSelection, data);
    setSelectedItems(newSelection);
  }, [data, onChange, selectedItems]);
  const deselectAll = useCallback((e) => {
    onChange([], data);
    setSelectedItems([]);
    e.stopPropagation();
  }, [data, onChange]);
  return {
    selectedItems,
    setSelectedItems,
    onToggleItem,
    deselectAll
  };
};
const FilterComboBox = (props) => {
  const {
    data,
    onChange,
    open,
    autoFilterItems = false,
    onSearch: onSearchCallback,
    renderListItem,
    defaultValue = [],
    defaultSearchTerm,
    ...rest
  } = props;
  const {
    selectedItems,
    onToggleItem,
    deselectAll
  } = useFilterComboboxSelection(defaultValue, onChange, data);
  const [searchTerm, setSearchTerm] = useState(defaultSearchTerm ?? "");
  const isMatch = useCallback((item) => !autoFilterItems || matchesSearch$1(item, searchTerm), [autoFilterItems, searchTerm]);
  const onSearch = (searchString) => {
    setSearchTerm(searchString);
    onSearchCallback(searchString);
  };
  const menuItemRenderer = useCallback((value, selected = false) => /* @__PURE__ */ jsx(FilterComboBoxMenuItem, {
    item: {
      ...value,
      textToHighlight: searchTerm
    },
    defaultSelection: selected,
    onSelect: onToggleItem,
    className: "text-sm",
    renderItem: renderListItem
  }, value.value), [onToggleItem, renderListItem, searchTerm]);
  const itemsNotSelected = useMemo(() => data.filter((dataItem) => !selectedItems.some((selectedItem) => selectedItem.value === dataItem.value) && isMatch(dataItem)).map((element) => menuItemRenderer(element, false)), [data, isMatch, menuItemRenderer, selectedItems]);
  const itemsSelected = useMemo(() => selectedItems.filter((selectedItem) => matchesSearch$1(selectedItem, searchTerm)).map((element) => menuItemRenderer(element, true)), [menuItemRenderer, searchTerm, selectedItems]);
  const isDropdownEmpty = useMemo(() => !(data.some((i) => isMatch(i)) || selectedItems.length > 0), [data, isMatch, selectedItems]);
  return /* @__PURE__ */ jsxs(FilterComboBoxWrapper, {
    open,
    isDropdownEmpty,
    onSearch,
    onDeselect: (item) => onToggleItem(item, false),
    ...rest,
    children: [itemsSelected, selectedItems.length > 0 && /* @__PURE__ */ jsx("div", {
      role: "button",
      "aria-label": "Clear selection",
      onClick: deselectAll,
      className: classes$2.popover.clearSelectionButton,
      children: "Clear selected"
    }), itemsNotSelected]
  });
};
const getKey = (item) => (item.id ?? item.title).toString();
const matchesSearch = (item, searchTerm) => {
  var _a, _b;
  const search = searchTerm.toLowerCase();
  return ((_a = item.id) == null ? void 0 : _a.toString().toLowerCase().includes(search)) || ((_b = item.value) == null ? void 0 : _b.toLowerCase().includes(search)) || item.title.toLowerCase().includes(search);
};
const treeMatchesSearch = (item, searchTerm) => {
  return matchesSearch(item, searchTerm) || !!item.children && item.children.some((child) => treeMatchesSearch(child, searchTerm));
};
const getDescendantKeys = (children) => {
  const keys = /* @__PURE__ */ new Set();
  const stack = [...children];
  while (stack.length > 0) {
    const node = stack.pop();
    if (!node) break;
    keys.add(node.id);
    if (node.children) {
      stack.push(...node.children);
    }
  }
  return keys;
};
const setDescendantChecked = (isChecked, state) => {
  const descendants = getDescendantKeys(state.children);
  if (isChecked) {
    for (const descendant of descendants) {
      state.checkedKeys.current.add(descendant);
    }
  } else {
    state.checkedKeys.current.delete(state.id);
    for (const key of descendants) {
      state.checkedKeys.current.delete(key);
    }
  }
};
const setIsCheckedAction = (state, isChecked, isHalfChecked) => {
  if (isChecked) state.checkedKeys.current.add(state.id);
  else state.checkedKeys.current.delete(state.id);
  return { ...state, isChecked, isHalfChecked };
};
const getNumberOfChildrenChecked = (children, checkedKeys) => {
  return children.reduce((pv, cv) => {
    return pv + (checkedKeys.current.has(cv.id) ? 1 : 0);
  }, 0);
};
const hasDescendantsChecked = (checkedKeys, children) => {
  if (!children) return false;
  return children.some(
    (node) => checkedKeys.current.has(node.id) || hasDescendantsChecked(checkedKeys, node.children)
  );
};
const updateCheckedKeysAndGetCheckedState = (id, childIsChecked, childKey, children, checkedKeys) => {
  if (childIsChecked) checkedKeys.current.add(childKey);
  else checkedKeys.current.delete(childKey);
  const numChecked = getNumberOfChildrenChecked(children, checkedKeys);
  const shouldBeChecked = numChecked === children.length;
  const shouldBeHalfChecked = !shouldBeChecked && hasDescendantsChecked(checkedKeys, children);
  if (shouldBeChecked) checkedKeys.current.add(id);
  else checkedKeys.current.delete(id);
  return { shouldBeChecked, shouldBeHalfChecked };
};
const toggleIsExpanded = (state, isExpanded) => {
  var _a;
  if (isExpanded) state.expandedKeys.current.delete(state.id);
  else state.expandedKeys.current.add(state.id);
  (_a = state.onExpandCallback) == null ? void 0 : _a.call(state, state.expandedKeys.current);
  return { ...state, isExpanded: !isExpanded };
};
const expandParentsOfItemsMatchingSearch = (id, node, expandedKeys, parentId, searchTerm) => {
  if (searchTerm) {
    expandedKeys.current.delete(id);
    if (matchesSearch(node, searchTerm) && parentId) {
      expandedKeys.current.add(parentId);
    }
  }
};
const getTreeNodeDefaultsFromChildren = (id, checkedKeys, expandedKeys, children) => {
  if (children == null ? void 0 : children.every((node) => node.isChecked)) {
    checkedKeys.current.add(id);
  }
  if (children == null ? void 0 : children.some((node) => node.isExpanded)) {
    expandedKeys.current.add(id);
  }
};
const removeRedundantKeys = (keys, data) => {
  const newKeys = /* @__PURE__ */ new Set();
  const nodes = [...data];
  while (nodes == null ? void 0 : nodes.length) {
    const node = nodes.pop();
    if (!node) break;
    if (keys.has(getKey(node))) {
      newKeys.add(getKey(node));
    } else if (node.children) {
      nodes.push(...node.children);
    }
  }
  return newKeys;
};
const nodeChildrenClasses = "ml-10";
const treeNodeReducer = (state, action) => {
  switch (action.type) {
    case "setIsChecked": {
      return setIsCheckedAction(state, action.isChecked, action.isHalfChecked);
    }
    case "toggleIsExpanded": {
      return toggleIsExpanded(state, state.isExpanded);
    }
    case "setIsExpanded": {
      return {
        ...state,
        isExpanded: action.isExpanded
      };
    }
  }
};
const treeNodeStateInit = (state) => {
  if (state.checkedKeys.current.has(state.id)) {
    for (const child of state.children) {
      state.checkedKeys.current.add(child.id);
    }
  }
  const numberChildrenChecked = getNumberOfChildrenChecked(state.children, state.checkedKeys);
  return {
    ...state,
    isChecked: state.isChecked,
    isHalfChecked: numberChildrenChecked > 0 && numberChildrenChecked !== state.children.length,
    isExpanded: state.isExpanded
  };
};
const TreeInternalNode = (props) => {
  const [state, dispatch] = useReducer(treeNodeReducer, {
    isChecked: props.checked,
    isExpanded: props.expanded,
    children: props.childrenData,
    checkedKeys: props.checkedKeys,
    expandedKeys: props.expandedKeys,
    onCheck: props.onCheck,
    onCheckCallback: props.onCheckCallback,
    onExpandCallback: props.onExpandCallback,
    id: props.id
  }, treeNodeStateInit);
  useEffect(() => {
    if (props.checked !== void 0) {
      const shouldBeHalfChecked = !props.checked && hasDescendantsChecked(props.checkedKeys, props.childrenData);
      dispatch({
        type: "setIsChecked",
        isChecked: props.checked,
        isHalfChecked: shouldBeHalfChecked
      });
    }
  }, [props.checked, props.checkedKeys, props.childrenData, props.id]);
  useEffect(() => {
    if (props.expanded !== void 0) dispatch({
      type: "setIsExpanded",
      isExpanded: props.expanded
    });
  }, [props.expanded]);
  if (props.searchTerm && !props.parentMatchesSearch && !treeMatchesSearch({
    value: props.value,
    title: props.title,
    id: props.id,
    children: props.childrenData
  }, props.searchTerm)) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex px-2.5 py-1",
      children: [/* @__PURE__ */ jsx(SvgChevronDown, {
        onClick: () => dispatch({
          type: "toggleIsExpanded"
        }),
        className: `size-6 cursor-pointer transition-all ${state.isExpanded ? "rotate-180	" : "rotate-0"}`
      }), /* @__PURE__ */ jsx(Checkbox, {
        value: props.value,
        label: highlight(props.title, props.searchTerm),
        isChecked: state.isChecked,
        isPartiallyChecked: state.isHalfChecked,
        onChange: (e) => {
          const checked = e.target.checked;
          setDescendantChecked(checked, state);
          props.onCheck(checked, props.id);
          dispatch({
            type: "setIsChecked",
            isChecked: checked,
            isHalfChecked: false
          });
        }
      })]
    }), state.isExpanded && props.childrenData.map((node) => {
      return /* @__PURE__ */ jsx("div", {
        className: nodeChildrenClasses,
        children: /* @__PURE__ */ jsx(TreeNode, {
          id: node.id,
          value: node.value,
          title: node.title,
          childrenData: node.children,
          level: props.level + 1,
          expanded: state.expandedKeys.current.has(node.id),
          checked: state.checkedKeys.current.has(node.id),
          checkedKeys: props.checkedKeys,
          expandedKeys: props.expandedKeys,
          onExpandCallback: props.onExpandCallback,
          searchTerm: props.searchTerm,
          onCheckCallback: props.onCheckCallback,
          parentMatchesSearch: props.parentMatchesSearch || matchesSearch(props, props.searchTerm),
          onCheck: (checked) => {
            var _a;
            const {
              shouldBeChecked,
              shouldBeHalfChecked
            } = updateCheckedKeysAndGetCheckedState(props.id, checked, node.id, props.childrenData, props.checkedKeys);
            if (!state.isChecked && shouldBeChecked) {
              props.onCheck(true, props.id);
            } else if (state.isChecked && !shouldBeChecked || state.isHalfChecked !== shouldBeHalfChecked) {
              props.onCheck(false, props.id);
            } else {
              (_a = props.onCheckCallback) == null ? void 0 : _a.call(props, props.checkedKeys.current);
            }
            dispatch({
              type: "setIsChecked",
              isChecked: shouldBeChecked,
              isHalfChecked: shouldBeHalfChecked
            });
          }
        })
      }, node.id);
    })]
  });
};
const TreeLeafNode = (props) => {
  const {
    id,
    checked: defaultIsChecked,
    value,
    title,
    onCheck,
    searchTerm,
    parentMatchesSearch
  } = props;
  const [isChecked, setIsChecked] = useState(defaultIsChecked);
  useEffect(() => {
    setIsChecked(defaultIsChecked);
  }, [defaultIsChecked]);
  if (searchTerm && !parentMatchesSearch && !treeMatchesSearch({
    value,
    title,
    id
  }, searchTerm)) return null;
  return /* @__PURE__ */ jsx("div", {
    className: "ml-8.5 py-1",
    children: /* @__PURE__ */ jsx(Checkbox, {
      value,
      isChecked,
      label: highlight(title, searchTerm),
      onChange: (e) => {
        setIsChecked(e.target.checked);
        onCheck(e.target.checked, id);
      }
    })
  });
};
const TreeNode = (props) => {
  return props.childrenData ? /* @__PURE__ */ jsx(TreeInternalNode, {
    ...props
  }) : /* @__PURE__ */ jsx(TreeLeafNode, {
    checked: props.checked || props.checkedKeys.current.has(props.id),
    ...props
  });
};
const TreeRoot = (props) => {
  return /* @__PURE__ */ jsx(TreeNode, {
    id: props.id,
    value: props.value,
    title: props.title,
    checked: props.isChecked,
    expanded: props.isExpanded,
    childrenData: props.children,
    checkedKeys: props.checkedKeys,
    expandedKeys: props.expandedKeys,
    onCheckCallback: props.onCheck,
    onExpandCallback: props.onExpand,
    searchTerm: props.searchTerm,
    parentMatchesSearch: matchesSearch(props, props.searchTerm),
    level: 0,
    onCheck: (checked, key) => {
      var _a;
      if (checked) {
        props.checkedKeys.current.add(key);
      }
      (_a = props.onCheck) == null ? void 0 : _a.call(props, props.checkedKeys.current);
    }
  });
};
const sectionHeaderClasses = "bg-gray-50 border-gray-200 border-y px-2.5 py-1 text-gray-900 font-medium";
const sectionBodyClasses = "py-1";
const TreeSection = (props) => {
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx("div", {
      className: sectionHeaderClasses,
      children: props.title
    }), /* @__PURE__ */ jsx("div", {
      className: sectionBodyClasses,
      children: props.children
    })]
  });
};
const rootClasses = "tree bg-white";
const getTreeData = (data, checkedKeys, expandedKeys, searchTerm) => {
  function getTreeDataRecursive(data2, level, parentId) {
    return data2.map((node, index2) => {
      const id = node.id ?? `${level}+${index2}`;
      const nextLevel = node.isSection ? 0 : level + 1;
      expandParentsOfItemsMatchingSearch(id, node, expandedKeys, parentId, searchTerm);
      const children = node.children ? getTreeDataRecursive(node.children, nextLevel, id) : void 0;
      getTreeNodeDefaultsFromChildren(id, checkedKeys, expandedKeys, children);
      return {
        ...node,
        id,
        isChecked: checkedKeys.current.has(id),
        isExpanded: expandedKeys.current.has(id),
        children
      };
    });
  }
  return getTreeDataRecursive(data, 0);
};
const Tree = (props) => {
  const {
    treeData,
    className,
    defaultCheckedKeys,
    defaultExpandedKeys,
    onCheck,
    onExpand,
    searchTerm = ""
  } = props;
  const checkedKeys = useRef(new Set(props.checkedKeys ?? defaultCheckedKeys));
  const expandedKeys = useRef(new Set(defaultExpandedKeys));
  if (props.checkedKeys) {
    checkedKeys.current = props.checkedKeys;
  }
  const data = getTreeData(treeData, checkedKeys, expandedKeys, searchTerm);
  return /* @__PURE__ */ jsx("div", {
    className: mergeStyles([rootClasses, className]),
    children: data.map((node) => {
      var _a;
      if (node.isSection) {
        return /* @__PURE__ */ jsx(TreeSection, {
          title: node.title,
          children: (_a = node.children) == null ? void 0 : _a.map((node2) => /* @__PURE__ */ createElement(TreeRoot, {
            ...node2,
            checkedKeys,
            expandedKeys,
            onCheck,
            onExpand,
            searchTerm,
            key: node2.id
          }))
        }, node.id);
      }
      return /* @__PURE__ */ createElement(TreeRoot, {
        ...node,
        checkedKeys,
        expandedKeys,
        onCheck,
        onExpand,
        searchTerm,
        key: node.id
      });
    })
  });
};
const TreeComboBoxContents = (props) => {
  const {
    displayDropdown,
    isLoading = false,
    bottomRef,
    bottomContent,
    ...rest
  } = props;
  if (isLoading) {
    return /* @__PURE__ */ jsx("div", {
      className: "popover-spinner-wrapper",
      children: /* @__PURE__ */ jsx(Spinner, {})
    });
  }
  if (!displayDropdown) return null;
  return /* @__PURE__ */ jsxs("div", {
    role: "menu",
    className: "popover-menu",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "popover-menu-content p-4",
      children: [/* @__PURE__ */ jsx(Tree, {
        ...rest
      }), /* @__PURE__ */ jsx("div", {
        ref: bottomRef
      })]
    }), bottomContent && /* @__PURE__ */ jsx("div", {
      className: "popover-menu-bottom-content",
      children: bottomContent
    })]
  });
};
const getMenuItemsFromSelection = (keys, data) => {
  const menuItems = [];
  const nodes = [...data];
  while (nodes == null ? void 0 : nodes.length) {
    const node = nodes.pop();
    if (!node) break;
    if (keys.has(getKey(node))) {
      menuItems.push({
        label: node.title,
        value: getKey(node)
      });
    } else if (node.children) {
      nodes.push(...node.children);
    }
  }
  return menuItems;
};
const filterData = (data, searchText) => {
  if (!searchText) return data;
  return data.filter((item) => treeMatchesSearch(item, searchText)).map((item) => {
    if (item.children) {
      const directMatch = matchesSearch(item, searchText);
      return {
        ...item,
        children: directMatch ? item.children : filterData(item.children, searchText)
      };
    }
    return item;
  });
};
const getKeysFromMenuItems = (data) => {
  const keys = /* @__PURE__ */ new Set();
  const nodes = [...data];
  while (nodes == null ? void 0 : nodes.length) {
    const node = nodes.pop();
    if (!node) break;
    keys.add(getKey(node));
    if (node.children) nodes.push(...node.children);
  }
  return keys;
};
const removeKeyAndDescendants = (node, keys) => {
  const nodeKey = getKey(node);
  keys.delete(nodeKey);
  if (node.children) {
    const descKeys = getDescendantKeys(node.children);
    for (const descKey of descKeys) {
      keys.delete(descKey);
    }
  }
};
const deselect = (key, selectedKeys, data) => {
  const newKeys = new Set(selectedKeys);
  function findNode(node) {
    if (getKey(node) === key) {
      removeKeyAndDescendants(node, newKeys);
      return true;
    }
    if (node.children) {
      for (const child of node.children) {
        if (findNode(child)) {
          newKeys.delete(getKey(node));
          return true;
        }
      }
    }
    return false;
  }
  for (const node of data) {
    if (findNode(node)) {
      newKeys.delete(getKey(node));
      break;
    }
  }
  return newKeys;
};
const TreeComboBox = (props) => {
  const {
    data,
    bottomRef,
    isLoading = false,
    searchText: defaultSearchTerm = "",
    onChange,
    onDeselect: onDeselectCallback,
    onSearch: onSearchCallback,
    value,
    bottomOptionsListContent,
    size,
    ...rest
  } = props;
  const [selectedKeys, setSelectedKeys] = useState(() => value ?? /* @__PURE__ */ new Set());
  const [searchText, setSearchText] = useState(defaultSearchTerm);
  useEffect(() => setSearchText(defaultSearchTerm), [defaultSearchTerm]);
  useEffect(() => {
    if (value) setSelectedKeys(value);
  }, [value]);
  const onSearch = useCallback((searchText2) => {
    setSearchText(searchText2);
    onSearchCallback == null ? void 0 : onSearchCallback(searchText2);
  }, [onSearchCallback]);
  const onSelect = useCallback((selection) => {
    const keys = new Set(selection);
    setSelectedKeys(keys);
    onChange(selection);
  }, [onChange]);
  const onDeselect = useCallback((item) => {
    const newKeys = deselect(item.value, selectedKeys, data);
    onSelect(newKeys);
    onDeselectCallback == null ? void 0 : onDeselectCallback(item);
  }, [data, onDeselectCallback, onSelect, selectedKeys]);
  const filteredData = useMemo(() => filterData(data, searchText), [data, searchText]);
  const selectedMenuItems = useMemo(() => getMenuItemsFromSelection(selectedKeys, data), [selectedKeys, data]);
  const defaultExpandedKeys = useMemo(() => getKeysFromMenuItems(data), [data]);
  return /* @__PURE__ */ jsx(ComboBoxCore, {
    ...rest,
    searchTerm: searchText,
    onSearch,
    defaultSelection: selectedMenuItems,
    onDeselect,
    containerSize: size,
    menuContent: /* @__PURE__ */ jsx(TreeComboBoxContents, {
      bottomRef,
      displayDropdown: filteredData.length > 0,
      isLoading,
      defaultExpandedKeys,
      treeData: data,
      searchTerm: searchText,
      checkedKeys: selectedKeys,
      onCheck: onSelect,
      bottomContent: bottomOptionsListContent
    })
  });
};
function getFormatted(children, props) {
  if (typeof children === "string" && !Number.isNaN(Date.parse(children))) {
    const formatter = Intl.DateTimeFormat(props.locales, {
      ...props
    });
    const date = new Date(/\d{4}-\d{2}-\d{2}/.test(children) ? `${children}T00:00:00` : children);
    return formatter.format(date);
  } else {
    return children;
  }
}
const FormattedDateTime = ({
  locales = "en-us",
  ...props
}) => {
  const {
    children
  } = props;
  const formatted = useMemo(() => {
    return getFormatted(children, {
      locales,
      ...props
    });
  }, [children, locales, props]);
  return /* @__PURE__ */ jsx(Fragment, {
    children: formatted
  });
};
const MountedMapsContext = React.createContext(null);
function cloneTransform(tr) {
  const newTransform = tr.clone();
  newTransform.pixelsToGLUnits = tr.pixelsToGLUnits;
  return newTransform;
}
function transformToViewState(tr) {
  return {
    longitude: tr.center.lng,
    latitude: tr.center.lat,
    zoom: tr.zoom,
    pitch: tr.pitch,
    bearing: tr.bearing,
    padding: tr.padding
  };
}
function applyViewStateToTransform(tr, props) {
  const v = props.viewState || props;
  let changed = false;
  if ("longitude" in v && "latitude" in v) {
    const center = tr.center;
    tr.center = new center.constructor(v.longitude, v.latitude);
    changed = changed || center !== tr.center;
  }
  if ("zoom" in v) {
    const zoom = tr.zoom;
    tr.zoom = v.zoom;
    changed = changed || zoom !== tr.zoom;
  }
  if ("bearing" in v) {
    const bearing = tr.bearing;
    tr.bearing = v.bearing;
    changed = changed || bearing !== tr.bearing;
  }
  if ("pitch" in v) {
    const pitch = tr.pitch;
    tr.pitch = v.pitch;
    changed = changed || pitch !== tr.pitch;
  }
  if (v.padding && !tr.isPaddingEqual(v.padding)) {
    changed = true;
    tr.padding = v.padding;
  }
  return changed;
}
const refProps = ["type", "source", "source-layer", "minzoom", "maxzoom", "filter", "layout"];
function normalizeStyle(style2) {
  if (!style2) {
    return null;
  }
  if (typeof style2 === "string") {
    return style2;
  }
  if ("toJS" in style2) {
    style2 = style2.toJS();
  }
  if (!style2.layers) {
    return style2;
  }
  const layerIndex = {};
  for (const layer of style2.layers) {
    layerIndex[layer.id] = layer;
  }
  const layers = style2.layers.map((layer) => {
    const layerRef = layerIndex[layer.ref];
    let normalizedLayer = null;
    if ("interactive" in layer) {
      normalizedLayer = { ...layer };
      delete normalizedLayer.interactive;
    }
    if (layerRef) {
      normalizedLayer = normalizedLayer || { ...layer };
      delete normalizedLayer.ref;
      for (const propName of refProps) {
        if (propName in layerRef) {
          normalizedLayer[propName] = layerRef[propName];
        }
      }
    }
    return normalizedLayer || layer;
  });
  return { ...style2, layers };
}
function arePointsEqual(a, b) {
  const ax = Array.isArray(a) ? a[0] : a ? a.x : 0;
  const ay = Array.isArray(a) ? a[1] : a ? a.y : 0;
  const bx = Array.isArray(b) ? b[0] : b ? b.x : 0;
  const by = Array.isArray(b) ? b[1] : b ? b.y : 0;
  return ax === bx && ay === by;
}
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  if (Array.isArray(a)) {
    if (!Array.isArray(b) || a.length !== b.length) {
      return false;
    }
    for (let i = 0; i < a.length; i++) {
      if (!deepEqual(a[i], b[i])) {
        return false;
      }
    }
    return true;
  } else if (Array.isArray(b)) {
    return false;
  }
  if (typeof a === "object" && typeof b === "object") {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    if (aKeys.length !== bKeys.length) {
      return false;
    }
    for (const key of aKeys) {
      if (!b.hasOwnProperty(key)) {
        return false;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return false;
}
const pointerEvents = {
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  click: "onClick",
  dblclick: "onDblClick",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  mouseout: "onMouseOut",
  contextmenu: "onContextMenu",
  touchstart: "onTouchStart",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchcancel: "onTouchCancel"
};
const cameraEvents = {
  movestart: "onMoveStart",
  move: "onMove",
  moveend: "onMoveEnd",
  dragstart: "onDragStart",
  drag: "onDrag",
  dragend: "onDragEnd",
  zoomstart: "onZoomStart",
  zoom: "onZoom",
  zoomend: "onZoomEnd",
  rotatestart: "onRotateStart",
  rotate: "onRotate",
  rotateend: "onRotateEnd",
  pitchstart: "onPitchStart",
  pitch: "onPitch",
  pitchend: "onPitchEnd"
};
const otherEvents = {
  wheel: "onWheel",
  boxzoomstart: "onBoxZoomStart",
  boxzoomend: "onBoxZoomEnd",
  boxzoomcancel: "onBoxZoomCancel",
  resize: "onResize",
  load: "onLoad",
  render: "onRender",
  idle: "onIdle",
  remove: "onRemove",
  data: "onData",
  styledata: "onStyleData",
  sourcedata: "onSourceData",
  error: "onError"
};
const settingNames = [
  "minZoom",
  "maxZoom",
  "minPitch",
  "maxPitch",
  "maxBounds",
  "projection",
  "renderWorldCopies"
];
const handlerNames = [
  "scrollZoom",
  "boxZoom",
  "dragRotate",
  "dragPan",
  "keyboard",
  "doubleClickZoom",
  "touchZoomRotate",
  "touchPitch"
];
class Mapbox {
  constructor(MapClass, props, container) {
    this._map = null;
    this._internalUpdate = false;
    this._inRender = false;
    this._hoveredFeatures = null;
    this._deferredEvents = {
      move: false,
      zoom: false,
      pitch: false,
      rotate: false
    };
    this._onEvent = (e) => {
      const cb = this.props[otherEvents[e.type]];
      if (cb) {
        cb(e);
      }
    };
    this._onPointerEvent = (e) => {
      if (e.type === "mousemove" || e.type === "mouseout") {
        this._updateHover(e);
      }
      const cb = this.props[pointerEvents[e.type]];
      if (cb) {
        if (this.props.interactiveLayerIds && e.type !== "mouseover" && e.type !== "mouseout") {
          const features = this._hoveredFeatures || this._map.queryRenderedFeatures(e.point, {
            layers: this.props.interactiveLayerIds
          });
          e.features = features;
        }
        cb(e);
        delete e.features;
      }
    };
    this._onCameraEvent = (e) => {
      if (!this._internalUpdate) {
        const cb = this.props[cameraEvents[e.type]];
        if (cb) {
          cb(e);
        }
      }
      if (e.type in this._deferredEvents) {
        this._deferredEvents[e.type] = false;
      }
    };
    this._MapClass = MapClass;
    this.props = props;
    this._initialize(container);
  }
  get map() {
    return this._map;
  }
  get transform() {
    return this._renderTransform;
  }
  setProps(props) {
    const oldProps = this.props;
    this.props = props;
    const settingsChanged = this._updateSettings(props, oldProps);
    if (settingsChanged) {
      this._createShadowTransform(this._map);
    }
    const sizeChanged = this._updateSize(props);
    const viewStateChanged = this._updateViewState(props, true);
    this._updateStyle(props, oldProps);
    this._updateStyleComponents(props, oldProps);
    this._updateHandlers(props, oldProps);
    if (settingsChanged || sizeChanged || viewStateChanged && !this._map.isMoving()) {
      this.redraw();
    }
  }
  static reuse(props, container) {
    const that = Mapbox.savedMaps.pop();
    if (!that) {
      return null;
    }
    const map = that.map;
    const oldContainer = map.getContainer();
    container.className = oldContainer.className;
    while (oldContainer.childNodes.length > 0) {
      container.appendChild(oldContainer.childNodes[0]);
    }
    map._container = container;
    that.setProps({ ...props, styleDiffing: false });
    map.resize();
    const { initialViewState } = props;
    if (initialViewState) {
      if (initialViewState.bounds) {
        map.fitBounds(initialViewState.bounds, { ...initialViewState.fitBoundsOptions, duration: 0 });
      } else {
        that._updateViewState(initialViewState, false);
      }
    }
    if (map.isStyleLoaded()) {
      map.fire("load");
    } else {
      map.once("styledata", () => map.fire("load"));
    }
    return that;
  }
  /* eslint-disable complexity,max-statements */
  _initialize(container) {
    const { props } = this;
    const mapOptions = {
      ...props,
      ...props.initialViewState,
      accessToken: props.mapboxAccessToken || getAccessTokenFromEnv() || null,
      container,
      style: normalizeStyle(props.mapStyle)
    };
    const viewState = mapOptions.initialViewState || mapOptions.viewState || mapOptions;
    Object.assign(mapOptions, {
      center: [viewState.longitude || 0, viewState.latitude || 0],
      zoom: viewState.zoom || 0,
      pitch: viewState.pitch || 0,
      bearing: viewState.bearing || 0
    });
    if (props.gl) {
      const getContext = HTMLCanvasElement.prototype.getContext;
      HTMLCanvasElement.prototype.getContext = () => {
        HTMLCanvasElement.prototype.getContext = getContext;
        return props.gl;
      };
    }
    const map = new this._MapClass(mapOptions);
    if (viewState.padding) {
      map.setPadding(viewState.padding);
    }
    if (props.cursor) {
      map.getCanvas().style.cursor = props.cursor;
    }
    this._createShadowTransform(map);
    const renderMap = map._render;
    map._render = (arg) => {
      this._inRender = true;
      renderMap.call(map, arg);
      this._inRender = false;
    };
    const runRenderTaskQueue = map._renderTaskQueue.run;
    map._renderTaskQueue.run = (arg) => {
      runRenderTaskQueue.call(map._renderTaskQueue, arg);
      this._onBeforeRepaint();
    };
    map.on("render", () => this._onAfterRepaint());
    const fireEvent = map.fire;
    map.fire = this._fireEvent.bind(this, fireEvent);
    map.on("resize", () => {
      this._renderTransform.resize(map.transform.width, map.transform.height);
    });
    map.on("styledata", () => this._updateStyleComponents(this.props, {}));
    map.on("sourcedata", () => this._updateStyleComponents(this.props, {}));
    for (const eventName in pointerEvents) {
      map.on(eventName, this._onPointerEvent);
    }
    for (const eventName in cameraEvents) {
      map.on(eventName, this._onCameraEvent);
    }
    for (const eventName in otherEvents) {
      map.on(eventName, this._onEvent);
    }
    this._map = map;
  }
  /* eslint-enable complexity,max-statements */
  recycle() {
    const container = this.map.getContainer();
    const children = container.querySelector("[mapboxgl-children]");
    children === null || children === void 0 ? void 0 : children.remove();
    Mapbox.savedMaps.push(this);
  }
  destroy() {
    this._map.remove();
  }
  // Force redraw the map now. Typically resize() and jumpTo() is reflected in the next
  // render cycle, which is managed by Mapbox's animation loop.
  // This removes the synchronization issue caused by requestAnimationFrame.
  redraw() {
    const map = this._map;
    if (!this._inRender && map.style) {
      if (map._frame) {
        map._frame.cancel();
        map._frame = null;
      }
      map._render();
    }
  }
  _createShadowTransform(map) {
    const renderTransform = cloneTransform(map.transform);
    map.painter.transform = renderTransform;
    this._renderTransform = renderTransform;
  }
  /* Trigger map resize if size is controlled
     @param {object} nextProps
     @returns {bool} true if size has changed
   */
  _updateSize(nextProps) {
    const { viewState } = nextProps;
    if (viewState) {
      const map = this._map;
      if (viewState.width !== map.transform.width || viewState.height !== map.transform.height) {
        map.resize();
        return true;
      }
    }
    return false;
  }
  // Adapted from map.jumpTo
  /* Update camera to match props
     @param {object} nextProps
     @param {bool} triggerEvents - should fire camera events
     @returns {bool} true if anything is changed
   */
  _updateViewState(nextProps, triggerEvents) {
    if (this._internalUpdate) {
      return false;
    }
    const map = this._map;
    const tr = this._renderTransform;
    const { zoom, pitch, bearing } = tr;
    const isMoving = map.isMoving();
    if (isMoving) {
      tr.cameraElevationReference = "sea";
    }
    const changed = applyViewStateToTransform(tr, {
      ...transformToViewState(map.transform),
      ...nextProps
    });
    if (isMoving) {
      tr.cameraElevationReference = "ground";
    }
    if (changed && triggerEvents) {
      const deferredEvents = this._deferredEvents;
      deferredEvents.move = true;
      deferredEvents.zoom || (deferredEvents.zoom = zoom !== tr.zoom);
      deferredEvents.rotate || (deferredEvents.rotate = bearing !== tr.bearing);
      deferredEvents.pitch || (deferredEvents.pitch = pitch !== tr.pitch);
    }
    if (!isMoving) {
      applyViewStateToTransform(map.transform, nextProps);
    }
    return changed;
  }
  /* Update camera constraints and projection settings to match props
     @param {object} nextProps
     @param {object} currProps
     @returns {bool} true if anything is changed
   */
  _updateSettings(nextProps, currProps) {
    const map = this._map;
    let changed = false;
    for (const propName of settingNames) {
      if (propName in nextProps && !deepEqual(nextProps[propName], currProps[propName])) {
        changed = true;
        map[`set${propName[0].toUpperCase()}${propName.slice(1)}`](nextProps[propName]);
      }
    }
    return changed;
  }
  /* Update map style to match props
     @param {object} nextProps
     @param {object} currProps
     @returns {bool} true if style is changed
   */
  _updateStyle(nextProps, currProps) {
    if (nextProps.cursor !== currProps.cursor) {
      this._map.getCanvas().style.cursor = nextProps.cursor;
    }
    if (nextProps.mapStyle !== currProps.mapStyle) {
      const options2 = {
        diff: nextProps.styleDiffing
      };
      if ("localIdeographFontFamily" in nextProps) {
        options2.localIdeographFontFamily = nextProps.localIdeographFontFamily;
      }
      this._map.setStyle(normalizeStyle(nextProps.mapStyle), options2);
      return true;
    }
    return false;
  }
  /* Update fog, light and terrain to match props
     @param {object} nextProps
     @param {object} currProps
     @returns {bool} true if anything is changed
   */
  _updateStyleComponents(nextProps, currProps) {
    const map = this._map;
    let changed = false;
    if (map.style.loaded()) {
      if ("light" in nextProps && !deepEqual(nextProps.light, currProps.light)) {
        changed = true;
        map.setLight(nextProps.light);
      }
      if ("fog" in nextProps && !deepEqual(nextProps.fog, currProps.fog)) {
        changed = true;
        map.setFog(nextProps.fog);
      }
      if ("terrain" in nextProps && !deepEqual(nextProps.terrain, currProps.terrain)) {
        if (!nextProps.terrain || map.getSource(nextProps.terrain.source)) {
          changed = true;
          map.setTerrain(nextProps.terrain);
        }
      }
    }
    return changed;
  }
  /* Update interaction handlers to match props
     @param {object} nextProps
     @param {object} currProps
     @returns {bool} true if anything is changed
   */
  _updateHandlers(nextProps, currProps) {
    const map = this._map;
    let changed = false;
    for (const propName of handlerNames) {
      const newValue = nextProps[propName];
      if (!deepEqual(newValue, currProps[propName])) {
        changed = true;
        if (newValue) {
          map[propName].enable(newValue);
        } else {
          map[propName].disable();
        }
      }
    }
    return changed;
  }
  _updateHover(e) {
    var _a;
    const { props } = this;
    const shouldTrackHoveredFeatures = props.interactiveLayerIds && (props.onMouseMove || props.onMouseEnter || props.onMouseLeave);
    if (shouldTrackHoveredFeatures) {
      const eventType = e.type;
      const wasHovering = ((_a = this._hoveredFeatures) === null || _a === void 0 ? void 0 : _a.length) > 0;
      let features;
      if (eventType === "mousemove") {
        try {
          features = this._map.queryRenderedFeatures(e.point, {
            layers: props.interactiveLayerIds
          });
        } catch (_b) {
          features = [];
        }
      } else {
        features = [];
      }
      const isHovering = features.length > 0;
      if (!isHovering && wasHovering) {
        e.type = "mouseleave";
        this._onPointerEvent(e);
      }
      this._hoveredFeatures = features;
      if (isHovering && !wasHovering) {
        e.type = "mouseenter";
        this._onPointerEvent(e);
      }
      e.type = eventType;
    } else {
      this._hoveredFeatures = null;
    }
  }
  _fireEvent(baseFire, event, properties) {
    const map = this._map;
    const tr = map.transform;
    const eventType = typeof event === "string" ? event : event.type;
    if (eventType === "move") {
      this._updateViewState(this.props, false);
    }
    if (eventType in cameraEvents) {
      if (typeof event === "object") {
        event.viewState = transformToViewState(tr);
      }
      if (this._map.isMoving()) {
        map.transform = this._renderTransform;
        baseFire.call(map, event, properties);
        map.transform = tr;
        return map;
      }
    }
    baseFire.call(map, event, properties);
    return map;
  }
  // All camera manipulations are complete, ready to repaint
  _onBeforeRepaint() {
    const map = this._map;
    this._internalUpdate = true;
    for (const eventType in this._deferredEvents) {
      if (this._deferredEvents[eventType]) {
        map.fire(eventType);
      }
    }
    this._internalUpdate = false;
    const tr = this._map.transform;
    this._map.transform = this._renderTransform;
    this._onAfterRepaint = () => {
      this._map.transform = tr;
    };
  }
}
Mapbox.savedMaps = [];
function getAccessTokenFromEnv() {
  let accessToken = null;
  if (typeof location !== "undefined") {
    const match = /access_token=([^&\/]*)/.exec(location.search);
    accessToken = match && match[1];
  }
  try {
    accessToken = accessToken || process.env.MapboxAccessToken;
  } catch (_a) {
  }
  try {
    accessToken = accessToken || process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
  } catch (_b) {
  }
  return accessToken;
}
const skipMethods = [
  "setMaxBounds",
  "setMinZoom",
  "setMaxZoom",
  "setMinPitch",
  "setMaxPitch",
  "setRenderWorldCopies",
  "setProjection",
  "setStyle",
  "addSource",
  "removeSource",
  "addLayer",
  "removeLayer",
  "setLayerZoomRange",
  "setFilter",
  "setPaintProperty",
  "setLayoutProperty",
  "setLight",
  "setTerrain",
  "setFog",
  "remove"
];
function createRef(mapInstance, mapLib) {
  if (!mapInstance) {
    return null;
  }
  const map = mapInstance.map;
  const result = {
    getMap: () => map,
    // Overwrite getters to use our shadow transform
    getCenter: () => mapInstance.transform.center,
    getZoom: () => mapInstance.transform.zoom,
    getBearing: () => mapInstance.transform.bearing,
    getPitch: () => mapInstance.transform.pitch,
    getPadding: () => mapInstance.transform.padding,
    getBounds: () => mapInstance.transform.getBounds(),
    project: (lnglat) => {
      return mapInstance.transform.locationPoint(mapLib.LngLat.convert(lnglat));
    },
    unproject: (point) => {
      return mapInstance.transform.pointLocation(mapLib.Point.convert(point));
    },
    queryTerrainElevation: (lnglat, options2) => {
      const tr = map.transform;
      map.transform = mapInstance.transform;
      const result2 = map.queryTerrainElevation(lnglat, options2);
      map.transform = tr;
      return result2;
    }
  };
  for (const key of getMethodNames(map)) {
    if (!(key in result) && !skipMethods.includes(key)) {
      result[key] = map[key].bind(map);
    }
  }
  return result;
}
function getMethodNames(obj) {
  const result = /* @__PURE__ */ new Set();
  let proto = obj;
  while (proto) {
    for (const key of Object.getOwnPropertyNames(proto)) {
      if (key[0] !== "_" && typeof obj[key] === "function" && key !== "fire" && key !== "setEventedParent") {
        result.add(key);
      }
    }
    proto = Object.getPrototypeOf(proto);
  }
  return Array.from(result);
}
const useIsomorphicLayoutEffect$2 = typeof document !== "undefined" ? useLayoutEffect : useEffect;
const globalSettings = [
  "baseApiUrl",
  "maxParallelImageRequests",
  "workerClass",
  "workerCount",
  "workerUrl"
];
function setGlobals(mapLib, props) {
  for (const key of globalSettings) {
    if (key in props) {
      mapLib[key] = props[key];
    }
  }
  if (props.RTLTextPlugin && mapLib.getRTLTextPluginStatus && mapLib.getRTLTextPluginStatus() === "unavailable") {
    mapLib.setRTLTextPlugin(props.RTLTextPlugin, (error) => {
      if (error) {
        console.error(error);
      }
    }, false);
  }
}
const MapContext = React.createContext(null);
const defaultProps$2 = {
  // Constraints
  minZoom: 0,
  maxZoom: 22,
  minPitch: 0,
  maxPitch: 60,
  // Interaction handlers
  scrollZoom: true,
  boxZoom: true,
  dragRotate: true,
  dragPan: true,
  keyboard: true,
  doubleClickZoom: true,
  touchZoomRotate: true,
  touchPitch: true,
  // Style
  mapStyle: {
    version: 8,
    sources: {},
    layers: []
  },
  styleDiffing: true,
  projection: "mercator",
  renderWorldCopies: true,
  // Callbacks
  onError: (e) => console.error(e.error),
  // Globals
  RTLTextPlugin: "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js"
};
const Map$2 = forwardRef((props, ref) => {
  const mountedMapsContext = useContext(MountedMapsContext);
  const [mapInstance, setMapInstance] = useState(null);
  const containerRef = useRef();
  const {
    current: contextValue
  } = useRef({
    mapLib: null,
    map: null
  });
  useEffect(() => {
    const mapLib = props.mapLib;
    let isMounted = true;
    let mapbox;
    Promise.resolve(mapLib || import("mapbox-gl")).then((mapboxgl) => {
      if (!isMounted) {
        return;
      }
      if (!mapboxgl.Map) {
        mapboxgl = mapboxgl.default;
      }
      if (!mapboxgl || !mapboxgl.Map) {
        throw new Error("Invalid mapLib");
      }
      if (mapboxgl.supported(props)) {
        setGlobals(mapboxgl, props);
        if (props.reuseMaps) {
          mapbox = Mapbox.reuse(props, containerRef.current);
        }
        if (!mapbox) {
          mapbox = new Mapbox(mapboxgl.Map, props, containerRef.current);
        }
        contextValue.map = createRef(mapbox, mapboxgl);
        contextValue.mapLib = mapboxgl;
        setMapInstance(mapbox);
        mountedMapsContext === null || mountedMapsContext === void 0 ? void 0 : mountedMapsContext.onMapMount(contextValue.map, props.id);
      } else {
        throw new Error("Map is not supported by this browser");
      }
    }).catch((error) => {
      props.onError({
        type: "error",
        target: null,
        originalEvent: null,
        error
      });
    });
    return () => {
      isMounted = false;
      if (mapbox) {
        mountedMapsContext === null || mountedMapsContext === void 0 ? void 0 : mountedMapsContext.onMapUnmount(props.id);
        if (props.reuseMaps) {
          mapbox.recycle();
        } else {
          mapbox.destroy();
        }
      }
    };
  }, []);
  useIsomorphicLayoutEffect$2(() => {
    if (mapInstance) {
      mapInstance.setProps(props);
    }
  });
  useImperativeHandle(ref, () => contextValue.map, [mapInstance]);
  const style2 = useMemo(() => ({
    position: "relative",
    width: "100%",
    height: "100%",
    ...props.style
  }), [props.style]);
  return /* @__PURE__ */ jsx("div", {
    id: props.id,
    ref: containerRef,
    style: style2,
    children: mapInstance && /* @__PURE__ */ jsx(MapContext.Provider, {
      value: contextValue,
      children: /* @__PURE__ */ jsx("div", {
        "mapboxgl-children": "",
        children: props.children
      })
    })
  });
});
Map$2.displayName = "Map";
Map$2.defaultProps = defaultProps$2;
const unitlessNumber = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/;
function applyReactStyle(element, styles2) {
  if (!element || !styles2) {
    return;
  }
  const style2 = element.style;
  for (const key in styles2) {
    const value = styles2[key];
    if (Number.isFinite(value) && !unitlessNumber.test(key)) {
      style2[key] = `${value}px`;
    } else {
      style2[key] = value;
    }
  }
}
const defaultProps$1 = {
  draggable: false,
  popup: null,
  rotation: 0,
  rotationAlignment: "auto",
  pitchAlignment: "auto"
};
function Marker(props) {
  const { map, mapLib } = useContext(MapContext);
  const thisRef = useRef({ props });
  thisRef.current.props = props;
  const marker = useMemo(() => {
    let hasChildren = false;
    React.Children.forEach(props.children, (el) => {
      if (el) {
        hasChildren = true;
      }
    });
    const options2 = {
      ...props,
      element: hasChildren ? document.createElement("div") : null
    };
    const mk = new mapLib.Marker(options2).setLngLat([props.longitude, props.latitude]);
    mk.getElement().addEventListener("click", (e) => {
      var _a, _b;
      (_b = (_a = thisRef.current.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, {
        type: "click",
        target: mk,
        originalEvent: e
      });
    });
    mk.on("dragstart", (e) => {
      var _a, _b;
      const evt = e;
      evt.lngLat = marker.getLngLat();
      (_b = (_a = thisRef.current.props).onDragStart) === null || _b === void 0 ? void 0 : _b.call(_a, evt);
    });
    mk.on("drag", (e) => {
      var _a, _b;
      const evt = e;
      evt.lngLat = marker.getLngLat();
      (_b = (_a = thisRef.current.props).onDrag) === null || _b === void 0 ? void 0 : _b.call(_a, evt);
    });
    mk.on("dragend", (e) => {
      var _a, _b;
      const evt = e;
      evt.lngLat = marker.getLngLat();
      (_b = (_a = thisRef.current.props).onDragEnd) === null || _b === void 0 ? void 0 : _b.call(_a, evt);
    });
    return mk;
  }, []);
  useEffect(() => {
    marker.addTo(map.getMap());
    return () => {
      marker.remove();
    };
  }, []);
  useEffect(() => {
    applyReactStyle(marker.getElement(), props.style);
  }, [props.style]);
  if (marker.getLngLat().lng !== props.longitude || marker.getLngLat().lat !== props.latitude) {
    marker.setLngLat([props.longitude, props.latitude]);
  }
  if (props.offset && !arePointsEqual(marker.getOffset(), props.offset)) {
    marker.setOffset(props.offset);
  }
  if (marker.isDraggable() !== props.draggable) {
    marker.setDraggable(props.draggable);
  }
  if (marker.getRotation() !== props.rotation) {
    marker.setRotation(props.rotation);
  }
  if (marker.getRotationAlignment() !== props.rotationAlignment) {
    marker.setRotationAlignment(props.rotationAlignment);
  }
  if (marker.getPitchAlignment() !== props.pitchAlignment) {
    marker.setPitchAlignment(props.pitchAlignment);
  }
  if (marker.getPopup() !== props.popup) {
    marker.setPopup(props.popup);
  }
  return createPortal(props.children, marker.getElement());
}
Marker.defaultProps = defaultProps$1;
const Marker$1 = React.memo(Marker);
function getClassList(className) {
  return new Set(className ? className.trim().split(/\s+/) : []);
}
function Popup(props) {
  const { map, mapLib } = useContext(MapContext);
  const container = useMemo(() => {
    return document.createElement("div");
  }, []);
  const thisRef = useRef({ props });
  thisRef.current.props = props;
  const popup = useMemo(() => {
    const options2 = { ...props };
    const pp = new mapLib.Popup(options2).setLngLat([props.longitude, props.latitude]);
    pp.once("open", (e) => {
      var _a, _b;
      (_b = (_a = thisRef.current.props).onOpen) === null || _b === void 0 ? void 0 : _b.call(_a, e);
    });
    return pp;
  }, []);
  useEffect(() => {
    const onClose = (e) => {
      var _a, _b;
      (_b = (_a = thisRef.current.props).onClose) === null || _b === void 0 ? void 0 : _b.call(_a, e);
    };
    popup.on("close", onClose);
    popup.setDOMContent(container).addTo(map.getMap());
    return () => {
      popup.off("close", onClose);
      if (popup.isOpen()) {
        popup.remove();
      }
    };
  }, []);
  useEffect(() => {
    applyReactStyle(popup.getElement(), props.style);
  }, [props.style]);
  if (popup.isOpen()) {
    if (popup.getLngLat().lng !== props.longitude || popup.getLngLat().lat !== props.latitude) {
      popup.setLngLat([props.longitude, props.latitude]);
    }
    if (props.offset && !deepEqual(popup.options.offset, props.offset)) {
      popup.setOffset(props.offset);
    }
    if (popup.options.anchor !== props.anchor || popup.options.maxWidth !== props.maxWidth) {
      popup.options.anchor = props.anchor;
      popup.setMaxWidth(props.maxWidth);
    }
    if (popup.options.className !== props.className) {
      const prevClassList = getClassList(popup.options.className);
      const nextClassList = getClassList(props.className);
      for (const c of prevClassList) {
        if (!nextClassList.has(c)) {
          popup.removeClassName(c);
        }
      }
      for (const c of nextClassList) {
        if (!prevClassList.has(c)) {
          popup.addClassName(c);
        }
      }
      popup.options.className = props.className;
    }
  }
  return createPortal(props.children, container);
}
React.memo(Popup);
function useControl(onCreate, arg1, arg2, arg3) {
  const context = useContext(MapContext);
  const ctrl = useMemo(() => onCreate(context), []);
  useEffect(() => {
    const opts = arg1;
    const onAdd = typeof arg1 === "function" && false ? arg1 : null;
    const onRemove = typeof arg1 === "function" ? arg1 : null;
    const { map } = context;
    if (!map.hasControl(ctrl)) {
      map.addControl(ctrl, opts === null || opts === void 0 ? void 0 : opts.position);
      if (onAdd) {
        onAdd(context);
      }
    }
    return () => {
      if (onRemove) {
        onRemove(context);
      }
      if (map.hasControl(ctrl)) {
        map.removeControl(ctrl);
      }
    };
  }, []);
  return ctrl;
}
function AttributionControl(props) {
  const ctrl = useControl(({ mapLib }) => new mapLib.AttributionControl(props), {
    position: props.position
  });
  useEffect(() => {
    applyReactStyle(ctrl._container, props.style);
  }, [props.style]);
  return null;
}
React.memo(AttributionControl);
function FullscreenControl(props) {
  const ctrl = useControl(({ mapLib }) => new mapLib.FullscreenControl({
    container: props.containerId && document.getElementById(props.containerId)
  }), { position: props.position });
  useEffect(() => {
    applyReactStyle(ctrl._controlContainer, props.style);
  }, [props.style]);
  return null;
}
React.memo(FullscreenControl);
const GeolocateControl = forwardRef((props, ref) => {
  const thisRef = useRef({ props });
  const ctrl = useControl(({ mapLib }) => {
    const gc = new mapLib.GeolocateControl(props);
    const setupUI = gc._setupUI;
    gc._setupUI = (args) => {
      if (!gc._container.hasChildNodes()) {
        setupUI(args);
      }
    };
    gc.on("geolocate", (e) => {
      var _a, _b;
      (_b = (_a = thisRef.current.props).onGeolocate) === null || _b === void 0 ? void 0 : _b.call(_a, e);
    });
    gc.on("error", (e) => {
      var _a, _b;
      (_b = (_a = thisRef.current.props).onError) === null || _b === void 0 ? void 0 : _b.call(_a, e);
    });
    gc.on("outofmaxbounds", (e) => {
      var _a, _b;
      (_b = (_a = thisRef.current.props).onOutOfMaxBounds) === null || _b === void 0 ? void 0 : _b.call(_a, e);
    });
    gc.on("trackuserlocationstart", (e) => {
      var _a, _b;
      (_b = (_a = thisRef.current.props).onTrackUserLocationStart) === null || _b === void 0 ? void 0 : _b.call(_a, e);
    });
    gc.on("trackuserlocationend", (e) => {
      var _a, _b;
      (_b = (_a = thisRef.current.props).onTrackUserLocationEnd) === null || _b === void 0 ? void 0 : _b.call(_a, e);
    });
    return gc;
  }, { position: props.position });
  thisRef.current.props = props;
  useImperativeHandle(ref, () => ({
    trigger: () => ctrl.trigger()
  }), []);
  useEffect(() => {
    applyReactStyle(ctrl._container, props.style);
  }, [props.style]);
  return null;
});
GeolocateControl.displayName = "GeolocateControl";
React.memo(GeolocateControl);
function NavigationControl(props) {
  const ctrl = useControl(({ mapLib }) => new mapLib.NavigationControl(props), {
    position: props.position
  });
  useEffect(() => {
    applyReactStyle(ctrl._container, props.style);
  }, [props.style]);
  return null;
}
React.memo(NavigationControl);
const defaultProps = {
  unit: "metric",
  maxWidth: 100
};
function ScaleControl(props) {
  const ctrl = useControl(({ mapLib }) => new mapLib.ScaleControl(props), {
    position: props.position
  });
  if (ctrl.options.unit !== props.unit || ctrl.options.maxWidth !== props.maxWidth) {
    ctrl.options.maxWidth = props.maxWidth;
    ctrl.setUnit(props.unit);
  }
  useEffect(() => {
    applyReactStyle(ctrl._container, props.style);
  }, [props.style]);
  return null;
}
ScaleControl.defaultProps = defaultProps;
React.memo(ScaleControl);
const SvgCanMarkerJungle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 28, height: 38, viewBox: "0 0 28 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M28 14.0337C28 20.4219 19.4688 31.7951 15.7281 36.4876C14.8313 37.6059 13.1687 37.6059 12.2719 36.4876C8.46558 31.7951 0 20.4219 0 14.0337C0 6.28299 6.26791 0 14 0C21.7292 0 28 6.28299 28 14.0337Z", fill: "#087A6F" }), /* @__PURE__ */ React.createElement("path", { d: "M18.7773 8.93265C18.759 9.13859 18.7222 9.34816 18.6563 9.55048C18.0915 11.2412 15.7959 11.9709 15.7922 11.9709C15.7922 11.9709 17.5524 12.549 18.682 11.7542C19.8115 10.9595 19.8812 9.0952 19.8812 9.0952C19.8812 9.0952 19.397 8.96153 18.7773 8.93265Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M16.8849 9.36621C17.4423 8.97607 18.1722 8.9038 18.7773 8.93268C18.9055 7.40453 17.831 5.84738 17.831 5.84738C17.831 5.84738 15.4658 6.71443 14.9009 8.40525C14.3362 10.096 15.7884 11.971 15.7884 11.971C15.7921 11.9674 15.7591 10.161 16.8849 9.36621Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M18.6526 9.54687C18.7186 9.34455 18.7589 9.13861 18.7737 8.92904C18.1722 8.90015 17.4387 8.97242 16.8813 9.36256C15.7518 10.1573 15.7848 11.9638 15.7848 11.9673C15.7958 11.9673 18.0915 11.2376 18.6526 9.54687Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M17.9777 12.8128H15.0183V12.6286C15.0183 12.3793 14.7836 12.1733 14.4976 12.1733H12.6089C12.3229 12.1733 12.0882 12.3793 12.0882 12.6286V12.8128H8.89042C8.50169 12.8128 8.18628 13.2102 8.18628 13.6943V14.5759H18.6818V13.6943C18.6818 13.2102 18.3664 12.8128 17.9777 12.8128Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M16.0415 21.2125C16.0415 22.3071 15.1357 23.1994 14.0246 23.1994H12.84C11.7289 23.1994 10.823 22.3071 10.823 21.2125V15.3851H8.25604V21.2125C8.25604 23.7016 10.3133 25.7284 12.84 25.7284H14.0246C16.5512 25.7284 18.6086 23.7016 18.6086 21.2125V15.3851H16.0415V21.2125Z", fill: "white" }));
const SvgCanMarkerLobster = (props) => /* @__PURE__ */ React.createElement("svg", { width: 28, height: 38, viewBox: "0 0 28 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M28 14.0337C28 20.4219 19.4688 31.7951 15.7281 36.4876C14.8313 37.6059 13.1687 37.6059 12.2719 36.4876C8.46558 31.7951 0 20.4219 0 14.0337C0 6.28299 6.26791 0 14 0C21.7292 0 28 6.28299 28 14.0337Z", fill: "#FB551C" }), /* @__PURE__ */ React.createElement("path", { d: "M18.7773 8.93265C18.759 9.13859 18.7222 9.34816 18.6563 9.55048C18.0915 11.2412 15.7959 11.9709 15.7922 11.9709C15.7922 11.9709 17.5524 12.549 18.682 11.7542C19.8115 10.9595 19.8812 9.0952 19.8812 9.0952C19.8812 9.0952 19.397 8.96153 18.7773 8.93265Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M16.8849 9.36621C17.4423 8.97607 18.1722 8.9038 18.7773 8.93268C18.9055 7.40453 17.831 5.84738 17.831 5.84738C17.831 5.84738 15.4658 6.71443 14.9009 8.40525C14.3362 10.096 15.7884 11.971 15.7884 11.971C15.7921 11.9674 15.7591 10.161 16.8849 9.36621Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M18.6526 9.54687C18.7186 9.34455 18.7589 9.13861 18.7737 8.92904C18.1722 8.90015 17.4387 8.97242 16.8813 9.36256C15.7518 10.1573 15.7848 11.9638 15.7848 11.9673C15.7958 11.9673 18.0915 11.2376 18.6526 9.54687Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M17.9777 12.8128H15.0183V12.6286C15.0183 12.3793 14.7836 12.1733 14.4976 12.1733H12.6089C12.3229 12.1733 12.0882 12.3793 12.0882 12.6286V12.8128H8.89042C8.50169 12.8128 8.18628 13.2102 8.18628 13.6943V14.5759H18.6818V13.6943C18.6818 13.2102 18.3664 12.8128 17.9777 12.8128Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M16.0415 21.2125C16.0415 22.3071 15.1357 23.1994 14.0246 23.1994H12.84C11.7289 23.1994 10.823 22.3071 10.823 21.2125V15.3851H8.25604V21.2125C8.25604 23.7016 10.3133 25.7284 12.84 25.7284H14.0246C16.5512 25.7284 18.6086 23.7016 18.6086 21.2125V15.3851H16.0415V21.2125Z", fill: "white" }));
const SvgLeafMarkerDefault = (props) => /* @__PURE__ */ React.createElement("svg", { width: 28, height: 38, viewBox: "0 0 28 38", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M28 14.0337C28 20.4219 19.4688 31.7951 15.7281 36.4876C14.8313 37.6059 13.1687 37.6059 12.2719 36.4876C8.46558 31.7951 0 20.4219 0 14.0337C0 6.283 6.26791 0 14 0C21.7292 0 28 6.283 28 14.0337Z", fill: "#00283F" }), /* @__PURE__ */ React.createElement("path", { d: "M18.6246 13.4957C18.5661 14.1623 18.4492 14.8406 18.2387 15.4955C16.4377 20.9687 9.1168 23.331 9.1051 23.331C9.1051 23.331 14.7186 25.2022 18.3206 22.6293C21.9225 20.0565 22.1447 14.022 22.1447 14.022C22.1447 14.022 20.601 13.5893 18.6246 13.4957Z", fill: "#42EDBF" }), /* @__PURE__ */ React.createElement("path", { d: "M12.5901 14.8991C14.3677 13.6361 16.695 13.4022 18.6246 13.4957C19.0339 8.54885 15.6074 3.50842 15.6074 3.50842C15.6074 3.50842 8.06425 6.31516 6.26326 11.7883C4.46227 17.2614 9.09339 23.331 9.09339 23.331C9.10508 23.3193 8.99983 17.4719 12.5901 14.8991Z", fill: "#B0E55C" }), /* @__PURE__ */ React.createElement("path", { d: "M18.2388 15.4839C18.4493 14.829 18.5779 14.1624 18.6247 13.4841C16.7068 13.3905 14.3678 13.6244 12.5902 14.8874C8.98827 17.4603 9.09352 23.3076 9.09352 23.3193C9.11691 23.3193 16.4378 20.957 18.2388 15.4839Z", fill: "#0D8720" }));
const pinIcons = {
  DEFAULT: /* @__PURE__ */ jsx(SvgLeafMarkerDefault, {
    className: "drop-shadow-light"
  }),
  CAN_JUNGLE: /* @__PURE__ */ jsx(SvgCanMarkerJungle, {
    className: "drop-shadow-light"
  }),
  CAN_LOBSTER: /* @__PURE__ */ jsx(SvgCanMarkerLobster, {
    className: "drop-shadow-light"
  })
};
const getBoundingBox = (locations) => {
  const longs = locations.map((l) => l.long);
  const lats = locations.map((l) => l.lat);
  const lowestLng = Math.min(...longs);
  const lowestLat = Math.min(...lats);
  const highestLng = Math.max(...longs);
  const highestLat = Math.max(...lats);
  return new LngLatBounds(new LngLat(lowestLng, lowestLat), new LngLat(highestLng, highestLat));
};
const Map$1 = ({
  interactive = false,
  mapState = {
    zoom: 16
  },
  ...props
}) => {
  const {
    mapbox_token,
    locations
  } = props;
  const markers = useMemo(() => {
    return locations == null ? void 0 : locations.map((location2, idx) => {
      return /* @__PURE__ */ jsx(Marker$1, {
        latitude: location2.lat,
        longitude: location2.long,
        anchor: "center",
        children: pinIcons[location2.icon || "DEFAULT"]
      }, idx);
    });
  }, [locations]);
  const viewState = useMemo(() => {
    if (locations && (locations == null ? void 0 : locations.length) > 1) {
      const bounds = getBoundingBox(locations);
      return {
        bounds,
        fitBoundsOptions: {
          padding: {
            top: 75,
            bottom: 30,
            left: 90,
            right: 90
          }
        }
      };
    } else {
      return {
        latitude: locations && locations[0].lat,
        longitude: locations && locations[0].long,
        ...mapState
      };
    }
  }, [mapState, locations]);
  return /* @__PURE__ */ jsx(Map$2, {
    mapboxAccessToken: mapbox_token,
    initialViewState: viewState,
    style: {
      width: "100%",
      height: "400px"
    },
    interactive,
    mapStyle: "mapbox://styles/mapbox/streets-v9",
    attributionControl: false,
    reuseMaps: true,
    cooperativeGestures: true,
    children: markers
  });
};
const classNames = {
  overlay: {
    base: "bg-black/45 z-50",
    centered: "grid place-items-center",
    nonCentered: "flex justify-center items-start"
  },
  container: {
    base: "divide-y divide-gray-300"
  },
  modal: {
    base: "modal relative rounded-lg shadow-dark bg-white border-white",
    nonCentered: "top-25"
  },
  close: {
    base: "modal-close absolute right-1 h-13.5 grid place-items-center cursor-pointer"
  },
  closeIcon: {
    base: "modal-close-icon w-16 h-8 leading-13"
  },
  title: {
    base: "modal-title py-4 px-6 font-medium text-lg leading-5.5"
  },
  body: {
    base: "modal-body p-6 text-base max-w-[calc(80vw)]",
    centered: "max-h-[calc(70vh)] overflow-y-auto modal-body-centered"
  },
  footer: {
    base: "modal-footer py-2.5 px-4 text-base text-right gap-x-2"
  }
};
const Modal = (props) => {
  const {
    children,
    title,
    footer,
    centered = true,
    initialFocus = 0,
    visible = false,
    closable = true,
    closeOnClickOutside = true,
    onCancel,
    classNames: userClassNames
  } = props;
  const {
    refs,
    context
  } = useFloating({
    open: visible,
    onOpenChange: () => {
      onCancel == null ? void 0 : onCancel();
    }
  });
  const click = useClick(context);
  const role = useRole(context);
  const dismiss = useDismiss(context, {
    enabled: closeOnClickOutside,
    outsidePressEvent: "mousedown"
  });
  const {
    getFloatingProps
  } = useInteractions([click, role, dismiss]);
  const getClassNames = (element) => {
    const elementClassNames = classNames[element];
    const baseClassNames = elementClassNames == null ? void 0 : elementClassNames.base;
    const centeredClass = centered ? elementClassNames == null ? void 0 : elementClassNames.centered : elementClassNames == null ? void 0 : elementClassNames.nonCentered;
    const userClassName = (userClassNames == null ? void 0 : userClassNames[element]) ?? "";
    return mergeStyles([baseClassNames, centeredClass, userClassName]);
  };
  return /* @__PURE__ */ jsx(Fragment, {
    children: visible === true ? /* @__PURE__ */ jsx(FloatingPortal, {
      root: portalElement(),
      children: /* @__PURE__ */ jsx(FloatingOverlay, {
        className: getClassNames("overlay"),
        lockScroll: true,
        children: /* @__PURE__ */ jsx(FloatingFocusManager, {
          context,
          initialFocus,
          children: /* @__PURE__ */ jsxs("div", {
            ref: refs.setFloating,
            ...getFloatingProps(),
            className: getClassNames("modal"),
            children: [closable && /* @__PURE__ */ jsx("div", {
              className: getClassNames("close"),
              children: /* @__PURE__ */ jsx(SvgXmark, {
                className: getClassNames("closeIcon"),
                onClick: onCancel
              })
            }), /* @__PURE__ */ jsxs("div", {
              className: getClassNames("container"),
              children: [title && /* @__PURE__ */ jsx("div", {
                className: getClassNames("title"),
                children: title
              }), /* @__PURE__ */ jsx("div", {
                className: getClassNames("body"),
                children
              }), footer && /* @__PURE__ */ jsx("div", {
                className: getClassNames("footer"),
                children: footer
              })]
            })]
          })
        })
      })
    }) : void 0
  });
};
const style$2 = {
  container: "flex flex-col shadow rounded overflow-hidden inline-block relative"
};
const MultiSelect = (props) => {
  const {
    options: options2,
    onSelected,
    selected,
    width
  } = props;
  const menuItems = useMemo(() => {
    return options2.map((option) => {
      const isSelected = selected.some((s) => s.value === option.value);
      return {
        ...option,
        isSelected
      };
    });
  }, [options2, selected]);
  return /* @__PURE__ */ jsx("div", {
    className: style$2.container,
    style: {
      width,
      maxWidth: width
    },
    children: menuItems.map((item) => {
      return /* @__PURE__ */ jsx(ComboBoxMenuItem, {
        item,
        onSelect: onSelected,
        isSelected: item.isSelected
      }, item.value);
    })
  });
};
const MultiSelectDropdown = (props) => {
  const {
    options: options2,
    onChange,
    value,
    width = "352px",
    isOpen = false,
    selected: defaultSelected = [],
    ...rest
  } = props;
  const [selected, setSelected] = useState(defaultSelected);
  const handleSelect = useCallback((selection) => {
    const newSelected = [...selected];
    const index2 = newSelected.findIndex((s) => {
      return s.value === selection.value;
    });
    if (index2 === -1) newSelected.push({
      label: selection.label,
      value: selection.value
    });
    else newSelected.splice(index2, 1);
    if (onChange) onChange([...newSelected]);
    setSelected(newSelected);
  }, [onChange, selected]);
  const onClearSelection = useCallback(() => {
    setSelected([]);
    if (onChange) onChange([]);
  }, [onChange]);
  const numberSelected = useMemo(() => {
    return selected.length;
  }, [selected]);
  const firstSelection = useMemo(() => {
    if (selected.length === 0) return;
    return [...selected.values()][0].label;
  }, [selected]);
  return /* @__PURE__ */ jsx(FilterChip, {
    menuContent: /* @__PURE__ */ jsx(MultiSelect, {
      options: options2,
      selected,
      onSelected: handleSelect,
      width
    }),
    numberSelected,
    onClearSelection,
    value,
    firstSelection,
    width,
    isOpen,
    ...rest
  });
};
const NumberRange = (props) => {
  const {
    label,
    defaultMin,
    defaultMax,
    onChange
  } = props;
  const [min2, setMin] = useState(0);
  const [max2, setMax] = useState(0);
  const onMinChange = (e) => {
    const newMin = Number(e.target.value);
    setMin(newMin);
    onChange(newMin, max2);
  };
  const onMaxChange = (e) => {
    const newMax = Number(e.target.value);
    setMax(newMax);
    onChange(min2, newMax);
  };
  return /* @__PURE__ */ jsxs("div", {
    children: [label && /* @__PURE__ */ jsx("label", {
      className: "mb-1 inline-block",
      children: label
    }), /* @__PURE__ */ jsxs("div", {
      className: "flex flex-row",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "w-36",
        children: [/* @__PURE__ */ jsx("label", {
          htmlFor: "min",
          className: "display-none"
        }), /* @__PURE__ */ jsx(Input$1, {
          name: "min",
          placeholder: "Minimum",
          type: "number",
          defaultValue: defaultMin,
          onChange: onMinChange
        })]
      }), /* @__PURE__ */ jsx("span", {
        className: "p-2",
        children: "-"
      }), /* @__PURE__ */ jsxs("div", {
        className: "w-36",
        children: [/* @__PURE__ */ jsx("label", {
          htmlFor: "max",
          className: "display-none"
        }), /* @__PURE__ */ jsx(Input$1, {
          name: "max",
          placeholder: "Maximum",
          type: "number",
          defaultValue: defaultMax,
          onChange: onMaxChange
        })]
      })]
    })]
  });
};
const options$4 = {
  base: "size-11 rounded-lg text-sm text-center",
  inactive: "text-gray-900 hover:bg-gray-200",
  active: "text-white bg-primary",
  ellipsis: "hover:bg-transparent cursor-default"
};
const calculatePages = (current, total, numDisplayed) => {
  const ceil = Math.ceil((numDisplayed - 1) / 2);
  let min2 = current - ceil;
  let max2 = current + ceil;
  if (min2 <= 0) {
    max2 = max2 + (min2 - 1) * -1;
    min2 = 1;
  }
  if (max2 >= total) {
    min2 = min2 + (total - max2);
    min2 = min2 <= 0 ? 1 : min2;
    max2 = total;
  }
  const pages = Array.from({
    length: max2 - min2 + 1
  }, (val, ind) => ind + min2);
  if (max2 !== total) {
    pages.splice(-1, 1);
    pages.push("-", total);
  }
  if (min2 !== 1) {
    pages.splice(0, 1);
    pages.unshift(1, "-");
  }
  return pages;
};
function Pagination$1({
  current = 1,
  total = 5,
  numDisplayed = 5,
  ...props
}) {
  const {
    className,
    onPageChange
  } = props;
  const [page, setPage] = useState(current);
  useEffect(() => {
    setPage(current);
  }, [current]);
  const shownPages = calculatePages(page, total, numDisplayed);
  const changePage = (event) => {
    const pageNum = +event.currentTarget.value;
    if (Number.isNaN(pageNum)) {
      return;
    }
    setPage(pageNum);
    onPageChange(pageNum);
  };
  if (total <= 1) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  return /* @__PURE__ */ jsx("div", {
    children: /* @__PURE__ */ jsx("nav", {
      role: "navigation",
      className,
      children: /* @__PURE__ */ jsxs("ul", {
        className: "flex flex-wrap items-center gap-x-2",
        children: [page !== 1 && /* @__PURE__ */ jsx("li", {
          children: /* @__PURE__ */ jsx("button", {
            onClick: changePage,
            value: page - 1,
            className: addStyles([options$4.base, options$4.inactive]),
            "aria-label": "Go to previous page",
            children: /* @__PURE__ */ jsx(SvgChevronLeft, {
              height: "1rem",
              width: "1rem",
              className: "mx-auto fill-gray-900"
            })
          })
        }), shownPages.map((pageNum, index2) => {
          return /* @__PURE__ */ jsx("li", {
            children: /* @__PURE__ */ jsx("button", {
              onClick: changePage,
              value: pageNum,
              "aria-current": pageNum === page ? "true" : "false",
              className: addStyles([options$4.base, pageNum === page ? options$4.active : options$4.inactive, pageNum === "-" ? options$4.ellipsis : ""]),
              children: pageNum === "-" ? /* @__PURE__ */ jsx("span", {
                children: "…"
              }) : pageNum
            })
          }, index2);
        }), page !== total && /* @__PURE__ */ jsx("li", {
          children: /* @__PURE__ */ jsx("button", {
            onClick: changePage,
            value: page + 1,
            className: addStyles([options$4.base, options$4.inactive]),
            "aria-label": "Go to next page",
            children: /* @__PURE__ */ jsx(SvgChevronRight, {
              height: "1rem",
              width: "1rem",
              className: "mx-auto fill-gray-900"
            })
          })
        })]
      })
    })
  });
}
const sectionLineClass = "border-gray-300";
const PALFilterBody = (props) => {
  const {
    portfoliosNotSelected = [],
    accountsNotSelected = [],
    locationsNotSelected = []
  } = props;
  const totalLength = portfoliosNotSelected.length + accountsNotSelected.length + locationsNotSelected.length;
  return totalLength === 0 ? /* @__PURE__ */ jsxs("div", {
    className: "py-6 text-center",
    children: [/* @__PURE__ */ jsx(SvgEmptyServices, {
      className: "mx-auto"
    }), /* @__PURE__ */ jsx("p", {
      className: "headline-xxs my-2",
      children: "No customers found"
    }), /* @__PURE__ */ jsx("p", {
      className: "my-4",
      children: "Please try changing your search term."
    })]
  }) : /* @__PURE__ */ jsxs(Fragment, {
    children: [portfoliosNotSelected, portfoliosNotSelected.length > 0 ? /* @__PURE__ */ jsx("hr", {
      className: sectionLineClass
    }) : void 0, accountsNotSelected, portfoliosNotSelected.length > 0 || accountsNotSelected.length > 0 ? /* @__PURE__ */ jsx("hr", {
      className: sectionLineClass
    }) : void 0, locationsNotSelected]
  });
};
const tagStyles = "whitespace-nowrap self-start bg-white rounded mr-1 normal-case inline-block rounded-sm py-1 px-2 text-xs font-medium text-gray-900";
const renderPALItem = (item) => /* @__PURE__ */ jsxs("div", {
  className: "flex items-stretch",
  children: [/* @__PURE__ */ jsx("div", {
    className: "w-10",
    children: item.tagLeftIcon ? item.tagLeftIcon({
      className: "h-full w-4 float-right mr-1 inline text-gray-800 fill-current"
    }) : void 0
  }), /* @__PURE__ */ jsxs("div", {
    className: "grow pl-3",
    children: [/* @__PURE__ */ jsx("div", {
      children: highlight(item.label, item.textToHighlight)
    }), /* @__PURE__ */ jsx("div", {
      className: "pt-1 text-xs text-gray-700",
      children: item.subtext
    })]
  }), /* @__PURE__ */ jsx("div", {
    className: tagStyles,
    children: highlight(item.tagText ?? "", item.textToHighlight)
  })]
});
const PALFilterMenuItem = (props) => {
  const {
    renderItem = renderPALItem,
    ...rest
  } = props;
  return /* @__PURE__ */ jsx(FilterComboBoxMenuItem, {
    renderItem,
    ...rest
  });
};
const classes$1 = {
  popover: {
    base: "flex-col max-h-104 overflow-y-auto rounded-t-none border-t border-t-gray-300 shadow-dark",
    clearSelectionButton: "text-primary ml-auto hover:text-jungle-400 active:underline cursor-pointer select-none font-medium decoration-primary text-xs hover:underline",
    headerWrapper: "px-4 py-3 flex-row flex",
    headerText: "font-medium text-gray-600 uppercase text-xs"
  }
};
const PALFilter = (props) => {
  const {
    portfolios,
    accounts,
    locations,
    onChange,
    onResultTypeChange,
    autoFilterItems = false,
    onSearch: onSearchCallback,
    renderListItem,
    defaultValue = [],
    defaultSearchTerm,
    resultType,
    isLoading,
    ...rest
  } = props;
  const [searchTerm, setSearchTerm] = useState(defaultSearchTerm ?? "");
  const data = useMemo(() => [...portfolios, ...accounts, ...locations], [portfolios, accounts, locations]);
  const {
    selectedItems,
    onToggleItem,
    deselectAll
  } = useFilterComboboxSelection(defaultValue, onChange, data);
  const isMatch = useCallback((item) => !autoFilterItems || matchesSearch$1(item, searchTerm), [autoFilterItems, searchTerm]);
  const onSearch = (searchString) => {
    setSearchTerm(searchString);
    onSearchCallback(searchString);
  };
  const menuItemRenderer = useCallback((value, selected = false) => /* @__PURE__ */ jsx(PALFilterMenuItem, {
    item: {
      ...value,
      textToHighlight: searchTerm
    },
    defaultSelection: selected,
    onSelect: onToggleItem,
    className: "text-sm",
    renderItem: renderListItem
  }, value.value), [onToggleItem, renderListItem, searchTerm]);
  const getNotSelected = useCallback((data2) => {
    return data2.filter((dataItem) => !selectedItems.some((selectedItem) => selectedItem.value === dataItem.value) && isMatch(dataItem)).map((element) => menuItemRenderer(element, false));
  }, [isMatch, menuItemRenderer, selectedItems]);
  const portfoliosNotSelected = useMemo(() => getNotSelected(portfolios), [portfolios, getNotSelected]);
  const accountsNotSelected = useMemo(() => getNotSelected(accounts), [accounts, getNotSelected]);
  const locationsNotSelected = useMemo(() => getNotSelected(locations), [locations, getNotSelected]);
  const itemsSelected = useMemo(() => selectedItems.filter((selectedItem) => matchesSearch$1(selectedItem, searchTerm)).map((element) => menuItemRenderer(element, true)), [menuItemRenderer, searchTerm, selectedItems]);
  return /* @__PURE__ */ jsxs(FilterComboBoxWrapper, {
    popoverClassesBase: classes$1.popover.base,
    isDropdownEmpty: false,
    onSearch,
    ...rest,
    children: [selectedItems.length > 0 && /* @__PURE__ */ jsxs("div", {
      className: classes$1.popover.headerWrapper,
      children: [/* @__PURE__ */ jsxs("div", {
        className: classes$1.popover.headerText,
        children: ["Selected (", selectedItems.length, ")"]
      }), /* @__PURE__ */ jsx("div", {
        role: "button",
        "aria-label": "Clear selection",
        onClick: deselectAll,
        className: classes$1.popover.clearSelectionButton,
        children: "Clear selected"
      })]
    }), itemsSelected, /* @__PURE__ */ jsx("div", {
      className: classes$1.popover.headerWrapper,
      children: /* @__PURE__ */ jsx("div", {
        className: classes$1.popover.headerText,
        children: "Results"
      })
    }), /* @__PURE__ */ jsx("div", {
      className: "mx-4 mb-3 text-sm leading-6",
      children: /* @__PURE__ */ jsx(SegmentedButton, {
        type: "radio",
        name: "seg-button-1",
        data: [{
          label: "All",
          value: "All"
        }, {
          label: "Portfolio",
          value: "Portfolio",
          icon: SvgHouseUser
        }, {
          label: "Account",
          value: "Account",
          icon: SvgUserSolid
        }, {
          label: "Location",
          value: "Location",
          icon: SvgLocationDot
        }],
        size: "medium",
        buttonClassName: "flex-1",
        iconClassName: "text-gray-800 fill-current",
        value: [resultType],
        onChange: (selected) => onResultTypeChange(selected)
      })
    }), isLoading ? /* @__PURE__ */ jsx("div", {
      className: "flex h-80 items-center justify-center",
      children: /* @__PURE__ */ jsx(Spinner, {})
    }) : /* @__PURE__ */ jsx(PALFilterBody, {
      portfoliosNotSelected,
      accountsNotSelected,
      locationsNotSelected
    })]
  });
};
const ProgressBarFill = (props) => {
  const {
    progress = 0,
    label,
    color,
    total
  } = props;
  return /* @__PURE__ */ jsx("div", {
    className: `flex h-full border-white ${progress < total && "border-r-2"} ${color}`,
    style: {
      width: `${progress / total * 100}%`
    },
    children: label && /* @__PURE__ */ jsx(Tooltip, {
      title: label,
      containerClassName: "flex-1",
      placement: "bottom",
      offsetOptions: 10,
      arrowPointAtCenter: true,
      autoPlacementOptions: {
        autoAlignment: true,
        allowedPlacements: ["bottom", "bottom-end", "bottom-start"]
      },
      children: /* @__PURE__ */ jsx("div", {
        className: "size-full"
      })
    })
  });
};
const parseColor = (color) => {
  if (color.includes("#")) {
    return `bg-[${color}]`;
  }
  return color;
};
const ProgressBarSections = (props) => {
  const {
    sections,
    total
  } = props;
  const filteredSections = useMemo(() => (sections == null ? void 0 : sections.filter((s) => s.value > 0)) ?? [], [sections]);
  const totalProgress = useMemo(() => (sections == null ? void 0 : sections.reduce((acc, s) => acc + s.value, 0)) ?? 0, [sections]);
  return /* @__PURE__ */ jsx(Fragment, {
    children: filteredSections.map((section, index2) => {
      const border = index2 === filteredSections.length - 1 && totalProgress === total ? "" : "border-r-2";
      return /* @__PURE__ */ jsx("div", {
        className: `border-white ${section.color ? parseColor(section.color) : "bg-blue-500"} flex h-full ${border}`,
        style: {
          width: `${section.value / total * 100}%`
        },
        children: section.label && /* @__PURE__ */ jsx(Tooltip, {
          title: section.label,
          containerClassName: "flex-1",
          placement: "bottom",
          offsetOptions: 10,
          arrowPointAtCenter: true,
          autoPlacementOptions: {
            autoAlignment: true,
            allowedPlacements: ["bottom", "bottom-end", "bottom-start"]
          },
          children: /* @__PURE__ */ jsx("div", {
            className: "size-full"
          })
        })
      }, section.key);
    })
  });
};
const progressBarSize = {
  small: "h-2",
  medium: "h-4",
  large: "h-9"
};
const ProgressBar = (props) => {
  const {
    size = "small",
    progress,
    sections,
    label,
    color,
    total = 100,
    remainingLabel,
    containerClassName
  } = props;
  const parsedColor = color ? parseColor(color) : "bg-blue-500";
  return /* @__PURE__ */ jsxs("div", {
    className: `
      flex w-full flex-1 overflow-hidden rounded-full bg-gray-300
      ${progressBarSize[size]}
      ${containerClassName ?? containerClassName}	
      `,
    children: [progress ? /* @__PURE__ */ jsx(ProgressBarFill, {
      progress,
      label,
      color: parsedColor,
      total
    }) : /* @__PURE__ */ jsx(ProgressBarSections, {
      sections,
      total
    }), remainingLabel && /* @__PURE__ */ jsx("div", {
      className: "flex h-full flex-1",
      children: /* @__PURE__ */ jsx(Tooltip, {
        title: remainingLabel,
        containerClassName: "flex-1",
        placement: "bottom",
        offsetOptions: 10,
        arrowPointAtCenter: true,
        autoPlacementOptions: {
          autoAlignment: true,
          allowedPlacements: ["bottom", "bottom-end", "bottom-start"]
        },
        children: /* @__PURE__ */ jsx("div", {
          className: "size-full"
        })
      })
    })]
  });
};
const updateBoxState = (isChecked) => {
  return (current) => {
    return current.map((box) => {
      return {
        ...box,
        isChecked
      };
    });
  };
};
const defaultFunction$1 = () => {
  return;
};
const RadioAccordion = forwardRef((props, ref) => {
  const {
    checkboxData,
    defaultOpen,
    onChange = defaultFunction$1,
    ...radioProps
  } = props;
  const [open, setOpen] = useState(defaultOpen);
  const [boxes, setBoxes] = useState(checkboxData);
  const onRadioChange = (e) => {
    setBoxes(updateBoxState(e.target.checked));
    onChange(e);
    radioProps.onCheckboxChange(radioProps.value, boxes.map((box) => box.value));
  };
  const onCheckboxChange = (e) => {
    setBoxes((curr) => {
      return curr.map((box) => {
        if (e.target.value === box.value) {
          return {
            ...box,
            isChecked: e.target.checked
          };
        }
        return box;
      });
    });
    radioProps.onCheckboxChange(radioProps.value, boxes.filter((box) => {
      return box.isChecked ? e.target.value !== box.value : e.target.value === box.value;
    }).map((box) => box.value));
  };
  useEffect(() => {
    if (radioProps.checked) {
      if (!boxes.some((b) => b.isChecked)) {
        setBoxes(updateBoxState(true));
      }
    } else {
      setBoxes(updateBoxState(false));
    }
  }, [radioProps.checked]);
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex cursor-pointer flex-row",
      children: [/* @__PURE__ */ jsx("div", {
        className: "flex-1",
        children: /* @__PURE__ */ jsx(RadioButton, {
          ...radioProps,
          onChange: onRadioChange,
          ref
        })
      }), /* @__PURE__ */ jsx(SvgChevronDown, {
        onClick: () => {
          setOpen((curr) => !curr);
        },
        className: `max-h-6 max-w-6 transition-all ${open ? "rotate-180	" : "rotate-0"}`
      })]
    }), open && /* @__PURE__ */ jsx("div", {
      className: "ml-10 mt-4 space-y-4",
      children: boxes.map((props2, index2) => {
        return /* @__PURE__ */ jsx(Checkbox, {
          ...props2,
          hideLabel: false,
          onChange: onCheckboxChange
        }, index2);
      })
    })]
  });
});
RadioAccordion.displayName = "RadioAccordion";
const input1Classes = "";
const input2Classes = "px-2";
const containerClasses$1 = "";
const RadioInput = (props) => {
  const {
    input1Text,
    input1Props,
    input2Text,
    input2Props,
    checked,
    onValueChange,
    ...rest
  } = props;
  const ref = useRef();
  const [radioChecked, setRadioChecked] = useState(checked);
  const [input1, setInput1] = useState((input1Props.value ?? "").toString());
  const [input2, setInput2] = useState(((input2Props == null ? void 0 : input2Props.value) ?? "").toString());
  useEffect(() => setRadioChecked(checked), [checked]);
  useEffect(() => setInput1((input1Props.value ?? "").toString()), [input1Props.value]);
  useEffect(() => setInput2(((input2Props == null ? void 0 : input2Props.value) ?? "").toString()), [input2Props == null ? void 0 : input2Props.value]);
  const radioOnChange = useCallback((e) => {
    console.log(e.target.value);
    onValueChange(e.target.value, [input1, input2]);
  }, [input1, input2, onValueChange]);
  const input1OnChange = useCallback((e) => {
    setInput1(e.target.value);
    onValueChange(ref.current.value, [e.target.value, input2]);
  }, [input2, onValueChange]);
  const input2OnChange = useCallback((e) => {
    setInput2(e.target.value);
    onValueChange(ref.current.value, [input1, e.target.value]);
  }, [input1, onValueChange]);
  return /* @__PURE__ */ jsx(RadioButton, {
    ref: (thisInput) => ref.current = thisInput,
    ...rest,
    onChange: radioOnChange,
    checked,
    children: /* @__PURE__ */ jsx("div", {
      className: containerClasses$1,
      children: radioChecked ? /* @__PURE__ */ jsxs("div", {
        className: "flex items-center",
        children: [input1Text ? /* @__PURE__ */ jsx("div", {
          className: input1Classes,
          children: input1Text
        }) : void 0, /* @__PURE__ */ jsx("div", {
          className: "w-24",
          children: /* @__PURE__ */ jsx(Input$1, {
            className: "py-1",
            ...input1Props,
            value: input1,
            prefix: "",
            onChange: input1OnChange
          })
        }), input2Text ? /* @__PURE__ */ jsx("div", {
          className: input2Classes,
          children: input2Text
        }) : void 0, input2Props ? /* @__PURE__ */ jsx("div", {
          className: "w-24",
          children: /* @__PURE__ */ jsx(Input$1, {
            className: "py-1",
            ...input2Props,
            value: input2,
            onChange: input2OnChange,
            prefix: ""
          })
        }) : void 0]
      }) : void 0
    })
  });
};
const RadioButtonGroupError = (props) => {
  const {
    buttonSize,
    error,
    errorProps
  } = props;
  const newProps = errorProps ?? {
    display: error,
    visible: true
  };
  const formHelperTextProps = {
    ...newProps,
    type: "error",
    size: (errorProps == null ? void 0 : errorProps.size) ?? buttonSize ?? "large",
    className: errorProps == null ? void 0 : errorProps.className
  };
  return /* @__PURE__ */ jsx(FormHelperText, {
    ...formHelperTextProps
  });
};
const options$3 = {
  layout: {
    vertical: "flex flex-col",
    horizontal: "flex flex-row gap-x-8"
  },
  margin: {
    medium: "mt-1",
    large: "mt-2"
  }
};
const defaultFunction = () => {
  return;
};
const updateCurrentValue = (radioValue) => {
  return (current) => {
    return current === radioValue ? "" : current;
  };
};
const RadioButtonGroup = forwardRef(({
  layout = "vertical",
  ...props
}, ref) => {
  const {
    label,
    data,
    onChange = defaultFunction,
    onValueChange = defaultFunction,
    name,
    error,
    errorProps,
    value: propValue = "",
    buttonSize
  } = props;
  const [value, setValue] = useState(propValue);
  const onRadioChange = (e) => {
    setValue(e.target.value);
    onChange(e);
    onValueChange(e.target.value, []);
  };
  const onCheckboxChange = (radioValue, selectedBoxes) => {
    if (selectedBoxes.length === 0) {
      setValue(updateCurrentValue(radioValue));
    } else {
      setValue(radioValue);
    }
    onValueChange(radioValue, selectedBoxes);
  };
  useEffect(() => {
    setValue(propValue);
  }, [propValue]);
  const itemWrapperClasses = buttonSize === "medium" ? "p-1" : "p-2.5";
  const defaultMargin = error || (errorProps == null ? void 0 : errorProps.visible) ? "" : options$3.margin[buttonSize || "large"];
  return /* @__PURE__ */ jsxs("fieldset", {
    children: [label && /* @__PURE__ */ jsx("div", {
      className: "flex flex-col",
      children: /* @__PURE__ */ jsx("legend", {
        className: "body-l",
        children: label
      })
    }), (error || errorProps) && /* @__PURE__ */ jsx(RadioButtonGroupError, {
      error,
      errorProps,
      buttonSize
    }), /* @__PURE__ */ jsx("div", {
      className: `${options$3.layout[layout]} ${defaultMargin}`,
      children: data.map(({
        name: id,
        ...radioButtonProps
      }, index2) => {
        const radioChecked = value === radioButtonProps.value;
        if ("checkboxData" in radioButtonProps) {
          return /* @__PURE__ */ jsx("div", {
            className: itemWrapperClasses,
            children: /* @__PURE__ */ jsx(RadioAccordion, {
              ...radioButtonProps,
              name,
              checked: radioChecked,
              onChange: onRadioChange,
              onCheckboxChange,
              size: buttonSize
            })
          }, radioButtonProps.value);
        }
        if ("input1Props" in radioButtonProps) {
          return /* @__PURE__ */ jsx("div", {
            className: itemWrapperClasses,
            children: /* @__PURE__ */ jsx(RadioInput, {
              ...radioButtonProps,
              name,
              checked: radioChecked,
              onChange: onRadioChange,
              onValueChange: onCheckboxChange,
              size: buttonSize
            })
          }, radioButtonProps.value);
        }
        return /* @__PURE__ */ jsx("div", {
          className: itemWrapperClasses,
          children: /* @__PURE__ */ jsx(RadioButton, {
            ...radioButtonProps,
            ref: index2 === 0 ? ref : void 0,
            checked: radioChecked,
            onChange: onRadioChange,
            size: buttonSize,
            name,
            id
          })
        }, radioButtonProps.value);
      })
    })]
  });
});
RadioButtonGroup.displayName = "RadioButtonGroup";
const style$1 = {
  popoverBase: "flex-col max-h-104 overflow-y-auto shadow-dark py-2.5 px-3.5 w-full"
};
const formatSelection = (data, inputs, radioValue) => {
  var _a;
  const item = data.find((item2) => item2.value === radioValue);
  if (!item) return radioValue;
  if (!("input1Props" in item && item.input1Props)) return item.label;
  let formatted = item.label;
  if (item.input1Text) formatted += ` ${item.input1Text}`;
  if (inputs[0]) formatted += ` ${inputs[0]}`;
  else if (item.input1Props.required) return "";
  else return formatted;
  if (item.input2Text) formatted += ` ${item.input2Text}`;
  if (inputs.length > 1 && inputs[1]) formatted += ` ${inputs[1]}`;
  else if ((_a = item.input2Props) == null ? void 0 : _a.required) return "";
  return formatted;
};
const RadioDropdown = (props) => {
  const {
    data: defaultData,
    value,
    onChange,
    onOpen,
    radioValue,
    name,
    width = "352px",
    isOpen = false,
    ...rest
  } = props;
  const [data, setData] = useState(defaultData);
  const [selection, setSelection] = useState([[], radioValue]);
  const onValueChange = (radioValue2, inputs) => {
    setSelection([inputs, radioValue2]);
    const itemIndex = data.findIndex((v) => v.value === radioValue2);
    const item = data[itemIndex];
    if (item && "input1Props" in item) {
      const newItem = {
        ...item,
        input1Props: {
          ...item.input1Props,
          value: inputs[0]
        }
      };
      if (inputs[1]) {
        newItem.input2Props = {
          ...item.input2Props,
          value: inputs[1]
        };
      }
      data[itemIndex] = newItem;
      setData([...data]);
    }
    onChange(inputs, radioValue2);
  };
  const onClearSelection = () => {
    setSelection([[], void 0]);
    onChange([], void 0);
  };
  const numberSelected = selection[1] === void 0 ? 0 : 1;
  const firstSelection = formatSelection(data, selection[0], selection[1]);
  return /* @__PURE__ */ jsx(FilterChip, {
    menuContent: /* @__PURE__ */ jsx("div", {
      style: {
        width
      },
      children: /* @__PURE__ */ jsx(Card, {
        className: style$1.popoverBase,
        children: /* @__PURE__ */ jsx("div", {
          role: "menu",
          children: /* @__PURE__ */ jsx(RadioButtonGroup, {
            data,
            name,
            layout: "vertical",
            value: selection[1],
            onValueChange,
            buttonSize: "medium"
          })
        })
      })
    }),
    numberSelected,
    onClearSelection,
    firstSelection,
    width,
    isOpen,
    value,
    onOpen,
    ...rest
  });
};
const getButtonStyle = (index2, length, selected) => {
  const styles2 = [];
  if (index2 === 0) {
    styles2.push("rounded-l-lg");
  } else if (index2 == length - 1) {
    styles2.push("rounded-r-lg");
  }
  if (selected) {
    styles2.push("bg-jungle-50", "border-jungle-900", "hover:bg-jungle-100", "z-10");
  } else {
    styles2.push("border-gray-500", "bg-white", "hover:text-primary");
  }
  return styles2.join(" ");
};
const iconSizes = {
  medium: "h-6 w-4",
  large: "h-6 w-6"
};
const getIconStyle = (index2, selected, indexOfHovered, size) => index2 === indexOfHovered && !selected ? `${iconSizes[size]} fill-primary` : iconSizes[size];
const baseLabelStyle = "flex peer-checked:text-jungle-900 peer-checked:fill-jungle-900 cursor-pointer select-none justify-center";
const labelStyles = {
  medium: `${baseLabelStyle} px-2 py-1`,
  large: `${baseLabelStyle}  px-5 py-2.5`
};
const SegmentedButton = (props) => {
  const {
    data,
    name,
    type = "radio",
    size = "large",
    onChange,
    value,
    buttonClassName,
    iconClassName
  } = props;
  const [selected, setSelected] = useState([]);
  const [indexOfHovered, setIndexOfHovered] = useState(-1);
  useEffect(() => {
    if (!value) return;
    setSelected(value);
  }, [value]);
  const handleRadioChange = useCallback((event) => {
    event.stopPropagation();
    const {
      value: value2
    } = event.target;
    if (onChange) onChange(value2);
    setSelected([value2]);
  }, [onChange]);
  const handleCheckboxChange = useCallback((event) => {
    event.stopPropagation();
    const {
      value: value2,
      checked
    } = event.target;
    const newSelected = checked ? [...selected, value2] : selected.filter((v) => v !== value2);
    if (onChange) onChange([...newSelected]);
    setSelected([...newSelected]);
  }, [selected, onChange]);
  const onChangeHandler = useMemo(() => {
    return type === "checkbox" ? handleCheckboxChange : handleRadioChange;
  }, [type, handleCheckboxChange, handleRadioChange]);
  return /* @__PURE__ */ jsx("fieldset", {
    className: "m-0",
    children: /* @__PURE__ */ jsx("div", {
      className: "flex flex-row rounded-lg",
      children: data.map((item, index2) => {
        const {
          value: value2,
          label,
          icon
        } = item;
        const checked = selected.includes(value2);
        return /* @__PURE__ */ jsxs("div", {
          className: addStyles(["border border-solid flex items-center justify-center", buttonClassName, getButtonStyle(index2, data.length, selected.includes(value2))]),
          onMouseEnter: () => setIndexOfHovered(index2),
          onMouseLeave: () => setIndexOfHovered(-1),
          onClick: (e) => e.stopPropagation(),
          children: [/* @__PURE__ */ jsx("input", {
            type,
            value: value2,
            name,
            id: value2,
            className: addStyles(["hidden", "peer"]),
            onChange: onChangeHandler,
            checked
          }), /* @__PURE__ */ jsxs("label", {
            htmlFor: value2,
            className: labelStyles[size],
            children: [icon && /* @__PURE__ */ jsx("div", {
              className: "pr-2 " + iconClassName,
              children: icon({
                className: getIconStyle(index2, selected.includes(value2), indexOfHovered, size)
              })
            }), " ", label]
          })]
        }, value2);
      })
    })
  });
};
const SvgBaler = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2199_59895)" }, /* @__PURE__ */ React.createElement("path", { d: "M48.2025 19.33H34.83V9C34.83 8.80109 34.751 8.61026 34.6103 8.4696C34.4697 8.32895 34.2789 8.25 34.08 8.25H30.1225C29.9236 8.25 29.7328 8.32895 29.5922 8.4696C29.4515 8.61026 29.3725 8.80109 29.3725 9V19.33H16C15.8011 19.33 15.6103 19.4089 15.4697 19.5496C15.329 19.6902 15.25 19.881 15.25 20.08V23.62C15.25 23.8189 15.329 24.0096 15.4697 24.1503C15.6103 24.2909 15.8011 24.37 16 24.37H16.895V55.0625C16.895 55.2614 16.974 55.4521 17.1147 55.5928C17.2553 55.7334 17.4461 55.8125 17.645 55.8125H46.5575C46.7564 55.8125 46.9472 55.7334 47.0878 55.5928C47.2285 55.4521 47.3075 55.2614 47.3075 55.0625V24.37H48.2025C48.4014 24.37 48.5922 24.2909 48.7328 24.1503C48.8735 24.0096 48.9525 23.8189 48.9525 23.62V20.08C48.9525 19.881 48.8735 19.6902 48.7328 19.5496C48.5922 19.4089 48.4014 19.33 48.2025 19.33V19.33ZM30.8725 19.33V9.75745H33.33V19.3374H30.87C30.87 19.3374 30.8725 19.3249 30.8725 19.3224V19.33ZM45.8075 54.33H18.395V24.37H25.5025V29.33H20.34C20.1411 29.33 19.9503 29.4089 19.8097 29.5496C19.669 29.6902 19.59 29.881 19.59 30.08V48.0275C19.59 48.2264 19.669 48.4171 19.8097 48.5577C19.9503 48.6984 20.1411 48.7775 20.34 48.7775H43.8625C44.0614 48.7775 44.2522 48.6984 44.3928 48.5577C44.5335 48.4171 44.6125 48.2264 44.6125 48.0275V30.08C44.6125 29.881 44.5335 29.6902 44.3928 29.5496C44.2522 29.4089 44.0614 29.33 43.8625 29.33H38.7V24.37H45.8075V54.33ZM43.1125 46.4049L42.2225 47.2949H40.8425L43.1125 45.0249V46.4049ZM43.1125 42.4049L38.2125 47.3049H36.8325L43.1125 41.0249V42.4049ZM43.1125 38.4049L34.2025 47.3149H32.8225L43.1125 37.0249V38.4049ZM43.1125 34.4049L30.195 47.3224H28.815L43.1125 33.0249V34.4049ZM26.7875 46.72C26.585 46.92 26.3925 47.1224 26.205 47.3224H24.755L41.2025 30.875H42.6325L26.7875 46.72ZM22.82 46.6274C22.5875 46.8599 22.365 47.0924 22.1525 47.3224H21.09V46.9199C21.43 46.6174 21.78 46.29 22.13 45.9375L37.1925 30.875H38.5725L22.82 46.6274ZM21.09 34.95L25.165 30.875H26.545L21.09 36.33V34.95ZM21.09 32.3224V30.875H22.5325L21.09 32.3224ZM21.09 38.96L29.175 30.875H30.555L21.09 40.34V38.96ZM21.09 42.96L33.185 30.8674H34.565L21.09 44.34V42.96ZM35.865 29.3674V24.4075H36.84V29.3674H35.865ZM34.0075 29.3674H33.0325V24.4075H34.01L34.0075 29.3674ZM31.1725 29.3674H30.195V24.4075H31.1725V29.3674ZM28.3375 29.3674H27.36V24.4075H28.3375V29.3674ZM47.4525 22.9075H16.75V20.8674H47.4525V22.9075Z" }), /* @__PURE__ */ React.createElement("path", { d: "M37.4531 49.457H34.9531C34.7542 49.457 34.5634 49.5361 34.4228 49.6768C34.2821 49.8174 34.2031 50.0081 34.2031 50.207V52.707C34.2031 52.9059 34.2821 53.0968 34.4228 53.2374C34.5634 53.3781 34.7542 53.457 34.9531 53.457H37.4531C37.652 53.457 37.8428 53.3781 37.9834 53.2374C38.1241 53.0968 38.2031 52.9059 38.2031 52.707V50.207C38.2031 50.0081 38.1241 49.8174 37.9834 49.6768C37.8428 49.5361 37.652 49.457 37.4531 49.457ZM36.7031 51.957H35.7031V50.957H36.7031V51.957Z" }), /* @__PURE__ */ React.createElement("path", { d: "M33.3516 49.457H30.8516C30.6526 49.457 30.4619 49.5361 30.3212 49.6768C30.1806 49.8174 30.1016 50.0081 30.1016 50.207V52.707C30.1016 52.9059 30.1806 53.0968 30.3212 53.2374C30.4619 53.3781 30.6526 53.457 30.8516 53.457H33.3516C33.5505 53.457 33.7412 53.3781 33.8819 53.2374C34.0225 53.0968 34.1016 52.9059 34.1016 52.707V50.207C34.1016 50.0081 34.0225 49.8174 33.8819 49.6768C33.7412 49.5361 33.5505 49.457 33.3516 49.457ZM32.6016 51.957H31.6016V50.957H32.6016V51.957Z" }), /* @__PURE__ */ React.createElement("path", { d: "M29.25 49.457H26.75C26.5511 49.457 26.3603 49.5361 26.2197 49.6768C26.079 49.8174 26 50.0081 26 50.207V52.707C26 52.9059 26.079 53.0968 26.2197 53.2374C26.3603 53.3781 26.5511 53.457 26.75 53.457H29.25C29.4489 53.457 29.6397 53.3781 29.7803 53.2374C29.921 53.0968 30 52.9059 30 52.707V50.207C30 50.0081 29.921 49.8174 29.7803 49.6768C29.6397 49.5361 29.4489 49.457 29.25 49.457ZM28.5 51.957H27.5V50.957H28.5V51.957Z" })));
const SvgCart = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2199_59887)" }, /* @__PURE__ */ React.createElement("path", { d: "M48.4725 13.0355L47.7075 12.9081C45.1325 12.4831 40.5325 12.7056 39.6175 16.2256L39.405 17.0305L39.0125 17.108H24.8375L24.605 16.223C23.69 12.703 19.09 12.473 16.515 12.9055L15.75 13.0331L20.865 44.838H22.7775L22.54 45.5231C22.3301 46.13 22.2552 46.7752 22.3203 47.4141C22.3855 48.0529 22.5892 48.6698 22.9173 49.2218C23.2454 49.7738 23.6899 50.2476 24.2199 50.6101C24.75 50.9726 25.3527 51.2153 25.9861 51.3209C26.6195 51.4266 27.2683 51.3928 27.8873 51.2219C28.5063 51.0511 29.0805 50.7472 29.57 50.3316C30.0595 49.9159 30.4525 49.3986 30.7215 48.8156C30.9905 48.2325 31.129 47.5977 31.1275 46.9556C31.1286 46.2197 30.941 45.4957 30.5825 44.853L30.5425 44.7755H33.6575L33.615 44.853C33.2586 45.4965 33.0719 46.2201 33.0725 46.9556C33.0585 47.5444 33.1624 48.1299 33.378 48.678C33.5936 49.226 33.9167 49.7255 34.3282 50.1469C34.7397 50.5682 35.2312 50.9031 35.774 51.1317C36.3168 51.3603 36.8998 51.4782 37.4887 51.4782C38.0777 51.4782 38.6607 51.3603 39.2035 51.1317C39.7463 50.9031 40.2379 50.5682 40.6493 50.1469C41.0608 49.7255 41.3838 49.226 41.5995 48.678C41.8151 48.1299 41.919 47.5444 41.905 46.9556C41.9023 46.4675 41.8178 45.9833 41.655 45.5231L41.405 44.838H43.34L48.4725 13.0355ZM38.6025 18.5155H39.01L38.94 18.7655C38.69 19.6705 38.425 20.678 38.1425 21.723L38.04 22.103H26.19L25.22 18.5105L38.6025 18.5155ZM27.425 26.6605L26.57 23.5281H37.655L36.8 26.6605H27.425ZM36.425 28.0656L35.5425 31.2805H28.69L27.8075 28.0656H36.425ZM17.5475 14.3506L18.1375 14.3356C20.9875 14.2656 22.7025 15.0531 23.11 16.6181C24.025 20.1356 26.775 30.1406 27.315 32.1181L27.515 32.8456H36.7275L36.885 32.2731C36.915 32.1631 40.135 20.4356 41.135 16.6231C41.535 15.0756 43.3025 14.268 46.1075 14.343L46.695 14.3606L42.04 43.2905H22.19L22.1725 43.1856L17.5475 14.3506ZM29.58 46.958C29.5809 47.4388 29.4606 47.912 29.2302 48.334C28.9998 48.7559 28.6668 49.113 28.2619 49.3722C27.857 49.6314 27.3933 49.7842 26.9136 49.8168C26.434 49.8493 25.9539 49.7605 25.5177 49.5584C25.0815 49.3563 24.7032 49.0474 24.418 48.6604C24.1327 48.2734 23.9496 47.8208 23.8855 47.3444C23.8214 46.8679 23.8785 46.383 24.0515 45.9345C24.2244 45.4859 24.5077 45.0882 24.875 44.7781H28.5675C28.8827 45.0471 29.1356 45.3813 29.3087 45.7577C29.4818 46.1341 29.5709 46.5437 29.57 46.958H29.58ZM37.4975 49.818C36.9119 49.8181 36.3404 49.6384 35.8604 49.303C35.3803 48.9676 35.0149 48.4928 34.8136 47.9429C34.6123 47.393 34.5848 46.7945 34.7348 46.2284C34.8849 45.6623 35.2052 45.1561 35.6525 44.7781H39.345C39.7924 45.1562 40.1128 45.6627 40.2628 46.229C40.4128 46.7953 40.3851 47.394 40.1835 47.944C39.9819 48.494 39.6161 48.9688 39.1356 49.304C38.6552 49.6392 38.0833 49.8186 37.4975 49.818Z" }), /* @__PURE__ */ React.createElement("path", { d: "M24.4405 37.0566H40.1355C40.3735 37.0566 40.6018 36.9621 40.7701 36.7938C40.9384 36.6255 41.033 36.3972 41.033 36.1592C41.033 35.9212 40.9384 35.6929 40.7701 35.5245C40.6018 35.3562 40.3735 35.2617 40.1355 35.2617H24.4405C24.2024 35.2617 23.9741 35.3562 23.8058 35.5245C23.6375 35.6929 23.543 35.9212 23.543 36.1592C23.543 36.3972 23.6375 36.6255 23.8058 36.7938C23.9741 36.9621 24.2024 37.0566 24.4405 37.0566Z" }), /* @__PURE__ */ React.createElement("path", { d: "M38.8376 39.4023H25.7276C25.4895 39.4023 25.2612 39.4968 25.0929 39.6652C24.9246 39.8335 24.8301 40.0618 24.8301 40.2998C24.8301 40.5378 24.9246 40.7661 25.0929 40.9344C25.2612 41.1028 25.4895 41.1973 25.7276 41.1973H38.8376C39.0756 41.1973 39.3039 41.1028 39.4722 40.9344C39.6405 40.7661 39.7351 40.5378 39.7351 40.2998C39.7351 40.0618 39.6405 39.8335 39.4722 39.6652C39.3039 39.4968 39.0756 39.4023 38.8376 39.4023V39.4023Z" })));
const SvgDrum = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2199_59896)" }, /* @__PURE__ */ React.createElement("path", { d: "M43.297 15.3241C42.097 13.1141 33.6445 12.9941 31.847 12.9941C29.942 12.9941 20.572 13.1291 20.2645 15.7441C20.2608 15.7732 20.2608 15.8025 20.2645 15.8315C20.2633 15.8465 20.2633 15.8616 20.2645 15.8766C20.2645 15.8766 20.2645 15.8915 20.2645 15.899C20.262 15.9307 20.262 15.9625 20.2645 15.9941C20.3138 16.3367 20.4928 16.6472 20.7645 16.8616C20.8958 17.0586 20.9899 17.2782 21.042 17.5092C21.042 17.5792 21.0145 17.6616 20.9945 17.7716C20.8245 18.6241 20.372 20.8916 20.5745 28.2316C20.607 29.4141 20.6345 30.6216 20.6595 31.8241C20.7095 34.0866 20.7595 36.1391 20.832 37.9691C20.832 37.9691 20.832 37.9841 20.832 37.9916C20.8294 38.0382 20.8294 38.085 20.832 38.1316C21.0545 43.6591 21.4895 47.1316 22.747 48.2216C24.7795 49.9891 29.112 50.9441 32.1545 50.9441C32.2127 50.9443 32.2707 50.9368 32.327 50.9216C35.6595 50.8841 39.2145 49.7765 41.027 48.2015C42.7095 46.739 42.917 41.0166 43.1195 31.8041C43.147 30.5991 43.172 29.3941 43.2045 28.2091C43.407 20.8691 42.9545 18.6041 42.787 17.7491C42.7645 17.6416 42.747 17.5566 42.7395 17.4991C42.8068 17.2145 42.9281 16.9454 43.097 16.7065C43.1982 16.599 43.2824 16.4769 43.347 16.3441L43.3695 16.3116C43.4794 16.1663 43.5327 15.9859 43.5193 15.8042C43.506 15.6225 43.427 15.4518 43.297 15.3241V15.3241ZM27.372 14.7716C27.2989 14.8948 27.2617 15.0359 27.2645 15.1791C27.2645 16.1591 28.652 16.1591 29.3995 16.1591C30.147 16.1591 31.532 16.1591 31.532 15.1791C31.5357 15.0736 31.5172 14.9686 31.4775 14.8708C31.4379 14.7731 31.3781 14.6847 31.302 14.6116H31.847C38.1395 14.6116 41.542 15.4566 41.597 15.9091C41.5794 15.9672 41.5412 16.017 41.4895 16.0491C40.837 16.3366 39.5745 16.6691 37.717 16.9116C37.4795 16.9391 37.232 16.9641 36.967 16.9891C36.9989 16.8984 37.015 16.8027 37.0145 16.7065C37.0145 15.724 35.627 15.7241 34.882 15.7241C34.137 15.7241 32.747 15.724 32.747 16.7065C32.7404 16.888 32.8 17.0656 32.9145 17.2065C32.5645 17.2065 32.2045 17.2065 31.8345 17.2065C29.873 17.2175 27.9123 17.1182 25.962 16.9091C24.0995 16.6591 22.8345 16.3341 22.1845 16.0466C22.1328 16.0146 22.0946 15.9648 22.077 15.9066C22.132 15.5741 23.9545 15.0441 27.382 14.7766L27.372 14.7716ZM40.0395 47.0741C38.472 48.4391 35.152 49.4266 32.1495 49.4266C32.0939 49.4268 32.0385 49.4335 31.9845 49.4467C28.867 49.4117 25.1945 48.3691 23.7345 47.0966C22.9845 46.4391 22.612 43.3816 22.4095 39.6791C25.2595 40.9091 31.032 40.9565 31.8795 40.9565C32.727 40.9565 38.522 40.9091 41.3795 39.6716C41.1595 43.3666 40.792 46.4166 40.0395 47.0741ZM41.617 31.7766C41.5745 33.7366 41.527 35.8441 41.447 37.8541C41.4456 37.8766 41.4456 37.8991 41.447 37.9216C41.032 38.4566 37.7995 39.4565 31.887 39.4565C25.9745 39.4565 22.7695 38.4566 22.3345 37.9266C22.252 35.9016 22.207 33.7741 22.162 31.7966C22.137 30.6541 22.112 29.5091 22.082 28.3816C22.8197 28.5857 23.5719 28.7336 24.332 28.8241C29.3626 29.3941 34.4414 29.3941 39.472 28.8241C40.2317 28.7337 40.9837 28.5875 41.722 28.3866C41.667 29.5016 41.632 30.639 41.617 31.774V31.7766ZM41.7345 26.7766C41.017 27.1466 37.687 27.7466 31.8895 27.7466C26.092 27.7466 22.727 27.1391 22.032 26.7716C21.9245 20.7291 22.3045 18.8166 22.4545 18.0641C22.482 17.9341 22.4995 17.8341 22.512 17.7466C25.492 18.6891 30.512 18.7466 31.847 18.7466C33.182 18.7466 38.2845 18.6765 41.2545 17.7115C41.2545 17.799 41.287 17.9016 41.312 18.0341C41.462 18.7991 41.8445 20.7166 41.7345 26.7791V26.7766Z" }), /* @__PURE__ */ React.createElement("path", { d: "M36.23 20.5879H33.5975C33.3727 20.5879 33.1572 20.6772 32.9982 20.8362C32.8393 20.9951 32.75 21.2107 32.75 21.4354C32.75 21.6602 32.8393 21.8757 32.9982 22.0347C33.1572 22.1936 33.3727 22.283 33.5975 22.283H36.23C36.4548 22.283 36.6703 22.1936 36.8293 22.0347C36.9882 21.8757 37.0775 21.6602 37.0775 21.4354C37.0775 21.2107 36.9882 20.9951 36.8293 20.8362C36.6703 20.6772 36.4548 20.5879 36.23 20.5879V20.5879Z" }), /* @__PURE__ */ React.createElement("path", { d: "M36.2292 23.6946H33.5966C33.4816 23.6884 33.3666 23.7056 33.2585 23.7453C33.1504 23.785 33.0515 23.8464 32.9679 23.9256C32.8842 24.0048 32.8176 24.1002 32.7721 24.206C32.7266 24.3118 32.7031 24.4258 32.7031 24.5409C32.7031 24.6561 32.7266 24.77 32.7721 24.8758C32.8176 24.9816 32.8842 25.077 32.9679 25.1562C33.0515 25.2354 33.1504 25.2968 33.2585 25.3365C33.3666 25.3762 33.4816 25.3934 33.5966 25.3871H36.2292C36.3442 25.3934 36.4592 25.3762 36.5673 25.3365C36.6754 25.2968 36.7743 25.2354 36.8579 25.1562C36.9416 25.077 37.0082 24.9816 37.0537 24.8758C37.0992 24.77 37.1227 24.6561 37.1227 24.5409C37.1227 24.4258 37.0992 24.3118 37.0537 24.206C37.0082 24.1002 36.9416 24.0048 36.8579 23.9256C36.7743 23.8464 36.6754 23.785 36.5673 23.7453C36.4592 23.7056 36.3442 23.6884 36.2292 23.6946V23.6946Z" }), /* @__PURE__ */ React.createElement("path", { d: "M36.2292 31.9309H33.5966C33.4816 31.9247 33.3666 31.942 33.2585 31.9817C33.1504 32.0214 33.0515 32.0827 32.9679 32.1619C32.8842 32.2411 32.8176 32.3365 32.7721 32.4423C32.7266 32.5481 32.7031 32.6621 32.7031 32.7772C32.7031 32.8924 32.7266 33.0063 32.7721 33.1121C32.8176 33.2179 32.8842 33.3133 32.9679 33.3925C33.0515 33.4717 33.1504 33.5331 33.2585 33.5728C33.3666 33.6125 33.4816 33.6297 33.5966 33.6234H36.2292C36.3442 33.6297 36.4592 33.6125 36.5673 33.5728C36.6754 33.5331 36.7743 33.4717 36.8579 33.3925C36.9416 33.3133 37.0082 33.2179 37.0537 33.1121C37.0992 33.0063 37.1227 32.8924 37.1227 32.7772C37.1227 32.6621 37.0992 32.5481 37.0537 32.4423C37.0082 32.3365 36.9416 32.2411 36.8579 32.1619C36.7743 32.0827 36.6754 32.0214 36.5673 31.9817C36.4592 31.942 36.3442 31.9247 36.2292 31.9309V31.9309Z" }), /* @__PURE__ */ React.createElement("path", { d: "M36.23 35.0352H33.5975C33.3727 35.0352 33.1572 35.1245 32.9982 35.2834C32.8393 35.4424 32.75 35.6579 32.75 35.8827C32.75 36.1075 32.8393 36.323 32.9982 36.4819C33.1572 36.6409 33.3727 36.7302 33.5975 36.7302H36.23C36.4548 36.7302 36.6703 36.6409 36.8293 36.4819C36.9882 36.323 37.0775 36.1075 37.0775 35.8827C37.0775 35.6579 36.9882 35.4424 36.8293 35.2834C36.6703 35.1245 36.4548 35.0352 36.23 35.0352Z" }), /* @__PURE__ */ React.createElement("path", { d: "M33.5975 44.1031H36.23C36.4548 44.1031 36.6703 44.0139 36.8293 43.855C36.9882 43.696 37.0775 43.4805 37.0775 43.2557C37.0775 43.031 36.9882 42.8153 36.8293 42.6564C36.6703 42.4974 36.4548 42.4082 36.23 42.4082H33.5975C33.3727 42.4082 33.1572 42.4974 32.9982 42.6564C32.8393 42.8153 32.75 43.031 32.75 43.2557C32.75 43.4805 32.8393 43.696 32.9982 43.855C33.1572 44.0139 33.3727 44.1031 33.5975 44.1031V44.1031Z" }), /* @__PURE__ */ React.createElement("path", { d: "M33.5975 47.2107H36.23C36.4548 47.2107 36.6703 47.1213 36.8293 46.9624C36.9882 46.8035 37.0775 46.5879 37.0775 46.3632C37.0775 46.1384 36.9882 45.9229 36.8293 45.7639C36.6703 45.605 36.4548 45.5156 36.23 45.5156H33.5975C33.3727 45.5156 33.1572 45.605 32.9982 45.7639C32.8393 45.9229 32.75 46.1384 32.75 46.3632C32.75 46.5879 32.8393 46.8035 32.9982 46.9624C33.1572 47.1213 33.3727 47.2107 33.5975 47.2107V47.2107Z" })));
const SvgFrontLoadContainer = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2199_59888)" }, /* @__PURE__ */ React.createElement("path", { d: "M19.2021 36.7191H24.8346C24.9496 36.7254 25.0647 36.7082 25.1728 36.6685C25.2809 36.6288 25.3798 36.5674 25.4634 36.4882C25.5471 36.409 25.6136 36.3136 25.6591 36.2078C25.7046 36.102 25.7281 35.9881 25.7281 35.873C25.7281 35.7578 25.7046 35.6438 25.6591 35.538C25.6136 35.4322 25.5471 35.3368 25.4634 35.2576C25.3798 35.1784 25.2809 35.117 25.1728 35.0773C25.0647 35.0376 24.9496 35.0204 24.8346 35.0266H19.2021C19.0871 35.0204 18.9721 35.0376 18.864 35.0773C18.7558 35.117 18.6569 35.1784 18.5733 35.2576C18.4897 35.3368 18.4231 35.4322 18.3776 35.538C18.3321 35.6438 18.3086 35.7578 18.3086 35.873C18.3086 35.9881 18.3321 36.102 18.3776 36.2078C18.4231 36.3136 18.4897 36.409 18.5733 36.4882C18.6569 36.5674 18.7558 36.6288 18.864 36.6685C18.9721 36.7082 19.0871 36.7254 19.2021 36.7191V36.7191Z" }), /* @__PURE__ */ React.createElement("path", { d: "M19.203 39.3043H24.8355C25.0602 39.3043 25.2758 39.2151 25.4348 39.0561C25.5937 38.8972 25.683 38.6817 25.683 38.4569C25.683 38.2321 25.5937 38.0165 25.4348 37.8575C25.2758 37.6986 25.0602 37.6094 24.8355 37.6094H19.203C18.9782 37.6094 18.7626 37.6986 18.6037 37.8575C18.4448 38.0165 18.3555 38.2321 18.3555 38.4569C18.3555 38.6817 18.4448 38.8972 18.6037 39.0561C18.7626 39.2151 18.9782 39.3043 19.203 39.3043Z" }), /* @__PURE__ */ React.createElement("path", { d: "M51.5246 28.5867L48.8121 27.5292V23.1616C49.3509 23.0016 49.8235 22.6717 50.1596 22.2212C50.4957 21.7707 50.6772 21.2237 50.6771 20.6616V19.3491C50.6771 19.2641 50.6346 19.2216 50.6346 19.1366C50.6028 19.0727 50.5596 19.0151 50.5071 18.9667V18.9241L45.0071 14.6041L44.9646 14.5617C44.9646 14.5192 44.9221 14.5191 44.9221 14.4766L44.8796 14.4367C44.8371 14.4367 44.8371 14.3942 44.7971 14.3942C44.7571 14.3942 44.7546 14.3516 44.7121 14.3516C44.6696 14.3516 44.6696 14.3091 44.6271 14.3091C44.5846 14.3091 44.5846 14.3091 44.5421 14.2666H43.9071C43.7414 13.8876 43.4686 13.5652 43.1222 13.3391C42.7757 13.113 42.3707 12.9931 41.9571 12.9941C41.5434 12.9935 41.1395 13.1189 40.7991 13.3539C40.4587 13.5889 40.1981 13.9221 40.0521 14.3091H38.8646C38.7179 13.9226 38.4572 13.5898 38.1169 13.355C37.7767 13.1202 37.373 12.9944 36.9596 12.9944C36.5461 12.9944 36.1425 13.1202 35.8023 13.355C35.462 13.5898 35.2012 13.9226 35.0546 14.3091H33.8671C33.7022 13.9266 33.4311 13.5994 33.086 13.3663C32.7408 13.1333 32.336 13.0041 31.9196 12.9941C31.5071 12.9995 31.1054 13.1273 30.7658 13.3615C30.4261 13.5956 30.1638 13.9254 30.0121 14.3091H28.8271C28.6663 13.9232 28.3958 13.593 28.0492 13.3593C27.7026 13.1255 27.2951 12.9986 26.8771 12.9941C26.4636 12.9938 26.0597 13.1195 25.7194 13.3544C25.3791 13.5893 25.1184 13.9223 24.9721 14.3091H23.7871C23.631 13.9199 23.3616 13.5866 23.014 13.3522C22.6664 13.1177 22.2564 12.993 21.8371 12.9941C21.4234 12.9931 21.0193 13.1185 20.6788 13.3535C20.3383 13.5885 20.0778 13.9219 19.9321 14.3091H19.5071C19.2519 14.3173 19.0094 14.4229 18.8296 14.6041L13.3295 18.9667V19.0092C13.287 19.0517 13.2446 19.1366 13.2021 19.1791C13.1635 19.2427 13.1484 19.318 13.1596 19.3916V20.7041C13.1648 21.2645 13.3481 21.8087 13.6829 22.2581C14.0177 22.7074 14.4866 23.0387 15.0221 23.2041V27.5691L12.3121 28.6266C12.147 28.6853 12.0048 28.7949 11.906 28.9396C11.8071 29.0843 11.7568 29.2565 11.7621 29.4317V34.4317C11.7619 34.6057 11.8143 34.7757 11.9124 34.9193C12.0106 35.063 12.1499 35.1735 12.3121 35.2366L15.0221 36.2966V43.0741C15.0291 44.278 15.5076 45.4312 16.3549 46.2864C17.2022 47.1416 18.3508 47.6309 19.5546 47.6492V49.9367C19.5559 50.161 19.6456 50.3758 19.8043 50.5344C19.9629 50.6931 20.1777 50.7829 20.4021 50.7842H26.3321C26.5566 50.7835 26.7718 50.694 26.9306 50.5352C27.0894 50.3764 27.1789 50.1612 27.1796 49.9367V47.6616H36.6671V49.9491C36.6684 50.1735 36.7581 50.3884 36.9168 50.547C37.0754 50.7057 37.2902 50.7953 37.5146 50.7966H43.4446C43.6692 50.796 43.8843 50.7064 44.0431 50.5476C44.2019 50.3888 44.2914 50.1737 44.2921 49.9491V47.6616C45.496 47.644 46.645 47.1549 47.4925 46.2996C48.3399 45.4442 48.8182 44.2907 48.8246 43.0867V36.3091L51.5371 35.2492C51.7022 35.1905 51.8444 35.081 51.9432 34.9363C52.042 34.7916 52.0924 34.6192 52.0871 34.4441V29.4042C52.0697 29.2316 52.0091 29.0661 51.9108 28.9232C51.8125 28.7803 51.6796 28.6646 51.5246 28.5867ZM15.0096 34.4741L13.4846 33.8391V29.9841L15.0096 29.3916V34.4741ZM44.0271 15.6766L48.0496 18.6766H44.0271V15.6766ZM41.6121 15.0767C41.6009 15.0212 41.6023 14.9638 41.6159 14.9088C41.6296 14.8539 41.6553 14.8027 41.6912 14.7589C41.7271 14.7151 41.7722 14.6798 41.8234 14.6555C41.8746 14.6313 41.9305 14.6188 41.9871 14.6188C42.0437 14.6188 42.0996 14.6313 42.1508 14.6555C42.202 14.6798 42.2471 14.7151 42.283 14.7589C42.3189 14.8027 42.3446 14.8539 42.3582 14.9088C42.3719 14.9638 42.3732 15.0212 42.3621 15.0767V18.6766H41.6121V15.0767ZM38.9846 16.0066H39.8746V18.6342H38.9846V16.0066ZM36.5721 15.0767C36.5632 15.0223 36.5662 14.9666 36.581 14.9135C36.5957 14.8604 36.6218 14.8112 36.6575 14.7692C36.6932 14.7272 36.7376 14.6934 36.7876 14.6703C36.8376 14.6472 36.892 14.6351 36.9471 14.6351C37.0022 14.6351 37.0566 14.6472 37.1067 14.6703C37.1567 14.6934 37.201 14.7272 37.2367 14.7692C37.2724 14.8112 37.2985 14.8604 37.3132 14.9135C37.3279 14.9666 37.331 15.0223 37.3221 15.0767V18.6766H36.5721V15.0767ZM33.9871 16.0066H34.8771V18.6342H33.9846L33.9871 16.0066ZM31.5296 15.0767C31.5253 15.024 31.532 14.971 31.5492 14.921C31.5664 14.8711 31.5938 14.8252 31.6297 14.7864C31.6655 14.7475 31.709 14.7165 31.7573 14.6953C31.8057 14.6741 31.858 14.6632 31.9109 14.6632C31.9637 14.6632 32.0159 14.6741 32.0643 14.6953C32.1127 14.7165 32.1562 14.7475 32.192 14.7864C32.2279 14.8252 32.2552 14.8711 32.2724 14.921C32.2896 14.971 32.2963 15.024 32.2921 15.0767V18.6766H31.5296V15.0767ZM28.9471 16.0066H29.8371V18.6342H28.9471V16.0066ZM26.4896 15.0767C26.4853 15.024 26.492 14.971 26.5092 14.921C26.5265 14.8711 26.5538 14.8252 26.5896 14.7864C26.6254 14.7475 26.669 14.7165 26.7174 14.6953C26.7658 14.6741 26.818 14.6632 26.8708 14.6632C26.9236 14.6632 26.9759 14.6741 27.0243 14.6953C27.0727 14.7165 27.1162 14.7475 27.152 14.7864C27.1878 14.8252 27.2152 14.8711 27.2324 14.921C27.2497 14.971 27.2564 15.024 27.2521 15.0767V18.6766H26.4846L26.4896 15.0767ZM23.9046 16.0066H24.7946V18.6342H23.9046V16.0066ZM21.4921 15.0767C21.4809 15.0212 21.4823 14.9638 21.4959 14.9088C21.5096 14.8539 21.5353 14.8027 21.5712 14.7589C21.6071 14.7151 21.6522 14.6798 21.7034 14.6555C21.7546 14.6313 21.8105 14.6188 21.8671 14.6188C21.9237 14.6188 21.9796 14.6313 22.0308 14.6555C22.082 14.6798 22.1271 14.7151 22.163 14.7589C22.1989 14.8027 22.2246 14.8539 22.2382 14.9088C22.2519 14.9638 22.2532 15.0212 22.2421 15.0767V18.6766H21.4921V15.0767ZM19.7971 15.6766V18.6766H15.7721L19.7971 15.6766ZM25.4721 49.0466H21.2346V47.6066H25.4846L25.4721 49.0466ZM42.5846 49.0466H38.3496V47.6066H42.5846V49.0466ZM47.1596 43.0316H47.1171C47.1164 43.7957 46.8124 44.5282 46.2719 45.0683C45.7314 45.6083 44.9986 45.9116 44.2346 45.9116H19.6246C18.861 45.911 18.1288 45.6074 17.5888 45.0674C17.0489 44.5274 16.7453 43.7953 16.7446 43.0316V23.2816H47.1596V43.0316ZM48.0921 21.5567H15.7346C15.4994 21.5547 15.2744 21.4601 15.1083 21.2936C14.9422 21.127 14.8484 20.9018 14.8471 20.6666V20.3267H48.9846V20.6616C48.9846 20.8986 48.8907 21.1258 48.7234 21.2936C48.5561 21.4614 48.329 21.556 48.0921 21.5567V21.5567ZM50.3421 33.8391L48.8171 34.4317V29.3491L50.3421 29.9417V33.8391Z" }), /* @__PURE__ */ React.createElement("path", { d: "M38.9842 28.9703H44.6192C44.844 28.9703 45.0595 28.8811 45.2184 28.7222C45.3774 28.5632 45.4667 28.3476 45.4667 28.1228C45.4667 27.898 45.3774 27.6825 45.2184 27.5236C45.0595 27.3646 44.844 27.2754 44.6192 27.2754H38.9842C38.7594 27.2754 38.5439 27.3646 38.3849 27.5236C38.226 27.6825 38.1367 27.898 38.1367 28.1228C38.1367 28.3476 38.226 28.5632 38.3849 28.7222C38.5439 28.8811 38.7594 28.9703 38.9842 28.9703Z" }), /* @__PURE__ */ React.createElement("path", { d: "M38.9853 36.7191H44.6203C44.7353 36.7254 44.8504 36.7082 44.9585 36.6685C45.0666 36.6288 45.1655 36.5674 45.2491 36.4882C45.3327 36.409 45.3993 36.3136 45.4448 36.2078C45.4903 36.102 45.5138 35.9881 45.5138 35.873C45.5138 35.7578 45.4903 35.6438 45.4448 35.538C45.3993 35.4322 45.3327 35.3368 45.2491 35.2576C45.1655 35.1784 45.0666 35.117 44.9585 35.0773C44.8504 35.0376 44.7353 35.0204 44.6203 35.0266H38.9853C38.8703 35.0204 38.7552 35.0376 38.6471 35.0773C38.539 35.117 38.4401 35.1784 38.3565 35.2576C38.2729 35.3368 38.2063 35.4322 38.1608 35.538C38.1153 35.6438 38.0918 35.7578 38.0918 35.873C38.0918 35.9881 38.1153 36.102 38.1608 36.2078C38.2063 36.3136 38.2729 36.409 38.3565 36.4882C38.4401 36.5674 38.539 36.6288 38.6471 36.6685C38.7552 36.7082 38.8703 36.7254 38.9853 36.7191Z" }), /* @__PURE__ */ React.createElement("path", { d: "M38.9842 34.1383H44.6192C44.844 34.1383 45.0595 34.0491 45.2184 33.8901C45.3774 33.7312 45.4667 33.5155 45.4667 33.2908C45.4667 33.066 45.3774 32.8505 45.2184 32.6915C45.0595 32.5326 44.844 32.4434 44.6192 32.4434H38.9842C38.7594 32.4434 38.5439 32.5326 38.3849 32.6915C38.226 32.8505 38.1367 33.066 38.1367 33.2908C38.1367 33.5155 38.226 33.7312 38.3849 33.8901C38.5439 34.0491 38.7594 34.1383 38.9842 34.1383Z" }), /* @__PURE__ */ React.createElement("path", { d: "M19.203 34.1383H24.8355C25.0602 34.1383 25.2758 34.0491 25.4348 33.8901C25.5937 33.7312 25.683 33.5155 25.683 33.2908C25.683 33.066 25.5937 32.8505 25.4348 32.6915C25.2758 32.5326 25.0602 32.4434 24.8355 32.4434H19.203C18.9782 32.4434 18.7626 32.5326 18.6037 32.6915C18.4448 32.8505 18.3555 33.066 18.3555 33.2908C18.3555 33.5155 18.4448 33.7312 18.6037 33.8901C18.7626 34.0491 18.9782 34.1383 19.203 34.1383Z" }), /* @__PURE__ */ React.createElement("path", { d: "M38.9853 31.5531H44.6203C44.7353 31.5594 44.8504 31.5422 44.9585 31.5025C45.0666 31.4628 45.1655 31.4014 45.2491 31.3222C45.3327 31.243 45.3993 31.1476 45.4448 31.0418C45.4903 30.936 45.5138 30.822 45.5138 30.7068C45.5138 30.5916 45.4903 30.4778 45.4448 30.372C45.3993 30.2662 45.3327 30.1708 45.2491 30.0916C45.1655 30.0124 45.0666 29.951 44.9585 29.9113C44.8504 29.8716 44.7353 29.8544 44.6203 29.8606H38.9853C38.8703 29.8544 38.7552 29.8716 38.6471 29.9113C38.539 29.951 38.4401 30.0124 38.3565 30.0916C38.2729 30.1708 38.2063 30.2662 38.1608 30.372C38.1153 30.4778 38.0918 30.5916 38.0918 30.7068C38.0918 30.822 38.1153 30.936 38.1608 31.0418C38.2063 31.1476 38.2729 31.243 38.3565 31.3222C38.4401 31.4014 38.539 31.4628 38.6471 31.5025C38.7552 31.5422 38.8703 31.5594 38.9853 31.5531Z" }), /* @__PURE__ */ React.createElement("path", { d: "M19.2021 31.5531H24.8346C24.9496 31.5594 25.0647 31.5422 25.1728 31.5025C25.2809 31.4628 25.3798 31.4014 25.4634 31.3222C25.5471 31.243 25.6136 31.1476 25.6591 31.0418C25.7046 30.936 25.7281 30.822 25.7281 30.7068C25.7281 30.5916 25.7046 30.4778 25.6591 30.372C25.6136 30.2662 25.5471 30.1708 25.4634 30.0916C25.3798 30.0124 25.2809 29.951 25.1728 29.9113C25.0647 29.8716 24.9496 29.8544 24.8346 29.8606H19.2021C19.0871 29.8544 18.9721 29.8716 18.864 29.9113C18.7558 29.951 18.6569 30.0124 18.5733 30.0916C18.4897 30.1708 18.4231 30.2662 18.3776 30.372C18.3321 30.4778 18.3086 30.5916 18.3086 30.7068C18.3086 30.822 18.3321 30.936 18.3776 31.0418C18.4231 31.1476 18.4897 31.243 18.5733 31.3222C18.6569 31.4014 18.7558 31.4628 18.864 31.5025C18.9721 31.5422 19.0871 31.5594 19.2021 31.5531V31.5531Z" }), /* @__PURE__ */ React.createElement("path", { d: "M19.203 28.9703H24.8355C25.0602 28.9703 25.2758 28.8811 25.4348 28.7222C25.5937 28.5632 25.683 28.3476 25.683 28.1228C25.683 27.898 25.5937 27.6825 25.4348 27.5236C25.2758 27.3646 25.0602 27.2754 24.8355 27.2754H19.203C18.9782 27.2754 18.7626 27.3646 18.6037 27.5236C18.4448 27.6825 18.3555 27.898 18.3555 28.1228C18.3555 28.3476 18.4448 28.5632 18.6037 28.7222C18.7626 28.8811 18.9782 28.9703 19.203 28.9703Z" }), /* @__PURE__ */ React.createElement("path", { d: "M38.9842 39.3043H44.6192C44.844 39.3043 45.0595 39.2151 45.2184 39.0561C45.3774 38.8972 45.4667 38.6817 45.4667 38.4569C45.4667 38.2321 45.3774 38.0165 45.2184 37.8575C45.0595 37.6986 44.844 37.6094 44.6192 37.6094H38.9842C38.7594 37.6094 38.5439 37.6986 38.3849 37.8575C38.226 38.0165 38.1367 38.2321 38.1367 38.4569C38.1367 38.6817 38.226 38.8972 38.3849 39.0561C38.5439 39.2151 38.7594 39.3043 38.9842 39.3043Z" })));
const SvgHandPickup = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2199_59889)" }, /* @__PURE__ */ React.createElement("path", { d: "M42.6719 29.2653C42.8192 28.6264 42.8071 27.961 42.6368 27.3278L41.8719 24.4352C41.6494 23.5902 41.8718 23.1453 42.2593 22.4053C42.3268 22.2753 42.3969 22.1403 42.4669 21.9953C42.5787 21.7976 42.6333 21.5726 42.6245 21.3456C42.6156 21.1187 42.5438 20.8987 42.4169 20.7103C42.2146 20.4357 41.9542 20.2091 41.6543 20.0466C41.3544 19.8841 41.0224 19.7898 40.6819 19.7703C39.9769 19.7378 39.6444 20.1353 39.3669 20.5478L39.2919 20.6652L37.9518 14.8577C38.0068 13.5252 37.1243 12.6753 36.2018 12.5253C35.3493 12.3828 34.3269 12.8303 33.9669 14.1528C33.8819 14.4603 33.7944 14.8377 33.7169 15.1802L31.2169 26.7878C30.5869 27.1653 30.4669 28.0028 30.3944 28.5778L29.9493 31.8078C29.5982 31.7776 29.2445 31.7987 28.8994 31.8703C28.4738 31.946 28.095 32.1857 27.8444 32.5378C27.6955 32.774 27.619 33.0487 27.6244 33.3278C26.7074 33.5868 25.8894 34.1154 25.2769 34.8453C24.8554 34.8437 24.4455 34.9828 24.1119 35.2403C23.7325 35.5533 23.4175 35.9371 23.1844 36.3703L22.9494 36.7753C21.5469 39.3553 21.5869 41.1228 21.6219 42.5578C21.6419 43.3203 21.6569 43.9803 21.4219 44.5928C21.1294 45.3578 20.6868 46.5128 21.3168 47.4528C21.5126 47.7698 21.7833 48.0338 22.105 48.2216C22.4267 48.4095 22.7896 48.5155 23.1619 48.5303C23.5046 48.5208 23.8392 48.4238 24.1341 48.2489C24.429 48.0739 24.6743 47.8266 24.8469 47.5303C25.3382 46.7529 25.615 45.8593 25.6494 44.9403C25.6494 43.9678 25.2519 43.6278 24.8569 43.3653C24.7169 43.2703 24.6593 43.2279 24.6293 43.1604C24.0418 41.8429 25.5844 38.7278 26.9944 37.7678C27.163 37.6632 27.3083 37.5252 27.4214 37.3623C27.5345 37.1993 27.6129 37.0148 27.6519 36.8203C27.6821 36.6385 27.6667 36.4521 27.6069 36.2778C27.7824 36.1511 27.9741 36.0486 28.1769 35.9728C28.3744 36.6503 28.7469 37.3078 29.9994 37.2028C30.731 37.1484 31.4561 37.3725 32.0294 37.8303C32.7494 38.3428 33.3518 38.3703 33.8268 37.9128C33.9106 38.0384 33.9826 38.1714 34.0419 38.3103C33.8731 38.4285 33.7392 38.59 33.6544 38.7778C33.5768 38.9695 33.5413 39.1757 33.5504 39.3823C33.5594 39.5889 33.6128 39.7911 33.7069 39.9753C34.3869 41.4278 34.2068 43.9553 33.3218 45.2753L33.2469 45.3878C32.9769 45.7978 32.9544 45.8303 32.5944 45.8403C32.0219 45.8553 31.5069 46.2028 31.1119 46.8403C30.4619 47.8978 30.2644 49.5303 30.6819 50.4028C30.8127 50.6595 31.0043 50.8803 31.2401 51.0459C31.4758 51.2114 31.7485 51.3168 32.0344 51.3527C32.1732 51.3756 32.3136 51.3873 32.4544 51.3878C33.0526 51.3995 33.6324 51.1812 34.0743 50.7778C34.5868 50.2653 34.7943 49.4453 34.9418 48.6353C35.0618 47.9878 35.4169 47.4303 35.8319 46.7828C36.9544 45.0328 38.4043 41.4178 37.5093 39.2403C37.3667 38.8714 37.1079 38.5589 36.7719 38.3503C36.6019 37.3734 36.1581 36.4648 35.4919 35.7303C35.7419 35.2078 35.7819 34.4177 34.6569 33.5402C34.4583 33.3862 34.2495 33.246 34.0319 33.1203L35.1419 29.5828C35.3372 29.0528 35.3372 28.4703 35.1419 27.9403L35.7244 25.2578V25.2153L35.9294 24.2678L36.5419 26.9202C36.6692 27.3448 36.6856 27.795 36.5894 28.2277C36.4984 28.6658 36.5078 29.1189 36.6169 29.5528L37.3019 32.8328C37.6344 34.3828 39.0018 34.9078 40.1293 34.7403C41.2568 34.5728 42.3793 33.7053 42.2518 32.1903C42.2177 31.8721 42.1677 31.5559 42.1019 31.2427C42.0769 31.1152 42.0519 30.9927 42.0294 30.8627V30.8378C42.0294 30.7853 42.0143 30.7453 42.0093 30.7128C42.0443 30.6628 42.0919 30.5978 42.1494 30.5053C42.3904 30.1235 42.5669 29.7045 42.6719 29.2653V29.2653ZM23.1544 47.0378C23.0304 47.0197 22.9123 46.973 22.8095 46.9014C22.7066 46.8298 22.6219 46.7353 22.5619 46.6253C22.3619 46.3278 22.6569 45.5628 22.7969 45.1978L22.8218 45.1328C23.0297 44.5651 23.1339 43.9648 23.1293 43.3603C23.1671 43.5013 23.2156 43.6392 23.2744 43.7728C23.4098 44.0799 23.638 44.3369 23.9269 44.5078C24.1194 44.6353 24.1769 44.6653 24.1769 44.9653C24.1369 45.5858 23.9446 46.1868 23.6169 46.7153C23.5728 46.8006 23.509 46.8742 23.4307 46.9299C23.3524 46.9855 23.262 47.0217 23.1669 47.0354L23.1544 47.0378ZM23.1169 41.5378C23.1494 40.3753 23.3669 39.0103 24.4744 37.1328C24.6082 36.8736 24.7877 36.6406 25.0043 36.4453C25.0749 36.3869 25.1628 36.3535 25.2543 36.3503C25.4321 36.3632 25.6038 36.4199 25.7543 36.5153L25.8669 36.5753L26.0144 36.6528C24.7769 37.5878 23.4694 39.6528 23.1169 41.5378V41.5378ZM36.0794 16.5602L33.8294 26.8727C33.49 26.7438 33.1368 26.6549 32.7769 26.6077L35.0944 15.9003L35.3994 14.5728C35.5219 14.1328 35.8194 13.9603 36.0519 14.0153C36.2844 14.0703 36.5168 14.4403 36.3818 15.1053L36.0643 16.5602H36.0794ZM32.9094 36.6228C32.6092 36.406 32.2875 36.2209 31.9493 36.0703C32.3153 36.0477 32.6649 35.9109 32.9489 35.679C33.2328 35.4471 33.4367 35.1318 33.5319 34.7778L33.5819 34.6177C33.6394 34.6577 33.6969 34.6978 33.7494 34.7403C33.9044 34.8439 34.0362 34.9784 34.1368 35.1353L32.9518 36.6553C32.9387 36.644 32.9245 36.6339 32.9094 36.6253V36.6228ZM29.1119 33.3728C29.153 33.3554 29.1957 33.3421 29.2394 33.3328C29.4037 33.2985 29.5719 33.2867 29.7394 33.2978L29.6769 33.7453C29.6392 34.1389 29.7129 34.5352 29.8898 34.8889C30.0666 35.2425 30.3394 35.5393 30.6769 35.7453C30.5349 35.7302 30.3922 35.7227 30.2494 35.7228C30.1294 35.7228 29.9993 35.7227 29.8868 35.7377H29.7644C29.7311 35.7355 29.6977 35.7355 29.6644 35.7377C29.627 35.6375 29.6002 35.5336 29.5844 35.4278C29.5694 35.3603 29.5544 35.2878 29.5369 35.2103L29.1219 33.4278C29.1169 33.3953 29.1144 33.3778 29.1119 33.3653V33.3728ZM32.1119 28.0953C32.4569 27.9778 33.4119 28.1928 33.6844 28.4503C33.7869 28.5478 33.8844 28.7003 33.7344 29.1678L32.1119 34.3403L32.0994 34.3853C32.0994 34.4453 32.0543 34.6203 31.7568 34.5778C31.5945 34.5597 31.4448 34.4814 31.3374 34.3582C31.23 34.2351 31.1728 34.0761 31.1769 33.9128L31.6769 30.2103L31.8793 28.7303C31.9393 28.3078 31.9819 28.1278 32.0944 28.0878L32.1119 28.0953ZM37.2319 18.3953L39.1444 26.6878C39.1644 26.8028 39.1919 26.9078 39.2169 27.0028C39.2969 27.3028 39.2969 27.3028 39.1544 27.3978C38.9538 27.5223 38.715 27.5703 38.4819 27.5328C38.2194 27.4878 38.2119 27.4478 38.1544 27.1953L38.0643 26.8278C38.0368 26.7203 38.0069 26.6103 37.9819 26.5028L36.6918 20.8928L37.2319 18.3953ZM40.9418 21.7253C40.4418 22.6903 40.0718 23.4503 40.4418 24.8253L41.0419 27.0978C41.0069 27.0553 40.9719 27.0128 40.9319 26.9703C40.8184 26.8563 40.7269 26.7224 40.6619 26.5753L40.0294 23.8253C39.8494 23.0353 40.0294 22.2753 40.6469 21.3603L40.6619 21.3378C40.6748 21.3179 40.6899 21.2994 40.7069 21.2828C40.8485 21.2982 40.982 21.3567 41.0894 21.4503L40.9418 21.7253ZM40.1144 28.5478V28.5928L40.7668 32.4103C40.8443 32.8653 40.4294 33.1977 39.9769 33.2902C39.8479 33.3258 39.7129 33.3344 39.5804 33.3154C39.4479 33.2964 39.3208 33.2502 39.207 33.1798C39.0932 33.1094 38.9952 33.0162 38.919 32.9062C38.8428 32.7962 38.7902 32.6715 38.7643 32.5402L38.0544 29.1428C38.0369 29.0553 38.0269 29.0053 38.0219 28.9553C38.3786 29.0452 38.7508 29.0544 39.1115 28.9821C39.4722 28.9099 39.8123 28.7581 40.1069 28.5378L40.1144 28.5478ZM32.0519 49.7978C31.8969 49.4678 31.9994 48.4453 32.3419 47.7653C32.4969 47.4553 32.6294 47.3703 32.6544 47.3653C33.4044 47.3453 33.8094 47.1153 34.1544 46.7253C33.8356 47.2424 33.6113 47.8121 33.4919 48.4078C33.4419 48.6778 33.2919 49.5053 33.0344 49.7603C32.9279 49.8339 32.8079 49.8856 32.6813 49.9127C32.5548 49.9397 32.4241 49.9414 32.2969 49.9178C32.248 49.9151 32.2003 49.9021 32.1567 49.8797C32.1132 49.8573 32.0749 49.826 32.0444 49.7878L32.0519 49.7978ZM35.1669 39.5478C35.7169 39.5203 36.0394 39.5728 36.1494 39.8403C36.6494 41.0653 35.9718 43.3652 35.1293 45.0502C35.7643 43.3477 35.8069 41.1053 35.1594 39.5378L35.1669 39.5478Z" })));
const SvgOtherCompactor = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2199_59891)" }, /* @__PURE__ */ React.createElement("path", { d: "M61.0925 28.2375H57.4975V19.215H58.9975C59.1964 19.215 59.3872 19.136 59.5278 18.9954C59.6685 18.8547 59.7475 18.6639 59.7475 18.465V15.5C59.7475 15.3011 59.6685 15.1104 59.5278 14.9697C59.3872 14.8291 59.1964 14.75 58.9975 14.75H19.1025C18.9036 14.75 18.7128 14.8291 18.5722 14.9697C18.4315 15.1104 18.3525 15.3011 18.3525 15.5V17.75C11.58 18.165 2 23.4525 2 29.91C2.0001 30.0258 2.027 30.14 2.07861 30.2436C2.13023 30.3473 2.20517 30.4377 2.29752 30.5076L17.715 42.1426L11.2675 47.8075C11.153 47.9085 11.072 48.0421 11.0354 48.1903C10.9988 48.3385 11.0084 48.4944 11.0627 48.6371C11.1171 48.7798 11.2137 48.9023 11.3396 48.9886C11.4655 49.0749 11.6148 49.1208 11.7675 49.12H52.095C52.2497 49.1196 52.4005 49.0713 52.5268 48.9818C52.653 48.8923 52.7484 48.7659 52.8 48.62L56.9725 37.0575H58.5775C58.7111 37.0575 58.8422 37.0218 58.9574 36.9541C59.0725 36.8864 59.1675 36.7892 59.2325 36.6725L61.7525 32.1426C61.8147 32.031 61.8474 31.9052 61.8475 31.7775V28.99C61.8478 28.8909 61.8285 28.7927 61.7906 28.701C61.7528 28.6094 61.6972 28.5263 61.6269 28.4563C61.5567 28.3863 61.4734 28.331 61.3816 28.2935C61.2899 28.2559 61.1916 28.2369 61.0925 28.2375V28.2375ZM60.3425 30.9551H36.0575L36.9425 29.7375H60.3425V30.9551ZM19.935 35.5425V32.6675H34.0575V35.5425H19.935ZM8.85501 33.5701L5.04001 30.6901H18.435V33.5675H8.85501V33.5701ZM18.435 29.1901H6.05499C7.23749 27.2276 10.87 22.4401 18.435 21.7051V29.1901ZM55.9975 28.2375H36.56C36.4421 28.2376 36.3259 28.2655 36.2207 28.319C36.1156 28.3724 36.0246 28.4498 35.955 28.545L34.205 30.9575C34.1592 31.0216 34.1238 31.0924 34.1 31.1675H19.94V19.215H28.345V24.855C28.345 25.0797 28.4343 25.2954 28.5932 25.4543C28.7522 25.6133 28.9677 25.7025 29.1925 25.7025C29.4173 25.7025 29.6328 25.6133 29.7918 25.4543C29.9507 25.2954 30.04 25.0797 30.04 24.855V19.215H34.76V24.855C34.7718 25.0715 34.8661 25.2752 35.0235 25.4243C35.1809 25.5734 35.3895 25.6565 35.6063 25.6565C35.8231 25.6565 36.0316 25.5734 36.189 25.4243C36.3464 25.2752 36.4407 25.0715 36.4525 24.855V19.215H41.1725V24.855C41.1725 25.0797 41.2618 25.2954 41.4207 25.4543C41.5797 25.6133 41.7952 25.7025 42.02 25.7025C42.2448 25.7025 42.4603 25.6133 42.6193 25.4543C42.7782 25.2954 42.8675 25.0797 42.8675 24.855V19.215H47.585V24.855C47.585 25.0797 47.6743 25.2954 47.8332 25.4543C47.9922 25.6133 48.2077 25.7025 48.4325 25.7025C48.6573 25.7025 48.8728 25.6133 49.0318 25.4543C49.1907 25.2954 49.28 25.0797 49.28 24.855V19.215H56.0075L55.9975 28.2375ZM19.8525 16.2375H58.2475V17.7025H19.8525V16.2375ZM8.99499 22.4401C11.895 20.6326 15.51 19.4125 18.435 19.2275V20.1875C8.8275 21.0425 5.01999 27.7975 4.33749 29.1875H3.7825C3.70263 29.1892 3.62346 29.2027 3.54752 29.2275C3.86252 26.8775 5.80499 24.44 8.99499 22.4525V22.4401ZM18.435 47.6H13.7525L18.435 43.4875V47.6ZM10.84 35.055H18.435V40.785L10.84 35.055ZM51.5625 47.6H19.935V37.03H34.685C34.7279 37.038 34.7714 37.0421 34.815 37.0425H55.3825L51.5625 47.6ZM58.13 35.5425H35.5575V32.4425H59.855L58.13 35.5425Z" })));
const SvgOtherContainer = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2199_59893)" }, /* @__PURE__ */ React.createElement("path", { d: "M47.795 13.75H15.955C15.0391 13.7513 14.1611 14.1158 13.5134 14.7634C12.8658 15.4111 12.5013 16.289 12.5 17.205V19.135L12.6325 20.25L15.045 44.72C15.1105 45.4105 15.4317 46.0516 15.9456 46.5173C16.4595 46.9831 17.1289 47.24 17.8225 47.2376H19.37L19.92 49.4876C19.9638 49.668 20.0669 49.8285 20.213 49.9432C20.359 50.058 20.5393 50.1202 20.725 50.12H27.03C27.2155 50.1205 27.3957 50.0583 27.5414 49.9435C27.6871 49.8287 27.7896 49.668 27.8325 49.4876L28.385 47.2376H35.3675L35.92 49.4876C35.9629 49.668 36.0655 49.8287 36.2111 49.9435C36.3568 50.0583 36.537 50.1205 36.7225 50.12H43.0275C43.2132 50.1202 43.3936 50.058 43.5396 49.9432C43.6856 49.8285 43.7887 49.668 43.8325 49.4876L44.3825 47.2376H45.925C46.6184 47.2395 47.2875 46.9824 47.8013 46.5167C48.3151 46.0511 48.6364 45.4102 48.7025 44.72L51.1225 20.2426L51.2525 19.17V17.2175C51.2538 16.7626 51.1654 16.312 50.9922 15.8914C50.819 15.4707 50.5646 15.0884 50.2434 14.7662C49.9222 14.4441 49.5406 14.1885 49.1204 14.0142C48.7003 13.8398 48.2499 13.75 47.795 13.75V13.75ZM26.3725 48.4525H21.3725L21.07 47.225H26.6775L26.3725 48.4525ZM42.3725 48.4525H37.3725L37.0725 47.225H42.6775L42.3725 48.4525ZM47.05 44.5451C47.0232 44.826 46.8925 45.0868 46.6835 45.2764C46.4745 45.466 46.2022 45.5707 45.92 45.5701H17.8225C17.5401 45.5713 17.2676 45.4667 17.0584 45.277C16.8493 45.0873 16.7187 44.8262 16.6925 44.5451L14.32 20.49H49.435L47.05 44.5451ZM49.595 18.8225L14.15 18.8075V17.205C14.1507 16.7278 14.3405 16.2704 14.6779 15.933C15.0154 15.5956 15.4728 15.4057 15.95 15.405H47.795C48.2718 15.4064 48.7286 15.5965 49.0655 15.9338C49.4023 16.2712 49.5918 16.7282 49.5925 17.205L49.595 18.8225Z" }), /* @__PURE__ */ React.createElement("path", { d: "M40.9333 42.7627H44.2032C44.4095 42.7641 44.6088 42.6877 44.7613 42.5487C44.9137 42.4097 45.0081 42.2183 45.0257 42.0127L46.5482 24.2002C46.5579 24.086 46.5438 23.9711 46.5067 23.8627C46.4697 23.7542 46.4105 23.6546 46.3329 23.5702C46.2554 23.4858 46.1611 23.4185 46.0562 23.3724C45.9512 23.3264 45.8378 23.3027 45.7232 23.3027H42.0457C41.8355 23.3029 41.6332 23.3832 41.48 23.5271C41.3268 23.671 41.2341 23.8679 41.2207 24.0778L40.1032 41.8903C40.0961 42.0029 40.1121 42.1159 40.1503 42.2222C40.1885 42.3284 40.2482 42.4256 40.3255 42.5078C40.4029 42.5901 40.4963 42.6556 40.5999 42.7003C40.7036 42.745 40.8153 42.7679 40.9282 42.7677L40.9333 42.7627ZM42.8282 24.9528H44.8282L43.4483 41.1078H41.8208L42.8282 24.9528Z" }), /* @__PURE__ */ React.createElement("path", { d: "M33.8069 42.7618H37.0744C37.289 42.7626 37.4954 42.6798 37.6499 42.5309C37.8044 42.382 37.8947 42.1788 37.9019 41.9643L38.5419 24.1544C38.5463 24.0434 38.5282 23.9326 38.4887 23.8287C38.4492 23.7249 38.3891 23.63 38.312 23.5499C38.235 23.4698 38.1426 23.4061 38.0403 23.3627C37.938 23.3192 37.828 23.2968 37.7169 23.2969H34.0444C33.8273 23.2975 33.619 23.3832 33.4643 23.5355C33.3096 23.6879 33.2208 23.8949 33.2169 24.1119L32.9669 41.9244C32.9652 42.034 32.9855 42.1428 33.0263 42.2445C33.0672 42.3462 33.1279 42.4387 33.2049 42.5167C33.282 42.5947 33.3738 42.6565 33.475 42.6986C33.5762 42.7407 33.6848 42.7622 33.7944 42.7618H33.8069ZM34.8619 24.9519H36.8619L36.2794 41.1069H34.6469L34.8619 24.9519Z" }), /* @__PURE__ */ React.createElement("path", { d: "M26.68 42.7618H29.9475C30.0573 42.7635 30.1664 42.7435 30.2683 42.7026C30.3703 42.6618 30.4632 42.6011 30.5415 42.5242C30.6199 42.4472 30.6822 42.3554 30.7249 42.2542C30.7675 42.1529 30.7896 42.0443 30.7899 41.9344C30.79 41.8799 30.785 41.8254 30.7749 41.7719L30.5249 24.1119C30.521 23.8949 30.4322 23.6879 30.2775 23.5355C30.1228 23.3832 29.9146 23.2975 29.6975 23.2969H26.045C25.9336 23.2965 25.8234 23.3186 25.7208 23.3619C25.6182 23.4053 25.5255 23.4688 25.4481 23.549C25.3708 23.6291 25.3106 23.7241 25.2709 23.8281C25.2313 23.9322 25.213 24.0432 25.2174 24.1544L25.8575 41.9644C25.8646 42.1779 25.9543 42.3804 26.1077 42.5292C26.2611 42.6779 26.4663 42.7613 26.68 42.7618V42.7618ZM28.8949 24.9519L29.11 41.1069H27.48L26.8974 24.9519H28.8949Z" }), /* @__PURE__ */ React.createElement("path", { d: "M19.545 42.7618H22.8125C22.9221 42.7632 23.0309 42.7429 23.1326 42.7019C23.2343 42.6609 23.3269 42.6001 23.405 42.5232C23.4831 42.4463 23.5452 42.3546 23.5876 42.2535C23.6301 42.1525 23.6522 42.0441 23.6525 41.9344C23.6525 41.8663 23.645 41.7984 23.63 41.7319L22.52 24.0719C22.5066 23.8621 22.4139 23.6652 22.2607 23.5212C22.1075 23.3773 21.9052 23.2971 21.695 23.2969H18.045C17.9304 23.2972 17.8171 23.3212 17.7121 23.3672C17.6072 23.4132 17.5129 23.4804 17.435 23.5645C17.3572 23.6487 17.2979 23.7482 17.2609 23.8567C17.2239 23.9652 17.2099 24.0803 17.22 24.1945L18.7425 42.007C18.7591 42.2098 18.8504 42.3991 18.9986 42.5386C19.1468 42.678 19.3415 42.7576 19.545 42.7618V42.7618ZM20.9175 24.9519L21.9175 41.1069H20.2925L18.91 24.9519H20.9175Z" })));
const SvgRearLoadContainer = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2199_59897)" }, /* @__PURE__ */ React.createElement("path", { d: "M54.3967 20.2296H53.0442V16.8622C53.0442 16.6633 52.9652 16.4725 52.8245 16.3318C52.6839 16.1911 52.4931 16.1122 52.2942 16.1122H50.8817C50.8518 16.1097 50.8216 16.1097 50.7917 16.1122V15.8021C50.6312 15.4238 50.366 15.0991 50.0271 14.8666C49.6882 14.634 49.29 14.5033 48.8792 14.4896C48.5534 14.4887 48.2323 14.5667 47.9432 14.7169C47.6541 14.8671 47.4057 15.0851 47.2192 15.3522H46.0992C45.91 15.092 45.6634 14.8787 45.3786 14.7291C45.0938 14.5796 44.7783 14.4976 44.4567 14.4896C44.1307 14.4872 43.809 14.5645 43.5197 14.7149C43.2303 14.8652 42.9821 15.084 42.7967 15.3522H41.6792C41.49 15.092 41.2435 14.8787 40.9586 14.7291C40.6738 14.5796 40.3583 14.4976 40.0367 14.4896C39.7111 14.4876 39.3899 14.5652 39.101 14.7155C38.8122 14.8658 38.5644 15.0844 38.3792 15.3522H37.2567C37.0675 15.092 36.821 14.8787 36.5361 14.7291C36.2513 14.5796 35.9358 14.4976 35.6142 14.4896C35.2884 14.4885 34.9672 14.5663 34.678 14.7166C34.3889 14.8668 34.1406 15.0849 33.9542 15.3522H32.7392H32.6917C32.5029 15.0906 32.2562 14.8761 31.9709 14.7256C31.6855 14.5751 31.3692 14.4926 31.0467 14.4846C30.7207 14.4822 30.3989 14.5595 30.1096 14.7099C29.8203 14.8602 29.5721 15.079 29.3867 15.3472H28.1792C27.99 15.087 27.7435 14.8737 27.4586 14.7241C27.1738 14.5746 26.8583 14.4926 26.5367 14.4846C26.2106 14.4822 25.889 14.5595 25.5997 14.7099C25.3103 14.8602 25.0621 15.079 24.8767 15.3472H23.8067C23.7726 15.3447 23.7383 15.3447 23.7042 15.3472C23.5152 15.0843 23.2678 14.8687 22.9816 14.7173C22.6953 14.5659 22.3779 14.4828 22.0542 14.4746C21.726 14.4734 21.4025 14.5526 21.1118 14.7051C20.8212 14.8576 20.5722 15.0789 20.3867 15.3496C20.3502 15.3458 20.3132 15.3458 20.2767 15.3496H19.0992C18.91 15.0894 18.6634 14.8763 18.3786 14.7267C18.0938 14.5771 17.7783 14.4952 17.4567 14.4872C17.0432 14.4856 16.6391 14.6104 16.2986 14.845C15.9581 15.0796 15.6975 15.4128 15.5517 15.7997H15.5392V16.1972C15.5084 16.2183 15.4791 16.2417 15.4517 16.2671L11.8467 19.7971C11.7317 19.9104 11.6563 20.0577 11.6317 20.2172H9.51172C9.31281 20.2172 9.12204 20.2961 8.98138 20.4368C8.84073 20.5774 8.76172 20.7683 8.76172 20.9672V23.9321C8.76172 24.1311 8.84073 24.3219 8.98138 24.4625C9.12204 24.6032 9.31281 24.6821 9.51172 24.6821H12.6067L18.3892 34.3596C18.3828 34.3675 18.3769 34.3759 18.3717 34.3847L16.4042 38.1347C16.3482 38.2419 16.3191 38.3612 16.3192 38.4822V40.5371C16.3192 40.736 16.3982 40.9269 16.5389 41.0675C16.6795 41.2082 16.8703 41.2871 17.0692 41.2871H19.7142C19.0544 41.6121 18.4902 42.1027 18.0768 42.7111C17.6635 43.3194 17.415 44.0247 17.3558 44.7578C17.2966 45.4909 17.4287 46.2268 17.7391 46.8936C18.0496 47.5604 18.5278 48.1352 19.1269 48.5618C19.726 48.9884 20.4256 49.2523 21.1572 49.3275C21.8889 49.4028 22.6275 49.2869 23.301 48.9911C23.9744 48.6954 24.5596 48.2299 24.9992 47.6403C25.4389 47.0506 25.7179 46.357 25.8092 45.6272H25.8742H45.0617C45.1231 46.3003 45.3442 46.9489 45.7066 47.5194C46.069 48.0899 46.5622 48.5658 47.1453 48.9075C47.7284 49.2492 48.3846 49.4469 49.0594 49.4843C49.7342 49.5216 50.4082 49.3974 51.0255 49.1221C51.6427 48.8468 52.1854 48.4282 52.6085 47.9011C53.0315 47.3741 53.3228 46.7538 53.4581 46.0916C53.5934 45.4294 53.5688 44.7445 53.3864 44.0938C53.2039 43.443 52.8689 42.845 52.4092 42.3496V24.6721H54.4092C54.6081 24.6721 54.7989 24.5932 54.9395 24.4525C55.0802 24.3119 55.1592 24.121 55.1592 23.9221V20.9796C55.1592 20.8801 55.1394 20.7815 55.101 20.6897C55.0625 20.5979 55.0061 20.5146 54.9351 20.4448C54.8641 20.375 54.78 20.32 54.6876 20.2831C54.5951 20.2461 54.4963 20.228 54.3967 20.2296V20.2296ZM50.8817 17.6122H51.5442V20.2296H50.7942V17.6022C50.823 17.6079 50.8523 17.6112 50.8817 17.6122V17.6122ZM19.3567 16.8622H20.1242V20.2296H19.3567V16.8622ZM23.9542 16.8622H24.6042V20.2296H23.9542V16.8622ZM28.4342 16.8622H29.1217V20.2296H28.4292L28.4342 16.8622ZM32.9517 16.8622H33.7017V20.2296H32.9517V16.8622ZM37.5217 16.8622H38.1142V20.2296H37.5217V16.8622ZM41.9442 16.8622H42.5367V20.2296H41.9442V16.8622ZM46.3692 16.8622H46.9617V20.2296H46.3692V16.8622ZM48.5417 16.5746C48.5374 16.5219 48.5441 16.469 48.5613 16.4191C48.5786 16.3691 48.606 16.3233 48.6418 16.2844C48.6776 16.2456 48.7211 16.2146 48.7695 16.1934C48.8179 16.1722 48.8701 16.1613 48.923 16.1613C48.9758 16.1613 49.028 16.1722 49.0764 16.1934C49.1248 16.2146 49.1683 16.2456 49.2041 16.2844C49.2399 16.3233 49.2673 16.3691 49.2845 16.4191C49.3018 16.469 49.3085 16.5219 49.3042 16.5746V20.1747H48.5417V16.5746ZM44.1167 16.5746C44.1124 16.5219 44.1191 16.469 44.1364 16.4191C44.1536 16.3691 44.181 16.3233 44.2168 16.2844C44.2526 16.2456 44.2961 16.2146 44.3445 16.1934C44.3929 16.1722 44.4451 16.1613 44.4979 16.1613C44.5508 16.1613 44.603 16.1722 44.6514 16.1934C44.6998 16.2146 44.7433 16.2456 44.7791 16.2844C44.8149 16.3233 44.8423 16.3691 44.8596 16.4191C44.8768 16.469 44.8835 16.5219 44.8792 16.5746V20.1747H44.1167V16.5746ZM39.6942 16.5746C39.6899 16.5219 39.6966 16.469 39.7139 16.4191C39.7311 16.3691 39.7584 16.3233 39.7943 16.2844C39.8301 16.2456 39.8735 16.2146 39.9219 16.1934C39.9703 16.1722 40.0226 16.1613 40.0754 16.1613C40.1283 16.1613 40.1805 16.1722 40.2289 16.1934C40.2773 16.2146 40.3208 16.2456 40.3566 16.2844C40.3924 16.3233 40.4198 16.3691 40.4371 16.4191C40.4543 16.469 40.461 16.5219 40.4567 16.5746V20.1747H39.6942V16.5746ZM35.2692 16.5746C35.2581 16.5191 35.2593 16.4618 35.273 16.4069C35.2867 16.3519 35.3124 16.3008 35.3483 16.257C35.3841 16.2132 35.4293 16.1778 35.4805 16.1536C35.5316 16.1293 35.5876 16.1168 35.6442 16.1168C35.7008 16.1168 35.7567 16.1293 35.8079 16.1536C35.8591 16.1778 35.9042 16.2132 35.9401 16.257C35.976 16.3008 36.0017 16.3519 36.0154 16.4069C36.0291 16.4618 36.0304 16.5191 36.0192 16.5746V20.1747H35.2692V16.5746ZM30.7017 16.5746C30.6906 16.5191 30.6918 16.4618 30.7055 16.4069C30.7192 16.3519 30.7449 16.3008 30.7808 16.257C30.8166 16.2132 30.8618 16.1778 30.913 16.1536C30.9641 16.1293 31.0201 16.1168 31.0767 16.1168C31.1333 16.1168 31.1892 16.1293 31.2404 16.1536C31.2916 16.1778 31.3367 16.2132 31.3726 16.257C31.4085 16.3008 31.4342 16.3519 31.4479 16.4069C31.4616 16.4618 31.4629 16.5191 31.4517 16.5746V20.1747H30.7017V16.5746ZM26.1842 16.5746C26.1799 16.5219 26.1866 16.469 26.2039 16.4191C26.2211 16.3691 26.2484 16.3233 26.2842 16.2844C26.3201 16.2456 26.3636 16.2146 26.412 16.1934C26.4604 16.1722 26.5126 16.1613 26.5654 16.1613C26.6183 16.1613 26.6705 16.1722 26.7189 16.1934C26.7673 16.2146 26.8108 16.2456 26.8466 16.2844C26.8824 16.3233 26.9098 16.3691 26.9271 16.4191C26.9443 16.469 26.951 16.5219 26.9467 16.5746V20.1747H26.1792L26.1842 16.5746ZM21.7042 16.5746C21.7 16.5219 21.7066 16.469 21.7238 16.4191C21.741 16.3691 21.7684 16.3233 21.8043 16.2844C21.8401 16.2456 21.8836 16.2146 21.9319 16.1934C21.9803 16.1722 22.0326 16.1613 22.0854 16.1613C22.1383 16.1613 22.1906 16.1722 22.239 16.1934C22.2873 16.2146 22.3308 16.2456 22.3666 16.2844C22.4025 16.3233 22.4299 16.3691 22.4471 16.4191C22.4643 16.469 22.4709 16.5219 22.4667 16.5746V20.1747H21.7042V16.5746ZM17.1067 16.5746C17.1024 16.5219 17.1091 16.469 17.1263 16.4191C17.1436 16.3691 17.171 16.3233 17.2068 16.2844C17.2426 16.2456 17.2861 16.2146 17.3345 16.1934C17.3829 16.1722 17.4351 16.1613 17.488 16.1613C17.5408 16.1613 17.593 16.1722 17.6414 16.1934C17.6898 16.2146 17.7333 16.2456 17.7691 16.2844C17.8049 16.3233 17.8323 16.3691 17.8495 16.4191C17.8668 16.469 17.8735 16.5219 17.8692 16.5746V20.1747H17.1067V16.5746ZM15.5267 18.2947V20.2296H13.5492L15.5267 18.2947ZM17.8067 38.6847L19.2767 35.8772L21.6217 39.8047H17.8067V38.6847ZM21.5817 47.8596C21.0378 47.8596 20.5061 47.6984 20.0539 47.3963C19.6017 47.0941 19.2492 46.6645 19.041 46.162C18.8329 45.6595 18.7784 45.1066 18.8845 44.5731C18.9906 44.0397 19.2526 43.5497 19.6371 43.1651C20.0217 42.7805 20.5118 42.5186 21.0452 42.4125C21.5787 42.3064 22.1316 42.3608 22.6341 42.569C23.1366 42.7771 23.5661 43.1296 23.8682 43.5818C24.1704 44.034 24.3317 44.5657 24.3317 45.1096C24.3317 45.839 24.042 46.5385 23.5262 47.0542C23.0105 47.5699 22.3111 47.8596 21.5817 47.8596ZM49.2792 48.0022C48.7353 48.0022 48.2036 47.8409 47.7514 47.5387C47.2992 47.2365 46.9467 46.8071 46.7385 46.3046C46.5304 45.8021 46.4759 45.2492 46.582 44.7157C46.6881 44.1823 46.9501 43.6922 47.3347 43.3076C47.7193 42.923 48.2092 42.6611 48.7427 42.555C49.2761 42.4488 49.8291 42.5033 50.3316 42.7114C50.8341 42.9196 51.2636 43.2722 51.5657 43.7244C51.8679 44.1766 52.0292 44.7083 52.0292 45.2522C52.0292 45.9816 51.7395 46.6809 51.2238 47.1967C50.708 47.7124 50.0085 48.0022 49.2792 48.0022ZM50.8967 41.3222C50.3841 41.1089 49.8343 40.9993 49.2792 40.9997C48.3445 41.0008 47.4363 41.3101 46.6951 41.8795C45.9539 42.449 45.4211 43.2468 45.1792 44.1497H25.8617C25.8155 44.1508 25.7695 44.1559 25.7242 44.1647C25.5636 43.471 25.2319 42.8285 24.7595 42.2958C24.287 41.7631 23.6888 41.357 23.0192 41.1146C23.041 41.0974 23.0611 41.0782 23.0792 41.0571C23.1249 41.0416 23.1691 41.0224 23.2117 40.9997C23.3806 40.8961 23.5017 40.73 23.5486 40.5375C23.5954 40.345 23.5642 40.1417 23.4617 39.9722L14.3342 24.6946H20.6217V30.1096C20.6217 30.3344 20.711 30.5499 20.8699 30.7089C21.0289 30.8678 21.2444 30.9572 21.4692 30.9572C21.6939 30.9572 21.9095 30.8678 22.0685 30.7089C22.2274 30.5499 22.3167 30.3344 22.3167 30.1096V24.6946H44.5917V30.1096C44.5917 30.3344 44.681 30.5499 44.8399 30.7089C44.9988 30.8678 45.2144 30.9572 45.4392 30.9572C45.664 30.9572 45.8795 30.8678 46.0385 30.7089C46.1974 30.5499 46.2867 30.3344 46.2867 30.1096V24.6946H50.8892L50.8967 41.3222ZM53.6467 23.1946H10.2492V21.7296H53.6467V23.1946Z" })));
const SvgRollOffCompactor = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2199_59890)" }, /* @__PURE__ */ React.createElement("path", { d: "M15.4258 32.3235H9.24579C9.11977 32.317 8.99374 32.3361 8.87537 32.3798C8.75699 32.4235 8.64876 32.4909 8.55725 32.5778C8.46574 32.6647 8.39285 32.7693 8.34305 32.8853C8.29325 33.0012 8.26758 33.126 8.26758 33.2522C8.26758 33.3784 8.29325 33.5033 8.34305 33.6193C8.39285 33.7352 8.46574 33.8398 8.55725 33.9267C8.64876 34.0136 8.75699 34.0809 8.87537 34.1247C8.99374 34.1684 9.11977 34.1875 9.24579 34.1809H15.4258C15.5518 34.1875 15.6778 34.1684 15.7962 34.1247C15.9146 34.0809 16.0228 34.0136 16.1143 33.9267C16.2058 33.8398 16.2787 33.7352 16.3285 33.6193C16.3783 33.5033 16.404 33.3784 16.404 33.2522C16.404 33.126 16.3783 33.0012 16.3285 32.8853C16.2787 32.7693 16.2058 32.6647 16.1143 32.5778C16.0228 32.4909 15.9146 32.4235 15.7962 32.3798C15.6778 32.3361 15.5518 32.317 15.4258 32.3235V32.3235Z" }), /* @__PURE__ */ React.createElement("path", { d: "M15.4244 23.8184H9.24445C8.99779 23.8184 8.76123 23.9163 8.58682 24.0907C8.41241 24.2651 8.31445 24.5016 8.31445 24.7483C8.31445 24.9949 8.41241 25.2316 8.58682 25.406C8.76123 25.5804 8.99779 25.6783 9.24445 25.6783H15.4244C15.5466 25.6783 15.6675 25.6543 15.7803 25.6075C15.8932 25.5608 15.9957 25.4924 16.0821 25.406C16.1684 25.3196 16.2369 25.2171 16.2837 25.1042C16.3304 24.9914 16.3544 24.8704 16.3544 24.7483C16.3544 24.6262 16.3304 24.5053 16.2837 24.3925C16.2369 24.2796 16.1684 24.1771 16.0821 24.0907C15.9957 24.0043 15.8932 23.9359 15.7803 23.8892C15.6675 23.8424 15.5466 23.8184 15.4244 23.8184V23.8184Z" }), /* @__PURE__ */ React.createElement("path", { d: "M15.4244 29.4902H9.24445C9.12232 29.4902 9.00138 29.5143 8.88855 29.561C8.77572 29.6078 8.67318 29.6762 8.58682 29.7626C8.50046 29.8489 8.43196 29.9515 8.38522 30.0643C8.33849 30.1772 8.31445 30.2982 8.31445 30.4203C8.31445 30.5424 8.33849 30.6633 8.38522 30.7761C8.43196 30.889 8.50046 30.9915 8.58682 31.0779C8.67318 31.1642 8.77572 31.2327 8.88855 31.2794C9.00138 31.3262 9.12232 31.3502 9.24445 31.3502H15.4244C15.6711 31.3502 15.9077 31.2523 16.0821 31.0779C16.2565 30.9035 16.3544 30.6669 16.3544 30.4203C16.3544 30.1736 16.2565 29.937 16.0821 29.7626C15.9077 29.5882 15.6711 29.4902 15.4244 29.4902V29.4902Z" }), /* @__PURE__ */ React.createElement("path", { d: "M15.4244 26.6523H9.24445C8.99779 26.6523 8.76123 26.7504 8.58682 26.9248C8.41241 27.0992 8.31445 27.3357 8.31445 27.5824C8.31445 27.8291 8.41241 28.0656 8.58682 28.24C8.76123 28.4144 8.99779 28.5123 9.24445 28.5123H15.4244C15.6711 28.5123 15.9077 28.4144 16.0821 28.24C16.2565 28.0656 16.3544 27.8291 16.3544 27.5824C16.3544 27.3357 16.2565 27.0992 16.0821 26.9248C15.9077 26.7504 15.6711 26.6523 15.4244 26.6523Z" }), /* @__PURE__ */ React.createElement("path", { d: "M15.4258 35.1575H9.24579C9.11977 35.151 8.99374 35.1702 8.87537 35.2139C8.75699 35.2576 8.64876 35.325 8.55725 35.4119C8.46574 35.4988 8.39285 35.6033 8.34305 35.7193C8.29325 35.8352 8.26758 35.96 8.26758 36.0862C8.26758 36.2124 8.29325 36.3373 8.34305 36.4533C8.39285 36.5692 8.46574 36.6738 8.55725 36.7606C8.64876 36.8475 8.75699 36.9149 8.87537 36.9586C8.99374 37.0024 9.11977 37.0216 9.24579 37.015H15.4258C15.5518 37.0216 15.6778 37.0024 15.7962 36.9586C15.9146 36.9149 16.0228 36.8475 16.1143 36.7606C16.2058 36.6738 16.2787 36.5692 16.3285 36.4533C16.3783 36.3373 16.404 36.2124 16.404 36.0862C16.404 35.96 16.3783 35.8352 16.3285 35.7193C16.2787 35.6033 16.2058 35.4988 16.1143 35.4119C16.0228 35.325 15.9146 35.2576 15.7962 35.2139C15.6778 35.1702 15.5518 35.151 15.4258 35.1575V35.1575Z" }), /* @__PURE__ */ React.createElement("path", { d: "M27.359 34.1809H33.5391C33.6651 34.1875 33.7911 34.1684 33.9095 34.1247C34.0279 34.0809 34.1361 34.0136 34.2276 33.9267C34.3191 33.8398 34.392 33.7352 34.4418 33.6193C34.4916 33.5033 34.5172 33.3784 34.5172 33.2522C34.5172 33.126 34.4916 33.0012 34.4418 32.8853C34.392 32.7693 34.3191 32.6647 34.2276 32.5778C34.1361 32.4909 34.0279 32.4235 33.9095 32.3798C33.7911 32.3361 33.6651 32.317 33.5391 32.3235H27.359C27.233 32.317 27.107 32.3361 26.9886 32.3798C26.8702 32.4235 26.762 32.4909 26.6705 32.5778C26.579 32.6647 26.5061 32.7693 26.4563 32.8853C26.4065 33.0012 26.3809 33.126 26.3809 33.2522C26.3809 33.3784 26.4065 33.5033 26.4563 33.6193C26.5061 33.7352 26.579 33.8398 26.6705 33.9267C26.762 34.0136 26.8702 34.0809 26.9886 34.1247C27.107 34.1684 27.233 34.1875 27.359 34.1809V34.1809Z" }), /* @__PURE__ */ React.createElement("path", { d: "M27.3597 25.6783H33.5397C33.6618 25.6783 33.7828 25.6543 33.8956 25.6075C34.0084 25.5608 34.1109 25.4924 34.1973 25.406C34.2836 25.3196 34.3522 25.2171 34.3989 25.1042C34.4456 24.9914 34.4697 24.8704 34.4697 24.7483C34.4697 24.6262 34.4456 24.5053 34.3989 24.3925C34.3522 24.2796 34.2836 24.1771 34.1973 24.0907C34.1109 24.0043 34.0084 23.9359 33.8956 23.8892C33.7828 23.8424 33.6618 23.8184 33.5397 23.8184H27.3597C27.113 23.8184 26.8765 23.9163 26.7021 24.0907C26.5277 24.2651 26.4297 24.5016 26.4297 24.7483C26.4297 24.9949 26.5277 25.2316 26.7021 25.406C26.8765 25.5804 27.113 25.6783 27.3597 25.6783V25.6783Z" }), /* @__PURE__ */ React.createElement("path", { d: "M27.3597 31.3483H33.5397C33.7863 31.3483 34.0229 31.2502 34.1973 31.0758C34.3717 30.9014 34.4697 30.6649 34.4697 30.4182C34.4697 30.1716 34.3717 29.935 34.1973 29.7606C34.0229 29.5862 33.7863 29.4883 33.5397 29.4883H27.3597C27.2376 29.4883 27.1166 29.5122 27.0038 29.559C26.891 29.6057 26.7884 29.6743 26.7021 29.7606C26.6157 29.847 26.5472 29.9495 26.5005 30.0624C26.4538 30.1752 26.4297 30.2961 26.4297 30.4182C26.4297 30.5403 26.4538 30.6613 26.5005 30.7742C26.5472 30.887 26.6157 30.9894 26.7021 31.0758C26.7884 31.1622 26.891 31.2307 27.0038 31.2775C27.1166 31.3242 27.2376 31.3483 27.3597 31.3483V31.3483Z" }), /* @__PURE__ */ React.createElement("path", { d: "M27.3597 28.5123H33.5397C33.7863 28.5123 34.0229 28.4144 34.1973 28.24C34.3717 28.0656 34.4697 27.8291 34.4697 27.5824C34.4697 27.3357 34.3717 27.0992 34.1973 26.9248C34.0229 26.7504 33.7863 26.6523 33.5397 26.6523H27.3597C27.113 26.6523 26.8765 26.7504 26.7021 26.9248C26.5277 27.0992 26.4297 27.3357 26.4297 27.5824C26.4297 27.8291 26.5277 28.0656 26.7021 28.24C26.8765 28.4144 27.113 28.5123 27.3597 28.5123Z" }), /* @__PURE__ */ React.createElement("path", { d: "M33.5391 35.1575H27.359C27.233 35.151 27.107 35.1702 26.9886 35.2139C26.8702 35.2576 26.762 35.325 26.6705 35.4119C26.579 35.4988 26.5061 35.6033 26.4563 35.7193C26.4065 35.8352 26.3809 35.96 26.3809 36.0862C26.3809 36.2124 26.4065 36.3373 26.4563 36.4533C26.5061 36.5692 26.579 36.6738 26.6705 36.7606C26.762 36.8475 26.8702 36.9149 26.9886 36.9586C27.107 37.0024 27.233 37.0216 27.359 37.015H33.5391C33.6651 37.0216 33.7911 37.0024 33.9095 36.9586C34.0279 36.9149 34.1361 36.8475 34.2276 36.7606C34.3191 36.6738 34.392 36.5692 34.4418 36.4533C34.4916 36.3373 34.5172 36.2124 34.5172 36.0862C34.5172 35.96 34.4916 35.8352 34.4418 35.7193C34.392 35.6033 34.3191 35.4988 34.2276 35.4119C34.1361 35.325 34.0279 35.2576 33.9095 35.2139C33.7911 35.1702 33.6651 35.151 33.5391 35.1575Z" }), /* @__PURE__ */ React.createElement("path", { d: "M62.5001 35.953H61.4476V33.3879H62.5001C62.7467 33.3879 62.9833 33.29 63.1577 33.1156C63.3321 32.9412 63.4301 32.7047 63.4301 32.458C63.4301 32.2114 63.3321 31.9748 63.1577 31.8004C62.9833 31.626 62.7467 31.5279 62.5001 31.5279H40.6576V19.8829H40.6276V19.338V17.5604L39.4901 15.038C39.4082 14.8786 39.2833 14.7454 39.1295 14.6534C38.9757 14.5615 38.7992 14.5145 38.6201 14.5179H5.58758C5.40619 14.513 5.2271 14.5594 5.07095 14.6518C4.91481 14.7443 4.78796 14.8791 4.70508 15.0405L3.58258 17.5229V17.5455V17.558V20.0129C3.58382 20.0254 3.58382 20.0381 3.58258 20.0505V20.3929H2.65009C2.08451 20.3929 1.5421 20.6177 1.14218 21.0176C0.74226 21.4175 0.517578 21.9599 0.517578 22.5255C0.517578 23.0911 0.74226 23.6334 1.14218 24.0333C1.5421 24.4332 2.08451 24.658 2.65009 24.658H3.58258V28.6229H2.65009C2.08451 28.6229 1.5421 28.8476 1.14218 29.2476C0.74226 29.6475 0.517578 30.1899 0.517578 30.7555C0.517578 31.3211 0.74226 31.8635 1.14218 32.2634C1.5421 32.6633 2.08451 32.8879 2.65009 32.8879H3.58258V36.853H2.65009C2.09682 36.872 1.57256 37.105 1.18787 37.503C0.803174 37.9011 0.588135 38.4331 0.588135 38.9867C0.588135 39.5403 0.803174 40.0722 1.18787 40.4703C1.57256 40.8684 2.09682 41.1015 2.65009 41.1205H3.58258V41.158C3.59028 42.4785 4.11523 43.7435 5.04483 44.6815C5.97442 45.6195 7.23462 46.1559 8.55508 46.1755V48.6755C8.55574 48.922 8.65395 49.1581 8.82822 49.3324C9.00248 49.5067 9.23863 49.6048 9.48508 49.6055H15.9851C16.2315 49.6048 16.4677 49.5067 16.642 49.3324C16.8162 49.1581 16.9144 48.922 16.9151 48.6755V46.1755H46.0276V48.6755C46.0282 48.922 46.1264 49.1581 46.3007 49.3324C46.475 49.5067 46.7111 49.6048 46.9576 49.6055H53.4576C53.7038 49.6042 53.9396 49.5058 54.1137 49.3317C54.2879 49.1575 54.3863 48.9218 54.3876 48.6755V46.2705L56.4126 44.2705L58.1976 42.553H60.1601C60.4067 42.553 60.6433 42.455 60.8177 42.2806C60.9921 42.1062 61.0901 41.8696 61.0901 41.6229C61.0901 41.3763 60.9921 41.1397 60.8177 40.9653C60.6433 40.7909 60.4067 40.693 60.1601 40.693H60.1301L61.4551 39.418V37.813H62.5076C62.7456 37.8006 62.9697 37.6974 63.1338 37.5245C63.2979 37.3517 63.3894 37.1226 63.3894 36.8843C63.3894 36.646 63.2979 36.4167 63.1338 36.2439C62.9697 36.0711 62.7456 35.9678 62.5076 35.9554L62.5001 35.953ZM3.3526 22.9029H2.6326C2.53115 22.9029 2.43385 22.8626 2.36212 22.7909C2.29039 22.7192 2.25009 22.6219 2.25009 22.5205C2.25009 22.4191 2.29039 22.3217 2.36212 22.25C2.43385 22.1783 2.53115 22.1379 2.6326 22.1379H3.3526V22.9029ZM3.3526 31.1329H2.6326C2.53115 31.1329 2.43385 31.0927 2.36212 31.021C2.29039 30.9493 2.25009 30.8519 2.25009 30.7505C2.25009 30.649 2.29039 30.5517 2.36212 30.48C2.43385 30.4082 2.53115 30.3679 2.6326 30.3679H3.3526V31.1329ZM3.3526 39.3655H2.6326C2.53617 39.3577 2.44621 39.3139 2.38062 39.2428C2.31502 39.1717 2.27859 39.0784 2.27859 38.9817C2.27859 38.8849 2.31502 38.7918 2.38062 38.7207C2.44621 38.6496 2.53617 38.6058 2.6326 38.598H3.3526V39.3655ZM6.21008 16.198H37.9901L38.6401 17.5455H5.56009L6.21008 16.198ZM15.0426 47.698H10.3976V46.1179H15.0426V47.698ZM38.7676 44.2605H8.6301C8.03484 44.2601 7.45182 44.0914 6.94839 43.7738C6.44497 43.4562 6.04168 43.0026 5.78509 42.4654C6.00509 42.4854 6.25009 42.4979 6.53509 42.4979H38.7676V44.2605ZM38.7676 40.6355H6.53509C6.17872 40.6308 5.82254 40.655 5.47009 40.708V19.443L23.1851 19.4005V19.3679L38.7676 19.3304V40.6355ZM52.5176 47.698H47.8701V46.1179H52.5176V47.698ZM53.8776 44.2605H40.6276V42.543H55.6651L53.8776 44.2605ZM59.6951 38.663L57.6451 40.6355H40.6251V37.803H59.6951V38.663ZM59.6951 35.9454H40.6251V33.3805H59.6951V35.9454Z" })));
const SvgRollOffOpenTop = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2199_59892)" }, /* @__PURE__ */ React.createElement("path", { d: "M27.0332 33.0716H20.8532C20.7272 33.065 20.6012 33.0842 20.4828 33.128C20.3644 33.1717 20.2562 33.2391 20.1647 33.326C20.0732 33.4128 20.0003 33.5174 19.9505 33.6333C19.9007 33.7493 19.875 33.8742 19.875 34.0004C19.875 34.1266 19.9007 34.2514 19.9505 34.3673C20.0003 34.4833 20.0732 34.5878 20.1647 34.6747C20.2562 34.7616 20.3644 34.829 20.4828 34.8727C20.6012 34.9164 20.7272 34.9356 20.8532 34.9291H27.0332C27.1592 34.9356 27.2853 34.9164 27.4036 34.8727C27.522 34.829 27.6302 34.7616 27.7217 34.6747C27.8132 34.5878 27.8862 34.4833 27.936 34.3673C27.9858 34.2514 28.0114 34.1266 28.0114 34.0004C28.0114 33.8742 27.9858 33.7493 27.936 33.6333C27.8862 33.5174 27.8132 33.4128 27.7217 33.326C27.6302 33.2391 27.522 33.1717 27.4036 33.128C27.2853 33.0842 27.1592 33.065 27.0332 33.0716Z" }), /* @__PURE__ */ React.createElement("path", { d: "M27.0319 24.5684H20.8519C20.6052 24.5684 20.3687 24.6664 20.1943 24.8408C20.0199 25.0152 19.9219 25.2518 19.9219 25.4984C19.9219 25.7451 20.0199 25.9816 20.1943 26.156C20.3687 26.3304 20.6052 26.4283 20.8519 26.4283H27.0319C27.2785 26.4283 27.5151 26.3304 27.6895 26.156C27.8639 25.9816 27.9619 25.7451 27.9619 25.4984C27.9619 25.2518 27.8639 25.0152 27.6895 24.8408C27.5151 24.6664 27.2785 24.5684 27.0319 24.5684V24.5684Z" }), /* @__PURE__ */ React.createElement("path", { d: "M27.0319 30.2383H20.8519C20.6052 30.2383 20.3687 30.3362 20.1943 30.5106C20.0199 30.685 19.9219 30.9216 19.9219 31.1682C19.9219 31.4149 20.0199 31.6515 20.1943 31.8259C20.3687 32.0003 20.6052 32.0983 20.8519 32.0983H27.0319C27.2785 32.0983 27.5151 32.0003 27.6895 31.8259C27.8639 31.6515 27.9619 31.4149 27.9619 31.1682C27.9619 30.9216 27.8639 30.685 27.6895 30.5106C27.5151 30.3362 27.2785 30.2383 27.0319 30.2383Z" }), /* @__PURE__ */ React.createElement("path", { d: "M27.0319 27.4023H20.8519C20.7297 27.4023 20.6088 27.4263 20.496 27.473C20.3831 27.5198 20.2806 27.5883 20.1943 27.6747C20.1079 27.761 20.0394 27.8636 19.9927 27.9764C19.9459 28.0893 19.9219 28.2101 19.9219 28.3323C19.9219 28.4544 19.9459 28.5754 19.9927 28.6882C20.0394 28.8011 20.1079 28.9035 20.1943 28.9899C20.2806 29.0762 20.3831 29.1448 20.496 29.1915C20.6088 29.2383 20.7297 29.2623 20.8519 29.2623H27.0319C27.154 29.2623 27.2749 29.2383 27.3878 29.1915C27.5006 29.1448 27.6032 29.0762 27.6895 28.9899C27.7759 28.9035 27.8444 28.8011 27.8911 28.6882C27.9378 28.5754 27.9619 28.4544 27.9619 28.3323C27.9619 28.2101 27.9378 28.0893 27.8911 27.9764C27.8444 27.8636 27.7759 27.761 27.6895 27.6747C27.6032 27.5883 27.5006 27.5198 27.3878 27.473C27.2749 27.4263 27.154 27.4023 27.0319 27.4023V27.4023Z" }), /* @__PURE__ */ React.createElement("path", { d: "M27.0332 35.9075H20.8532C20.7272 35.901 20.6012 35.9201 20.4828 35.9638C20.3644 36.0075 20.2562 36.0749 20.1647 36.1618C20.0732 36.2487 20.0003 36.3532 19.9505 36.4691C19.9007 36.5851 19.875 36.71 19.875 36.8362C19.875 36.9624 19.9007 37.0872 19.9505 37.2032C20.0003 37.3191 20.0732 37.4238 20.1647 37.5107C20.2562 37.5975 20.3644 37.6649 20.4828 37.7086C20.6012 37.7524 20.7272 37.7715 20.8532 37.7649H27.0332C27.1592 37.7715 27.2853 37.7524 27.4036 37.7086C27.522 37.6649 27.6302 37.5975 27.7217 37.5107C27.8132 37.4238 27.8862 37.3191 27.936 37.2032C27.9858 37.0872 28.0114 36.9624 28.0114 36.8362C28.0114 36.71 27.9858 36.5851 27.936 36.4691C27.8862 36.3532 27.8132 36.2487 27.7217 36.1618C27.6302 36.0749 27.522 36.0075 27.4036 35.9638C27.2853 35.9201 27.1592 35.901 27.0332 35.9075V35.9075Z" }), /* @__PURE__ */ React.createElement("path", { d: "M43.9658 34.9298H50.1483C50.3863 34.9175 50.6105 34.8142 50.7745 34.6414C50.9386 34.4685 51.0301 34.2394 51.0301 34.0011C51.0301 33.7628 50.9386 33.5335 50.7745 33.3607C50.6105 33.1879 50.3863 33.0846 50.1483 33.0723H43.9658C43.7278 33.0846 43.5036 33.1879 43.3395 33.3607C43.1755 33.5335 43.084 33.7628 43.084 34.0011C43.084 34.2394 43.1755 34.4685 43.3395 34.6414C43.5036 34.8142 43.7278 34.9175 43.9658 34.9298Z" }), /* @__PURE__ */ React.createElement("path", { d: "M43.9651 26.4283H50.1477C50.3944 26.4283 50.6309 26.3304 50.8053 26.156C50.9797 25.9816 51.0777 25.7451 51.0777 25.4984C51.0777 25.2518 50.9797 25.0152 50.8053 24.8408C50.6309 24.6664 50.3944 24.5684 50.1477 24.5684H43.9651C43.7185 24.5684 43.482 24.6664 43.3076 24.8408C43.1331 25.0152 43.0352 25.2518 43.0352 25.4984C43.0352 25.7451 43.1331 25.9816 43.3076 26.156C43.482 26.3304 43.7185 26.4283 43.9651 26.4283Z" }), /* @__PURE__ */ React.createElement("path", { d: "M43.9651 32.0983H50.1477C50.3944 32.0983 50.6309 32.0003 50.8053 31.8259C50.9797 31.6515 51.0777 31.4149 51.0777 31.1682C51.0777 30.9216 50.9797 30.685 50.8053 30.5106C50.6309 30.3362 50.3944 30.2383 50.1477 30.2383H43.9651C43.7185 30.2383 43.482 30.3362 43.3076 30.5106C43.1331 30.685 43.0352 30.9216 43.0352 31.1682C43.0352 31.4149 43.1331 31.6515 43.3076 31.8259C43.482 32.0003 43.7185 32.0983 43.9651 32.0983V32.0983Z" }), /* @__PURE__ */ React.createElement("path", { d: "M43.9651 29.2623H50.1477C50.3944 29.2623 50.6309 29.1643 50.8053 28.9899C50.9797 28.8155 51.0777 28.5789 51.0777 28.3323C51.0777 28.0856 50.9797 27.8491 50.8053 27.6747C50.6309 27.5003 50.3944 27.4023 50.1477 27.4023H43.9651C43.7185 27.4023 43.482 27.5003 43.3076 27.6747C43.1331 27.8491 43.0352 28.0856 43.0352 28.3323C43.0352 28.5789 43.1331 28.8155 43.3076 28.9899C43.482 29.1643 43.7185 29.2623 43.9651 29.2623Z" }), /* @__PURE__ */ React.createElement("path", { d: "M43.9658 37.7656H50.1483C50.3863 37.7533 50.6105 37.6501 50.7745 37.4773C50.9386 37.3045 51.0301 37.0752 51.0301 36.8369C51.0301 36.5986 50.9386 36.3694 50.7745 36.1965C50.6105 36.0237 50.3863 35.9206 50.1483 35.9082H43.9658C43.7278 35.9206 43.5036 36.0237 43.3395 36.1965C43.1755 36.3694 43.084 36.5986 43.084 36.8369C43.084 37.0752 43.1755 37.3045 43.3395 37.4773C43.5036 37.6501 43.7278 37.7533 43.9658 37.7656V37.7656Z" }), /* @__PURE__ */ React.createElement("path", { d: "M58.8075 26.0546L55.8325 24.8922V18.3021V18.2896V18.2672H55.8075L54.6875 15.7846C54.6044 15.6228 54.4772 15.4878 54.3206 15.3953C54.1639 15.3029 53.9843 15.2567 53.8025 15.2621H6.75751C6.57873 15.2589 6.40263 15.306 6.24927 15.3979C6.0959 15.4898 5.9714 15.623 5.88998 15.7822L4.75 18.3046V20.0797H6.9075V39.6021H10.39L16.1775 45.0096H22.7275V45.1621V47.6621C22.7281 47.9085 22.8263 48.1448 23.0006 48.319C23.1749 48.4933 23.411 48.5914 23.6575 48.5921H30.1575C30.4037 48.5914 30.6396 48.4931 30.8135 48.3188C30.9873 48.1445 31.085 47.9083 31.085 47.6621V45.1621H42.485V47.6621C42.485 47.9083 42.5827 48.1445 42.7565 48.3188C42.9304 48.4931 43.1663 48.5914 43.4125 48.5921H49.9125C50.1587 48.5914 50.3946 48.4931 50.5685 48.3188C50.7424 48.1445 50.84 47.9083 50.84 47.6621V45.1621C52.1604 45.1425 53.4206 44.6062 54.3502 43.6682C55.2798 42.7301 55.8048 41.4652 55.8125 40.1446V34.4597L58.7875 33.2971C58.9649 33.2272 59.1174 33.1058 59.2252 32.9485C59.3331 32.7913 59.3913 32.6053 59.3925 32.4146V26.9296C59.3977 26.7411 59.3441 26.5557 59.2393 26.399C59.1345 26.2422 58.9836 26.1219 58.8075 26.0546V26.0546ZM9.435 37.8596H8.66998V20.0971H9.435V37.8596ZM6.76001 18.2946L7.4075 16.9471H53.1825L53.83 18.2946H6.7525H6.76001ZM29.24 46.7047H24.5925V45.1246H29.24V46.7047ZM49.0025 46.7047H44.355V45.1246H49.0025V46.7047ZM53.9275 40.1046C53.9268 40.9424 53.5937 41.7458 53.0012 42.3383C52.4088 42.9308 51.6054 43.2639 50.7675 43.2646H16.8725L11.1775 37.9421V20.0971L33.4425 20.1346V20.1671L53.92 20.2021L53.9275 40.1046ZM57.5075 31.7696L55.8325 32.4671V26.8922L57.5075 27.5421V31.7696Z" })));
const SvgToter = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2199_59894)" }, /* @__PURE__ */ React.createElement("path", { d: "M18.6048 23.9874H18.8948L19.7223 46.5C19.7309 47.5667 20.1272 48.5938 20.8373 49.3899C21.7048 50.2999 22.9848 50.755 24.6373 50.755H36.8223C36.9315 50.7623 37.0409 50.7434 37.1413 50.7C37.2418 50.6565 37.3304 50.5896 37.3998 50.505C37.8808 50.6774 38.3889 50.7621 38.8998 50.755C39.9796 50.7569 41.0245 50.373 41.8463 49.6726C42.6681 48.9722 43.2126 48.0012 43.3818 46.9348C43.551 45.8684 43.3337 44.7766 42.7691 43.8562C42.2045 42.9358 41.3296 42.2473 40.3023 41.9149C40.3542 41.8125 40.3824 41.6998 40.3848 41.585L41.0473 23.9874H41.3348C41.7987 23.989 42.2498 23.8357 42.6167 23.5518C42.9835 23.2678 43.2451 22.8694 43.3598 22.4199H45.6723C46.1212 22.4179 46.5512 22.2387 46.8686 21.9213C47.1861 21.6038 47.3653 21.1739 47.3673 20.725V19.1974C47.3653 18.7485 47.1861 18.3185 46.8686 18.0011C46.5512 17.6837 46.1212 17.5044 45.6723 17.5024H43.4423V16.9249C43.4417 16.7063 43.3545 16.4969 43.1999 16.3423C43.0454 16.1877 42.8359 16.1006 42.6173 16.1H34.5623V14.075C34.5616 13.8559 34.4741 13.6461 34.319 13.4915C34.1639 13.3368 33.9538 13.25 33.7348 13.25H27.2098C27.1015 13.25 26.9942 13.2713 26.8941 13.3127C26.794 13.3542 26.7031 13.415 26.6265 13.4916C26.5498 13.5682 26.4891 13.6592 26.4476 13.7593C26.4062 13.8594 26.3848 13.9666 26.3848 14.075V16.1H21.9223C21.5208 16.099 21.1232 16.1773 20.7521 16.3304C20.381 16.4836 20.0438 16.7087 19.7599 16.9926C19.476 17.2764 19.251 17.6135 19.0978 17.9846C18.9446 18.3557 18.8663 18.7534 18.8673 19.1549V19.1974H18.6173C18.0594 19.2 17.5251 19.423 17.1308 19.8177C16.7366 20.2125 16.5143 20.747 16.5123 21.3049V21.84C16.5057 22.1192 16.5548 22.3969 16.6569 22.6569C16.759 22.9168 16.912 23.1537 17.1069 23.3538C17.3018 23.5538 17.5347 23.7128 17.7919 23.8217C18.0491 23.9305 18.3255 23.9868 18.6048 23.9874V23.9874ZM41.7773 46.2524C41.7773 46.8246 41.6076 47.384 41.2897 47.8597C40.9717 48.3355 40.5198 48.7062 39.9911 48.925C39.4625 49.1439 38.8807 49.201 38.3196 49.0892C37.7584 48.9774 37.243 48.7016 36.8386 48.2969C36.4342 47.8921 36.1589 47.3764 36.0476 46.8152C35.9363 46.2539 35.9939 45.6723 36.2132 45.1438C36.4325 44.6153 36.8037 44.1637 37.2797 43.8462C37.7557 43.5287 38.3151 43.3595 38.8873 43.36C39.6536 43.362 40.3879 43.6674 40.9296 44.2095C41.4712 44.7516 41.776 45.4861 41.7773 46.2524V46.2524ZM38.7223 41.5425V41.7074C37.8755 41.7397 37.0546 42.0077 36.3519 42.4812C35.6491 42.9547 35.0925 43.615 34.7446 44.3877C34.3967 45.1604 34.2714 46.0147 34.3827 46.8547C34.4941 47.6948 34.8377 48.4871 35.3748 49.1425H24.6373C23.479 49.1425 22.6114 48.8532 22.0348 48.2749C21.6066 47.7955 21.3583 47.1822 21.3323 46.5399V46.4574L20.5048 23.9874H39.3823L38.7223 41.5425ZM45.6598 19.2374V20.7675C45.6598 20.7781 45.6556 20.7883 45.6481 20.7958C45.6406 20.8033 45.6304 20.8075 45.6198 20.8075L43.4298 20.7675L43.4723 19.1974L45.6598 19.2374ZM28.0223 14.9425H32.9373V16.1324H28.0223V14.9425ZM20.5048 19.1925C20.5031 19.0075 20.5383 18.824 20.6083 18.6528C20.6783 18.4816 20.7818 18.326 20.9126 18.1952C21.0434 18.0644 21.1989 17.961 21.3702 17.891C21.5414 17.821 21.7248 17.7858 21.9098 17.7875H41.8198V19.2324H20.4948L20.5048 19.1925ZM18.1523 21.34C18.1529 21.2199 18.2007 21.1049 18.2854 21.0198C18.37 20.9347 18.4847 20.8862 18.6048 20.8849H41.8198V21.8849C41.8185 22.0052 41.7702 22.1202 41.6851 22.2052C41.6001 22.2902 41.4851 22.3387 41.3648 22.34H18.6148C18.4948 22.3387 18.38 22.2902 18.2954 22.2051C18.2107 22.12 18.1629 22.0049 18.1623 21.8849L18.1523 21.34ZM27.4023 29.59H32.5223C32.7941 29.5995 33.065 29.5542 33.3188 29.4568C33.5727 29.3594 33.8043 29.2119 33.9999 29.0231C34.1955 28.8342 34.3512 28.6078 34.4574 28.3575C34.5637 28.1073 34.6185 27.8381 34.6185 27.5662C34.6185 27.2942 34.5637 27.0252 34.4574 26.7749C34.3512 26.5246 34.1955 26.2982 33.9999 26.1094C33.8043 25.9205 33.5727 25.7729 33.3188 25.6755C33.065 25.5781 32.7941 25.5329 32.5223 25.5425H27.4023C27.1305 25.5329 26.8597 25.5781 26.6058 25.6755C26.352 25.7729 26.1203 25.9205 25.9247 26.1094C25.729 26.2982 25.5735 26.5246 25.4672 26.7749C25.361 27.0252 25.3061 27.2942 25.3061 27.5662C25.3061 27.8381 25.361 28.1073 25.4672 28.3575C25.5735 28.6078 25.729 28.8342 25.9247 29.0231C26.1203 29.2119 26.352 29.3594 26.6058 29.4568C26.8597 29.5542 27.1305 29.5995 27.4023 29.59V29.59ZM27.4023 27.1949H32.5223C32.6218 27.1949 32.7171 27.2345 32.7875 27.3048C32.8578 27.3751 32.8973 27.4705 32.8973 27.5699C32.8973 27.6694 32.8578 27.7648 32.7875 27.8351C32.7171 27.9054 32.6218 27.9449 32.5223 27.9449H27.4023C27.3028 27.9449 27.2075 27.9054 27.1371 27.8351C27.0668 27.7648 27.0273 27.6694 27.0273 27.5699C27.0273 27.4705 27.0668 27.3751 27.1371 27.3048C27.2075 27.2345 27.3028 27.1949 27.4023 27.1949V27.1949Z" })));
const options$2 = {
  base: "icon rounded-lg bg-gray-50 relative size-16 sm:w-24 sm:h-24 z-0",
  iconBase: "fill-gray-700 absolute inset-0 m-auto size-8 sm:w-16 sm:h-16",
  iconwithBorder: "-left-2",
  streams: {
    "Trash (MSW) / Landfill": "border-l-8 border-gray-800",
    "Single-stream recycling": " border-l-8 border-midday",
    "Cardboard recycling": "border-l-8 border-poppy",
    "Comingled recycling": "border-l-8 border-recycling",
    "Paper recycling": "border-l-8 border-sunflower",
    "Compost organics": "border-l-8 border-chartreuse",
    "Compost greens": "border-l-8 border-cactus",
    "Other stream": "border-l-8 border-gray-500",
    "Electronic recycling": "border-l-8 border-electric-seaglass"
  },
  containers: {
    "baler": SvgBaler,
    "cart": SvgCart,
    "drum": SvgDrum,
    "toter": SvgToter,
    "rear-load container": SvgRearLoadContainer,
    "other compactor": SvgOtherCompactor,
    "hand pickup": SvgHandPickup,
    "roll-off compactor": SvgRollOffCompactor,
    "other container": SvgOtherContainer,
    "front-load container": SvgFrontLoadContainer,
    "roll-off open-top container": SvgRollOffOpenTop
  }
};
function ServiceIcon({
  containerType = "other container",
  ...props
}) {
  const {
    streamType,
    className
  } = props;
  const ContainerIcon = containerType && Object.keys(options$2.containers).includes(containerType) ? options$2.containers[containerType] : SvgOtherContainer;
  const hasStream = streamType && Object.keys(options$2.streams).includes(streamType);
  return /* @__PURE__ */ jsx("div", {
    role: "presentation",
    className: addStyles([options$2.base, hasStream ? options$2.streams[streamType] : "", className]),
    children: /* @__PURE__ */ jsx(ContainerIcon, {
      className: addStyles([options$2.iconBase, hasStream ? options$2.iconwithBorder : ""])
    })
  });
}
const wrapperClasses$1 = "flex items-center justify-items-end w-full text-sm leading-6 text-gray-900 p-2 bg-white border-t border-gray-300 ";
const buttonClasses = "text-base size-6 hover:bg-gray-100 active:bg-gray-200 rounded-lg";
const buttonDisabledClasses = `${buttonClasses} text-gray-500 active:bg-gray-100`;
const buttonIconClasses = "h-6 w-6 fill-current";
const dividerClasses = "border-l mx-4 border-gray-300 h-8";
const dropdownWrapper = "ml-3";
const pageNumberDisplayClasses = "mr-3";
const pageSizeControlClasses = "ml-auto";
const dropdownMenuItemClasses = "py-2.5 w-16 px-5 text-right hover:bg-jungle-50 select-none";
const skeletonClasses = "h-6 bg-gray-100 rounded-lg mb-1";
const pageNumberSkeletonClasses = `${skeletonClasses} w-28`;
const pageControlskeletonClasses = `${skeletonClasses} w-6 ml-1`;
const getRange = (count2, page, pageSize) => {
  const start = 1 + pageSize * (page - 1);
  const end = start + pageSize - 1;
  return end > count2 ? [start, count2] : [start, end];
};
const getIsLastPage = (count2, page, pageSize) => {
  return getRange(count2, page, pageSize)[1] == count2;
};
const ForwardButton = (props) => {
  const {
    disabled,
    onClick,
    isLoading
  } = props;
  if (isLoading) {
    return /* @__PURE__ */ jsx("div", {
      className: pageControlskeletonClasses
    });
  }
  return /* @__PURE__ */ jsx("button", {
    "aria-label": "next-button",
    className: disabled ? buttonDisabledClasses : buttonClasses,
    onClick: (e) => !disabled && onClick(e),
    children: /* @__PURE__ */ jsx(SvgChevronRight, {
      className: buttonIconClasses
    })
  });
};
const PreviousButton = (props) => {
  const {
    disabled,
    onClick,
    isLoading
  } = props;
  if (isLoading) {
    return /* @__PURE__ */ jsx("div", {
      className: pageControlskeletonClasses
    });
  }
  return /* @__PURE__ */ jsx("button", {
    "aria-label": "prev-button",
    className: disabled ? buttonDisabledClasses : buttonClasses,
    onClick: (e) => !disabled && onClick(e),
    children: /* @__PURE__ */ jsx(SvgChevronLeft, {
      className: buttonIconClasses
    })
  });
};
const PageNumberDisplay = (props) => {
  const {
    page,
    pageSize,
    count: count2,
    itemText,
    isLoading
  } = props;
  const [start, end] = useMemo(() => getRange(count2, page, pageSize), [count2, page, pageSize]);
  if (isLoading) {
    return /* @__PURE__ */ jsx("span", {
      className: pageNumberSkeletonClasses
    });
  }
  return /* @__PURE__ */ jsxs("span", {
    className: pageNumberDisplayClasses,
    children: [/* @__PURE__ */ jsx(FormattedNumber, {
      children: start
    }), "-", /* @__PURE__ */ jsx(FormattedNumber, {
      children: end
    }), " of", " ", /* @__PURE__ */ jsx(FormattedNumber, {
      children: count2
    }), " ", itemText]
  });
};
const PageSizeControl = (props) => {
  const {
    pageSize,
    pageSizeOptions,
    onPageSizeChange
  } = props;
  const handleOnClick = useCallback((size) => () => {
    if (!onPageSizeChange) return;
    onPageSizeChange(size);
  }, [onPageSizeChange]);
  return /* @__PURE__ */ jsxs("div", {
    className: pageSizeControlClasses,
    children: ["Items per page:", " ", /* @__PURE__ */ jsx("span", {
      className: dropdownWrapper,
      children: /* @__PURE__ */ jsx(DropdownMenu, {
        closeOnSelect: true,
        buttonContent: /* @__PURE__ */ jsx("div", {
          "data-testid": "page-size-control",
          children: pageSize
        }),
        menuContent: /* @__PURE__ */ jsx("div", {
          "aria-label": "group",
          "data-testid": "page-size-dropdown",
          children: pageSizeOptions.map((v) => /* @__PURE__ */ jsx("div", {
            "aria-label": "menuitem",
            className: dropdownMenuItemClasses,
            onClick: handleOnClick(v),
            children: v
          }, v))
        })
      })
    })]
  });
};
const TablePagination = ({
  page = 1,
  isLoading = false,
  pageSize = 25,
  count: count2 = 0,
  pageSizeOptions = [10, 25, 50, 100, 500],
  itemText = "items",
  ...props
}) => {
  const {
    onPageChange
  } = props;
  const [pageData, setPageData] = useState({
    page,
    size: pageSize
  });
  const {
    page: currentPage,
    size
  } = pageData;
  const isLastPage = useMemo(() => getIsLastPage(count2, currentPage, size), [count2, currentPage, size]);
  useEffect(() => setPageData((prev) => ({
    ...prev,
    size: pageSize
  })), [pageSize]);
  useEffect(() => setPageData((prev) => ({
    ...prev,
    page
  })), [page]);
  const handlePageChange = useCallback((page2) => {
    setPageData((prev) => ({
      ...prev,
      page: page2
    }));
    if (!onPageChange) return;
    onPageChange(page2, size);
  }, [size, onPageChange]);
  const handlePageSizeChange = useCallback((size2) => {
    setPageData({
      page: 1,
      size: size2
    });
    if (!onPageChange) return;
    onPageChange(1, size2);
  }, [onPageChange]);
  return /* @__PURE__ */ jsxs("div", {
    className: wrapperClasses$1,
    children: [/* @__PURE__ */ jsx(PageSizeControl, {
      pageSize: size,
      pageSizeOptions,
      onPageSizeChange: handlePageSizeChange
    }), /* @__PURE__ */ jsx("div", {
      className: dividerClasses
    }), /* @__PURE__ */ jsx(PageNumberDisplay, {
      isLoading,
      page: currentPage,
      pageSize: size,
      count: count2,
      itemText
    }), /* @__PURE__ */ jsx(PreviousButton, {
      disabled: currentPage == 1,
      onClick: () => handlePageChange(currentPage - 1),
      isLoading
    }), /* @__PURE__ */ jsx(ForwardButton, {
      disabled: isLastPage,
      onClick: () => handlePageChange(currentPage + 1),
      isLoading
    })]
  });
};
const options$1 = {
  default: {
    base: "inline-block border rounded-sm px-2 text-xs font-medium uppercase text-gray-900",
    text: "align-middle my-1 inline-block",
    type: {
      default: "bg-gray-50 border-gray-500",
      error: "bg-red-50 border-red-500 text-red-600",
      processing: "bg-blue-50 border-blue-300 text-blue-800",
      warning: "bg-gold-50 border-gold-800",
      success: "bg-green-50 border-green-700 text-green-800"
    },
    caretIcon: "h-4 w-4 inline fill-current cursor-pointer",
    rightIcon: "size-5.5 inline cursor-pointer",
    leftIcon: "h-6 w-6 inline"
  },
  table: {
    base: "table-tag mr-1 normal-case border-0 inline-block border rounded px-2 text-xs font-medium text-gray-900",
    text: "align-middle inline-block",
    type: {
      default: "bg-gray-100 border-gray-500",
      error: "bg-red-50 border-red-500 text-red-600",
      processing: "bg-blue-50 border-blue-300 text-blue-800",
      warning: "bg-gold-50 border-gold-800",
      success: "bg-green-50 border-green-700 text-green-800"
    },
    caretIcon: "h-4 w-4 inline fill-current cursor-pointer",
    rightIcon: "size-5.5 inline cursor-pointer",
    leftIcon: "h-6 w-6 inline"
  }
};
function Tag({
  baseType = "default",
  menuContent,
  type = "default",
  text: text2,
  leftIcon,
  leftIconClassName,
  rightIcon,
  className,
  isMenuOpen = false,
  onRightClick,
  onClick,
  onMenuOpenChange
}) {
  const [menuOpen, setMenuOpen] = React__default.useState(isMenuOpen);
  const icon = menuContent ? SvgCaretDown({
    title: "caret",
    className: options$1[baseType].caretIcon,
    onClick: onRightClick
  }) : rightIcon == null ? void 0 : rightIcon({
    className: options$1[baseType].rightIcon,
    onClick: onRightClick
  });
  useEffect(() => {
    setMenuOpen(isMenuOpen);
  }, [isMenuOpen]);
  const containerClasses2 = useMemo(() => {
    const base = options$1[baseType].base;
    return addStyles([className ?? base, options$1[baseType].type[type], menuContent ? "cursor-pointer" : ""]);
  }, [baseType, className, type, menuContent]);
  return /* @__PURE__ */ jsx(Popover, {
    open: menuOpen,
    trigger: "external",
    innerContentClassName: "",
    showArrow: false,
    content: menuContent,
    onOpenChange: (isOpen) => {
      setMenuOpen(isOpen);
      onMenuOpenChange == null ? void 0 : onMenuOpenChange(isOpen);
    },
    children: /* @__PURE__ */ jsxs("div", {
      className: containerClasses2,
      onClick: (e) => {
        if (menuContent) {
          setMenuOpen(true);
          onMenuOpenChange == null ? void 0 : onMenuOpenChange(true);
        }
        onClick == null ? void 0 : onClick(e);
      },
      children: [/* @__PURE__ */ jsx("span", {
        children: leftIcon == null ? void 0 : leftIcon({
          className: addStyles([leftIconClassName ?? options$1[baseType].leftIcon])
        })
      }), /* @__PURE__ */ jsx("div", {
        className: options$1[baseType].text,
        children: text2
      }), /* @__PURE__ */ jsx("div", {
        className: "inline overflow-hidden",
        children: icon
      })]
    })
  });
}
const TableTag = (props) => {
  return /* @__PURE__ */ jsx(Tag, {
    ...props,
    baseType: "table",
    className: addStyles([props.className, "table-tag mr-1 normal-case border-0 flex border rounded-sm py-1 px-2 text-xs font-medium text-gray-900"])
  });
};
const containerClass = "cursor-pointer outline-black flex flex-nowrap items-center group min-w-0";
const linkWrapperBase = "relative shrink overflow-hidden";
const iconClass = "h-4 w-4 mr-1 shrink-0";
const relativeToAbsoluteUrl = (relativeURL) => {
  const link = document.createElement("a");
  link.href = relativeURL;
  return link.href;
};
const TableLink = (props) => {
  const {
    label,
    url,
    icon,
    absoluteURL = true,
    truncate = true,
    showCopyLink = true,
    ...rest
  } = props;
  const copyURL = useMemo(() => absoluteURL ? relativeToAbsoluteUrl(url) : url, [url, absoluteURL]);
  const onClick = useCallback((event) => {
    if (event.key === "Enter" || event.key === " ") {
      window.location.href = url;
    }
  }, [url]);
  const linkWrapperStyle = truncate ? linkWrapperBase + " truncate" : linkWrapperBase;
  return /* @__PURE__ */ jsxs("div", {
    "data-testid": "table-link-container",
    className: containerClass,
    tabIndex: 0,
    onKeyDown: onClick,
    children: [!!icon && icon({
      className: iconClass,
      title: "LinkIcon"
    }), /* @__PURE__ */ jsx("span", {
      className: linkWrapperStyle,
      children: /* @__PURE__ */ jsx(TextLink, {
        href: url,
        tabIndex: -1,
        target: "_blank",
        rel: "noreferrer",
        ...rest,
        children: label
      })
    }), showCopyLink && /* @__PURE__ */ jsx(CopyToClipboardButton, {
      textToCopy: copyURL,
      tooltipText: "Copy link",
      copyIcon: SvgLink
    })]
  });
};
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function functionalUpdate(updater, input) {
  return typeof updater === "function" ? updater(input) : updater;
}
function makeStateUpdater(key, instance) {
  return (updater) => {
    instance.setState((old) => {
      return {
        ...old,
        [key]: functionalUpdate(updater, old[key])
      };
    });
  };
}
function isFunction(d) {
  return d instanceof Function;
}
function isNumberArray(d) {
  return Array.isArray(d) && d.every((val) => typeof val === "number");
}
function flattenBy(arr, getChildren2) {
  const flat = [];
  const recurse = (subArr) => {
    subArr.forEach((item) => {
      flat.push(item);
      const children = getChildren2(item);
      if (children != null && children.length) {
        recurse(children);
      }
    });
  };
  recurse(arr);
  return flat;
}
function memo$1(getDeps, fn, opts) {
  let deps = [];
  let result;
  return (depArgs) => {
    let depTime;
    if (opts.key && opts.debug) depTime = Date.now();
    const newDeps = getDeps(depArgs);
    const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index2) => deps[index2] !== dep);
    if (!depsChanged) {
      return result;
    }
    deps = newDeps;
    let resultTime;
    if (opts.key && opts.debug) resultTime = Date.now();
    result = fn(...newDeps);
    opts == null || opts.onChange == null || opts.onChange(result);
    if (opts.key && opts.debug) {
      if (opts != null && opts.debug()) {
        const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
        const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
        const resultFpsPercentage = resultEndTime / 16;
        const pad = (str, num) => {
          str = String(str);
          while (str.length < num) {
            str = " " + str;
          }
          return str;
        };
        console.info(`%c⏱ ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
      }
    }
    return result;
  };
}
function getMemoOptions(tableOptions, debugLevel, key, onChange) {
  return {
    debug: () => {
      var _tableOptions$debugAl;
      return (_tableOptions$debugAl = tableOptions == null ? void 0 : tableOptions.debugAll) != null ? _tableOptions$debugAl : tableOptions[debugLevel];
    },
    key: process.env.NODE_ENV === "development" && key,
    onChange
  };
}
function createCell(table, row, column, columnId) {
  const getRenderValue = () => {
    var _cell$getValue;
    return (_cell$getValue = cell.getValue()) != null ? _cell$getValue : table.options.renderFallbackValue;
  };
  const cell = {
    id: `${row.id}_${column.id}`,
    row,
    column,
    getValue: () => row.getValue(columnId),
    renderValue: getRenderValue,
    getContext: memo$1(() => [table, column, row, cell], (table2, column2, row2, cell2) => ({
      table: table2,
      column: column2,
      row: row2,
      cell: cell2,
      getValue: cell2.getValue,
      renderValue: cell2.renderValue
    }), getMemoOptions(table.options, "debugCells", "cell.getContext"))
  };
  table._features.forEach((feature) => {
    feature.createCell == null || feature.createCell(cell, column, row, table);
  }, {});
  return cell;
}
function createColumn(table, columnDef, depth, parent) {
  var _ref, _resolvedColumnDef$id;
  const defaultColumn = table._getDefaultColumnDef();
  const resolvedColumnDef = {
    ...defaultColumn,
    ...columnDef
  };
  const accessorKey = resolvedColumnDef.accessorKey;
  let id = (_ref = (_resolvedColumnDef$id = resolvedColumnDef.id) != null ? _resolvedColumnDef$id : accessorKey ? accessorKey.replace(".", "_") : void 0) != null ? _ref : typeof resolvedColumnDef.header === "string" ? resolvedColumnDef.header : void 0;
  let accessorFn;
  if (resolvedColumnDef.accessorFn) {
    accessorFn = resolvedColumnDef.accessorFn;
  } else if (accessorKey) {
    if (accessorKey.includes(".")) {
      accessorFn = (originalRow) => {
        let result = originalRow;
        for (const key of accessorKey.split(".")) {
          var _result;
          result = (_result = result) == null ? void 0 : _result[key];
          if (process.env.NODE_ENV !== "production" && result === void 0) {
            console.warn(`"${key}" in deeply nested key "${accessorKey}" returned undefined.`);
          }
        }
        return result;
      };
    } else {
      accessorFn = (originalRow) => originalRow[resolvedColumnDef.accessorKey];
    }
  }
  if (!id) {
    if (process.env.NODE_ENV !== "production") {
      throw new Error(resolvedColumnDef.accessorFn ? `Columns require an id when using an accessorFn` : `Columns require an id when using a non-string header`);
    }
    throw new Error();
  }
  let column = {
    id: `${String(id)}`,
    accessorFn,
    parent,
    depth,
    columnDef: resolvedColumnDef,
    columns: [],
    getFlatColumns: memo$1(() => [true], () => {
      var _column$columns;
      return [column, ...(_column$columns = column.columns) == null ? void 0 : _column$columns.flatMap((d) => d.getFlatColumns())];
    }, getMemoOptions(table.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: memo$1(() => [table._getOrderColumnsFn()], (orderColumns2) => {
      var _column$columns2;
      if ((_column$columns2 = column.columns) != null && _column$columns2.length) {
        let leafColumns = column.columns.flatMap((column2) => column2.getLeafColumns());
        return orderColumns2(leafColumns);
      }
      return [column];
    }, getMemoOptions(table.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const feature of table._features) {
    feature.createColumn == null || feature.createColumn(column, table);
  }
  return column;
}
const debug = "debugHeaders";
function createHeader(table, column, options2) {
  var _options$id;
  const id = (_options$id = options2.id) != null ? _options$id : column.id;
  let header = {
    id,
    column,
    index: options2.index,
    isPlaceholder: !!options2.isPlaceholder,
    placeholderId: options2.placeholderId,
    depth: options2.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const leafHeaders = [];
      const recurseHeader = (h) => {
        if (h.subHeaders && h.subHeaders.length) {
          h.subHeaders.map(recurseHeader);
        }
        leafHeaders.push(h);
      };
      recurseHeader(header);
      return leafHeaders;
    },
    getContext: () => ({
      table,
      header,
      column
    })
  };
  table._features.forEach((feature) => {
    feature.createHeader == null || feature.createHeader(header, table);
  });
  return header;
}
const Headers = {
  createTable: (table) => {
    table.getHeaderGroups = memo$1(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allColumns, leafColumns, left, right) => {
      var _left$map$filter, _right$map$filter;
      const leftColumns = (_left$map$filter = left == null ? void 0 : left.map((columnId) => leafColumns.find((d) => d.id === columnId)).filter(Boolean)) != null ? _left$map$filter : [];
      const rightColumns = (_right$map$filter = right == null ? void 0 : right.map((columnId) => leafColumns.find((d) => d.id === columnId)).filter(Boolean)) != null ? _right$map$filter : [];
      const centerColumns = leafColumns.filter((column) => !(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
      const headerGroups = buildHeaderGroups(allColumns, [...leftColumns, ...centerColumns, ...rightColumns], table);
      return headerGroups;
    }, getMemoOptions(table.options, debug, "getHeaderGroups"));
    table.getCenterHeaderGroups = memo$1(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allColumns, leafColumns, left, right) => {
      leafColumns = leafColumns.filter((column) => !(left != null && left.includes(column.id)) && !(right != null && right.includes(column.id)));
      return buildHeaderGroups(allColumns, leafColumns, table, "center");
    }, getMemoOptions(table.options, debug, "getCenterHeaderGroups"));
    table.getLeftHeaderGroups = memo$1(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.left], (allColumns, leafColumns, left) => {
      var _left$map$filter2;
      const orderedLeafColumns = (_left$map$filter2 = left == null ? void 0 : left.map((columnId) => leafColumns.find((d) => d.id === columnId)).filter(Boolean)) != null ? _left$map$filter2 : [];
      return buildHeaderGroups(allColumns, orderedLeafColumns, table, "left");
    }, getMemoOptions(table.options, debug, "getLeftHeaderGroups"));
    table.getRightHeaderGroups = memo$1(() => [table.getAllColumns(), table.getVisibleLeafColumns(), table.getState().columnPinning.right], (allColumns, leafColumns, right) => {
      var _right$map$filter2;
      const orderedLeafColumns = (_right$map$filter2 = right == null ? void 0 : right.map((columnId) => leafColumns.find((d) => d.id === columnId)).filter(Boolean)) != null ? _right$map$filter2 : [];
      return buildHeaderGroups(allColumns, orderedLeafColumns, table, "right");
    }, getMemoOptions(table.options, debug, "getRightHeaderGroups"));
    table.getFooterGroups = memo$1(() => [table.getHeaderGroups()], (headerGroups) => {
      return [...headerGroups].reverse();
    }, getMemoOptions(table.options, debug, "getFooterGroups"));
    table.getLeftFooterGroups = memo$1(() => [table.getLeftHeaderGroups()], (headerGroups) => {
      return [...headerGroups].reverse();
    }, getMemoOptions(table.options, debug, "getLeftFooterGroups"));
    table.getCenterFooterGroups = memo$1(() => [table.getCenterHeaderGroups()], (headerGroups) => {
      return [...headerGroups].reverse();
    }, getMemoOptions(table.options, debug, "getCenterFooterGroups"));
    table.getRightFooterGroups = memo$1(() => [table.getRightHeaderGroups()], (headerGroups) => {
      return [...headerGroups].reverse();
    }, getMemoOptions(table.options, debug, "getRightFooterGroups"));
    table.getFlatHeaders = memo$1(() => [table.getHeaderGroups()], (headerGroups) => {
      return headerGroups.map((headerGroup) => {
        return headerGroup.headers;
      }).flat();
    }, getMemoOptions(table.options, debug, "getFlatHeaders"));
    table.getLeftFlatHeaders = memo$1(() => [table.getLeftHeaderGroups()], (left) => {
      return left.map((headerGroup) => {
        return headerGroup.headers;
      }).flat();
    }, getMemoOptions(table.options, debug, "getLeftFlatHeaders"));
    table.getCenterFlatHeaders = memo$1(() => [table.getCenterHeaderGroups()], (left) => {
      return left.map((headerGroup) => {
        return headerGroup.headers;
      }).flat();
    }, getMemoOptions(table.options, debug, "getCenterFlatHeaders"));
    table.getRightFlatHeaders = memo$1(() => [table.getRightHeaderGroups()], (left) => {
      return left.map((headerGroup) => {
        return headerGroup.headers;
      }).flat();
    }, getMemoOptions(table.options, debug, "getRightFlatHeaders"));
    table.getCenterLeafHeaders = memo$1(() => [table.getCenterFlatHeaders()], (flatHeaders) => {
      return flatHeaders.filter((header) => {
        var _header$subHeaders;
        return !((_header$subHeaders = header.subHeaders) != null && _header$subHeaders.length);
      });
    }, getMemoOptions(table.options, debug, "getCenterLeafHeaders"));
    table.getLeftLeafHeaders = memo$1(() => [table.getLeftFlatHeaders()], (flatHeaders) => {
      return flatHeaders.filter((header) => {
        var _header$subHeaders2;
        return !((_header$subHeaders2 = header.subHeaders) != null && _header$subHeaders2.length);
      });
    }, getMemoOptions(table.options, debug, "getLeftLeafHeaders"));
    table.getRightLeafHeaders = memo$1(() => [table.getRightFlatHeaders()], (flatHeaders) => {
      return flatHeaders.filter((header) => {
        var _header$subHeaders3;
        return !((_header$subHeaders3 = header.subHeaders) != null && _header$subHeaders3.length);
      });
    }, getMemoOptions(table.options, debug, "getRightLeafHeaders"));
    table.getLeafHeaders = memo$1(() => [table.getLeftHeaderGroups(), table.getCenterHeaderGroups(), table.getRightHeaderGroups()], (left, center, right) => {
      var _left$0$headers, _left$, _center$0$headers, _center$, _right$0$headers, _right$;
      return [...(_left$0$headers = (_left$ = left[0]) == null ? void 0 : _left$.headers) != null ? _left$0$headers : [], ...(_center$0$headers = (_center$ = center[0]) == null ? void 0 : _center$.headers) != null ? _center$0$headers : [], ...(_right$0$headers = (_right$ = right[0]) == null ? void 0 : _right$.headers) != null ? _right$0$headers : []].map((header) => {
        return header.getLeafHeaders();
      }).flat();
    }, getMemoOptions(table.options, debug, "getLeafHeaders"));
  }
};
function buildHeaderGroups(allColumns, columnsToGroup, table, headerFamily) {
  var _headerGroups$0$heade, _headerGroups$;
  let maxDepth = 0;
  const findMaxDepth = function(columns, depth) {
    if (depth === void 0) {
      depth = 1;
    }
    maxDepth = Math.max(maxDepth, depth);
    columns.filter((column) => column.getIsVisible()).forEach((column) => {
      var _column$columns;
      if ((_column$columns = column.columns) != null && _column$columns.length) {
        findMaxDepth(column.columns, depth + 1);
      }
    }, 0);
  };
  findMaxDepth(allColumns);
  let headerGroups = [];
  const createHeaderGroup = (headersToGroup, depth) => {
    const headerGroup = {
      depth,
      id: [headerFamily, `${depth}`].filter(Boolean).join("_"),
      headers: []
    };
    const pendingParentHeaders = [];
    headersToGroup.forEach((headerToGroup) => {
      const latestPendingParentHeader = [...pendingParentHeaders].reverse()[0];
      const isLeafHeader = headerToGroup.column.depth === headerGroup.depth;
      let column;
      let isPlaceholder = false;
      if (isLeafHeader && headerToGroup.column.parent) {
        column = headerToGroup.column.parent;
      } else {
        column = headerToGroup.column;
        isPlaceholder = true;
      }
      if (latestPendingParentHeader && (latestPendingParentHeader == null ? void 0 : latestPendingParentHeader.column) === column) {
        latestPendingParentHeader.subHeaders.push(headerToGroup);
      } else {
        const header = createHeader(table, column, {
          id: [headerFamily, depth, column.id, headerToGroup == null ? void 0 : headerToGroup.id].filter(Boolean).join("_"),
          isPlaceholder,
          placeholderId: isPlaceholder ? `${pendingParentHeaders.filter((d) => d.column === column).length}` : void 0,
          depth,
          index: pendingParentHeaders.length
        });
        header.subHeaders.push(headerToGroup);
        pendingParentHeaders.push(header);
      }
      headerGroup.headers.push(headerToGroup);
      headerToGroup.headerGroup = headerGroup;
    });
    headerGroups.push(headerGroup);
    if (depth > 0) {
      createHeaderGroup(pendingParentHeaders, depth - 1);
    }
  };
  const bottomHeaders = columnsToGroup.map((column, index2) => createHeader(table, column, {
    depth: maxDepth,
    index: index2
  }));
  createHeaderGroup(bottomHeaders, maxDepth - 1);
  headerGroups.reverse();
  const recurseHeadersForSpans = (headers) => {
    const filteredHeaders = headers.filter((header) => header.column.getIsVisible());
    return filteredHeaders.map((header) => {
      let colSpan = 0;
      let rowSpan = 0;
      let childRowSpans = [0];
      if (header.subHeaders && header.subHeaders.length) {
        childRowSpans = [];
        recurseHeadersForSpans(header.subHeaders).forEach((_ref) => {
          let {
            colSpan: childColSpan,
            rowSpan: childRowSpan
          } = _ref;
          colSpan += childColSpan;
          childRowSpans.push(childRowSpan);
        });
      } else {
        colSpan = 1;
      }
      const minChildRowSpan = Math.min(...childRowSpans);
      rowSpan = rowSpan + minChildRowSpan;
      header.colSpan = colSpan;
      header.rowSpan = rowSpan;
      return {
        colSpan,
        rowSpan
      };
    });
  };
  recurseHeadersForSpans((_headerGroups$0$heade = (_headerGroups$ = headerGroups[0]) == null ? void 0 : _headerGroups$.headers) != null ? _headerGroups$0$heade : []);
  return headerGroups;
}
const createRow = (table, id, original, rowIndex, depth, subRows, parentId) => {
  let row = {
    id,
    index: rowIndex,
    original,
    depth,
    parentId,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (columnId) => {
      if (row._valuesCache.hasOwnProperty(columnId)) {
        return row._valuesCache[columnId];
      }
      const column = table.getColumn(columnId);
      if (!(column != null && column.accessorFn)) {
        return void 0;
      }
      row._valuesCache[columnId] = column.accessorFn(row.original, rowIndex);
      return row._valuesCache[columnId];
    },
    getUniqueValues: (columnId) => {
      if (row._uniqueValuesCache.hasOwnProperty(columnId)) {
        return row._uniqueValuesCache[columnId];
      }
      const column = table.getColumn(columnId);
      if (!(column != null && column.accessorFn)) {
        return void 0;
      }
      if (!column.columnDef.getUniqueValues) {
        row._uniqueValuesCache[columnId] = [row.getValue(columnId)];
        return row._uniqueValuesCache[columnId];
      }
      row._uniqueValuesCache[columnId] = column.columnDef.getUniqueValues(row.original, rowIndex);
      return row._uniqueValuesCache[columnId];
    },
    renderValue: (columnId) => {
      var _row$getValue;
      return (_row$getValue = row.getValue(columnId)) != null ? _row$getValue : table.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => flattenBy(row.subRows, (d) => d.subRows),
    getParentRow: () => row.parentId ? table.getRow(row.parentId, true) : void 0,
    getParentRows: () => {
      let parentRows = [];
      let currentRow = row;
      while (true) {
        const parentRow = currentRow.getParentRow();
        if (!parentRow) break;
        parentRows.push(parentRow);
        currentRow = parentRow;
      }
      return parentRows.reverse();
    },
    getAllCells: memo$1(() => [table.getAllLeafColumns()], (leafColumns) => {
      return leafColumns.map((column) => {
        return createCell(table, row, column, column.id);
      });
    }, getMemoOptions(table.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: memo$1(() => [row.getAllCells()], (allCells) => {
      return allCells.reduce((acc, cell) => {
        acc[cell.column.id] = cell;
        return acc;
      }, {});
    }, getMemoOptions(table.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let i = 0; i < table._features.length; i++) {
    const feature = table._features[i];
    feature == null || feature.createRow == null || feature.createRow(row, table);
  }
  return row;
};
const ColumnFaceting = {
  createColumn: (column, table) => {
    column._getFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, column.id);
    column.getFacetedRowModel = () => {
      if (!column._getFacetedRowModel) {
        return table.getPreFilteredRowModel();
      }
      return column._getFacetedRowModel();
    };
    column._getFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, column.id);
    column.getFacetedUniqueValues = () => {
      if (!column._getFacetedUniqueValues) {
        return /* @__PURE__ */ new Map();
      }
      return column._getFacetedUniqueValues();
    };
    column._getFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, column.id);
    column.getFacetedMinMaxValues = () => {
      if (!column._getFacetedMinMaxValues) {
        return void 0;
      }
      return column._getFacetedMinMaxValues();
    };
  }
};
const includesString = (row, columnId, filterValue) => {
  var _row$getValue;
  const search = filterValue.toLowerCase();
  return Boolean((_row$getValue = row.getValue(columnId)) == null || (_row$getValue = _row$getValue.toString()) == null || (_row$getValue = _row$getValue.toLowerCase()) == null ? void 0 : _row$getValue.includes(search));
};
includesString.autoRemove = (val) => testFalsey(val);
const includesStringSensitive = (row, columnId, filterValue) => {
  var _row$getValue2;
  return Boolean((_row$getValue2 = row.getValue(columnId)) == null || (_row$getValue2 = _row$getValue2.toString()) == null ? void 0 : _row$getValue2.includes(filterValue));
};
includesStringSensitive.autoRemove = (val) => testFalsey(val);
const equalsString = (row, columnId, filterValue) => {
  var _row$getValue3;
  return ((_row$getValue3 = row.getValue(columnId)) == null || (_row$getValue3 = _row$getValue3.toString()) == null ? void 0 : _row$getValue3.toLowerCase()) === (filterValue == null ? void 0 : filterValue.toLowerCase());
};
equalsString.autoRemove = (val) => testFalsey(val);
const arrIncludes = (row, columnId, filterValue) => {
  var _row$getValue4;
  return (_row$getValue4 = row.getValue(columnId)) == null ? void 0 : _row$getValue4.includes(filterValue);
};
arrIncludes.autoRemove = (val) => testFalsey(val) || !(val != null && val.length);
const arrIncludesAll = (row, columnId, filterValue) => {
  return !filterValue.some((val) => {
    var _row$getValue5;
    return !((_row$getValue5 = row.getValue(columnId)) != null && _row$getValue5.includes(val));
  });
};
arrIncludesAll.autoRemove = (val) => testFalsey(val) || !(val != null && val.length);
const arrIncludesSome = (row, columnId, filterValue) => {
  return filterValue.some((val) => {
    var _row$getValue6;
    return (_row$getValue6 = row.getValue(columnId)) == null ? void 0 : _row$getValue6.includes(val);
  });
};
arrIncludesSome.autoRemove = (val) => testFalsey(val) || !(val != null && val.length);
const equals = (row, columnId, filterValue) => {
  return row.getValue(columnId) === filterValue;
};
equals.autoRemove = (val) => testFalsey(val);
const weakEquals = (row, columnId, filterValue) => {
  return row.getValue(columnId) == filterValue;
};
weakEquals.autoRemove = (val) => testFalsey(val);
const inNumberRange = (row, columnId, filterValue) => {
  let [min2, max2] = filterValue;
  const rowValue = row.getValue(columnId);
  return rowValue >= min2 && rowValue <= max2;
};
inNumberRange.resolveFilterValue = (val) => {
  let [unsafeMin, unsafeMax] = val;
  let parsedMin = typeof unsafeMin !== "number" ? parseFloat(unsafeMin) : unsafeMin;
  let parsedMax = typeof unsafeMax !== "number" ? parseFloat(unsafeMax) : unsafeMax;
  let min2 = unsafeMin === null || Number.isNaN(parsedMin) ? -Infinity : parsedMin;
  let max2 = unsafeMax === null || Number.isNaN(parsedMax) ? Infinity : parsedMax;
  if (min2 > max2) {
    const temp = min2;
    min2 = max2;
    max2 = temp;
  }
  return [min2, max2];
};
inNumberRange.autoRemove = (val) => testFalsey(val) || testFalsey(val[0]) && testFalsey(val[1]);
const filterFns = {
  includesString,
  includesStringSensitive,
  equalsString,
  arrIncludes,
  arrIncludesAll,
  arrIncludesSome,
  equals,
  weakEquals,
  inNumberRange
};
function testFalsey(val) {
  return val === void 0 || val === null || val === "";
}
const ColumnFiltering = {
  getDefaultColumnDef: () => {
    return {
      filterFn: "auto"
    };
  },
  getInitialState: (state) => {
    return {
      columnFilters: [],
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onColumnFiltersChange: makeStateUpdater("columnFilters", table),
      filterFromLeafRows: false,
      maxLeafRowFilterDepth: 100
    };
  },
  createColumn: (column, table) => {
    column.getAutoFilterFn = () => {
      const firstRow = table.getCoreRowModel().flatRows[0];
      const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
      if (typeof value === "string") {
        return filterFns.includesString;
      }
      if (typeof value === "number") {
        return filterFns.inNumberRange;
      }
      if (typeof value === "boolean") {
        return filterFns.equals;
      }
      if (value !== null && typeof value === "object") {
        return filterFns.equals;
      }
      if (Array.isArray(value)) {
        return filterFns.arrIncludes;
      }
      return filterFns.weakEquals;
    };
    column.getFilterFn = () => {
      var _table$options$filter, _table$options$filter2;
      return isFunction(column.columnDef.filterFn) ? column.columnDef.filterFn : column.columnDef.filterFn === "auto" ? column.getAutoFilterFn() : (
        // @ts-ignore
        (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[column.columnDef.filterFn]) != null ? _table$options$filter : filterFns[column.columnDef.filterFn]
      );
    };
    column.getCanFilter = () => {
      var _column$columnDef$ena, _table$options$enable, _table$options$enable2;
      return ((_column$columnDef$ena = column.columnDef.enableColumnFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnFilters) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && !!column.accessorFn;
    };
    column.getIsFiltered = () => column.getFilterIndex() > -1;
    column.getFilterValue = () => {
      var _table$getState$colum;
      return (_table$getState$colum = table.getState().columnFilters) == null || (_table$getState$colum = _table$getState$colum.find((d) => d.id === column.id)) == null ? void 0 : _table$getState$colum.value;
    };
    column.getFilterIndex = () => {
      var _table$getState$colum2, _table$getState$colum3;
      return (_table$getState$colum2 = (_table$getState$colum3 = table.getState().columnFilters) == null ? void 0 : _table$getState$colum3.findIndex((d) => d.id === column.id)) != null ? _table$getState$colum2 : -1;
    };
    column.setFilterValue = (value) => {
      table.setColumnFilters((old) => {
        const filterFn = column.getFilterFn();
        const previousFilter = old == null ? void 0 : old.find((d) => d.id === column.id);
        const newFilter = functionalUpdate(value, previousFilter ? previousFilter.value : void 0);
        if (shouldAutoRemoveFilter(filterFn, newFilter, column)) {
          var _old$filter;
          return (_old$filter = old == null ? void 0 : old.filter((d) => d.id !== column.id)) != null ? _old$filter : [];
        }
        const newFilterObj = {
          id: column.id,
          value: newFilter
        };
        if (previousFilter) {
          var _old$map;
          return (_old$map = old == null ? void 0 : old.map((d) => {
            if (d.id === column.id) {
              return newFilterObj;
            }
            return d;
          })) != null ? _old$map : [];
        }
        if (old != null && old.length) {
          return [...old, newFilterObj];
        }
        return [newFilterObj];
      });
    };
  },
  createRow: (row, _table) => {
    row.columnFilters = {};
    row.columnFiltersMeta = {};
  },
  createTable: (table) => {
    table.setColumnFilters = (updater) => {
      const leafColumns = table.getAllLeafColumns();
      const updateFn = (old) => {
        var _functionalUpdate;
        return (_functionalUpdate = functionalUpdate(updater, old)) == null ? void 0 : _functionalUpdate.filter((filter) => {
          const column = leafColumns.find((d) => d.id === filter.id);
          if (column) {
            const filterFn = column.getFilterFn();
            if (shouldAutoRemoveFilter(filterFn, filter.value, column)) {
              return false;
            }
          }
          return true;
        });
      };
      table.options.onColumnFiltersChange == null || table.options.onColumnFiltersChange(updateFn);
    };
    table.resetColumnFilters = (defaultState) => {
      var _table$initialState$c, _table$initialState;
      table.setColumnFilters(defaultState ? [] : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnFilters) != null ? _table$initialState$c : []);
    };
    table.getPreFilteredRowModel = () => table.getCoreRowModel();
    table.getFilteredRowModel = () => {
      if (!table._getFilteredRowModel && table.options.getFilteredRowModel) {
        table._getFilteredRowModel = table.options.getFilteredRowModel(table);
      }
      if (table.options.manualFiltering || !table._getFilteredRowModel) {
        return table.getPreFilteredRowModel();
      }
      return table._getFilteredRowModel();
    };
  }
};
function shouldAutoRemoveFilter(filterFn, value, column) {
  return (filterFn && filterFn.autoRemove ? filterFn.autoRemove(value, column) : false) || typeof value === "undefined" || typeof value === "string" && !value;
}
const sum = (columnId, _leafRows, childRows) => {
  return childRows.reduce((sum2, next) => {
    const nextValue = next.getValue(columnId);
    return sum2 + (typeof nextValue === "number" ? nextValue : 0);
  }, 0);
};
const min = (columnId, _leafRows, childRows) => {
  let min2;
  childRows.forEach((row) => {
    const value = row.getValue(columnId);
    if (value != null && (min2 > value || min2 === void 0 && value >= value)) {
      min2 = value;
    }
  });
  return min2;
};
const max = (columnId, _leafRows, childRows) => {
  let max2;
  childRows.forEach((row) => {
    const value = row.getValue(columnId);
    if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
      max2 = value;
    }
  });
  return max2;
};
const extent = (columnId, _leafRows, childRows) => {
  let min2;
  let max2;
  childRows.forEach((row) => {
    const value = row.getValue(columnId);
    if (value != null) {
      if (min2 === void 0) {
        if (value >= value) min2 = max2 = value;
      } else {
        if (min2 > value) min2 = value;
        if (max2 < value) max2 = value;
      }
    }
  });
  return [min2, max2];
};
const mean = (columnId, leafRows) => {
  let count2 = 0;
  let sum2 = 0;
  leafRows.forEach((row) => {
    let value = row.getValue(columnId);
    if (value != null && (value = +value) >= value) {
      ++count2, sum2 += value;
    }
  });
  if (count2) return sum2 / count2;
  return;
};
const median = (columnId, leafRows) => {
  if (!leafRows.length) {
    return;
  }
  const values = leafRows.map((row) => row.getValue(columnId));
  if (!isNumberArray(values)) {
    return;
  }
  if (values.length === 1) {
    return values[0];
  }
  const mid = Math.floor(values.length / 2);
  const nums = values.sort((a, b) => a - b);
  return values.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
};
const unique = (columnId, leafRows) => {
  return Array.from(new Set(leafRows.map((d) => d.getValue(columnId))).values());
};
const uniqueCount = (columnId, leafRows) => {
  return new Set(leafRows.map((d) => d.getValue(columnId))).size;
};
const count = (_columnId, leafRows) => {
  return leafRows.length;
};
const aggregationFns = {
  sum,
  min,
  max,
  extent,
  mean,
  median,
  unique,
  uniqueCount,
  count
};
const ColumnGrouping = {
  getDefaultColumnDef: () => {
    return {
      aggregatedCell: (props) => {
        var _toString, _props$getValue;
        return (_toString = (_props$getValue = props.getValue()) == null || _props$getValue.toString == null ? void 0 : _props$getValue.toString()) != null ? _toString : null;
      },
      aggregationFn: "auto"
    };
  },
  getInitialState: (state) => {
    return {
      grouping: [],
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onGroupingChange: makeStateUpdater("grouping", table),
      groupedColumnMode: "reorder"
    };
  },
  createColumn: (column, table) => {
    column.toggleGrouping = () => {
      table.setGrouping((old) => {
        if (old != null && old.includes(column.id)) {
          return old.filter((d) => d !== column.id);
        }
        return [...old != null ? old : [], column.id];
      });
    };
    column.getCanGroup = () => {
      var _column$columnDef$ena, _table$options$enable;
      return ((_column$columnDef$ena = column.columnDef.enableGrouping) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGrouping) != null ? _table$options$enable : true) && (!!column.accessorFn || !!column.columnDef.getGroupingValue);
    };
    column.getIsGrouped = () => {
      var _table$getState$group;
      return (_table$getState$group = table.getState().grouping) == null ? void 0 : _table$getState$group.includes(column.id);
    };
    column.getGroupedIndex = () => {
      var _table$getState$group2;
      return (_table$getState$group2 = table.getState().grouping) == null ? void 0 : _table$getState$group2.indexOf(column.id);
    };
    column.getToggleGroupingHandler = () => {
      const canGroup = column.getCanGroup();
      return () => {
        if (!canGroup) return;
        column.toggleGrouping();
      };
    };
    column.getAutoAggregationFn = () => {
      const firstRow = table.getCoreRowModel().flatRows[0];
      const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
      if (typeof value === "number") {
        return aggregationFns.sum;
      }
      if (Object.prototype.toString.call(value) === "[object Date]") {
        return aggregationFns.extent;
      }
    };
    column.getAggregationFn = () => {
      var _table$options$aggreg, _table$options$aggreg2;
      if (!column) {
        throw new Error();
      }
      return isFunction(column.columnDef.aggregationFn) ? column.columnDef.aggregationFn : column.columnDef.aggregationFn === "auto" ? column.getAutoAggregationFn() : (_table$options$aggreg = (_table$options$aggreg2 = table.options.aggregationFns) == null ? void 0 : _table$options$aggreg2[column.columnDef.aggregationFn]) != null ? _table$options$aggreg : aggregationFns[column.columnDef.aggregationFn];
    };
  },
  createTable: (table) => {
    table.setGrouping = (updater) => table.options.onGroupingChange == null ? void 0 : table.options.onGroupingChange(updater);
    table.resetGrouping = (defaultState) => {
      var _table$initialState$g, _table$initialState;
      table.setGrouping(defaultState ? [] : (_table$initialState$g = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.grouping) != null ? _table$initialState$g : []);
    };
    table.getPreGroupedRowModel = () => table.getFilteredRowModel();
    table.getGroupedRowModel = () => {
      if (!table._getGroupedRowModel && table.options.getGroupedRowModel) {
        table._getGroupedRowModel = table.options.getGroupedRowModel(table);
      }
      if (table.options.manualGrouping || !table._getGroupedRowModel) {
        return table.getPreGroupedRowModel();
      }
      return table._getGroupedRowModel();
    };
  },
  createRow: (row, table) => {
    row.getIsGrouped = () => !!row.groupingColumnId;
    row.getGroupingValue = (columnId) => {
      if (row._groupingValuesCache.hasOwnProperty(columnId)) {
        return row._groupingValuesCache[columnId];
      }
      const column = table.getColumn(columnId);
      if (!(column != null && column.columnDef.getGroupingValue)) {
        return row.getValue(columnId);
      }
      row._groupingValuesCache[columnId] = column.columnDef.getGroupingValue(row.original);
      return row._groupingValuesCache[columnId];
    };
    row._groupingValuesCache = {};
  },
  createCell: (cell, column, row, table) => {
    cell.getIsGrouped = () => column.getIsGrouped() && column.id === row.groupingColumnId;
    cell.getIsPlaceholder = () => !cell.getIsGrouped() && column.getIsGrouped();
    cell.getIsAggregated = () => {
      var _row$subRows;
      return !cell.getIsGrouped() && !cell.getIsPlaceholder() && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
    };
  }
};
function orderColumns(leafColumns, grouping, groupedColumnMode) {
  if (!(grouping != null && grouping.length) || !groupedColumnMode) {
    return leafColumns;
  }
  const nonGroupingColumns = leafColumns.filter((col) => !grouping.includes(col.id));
  if (groupedColumnMode === "remove") {
    return nonGroupingColumns;
  }
  const groupingColumns = grouping.map((g) => leafColumns.find((col) => col.id === g)).filter(Boolean);
  return [...groupingColumns, ...nonGroupingColumns];
}
const ColumnOrdering = {
  getInitialState: (state) => {
    return {
      columnOrder: [],
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onColumnOrderChange: makeStateUpdater("columnOrder", table)
    };
  },
  createColumn: (column, table) => {
    column.getIndex = memo$1((position) => [_getVisibleLeafColumns(table, position)], (columns) => columns.findIndex((d) => d.id === column.id), getMemoOptions(table.options, "debugColumns", "getIndex"));
    column.getIsFirstColumn = (position) => {
      var _columns$;
      const columns = _getVisibleLeafColumns(table, position);
      return ((_columns$ = columns[0]) == null ? void 0 : _columns$.id) === column.id;
    };
    column.getIsLastColumn = (position) => {
      var _columns;
      const columns = _getVisibleLeafColumns(table, position);
      return ((_columns = columns[columns.length - 1]) == null ? void 0 : _columns.id) === column.id;
    };
  },
  createTable: (table) => {
    table.setColumnOrder = (updater) => table.options.onColumnOrderChange == null ? void 0 : table.options.onColumnOrderChange(updater);
    table.resetColumnOrder = (defaultState) => {
      var _table$initialState$c;
      table.setColumnOrder(defaultState ? [] : (_table$initialState$c = table.initialState.columnOrder) != null ? _table$initialState$c : []);
    };
    table._getOrderColumnsFn = memo$1(() => [table.getState().columnOrder, table.getState().grouping, table.options.groupedColumnMode], (columnOrder, grouping, groupedColumnMode) => (columns) => {
      let orderedColumns = [];
      if (!(columnOrder != null && columnOrder.length)) {
        orderedColumns = columns;
      } else {
        const columnOrderCopy = [...columnOrder];
        const columnsCopy = [...columns];
        while (columnsCopy.length && columnOrderCopy.length) {
          const targetColumnId = columnOrderCopy.shift();
          const foundIndex = columnsCopy.findIndex((d) => d.id === targetColumnId);
          if (foundIndex > -1) {
            orderedColumns.push(columnsCopy.splice(foundIndex, 1)[0]);
          }
        }
        orderedColumns = [...orderedColumns, ...columnsCopy];
      }
      return orderColumns(orderedColumns, grouping, groupedColumnMode);
    }, getMemoOptions(table.options, "debugTable", "_getOrderColumnsFn"));
  }
};
const getDefaultColumnPinningState = () => ({
  left: [],
  right: []
});
const ColumnPinning = {
  getInitialState: (state) => {
    return {
      columnPinning: getDefaultColumnPinningState(),
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onColumnPinningChange: makeStateUpdater("columnPinning", table)
    };
  },
  createColumn: (column, table) => {
    column.pin = (position) => {
      const columnIds = column.getLeafColumns().map((d) => d.id).filter(Boolean);
      table.setColumnPinning((old) => {
        var _old$left3, _old$right3;
        if (position === "right") {
          var _old$left, _old$right;
          return {
            left: ((_old$left = old == null ? void 0 : old.left) != null ? _old$left : []).filter((d) => !(columnIds != null && columnIds.includes(d))),
            right: [...((_old$right = old == null ? void 0 : old.right) != null ? _old$right : []).filter((d) => !(columnIds != null && columnIds.includes(d))), ...columnIds]
          };
        }
        if (position === "left") {
          var _old$left2, _old$right2;
          return {
            left: [...((_old$left2 = old == null ? void 0 : old.left) != null ? _old$left2 : []).filter((d) => !(columnIds != null && columnIds.includes(d))), ...columnIds],
            right: ((_old$right2 = old == null ? void 0 : old.right) != null ? _old$right2 : []).filter((d) => !(columnIds != null && columnIds.includes(d)))
          };
        }
        return {
          left: ((_old$left3 = old == null ? void 0 : old.left) != null ? _old$left3 : []).filter((d) => !(columnIds != null && columnIds.includes(d))),
          right: ((_old$right3 = old == null ? void 0 : old.right) != null ? _old$right3 : []).filter((d) => !(columnIds != null && columnIds.includes(d)))
        };
      });
    };
    column.getCanPin = () => {
      const leafColumns = column.getLeafColumns();
      return leafColumns.some((d) => {
        var _d$columnDef$enablePi, _ref, _table$options$enable;
        return ((_d$columnDef$enablePi = d.columnDef.enablePinning) != null ? _d$columnDef$enablePi : true) && ((_ref = (_table$options$enable = table.options.enableColumnPinning) != null ? _table$options$enable : table.options.enablePinning) != null ? _ref : true);
      });
    };
    column.getIsPinned = () => {
      const leafColumnIds = column.getLeafColumns().map((d) => d.id);
      const {
        left,
        right
      } = table.getState().columnPinning;
      const isLeft = leafColumnIds.some((d) => left == null ? void 0 : left.includes(d));
      const isRight = leafColumnIds.some((d) => right == null ? void 0 : right.includes(d));
      return isLeft ? "left" : isRight ? "right" : false;
    };
    column.getPinnedIndex = () => {
      var _table$getState$colum, _table$getState$colum2;
      const position = column.getIsPinned();
      return position ? (_table$getState$colum = (_table$getState$colum2 = table.getState().columnPinning) == null || (_table$getState$colum2 = _table$getState$colum2[position]) == null ? void 0 : _table$getState$colum2.indexOf(column.id)) != null ? _table$getState$colum : -1 : 0;
    };
  },
  createRow: (row, table) => {
    row.getCenterVisibleCells = memo$1(() => [row._getAllVisibleCells(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allCells, left, right) => {
      const leftAndRight = [...left != null ? left : [], ...right != null ? right : []];
      return allCells.filter((d) => !leftAndRight.includes(d.column.id));
    }, getMemoOptions(table.options, "debugRows", "getCenterVisibleCells"));
    row.getLeftVisibleCells = memo$1(() => [row._getAllVisibleCells(), table.getState().columnPinning.left], (allCells, left) => {
      const cells = (left != null ? left : []).map((columnId) => allCells.find((cell) => cell.column.id === columnId)).filter(Boolean).map((d) => ({
        ...d,
        position: "left"
      }));
      return cells;
    }, getMemoOptions(table.options, "debugRows", "getLeftVisibleCells"));
    row.getRightVisibleCells = memo$1(() => [row._getAllVisibleCells(), table.getState().columnPinning.right], (allCells, right) => {
      const cells = (right != null ? right : []).map((columnId) => allCells.find((cell) => cell.column.id === columnId)).filter(Boolean).map((d) => ({
        ...d,
        position: "right"
      }));
      return cells;
    }, getMemoOptions(table.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (table) => {
    table.setColumnPinning = (updater) => table.options.onColumnPinningChange == null ? void 0 : table.options.onColumnPinningChange(updater);
    table.resetColumnPinning = (defaultState) => {
      var _table$initialState$c, _table$initialState;
      return table.setColumnPinning(defaultState ? getDefaultColumnPinningState() : (_table$initialState$c = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.columnPinning) != null ? _table$initialState$c : getDefaultColumnPinningState());
    };
    table.getIsSomeColumnsPinned = (position) => {
      var _pinningState$positio;
      const pinningState = table.getState().columnPinning;
      if (!position) {
        var _pinningState$left, _pinningState$right;
        return Boolean(((_pinningState$left = pinningState.left) == null ? void 0 : _pinningState$left.length) || ((_pinningState$right = pinningState.right) == null ? void 0 : _pinningState$right.length));
      }
      return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
    };
    table.getLeftLeafColumns = memo$1(() => [table.getAllLeafColumns(), table.getState().columnPinning.left], (allColumns, left) => {
      return (left != null ? left : []).map((columnId) => allColumns.find((column) => column.id === columnId)).filter(Boolean);
    }, getMemoOptions(table.options, "debugColumns", "getLeftLeafColumns"));
    table.getRightLeafColumns = memo$1(() => [table.getAllLeafColumns(), table.getState().columnPinning.right], (allColumns, right) => {
      return (right != null ? right : []).map((columnId) => allColumns.find((column) => column.id === columnId)).filter(Boolean);
    }, getMemoOptions(table.options, "debugColumns", "getRightLeafColumns"));
    table.getCenterLeafColumns = memo$1(() => [table.getAllLeafColumns(), table.getState().columnPinning.left, table.getState().columnPinning.right], (allColumns, left, right) => {
      const leftAndRight = [...left != null ? left : [], ...right != null ? right : []];
      return allColumns.filter((d) => !leftAndRight.includes(d.id));
    }, getMemoOptions(table.options, "debugColumns", "getCenterLeafColumns"));
  }
};
const defaultColumnSizing = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
};
const getDefaultColumnSizingInfoState = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: false,
  columnSizingStart: []
});
const ColumnSizing = {
  getDefaultColumnDef: () => {
    return defaultColumnSizing;
  },
  getInitialState: (state) => {
    return {
      columnSizing: {},
      columnSizingInfo: getDefaultColumnSizingInfoState(),
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      columnResizeMode: "onEnd",
      columnResizeDirection: "ltr",
      onColumnSizingChange: makeStateUpdater("columnSizing", table),
      onColumnSizingInfoChange: makeStateUpdater("columnSizingInfo", table)
    };
  },
  createColumn: (column, table) => {
    column.getSize = () => {
      var _column$columnDef$min, _ref, _column$columnDef$max;
      const columnSize = table.getState().columnSizing[column.id];
      return Math.min(Math.max((_column$columnDef$min = column.columnDef.minSize) != null ? _column$columnDef$min : defaultColumnSizing.minSize, (_ref = columnSize != null ? columnSize : column.columnDef.size) != null ? _ref : defaultColumnSizing.size), (_column$columnDef$max = column.columnDef.maxSize) != null ? _column$columnDef$max : defaultColumnSizing.maxSize);
    };
    column.getStart = memo$1((position) => [position, _getVisibleLeafColumns(table, position), table.getState().columnSizing], (position, columns) => columns.slice(0, column.getIndex(position)).reduce((sum2, column2) => sum2 + column2.getSize(), 0), getMemoOptions(table.options, "debugColumns", "getStart"));
    column.getAfter = memo$1((position) => [position, _getVisibleLeafColumns(table, position), table.getState().columnSizing], (position, columns) => columns.slice(column.getIndex(position) + 1).reduce((sum2, column2) => sum2 + column2.getSize(), 0), getMemoOptions(table.options, "debugColumns", "getAfter"));
    column.resetSize = () => {
      table.setColumnSizing((_ref2) => {
        let {
          [column.id]: _,
          ...rest
        } = _ref2;
        return rest;
      });
    };
    column.getCanResize = () => {
      var _column$columnDef$ena, _table$options$enable;
      return ((_column$columnDef$ena = column.columnDef.enableResizing) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableColumnResizing) != null ? _table$options$enable : true);
    };
    column.getIsResizing = () => {
      return table.getState().columnSizingInfo.isResizingColumn === column.id;
    };
  },
  createHeader: (header, table) => {
    header.getSize = () => {
      let sum2 = 0;
      const recurse = (header2) => {
        if (header2.subHeaders.length) {
          header2.subHeaders.forEach(recurse);
        } else {
          var _header$column$getSiz;
          sum2 += (_header$column$getSiz = header2.column.getSize()) != null ? _header$column$getSiz : 0;
        }
      };
      recurse(header);
      return sum2;
    };
    header.getStart = () => {
      if (header.index > 0) {
        const prevSiblingHeader = header.headerGroup.headers[header.index - 1];
        return prevSiblingHeader.getStart() + prevSiblingHeader.getSize();
      }
      return 0;
    };
    header.getResizeHandler = (_contextDocument) => {
      const column = table.getColumn(header.column.id);
      const canResize = column == null ? void 0 : column.getCanResize();
      return (e) => {
        if (!column || !canResize) {
          return;
        }
        e.persist == null || e.persist();
        if (isTouchStartEvent(e)) {
          if (e.touches && e.touches.length > 1) {
            return;
          }
        }
        const startSize = header.getSize();
        const columnSizingStart = header ? header.getLeafHeaders().map((d) => [d.column.id, d.column.getSize()]) : [[column.id, column.getSize()]];
        const clientX = isTouchStartEvent(e) ? Math.round(e.touches[0].clientX) : e.clientX;
        const newColumnSizing = {};
        const updateOffset = (eventType, clientXPos) => {
          if (typeof clientXPos !== "number") {
            return;
          }
          table.setColumnSizingInfo((old) => {
            var _old$startOffset, _old$startSize;
            const deltaDirection = table.options.columnResizeDirection === "rtl" ? -1 : 1;
            const deltaOffset = (clientXPos - ((_old$startOffset = old == null ? void 0 : old.startOffset) != null ? _old$startOffset : 0)) * deltaDirection;
            const deltaPercentage = Math.max(deltaOffset / ((_old$startSize = old == null ? void 0 : old.startSize) != null ? _old$startSize : 0), -0.999999);
            old.columnSizingStart.forEach((_ref3) => {
              let [columnId, headerSize] = _ref3;
              newColumnSizing[columnId] = Math.round(Math.max(headerSize + headerSize * deltaPercentage, 0) * 100) / 100;
            });
            return {
              ...old,
              deltaOffset,
              deltaPercentage
            };
          });
          if (table.options.columnResizeMode === "onChange" || eventType === "end") {
            table.setColumnSizing((old) => ({
              ...old,
              ...newColumnSizing
            }));
          }
        };
        const onMove = (clientXPos) => updateOffset("move", clientXPos);
        const onEnd = (clientXPos) => {
          updateOffset("end", clientXPos);
          table.setColumnSizingInfo((old) => ({
            ...old,
            isResizingColumn: false,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        };
        const contextDocument = _contextDocument || typeof document !== "undefined" ? document : null;
        const mouseEvents = {
          moveHandler: (e2) => onMove(e2.clientX),
          upHandler: (e2) => {
            contextDocument == null || contextDocument.removeEventListener("mousemove", mouseEvents.moveHandler);
            contextDocument == null || contextDocument.removeEventListener("mouseup", mouseEvents.upHandler);
            onEnd(e2.clientX);
          }
        };
        const touchEvents = {
          moveHandler: (e2) => {
            if (e2.cancelable) {
              e2.preventDefault();
              e2.stopPropagation();
            }
            onMove(e2.touches[0].clientX);
            return false;
          },
          upHandler: (e2) => {
            var _e$touches$;
            contextDocument == null || contextDocument.removeEventListener("touchmove", touchEvents.moveHandler);
            contextDocument == null || contextDocument.removeEventListener("touchend", touchEvents.upHandler);
            if (e2.cancelable) {
              e2.preventDefault();
              e2.stopPropagation();
            }
            onEnd((_e$touches$ = e2.touches[0]) == null ? void 0 : _e$touches$.clientX);
          }
        };
        const passiveIfSupported = passiveEventSupported() ? {
          passive: false
        } : false;
        if (isTouchStartEvent(e)) {
          contextDocument == null || contextDocument.addEventListener("touchmove", touchEvents.moveHandler, passiveIfSupported);
          contextDocument == null || contextDocument.addEventListener("touchend", touchEvents.upHandler, passiveIfSupported);
        } else {
          contextDocument == null || contextDocument.addEventListener("mousemove", mouseEvents.moveHandler, passiveIfSupported);
          contextDocument == null || contextDocument.addEventListener("mouseup", mouseEvents.upHandler, passiveIfSupported);
        }
        table.setColumnSizingInfo((old) => ({
          ...old,
          startOffset: clientX,
          startSize,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart,
          isResizingColumn: column.id
        }));
      };
    };
  },
  createTable: (table) => {
    table.setColumnSizing = (updater) => table.options.onColumnSizingChange == null ? void 0 : table.options.onColumnSizingChange(updater);
    table.setColumnSizingInfo = (updater) => table.options.onColumnSizingInfoChange == null ? void 0 : table.options.onColumnSizingInfoChange(updater);
    table.resetColumnSizing = (defaultState) => {
      var _table$initialState$c;
      table.setColumnSizing(defaultState ? {} : (_table$initialState$c = table.initialState.columnSizing) != null ? _table$initialState$c : {});
    };
    table.resetHeaderSizeInfo = (defaultState) => {
      var _table$initialState$c2;
      table.setColumnSizingInfo(defaultState ? getDefaultColumnSizingInfoState() : (_table$initialState$c2 = table.initialState.columnSizingInfo) != null ? _table$initialState$c2 : getDefaultColumnSizingInfoState());
    };
    table.getTotalSize = () => {
      var _table$getHeaderGroup, _table$getHeaderGroup2;
      return (_table$getHeaderGroup = (_table$getHeaderGroup2 = table.getHeaderGroups()[0]) == null ? void 0 : _table$getHeaderGroup2.headers.reduce((sum2, header) => {
        return sum2 + header.getSize();
      }, 0)) != null ? _table$getHeaderGroup : 0;
    };
    table.getLeftTotalSize = () => {
      var _table$getLeftHeaderG, _table$getLeftHeaderG2;
      return (_table$getLeftHeaderG = (_table$getLeftHeaderG2 = table.getLeftHeaderGroups()[0]) == null ? void 0 : _table$getLeftHeaderG2.headers.reduce((sum2, header) => {
        return sum2 + header.getSize();
      }, 0)) != null ? _table$getLeftHeaderG : 0;
    };
    table.getCenterTotalSize = () => {
      var _table$getCenterHeade, _table$getCenterHeade2;
      return (_table$getCenterHeade = (_table$getCenterHeade2 = table.getCenterHeaderGroups()[0]) == null ? void 0 : _table$getCenterHeade2.headers.reduce((sum2, header) => {
        return sum2 + header.getSize();
      }, 0)) != null ? _table$getCenterHeade : 0;
    };
    table.getRightTotalSize = () => {
      var _table$getRightHeader, _table$getRightHeader2;
      return (_table$getRightHeader = (_table$getRightHeader2 = table.getRightHeaderGroups()[0]) == null ? void 0 : _table$getRightHeader2.headers.reduce((sum2, header) => {
        return sum2 + header.getSize();
      }, 0)) != null ? _table$getRightHeader : 0;
    };
  }
};
let passiveSupported = null;
function passiveEventSupported() {
  if (typeof passiveSupported === "boolean") return passiveSupported;
  let supported = false;
  try {
    const options2 = {
      get passive() {
        supported = true;
        return false;
      }
    };
    const noop = () => {
    };
    window.addEventListener("test", noop, options2);
    window.removeEventListener("test", noop);
  } catch (err) {
    supported = false;
  }
  passiveSupported = supported;
  return passiveSupported;
}
function isTouchStartEvent(e) {
  return e.type === "touchstart";
}
const ColumnVisibility = {
  getInitialState: (state) => {
    return {
      columnVisibility: {},
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onColumnVisibilityChange: makeStateUpdater("columnVisibility", table)
    };
  },
  createColumn: (column, table) => {
    column.toggleVisibility = (value) => {
      if (column.getCanHide()) {
        table.setColumnVisibility((old) => ({
          ...old,
          [column.id]: value != null ? value : !column.getIsVisible()
        }));
      }
    };
    column.getIsVisible = () => {
      var _ref, _table$getState$colum;
      const childColumns = column.columns;
      return (_ref = childColumns.length ? childColumns.some((c) => c.getIsVisible()) : (_table$getState$colum = table.getState().columnVisibility) == null ? void 0 : _table$getState$colum[column.id]) != null ? _ref : true;
    };
    column.getCanHide = () => {
      var _column$columnDef$ena, _table$options$enable;
      return ((_column$columnDef$ena = column.columnDef.enableHiding) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableHiding) != null ? _table$options$enable : true);
    };
    column.getToggleVisibilityHandler = () => {
      return (e) => {
        column.toggleVisibility == null || column.toggleVisibility(e.target.checked);
      };
    };
  },
  createRow: (row, table) => {
    row._getAllVisibleCells = memo$1(() => [row.getAllCells(), table.getState().columnVisibility], (cells) => {
      return cells.filter((cell) => cell.column.getIsVisible());
    }, getMemoOptions(table.options, "debugRows", "_getAllVisibleCells"));
    row.getVisibleCells = memo$1(() => [row.getLeftVisibleCells(), row.getCenterVisibleCells(), row.getRightVisibleCells()], (left, center, right) => [...left, ...center, ...right], getMemoOptions(table.options, "debugRows", "getVisibleCells"));
  },
  createTable: (table) => {
    const makeVisibleColumnsMethod = (key, getColumns) => {
      return memo$1(() => [getColumns(), getColumns().filter((d) => d.getIsVisible()).map((d) => d.id).join("_")], (columns) => {
        return columns.filter((d) => d.getIsVisible == null ? void 0 : d.getIsVisible());
      }, getMemoOptions(table.options, "debugColumns", key));
    };
    table.getVisibleFlatColumns = makeVisibleColumnsMethod("getVisibleFlatColumns", () => table.getAllFlatColumns());
    table.getVisibleLeafColumns = makeVisibleColumnsMethod("getVisibleLeafColumns", () => table.getAllLeafColumns());
    table.getLeftVisibleLeafColumns = makeVisibleColumnsMethod("getLeftVisibleLeafColumns", () => table.getLeftLeafColumns());
    table.getRightVisibleLeafColumns = makeVisibleColumnsMethod("getRightVisibleLeafColumns", () => table.getRightLeafColumns());
    table.getCenterVisibleLeafColumns = makeVisibleColumnsMethod("getCenterVisibleLeafColumns", () => table.getCenterLeafColumns());
    table.setColumnVisibility = (updater) => table.options.onColumnVisibilityChange == null ? void 0 : table.options.onColumnVisibilityChange(updater);
    table.resetColumnVisibility = (defaultState) => {
      var _table$initialState$c;
      table.setColumnVisibility(defaultState ? {} : (_table$initialState$c = table.initialState.columnVisibility) != null ? _table$initialState$c : {});
    };
    table.toggleAllColumnsVisible = (value) => {
      var _value;
      value = (_value = value) != null ? _value : !table.getIsAllColumnsVisible();
      table.setColumnVisibility(table.getAllLeafColumns().reduce((obj, column) => ({
        ...obj,
        [column.id]: !value ? !(column.getCanHide != null && column.getCanHide()) : value
      }), {}));
    };
    table.getIsAllColumnsVisible = () => !table.getAllLeafColumns().some((column) => !(column.getIsVisible != null && column.getIsVisible()));
    table.getIsSomeColumnsVisible = () => table.getAllLeafColumns().some((column) => column.getIsVisible == null ? void 0 : column.getIsVisible());
    table.getToggleAllColumnsVisibilityHandler = () => {
      return (e) => {
        var _target;
        table.toggleAllColumnsVisible((_target = e.target) == null ? void 0 : _target.checked);
      };
    };
  }
};
function _getVisibleLeafColumns(table, position) {
  return !position ? table.getVisibleLeafColumns() : position === "center" ? table.getCenterVisibleLeafColumns() : position === "left" ? table.getLeftVisibleLeafColumns() : table.getRightVisibleLeafColumns();
}
const GlobalFaceting = {
  createTable: (table) => {
    table._getGlobalFacetedRowModel = table.options.getFacetedRowModel && table.options.getFacetedRowModel(table, "__global__");
    table.getGlobalFacetedRowModel = () => {
      if (table.options.manualFiltering || !table._getGlobalFacetedRowModel) {
        return table.getPreFilteredRowModel();
      }
      return table._getGlobalFacetedRowModel();
    };
    table._getGlobalFacetedUniqueValues = table.options.getFacetedUniqueValues && table.options.getFacetedUniqueValues(table, "__global__");
    table.getGlobalFacetedUniqueValues = () => {
      if (!table._getGlobalFacetedUniqueValues) {
        return /* @__PURE__ */ new Map();
      }
      return table._getGlobalFacetedUniqueValues();
    };
    table._getGlobalFacetedMinMaxValues = table.options.getFacetedMinMaxValues && table.options.getFacetedMinMaxValues(table, "__global__");
    table.getGlobalFacetedMinMaxValues = () => {
      if (!table._getGlobalFacetedMinMaxValues) {
        return;
      }
      return table._getGlobalFacetedMinMaxValues();
    };
  }
};
const GlobalFiltering = {
  getInitialState: (state) => {
    return {
      globalFilter: void 0,
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onGlobalFilterChange: makeStateUpdater("globalFilter", table),
      globalFilterFn: "auto",
      getColumnCanGlobalFilter: (column) => {
        var _table$getCoreRowMode;
        const value = (_table$getCoreRowMode = table.getCoreRowModel().flatRows[0]) == null || (_table$getCoreRowMode = _table$getCoreRowMode._getAllCellsByColumnId()[column.id]) == null ? void 0 : _table$getCoreRowMode.getValue();
        return typeof value === "string" || typeof value === "number";
      }
    };
  },
  createColumn: (column, table) => {
    column.getCanGlobalFilter = () => {
      var _column$columnDef$ena, _table$options$enable, _table$options$enable2, _table$options$getCol;
      return ((_column$columnDef$ena = column.columnDef.enableGlobalFilter) != null ? _column$columnDef$ena : true) && ((_table$options$enable = table.options.enableGlobalFilter) != null ? _table$options$enable : true) && ((_table$options$enable2 = table.options.enableFilters) != null ? _table$options$enable2 : true) && ((_table$options$getCol = table.options.getColumnCanGlobalFilter == null ? void 0 : table.options.getColumnCanGlobalFilter(column)) != null ? _table$options$getCol : true) && !!column.accessorFn;
    };
  },
  createTable: (table) => {
    table.getGlobalAutoFilterFn = () => {
      return filterFns.includesString;
    };
    table.getGlobalFilterFn = () => {
      var _table$options$filter, _table$options$filter2;
      const {
        globalFilterFn
      } = table.options;
      return isFunction(globalFilterFn) ? globalFilterFn : globalFilterFn === "auto" ? table.getGlobalAutoFilterFn() : (_table$options$filter = (_table$options$filter2 = table.options.filterFns) == null ? void 0 : _table$options$filter2[globalFilterFn]) != null ? _table$options$filter : filterFns[globalFilterFn];
    };
    table.setGlobalFilter = (updater) => {
      table.options.onGlobalFilterChange == null || table.options.onGlobalFilterChange(updater);
    };
    table.resetGlobalFilter = (defaultState) => {
      table.setGlobalFilter(defaultState ? void 0 : table.initialState.globalFilter);
    };
  }
};
const RowExpanding = {
  getInitialState: (state) => {
    return {
      expanded: {},
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onExpandedChange: makeStateUpdater("expanded", table),
      paginateExpandedRows: true
    };
  },
  createTable: (table) => {
    let registered = false;
    let queued = false;
    table._autoResetExpanded = () => {
      var _ref, _table$options$autoRe;
      if (!registered) {
        table._queue(() => {
          registered = true;
        });
        return;
      }
      if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetExpanded) != null ? _ref : !table.options.manualExpanding) {
        if (queued) return;
        queued = true;
        table._queue(() => {
          table.resetExpanded();
          queued = false;
        });
      }
    };
    table.setExpanded = (updater) => table.options.onExpandedChange == null ? void 0 : table.options.onExpandedChange(updater);
    table.toggleAllRowsExpanded = (expanded) => {
      if (expanded != null ? expanded : !table.getIsAllRowsExpanded()) {
        table.setExpanded(true);
      } else {
        table.setExpanded({});
      }
    };
    table.resetExpanded = (defaultState) => {
      var _table$initialState$e, _table$initialState;
      table.setExpanded(defaultState ? {} : (_table$initialState$e = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.expanded) != null ? _table$initialState$e : {});
    };
    table.getCanSomeRowsExpand = () => {
      return table.getPrePaginationRowModel().flatRows.some((row) => row.getCanExpand());
    };
    table.getToggleAllRowsExpandedHandler = () => {
      return (e) => {
        e.persist == null || e.persist();
        table.toggleAllRowsExpanded();
      };
    };
    table.getIsSomeRowsExpanded = () => {
      const expanded = table.getState().expanded;
      return expanded === true || Object.values(expanded).some(Boolean);
    };
    table.getIsAllRowsExpanded = () => {
      const expanded = table.getState().expanded;
      if (typeof expanded === "boolean") {
        return expanded === true;
      }
      if (!Object.keys(expanded).length) {
        return false;
      }
      if (table.getRowModel().flatRows.some((row) => !row.getIsExpanded())) {
        return false;
      }
      return true;
    };
    table.getExpandedDepth = () => {
      let maxDepth = 0;
      const rowIds = table.getState().expanded === true ? Object.keys(table.getRowModel().rowsById) : Object.keys(table.getState().expanded);
      rowIds.forEach((id) => {
        const splitId = id.split(".");
        maxDepth = Math.max(maxDepth, splitId.length);
      });
      return maxDepth;
    };
    table.getPreExpandedRowModel = () => table.getSortedRowModel();
    table.getExpandedRowModel = () => {
      if (!table._getExpandedRowModel && table.options.getExpandedRowModel) {
        table._getExpandedRowModel = table.options.getExpandedRowModel(table);
      }
      if (table.options.manualExpanding || !table._getExpandedRowModel) {
        return table.getPreExpandedRowModel();
      }
      return table._getExpandedRowModel();
    };
  },
  createRow: (row, table) => {
    row.toggleExpanded = (expanded) => {
      table.setExpanded((old) => {
        var _expanded;
        const exists = old === true ? true : !!(old != null && old[row.id]);
        let oldExpanded = {};
        if (old === true) {
          Object.keys(table.getRowModel().rowsById).forEach((rowId) => {
            oldExpanded[rowId] = true;
          });
        } else {
          oldExpanded = old;
        }
        expanded = (_expanded = expanded) != null ? _expanded : !exists;
        if (!exists && expanded) {
          return {
            ...oldExpanded,
            [row.id]: true
          };
        }
        if (exists && !expanded) {
          const {
            [row.id]: _,
            ...rest
          } = oldExpanded;
          return rest;
        }
        return old;
      });
    };
    row.getIsExpanded = () => {
      var _table$options$getIsR;
      const expanded = table.getState().expanded;
      return !!((_table$options$getIsR = table.options.getIsRowExpanded == null ? void 0 : table.options.getIsRowExpanded(row)) != null ? _table$options$getIsR : expanded === true || (expanded == null ? void 0 : expanded[row.id]));
    };
    row.getCanExpand = () => {
      var _table$options$getRow, _table$options$enable, _row$subRows;
      return (_table$options$getRow = table.options.getRowCanExpand == null ? void 0 : table.options.getRowCanExpand(row)) != null ? _table$options$getRow : ((_table$options$enable = table.options.enableExpanding) != null ? _table$options$enable : true) && !!((_row$subRows = row.subRows) != null && _row$subRows.length);
    };
    row.getIsAllParentsExpanded = () => {
      let isFullyExpanded = true;
      let currentRow = row;
      while (isFullyExpanded && currentRow.parentId) {
        currentRow = table.getRow(currentRow.parentId, true);
        isFullyExpanded = currentRow.getIsExpanded();
      }
      return isFullyExpanded;
    };
    row.getToggleExpandedHandler = () => {
      const canExpand = row.getCanExpand();
      return () => {
        if (!canExpand) return;
        row.toggleExpanded();
      };
    };
  }
};
const defaultPageIndex = 0;
const defaultPageSize = 10;
const getDefaultPaginationState = () => ({
  pageIndex: defaultPageIndex,
  pageSize: defaultPageSize
});
const RowPagination = {
  getInitialState: (state) => {
    return {
      ...state,
      pagination: {
        ...getDefaultPaginationState(),
        ...state == null ? void 0 : state.pagination
      }
    };
  },
  getDefaultOptions: (table) => {
    return {
      onPaginationChange: makeStateUpdater("pagination", table)
    };
  },
  createTable: (table) => {
    let registered = false;
    let queued = false;
    table._autoResetPageIndex = () => {
      var _ref, _table$options$autoRe;
      if (!registered) {
        table._queue(() => {
          registered = true;
        });
        return;
      }
      if ((_ref = (_table$options$autoRe = table.options.autoResetAll) != null ? _table$options$autoRe : table.options.autoResetPageIndex) != null ? _ref : !table.options.manualPagination) {
        if (queued) return;
        queued = true;
        table._queue(() => {
          table.resetPageIndex();
          queued = false;
        });
      }
    };
    table.setPagination = (updater) => {
      const safeUpdater = (old) => {
        let newState = functionalUpdate(updater, old);
        return newState;
      };
      return table.options.onPaginationChange == null ? void 0 : table.options.onPaginationChange(safeUpdater);
    };
    table.resetPagination = (defaultState) => {
      var _table$initialState$p;
      table.setPagination(defaultState ? getDefaultPaginationState() : (_table$initialState$p = table.initialState.pagination) != null ? _table$initialState$p : getDefaultPaginationState());
    };
    table.setPageIndex = (updater) => {
      table.setPagination((old) => {
        let pageIndex = functionalUpdate(updater, old.pageIndex);
        const maxPageIndex = typeof table.options.pageCount === "undefined" || table.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : table.options.pageCount - 1;
        pageIndex = Math.max(0, Math.min(pageIndex, maxPageIndex));
        return {
          ...old,
          pageIndex
        };
      });
    };
    table.resetPageIndex = (defaultState) => {
      var _table$initialState$p2, _table$initialState;
      table.setPageIndex(defaultState ? defaultPageIndex : (_table$initialState$p2 = (_table$initialState = table.initialState) == null || (_table$initialState = _table$initialState.pagination) == null ? void 0 : _table$initialState.pageIndex) != null ? _table$initialState$p2 : defaultPageIndex);
    };
    table.resetPageSize = (defaultState) => {
      var _table$initialState$p3, _table$initialState2;
      table.setPageSize(defaultState ? defaultPageSize : (_table$initialState$p3 = (_table$initialState2 = table.initialState) == null || (_table$initialState2 = _table$initialState2.pagination) == null ? void 0 : _table$initialState2.pageSize) != null ? _table$initialState$p3 : defaultPageSize);
    };
    table.setPageSize = (updater) => {
      table.setPagination((old) => {
        const pageSize = Math.max(1, functionalUpdate(updater, old.pageSize));
        const topRowIndex = old.pageSize * old.pageIndex;
        const pageIndex = Math.floor(topRowIndex / pageSize);
        return {
          ...old,
          pageIndex,
          pageSize
        };
      });
    };
    table.setPageCount = (updater) => table.setPagination((old) => {
      var _table$options$pageCo;
      let newPageCount = functionalUpdate(updater, (_table$options$pageCo = table.options.pageCount) != null ? _table$options$pageCo : -1);
      if (typeof newPageCount === "number") {
        newPageCount = Math.max(-1, newPageCount);
      }
      return {
        ...old,
        pageCount: newPageCount
      };
    });
    table.getPageOptions = memo$1(() => [table.getPageCount()], (pageCount) => {
      let pageOptions = [];
      if (pageCount && pageCount > 0) {
        pageOptions = [...new Array(pageCount)].fill(null).map((_, i) => i);
      }
      return pageOptions;
    }, getMemoOptions(table.options, "debugTable", "getPageOptions"));
    table.getCanPreviousPage = () => table.getState().pagination.pageIndex > 0;
    table.getCanNextPage = () => {
      const {
        pageIndex
      } = table.getState().pagination;
      const pageCount = table.getPageCount();
      if (pageCount === -1) {
        return true;
      }
      if (pageCount === 0) {
        return false;
      }
      return pageIndex < pageCount - 1;
    };
    table.previousPage = () => {
      return table.setPageIndex((old) => old - 1);
    };
    table.nextPage = () => {
      return table.setPageIndex((old) => {
        return old + 1;
      });
    };
    table.firstPage = () => {
      return table.setPageIndex(0);
    };
    table.lastPage = () => {
      return table.setPageIndex(table.getPageCount() - 1);
    };
    table.getPrePaginationRowModel = () => table.getExpandedRowModel();
    table.getPaginationRowModel = () => {
      if (!table._getPaginationRowModel && table.options.getPaginationRowModel) {
        table._getPaginationRowModel = table.options.getPaginationRowModel(table);
      }
      if (table.options.manualPagination || !table._getPaginationRowModel) {
        return table.getPrePaginationRowModel();
      }
      return table._getPaginationRowModel();
    };
    table.getPageCount = () => {
      var _table$options$pageCo2;
      return (_table$options$pageCo2 = table.options.pageCount) != null ? _table$options$pageCo2 : Math.ceil(table.getRowCount() / table.getState().pagination.pageSize);
    };
    table.getRowCount = () => {
      var _table$options$rowCou;
      return (_table$options$rowCou = table.options.rowCount) != null ? _table$options$rowCou : table.getPrePaginationRowModel().rows.length;
    };
  }
};
const getDefaultRowPinningState = () => ({
  top: [],
  bottom: []
});
const RowPinning = {
  getInitialState: (state) => {
    return {
      rowPinning: getDefaultRowPinningState(),
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onRowPinningChange: makeStateUpdater("rowPinning", table)
    };
  },
  createRow: (row, table) => {
    row.pin = (position, includeLeafRows, includeParentRows) => {
      const leafRowIds = includeLeafRows ? row.getLeafRows().map((_ref) => {
        let {
          id
        } = _ref;
        return id;
      }) : [];
      const parentRowIds = includeParentRows ? row.getParentRows().map((_ref2) => {
        let {
          id
        } = _ref2;
        return id;
      }) : [];
      const rowIds = /* @__PURE__ */ new Set([...parentRowIds, row.id, ...leafRowIds]);
      table.setRowPinning((old) => {
        var _old$top3, _old$bottom3;
        if (position === "bottom") {
          var _old$top, _old$bottom;
          return {
            top: ((_old$top = old == null ? void 0 : old.top) != null ? _old$top : []).filter((d) => !(rowIds != null && rowIds.has(d))),
            bottom: [...((_old$bottom = old == null ? void 0 : old.bottom) != null ? _old$bottom : []).filter((d) => !(rowIds != null && rowIds.has(d))), ...Array.from(rowIds)]
          };
        }
        if (position === "top") {
          var _old$top2, _old$bottom2;
          return {
            top: [...((_old$top2 = old == null ? void 0 : old.top) != null ? _old$top2 : []).filter((d) => !(rowIds != null && rowIds.has(d))), ...Array.from(rowIds)],
            bottom: ((_old$bottom2 = old == null ? void 0 : old.bottom) != null ? _old$bottom2 : []).filter((d) => !(rowIds != null && rowIds.has(d)))
          };
        }
        return {
          top: ((_old$top3 = old == null ? void 0 : old.top) != null ? _old$top3 : []).filter((d) => !(rowIds != null && rowIds.has(d))),
          bottom: ((_old$bottom3 = old == null ? void 0 : old.bottom) != null ? _old$bottom3 : []).filter((d) => !(rowIds != null && rowIds.has(d)))
        };
      });
    };
    row.getCanPin = () => {
      var _ref3;
      const {
        enableRowPinning,
        enablePinning
      } = table.options;
      if (typeof enableRowPinning === "function") {
        return enableRowPinning(row);
      }
      return (_ref3 = enableRowPinning != null ? enableRowPinning : enablePinning) != null ? _ref3 : true;
    };
    row.getIsPinned = () => {
      const rowIds = [row.id];
      const {
        top,
        bottom
      } = table.getState().rowPinning;
      const isTop = rowIds.some((d) => top == null ? void 0 : top.includes(d));
      const isBottom = rowIds.some((d) => bottom == null ? void 0 : bottom.includes(d));
      return isTop ? "top" : isBottom ? "bottom" : false;
    };
    row.getPinnedIndex = () => {
      var _table$_getPinnedRows, _visiblePinnedRowIds$;
      const position = row.getIsPinned();
      if (!position) return -1;
      const visiblePinnedRowIds = (_table$_getPinnedRows = table._getPinnedRows(position)) == null ? void 0 : _table$_getPinnedRows.map((_ref4) => {
        let {
          id
        } = _ref4;
        return id;
      });
      return (_visiblePinnedRowIds$ = visiblePinnedRowIds == null ? void 0 : visiblePinnedRowIds.indexOf(row.id)) != null ? _visiblePinnedRowIds$ : -1;
    };
  },
  createTable: (table) => {
    table.setRowPinning = (updater) => table.options.onRowPinningChange == null ? void 0 : table.options.onRowPinningChange(updater);
    table.resetRowPinning = (defaultState) => {
      var _table$initialState$r, _table$initialState;
      return table.setRowPinning(defaultState ? getDefaultRowPinningState() : (_table$initialState$r = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.rowPinning) != null ? _table$initialState$r : getDefaultRowPinningState());
    };
    table.getIsSomeRowsPinned = (position) => {
      var _pinningState$positio;
      const pinningState = table.getState().rowPinning;
      if (!position) {
        var _pinningState$top, _pinningState$bottom;
        return Boolean(((_pinningState$top = pinningState.top) == null ? void 0 : _pinningState$top.length) || ((_pinningState$bottom = pinningState.bottom) == null ? void 0 : _pinningState$bottom.length));
      }
      return Boolean((_pinningState$positio = pinningState[position]) == null ? void 0 : _pinningState$positio.length);
    };
    table._getPinnedRows = memo$1((position) => [table.getRowModel().rows, table.getState().rowPinning[position], position], (visibleRows, pinnedRowIds, position) => {
      var _table$options$keepPi;
      const rows = ((_table$options$keepPi = table.options.keepPinnedRows) != null ? _table$options$keepPi : true) ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (pinnedRowIds != null ? pinnedRowIds : []).map((rowId) => {
          const row = table.getRow(rowId, true);
          return row.getIsAllParentsExpanded() ? row : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (pinnedRowIds != null ? pinnedRowIds : []).map((rowId) => visibleRows.find((row) => row.id === rowId))
      );
      return rows.filter(Boolean).map((d) => ({
        ...d,
        position
      }));
    }, getMemoOptions(table.options, "debugRows", "_getPinnedRows"));
    table.getTopRows = () => table._getPinnedRows("top");
    table.getBottomRows = () => table._getPinnedRows("bottom");
    table.getCenterRows = memo$1(() => [table.getRowModel().rows, table.getState().rowPinning.top, table.getState().rowPinning.bottom], (allRows, top, bottom) => {
      const topAndBottom = /* @__PURE__ */ new Set([...top != null ? top : [], ...bottom != null ? bottom : []]);
      return allRows.filter((d) => !topAndBottom.has(d.id));
    }, getMemoOptions(table.options, "debugRows", "getCenterRows"));
  }
};
const RowSelection = {
  getInitialState: (state) => {
    return {
      rowSelection: {},
      ...state
    };
  },
  getDefaultOptions: (table) => {
    return {
      onRowSelectionChange: makeStateUpdater("rowSelection", table),
      enableRowSelection: true,
      enableMultiRowSelection: true,
      enableSubRowSelection: true
      // enableGroupingRowSelection: false,
      // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
      // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
    };
  },
  createTable: (table) => {
    table.setRowSelection = (updater) => table.options.onRowSelectionChange == null ? void 0 : table.options.onRowSelectionChange(updater);
    table.resetRowSelection = (defaultState) => {
      var _table$initialState$r;
      return table.setRowSelection(defaultState ? {} : (_table$initialState$r = table.initialState.rowSelection) != null ? _table$initialState$r : {});
    };
    table.toggleAllRowsSelected = (value) => {
      table.setRowSelection((old) => {
        value = typeof value !== "undefined" ? value : !table.getIsAllRowsSelected();
        const rowSelection = {
          ...old
        };
        const preGroupedFlatRows = table.getPreGroupedRowModel().flatRows;
        if (value) {
          preGroupedFlatRows.forEach((row) => {
            if (!row.getCanSelect()) {
              return;
            }
            rowSelection[row.id] = true;
          });
        } else {
          preGroupedFlatRows.forEach((row) => {
            delete rowSelection[row.id];
          });
        }
        return rowSelection;
      });
    };
    table.toggleAllPageRowsSelected = (value) => table.setRowSelection((old) => {
      const resolvedValue = typeof value !== "undefined" ? value : !table.getIsAllPageRowsSelected();
      const rowSelection = {
        ...old
      };
      table.getRowModel().rows.forEach((row) => {
        mutateRowIsSelected(rowSelection, row.id, resolvedValue, true, table);
      });
      return rowSelection;
    });
    table.getPreSelectedRowModel = () => table.getCoreRowModel();
    table.getSelectedRowModel = memo$1(() => [table.getState().rowSelection, table.getCoreRowModel()], (rowSelection, rowModel) => {
      if (!Object.keys(rowSelection).length) {
        return {
          rows: [],
          flatRows: [],
          rowsById: {}
        };
      }
      return selectRowsFn(table, rowModel);
    }, getMemoOptions(table.options, "debugTable", "getSelectedRowModel"));
    table.getFilteredSelectedRowModel = memo$1(() => [table.getState().rowSelection, table.getFilteredRowModel()], (rowSelection, rowModel) => {
      if (!Object.keys(rowSelection).length) {
        return {
          rows: [],
          flatRows: [],
          rowsById: {}
        };
      }
      return selectRowsFn(table, rowModel);
    }, getMemoOptions(table.options, "debugTable", "getFilteredSelectedRowModel"));
    table.getGroupedSelectedRowModel = memo$1(() => [table.getState().rowSelection, table.getSortedRowModel()], (rowSelection, rowModel) => {
      if (!Object.keys(rowSelection).length) {
        return {
          rows: [],
          flatRows: [],
          rowsById: {}
        };
      }
      return selectRowsFn(table, rowModel);
    }, getMemoOptions(table.options, "debugTable", "getGroupedSelectedRowModel"));
    table.getIsAllRowsSelected = () => {
      const preGroupedFlatRows = table.getFilteredRowModel().flatRows;
      const {
        rowSelection
      } = table.getState();
      let isAllRowsSelected = Boolean(preGroupedFlatRows.length && Object.keys(rowSelection).length);
      if (isAllRowsSelected) {
        if (preGroupedFlatRows.some((row) => row.getCanSelect() && !rowSelection[row.id])) {
          isAllRowsSelected = false;
        }
      }
      return isAllRowsSelected;
    };
    table.getIsAllPageRowsSelected = () => {
      const paginationFlatRows = table.getPaginationRowModel().flatRows.filter((row) => row.getCanSelect());
      const {
        rowSelection
      } = table.getState();
      let isAllPageRowsSelected = !!paginationFlatRows.length;
      if (isAllPageRowsSelected && paginationFlatRows.some((row) => !rowSelection[row.id])) {
        isAllPageRowsSelected = false;
      }
      return isAllPageRowsSelected;
    };
    table.getIsSomeRowsSelected = () => {
      var _table$getState$rowSe;
      const totalSelected = Object.keys((_table$getState$rowSe = table.getState().rowSelection) != null ? _table$getState$rowSe : {}).length;
      return totalSelected > 0 && totalSelected < table.getFilteredRowModel().flatRows.length;
    };
    table.getIsSomePageRowsSelected = () => {
      const paginationFlatRows = table.getPaginationRowModel().flatRows;
      return table.getIsAllPageRowsSelected() ? false : paginationFlatRows.filter((row) => row.getCanSelect()).some((d) => d.getIsSelected() || d.getIsSomeSelected());
    };
    table.getToggleAllRowsSelectedHandler = () => {
      return (e) => {
        table.toggleAllRowsSelected(e.target.checked);
      };
    };
    table.getToggleAllPageRowsSelectedHandler = () => {
      return (e) => {
        table.toggleAllPageRowsSelected(e.target.checked);
      };
    };
  },
  createRow: (row, table) => {
    row.toggleSelected = (value, opts) => {
      const isSelected = row.getIsSelected();
      table.setRowSelection((old) => {
        var _opts$selectChildren;
        value = typeof value !== "undefined" ? value : !isSelected;
        if (row.getCanSelect() && isSelected === value) {
          return old;
        }
        const selectedRowIds = {
          ...old
        };
        mutateRowIsSelected(selectedRowIds, row.id, value, (_opts$selectChildren = opts == null ? void 0 : opts.selectChildren) != null ? _opts$selectChildren : true, table);
        return selectedRowIds;
      });
    };
    row.getIsSelected = () => {
      const {
        rowSelection
      } = table.getState();
      return isRowSelected(row, rowSelection);
    };
    row.getIsSomeSelected = () => {
      const {
        rowSelection
      } = table.getState();
      return isSubRowSelected(row, rowSelection) === "some";
    };
    row.getIsAllSubRowsSelected = () => {
      const {
        rowSelection
      } = table.getState();
      return isSubRowSelected(row, rowSelection) === "all";
    };
    row.getCanSelect = () => {
      var _table$options$enable;
      if (typeof table.options.enableRowSelection === "function") {
        return table.options.enableRowSelection(row);
      }
      return (_table$options$enable = table.options.enableRowSelection) != null ? _table$options$enable : true;
    };
    row.getCanSelectSubRows = () => {
      var _table$options$enable2;
      if (typeof table.options.enableSubRowSelection === "function") {
        return table.options.enableSubRowSelection(row);
      }
      return (_table$options$enable2 = table.options.enableSubRowSelection) != null ? _table$options$enable2 : true;
    };
    row.getCanMultiSelect = () => {
      var _table$options$enable3;
      if (typeof table.options.enableMultiRowSelection === "function") {
        return table.options.enableMultiRowSelection(row);
      }
      return (_table$options$enable3 = table.options.enableMultiRowSelection) != null ? _table$options$enable3 : true;
    };
    row.getToggleSelectedHandler = () => {
      const canSelect = row.getCanSelect();
      return (e) => {
        var _target;
        if (!canSelect) return;
        row.toggleSelected((_target = e.target) == null ? void 0 : _target.checked);
      };
    };
  }
};
const mutateRowIsSelected = (selectedRowIds, id, value, includeChildren, table) => {
  var _row$subRows;
  const row = table.getRow(id, true);
  if (value) {
    if (!row.getCanMultiSelect()) {
      Object.keys(selectedRowIds).forEach((key) => delete selectedRowIds[key]);
    }
    if (row.getCanSelect()) {
      selectedRowIds[id] = true;
    }
  } else {
    delete selectedRowIds[id];
  }
  if (includeChildren && (_row$subRows = row.subRows) != null && _row$subRows.length && row.getCanSelectSubRows()) {
    row.subRows.forEach((row2) => mutateRowIsSelected(selectedRowIds, row2.id, value, includeChildren, table));
  }
};
function selectRowsFn(table, rowModel) {
  const rowSelection = table.getState().rowSelection;
  const newSelectedFlatRows = [];
  const newSelectedRowsById = {};
  const recurseRows = function(rows, depth) {
    return rows.map((row) => {
      var _row$subRows2;
      const isSelected = isRowSelected(row, rowSelection);
      if (isSelected) {
        newSelectedFlatRows.push(row);
        newSelectedRowsById[row.id] = row;
      }
      if ((_row$subRows2 = row.subRows) != null && _row$subRows2.length) {
        row = {
          ...row,
          subRows: recurseRows(row.subRows)
        };
      }
      if (isSelected) {
        return row;
      }
    }).filter(Boolean);
  };
  return {
    rows: recurseRows(rowModel.rows),
    flatRows: newSelectedFlatRows,
    rowsById: newSelectedRowsById
  };
}
function isRowSelected(row, selection) {
  var _selection$row$id;
  return (_selection$row$id = selection[row.id]) != null ? _selection$row$id : false;
}
function isSubRowSelected(row, selection, table) {
  var _row$subRows3;
  if (!((_row$subRows3 = row.subRows) != null && _row$subRows3.length)) return false;
  let allChildrenSelected = true;
  let someSelected = false;
  row.subRows.forEach((subRow) => {
    if (someSelected && !allChildrenSelected) {
      return;
    }
    if (subRow.getCanSelect()) {
      if (isRowSelected(subRow, selection)) {
        someSelected = true;
      } else {
        allChildrenSelected = false;
      }
    }
    if (subRow.subRows && subRow.subRows.length) {
      const subRowChildrenSelected = isSubRowSelected(subRow, selection);
      if (subRowChildrenSelected === "all") {
        someSelected = true;
      } else if (subRowChildrenSelected === "some") {
        someSelected = true;
        allChildrenSelected = false;
      } else {
        allChildrenSelected = false;
      }
    }
  });
  return allChildrenSelected ? "all" : someSelected ? "some" : false;
}
const reSplitAlphaNumeric = /([0-9]+)/gm;
const alphanumeric = (rowA, rowB, columnId) => {
  return compareAlphanumeric(toString(rowA.getValue(columnId)).toLowerCase(), toString(rowB.getValue(columnId)).toLowerCase());
};
const alphanumericCaseSensitive = (rowA, rowB, columnId) => {
  return compareAlphanumeric(toString(rowA.getValue(columnId)), toString(rowB.getValue(columnId)));
};
const text = (rowA, rowB, columnId) => {
  return compareBasic(toString(rowA.getValue(columnId)).toLowerCase(), toString(rowB.getValue(columnId)).toLowerCase());
};
const textCaseSensitive = (rowA, rowB, columnId) => {
  return compareBasic(toString(rowA.getValue(columnId)), toString(rowB.getValue(columnId)));
};
const datetime = (rowA, rowB, columnId) => {
  const a = rowA.getValue(columnId);
  const b = rowB.getValue(columnId);
  return a > b ? 1 : a < b ? -1 : 0;
};
const basic = (rowA, rowB, columnId) => {
  return compareBasic(rowA.getValue(columnId), rowB.getValue(columnId));
};
function compareBasic(a, b) {
  return a === b ? 0 : a > b ? 1 : -1;
}
function toString(a) {
  if (typeof a === "number") {
    if (isNaN(a) || a === Infinity || a === -Infinity) {
      return "";
    }
    return String(a);
  }
  if (typeof a === "string") {
    return a;
  }
  return "";
}
function compareAlphanumeric(aStr, bStr) {
  const a = aStr.split(reSplitAlphaNumeric).filter(Boolean);
  const b = bStr.split(reSplitAlphaNumeric).filter(Boolean);
  while (a.length && b.length) {
    const aa = a.shift();
    const bb = b.shift();
    const an = parseInt(aa, 10);
    const bn = parseInt(bb, 10);
    const combo = [an, bn].sort();
    if (isNaN(combo[0])) {
      if (aa > bb) {
        return 1;
      }
      if (bb > aa) {
        return -1;
      }
      continue;
    }
    if (isNaN(combo[1])) {
      return isNaN(an) ? -1 : 1;
    }
    if (an > bn) {
      return 1;
    }
    if (bn > an) {
      return -1;
    }
  }
  return a.length - b.length;
}
const sortingFns = {
  alphanumeric,
  alphanumericCaseSensitive,
  text,
  textCaseSensitive,
  datetime,
  basic
};
const RowSorting = {
  getInitialState: (state) => {
    return {
      sorting: [],
      ...state
    };
  },
  getDefaultColumnDef: () => {
    return {
      sortingFn: "auto",
      sortUndefined: 1
    };
  },
  getDefaultOptions: (table) => {
    return {
      onSortingChange: makeStateUpdater("sorting", table),
      isMultiSortEvent: (e) => {
        return e.shiftKey;
      }
    };
  },
  createColumn: (column, table) => {
    column.getAutoSortingFn = () => {
      const firstRows = table.getFilteredRowModel().flatRows.slice(10);
      let isString = false;
      for (const row of firstRows) {
        const value = row == null ? void 0 : row.getValue(column.id);
        if (Object.prototype.toString.call(value) === "[object Date]") {
          return sortingFns.datetime;
        }
        if (typeof value === "string") {
          isString = true;
          if (value.split(reSplitAlphaNumeric).length > 1) {
            return sortingFns.alphanumeric;
          }
        }
      }
      if (isString) {
        return sortingFns.text;
      }
      return sortingFns.basic;
    };
    column.getAutoSortDir = () => {
      const firstRow = table.getFilteredRowModel().flatRows[0];
      const value = firstRow == null ? void 0 : firstRow.getValue(column.id);
      if (typeof value === "string") {
        return "asc";
      }
      return "desc";
    };
    column.getSortingFn = () => {
      var _table$options$sortin, _table$options$sortin2;
      if (!column) {
        throw new Error();
      }
      return isFunction(column.columnDef.sortingFn) ? column.columnDef.sortingFn : column.columnDef.sortingFn === "auto" ? column.getAutoSortingFn() : (_table$options$sortin = (_table$options$sortin2 = table.options.sortingFns) == null ? void 0 : _table$options$sortin2[column.columnDef.sortingFn]) != null ? _table$options$sortin : sortingFns[column.columnDef.sortingFn];
    };
    column.toggleSorting = (desc, multi) => {
      const nextSortingOrder = column.getNextSortingOrder();
      const hasManualValue = typeof desc !== "undefined" && desc !== null;
      table.setSorting((old) => {
        const existingSorting = old == null ? void 0 : old.find((d) => d.id === column.id);
        const existingIndex = old == null ? void 0 : old.findIndex((d) => d.id === column.id);
        let newSorting = [];
        let sortAction;
        let nextDesc = hasManualValue ? desc : nextSortingOrder === "desc";
        if (old != null && old.length && column.getCanMultiSort() && multi) {
          if (existingSorting) {
            sortAction = "toggle";
          } else {
            sortAction = "add";
          }
        } else {
          if (old != null && old.length && existingIndex !== old.length - 1) {
            sortAction = "replace";
          } else if (existingSorting) {
            sortAction = "toggle";
          } else {
            sortAction = "replace";
          }
        }
        if (sortAction === "toggle") {
          if (!hasManualValue) {
            if (!nextSortingOrder) {
              sortAction = "remove";
            }
          }
        }
        if (sortAction === "add") {
          var _table$options$maxMul;
          newSorting = [...old, {
            id: column.id,
            desc: nextDesc
          }];
          newSorting.splice(0, newSorting.length - ((_table$options$maxMul = table.options.maxMultiSortColCount) != null ? _table$options$maxMul : Number.MAX_SAFE_INTEGER));
        } else if (sortAction === "toggle") {
          newSorting = old.map((d) => {
            if (d.id === column.id) {
              return {
                ...d,
                desc: nextDesc
              };
            }
            return d;
          });
        } else if (sortAction === "remove") {
          newSorting = old.filter((d) => d.id !== column.id);
        } else {
          newSorting = [{
            id: column.id,
            desc: nextDesc
          }];
        }
        return newSorting;
      });
    };
    column.getFirstSortDir = () => {
      var _ref, _column$columnDef$sor;
      const sortDescFirst = (_ref = (_column$columnDef$sor = column.columnDef.sortDescFirst) != null ? _column$columnDef$sor : table.options.sortDescFirst) != null ? _ref : column.getAutoSortDir() === "desc";
      return sortDescFirst ? "desc" : "asc";
    };
    column.getNextSortingOrder = (multi) => {
      var _table$options$enable, _table$options$enable2;
      const firstSortDirection = column.getFirstSortDir();
      const isSorted = column.getIsSorted();
      if (!isSorted) {
        return firstSortDirection;
      }
      if (isSorted !== firstSortDirection && ((_table$options$enable = table.options.enableSortingRemoval) != null ? _table$options$enable : true) && // If enableSortRemove, enable in general
      (multi ? (_table$options$enable2 = table.options.enableMultiRemove) != null ? _table$options$enable2 : true : true)) {
        return false;
      }
      return isSorted === "desc" ? "asc" : "desc";
    };
    column.getCanSort = () => {
      var _column$columnDef$ena, _table$options$enable3;
      return ((_column$columnDef$ena = column.columnDef.enableSorting) != null ? _column$columnDef$ena : true) && ((_table$options$enable3 = table.options.enableSorting) != null ? _table$options$enable3 : true) && !!column.accessorFn;
    };
    column.getCanMultiSort = () => {
      var _ref2, _column$columnDef$ena2;
      return (_ref2 = (_column$columnDef$ena2 = column.columnDef.enableMultiSort) != null ? _column$columnDef$ena2 : table.options.enableMultiSort) != null ? _ref2 : !!column.accessorFn;
    };
    column.getIsSorted = () => {
      var _table$getState$sorti;
      const columnSort = (_table$getState$sorti = table.getState().sorting) == null ? void 0 : _table$getState$sorti.find((d) => d.id === column.id);
      return !columnSort ? false : columnSort.desc ? "desc" : "asc";
    };
    column.getSortIndex = () => {
      var _table$getState$sorti2, _table$getState$sorti3;
      return (_table$getState$sorti2 = (_table$getState$sorti3 = table.getState().sorting) == null ? void 0 : _table$getState$sorti3.findIndex((d) => d.id === column.id)) != null ? _table$getState$sorti2 : -1;
    };
    column.clearSorting = () => {
      table.setSorting((old) => old != null && old.length ? old.filter((d) => d.id !== column.id) : []);
    };
    column.getToggleSortingHandler = () => {
      const canSort = column.getCanSort();
      return (e) => {
        if (!canSort) return;
        e.persist == null || e.persist();
        column.toggleSorting == null || column.toggleSorting(void 0, column.getCanMultiSort() ? table.options.isMultiSortEvent == null ? void 0 : table.options.isMultiSortEvent(e) : false);
      };
    };
  },
  createTable: (table) => {
    table.setSorting = (updater) => table.options.onSortingChange == null ? void 0 : table.options.onSortingChange(updater);
    table.resetSorting = (defaultState) => {
      var _table$initialState$s, _table$initialState;
      table.setSorting(defaultState ? [] : (_table$initialState$s = (_table$initialState = table.initialState) == null ? void 0 : _table$initialState.sorting) != null ? _table$initialState$s : []);
    };
    table.getPreSortedRowModel = () => table.getGroupedRowModel();
    table.getSortedRowModel = () => {
      if (!table._getSortedRowModel && table.options.getSortedRowModel) {
        table._getSortedRowModel = table.options.getSortedRowModel(table);
      }
      if (table.options.manualSorting || !table._getSortedRowModel) {
        return table.getPreSortedRowModel();
      }
      return table._getSortedRowModel();
    };
  }
};
const builtInFeatures = [
  Headers,
  ColumnVisibility,
  ColumnOrdering,
  ColumnPinning,
  ColumnFaceting,
  ColumnFiltering,
  GlobalFaceting,
  //depends on ColumnFaceting
  GlobalFiltering,
  //depends on ColumnFiltering
  RowSorting,
  ColumnGrouping,
  //depends on RowSorting
  RowExpanding,
  RowPagination,
  RowPinning,
  RowSelection,
  ColumnSizing
];
function createTable(options2) {
  var _options$_features, _options$initialState;
  if (process.env.NODE_ENV !== "production" && (options2.debugAll || options2.debugTable)) {
    console.info("Creating Table Instance...");
  }
  const _features = [...builtInFeatures, ...(_options$_features = options2._features) != null ? _options$_features : []];
  let table = {
    _features
  };
  const defaultOptions = table._features.reduce((obj, feature) => {
    return Object.assign(obj, feature.getDefaultOptions == null ? void 0 : feature.getDefaultOptions(table));
  }, {});
  const mergeOptions = (options3) => {
    if (table.options.mergeOptions) {
      return table.options.mergeOptions(defaultOptions, options3);
    }
    return {
      ...defaultOptions,
      ...options3
    };
  };
  const coreInitialState = {};
  let initialState2 = {
    ...coreInitialState,
    ...(_options$initialState = options2.initialState) != null ? _options$initialState : {}
  };
  table._features.forEach((feature) => {
    var _feature$getInitialSt;
    initialState2 = (_feature$getInitialSt = feature.getInitialState == null ? void 0 : feature.getInitialState(initialState2)) != null ? _feature$getInitialSt : initialState2;
  });
  const queued = [];
  let queuedTimeout = false;
  const coreInstance = {
    _features,
    options: {
      ...defaultOptions,
      ...options2
    },
    initialState: initialState2,
    _queue: (cb) => {
      queued.push(cb);
      if (!queuedTimeout) {
        queuedTimeout = true;
        Promise.resolve().then(() => {
          while (queued.length) {
            queued.shift()();
          }
          queuedTimeout = false;
        }).catch((error) => setTimeout(() => {
          throw error;
        }));
      }
    },
    reset: () => {
      table.setState(table.initialState);
    },
    setOptions: (updater) => {
      const newOptions = functionalUpdate(updater, table.options);
      table.options = mergeOptions(newOptions);
    },
    getState: () => {
      return table.options.state;
    },
    setState: (updater) => {
      table.options.onStateChange == null || table.options.onStateChange(updater);
    },
    _getRowId: (row, index2, parent) => {
      var _table$options$getRow;
      return (_table$options$getRow = table.options.getRowId == null ? void 0 : table.options.getRowId(row, index2, parent)) != null ? _table$options$getRow : `${parent ? [parent.id, index2].join(".") : index2}`;
    },
    getCoreRowModel: () => {
      if (!table._getCoreRowModel) {
        table._getCoreRowModel = table.options.getCoreRowModel(table);
      }
      return table._getCoreRowModel();
    },
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => {
      return table.getPaginationRowModel();
    },
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (id, searchAll) => {
      let row = (searchAll ? table.getPrePaginationRowModel() : table.getRowModel()).rowsById[id];
      if (!row) {
        row = table.getCoreRowModel().rowsById[id];
        if (!row) {
          if (process.env.NODE_ENV !== "production") {
            throw new Error(`getRow could not find row with ID: ${id}`);
          }
          throw new Error();
        }
      }
      return row;
    },
    _getDefaultColumnDef: memo$1(() => [table.options.defaultColumn], (defaultColumn) => {
      var _defaultColumn;
      defaultColumn = (_defaultColumn = defaultColumn) != null ? _defaultColumn : {};
      return {
        header: (props) => {
          const resolvedColumnDef = props.header.column.columnDef;
          if (resolvedColumnDef.accessorKey) {
            return resolvedColumnDef.accessorKey;
          }
          if (resolvedColumnDef.accessorFn) {
            return resolvedColumnDef.id;
          }
          return null;
        },
        // footer: props => props.header.column.id,
        cell: (props) => {
          var _props$renderValue$to, _props$renderValue;
          return (_props$renderValue$to = (_props$renderValue = props.renderValue()) == null || _props$renderValue.toString == null ? void 0 : _props$renderValue.toString()) != null ? _props$renderValue$to : null;
        },
        ...table._features.reduce((obj, feature) => {
          return Object.assign(obj, feature.getDefaultColumnDef == null ? void 0 : feature.getDefaultColumnDef());
        }, {}),
        ...defaultColumn
      };
    }, getMemoOptions(options2, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => table.options.columns,
    getAllColumns: memo$1(() => [table._getColumnDefs()], (columnDefs) => {
      const recurseColumns = function(columnDefs2, parent, depth) {
        if (depth === void 0) {
          depth = 0;
        }
        return columnDefs2.map((columnDef) => {
          const column = createColumn(table, columnDef, depth, parent);
          const groupingColumnDef = columnDef;
          column.columns = groupingColumnDef.columns ? recurseColumns(groupingColumnDef.columns, column, depth + 1) : [];
          return column;
        });
      };
      return recurseColumns(columnDefs);
    }, getMemoOptions(options2, "debugColumns", "getAllColumns")),
    getAllFlatColumns: memo$1(() => [table.getAllColumns()], (allColumns) => {
      return allColumns.flatMap((column) => {
        return column.getFlatColumns();
      });
    }, getMemoOptions(options2, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: memo$1(() => [table.getAllFlatColumns()], (flatColumns) => {
      return flatColumns.reduce((acc, column) => {
        acc[column.id] = column;
        return acc;
      }, {});
    }, getMemoOptions(options2, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: memo$1(() => [table.getAllColumns(), table._getOrderColumnsFn()], (allColumns, orderColumns2) => {
      let leafColumns = allColumns.flatMap((column) => column.getLeafColumns());
      return orderColumns2(leafColumns);
    }, getMemoOptions(options2, "debugColumns", "getAllLeafColumns")),
    getColumn: (columnId) => {
      const column = table._getAllFlatColumnsById()[columnId];
      if (process.env.NODE_ENV !== "production" && !column) {
        console.error(`[Table] Column with id '${columnId}' does not exist.`);
      }
      return column;
    }
  };
  Object.assign(table, coreInstance);
  for (let index2 = 0; index2 < table._features.length; index2++) {
    const feature = table._features[index2];
    feature == null || feature.createTable == null || feature.createTable(table);
  }
  return table;
}
function getCoreRowModel() {
  return (table) => memo$1(() => [table.options.data], (data) => {
    const rowModel = {
      rows: [],
      flatRows: [],
      rowsById: {}
    };
    const accessRows = function(originalRows, depth, parentRow) {
      if (depth === void 0) {
        depth = 0;
      }
      const rows = [];
      for (let i = 0; i < originalRows.length; i++) {
        const row = createRow(table, table._getRowId(originalRows[i], i, parentRow), originalRows[i], i, depth, void 0, parentRow == null ? void 0 : parentRow.id);
        rowModel.flatRows.push(row);
        rowModel.rowsById[row.id] = row;
        rows.push(row);
        if (table.options.getSubRows) {
          var _row$originalSubRows;
          row.originalSubRows = table.options.getSubRows(originalRows[i], i);
          if ((_row$originalSubRows = row.originalSubRows) != null && _row$originalSubRows.length) {
            row.subRows = accessRows(row.originalSubRows, depth + 1, row);
          }
        }
      }
      return rows;
    };
    rowModel.rows = accessRows(data);
    return rowModel;
  }, getMemoOptions(table.options, "debugTable", "getRowModel", () => table._autoResetPageIndex()));
}
function getExpandedRowModel() {
  return (table) => memo$1(() => [table.getState().expanded, table.getPreExpandedRowModel(), table.options.paginateExpandedRows], (expanded, rowModel, paginateExpandedRows) => {
    if (!rowModel.rows.length || expanded !== true && !Object.keys(expanded != null ? expanded : {}).length) {
      return rowModel;
    }
    if (!paginateExpandedRows) {
      return rowModel;
    }
    return expandRows(rowModel);
  }, getMemoOptions(table.options, "debugTable", "getExpandedRowModel"));
}
function expandRows(rowModel) {
  const expandedRows = [];
  const handleRow = (row) => {
    var _row$subRows;
    expandedRows.push(row);
    if ((_row$subRows = row.subRows) != null && _row$subRows.length && row.getIsExpanded()) {
      row.subRows.forEach(handleRow);
    }
  };
  rowModel.rows.forEach(handleRow);
  return {
    rows: expandedRows,
    flatRows: rowModel.flatRows,
    rowsById: rowModel.rowsById
  };
}
function getGroupedRowModel() {
  return (table) => memo$1(() => [table.getState().grouping, table.getPreGroupedRowModel()], (grouping, rowModel) => {
    if (!rowModel.rows.length || !grouping.length) {
      return rowModel;
    }
    const existingGrouping = grouping.filter((columnId) => table.getColumn(columnId));
    const groupedFlatRows = [];
    const groupedRowsById = {};
    const groupUpRecursively = function(rows, depth, parentId) {
      if (depth === void 0) {
        depth = 0;
      }
      if (depth >= existingGrouping.length) {
        return rows.map((row) => {
          row.depth = depth;
          groupedFlatRows.push(row);
          groupedRowsById[row.id] = row;
          if (row.subRows) {
            row.subRows = groupUpRecursively(row.subRows, depth + 1, row.id);
          }
          return row;
        });
      }
      const columnId = existingGrouping[depth];
      const rowGroupsMap = groupBy(rows, columnId);
      const aggregatedGroupedRows = Array.from(rowGroupsMap.entries()).map((_ref, index2) => {
        let [groupingValue, groupedRows2] = _ref;
        let id = `${columnId}:${groupingValue}`;
        id = parentId ? `${parentId}>${id}` : id;
        const subRows = groupUpRecursively(groupedRows2, depth + 1, id);
        const leafRows = depth ? flattenBy(groupedRows2, (row2) => row2.subRows) : groupedRows2;
        const row = createRow(table, id, leafRows[0].original, index2, depth, void 0, parentId);
        Object.assign(row, {
          groupingColumnId: columnId,
          groupingValue,
          subRows,
          leafRows,
          getValue: (columnId2) => {
            if (existingGrouping.includes(columnId2)) {
              if (row._valuesCache.hasOwnProperty(columnId2)) {
                return row._valuesCache[columnId2];
              }
              if (groupedRows2[0]) {
                var _groupedRows$0$getVal;
                row._valuesCache[columnId2] = (_groupedRows$0$getVal = groupedRows2[0].getValue(columnId2)) != null ? _groupedRows$0$getVal : void 0;
              }
              return row._valuesCache[columnId2];
            }
            if (row._groupingValuesCache.hasOwnProperty(columnId2)) {
              return row._groupingValuesCache[columnId2];
            }
            const column = table.getColumn(columnId2);
            const aggregateFn = column == null ? void 0 : column.getAggregationFn();
            if (aggregateFn) {
              row._groupingValuesCache[columnId2] = aggregateFn(columnId2, leafRows, groupedRows2);
              return row._groupingValuesCache[columnId2];
            }
          }
        });
        subRows.forEach((subRow) => {
          groupedFlatRows.push(subRow);
          groupedRowsById[subRow.id] = subRow;
        });
        return row;
      });
      return aggregatedGroupedRows;
    };
    const groupedRows = groupUpRecursively(rowModel.rows, 0);
    groupedRows.forEach((subRow) => {
      groupedFlatRows.push(subRow);
      groupedRowsById[subRow.id] = subRow;
    });
    return {
      rows: groupedRows,
      flatRows: groupedFlatRows,
      rowsById: groupedRowsById
    };
  }, getMemoOptions(table.options, "debugTable", "getGroupedRowModel", () => {
    table._queue(() => {
      table._autoResetExpanded();
      table._autoResetPageIndex();
    });
  }));
}
function groupBy(rows, columnId) {
  const groupMap = /* @__PURE__ */ new Map();
  return rows.reduce((map, row) => {
    const resKey = `${row.getGroupingValue(columnId)}`;
    const previous = map.get(resKey);
    if (!previous) {
      map.set(resKey, [row]);
    } else {
      previous.push(row);
    }
    return map;
  }, groupMap);
}
function getPaginationRowModel(opts) {
  return (table) => memo$1(() => [table.getState().pagination, table.getPrePaginationRowModel(), table.options.paginateExpandedRows ? void 0 : table.getState().expanded], (pagination, rowModel) => {
    if (!rowModel.rows.length) {
      return rowModel;
    }
    const {
      pageSize,
      pageIndex
    } = pagination;
    let {
      rows,
      flatRows,
      rowsById
    } = rowModel;
    const pageStart = pageSize * pageIndex;
    const pageEnd = pageStart + pageSize;
    rows = rows.slice(pageStart, pageEnd);
    let paginatedRowModel;
    if (!table.options.paginateExpandedRows) {
      paginatedRowModel = expandRows({
        rows,
        flatRows,
        rowsById
      });
    } else {
      paginatedRowModel = {
        rows,
        flatRows,
        rowsById
      };
    }
    paginatedRowModel.flatRows = [];
    const handleRow = (row) => {
      paginatedRowModel.flatRows.push(row);
      if (row.subRows.length) {
        row.subRows.forEach(handleRow);
      }
    };
    paginatedRowModel.rows.forEach(handleRow);
    return paginatedRowModel;
  }, getMemoOptions(table.options, "debugTable", "getPaginationRowModel"));
}
function getSortedRowModel() {
  return (table) => memo$1(() => [table.getState().sorting, table.getPreSortedRowModel()], (sorting, rowModel) => {
    if (!rowModel.rows.length || !(sorting != null && sorting.length)) {
      return rowModel;
    }
    const sortingState = table.getState().sorting;
    const sortedFlatRows = [];
    const availableSorting = sortingState.filter((sort) => {
      var _table$getColumn;
      return (_table$getColumn = table.getColumn(sort.id)) == null ? void 0 : _table$getColumn.getCanSort();
    });
    const columnInfoById = {};
    availableSorting.forEach((sortEntry) => {
      const column = table.getColumn(sortEntry.id);
      if (!column) return;
      columnInfoById[sortEntry.id] = {
        sortUndefined: column.columnDef.sortUndefined,
        invertSorting: column.columnDef.invertSorting,
        sortingFn: column.getSortingFn()
      };
    });
    const sortData = (rows) => {
      const sortedData = rows.map((row) => ({
        ...row
      }));
      sortedData.sort((rowA, rowB) => {
        for (let i = 0; i < availableSorting.length; i += 1) {
          var _sortEntry$desc;
          const sortEntry = availableSorting[i];
          const columnInfo = columnInfoById[sortEntry.id];
          const sortUndefined = columnInfo.sortUndefined;
          const isDesc = (_sortEntry$desc = sortEntry == null ? void 0 : sortEntry.desc) != null ? _sortEntry$desc : false;
          let sortInt = 0;
          if (sortUndefined) {
            const aValue = rowA.getValue(sortEntry.id);
            const bValue = rowB.getValue(sortEntry.id);
            const aUndefined = aValue === void 0;
            const bUndefined = bValue === void 0;
            if (aUndefined || bUndefined) {
              if (sortUndefined === "first") return aUndefined ? -1 : 1;
              if (sortUndefined === "last") return aUndefined ? 1 : -1;
              sortInt = aUndefined && bUndefined ? 0 : aUndefined ? sortUndefined : -sortUndefined;
            }
          }
          if (sortInt === 0) {
            sortInt = columnInfo.sortingFn(rowA, rowB, sortEntry.id);
          }
          if (sortInt !== 0) {
            if (isDesc) {
              sortInt *= -1;
            }
            if (columnInfo.invertSorting) {
              sortInt *= -1;
            }
            return sortInt;
          }
        }
        return rowA.index - rowB.index;
      });
      sortedData.forEach((row) => {
        var _row$subRows;
        sortedFlatRows.push(row);
        if ((_row$subRows = row.subRows) != null && _row$subRows.length) {
          row.subRows = sortData(row.subRows);
        }
      });
      return sortedData;
    };
    return {
      rows: sortData(rowModel.rows),
      flatRows: sortedFlatRows,
      rowsById: rowModel.rowsById
    };
  }, getMemoOptions(table.options, "debugTable", "getSortedRowModel", () => table._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function flexRender(Comp, props) {
  return !Comp ? null : isReactComponent(Comp) ? /* @__PURE__ */ jsx(Comp, {
    ...props
  }) : Comp;
}
function isReactComponent(component) {
  return isClassComponent(component) || typeof component === "function" || isExoticComponent(component);
}
function isClassComponent(component) {
  return typeof component === "function" && (() => {
    const proto = Object.getPrototypeOf(component);
    return proto.prototype && proto.prototype.isReactComponent;
  })();
}
function isExoticComponent(component) {
  return typeof component === "object" && typeof component.$$typeof === "symbol" && ["react.memo", "react.forward_ref"].includes(component.$$typeof.description);
}
function useReactTable(options2) {
  const resolvedOptions = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...options2
  };
  const [tableRef] = React.useState(() => ({
    current: createTable(resolvedOptions)
  }));
  const [state, setState] = React.useState(() => tableRef.current.initialState);
  tableRef.current.setOptions((prev) => ({
    ...prev,
    ...options2,
    state: {
      ...state,
      ...options2.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (updater) => {
      setState(updater);
      options2.onStateChange == null || options2.onStateChange(updater);
    }
  }));
  return tableRef.current;
}
const ErrorBoundaryContext = createContext(null);
const initialState$2 = {
  didCatch: false,
  error: null
};
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
    this.state = initialState$2;
  }
  static getDerivedStateFromError(error) {
    return {
      didCatch: true,
      error
    };
  }
  resetErrorBoundary() {
    const {
      error
    } = this.state;
    if (error !== null) {
      var _this$props$onReset, _this$props;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 ? void 0 : _this$props$onReset.call(_this$props, {
        args,
        reason: "imperative-api"
      });
      this.setState(initialState$2);
    }
  }
  componentDidCatch(error, info) {
    var _this$props$onError, _this$props2;
    (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 ? void 0 : _this$props$onError.call(_this$props2, error, info);
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      didCatch
    } = this.state;
    const {
      resetKeys
    } = this.props;
    if (didCatch && prevState.error !== null && hasArrayChanged(prevProps.resetKeys, resetKeys)) {
      var _this$props$onReset2, _this$props3;
      (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 ? void 0 : _this$props$onReset2.call(_this$props3, {
        next: resetKeys,
        prev: prevProps.resetKeys,
        reason: "keys"
      });
      this.setState(initialState$2);
    }
  }
  render() {
    const {
      children,
      fallbackRender,
      FallbackComponent,
      fallback
    } = this.props;
    const {
      didCatch,
      error
    } = this.state;
    let childToRender = children;
    if (didCatch) {
      const props = {
        error,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (typeof fallbackRender === "function") {
        childToRender = fallbackRender(props);
      } else if (FallbackComponent) {
        childToRender = createElement(FallbackComponent, props);
      } else if (fallback === null || isValidElement(fallback)) {
        childToRender = fallback;
      } else {
        throw error;
      }
    }
    return createElement(ErrorBoundaryContext.Provider, {
      value: {
        didCatch,
        error,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, childToRender);
  }
}
function hasArrayChanged() {
  let a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  let b = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return a.length !== b.length || a.some((item, index2) => !Object.is(item, b[index2]));
}
const getStickyStyles = (column) => {
  const isPinned = column.getIsPinned();
  const isLastLeftPinnedColumn = isPinned === "left" && column.getIsLastColumn("left");
  const isFirstRightPinnedColumn = isPinned === "right" && column.getIsFirstColumn("right");
  return {
    borderLeft: isFirstRightPinnedColumn ? "1px solid rgb(224 224 224 / var(--tw-border-opacity))" : void 0,
    borderRight: isLastLeftPinnedColumn ? "1px solid rgb(224 224 224 / var(--tw-border-opacity))" : void 0,
    left: isPinned === "left" ? `${column.getStart("left")}px` : void 0,
    right: isPinned === "right" ? `${column.getAfter("right")}px` : void 0,
    position: isPinned ? "sticky" : "relative",
    width: column.getSize(),
    minWidth: column.getSize(),
    zIndex: isPinned ? 10 : 0,
    background: "inherit"
  };
};
const CellContents = (props) => {
  var _a, _b;
  const {
    cell,
    classNames: classNames2
  } = props;
  let styles2 = {};
  if (cell.column.getIsPinned()) {
    styles2 = getStickyStyles(cell.column);
  }
  let classes2 = classNames2 ?? "";
  if ((_a = cell.column.columnDef.meta) == null ? void 0 : _a.classes) {
    classes2 += " " + ((_b = cell.column.columnDef.meta) == null ? void 0 : _b.classes) + " ";
  }
  return /* @__PURE__ */ jsx("td", {
    style: styles2,
    className: `${classes2 ?? ""} body-td`,
    children: flexRender(cell.column.columnDef.cell, cell.getContext())
  });
};
const ACTION_CELLS = /* @__PURE__ */ new Set(["select", "expand"]);
const GroupRow = (props) => {
  var _a, _b;
  const {
    row,
    table
  } = props;
  const visibleCells = (row == null ? void 0 : row.getVisibleCells()) || [];
  let actionCells = [];
  for (const cell of visibleCells) {
    if (!ACTION_CELLS.has(cell.column.id)) continue;
    actionCells = [...actionCells, /* @__PURE__ */ jsx(CellContents, {
      cell,
      classNames: "group-td"
    }, cell.id)];
  }
  return /* @__PURE__ */ jsxs("tr", {
    className: "bg-gray-50 ",
    children: [actionCells, /* @__PURE__ */ jsx("td", {
      style: {
        left: `${actionCells.length * 60}px`
      },
      className: `body-td-sticky group-td  w-6 overflow-visible`,
      children: /* @__PURE__ */ jsx("div", {
        className: "flex w-6 items-center overflow-visible ",
        children: flexRender((_a = table.getColumn(table.getState().grouping[0])) == null ? void 0 : _a.columnDef.aggregatedCell, (_b = row.getAllCells().find((c) => c.column.id === table.getState().grouping[0])) == null ? void 0 : _b.getContext())
      })
    }), [...visibleCells].slice(actionCells.length + 1, visibleCells.length).map((cell) => {
      return /* @__PURE__ */ jsx("td", {
        className: "group-td body-td inherit-bg sticky px-4 py-2"
      }, cell.id);
    })]
  }, row == null ? void 0 : row.id);
};
/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function memo(getDeps, fn, opts) {
  var _opts$initialDeps;
  var deps = (_opts$initialDeps = opts.initialDeps) != null ? _opts$initialDeps : [];
  var result;
  return function() {
    var depTime;
    if (opts.key && opts.debug != null && opts.debug()) depTime = Date.now();
    var newDeps = getDeps();
    var depsChanged = newDeps.length !== deps.length || newDeps.some(function(dep, index2) {
      return deps[index2] !== dep;
    });
    if (!depsChanged) {
      return result;
    }
    deps = newDeps;
    var resultTime;
    if (opts.key && opts.debug != null && opts.debug()) resultTime = Date.now();
    result = fn.apply(void 0, newDeps);
    if (opts.key && opts.debug != null && opts.debug()) {
      var depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
      var resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
      var resultFpsPercentage = resultEndTime / 16;
      var pad = function pad2(str, num) {
        str = String(str);
        while (str.length < num) {
          str = " " + str;
        }
        return str;
      };
      console.info("%c⏱ " + pad(resultEndTime, 5) + " /" + pad(depEndTime, 5) + " ms", "\n            font-size: .6rem;\n            font-weight: bold;\n            color: hsl(" + Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120)) + "deg 100% 31%);", opts == null ? void 0 : opts.key);
    }
    opts == null ? void 0 : opts.onChange == null ? void 0 : opts.onChange(result);
    return result;
  };
}
function notUndefined(value, msg) {
  if (value === void 0) {
    throw new Error("Unexpected undefined");
  } else {
    return value;
  }
}
var approxEqual = function approxEqual2(a, b) {
  return Math.abs(a - b) < 1;
};
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var defaultKeyExtractor = function defaultKeyExtractor2(index2) {
  return index2;
};
var defaultRangeExtractor = function defaultRangeExtractor2(range) {
  var start = Math.max(range.startIndex - range.overscan, 0);
  var end = Math.min(range.endIndex + range.overscan, range.count - 1);
  var arr = [];
  for (var _i = start; _i <= end; _i++) {
    arr.push(_i);
  }
  return arr;
};
var observeElementRect = function observeElementRect2(instance, cb) {
  var element = instance.scrollElement;
  if (!element) {
    return;
  }
  var handler = function handler2(rect) {
    var width = rect.width, height = rect.height;
    cb({
      width: Math.round(width),
      height: Math.round(height)
    });
  };
  handler(element.getBoundingClientRect());
  var observer = new ResizeObserver(function(entries) {
    var entry = entries[0];
    if (entry != null && entry.borderBoxSize) {
      var box = entry.borderBoxSize[0];
      if (box) {
        handler({
          width: box.inlineSize,
          height: box.blockSize
        });
        return;
      }
    }
    handler(element.getBoundingClientRect());
  });
  observer.observe(element, {
    box: "border-box"
  });
  return function() {
    observer.unobserve(element);
  };
};
var observeElementOffset = function observeElementOffset2(instance, cb) {
  var element = instance.scrollElement;
  if (!element) {
    return;
  }
  var handler = function handler2() {
    cb(element[instance.options.horizontal ? "scrollLeft" : "scrollTop"]);
  };
  handler();
  element.addEventListener("scroll", handler, {
    passive: true
  });
  return function() {
    element.removeEventListener("scroll", handler);
  };
};
var measureElement = function measureElement2(element, entry, instance) {
  if (entry != null && entry.borderBoxSize) {
    var box = entry.borderBoxSize[0];
    if (box) {
      var size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
      return size;
    }
  }
  return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
};
var elementScroll = function elementScroll2(offset2, _ref2, instance) {
  var _instance$scrollEleme3, _instance$scrollEleme4;
  var _ref2$adjustments = _ref2.adjustments, adjustments = _ref2$adjustments === void 0 ? 0 : _ref2$adjustments, behavior = _ref2.behavior;
  var toOffset = offset2 + adjustments;
  (_instance$scrollEleme3 = instance.scrollElement) == null ? void 0 : _instance$scrollEleme3.scrollTo == null ? void 0 : _instance$scrollEleme3.scrollTo((_instance$scrollEleme4 = {}, _instance$scrollEleme4[instance.options.horizontal ? "left" : "top"] = toOffset, _instance$scrollEleme4.behavior = behavior, _instance$scrollEleme4));
};
var Virtualizer = function Virtualizer2(_opts) {
  var _this = this;
  this.unsubs = [];
  this.scrollElement = null;
  this.isScrolling = false;
  this.isScrollingTimeoutId = null;
  this.scrollToIndexTimeoutId = null;
  this.measurementsCache = [];
  this.itemSizeCache = /* @__PURE__ */ new Map();
  this.pendingMeasuredCacheIndexes = [];
  this.scrollDirection = null;
  this.scrollAdjustments = 0;
  this.measureElementCache = /* @__PURE__ */ new Map();
  this.observer = /* @__PURE__ */ function() {
    var _ro = null;
    var get2 = function get3() {
      if (_ro) {
        return _ro;
      } else if (typeof ResizeObserver !== "undefined") {
        return _ro = new ResizeObserver(function(entries) {
          entries.forEach(function(entry) {
            _this._measureElement(entry.target, entry);
          });
        });
      } else {
        return null;
      }
    };
    return {
      disconnect: function disconnect() {
        var _get;
        return (_get = get2()) == null ? void 0 : _get.disconnect();
      },
      observe: function observe2(target) {
        var _get2;
        return (_get2 = get2()) == null ? void 0 : _get2.observe(target, {
          box: "border-box"
        });
      },
      unobserve: function unobserve(target) {
        var _get3;
        return (_get3 = get2()) == null ? void 0 : _get3.unobserve(target);
      }
    };
  }();
  this.range = {
    startIndex: 0,
    endIndex: 0
  };
  this.setOptions = function(opts) {
    Object.entries(opts).forEach(function(_ref3) {
      var key = _ref3[0], value = _ref3[1];
      if (typeof value === "undefined") delete opts[key];
    });
    _this.options = _extends({
      debug: false,
      initialOffset: 0,
      overscan: 1,
      paddingStart: 0,
      paddingEnd: 0,
      scrollPaddingStart: 0,
      scrollPaddingEnd: 0,
      horizontal: false,
      getItemKey: defaultKeyExtractor,
      rangeExtractor: defaultRangeExtractor,
      onChange: function onChange() {
      },
      measureElement,
      initialRect: {
        width: 0,
        height: 0
      },
      scrollMargin: 0,
      scrollingDelay: 150,
      indexAttribute: "data-index",
      initialMeasurementsCache: [],
      lanes: 1
    }, opts);
  };
  this.notify = function() {
    _this.options.onChange == null ? void 0 : _this.options.onChange(_this);
  };
  this.cleanup = function() {
    _this.unsubs.filter(Boolean).forEach(function(d) {
      return d();
    });
    _this.unsubs = [];
    _this.scrollElement = null;
  };
  this._didMount = function() {
    _this.measureElementCache.forEach(_this.observer.observe);
    return function() {
      _this.observer.disconnect();
      _this.cleanup();
    };
  };
  this._willUpdate = function() {
    var scrollElement = _this.options.getScrollElement();
    if (_this.scrollElement !== scrollElement) {
      _this.cleanup();
      _this.scrollElement = scrollElement;
      _this._scrollToOffset(_this.scrollOffset, {
        adjustments: void 0,
        behavior: void 0
      });
      _this.unsubs.push(_this.options.observeElementRect(_this, function(rect) {
        var prev = _this.scrollRect;
        _this.scrollRect = rect;
        if (_this.options.horizontal ? rect.width !== prev.width : rect.height !== prev.height) {
          _this.maybeNotify();
        }
      }));
      _this.unsubs.push(_this.options.observeElementOffset(_this, function(offset2) {
        _this.scrollAdjustments = 0;
        if (_this.scrollOffset === offset2) {
          return;
        }
        if (_this.isScrollingTimeoutId !== null) {
          clearTimeout(_this.isScrollingTimeoutId);
          _this.isScrollingTimeoutId = null;
        }
        _this.isScrolling = true;
        _this.scrollDirection = _this.scrollOffset < offset2 ? "forward" : "backward";
        _this.scrollOffset = offset2;
        _this.maybeNotify();
        _this.isScrollingTimeoutId = setTimeout(function() {
          _this.isScrollingTimeoutId = null;
          _this.isScrolling = false;
          _this.scrollDirection = null;
          _this.maybeNotify();
        }, _this.options.scrollingDelay);
      }));
    }
  };
  this.getSize = function() {
    return _this.scrollRect[_this.options.horizontal ? "width" : "height"];
  };
  this.memoOptions = memo(function() {
    return [_this.options.count, _this.options.paddingStart, _this.options.scrollMargin, _this.options.getItemKey];
  }, function(count2, paddingStart, scrollMargin, getItemKey) {
    _this.pendingMeasuredCacheIndexes = [];
    return {
      count: count2,
      paddingStart,
      scrollMargin,
      getItemKey
    };
  }, {
    key: false
  });
  this.getFurthestMeasurement = function(measurements, index2) {
    var furthestMeasurementsFound = /* @__PURE__ */ new Map();
    var furthestMeasurements = /* @__PURE__ */ new Map();
    for (var m = index2 - 1; m >= 0; m--) {
      var measurement = measurements[m];
      if (furthestMeasurementsFound.has(measurement.lane)) {
        continue;
      }
      var previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
      if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) {
        furthestMeasurements.set(measurement.lane, measurement);
      } else if (measurement.end < previousFurthestMeasurement.end) {
        furthestMeasurementsFound.set(measurement.lane, true);
      }
      if (furthestMeasurementsFound.size === _this.options.lanes) {
        break;
      }
    }
    return furthestMeasurements.size === _this.options.lanes ? Array.from(furthestMeasurements.values()).sort(function(a, b) {
      return a.end - b.end;
    })[0] : void 0;
  };
  this.getMeasurements = memo(function() {
    return [_this.memoOptions(), _this.itemSizeCache];
  }, function(_ref4, itemSizeCache) {
    var count2 = _ref4.count, paddingStart = _ref4.paddingStart, scrollMargin = _ref4.scrollMargin, getItemKey = _ref4.getItemKey;
    var min2 = _this.pendingMeasuredCacheIndexes.length > 0 ? Math.min.apply(Math, _this.pendingMeasuredCacheIndexes) : 0;
    _this.pendingMeasuredCacheIndexes = [];
    var measurements = _this.measurementsCache.slice(0, min2);
    for (var _i2 = min2; _i2 < count2; _i2++) {
      var key = getItemKey(_i2);
      var furthestMeasurement = _this.options.lanes === 1 ? measurements[_i2 - 1] : _this.getFurthestMeasurement(measurements, _i2);
      var start = furthestMeasurement ? furthestMeasurement.end : paddingStart + scrollMargin;
      var measuredSize = itemSizeCache.get(key);
      var size = typeof measuredSize === "number" ? measuredSize : _this.options.estimateSize(_i2);
      var end = start + size;
      var lane = furthestMeasurement ? furthestMeasurement.lane : _i2 % _this.options.lanes;
      measurements[_i2] = {
        index: _i2,
        start,
        size,
        end,
        key,
        lane
      };
    }
    _this.measurementsCache = measurements;
    return measurements;
  }, {
    key: process.env.NODE_ENV !== "production" && "getMeasurements",
    debug: function debug2() {
      return _this.options.debug;
    }
  });
  this.calculateRange = memo(function() {
    return [_this.getMeasurements(), _this.getSize(), _this.scrollOffset];
  }, function(measurements, outerSize, scrollOffset) {
    return _this.range = calculateRange({
      measurements,
      outerSize,
      scrollOffset
    });
  }, {
    key: process.env.NODE_ENV !== "production" && "calculateRange",
    debug: function debug2() {
      return _this.options.debug;
    }
  });
  this.maybeNotify = memo(function() {
    var range = _this.calculateRange();
    return [range.startIndex, range.endIndex, _this.isScrolling];
  }, function() {
    _this.notify();
  }, {
    key: process.env.NODE_ENV !== "production" && "maybeNotify",
    debug: function debug2() {
      return _this.options.debug;
    },
    initialDeps: [this.range.startIndex, this.range.endIndex, this.isScrolling]
  });
  this.getIndexes = memo(function() {
    return [_this.options.rangeExtractor, _this.calculateRange(), _this.options.overscan, _this.options.count];
  }, function(rangeExtractor, range, overscan, count2) {
    return rangeExtractor(_extends({}, range, {
      overscan,
      count: count2
    }));
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function debug2() {
      return _this.options.debug;
    }
  });
  this.indexFromElement = function(node) {
    var attributeName = _this.options.indexAttribute;
    var indexStr = node.getAttribute(attributeName);
    if (!indexStr) {
      console.warn("Missing attribute name '" + attributeName + "={index}' on measured element.");
      return -1;
    }
    return parseInt(indexStr, 10);
  };
  this._measureElement = function(node, entry) {
    var _this$itemSizeCache$g;
    var index2 = _this.indexFromElement(node);
    var item = _this.measurementsCache[index2];
    if (!item) {
      return;
    }
    var prevNode = _this.measureElementCache.get(item.key);
    if (!node.isConnected) {
      _this.observer.unobserve(node);
      if (node === prevNode) {
        _this.measureElementCache["delete"](item.key);
      }
      return;
    }
    if (prevNode !== node) {
      if (prevNode) {
        _this.observer.unobserve(prevNode);
      }
      _this.observer.observe(node);
      _this.measureElementCache.set(item.key, node);
    }
    var measuredItemSize = _this.options.measureElement(node, entry, _this);
    var itemSize = (_this$itemSizeCache$g = _this.itemSizeCache.get(item.key)) != null ? _this$itemSizeCache$g : item.size;
    var delta = measuredItemSize - itemSize;
    if (delta !== 0) {
      if (item.start < _this.scrollOffset) {
        if (process.env.NODE_ENV !== "production" && _this.options.debug) {
          console.info("correction", delta);
        }
        _this._scrollToOffset(_this.scrollOffset, {
          adjustments: _this.scrollAdjustments += delta,
          behavior: void 0
        });
      }
      _this.pendingMeasuredCacheIndexes.push(index2);
      _this.itemSizeCache = new Map(_this.itemSizeCache.set(item.key, measuredItemSize));
      _this.notify();
    }
  };
  this.measureElement = function(node) {
    if (!node) {
      return;
    }
    _this._measureElement(node, void 0);
  };
  this.getVirtualItems = memo(function() {
    return [_this.getIndexes(), _this.getMeasurements()];
  }, function(indexes, measurements) {
    var virtualItems = [];
    for (var k = 0, len = indexes.length; k < len; k++) {
      var _i3 = indexes[k];
      var measurement = measurements[_i3];
      virtualItems.push(measurement);
    }
    return virtualItems;
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function debug2() {
      return _this.options.debug;
    }
  });
  this.getVirtualItemForOffset = function(offset2) {
    var measurements = _this.getMeasurements();
    return notUndefined(measurements[findNearestBinarySearch(0, measurements.length - 1, function(index2) {
      return notUndefined(measurements[index2]).start;
    }, offset2)]);
  };
  this.getOffsetForAlignment = function(toOffset, align) {
    var size = _this.getSize();
    if (align === "auto") {
      if (toOffset <= _this.scrollOffset) {
        align = "start";
      } else if (toOffset >= _this.scrollOffset + size) {
        align = "end";
      } else {
        align = "start";
      }
    }
    if (align === "start") {
      toOffset = toOffset;
    } else if (align === "end") {
      toOffset = toOffset - size;
    } else if (align === "center") {
      toOffset = toOffset - size / 2;
    }
    var scrollSizeProp = _this.options.horizontal ? "scrollWidth" : "scrollHeight";
    var scrollSize = _this.scrollElement ? "document" in _this.scrollElement ? _this.scrollElement.document.documentElement[scrollSizeProp] : _this.scrollElement[scrollSizeProp] : 0;
    var maxOffset = scrollSize - _this.getSize();
    return Math.max(Math.min(maxOffset, toOffset), 0);
  };
  this.getOffsetForIndex = function(index2, align) {
    if (align === void 0) {
      align = "auto";
    }
    index2 = Math.max(0, Math.min(index2, _this.options.count - 1));
    var measurement = notUndefined(_this.getMeasurements()[index2]);
    if (align === "auto") {
      if (measurement.end >= _this.scrollOffset + _this.getSize() - _this.options.scrollPaddingEnd) {
        align = "end";
      } else if (measurement.start <= _this.scrollOffset + _this.options.scrollPaddingStart) {
        align = "start";
      } else {
        return [_this.scrollOffset, align];
      }
    }
    var toOffset = align === "end" ? measurement.end + _this.options.scrollPaddingEnd : measurement.start - _this.options.scrollPaddingStart;
    return [_this.getOffsetForAlignment(toOffset, align), align];
  };
  this.isDynamicMode = function() {
    return _this.measureElementCache.size > 0;
  };
  this.cancelScrollToIndex = function() {
    if (_this.scrollToIndexTimeoutId !== null) {
      clearTimeout(_this.scrollToIndexTimeoutId);
      _this.scrollToIndexTimeoutId = null;
    }
  };
  this.scrollToOffset = function(toOffset, _temp) {
    var _ref5 = _temp === void 0 ? {} : _temp, _ref5$align = _ref5.align, align = _ref5$align === void 0 ? "start" : _ref5$align, behavior = _ref5.behavior;
    _this.cancelScrollToIndex();
    if (behavior === "smooth" && _this.isDynamicMode()) {
      console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
    }
    _this._scrollToOffset(_this.getOffsetForAlignment(toOffset, align), {
      adjustments: void 0,
      behavior
    });
  };
  this.scrollToIndex = function(index2, _temp2) {
    var _ref6 = _temp2 === void 0 ? {} : _temp2, _ref6$align = _ref6.align, initialAlign = _ref6$align === void 0 ? "auto" : _ref6$align, behavior = _ref6.behavior;
    index2 = Math.max(0, Math.min(index2, _this.options.count - 1));
    _this.cancelScrollToIndex();
    if (behavior === "smooth" && _this.isDynamicMode()) {
      console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
    }
    var _this$getOffsetForInd = _this.getOffsetForIndex(index2, initialAlign), toOffset = _this$getOffsetForInd[0], align = _this$getOffsetForInd[1];
    _this._scrollToOffset(toOffset, {
      adjustments: void 0,
      behavior
    });
    if (behavior !== "smooth" && _this.isDynamicMode()) {
      _this.scrollToIndexTimeoutId = setTimeout(function() {
        _this.scrollToIndexTimeoutId = null;
        var elementInDOM = _this.measureElementCache.has(_this.options.getItemKey(index2));
        if (elementInDOM) {
          var _this$getOffsetForInd2 = _this.getOffsetForIndex(index2, align), _toOffset = _this$getOffsetForInd2[0];
          if (!approxEqual(_toOffset, _this.scrollOffset)) {
            _this.scrollToIndex(index2, {
              align,
              behavior
            });
          }
        } else {
          _this.scrollToIndex(index2, {
            align,
            behavior
          });
        }
      });
    }
  };
  this.scrollBy = function(delta, _temp3) {
    var _ref7 = _temp3 === void 0 ? {} : _temp3, behavior = _ref7.behavior;
    _this.cancelScrollToIndex();
    if (behavior === "smooth" && _this.isDynamicMode()) {
      console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
    }
    _this._scrollToOffset(_this.scrollOffset + delta, {
      adjustments: void 0,
      behavior
    });
  };
  this.getTotalSize = function() {
    var _this$getMeasurements;
    return (((_this$getMeasurements = _this.getMeasurements()[_this.options.count - 1]) == null ? void 0 : _this$getMeasurements.end) || _this.options.paddingStart) - _this.options.scrollMargin + _this.options.paddingEnd;
  };
  this._scrollToOffset = function(offset2, _ref8) {
    var adjustments = _ref8.adjustments, behavior = _ref8.behavior;
    _this.options.scrollToFn(offset2, {
      behavior,
      adjustments
    }, _this);
  };
  this.measure = function() {
    _this.itemSizeCache = /* @__PURE__ */ new Map();
    _this.notify();
  };
  this.setOptions(_opts);
  this.scrollRect = this.options.initialRect;
  this.scrollOffset = this.options.initialOffset;
  this.measurementsCache = this.options.initialMeasurementsCache;
  this.measurementsCache.forEach(function(item) {
    _this.itemSizeCache.set(item.key, item.size);
  });
  this.maybeNotify();
};
var findNearestBinarySearch = function findNearestBinarySearch2(low, high, getCurrentValue, value) {
  while (low <= high) {
    var middle = (low + high) / 2 | 0;
    var currentValue = getCurrentValue(middle);
    if (currentValue < value) {
      low = middle + 1;
    } else if (currentValue > value) {
      high = middle - 1;
    } else {
      return middle;
    }
  }
  if (low > 0) {
    return low - 1;
  } else {
    return 0;
  }
};
function calculateRange(_ref9) {
  var measurements = _ref9.measurements, outerSize = _ref9.outerSize, scrollOffset = _ref9.scrollOffset;
  var count2 = measurements.length - 1;
  var getOffset = function getOffset2(index2) {
    return measurements[index2].start;
  };
  var startIndex = findNearestBinarySearch(0, count2, getOffset, scrollOffset);
  var endIndex = startIndex;
  while (endIndex < count2 && measurements[endIndex].end < scrollOffset + outerSize) {
    endIndex++;
  }
  return {
    startIndex,
    endIndex
  };
}
/**
 * react-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var useIsomorphicLayoutEffect$1 = typeof document !== "undefined" ? React.useLayoutEffect : React.useEffect;
function useVirtualizerBase(options2) {
  var rerender = React.useReducer(function() {
    return {};
  }, {})[1];
  var resolvedOptions = _extends$1({}, options2, {
    onChange: function onChange(instance2) {
      rerender();
      options2.onChange == null ? void 0 : options2.onChange(instance2);
    }
  });
  var _React$useState = React.useState(function() {
    return new Virtualizer(resolvedOptions);
  }), instance = _React$useState[0];
  instance.setOptions(resolvedOptions);
  React.useEffect(function() {
    return instance._didMount();
  }, []);
  useIsomorphicLayoutEffect$1(function() {
    return instance._willUpdate();
  });
  return instance;
}
function useVirtualizer(options2) {
  return useVirtualizerBase(_extends$1({
    observeElementRect,
    observeElementOffset,
    scrollToFn: elementScroll
  }, options2));
}
const HeaderRenderer = (props) => {
  const {
    isLoading,
    getIsAllRowsExpanded,
    toggleAllRowsExpanded
  } = props;
  return /* @__PURE__ */ jsx("div", {
    className: `flex items-center ${isLoading && "collapse"}`,
    children: /* @__PURE__ */ jsx("button", {
      onClick: () => {
        toggleAllRowsExpanded();
      },
      children: /* @__PURE__ */ jsx(SvgChevronDown, {
        className: `size-6 ${getIsAllRowsExpanded() ? "" : "rotate-180"}`
      })
    })
  });
};
const CellRenderer = (props) => {
  const {
    getIsExpanded,
    isLoading,
    toggleExpanded,
    getIsGrouped
  } = props;
  return getIsGrouped() ? /* @__PURE__ */ jsx("div", {
    className: `flex items-center ${isLoading && "collapse"} size-6 `,
    children: /* @__PURE__ */ jsx("button", {
      onClick: () => {
        toggleExpanded();
      },
      children: /* @__PURE__ */ jsx(SvgChevronDown, {
        className: `size-6 ${getIsExpanded() ? "" : "rotate-180"}`
      })
    })
  }) : /* @__PURE__ */ jsx("div", {
    className: "w-full"
  });
};
const expandColumnConfig = () => {
  return {
    id: "expand",
    size: 58,
    enableHiding: false,
    enableSorting: false,
    enablePinning: false,
    header: ({
      table
    }) => {
      return /* @__PURE__ */ jsx(HeaderRenderer, {
        getIsAllRowsExpanded: table.getIsAllRowsExpanded,
        isLoading: table.options.meta.isLoading,
        toggleAllRowsExpanded: table.toggleAllRowsExpanded
      });
    },
    cell: ({
      row,
      table
    }) => {
      return /* @__PURE__ */ jsx(CellRenderer, {
        getIsExpanded: row.getIsExpanded,
        getIsGrouped: row.getIsGrouped,
        isLoading: table.options.meta.isLoading,
        toggleExpanded: row.toggleExpanded
      });
    }
  };
};
const onRowSelectionChange = (row, onRowSelect, onRowDeselect) => (event) => {
  const previousSelection = row.getIsSelected();
  if (row.getIsGrouped()) {
    for (const subRow of row.subRows) subRow.toggleSelected(!row.getIsAllSubRowsSelected());
  } else {
    row.getToggleSelectedHandler()(event);
  }
  if (previousSelection) {
    onRowDeselect == null ? void 0 : onRowDeselect([row.original]);
  } else {
    onRowSelect == null ? void 0 : onRowSelect([row.original]);
  }
};
const onAllRowsSelectionChange = (table, onRowSelect, onRowDeselect) => (event) => {
  const previousSelection = table.getIsAllRowsSelected();
  const prevSelectedKeys = table.getState().rowSelection;
  const {
    grouping
  } = table.getState();
  const isGrouped = grouping.length > 0;
  let selectedRows = [];
  if (isGrouped) {
    const rows = table.getRowModel().rows;
    for (const row of rows) {
      row.toggleSelected(event.target.checked);
      selectedRows = [...selectedRows, ...row.getLeafRows()];
    }
  } else {
    table.getToggleAllRowsSelectedHandler()(event);
    selectedRows = table.getPreSelectedRowModel().rows;
  }
  if (previousSelection) {
    onRowDeselect == null ? void 0 : onRowDeselect(selectedRows.filter((row) => prevSelectedKeys[row.id]).map((row) => row.original));
  } else {
    onRowSelect == null ? void 0 : onRowSelect(selectedRows.filter((row) => !prevSelectedKeys[row.id]).map((row) => row.original));
  }
};
const selectColumnConfig = (onRowSelect, onRowDeselect, isLoading = false) => ({
  id: "select",
  enableHiding: false,
  enableSorting: false,
  size: 62,
  header: ({
    table
  }) => /* @__PURE__ */ jsx("div", {
    className: `flex items-center ${isLoading && "collapse"}`,
    children: /* @__PURE__ */ jsx(Checkbox, {
      isChecked: table.getIsAllPageRowsSelected(),
      isPartiallyChecked: table.getIsSomePageRowsSelected(),
      onChange: onAllRowsSelectionChange(table, onRowSelect, onRowDeselect),
      hideLabel: true,
      isDisabled: isLoading,
      label: "",
      value: `table_selection`
    })
  }),
  cell: ({
    row
  }) => {
    return /* @__PURE__ */ jsx("div", {
      className: `flex items-center ${isLoading && "collapse"}`,
      children: /* @__PURE__ */ jsx(Checkbox, {
        isChecked: row.getIsGrouped() ? row.getIsAllSubRowsSelected() : row.getIsSelected(),
        isDisabled: !row.getCanSelect(),
        isPartiallyChecked: row.getIsSomeSelected(),
        onChange: onRowSelectionChange(row, onRowSelect, onRowDeselect),
        hideLabel: true,
        label: "",
        value: `row_${row.id}_selection`
      })
    });
  }
});
const useDidUpdateEffect = (fn, inputs) => {
  const isMountingRef = useRef(true);
  useEffect(() => {
    if (isMountingRef.current) {
      isMountingRef.current = false;
    } else {
      return fn();
    }
  }, inputs);
};
const defaultTableState = {
  table: {},
  isLoading: false,
  enableRowVirtualization: {
    minRows: 200
  }
};
const TableStateContext = createContext(defaultTableState);
const Skeleton = ({
  column
}) => {
  var _a;
  return ((_a = column.columnDef.meta) == null ? void 0 : _a.classes) ? /* @__PURE__ */ jsx("div", {
    className: `skeleton-td ${column.columnDef.meta.classes}`
  }) : /* @__PURE__ */ jsx("div", {
    className: "skeleton-td w-20"
  });
};
const estimateRowHeightDefault = () => 58.8125;
const TableStateProvider = (props) => {
  var _a, _b, _c;
  const {
    options: defaultOptions,
    stickyColumns: defaultStickyColumns,
    enableRowVirtualization,
    children,
    estimateRowHeight,
    isLoading,
    onRowSelect,
    onRowDeselect,
    groupBy: groupBy2,
    hideGroupByColumn,
    ...rest
  } = props;
  const [expanded, setExpanded] = useState({});
  useEffect(() => {
    if (groupBy2) {
      setExpanded(true);
    }
  }, [groupBy2]);
  const columns = useMemo(() => {
    let newColumns = defaultOptions.columns;
    if (defaultOptions.enableRowSelection) {
      newColumns = [selectColumnConfig(onRowSelect, onRowDeselect, isLoading), ...newColumns];
    }
    if (defaultOptions.enableGrouping && groupBy2 !== void 0) {
      newColumns = [expandColumnConfig(), ...newColumns];
    }
    if (isLoading) {
      newColumns = newColumns.map((column) => ({
        ...column,
        cell: Skeleton
      }));
    }
    return newColumns;
  }, [defaultOptions.columns, defaultOptions.enableRowSelection, defaultOptions.enableGrouping, groupBy2, isLoading, onRowDeselect, onRowSelect]);
  const data = useMemo(() => {
    return isLoading ? Array.from({
      length: 30
    }).fill({}) : defaultOptions.data;
  }, [defaultOptions.data, isLoading]);
  let newStickyColumns = defaultStickyColumns;
  if (defaultOptions.enableRowSelection) {
    newStickyColumns = defaultStickyColumns ? ["expand", "select", ...defaultStickyColumns] : ["expand", "select"];
  } else {
    newStickyColumns = defaultStickyColumns ? ["expand", ...defaultStickyColumns] : ["expand"];
  }
  const columnVisibility = useMemo(() => {
    var _a2;
    const state = {
      ...(_a2 = defaultOptions.state) == null ? void 0 : _a2.columnVisibility
    };
    if (groupBy2 && hideGroupByColumn) {
      state[groupBy2] = false;
    }
    return state;
  }, [groupBy2, (_a = defaultOptions.state) == null ? void 0 : _a.columnVisibility, hideGroupByColumn]);
  const columnPinning = useMemo(() => {
    var _a2, _b2, _c2, _d;
    return {
      left: [...newStickyColumns || [], ...((_b2 = (_a2 = defaultOptions.state) == null ? void 0 : _a2.columnPinning) == null ? void 0 : _b2.left) || []],
      right: ((_d = (_c2 = defaultOptions.state) == null ? void 0 : _c2.columnPinning) == null ? void 0 : _d.right) || []
    };
  }, [newStickyColumns, (_b = defaultOptions.state) == null ? void 0 : _b.columnPinning]);
  const options2 = {
    getExpandedRowModel: defaultOptions.enableGrouping ? getExpandedRowModel() : void 0,
    getGroupedRowModel: defaultOptions.enableGrouping ? getGroupedRowModel() : void 0,
    getPaginationRowModel: defaultOptions.enableGrouping ? getPaginationRowModel() : void 0,
    onExpandedChange: setExpanded,
    paginateExpandedRows: false,
    autoResetExpanded: false,
    columnResizeMode: "onChange",
    ...defaultOptions,
    columns,
    data,
    initialState: {
      ...defaultOptions.initialState,
      grouping: groupBy2 ? [groupBy2] : [],
      sorting: groupBy2 ? [{
        id: groupBy2,
        desc: false
      }] : ((_c = defaultOptions.initialState) == null ? void 0 : _c.sorting) ?? []
    },
    state: {
      expanded,
      ...defaultOptions.state,
      columnVisibility,
      columnPinning
    },
    meta: {
      ...defaultOptions.meta,
      isLoading
    }
  };
  const table = useReactTable(options2);
  const tableContainerRef = useRef(null);
  const rowVirtualizer = useVirtualizer({
    getScrollElement: () => tableContainerRef.current,
    count: data.length,
    estimateSize: estimateRowHeight ?? estimateRowHeightDefault,
    overscan: 75
  });
  const context = useMemo(() => ({
    table,
    stickyColumns: newStickyColumns,
    isLoading,
    rowVirtualizer,
    enableRowVirtualization,
    tableContainerRef,
    ...rest
  }), [table, newStickyColumns, isLoading, rowVirtualizer, enableRowVirtualization, rest]);
  useDidUpdateEffect(() => {
    table.setGrouping(groupBy2 ? [groupBy2] : []);
    table.resetRowSelection();
    table.setSorting(groupBy2 ? [{
      id: groupBy2,
      desc: false
    }] : []);
  }, [groupBy2, table]);
  return /* @__PURE__ */ jsx(TableStateContext.Provider, {
    value: context,
    children
  });
};
const useTable = () => {
  return useContext(TableStateContext);
};
const rowClasses = "group/tablerow [&:has(:checked)]:bg-gray-200 [&:has(:checked)]:is-selected";
const getRowVirtualizationEnabled = (enableRowVirtualization, numRows) => {
  if (typeof enableRowVirtualization === "boolean") {
    return enableRowVirtualization;
  }
  return (enableRowVirtualization == null ? void 0 : enableRowVirtualization.minRows) <= numRows;
};
const Body = () => {
  var _a, _b;
  const {
    table,
    rowVirtualizer,
    enableRowVirtualization
  } = useTable();
  const {
    rows
  } = (table == null ? void 0 : table.getRowModel()) ?? {
    rows: []
  };
  const virtualRows = (rowVirtualizer == null ? void 0 : rowVirtualizer.getVirtualItems()) ?? [];
  const totalSize = (rowVirtualizer == null ? void 0 : rowVirtualizer.getTotalSize()) ?? 0;
  const paddingTop = virtualRows.length > 0 ? ((_a = virtualRows == null ? void 0 : virtualRows[0]) == null ? void 0 : _a.start) || 0 : 0;
  const paddingBottom = virtualRows.length > 0 ? totalSize - (((_b = virtualRows == null ? void 0 : virtualRows[virtualRows.length - 1]) == null ? void 0 : _b.end) || 0) : 0;
  const isRowVirtualized = getRowVirtualizationEnabled(enableRowVirtualization, totalSize);
  const rowsToRender = isRowVirtualized ? virtualRows : rows;
  return /* @__PURE__ */ jsxs("tbody", {
    children: [isRowVirtualized && paddingTop > 0 && /* @__PURE__ */ jsx("tr", {
      children: /* @__PURE__ */ jsx("td", {
        style: {
          height: `${paddingTop}px`
        }
      })
    }), rowsToRender.map((rowToRender) => {
      const row = isRowVirtualized ? rows[rowToRender.index] : rowToRender;
      const cells = (row == null ? void 0 : row.getVisibleCells()) || [];
      return (row == null ? void 0 : row.getIsGrouped()) ? /* @__PURE__ */ jsx(GroupRow, {
        row,
        table
      }) : /* @__PURE__ */ jsx("tr", {
        className: `body-tr ${rowClasses}`,
        children: cells == null ? void 0 : cells.map((cell) => {
          return /* @__PURE__ */ jsx(CellContents, {
            cell
          }, `cell_${cell == null ? void 0 : cell.id}`);
        })
      }, row == null ? void 0 : row.id);
    }), isRowVirtualized && paddingBottom > 0 && /* @__PURE__ */ jsx("tr", {
      children: /* @__PURE__ */ jsx("td", {
        style: {
          height: `${paddingBottom}px`
        }
      })
    })]
  });
};
const DndContext = createContext({
  dragDropManager: void 0
});
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or use the non-minified dev environment for full errors. ";
}
var $$observable = function() {
  return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var randomString = function randomString2() {
  return Math.random().toString(36).substring(7).split("").join(".");
};
var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString()
};
function isPlainObject(obj) {
  if (typeof obj !== "object" || obj === null) return false;
  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto;
}
function miniKindOf(val) {
  if (val === void 0) return "undefined";
  if (val === null) return "null";
  var type = typeof val;
  switch (type) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function": {
      return type;
    }
  }
  if (Array.isArray(val)) return "array";
  if (isDate(val)) return "date";
  if (isError(val)) return "error";
  var constructorName = ctorName(val);
  switch (constructorName) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return constructorName;
  }
  return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
  return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
  return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
  var typeOfVal = typeof val;
  if (process.env.NODE_ENV !== "production") {
    typeOfVal = miniKindOf(val);
  }
  return typeOfVal;
}
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  if (typeof reducer !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }
  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  function getState2() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    }
    return currentState;
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    }
    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index2 = nextListeners.indexOf(listener);
      nextListeners.splice(index2, 1);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }
    if (typeof action.type === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : "Reducers may not dispatch actions.");
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }
    currentReducer = nextReducer;
    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  function observable() {
    var _ref;
    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe2(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }
        function observeState() {
          if (observer.next) {
            observer.next(getState2());
          }
        }
        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      }
    }, _ref[$$observable] = function() {
      return this;
    }, _ref;
  }
  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch,
    subscribe,
    getState: getState2,
    replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
function invariant(condition, format, ...args) {
  if (isProduction()) {
    if (format === void 0) {
      throw new Error("invariant requires an error message argument");
    }
  }
  if (!condition) {
    let error;
    if (format === void 0) {
      error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    } else {
      let argIndex = 0;
      error = new Error(format.replace(/%s/g, function() {
        return args[argIndex++];
      }));
      error.name = "Invariant Violation";
    }
    error.framesToPop = 1;
    throw error;
  }
}
function isProduction() {
  return typeof process !== "undefined" && process.env["NODE_ENV"] === "production";
}
function get(obj, path, defaultValue) {
  return path.split(".").reduce(
    (a, c) => a && a[c] ? a[c] : defaultValue || null,
    obj
  );
}
function without$1(items, item) {
  return items.filter(
    (i) => i !== item
  );
}
function isObject(input) {
  return typeof input === "object";
}
function xor(itemsA, itemsB) {
  const map = /* @__PURE__ */ new Map();
  const insertItem = (item) => {
    map.set(item, map.has(item) ? map.get(item) + 1 : 1);
  };
  itemsA.forEach(insertItem);
  itemsB.forEach(insertItem);
  const result = [];
  map.forEach((count2, key) => {
    if (count2 === 1) {
      result.push(key);
    }
  });
  return result;
}
function intersection(itemsA, itemsB) {
  return itemsA.filter(
    (t) => itemsB.indexOf(t) > -1
  );
}
const INIT_COORDS = "dnd-core/INIT_COORDS";
const BEGIN_DRAG = "dnd-core/BEGIN_DRAG";
const PUBLISH_DRAG_SOURCE = "dnd-core/PUBLISH_DRAG_SOURCE";
const HOVER = "dnd-core/HOVER";
const DROP = "dnd-core/DROP";
const END_DRAG = "dnd-core/END_DRAG";
function setClientOffset(clientOffset, sourceClientOffset) {
  return {
    type: INIT_COORDS,
    payload: {
      sourceClientOffset: sourceClientOffset || null,
      clientOffset: clientOffset || null
    }
  };
}
const ResetCoordinatesAction = {
  type: INIT_COORDS,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function createBeginDrag(manager) {
  return function beginDrag(sourceIds = [], options2 = {
    publishSource: true
  }) {
    const { publishSource = true, clientOffset, getSourceClientOffset: getSourceClientOffset2 } = options2;
    const monitor = manager.getMonitor();
    const registry = manager.getRegistry();
    manager.dispatch(setClientOffset(clientOffset));
    verifyInvariants$1(sourceIds, monitor, registry);
    const sourceId = getDraggableSource(sourceIds, monitor);
    if (sourceId == null) {
      manager.dispatch(ResetCoordinatesAction);
      return;
    }
    let sourceClientOffset = null;
    if (clientOffset) {
      if (!getSourceClientOffset2) {
        throw new Error("getSourceClientOffset must be defined");
      }
      verifyGetSourceClientOffsetIsFunction(getSourceClientOffset2);
      sourceClientOffset = getSourceClientOffset2(sourceId);
    }
    manager.dispatch(setClientOffset(clientOffset, sourceClientOffset));
    const source = registry.getSource(sourceId);
    const item = source.beginDrag(monitor, sourceId);
    if (item == null) {
      return void 0;
    }
    verifyItemIsObject(item);
    registry.pinSource(sourceId);
    const itemType = registry.getSourceType(sourceId);
    return {
      type: BEGIN_DRAG,
      payload: {
        itemType,
        item,
        sourceId,
        clientOffset: clientOffset || null,
        sourceClientOffset: sourceClientOffset || null,
        isSourcePublic: !!publishSource
      }
    };
  };
}
function verifyInvariants$1(sourceIds, monitor, registry) {
  invariant(!monitor.isDragging(), "Cannot call beginDrag while dragging.");
  sourceIds.forEach(function(sourceId) {
    invariant(registry.getSource(sourceId), "Expected sourceIds to be registered.");
  });
}
function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset2) {
  invariant(typeof getSourceClientOffset2 === "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function verifyItemIsObject(item) {
  invariant(isObject(item), "Item must be an object.");
}
function getDraggableSource(sourceIds, monitor) {
  let sourceId = null;
  for (let i = sourceIds.length - 1; i >= 0; i--) {
    if (monitor.canDragSource(sourceIds[i])) {
      sourceId = sourceIds[i];
      break;
    }
  }
  return sourceId;
}
function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _defineProperty$4(target, key, source[key]);
    });
  }
  return target;
}
function createDrop(manager) {
  return function drop(options2 = {}) {
    const monitor = manager.getMonitor();
    const registry = manager.getRegistry();
    verifyInvariants(monitor);
    const targetIds = getDroppableTargets(monitor);
    targetIds.forEach((targetId, index2) => {
      const dropResult = determineDropResult(targetId, index2, registry, monitor);
      const action = {
        type: DROP,
        payload: {
          dropResult: _objectSpread$4({}, options2, dropResult)
        }
      };
      manager.dispatch(action);
    });
  };
}
function verifyInvariants(monitor) {
  invariant(monitor.isDragging(), "Cannot call drop while not dragging.");
  invariant(!monitor.didDrop(), "Cannot call drop twice during one drag operation.");
}
function determineDropResult(targetId, index2, registry, monitor) {
  const target = registry.getTarget(targetId);
  let dropResult = target ? target.drop(monitor, targetId) : void 0;
  verifyDropResultType(dropResult);
  if (typeof dropResult === "undefined") {
    dropResult = index2 === 0 ? {} : monitor.getDropResult();
  }
  return dropResult;
}
function verifyDropResultType(dropResult) {
  invariant(typeof dropResult === "undefined" || isObject(dropResult), "Drop result must either be an object or undefined.");
}
function getDroppableTargets(monitor) {
  const targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
  targetIds.reverse();
  return targetIds;
}
function createEndDrag(manager) {
  return function endDrag() {
    const monitor = manager.getMonitor();
    const registry = manager.getRegistry();
    verifyIsDragging(monitor);
    const sourceId = monitor.getSourceId();
    if (sourceId != null) {
      const source = registry.getSource(sourceId, true);
      source.endDrag(monitor, sourceId);
      registry.unpinSource();
    }
    return {
      type: END_DRAG
    };
  };
}
function verifyIsDragging(monitor) {
  invariant(monitor.isDragging(), "Cannot call endDrag while not dragging.");
}
function matchesType(targetType, draggedItemType) {
  if (draggedItemType === null) {
    return targetType === null;
  }
  return Array.isArray(targetType) ? targetType.some(
    (t) => t === draggedItemType
  ) : targetType === draggedItemType;
}
function createHover(manager) {
  return function hover(targetIdsArg, { clientOffset } = {}) {
    verifyTargetIdsIsArray(targetIdsArg);
    const targetIds = targetIdsArg.slice(0);
    const monitor = manager.getMonitor();
    const registry = manager.getRegistry();
    const draggedItemType = monitor.getItemType();
    removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
    checkInvariants(targetIds, monitor, registry);
    hoverAllTargets(targetIds, monitor, registry);
    return {
      type: HOVER,
      payload: {
        targetIds,
        clientOffset: clientOffset || null
      }
    };
  };
}
function verifyTargetIdsIsArray(targetIdsArg) {
  invariant(Array.isArray(targetIdsArg), "Expected targetIds to be an array.");
}
function checkInvariants(targetIds, monitor, registry) {
  invariant(monitor.isDragging(), "Cannot call hover while not dragging.");
  invariant(!monitor.didDrop(), "Cannot call hover after drop.");
  for (let i = 0; i < targetIds.length; i++) {
    const targetId = targetIds[i];
    invariant(targetIds.lastIndexOf(targetId) === i, "Expected targetIds to be unique in the passed array.");
    const target = registry.getTarget(targetId);
    invariant(target, "Expected targetIds to be registered.");
  }
}
function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
  for (let i = targetIds.length - 1; i >= 0; i--) {
    const targetId = targetIds[i];
    const targetType = registry.getTargetType(targetId);
    if (!matchesType(targetType, draggedItemType)) {
      targetIds.splice(i, 1);
    }
  }
}
function hoverAllTargets(targetIds, monitor, registry) {
  targetIds.forEach(function(targetId) {
    const target = registry.getTarget(targetId);
    target.hover(monitor, targetId);
  });
}
function createPublishDragSource(manager) {
  return function publishDragSource() {
    const monitor = manager.getMonitor();
    if (monitor.isDragging()) {
      return {
        type: PUBLISH_DRAG_SOURCE
      };
    }
    return;
  };
}
function createDragDropActions(manager) {
  return {
    beginDrag: createBeginDrag(manager),
    publishDragSource: createPublishDragSource(manager),
    hover: createHover(manager),
    drop: createDrop(manager),
    endDrag: createEndDrag(manager)
  };
}
class DragDropManagerImpl {
  receiveBackend(backend) {
    this.backend = backend;
  }
  getMonitor() {
    return this.monitor;
  }
  getBackend() {
    return this.backend;
  }
  getRegistry() {
    return this.monitor.registry;
  }
  getActions() {
    const manager = this;
    const { dispatch } = this.store;
    function bindActionCreator(actionCreator) {
      return (...args) => {
        const action = actionCreator.apply(manager, args);
        if (typeof action !== "undefined") {
          dispatch(action);
        }
      };
    }
    const actions = createDragDropActions(this);
    return Object.keys(actions).reduce((boundActions, key) => {
      const action = actions[key];
      boundActions[key] = bindActionCreator(action);
      return boundActions;
    }, {});
  }
  dispatch(action) {
    this.store.dispatch(action);
  }
  constructor(store, monitor) {
    this.isSetUp = false;
    this.handleRefCountChange = () => {
      const shouldSetUp = this.store.getState().refCount > 0;
      if (this.backend) {
        if (shouldSetUp && !this.isSetUp) {
          this.backend.setup();
          this.isSetUp = true;
        } else if (!shouldSetUp && this.isSetUp) {
          this.backend.teardown();
          this.isSetUp = false;
        }
      }
    };
    this.store = store;
    this.monitor = monitor;
    store.subscribe(this.handleRefCountChange);
  }
}
function add(a, b) {
  return {
    x: a.x + b.x,
    y: a.y + b.y
  };
}
function subtract(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y
  };
}
function getSourceClientOffset(state) {
  const { clientOffset, initialClientOffset, initialSourceClientOffset } = state;
  if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
    return null;
  }
  return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
function getDifferenceFromInitialOffset(state) {
  const { clientOffset, initialClientOffset } = state;
  if (!clientOffset || !initialClientOffset) {
    return null;
  }
  return subtract(clientOffset, initialClientOffset);
}
const NONE = [];
const ALL = [];
NONE.__IS_NONE__ = true;
ALL.__IS_ALL__ = true;
function areDirty(dirtyIds, handlerIds) {
  if (dirtyIds === NONE) {
    return false;
  }
  if (dirtyIds === ALL || typeof handlerIds === "undefined") {
    return true;
  }
  const commonIds = intersection(handlerIds, dirtyIds);
  return commonIds.length > 0;
}
class DragDropMonitorImpl {
  subscribeToStateChange(listener, options2 = {}) {
    const { handlerIds } = options2;
    invariant(typeof listener === "function", "listener must be a function.");
    invariant(typeof handlerIds === "undefined" || Array.isArray(handlerIds), "handlerIds, when specified, must be an array of strings.");
    let prevStateId = this.store.getState().stateId;
    const handleChange = () => {
      const state = this.store.getState();
      const currentStateId = state.stateId;
      try {
        const canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !areDirty(state.dirtyHandlerIds, handlerIds);
        if (!canSkipListener) {
          listener();
        }
      } finally {
        prevStateId = currentStateId;
      }
    };
    return this.store.subscribe(handleChange);
  }
  subscribeToOffsetChange(listener) {
    invariant(typeof listener === "function", "listener must be a function.");
    let previousState = this.store.getState().dragOffset;
    const handleChange = () => {
      const nextState = this.store.getState().dragOffset;
      if (nextState === previousState) {
        return;
      }
      previousState = nextState;
      listener();
    };
    return this.store.subscribe(handleChange);
  }
  canDragSource(sourceId) {
    if (!sourceId) {
      return false;
    }
    const source = this.registry.getSource(sourceId);
    invariant(source, `Expected to find a valid source. sourceId=${sourceId}`);
    if (this.isDragging()) {
      return false;
    }
    return source.canDrag(this, sourceId);
  }
  canDropOnTarget(targetId) {
    if (!targetId) {
      return false;
    }
    const target = this.registry.getTarget(targetId);
    invariant(target, `Expected to find a valid target. targetId=${targetId}`);
    if (!this.isDragging() || this.didDrop()) {
      return false;
    }
    const targetType = this.registry.getTargetType(targetId);
    const draggedItemType = this.getItemType();
    return matchesType(targetType, draggedItemType) && target.canDrop(this, targetId);
  }
  isDragging() {
    return Boolean(this.getItemType());
  }
  isDraggingSource(sourceId) {
    if (!sourceId) {
      return false;
    }
    const source = this.registry.getSource(sourceId, true);
    invariant(source, `Expected to find a valid source. sourceId=${sourceId}`);
    if (!this.isDragging() || !this.isSourcePublic()) {
      return false;
    }
    const sourceType = this.registry.getSourceType(sourceId);
    const draggedItemType = this.getItemType();
    if (sourceType !== draggedItemType) {
      return false;
    }
    return source.isDragging(this, sourceId);
  }
  isOverTarget(targetId, options2 = {
    shallow: false
  }) {
    if (!targetId) {
      return false;
    }
    const { shallow } = options2;
    if (!this.isDragging()) {
      return false;
    }
    const targetType = this.registry.getTargetType(targetId);
    const draggedItemType = this.getItemType();
    if (draggedItemType && !matchesType(targetType, draggedItemType)) {
      return false;
    }
    const targetIds = this.getTargetIds();
    if (!targetIds.length) {
      return false;
    }
    const index2 = targetIds.indexOf(targetId);
    if (shallow) {
      return index2 === targetIds.length - 1;
    } else {
      return index2 > -1;
    }
  }
  getItemType() {
    return this.store.getState().dragOperation.itemType;
  }
  getItem() {
    return this.store.getState().dragOperation.item;
  }
  getSourceId() {
    return this.store.getState().dragOperation.sourceId;
  }
  getTargetIds() {
    return this.store.getState().dragOperation.targetIds;
  }
  getDropResult() {
    return this.store.getState().dragOperation.dropResult;
  }
  didDrop() {
    return this.store.getState().dragOperation.didDrop;
  }
  isSourcePublic() {
    return Boolean(this.store.getState().dragOperation.isSourcePublic);
  }
  getInitialClientOffset() {
    return this.store.getState().dragOffset.initialClientOffset;
  }
  getInitialSourceClientOffset() {
    return this.store.getState().dragOffset.initialSourceClientOffset;
  }
  getClientOffset() {
    return this.store.getState().dragOffset.clientOffset;
  }
  getSourceClientOffset() {
    return getSourceClientOffset(this.store.getState().dragOffset);
  }
  getDifferenceFromInitialOffset() {
    return getDifferenceFromInitialOffset(this.store.getState().dragOffset);
  }
  constructor(store, registry) {
    this.store = store;
    this.registry = registry;
  }
}
const scope = typeof global !== "undefined" ? global : self;
const BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
function makeRequestCallFromTimer(callback) {
  return function requestCall() {
    const timeoutHandle = setTimeout(handleTimer, 0);
    const intervalHandle = setInterval(handleTimer, 50);
    function handleTimer() {
      clearTimeout(timeoutHandle);
      clearInterval(intervalHandle);
      callback();
    }
  };
}
function makeRequestCallFromMutationObserver(callback) {
  let toggle = 1;
  const observer = new BrowserMutationObserver(callback);
  const node = document.createTextNode("");
  observer.observe(node, {
    characterData: true
  });
  return function requestCall() {
    toggle = -toggle;
    node.data = toggle;
  };
}
const makeRequestCall = typeof BrowserMutationObserver === "function" ? (
  // reliably everywhere they are implemented.
  // They are implemented in all modern browsers.
  //
  // - Android 4-4.3
  // - Chrome 26-34
  // - Firefox 14-29
  // - Internet Explorer 11
  // - iPad Safari 6-7.1
  // - iPhone Safari 7-7.1
  // - Safari 6-7
  makeRequestCallFromMutationObserver
) : (
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
  makeRequestCallFromTimer
);
class AsapQueue {
  // Use the fastest means possible to execute a task in its own turn, with
  // priority over other events including IO, animation, reflow, and redraw
  // events in browsers.
  //
  // An exception thrown by a task will permanently interrupt the processing of
  // subsequent tasks. The higher level `asap` function ensures that if an
  // exception is thrown by a task, that the task queue will continue flushing as
  // soon as possible, but if you use `rawAsap` directly, you are responsible to
  // either ensure that no exceptions are thrown from your task, or to manually
  // call `rawAsap.requestFlush` if an exception is thrown.
  enqueueTask(task) {
    const { queue: q, requestFlush } = this;
    if (!q.length) {
      requestFlush();
      this.flushing = true;
    }
    q[q.length] = task;
  }
  constructor() {
    this.queue = [];
    this.pendingErrors = [];
    this.flushing = false;
    this.index = 0;
    this.capacity = 1024;
    this.flush = () => {
      const { queue: q } = this;
      while (this.index < q.length) {
        const currentIndex = this.index;
        this.index++;
        q[currentIndex].call();
        if (this.index > this.capacity) {
          for (let scan = 0, newLength = q.length - this.index; scan < newLength; scan++) {
            q[scan] = q[scan + this.index];
          }
          q.length -= this.index;
          this.index = 0;
        }
      }
      q.length = 0;
      this.index = 0;
      this.flushing = false;
    };
    this.registerPendingError = (err) => {
      this.pendingErrors.push(err);
      this.requestErrorThrow();
    };
    this.requestFlush = makeRequestCall(this.flush);
    this.requestErrorThrow = makeRequestCallFromTimer(() => {
      if (this.pendingErrors.length) {
        throw this.pendingErrors.shift();
      }
    });
  }
}
class RawTask {
  call() {
    try {
      this.task && this.task();
    } catch (error) {
      this.onError(error);
    } finally {
      this.task = null;
      this.release(this);
    }
  }
  constructor(onError, release) {
    this.onError = onError;
    this.release = release;
    this.task = null;
  }
}
class TaskFactory {
  create(task) {
    const tasks = this.freeTasks;
    const t1 = tasks.length ? tasks.pop() : new RawTask(
      this.onError,
      (t) => tasks[tasks.length] = t
    );
    t1.task = task;
    return t1;
  }
  constructor(onError) {
    this.onError = onError;
    this.freeTasks = [];
  }
}
const asapQueue = new AsapQueue();
const taskFactory = new TaskFactory(asapQueue.registerPendingError);
function asap(task) {
  asapQueue.enqueueTask(taskFactory.create(task));
}
const ADD_SOURCE = "dnd-core/ADD_SOURCE";
const ADD_TARGET = "dnd-core/ADD_TARGET";
const REMOVE_SOURCE = "dnd-core/REMOVE_SOURCE";
const REMOVE_TARGET = "dnd-core/REMOVE_TARGET";
function addSource(sourceId) {
  return {
    type: ADD_SOURCE,
    payload: {
      sourceId
    }
  };
}
function addTarget(targetId) {
  return {
    type: ADD_TARGET,
    payload: {
      targetId
    }
  };
}
function removeSource(sourceId) {
  return {
    type: REMOVE_SOURCE,
    payload: {
      sourceId
    }
  };
}
function removeTarget(targetId) {
  return {
    type: REMOVE_TARGET,
    payload: {
      targetId
    }
  };
}
function validateSourceContract(source) {
  invariant(typeof source.canDrag === "function", "Expected canDrag to be a function.");
  invariant(typeof source.beginDrag === "function", "Expected beginDrag to be a function.");
  invariant(typeof source.endDrag === "function", "Expected endDrag to be a function.");
}
function validateTargetContract(target) {
  invariant(typeof target.canDrop === "function", "Expected canDrop to be a function.");
  invariant(typeof target.hover === "function", "Expected hover to be a function.");
  invariant(typeof target.drop === "function", "Expected beginDrag to be a function.");
}
function validateType(type, allowArray) {
  if (allowArray && Array.isArray(type)) {
    type.forEach(
      (t) => validateType(t, false)
    );
    return;
  }
  invariant(typeof type === "string" || typeof type === "symbol", allowArray ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
var HandlerRole;
(function(HandlerRole2) {
  HandlerRole2["SOURCE"] = "SOURCE";
  HandlerRole2["TARGET"] = "TARGET";
})(HandlerRole || (HandlerRole = {}));
let nextUniqueId = 0;
function getNextUniqueId() {
  return nextUniqueId++;
}
function getNextHandlerId(role) {
  const id = getNextUniqueId().toString();
  switch (role) {
    case HandlerRole.SOURCE:
      return `S${id}`;
    case HandlerRole.TARGET:
      return `T${id}`;
    default:
      throw new Error(`Unknown Handler Role: ${role}`);
  }
}
function parseRoleFromHandlerId(handlerId) {
  switch (handlerId[0]) {
    case "S":
      return HandlerRole.SOURCE;
    case "T":
      return HandlerRole.TARGET;
    default:
      throw new Error(`Cannot parse handler ID: ${handlerId}`);
  }
}
function mapContainsValue(map, searchValue) {
  const entries = map.entries();
  let isDone = false;
  do {
    const { done, value: [, value] } = entries.next();
    if (value === searchValue) {
      return true;
    }
    isDone = !!done;
  } while (!isDone);
  return false;
}
class HandlerRegistryImpl {
  addSource(type, source) {
    validateType(type);
    validateSourceContract(source);
    const sourceId = this.addHandler(HandlerRole.SOURCE, type, source);
    this.store.dispatch(addSource(sourceId));
    return sourceId;
  }
  addTarget(type, target) {
    validateType(type, true);
    validateTargetContract(target);
    const targetId = this.addHandler(HandlerRole.TARGET, type, target);
    this.store.dispatch(addTarget(targetId));
    return targetId;
  }
  containsHandler(handler) {
    return mapContainsValue(this.dragSources, handler) || mapContainsValue(this.dropTargets, handler);
  }
  getSource(sourceId, includePinned = false) {
    invariant(this.isSourceId(sourceId), "Expected a valid source ID.");
    const isPinned = includePinned && sourceId === this.pinnedSourceId;
    const source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
    return source;
  }
  getTarget(targetId) {
    invariant(this.isTargetId(targetId), "Expected a valid target ID.");
    return this.dropTargets.get(targetId);
  }
  getSourceType(sourceId) {
    invariant(this.isSourceId(sourceId), "Expected a valid source ID.");
    return this.types.get(sourceId);
  }
  getTargetType(targetId) {
    invariant(this.isTargetId(targetId), "Expected a valid target ID.");
    return this.types.get(targetId);
  }
  isSourceId(handlerId) {
    const role = parseRoleFromHandlerId(handlerId);
    return role === HandlerRole.SOURCE;
  }
  isTargetId(handlerId) {
    const role = parseRoleFromHandlerId(handlerId);
    return role === HandlerRole.TARGET;
  }
  removeSource(sourceId) {
    invariant(this.getSource(sourceId), "Expected an existing source.");
    this.store.dispatch(removeSource(sourceId));
    asap(() => {
      this.dragSources.delete(sourceId);
      this.types.delete(sourceId);
    });
  }
  removeTarget(targetId) {
    invariant(this.getTarget(targetId), "Expected an existing target.");
    this.store.dispatch(removeTarget(targetId));
    this.dropTargets.delete(targetId);
    this.types.delete(targetId);
  }
  pinSource(sourceId) {
    const source = this.getSource(sourceId);
    invariant(source, "Expected an existing source.");
    this.pinnedSourceId = sourceId;
    this.pinnedSource = source;
  }
  unpinSource() {
    invariant(this.pinnedSource, "No source is pinned at the time.");
    this.pinnedSourceId = null;
    this.pinnedSource = null;
  }
  addHandler(role, type, handler) {
    const id = getNextHandlerId(role);
    this.types.set(id, type);
    if (role === HandlerRole.SOURCE) {
      this.dragSources.set(id, handler);
    } else if (role === HandlerRole.TARGET) {
      this.dropTargets.set(id, handler);
    }
    return id;
  }
  constructor(store) {
    this.types = /* @__PURE__ */ new Map();
    this.dragSources = /* @__PURE__ */ new Map();
    this.dropTargets = /* @__PURE__ */ new Map();
    this.pinnedSourceId = null;
    this.pinnedSource = null;
    this.store = store;
  }
}
const strictEquality = (a, b) => a === b;
function areCoordsEqual(offsetA, offsetB) {
  if (!offsetA && !offsetB) {
    return true;
  } else if (!offsetA || !offsetB) {
    return false;
  } else {
    return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
  }
}
function areArraysEqual(a, b, isEqual = strictEquality) {
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0; i < a.length; ++i) {
    if (!isEqual(a[i], b[i])) {
      return false;
    }
  }
  return true;
}
function reduce$5(_state = NONE, action) {
  switch (action.type) {
    case HOVER:
      break;
    case ADD_SOURCE:
    case ADD_TARGET:
    case REMOVE_TARGET:
    case REMOVE_SOURCE:
      return NONE;
    case BEGIN_DRAG:
    case PUBLISH_DRAG_SOURCE:
    case END_DRAG:
    case DROP:
    default:
      return ALL;
  }
  const { targetIds = [], prevTargetIds = [] } = action.payload;
  const result = xor(targetIds, prevTargetIds);
  const didChange = result.length > 0 || !areArraysEqual(targetIds, prevTargetIds);
  if (!didChange) {
    return NONE;
  }
  const prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
  const innermostTargetId = targetIds[targetIds.length - 1];
  if (prevInnermostTargetId !== innermostTargetId) {
    if (prevInnermostTargetId) {
      result.push(prevInnermostTargetId);
    }
    if (innermostTargetId) {
      result.push(innermostTargetId);
    }
  }
  return result;
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _defineProperty$3(target, key, source[key]);
    });
  }
  return target;
}
const initialState$1 = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function reduce$4(state = initialState$1, action) {
  const { payload } = action;
  switch (action.type) {
    case INIT_COORDS:
    case BEGIN_DRAG:
      return {
        initialSourceClientOffset: payload.sourceClientOffset,
        initialClientOffset: payload.clientOffset,
        clientOffset: payload.clientOffset
      };
    case HOVER:
      if (areCoordsEqual(state.clientOffset, payload.clientOffset)) {
        return state;
      }
      return _objectSpread$3({}, state, {
        clientOffset: payload.clientOffset
      });
    case END_DRAG:
    case DROP:
      return initialState$1;
    default:
      return state;
  }
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    });
  }
  return target;
}
const initialState = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: false,
  isSourcePublic: null
};
function reduce$3(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case BEGIN_DRAG:
      return _objectSpread$2({}, state, {
        itemType: payload.itemType,
        item: payload.item,
        sourceId: payload.sourceId,
        isSourcePublic: payload.isSourcePublic,
        dropResult: null,
        didDrop: false
      });
    case PUBLISH_DRAG_SOURCE:
      return _objectSpread$2({}, state, {
        isSourcePublic: true
      });
    case HOVER:
      return _objectSpread$2({}, state, {
        targetIds: payload.targetIds
      });
    case REMOVE_TARGET:
      if (state.targetIds.indexOf(payload.targetId) === -1) {
        return state;
      }
      return _objectSpread$2({}, state, {
        targetIds: without$1(state.targetIds, payload.targetId)
      });
    case DROP:
      return _objectSpread$2({}, state, {
        dropResult: payload.dropResult,
        didDrop: true,
        targetIds: []
      });
    case END_DRAG:
      return _objectSpread$2({}, state, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: false,
        isSourcePublic: null,
        targetIds: []
      });
    default:
      return state;
  }
}
function reduce$2(state = 0, action) {
  switch (action.type) {
    case ADD_SOURCE:
    case ADD_TARGET:
      return state + 1;
    case REMOVE_SOURCE:
    case REMOVE_TARGET:
      return state - 1;
    default:
      return state;
  }
}
function reduce$1(state = 0) {
  return state + 1;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    });
  }
  return target;
}
function reduce(state = {}, action) {
  return {
    dirtyHandlerIds: reduce$5(state.dirtyHandlerIds, {
      type: action.type,
      payload: _objectSpread$1({}, action.payload, {
        prevTargetIds: get(state, "dragOperation.targetIds", [])
      })
    }),
    dragOffset: reduce$4(state.dragOffset, action),
    refCount: reduce$2(state.refCount, action),
    dragOperation: reduce$3(state.dragOperation, action),
    stateId: reduce$1(state.stateId)
  };
}
function createDragDropManager(backendFactory, globalContext = void 0, backendOptions = {}, debugMode = false) {
  const store = makeStoreInstance(debugMode);
  const monitor = new DragDropMonitorImpl(store, new HandlerRegistryImpl(store));
  const manager = new DragDropManagerImpl(store, monitor);
  const backend = backendFactory(manager, globalContext, backendOptions);
  manager.receiveBackend(backend);
  return manager;
}
function makeStoreInstance(debugMode) {
  const reduxDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__;
  return createStore(reduce, debugMode && reduxDevTools && reduxDevTools({
    name: "dnd-core",
    instanceId: "dnd-core"
  }));
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
let refCount = 0;
const INSTANCE_SYM = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var DndProvider = /* @__PURE__ */ memo$2(function DndProvider2(_param) {
  var { children } = _param, props = _objectWithoutProperties(_param, [
    "children"
  ]);
  const [manager, isGlobalInstance] = getDndContextValue(props);
  useEffect(() => {
    if (isGlobalInstance) {
      const context = getGlobalContext();
      ++refCount;
      return () => {
        if (--refCount === 0) {
          context[INSTANCE_SYM] = null;
        }
      };
    }
    return;
  }, []);
  return /* @__PURE__ */ jsx(DndContext.Provider, {
    value: manager,
    children
  });
});
function getDndContextValue(props) {
  if ("manager" in props) {
    const manager2 = {
      dragDropManager: props.manager
    };
    return [
      manager2,
      false
    ];
  }
  const manager = createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
  const isGlobalInstance = !props.context;
  return [
    manager,
    isGlobalInstance
  ];
}
function createSingletonDndContext(backend, context = getGlobalContext(), options2, debugMode) {
  const ctx = context;
  if (!ctx[INSTANCE_SYM]) {
    ctx[INSTANCE_SYM] = {
      dragDropManager: createDragDropManager(backend, context, options2, debugMode)
    };
  }
  return ctx[INSTANCE_SYM];
}
function getGlobalContext() {
  return typeof global !== "undefined" ? global : window;
}
var fastDeepEqual;
var hasRequiredFastDeepEqual;
function requireFastDeepEqual() {
  if (hasRequiredFastDeepEqual) return fastDeepEqual;
  hasRequiredFastDeepEqual = 1;
  fastDeepEqual = function equal2(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
      if (a.constructor !== b.constructor) return false;
      var length, i, keys;
      if (Array.isArray(a)) {
        length = a.length;
        if (length != b.length) return false;
        for (i = length; i-- !== 0; )
          if (!equal2(a[i], b[i])) return false;
        return true;
      }
      if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
      if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
      if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
      keys = Object.keys(a);
      length = keys.length;
      if (length !== Object.keys(b).length) return false;
      for (i = length; i-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
      for (i = length; i-- !== 0; ) {
        var key = keys[i];
        if (!equal2(a[key], b[key])) return false;
      }
      return true;
    }
    return a !== a && b !== b;
  };
  return fastDeepEqual;
}
var fastDeepEqualExports = requireFastDeepEqual();
const equal = /* @__PURE__ */ getDefaultExportFromCjs(fastDeepEqualExports);
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
function useCollector(monitor, collect, onUpdate) {
  const [collected, setCollected] = useState(
    () => collect(monitor)
  );
  const updateCollected = useCallback(() => {
    const nextValue = collect(monitor);
    if (!equal(collected, nextValue)) {
      setCollected(nextValue);
      if (onUpdate) {
        onUpdate();
      }
    }
  }, [
    collected,
    monitor,
    onUpdate
  ]);
  useIsomorphicLayoutEffect(updateCollected);
  return [
    collected,
    updateCollected
  ];
}
function useMonitorOutput(monitor, collect, onCollect) {
  const [collected, updateCollected] = useCollector(monitor, collect, onCollect);
  useIsomorphicLayoutEffect(function subscribeToMonitorStateChange() {
    const handlerId = monitor.getHandlerId();
    if (handlerId == null) {
      return;
    }
    return monitor.subscribeToStateChange(updateCollected, {
      handlerIds: [
        handlerId
      ]
    });
  }, [
    monitor,
    updateCollected
  ]);
  return collected;
}
function useCollectedProps(collector, monitor, connector) {
  return useMonitorOutput(
    monitor,
    collector || (() => ({})),
    () => connector.reconnect()
  );
}
function useOptionalFactory(arg, deps) {
  const memoDeps = [
    ...[]
  ];
  if (typeof arg !== "function") {
    memoDeps.push(arg);
  }
  return useMemo(() => {
    return typeof arg === "function" ? arg() : arg;
  }, memoDeps);
}
function useConnectDragSource(connector) {
  return useMemo(
    () => connector.hooks.dragSource(),
    [
      connector
    ]
  );
}
function useConnectDragPreview(connector) {
  return useMemo(
    () => connector.hooks.dragPreview(),
    [
      connector
    ]
  );
}
let isCallingCanDrag = false;
let isCallingIsDragging = false;
class DragSourceMonitorImpl {
  receiveHandlerId(sourceId) {
    this.sourceId = sourceId;
  }
  getHandlerId() {
    return this.sourceId;
  }
  canDrag() {
    invariant(!isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      isCallingCanDrag = true;
      return this.internalMonitor.canDragSource(this.sourceId);
    } finally {
      isCallingCanDrag = false;
    }
  }
  isDragging() {
    if (!this.sourceId) {
      return false;
    }
    invariant(!isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      isCallingIsDragging = true;
      return this.internalMonitor.isDraggingSource(this.sourceId);
    } finally {
      isCallingIsDragging = false;
    }
  }
  subscribeToStateChange(listener, options2) {
    return this.internalMonitor.subscribeToStateChange(listener, options2);
  }
  isDraggingSource(sourceId) {
    return this.internalMonitor.isDraggingSource(sourceId);
  }
  isOverTarget(targetId, options2) {
    return this.internalMonitor.isOverTarget(targetId, options2);
  }
  getTargetIds() {
    return this.internalMonitor.getTargetIds();
  }
  isSourcePublic() {
    return this.internalMonitor.isSourcePublic();
  }
  getSourceId() {
    return this.internalMonitor.getSourceId();
  }
  subscribeToOffsetChange(listener) {
    return this.internalMonitor.subscribeToOffsetChange(listener);
  }
  canDragSource(sourceId) {
    return this.internalMonitor.canDragSource(sourceId);
  }
  canDropOnTarget(targetId) {
    return this.internalMonitor.canDropOnTarget(targetId);
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(manager) {
    this.sourceId = null;
    this.internalMonitor = manager.getMonitor();
  }
}
let isCallingCanDrop = false;
class DropTargetMonitorImpl {
  receiveHandlerId(targetId) {
    this.targetId = targetId;
  }
  getHandlerId() {
    return this.targetId;
  }
  subscribeToStateChange(listener, options2) {
    return this.internalMonitor.subscribeToStateChange(listener, options2);
  }
  canDrop() {
    if (!this.targetId) {
      return false;
    }
    invariant(!isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
    try {
      isCallingCanDrop = true;
      return this.internalMonitor.canDropOnTarget(this.targetId);
    } finally {
      isCallingCanDrop = false;
    }
  }
  isOver(options2) {
    if (!this.targetId) {
      return false;
    }
    return this.internalMonitor.isOverTarget(this.targetId, options2);
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(manager) {
    this.targetId = null;
    this.internalMonitor = manager.getMonitor();
  }
}
function registerTarget(type, target, manager) {
  const registry = manager.getRegistry();
  const targetId = registry.addTarget(type, target);
  return [
    targetId,
    () => registry.removeTarget(targetId)
  ];
}
function registerSource(type, source, manager) {
  const registry = manager.getRegistry();
  const sourceId = registry.addSource(type, source);
  return [
    sourceId,
    () => registry.removeSource(sourceId)
  ];
}
function shallowEqual(objA, objB, compare, compareContext) {
  let compareResult = void 0;
  if (compareResult !== void 0) {
    return !!compareResult;
  }
  if (objA === objB) {
    return true;
  }
  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }
  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) {
    return false;
  }
  const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (let idx = 0; idx < keysA.length; idx++) {
    const key = keysA[idx];
    if (!bHasOwnProperty(key)) {
      return false;
    }
    const valueA = objA[key];
    const valueB = objB[key];
    compareResult = void 0;
    if (compareResult === false || compareResult === void 0 && valueA !== valueB) {
      return false;
    }
  }
  return true;
}
function isRef(obj) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    obj !== null && typeof obj === "object" && Object.prototype.hasOwnProperty.call(obj, "current")
  );
}
function throwIfCompositeComponentElement(element) {
  if (typeof element.type === "string") {
    return;
  }
  const displayName = element.type.displayName || element.type.name || "the component";
  throw new Error(`Only native element nodes can now be passed to React DnD connectors.You can either wrap ${displayName} into a <div>, or turn it into a drag source or a drop target itself.`);
}
function wrapHookToRecognizeElement(hook) {
  return (elementOrNode = null, options2 = null) => {
    if (!isValidElement(elementOrNode)) {
      const node = elementOrNode;
      hook(node, options2);
      return node;
    }
    const element = elementOrNode;
    throwIfCompositeComponentElement(element);
    const ref = options2 ? (node) => hook(node, options2) : hook;
    return cloneWithRef(element, ref);
  };
}
function wrapConnectorHooks(hooks) {
  const wrappedHooks = {};
  Object.keys(hooks).forEach((key) => {
    const hook = hooks[key];
    if (key.endsWith("Ref")) {
      wrappedHooks[key] = hooks[key];
    } else {
      const wrappedHook = wrapHookToRecognizeElement(hook);
      wrappedHooks[key] = () => wrappedHook;
    }
  });
  return wrappedHooks;
}
function setRef(ref, node) {
  if (typeof ref === "function") {
    ref(node);
  } else {
    ref.current = node;
  }
}
function cloneWithRef(element, newRef) {
  const previousRef = element.ref;
  invariant(typeof previousRef !== "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs");
  if (!previousRef) {
    return cloneElement(element, {
      ref: newRef
    });
  } else {
    return cloneElement(element, {
      ref: (node) => {
        setRef(previousRef, node);
        setRef(newRef, node);
      }
    });
  }
}
class SourceConnector {
  receiveHandlerId(newHandlerId) {
    if (this.handlerId === newHandlerId) {
      return;
    }
    this.handlerId = newHandlerId;
    this.reconnect();
  }
  get connectTarget() {
    return this.dragSource;
  }
  get dragSourceOptions() {
    return this.dragSourceOptionsInternal;
  }
  set dragSourceOptions(options2) {
    this.dragSourceOptionsInternal = options2;
  }
  get dragPreviewOptions() {
    return this.dragPreviewOptionsInternal;
  }
  set dragPreviewOptions(options2) {
    this.dragPreviewOptionsInternal = options2;
  }
  reconnect() {
    const didChange = this.reconnectDragSource();
    this.reconnectDragPreview(didChange);
  }
  reconnectDragSource() {
    const dragSource = this.dragSource;
    const didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
    if (didChange) {
      this.disconnectDragSource();
    }
    if (!this.handlerId) {
      return didChange;
    }
    if (!dragSource) {
      this.lastConnectedDragSource = dragSource;
      return didChange;
    }
    if (didChange) {
      this.lastConnectedHandlerId = this.handlerId;
      this.lastConnectedDragSource = dragSource;
      this.lastConnectedDragSourceOptions = this.dragSourceOptions;
      this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
    }
    return didChange;
  }
  reconnectDragPreview(forceDidChange = false) {
    const dragPreview = this.dragPreview;
    const didChange = forceDidChange || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
    if (didChange) {
      this.disconnectDragPreview();
    }
    if (!this.handlerId) {
      return;
    }
    if (!dragPreview) {
      this.lastConnectedDragPreview = dragPreview;
      return;
    }
    if (didChange) {
      this.lastConnectedHandlerId = this.handlerId;
      this.lastConnectedDragPreview = dragPreview;
      this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
      this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
    }
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didConnectedDragSourceChange() {
    return this.lastConnectedDragSource !== this.dragSource;
  }
  didConnectedDragPreviewChange() {
    return this.lastConnectedDragPreview !== this.dragPreview;
  }
  didDragSourceOptionsChange() {
    return !shallowEqual(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
  }
  didDragPreviewOptionsChange() {
    return !shallowEqual(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
  }
  disconnectDragSource() {
    if (this.dragSourceUnsubscribe) {
      this.dragSourceUnsubscribe();
      this.dragSourceUnsubscribe = void 0;
    }
  }
  disconnectDragPreview() {
    if (this.dragPreviewUnsubscribe) {
      this.dragPreviewUnsubscribe();
      this.dragPreviewUnsubscribe = void 0;
      this.dragPreviewNode = null;
      this.dragPreviewRef = null;
    }
  }
  get dragSource() {
    return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
  }
  get dragPreview() {
    return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
  }
  clearDragSource() {
    this.dragSourceNode = null;
    this.dragSourceRef = null;
  }
  clearDragPreview() {
    this.dragPreviewNode = null;
    this.dragPreviewRef = null;
  }
  constructor(backend) {
    this.hooks = wrapConnectorHooks({
      dragSource: (node, options2) => {
        this.clearDragSource();
        this.dragSourceOptions = options2 || null;
        if (isRef(node)) {
          this.dragSourceRef = node;
        } else {
          this.dragSourceNode = node;
        }
        this.reconnectDragSource();
      },
      dragPreview: (node, options2) => {
        this.clearDragPreview();
        this.dragPreviewOptions = options2 || null;
        if (isRef(node)) {
          this.dragPreviewRef = node;
        } else {
          this.dragPreviewNode = node;
        }
        this.reconnectDragPreview();
      }
    });
    this.handlerId = null;
    this.dragSourceRef = null;
    this.dragSourceOptionsInternal = null;
    this.dragPreviewRef = null;
    this.dragPreviewOptionsInternal = null;
    this.lastConnectedHandlerId = null;
    this.lastConnectedDragSource = null;
    this.lastConnectedDragSourceOptions = null;
    this.lastConnectedDragPreview = null;
    this.lastConnectedDragPreviewOptions = null;
    this.backend = backend;
  }
}
class TargetConnector {
  get connectTarget() {
    return this.dropTarget;
  }
  reconnect() {
    const didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
    if (didChange) {
      this.disconnectDropTarget();
    }
    const dropTarget = this.dropTarget;
    if (!this.handlerId) {
      return;
    }
    if (!dropTarget) {
      this.lastConnectedDropTarget = dropTarget;
      return;
    }
    if (didChange) {
      this.lastConnectedHandlerId = this.handlerId;
      this.lastConnectedDropTarget = dropTarget;
      this.lastConnectedDropTargetOptions = this.dropTargetOptions;
      this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
    }
  }
  receiveHandlerId(newHandlerId) {
    if (newHandlerId === this.handlerId) {
      return;
    }
    this.handlerId = newHandlerId;
    this.reconnect();
  }
  get dropTargetOptions() {
    return this.dropTargetOptionsInternal;
  }
  set dropTargetOptions(options2) {
    this.dropTargetOptionsInternal = options2;
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didDropTargetChange() {
    return this.lastConnectedDropTarget !== this.dropTarget;
  }
  didOptionsChange() {
    return !shallowEqual(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
  }
  disconnectDropTarget() {
    if (this.unsubscribeDropTarget) {
      this.unsubscribeDropTarget();
      this.unsubscribeDropTarget = void 0;
    }
  }
  get dropTarget() {
    return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
  }
  clearDropTarget() {
    this.dropTargetRef = null;
    this.dropTargetNode = null;
  }
  constructor(backend) {
    this.hooks = wrapConnectorHooks({
      dropTarget: (node, options2) => {
        this.clearDropTarget();
        this.dropTargetOptions = options2;
        if (isRef(node)) {
          this.dropTargetRef = node;
        } else {
          this.dropTargetNode = node;
        }
        this.reconnect();
      }
    });
    this.handlerId = null;
    this.dropTargetRef = null;
    this.dropTargetOptionsInternal = null;
    this.lastConnectedHandlerId = null;
    this.lastConnectedDropTarget = null;
    this.lastConnectedDropTargetOptions = null;
    this.backend = backend;
  }
}
function useDragDropManager() {
  const { dragDropManager } = useContext(DndContext);
  invariant(dragDropManager != null, "Expected drag drop context");
  return dragDropManager;
}
function useDragSourceConnector(dragSourceOptions, dragPreviewOptions) {
  const manager = useDragDropManager();
  const connector = useMemo(
    () => new SourceConnector(manager.getBackend()),
    [
      manager
    ]
  );
  useIsomorphicLayoutEffect(() => {
    connector.dragSourceOptions = dragSourceOptions || null;
    connector.reconnect();
    return () => connector.disconnectDragSource();
  }, [
    connector,
    dragSourceOptions
  ]);
  useIsomorphicLayoutEffect(() => {
    connector.dragPreviewOptions = dragPreviewOptions || null;
    connector.reconnect();
    return () => connector.disconnectDragPreview();
  }, [
    connector,
    dragPreviewOptions
  ]);
  return connector;
}
function useDragSourceMonitor() {
  const manager = useDragDropManager();
  return useMemo(
    () => new DragSourceMonitorImpl(manager),
    [
      manager
    ]
  );
}
class DragSourceImpl {
  beginDrag() {
    const spec = this.spec;
    const monitor = this.monitor;
    let result = null;
    if (typeof spec.item === "object") {
      result = spec.item;
    } else if (typeof spec.item === "function") {
      result = spec.item(monitor);
    } else {
      result = {};
    }
    return result !== null && result !== void 0 ? result : null;
  }
  canDrag() {
    const spec = this.spec;
    const monitor = this.monitor;
    if (typeof spec.canDrag === "boolean") {
      return spec.canDrag;
    } else if (typeof spec.canDrag === "function") {
      return spec.canDrag(monitor);
    } else {
      return true;
    }
  }
  isDragging(globalMonitor, target) {
    const spec = this.spec;
    const monitor = this.monitor;
    const { isDragging } = spec;
    return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
  }
  endDrag() {
    const spec = this.spec;
    const monitor = this.monitor;
    const connector = this.connector;
    const { end } = spec;
    if (end) {
      end(monitor.getItem(), monitor);
    }
    connector.reconnect();
  }
  constructor(spec, monitor, connector) {
    this.spec = spec;
    this.monitor = monitor;
    this.connector = connector;
  }
}
function useDragSource(spec, monitor, connector) {
  const handler = useMemo(
    () => new DragSourceImpl(spec, monitor, connector),
    [
      monitor,
      connector
    ]
  );
  useEffect(() => {
    handler.spec = spec;
  }, [
    spec
  ]);
  return handler;
}
function useDragType(spec) {
  return useMemo(() => {
    const result = spec.type;
    invariant(result != null, "spec.type must be defined");
    return result;
  }, [
    spec
  ]);
}
function useRegisteredDragSource(spec, monitor, connector) {
  const manager = useDragDropManager();
  const handler = useDragSource(spec, monitor, connector);
  const itemType = useDragType(spec);
  useIsomorphicLayoutEffect(function registerDragSource() {
    if (itemType != null) {
      const [handlerId, unregister] = registerSource(itemType, handler, manager);
      monitor.receiveHandlerId(handlerId);
      connector.receiveHandlerId(handlerId);
      return unregister;
    }
    return;
  }, [
    manager,
    monitor,
    connector,
    handler,
    itemType
  ]);
}
function useDrag(specArg, deps) {
  const spec = useOptionalFactory(specArg);
  invariant(!spec.begin, `useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)`);
  const monitor = useDragSourceMonitor();
  const connector = useDragSourceConnector(spec.options, spec.previewOptions);
  useRegisteredDragSource(spec, monitor, connector);
  return [
    useCollectedProps(spec.collect, monitor, connector),
    useConnectDragSource(connector),
    useConnectDragPreview(connector)
  ];
}
function useConnectDropTarget(connector) {
  return useMemo(
    () => connector.hooks.dropTarget(),
    [
      connector
    ]
  );
}
function useDropTargetConnector(options2) {
  const manager = useDragDropManager();
  const connector = useMemo(
    () => new TargetConnector(manager.getBackend()),
    [
      manager
    ]
  );
  useIsomorphicLayoutEffect(() => {
    connector.dropTargetOptions = options2 || null;
    connector.reconnect();
    return () => connector.disconnectDropTarget();
  }, [
    options2
  ]);
  return connector;
}
function useDropTargetMonitor() {
  const manager = useDragDropManager();
  return useMemo(
    () => new DropTargetMonitorImpl(manager),
    [
      manager
    ]
  );
}
function useAccept(spec) {
  const { accept } = spec;
  return useMemo(() => {
    invariant(spec.accept != null, "accept must be defined");
    return Array.isArray(accept) ? accept : [
      accept
    ];
  }, [
    accept
  ]);
}
class DropTargetImpl {
  canDrop() {
    const spec = this.spec;
    const monitor = this.monitor;
    return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
  }
  hover() {
    const spec = this.spec;
    const monitor = this.monitor;
    if (spec.hover) {
      spec.hover(monitor.getItem(), monitor);
    }
  }
  drop() {
    const spec = this.spec;
    const monitor = this.monitor;
    if (spec.drop) {
      return spec.drop(monitor.getItem(), monitor);
    }
    return;
  }
  constructor(spec, monitor) {
    this.spec = spec;
    this.monitor = monitor;
  }
}
function useDropTarget(spec, monitor) {
  const dropTarget = useMemo(
    () => new DropTargetImpl(spec, monitor),
    [
      monitor
    ]
  );
  useEffect(() => {
    dropTarget.spec = spec;
  }, [
    spec
  ]);
  return dropTarget;
}
function useRegisteredDropTarget(spec, monitor, connector) {
  const manager = useDragDropManager();
  const dropTarget = useDropTarget(spec, monitor);
  const accept = useAccept(spec);
  useIsomorphicLayoutEffect(function registerDropTarget() {
    const [handlerId, unregister] = registerTarget(accept, dropTarget, manager);
    monitor.receiveHandlerId(handlerId);
    connector.receiveHandlerId(handlerId);
    return unregister;
  }, [
    manager,
    monitor,
    dropTarget,
    connector,
    accept.map(
      (a) => a.toString()
    ).join("|")
  ]);
}
function useDrop(specArg, deps) {
  const spec = useOptionalFactory(specArg);
  const monitor = useDropTargetMonitor();
  const connector = useDropTargetConnector(spec.options);
  useRegisteredDropTarget(spec, monitor, connector);
  return [
    useCollectedProps(spec.collect, monitor, connector),
    useConnectDropTarget(connector)
  ];
}
function memoize(fn) {
  let result = null;
  const memoized = () => {
    if (result == null) {
      result = fn();
    }
    return result;
  };
  return memoized;
}
function without(items, item) {
  return items.filter(
    (i) => i !== item
  );
}
function union(itemsA, itemsB) {
  const set = /* @__PURE__ */ new Set();
  const insertItem = (item) => set.add(item);
  itemsA.forEach(insertItem);
  itemsB.forEach(insertItem);
  const result = [];
  set.forEach(
    (key) => result.push(key)
  );
  return result;
}
class EnterLeaveCounter {
  enter(enteringNode) {
    const previousLength = this.entered.length;
    const isNodeEntered = (node) => this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
    this.entered = union(this.entered.filter(isNodeEntered), [
      enteringNode
    ]);
    return previousLength === 0 && this.entered.length > 0;
  }
  leave(leavingNode) {
    const previousLength = this.entered.length;
    this.entered = without(this.entered.filter(this.isNodeInDocument), leavingNode);
    return previousLength > 0 && this.entered.length === 0;
  }
  reset() {
    this.entered = [];
  }
  constructor(isNodeInDocument) {
    this.entered = [];
    this.isNodeInDocument = isNodeInDocument;
  }
}
class NativeDragSource {
  initializeExposedProperties() {
    Object.keys(this.config.exposeProperties).forEach((property) => {
      Object.defineProperty(this.item, property, {
        configurable: true,
        enumerable: true,
        get() {
          console.warn(`Browser doesn't allow reading "${property}" until the drop event.`);
          return null;
        }
      });
    });
  }
  loadDataTransfer(dataTransfer) {
    if (dataTransfer) {
      const newProperties = {};
      Object.keys(this.config.exposeProperties).forEach((property) => {
        const propertyFn = this.config.exposeProperties[property];
        if (propertyFn != null) {
          newProperties[property] = {
            value: propertyFn(dataTransfer, this.config.matchesTypes),
            configurable: true,
            enumerable: true
          };
        }
      });
      Object.defineProperties(this.item, newProperties);
    }
  }
  canDrag() {
    return true;
  }
  beginDrag() {
    return this.item;
  }
  isDragging(monitor, handle) {
    return handle === monitor.getSourceId();
  }
  endDrag() {
  }
  constructor(config) {
    this.config = config;
    this.item = {};
    this.initializeExposedProperties();
  }
}
const FILE = "__NATIVE_FILE__";
const URL = "__NATIVE_URL__";
const TEXT = "__NATIVE_TEXT__";
const HTML = "__NATIVE_HTML__";
const NativeTypes = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FILE,
  HTML,
  TEXT,
  URL
}, Symbol.toStringTag, { value: "Module" }));
function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
  const result = typesToTry.reduce(
    (resultSoFar, typeToTry) => resultSoFar || dataTransfer.getData(typeToTry),
    ""
  );
  return result != null ? result : defaultValue;
}
const nativeTypesConfig = {
  [FILE]: {
    exposeProperties: {
      files: (dataTransfer) => Array.prototype.slice.call(dataTransfer.files),
      items: (dataTransfer) => dataTransfer.items,
      dataTransfer: (dataTransfer) => dataTransfer
    },
    matchesTypes: [
      "Files"
    ]
  },
  [HTML]: {
    exposeProperties: {
      html: (dataTransfer, matchesTypes) => getDataFromDataTransfer(dataTransfer, matchesTypes, ""),
      dataTransfer: (dataTransfer) => dataTransfer
    },
    matchesTypes: [
      "Html",
      "text/html"
    ]
  },
  [URL]: {
    exposeProperties: {
      urls: (dataTransfer, matchesTypes) => getDataFromDataTransfer(dataTransfer, matchesTypes, "").split("\n"),
      dataTransfer: (dataTransfer) => dataTransfer
    },
    matchesTypes: [
      "Url",
      "text/uri-list"
    ]
  },
  [TEXT]: {
    exposeProperties: {
      text: (dataTransfer, matchesTypes) => getDataFromDataTransfer(dataTransfer, matchesTypes, ""),
      dataTransfer: (dataTransfer) => dataTransfer
    },
    matchesTypes: [
      "Text",
      "text/plain"
    ]
  }
};
function createNativeDragSource(type, dataTransfer) {
  const config = nativeTypesConfig[type];
  if (!config) {
    throw new Error(`native type ${type} has no configuration`);
  }
  const result = new NativeDragSource(config);
  result.loadDataTransfer(dataTransfer);
  return result;
}
function matchNativeItemType(dataTransfer) {
  if (!dataTransfer) {
    return null;
  }
  const dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
  return Object.keys(nativeTypesConfig).filter((nativeItemType) => {
    const typeConfig = nativeTypesConfig[nativeItemType];
    if (!(typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.matchesTypes)) {
      return false;
    }
    return typeConfig.matchesTypes.some(
      (t) => dataTransferTypes.indexOf(t) > -1
    );
  })[0] || null;
}
const isFirefox = memoize(
  () => /firefox/i.test(navigator.userAgent)
);
const isSafari = memoize(
  () => Boolean(window.safari)
);
class MonotonicInterpolant {
  interpolate(x) {
    const { xs, ys, c1s, c2s, c3s } = this;
    let i = xs.length - 1;
    if (x === xs[i]) {
      return ys[i];
    }
    let low = 0;
    let high = c3s.length - 1;
    let mid;
    while (low <= high) {
      mid = Math.floor(0.5 * (low + high));
      const xHere = xs[mid];
      if (xHere < x) {
        low = mid + 1;
      } else if (xHere > x) {
        high = mid - 1;
      } else {
        return ys[mid];
      }
    }
    i = Math.max(0, high);
    const diff = x - xs[i];
    const diffSq = diff * diff;
    return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
  }
  constructor(xs, ys) {
    const { length } = xs;
    const indexes = [];
    for (let i = 0; i < length; i++) {
      indexes.push(i);
    }
    indexes.sort(
      (a, b) => xs[a] < xs[b] ? -1 : 1
    );
    const dxs = [];
    const ms = [];
    let dx;
    let dy;
    for (let i1 = 0; i1 < length - 1; i1++) {
      dx = xs[i1 + 1] - xs[i1];
      dy = ys[i1 + 1] - ys[i1];
      dxs.push(dx);
      ms.push(dy / dx);
    }
    const c1s = [
      ms[0]
    ];
    for (let i2 = 0; i2 < dxs.length - 1; i2++) {
      const m2 = ms[i2];
      const mNext = ms[i2 + 1];
      if (m2 * mNext <= 0) {
        c1s.push(0);
      } else {
        dx = dxs[i2];
        const dxNext = dxs[i2 + 1];
        const common = dx + dxNext;
        c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
      }
    }
    c1s.push(ms[ms.length - 1]);
    const c2s = [];
    const c3s = [];
    let m;
    for (let i3 = 0; i3 < c1s.length - 1; i3++) {
      m = ms[i3];
      const c1 = c1s[i3];
      const invDx = 1 / dxs[i3];
      const common = c1 + c1s[i3 + 1] - m - m;
      c2s.push((m - c1 - common) * invDx);
      c3s.push(common * invDx * invDx);
    }
    this.xs = xs;
    this.ys = ys;
    this.c1s = c1s;
    this.c2s = c2s;
    this.c3s = c3s;
  }
}
const ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
  const el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
  if (!el) {
    return null;
  }
  const { top, left } = el.getBoundingClientRect();
  return {
    x: left,
    y: top
  };
}
function getEventClientOffset(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function isImageNode(node) {
  var ref;
  return node.nodeName === "IMG" && (isFirefox() || !((ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.contains(node)));
}
function getDragPreviewSize(isImage2, dragPreview, sourceWidth, sourceHeight) {
  let dragPreviewWidth = isImage2 ? dragPreview.width : sourceWidth;
  let dragPreviewHeight = isImage2 ? dragPreview.height : sourceHeight;
  if (isSafari() && isImage2) {
    dragPreviewHeight /= window.devicePixelRatio;
    dragPreviewWidth /= window.devicePixelRatio;
  }
  return {
    dragPreviewWidth,
    dragPreviewHeight
  };
}
function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
  const isImage2 = isImageNode(dragPreview);
  const dragPreviewNode = isImage2 ? sourceNode : dragPreview;
  const dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
  const offsetFromDragPreview = {
    x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
    y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
  };
  const { offsetWidth: sourceWidth, offsetHeight: sourceHeight } = sourceNode;
  const { anchorX, anchorY } = anchorPoint;
  const { dragPreviewWidth, dragPreviewHeight } = getDragPreviewSize(isImage2, dragPreview, sourceWidth, sourceHeight);
  const calculateYOffset = () => {
    const interpolantY = new MonotonicInterpolant([
      0,
      0.5,
      1
    ], [
      // Dock to the top
      offsetFromDragPreview.y,
      // Align at the center
      offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
      // Dock to the bottom
      offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
    ]);
    let y = interpolantY.interpolate(anchorY);
    if (isSafari() && isImage2) {
      y += (window.devicePixelRatio - 1) * dragPreviewHeight;
    }
    return y;
  };
  const calculateXOffset = () => {
    const interpolantX = new MonotonicInterpolant([
      0,
      0.5,
      1
    ], [
      // Dock to the left
      offsetFromDragPreview.x,
      // Align at the center
      offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
      // Dock to the right
      offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
    ]);
    return interpolantX.interpolate(anchorX);
  };
  const { offsetX, offsetY } = offsetPoint;
  const isManualOffsetX = offsetX === 0 || offsetX;
  const isManualOffsetY = offsetY === 0 || offsetY;
  return {
    x: isManualOffsetX ? offsetX : calculateXOffset(),
    y: isManualOffsetY ? offsetY : calculateYOffset()
  };
}
class OptionsReader {
  get window() {
    if (this.globalContext) {
      return this.globalContext;
    } else if (typeof window !== "undefined") {
      return window;
    }
    return void 0;
  }
  get document() {
    var ref;
    if ((ref = this.globalContext) === null || ref === void 0 ? void 0 : ref.document) {
      return this.globalContext.document;
    } else if (this.window) {
      return this.window.document;
    } else {
      return void 0;
    }
  }
  get rootElement() {
    var ref;
    return ((ref = this.optionsArgs) === null || ref === void 0 ? void 0 : ref.rootElement) || this.window;
  }
  constructor(globalContext, options2) {
    this.ownerDocument = null;
    this.globalContext = globalContext;
    this.optionsArgs = options2;
  }
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function(key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
class HTML5BackendImpl {
  /**
  * Generate profiling statistics for the HTML5Backend.
  */
  profile() {
    var ref, ref1;
    return {
      sourcePreviewNodes: this.sourcePreviewNodes.size,
      sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
      sourceNodeOptions: this.sourceNodeOptions.size,
      sourceNodes: this.sourceNodes.size,
      dragStartSourceIds: ((ref = this.dragStartSourceIds) === null || ref === void 0 ? void 0 : ref.length) || 0,
      dropTargetIds: this.dropTargetIds.length,
      dragEnterTargetIds: this.dragEnterTargetIds.length,
      dragOverTargetIds: ((ref1 = this.dragOverTargetIds) === null || ref1 === void 0 ? void 0 : ref1.length) || 0
    };
  }
  // public for test
  get window() {
    return this.options.window;
  }
  get document() {
    return this.options.document;
  }
  /**
  * Get the root element to use for event subscriptions
  */
  get rootElement() {
    return this.options.rootElement;
  }
  setup() {
    const root = this.rootElement;
    if (root === void 0) {
      return;
    }
    if (root.__isReactDndBackendSetUp) {
      throw new Error("Cannot have two HTML5 backends at the same time.");
    }
    root.__isReactDndBackendSetUp = true;
    this.addEventListeners(root);
  }
  teardown() {
    const root = this.rootElement;
    if (root === void 0) {
      return;
    }
    root.__isReactDndBackendSetUp = false;
    this.removeEventListeners(this.rootElement);
    this.clearCurrentDragSourceNode();
    if (this.asyncEndDragFrameId) {
      var ref;
      (ref = this.window) === null || ref === void 0 ? void 0 : ref.cancelAnimationFrame(this.asyncEndDragFrameId);
    }
  }
  connectDragPreview(sourceId, node, options2) {
    this.sourcePreviewNodeOptions.set(sourceId, options2);
    this.sourcePreviewNodes.set(sourceId, node);
    return () => {
      this.sourcePreviewNodes.delete(sourceId);
      this.sourcePreviewNodeOptions.delete(sourceId);
    };
  }
  connectDragSource(sourceId, node, options2) {
    this.sourceNodes.set(sourceId, node);
    this.sourceNodeOptions.set(sourceId, options2);
    const handleDragStart = (e) => this.handleDragStart(e, sourceId);
    const handleSelectStart = (e) => this.handleSelectStart(e);
    node.setAttribute("draggable", "true");
    node.addEventListener("dragstart", handleDragStart);
    node.addEventListener("selectstart", handleSelectStart);
    return () => {
      this.sourceNodes.delete(sourceId);
      this.sourceNodeOptions.delete(sourceId);
      node.removeEventListener("dragstart", handleDragStart);
      node.removeEventListener("selectstart", handleSelectStart);
      node.setAttribute("draggable", "false");
    };
  }
  connectDropTarget(targetId, node) {
    const handleDragEnter = (e) => this.handleDragEnter(e, targetId);
    const handleDragOver = (e) => this.handleDragOver(e, targetId);
    const handleDrop = (e) => this.handleDrop(e, targetId);
    node.addEventListener("dragenter", handleDragEnter);
    node.addEventListener("dragover", handleDragOver);
    node.addEventListener("drop", handleDrop);
    return () => {
      node.removeEventListener("dragenter", handleDragEnter);
      node.removeEventListener("dragover", handleDragOver);
      node.removeEventListener("drop", handleDrop);
    };
  }
  addEventListeners(target) {
    if (!target.addEventListener) {
      return;
    }
    target.addEventListener("dragstart", this.handleTopDragStart);
    target.addEventListener("dragstart", this.handleTopDragStartCapture, true);
    target.addEventListener("dragend", this.handleTopDragEndCapture, true);
    target.addEventListener("dragenter", this.handleTopDragEnter);
    target.addEventListener("dragenter", this.handleTopDragEnterCapture, true);
    target.addEventListener("dragleave", this.handleTopDragLeaveCapture, true);
    target.addEventListener("dragover", this.handleTopDragOver);
    target.addEventListener("dragover", this.handleTopDragOverCapture, true);
    target.addEventListener("drop", this.handleTopDrop);
    target.addEventListener("drop", this.handleTopDropCapture, true);
  }
  removeEventListeners(target) {
    if (!target.removeEventListener) {
      return;
    }
    target.removeEventListener("dragstart", this.handleTopDragStart);
    target.removeEventListener("dragstart", this.handleTopDragStartCapture, true);
    target.removeEventListener("dragend", this.handleTopDragEndCapture, true);
    target.removeEventListener("dragenter", this.handleTopDragEnter);
    target.removeEventListener("dragenter", this.handleTopDragEnterCapture, true);
    target.removeEventListener("dragleave", this.handleTopDragLeaveCapture, true);
    target.removeEventListener("dragover", this.handleTopDragOver);
    target.removeEventListener("dragover", this.handleTopDragOverCapture, true);
    target.removeEventListener("drop", this.handleTopDrop);
    target.removeEventListener("drop", this.handleTopDropCapture, true);
  }
  getCurrentSourceNodeOptions() {
    const sourceId = this.monitor.getSourceId();
    const sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
    return _objectSpread({
      dropEffect: this.altKeyPressed ? "copy" : "move"
    }, sourceNodeOptions || {});
  }
  getCurrentDropEffect() {
    if (this.isDraggingNativeItem()) {
      return "copy";
    }
    return this.getCurrentSourceNodeOptions().dropEffect;
  }
  getCurrentSourcePreviewNodeOptions() {
    const sourceId = this.monitor.getSourceId();
    const sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
    return _objectSpread({
      anchorX: 0.5,
      anchorY: 0.5,
      captureDraggingState: false
    }, sourcePreviewNodeOptions || {});
  }
  isDraggingNativeItem() {
    const itemType = this.monitor.getItemType();
    return Object.keys(NativeTypes).some(
      (key) => NativeTypes[key] === itemType
    );
  }
  beginDragNativeItem(type, dataTransfer) {
    this.clearCurrentDragSourceNode();
    this.currentNativeSource = createNativeDragSource(type, dataTransfer);
    this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
    this.actions.beginDrag([
      this.currentNativeHandle
    ]);
  }
  setCurrentDragSourceNode(node) {
    this.clearCurrentDragSourceNode();
    this.currentDragSourceNode = node;
    const MOUSE_MOVE_TIMEOUT = 1e3;
    this.mouseMoveTimeoutTimer = setTimeout(() => {
      var ref;
      return (ref = this.rootElement) === null || ref === void 0 ? void 0 : ref.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
    }, MOUSE_MOVE_TIMEOUT);
  }
  clearCurrentDragSourceNode() {
    if (this.currentDragSourceNode) {
      this.currentDragSourceNode = null;
      if (this.rootElement) {
        var ref;
        (ref = this.window) === null || ref === void 0 ? void 0 : ref.clearTimeout(this.mouseMoveTimeoutTimer || void 0);
        this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
      }
      this.mouseMoveTimeoutTimer = null;
      return true;
    }
    return false;
  }
  handleDragStart(e, sourceId) {
    if (e.defaultPrevented) {
      return;
    }
    if (!this.dragStartSourceIds) {
      this.dragStartSourceIds = [];
    }
    this.dragStartSourceIds.unshift(sourceId);
  }
  handleDragEnter(_e, targetId) {
    this.dragEnterTargetIds.unshift(targetId);
  }
  handleDragOver(_e, targetId) {
    if (this.dragOverTargetIds === null) {
      this.dragOverTargetIds = [];
    }
    this.dragOverTargetIds.unshift(targetId);
  }
  handleDrop(_e, targetId) {
    this.dropTargetIds.unshift(targetId);
  }
  constructor(manager, globalContext, options2) {
    this.sourcePreviewNodes = /* @__PURE__ */ new Map();
    this.sourcePreviewNodeOptions = /* @__PURE__ */ new Map();
    this.sourceNodes = /* @__PURE__ */ new Map();
    this.sourceNodeOptions = /* @__PURE__ */ new Map();
    this.dragStartSourceIds = null;
    this.dropTargetIds = [];
    this.dragEnterTargetIds = [];
    this.currentNativeSource = null;
    this.currentNativeHandle = null;
    this.currentDragSourceNode = null;
    this.altKeyPressed = false;
    this.mouseMoveTimeoutTimer = null;
    this.asyncEndDragFrameId = null;
    this.dragOverTargetIds = null;
    this.lastClientOffset = null;
    this.hoverRafId = null;
    this.getSourceClientOffset = (sourceId) => {
      const source = this.sourceNodes.get(sourceId);
      return source && getNodeClientOffset(source) || null;
    };
    this.endDragNativeItem = () => {
      if (!this.isDraggingNativeItem()) {
        return;
      }
      this.actions.endDrag();
      if (this.currentNativeHandle) {
        this.registry.removeSource(this.currentNativeHandle);
      }
      this.currentNativeHandle = null;
      this.currentNativeSource = null;
    };
    this.isNodeInDocument = (node) => {
      return Boolean(node && this.document && this.document.body && this.document.body.contains(node));
    };
    this.endDragIfSourceWasRemovedFromDOM = () => {
      const node = this.currentDragSourceNode;
      if (node == null || this.isNodeInDocument(node)) {
        return;
      }
      if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) {
        this.actions.endDrag();
      }
      this.cancelHover();
    };
    this.scheduleHover = (dragOverTargetIds) => {
      if (this.hoverRafId === null && typeof requestAnimationFrame !== "undefined") {
        this.hoverRafId = requestAnimationFrame(() => {
          if (this.monitor.isDragging()) {
            this.actions.hover(dragOverTargetIds || [], {
              clientOffset: this.lastClientOffset
            });
          }
          this.hoverRafId = null;
        });
      }
    };
    this.cancelHover = () => {
      if (this.hoverRafId !== null && typeof cancelAnimationFrame !== "undefined") {
        cancelAnimationFrame(this.hoverRafId);
        this.hoverRafId = null;
      }
    };
    this.handleTopDragStartCapture = () => {
      this.clearCurrentDragSourceNode();
      this.dragStartSourceIds = [];
    };
    this.handleTopDragStart = (e) => {
      if (e.defaultPrevented) {
        return;
      }
      const { dragStartSourceIds } = this;
      this.dragStartSourceIds = null;
      const clientOffset = getEventClientOffset(e);
      if (this.monitor.isDragging()) {
        this.actions.endDrag();
        this.cancelHover();
      }
      this.actions.beginDrag(dragStartSourceIds || [], {
        publishSource: false,
        getSourceClientOffset: this.getSourceClientOffset,
        clientOffset
      });
      const { dataTransfer } = e;
      const nativeType = matchNativeItemType(dataTransfer);
      if (this.monitor.isDragging()) {
        if (dataTransfer && typeof dataTransfer.setDragImage === "function") {
          const sourceId = this.monitor.getSourceId();
          const sourceNode = this.sourceNodes.get(sourceId);
          const dragPreview = this.sourcePreviewNodes.get(sourceId) || sourceNode;
          if (dragPreview) {
            const { anchorX, anchorY, offsetX, offsetY } = this.getCurrentSourcePreviewNodeOptions();
            const anchorPoint = {
              anchorX,
              anchorY
            };
            const offsetPoint = {
              offsetX,
              offsetY
            };
            const dragPreviewOffset = getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
            dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
          }
        }
        try {
          dataTransfer === null || dataTransfer === void 0 ? void 0 : dataTransfer.setData("application/json", {});
        } catch (err) {
        }
        this.setCurrentDragSourceNode(e.target);
        const { captureDraggingState } = this.getCurrentSourcePreviewNodeOptions();
        if (!captureDraggingState) {
          setTimeout(
            () => this.actions.publishDragSource(),
            0
          );
        } else {
          this.actions.publishDragSource();
        }
      } else if (nativeType) {
        this.beginDragNativeItem(nativeType);
      } else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute("draggable"))) {
        return;
      } else {
        e.preventDefault();
      }
    };
    this.handleTopDragEndCapture = () => {
      if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) {
        this.actions.endDrag();
      }
      this.cancelHover();
    };
    this.handleTopDragEnterCapture = (e) => {
      this.dragEnterTargetIds = [];
      if (this.isDraggingNativeItem()) {
        var ref;
        (ref = this.currentNativeSource) === null || ref === void 0 ? void 0 : ref.loadDataTransfer(e.dataTransfer);
      }
      const isFirstEnter = this.enterLeaveCounter.enter(e.target);
      if (!isFirstEnter || this.monitor.isDragging()) {
        return;
      }
      const { dataTransfer } = e;
      const nativeType = matchNativeItemType(dataTransfer);
      if (nativeType) {
        this.beginDragNativeItem(nativeType, dataTransfer);
      }
    };
    this.handleTopDragEnter = (e) => {
      const { dragEnterTargetIds } = this;
      this.dragEnterTargetIds = [];
      if (!this.monitor.isDragging()) {
        return;
      }
      this.altKeyPressed = e.altKey;
      if (dragEnterTargetIds.length > 0) {
        this.actions.hover(dragEnterTargetIds, {
          clientOffset: getEventClientOffset(e)
        });
      }
      const canDrop = dragEnterTargetIds.some(
        (targetId) => this.monitor.canDropOnTarget(targetId)
      );
      if (canDrop) {
        e.preventDefault();
        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = this.getCurrentDropEffect();
        }
      }
    };
    this.handleTopDragOverCapture = (e) => {
      this.dragOverTargetIds = [];
      if (this.isDraggingNativeItem()) {
        var ref;
        (ref = this.currentNativeSource) === null || ref === void 0 ? void 0 : ref.loadDataTransfer(e.dataTransfer);
      }
    };
    this.handleTopDragOver = (e) => {
      const { dragOverTargetIds } = this;
      this.dragOverTargetIds = [];
      if (!this.monitor.isDragging()) {
        e.preventDefault();
        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = "none";
        }
        return;
      }
      this.altKeyPressed = e.altKey;
      this.lastClientOffset = getEventClientOffset(e);
      this.scheduleHover(dragOverTargetIds);
      const canDrop = (dragOverTargetIds || []).some(
        (targetId) => this.monitor.canDropOnTarget(targetId)
      );
      if (canDrop) {
        e.preventDefault();
        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = this.getCurrentDropEffect();
        }
      } else if (this.isDraggingNativeItem()) {
        e.preventDefault();
      } else {
        e.preventDefault();
        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = "none";
        }
      }
    };
    this.handleTopDragLeaveCapture = (e) => {
      if (this.isDraggingNativeItem()) {
        e.preventDefault();
      }
      const isLastLeave = this.enterLeaveCounter.leave(e.target);
      if (!isLastLeave) {
        return;
      }
      if (this.isDraggingNativeItem()) {
        setTimeout(
          () => this.endDragNativeItem(),
          0
        );
      }
      this.cancelHover();
    };
    this.handleTopDropCapture = (e) => {
      this.dropTargetIds = [];
      if (this.isDraggingNativeItem()) {
        var ref;
        e.preventDefault();
        (ref = this.currentNativeSource) === null || ref === void 0 ? void 0 : ref.loadDataTransfer(e.dataTransfer);
      } else if (matchNativeItemType(e.dataTransfer)) {
        e.preventDefault();
      }
      this.enterLeaveCounter.reset();
    };
    this.handleTopDrop = (e) => {
      const { dropTargetIds } = this;
      this.dropTargetIds = [];
      this.actions.hover(dropTargetIds, {
        clientOffset: getEventClientOffset(e)
      });
      this.actions.drop({
        dropEffect: this.getCurrentDropEffect()
      });
      if (this.isDraggingNativeItem()) {
        this.endDragNativeItem();
      } else if (this.monitor.isDragging()) {
        this.actions.endDrag();
      }
      this.cancelHover();
    };
    this.handleSelectStart = (e) => {
      const target = e.target;
      if (typeof target.dragDrop !== "function") {
        return;
      }
      if (target.tagName === "INPUT" || target.tagName === "SELECT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
        return;
      }
      e.preventDefault();
      target.dragDrop();
    };
    this.options = new OptionsReader(globalContext, options2);
    this.actions = manager.getActions();
    this.monitor = manager.getMonitor();
    this.registry = manager.getRegistry();
    this.enterLeaveCounter = new EnterLeaveCounter(this.isNodeInDocument);
  }
}
const HTML5Backend = function createBackend(manager, context, options2) {
  return new HTML5BackendImpl(manager, context, options2);
};
const iconClasses = "mb-0.5 ml-1 h-4 w-4 inline fill-current";
function sortMenu(canSort, sortDirection, header, canHide, setVisible) {
  const options2 = [];
  if (canSort) {
    const sort = (sortMode) => {
      setVisible(false);
      if (sortMode === "clear") header.column.clearSorting();
      else header.column.toggleSorting(sortMode === "desc");
    };
    if (sortDirection === "desc" || sortDirection === false) {
      options2.push(/* @__PURE__ */ jsx("button", {
        className: "table-action-item",
        onClick: () => sort("asc"),
        children: "Sort ascending"
      }, "sort_asc"));
    }
    if (sortDirection === "asc" || sortDirection === false) {
      options2.push(/* @__PURE__ */ jsx("button", {
        className: "table-action-item",
        onClick: () => sort("desc"),
        children: "Sort descending"
      }, "sort_desc"));
    }
    if (sortDirection !== false) {
      options2.push(/* @__PURE__ */ jsx("button", {
        className: "table-action-item",
        onClick: () => sort("clear"),
        children: "Clear sort"
      }, "clear_sort"));
    }
  }
  if (canHide) {
    options2.push(/* @__PURE__ */ jsx("button", {
      className: "table-action-item",
      onClick: () => {
        setVisible(false);
        header.column.toggleVisibility();
      },
      children: "Hide field"
    }, "hide_field"));
  }
  return options2;
}
const SortColumnContent = ({
  header
}) => {
  const canSort = header.column.getCanSort();
  const canHide = header.column.getCanHide();
  const sortDirection = header.column.getIsSorted();
  const [visible, setVisible] = useState(false);
  const menu = useMemo(() => sortMenu(canSort, sortDirection, header, canHide, setVisible), [canHide, canSort, header, sortDirection]);
  return /* @__PURE__ */ jsx(Popover, {
    open: visible,
    onOpenChange: setVisible,
    content: /* @__PURE__ */ jsx("div", {
      className: "table-action-container",
      children: menu
    }),
    showArrow: false,
    arrowPointAtCenter: false,
    placement: "bottom-end",
    innerContentClassName: "text-sm",
    offsetOptions: {
      crossAxis: 1,
      mainAxis: 0
    },
    children: /* @__PURE__ */ jsxs("div", {
      className: "group/th header-th-content flex",
      children: [/* @__PURE__ */ jsxs("div", {
        className: "flex flex-1",
        children: [/* @__PURE__ */ jsx(CellContent, {
          header
        }), /* @__PURE__ */ jsx("div", {
          className: "w-2",
          children: sortDirection !== false && (sortDirection == "asc" ? /* @__PURE__ */ jsx(SvgArrowUp, {
            className: iconClasses
          }) : /* @__PURE__ */ jsx(SvgArrowDown, {
            className: iconClasses
          }))
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: "invisible inline w-2 pl-4 pr-2 pt-1 group-hover/th:visible",
        children: SvgEllipsisVertical({
          className: "h-4 w-4",
          title: "EllipsisVertical"
        })
      })]
    })
  });
};
const CellContent = ({
  header
}) => {
  return /* @__PURE__ */ jsx(Fragment, {
    children: header.isPlaceholder ? void 0 : flexRender(header.column.columnDef.header, header.getContext())
  });
};
const Cell = ({
  header,
  index: index2,
  dragProps
}) => {
  var _a;
  const {
    stickyColumns
  } = useTable();
  let classes2 = (stickyColumns == null ? void 0 : stickyColumns.includes(header.column.id)) ? " header-th-sticky" : " header-th";
  if ((_a = header.column.columnDef.meta) == null ? void 0 : _a.classes) {
    classes2 += " " + header.column.columnDef.meta.classes;
  }
  const styles2 = getStickyStyles(header.column);
  const canSort = header.column.getCanSort();
  const canHide = header.column.getCanHide();
  const sortDirection = header.column.getIsSorted();
  return /* @__PURE__ */ jsx("th", {
    style: {
      opacity: (dragProps == null ? void 0 : dragProps.isDragging) ? 0.5 : 1,
      ...styles2
    },
    ref: dragProps == null ? void 0 : dragProps.dropRef,
    scope: "col",
    className: classes2,
    children: /* @__PURE__ */ jsxs("div", {
      className: "flex",
      ref: dragProps == null ? void 0 : dragProps.previewRef,
      children: [/* @__PURE__ */ jsx("div", {
        className: `table-cell-text flex flex-1 flex-col ${sortDirection ? "text-jungle-800" : "text-gray-900"}`,
        children: canSort || canHide ? /* @__PURE__ */ jsx(SortColumnContent, {
          header
        }) : /* @__PURE__ */ jsx("div", {
          className: "header-th-content flex",
          children: /* @__PURE__ */ jsx(CellContent, {
            header
          })
        })
      }), dragProps && /* @__PURE__ */ jsx("button", {
        className: "pr-2",
        ref: dragProps == null ? void 0 : dragProps.dragRef,
        children: "🟰"
      })]
    })
  }, `${header.column.id}_${index2}`);
};
const reorderColumn = (draggedColumnId, targetColumnId, columnOrder) => {
  columnOrder.splice(columnOrder.indexOf(targetColumnId), 0, columnOrder.splice(columnOrder.indexOf(draggedColumnId), 1)[0]);
  return [...columnOrder];
};
const DraggableColumnHeader = ({
  table,
  header,
  index: index2
}) => {
  const [, dropRef] = useDrop({
    accept: "column",
    drop: (draggedColumn) => {
      const newColumnOrder = reorderColumn(draggedColumn.id, header.column.id, (table == null ? void 0 : table.getVisibleLeafColumns().map((col) => col.id)) || []);
      table == null ? void 0 : table.setColumnOrder(newColumnOrder);
    }
  });
  const [{
    isDragging
  }, dragRef, previewRef] = useDrag({
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    }),
    item: () => header.column,
    type: "column"
  });
  return /* @__PURE__ */ jsx(Cell, {
    header,
    index: index2,
    dragProps: {
      dropRef,
      dragRef,
      previewRef,
      isDragging
    }
  });
};
const Header = () => {
  const {
    table,
    stickyColumns,
    enableColumnOrdering
  } = useTable();
  const canOrderHeader = useCallback((header) => enableColumnOrdering && !(stickyColumns == null ? void 0 : stickyColumns.includes(header.column.id)), [enableColumnOrdering, stickyColumns]);
  return /* @__PURE__ */ jsx(DndProvider, {
    backend: HTML5Backend,
    children: /* @__PURE__ */ jsx("thead", {
      children: table == null ? void 0 : table.getHeaderGroups().map((headerGroup) => /* @__PURE__ */ jsx("tr", {
        className: "header-tr",
        children: headerGroup.headers.map((header, index2) => {
          return canOrderHeader(header) ? /* @__PURE__ */ jsx(DraggableColumnHeader, {
            table,
            header,
            index: index2
          }, `${header.id}_dnd`) : /* @__PURE__ */ jsx(Cell, {
            header,
            index: index2
          }, `${header.id}_plain_cell`);
        })
      }, `header_${headerGroup.id}`))
    })
  });
};
const Pagination = () => {
  const {
    table,
    totalRowCount,
    isLoading
  } = useTable();
  const {
    pagination = {
      pageIndex: 0,
      pageSize: 100
    },
    grouping = []
  } = (table == null ? void 0 : table.getState()) ?? {};
  return /* @__PURE__ */ jsx(TablePagination, {
    isLoading,
    page: pagination.pageIndex + 1,
    pageSize: pagination.pageSize,
    onPageChange: (page, size) => {
      table == null ? void 0 : table.setPagination({
        pageIndex: page - 1,
        pageSize: size
      });
    },
    count: totalRowCount ?? ((table == null ? void 0 : table.getPageCount()) ?? 1) * pagination.pageSize,
    itemText: grouping.length > 0 ? "groups" : "items"
  });
};
const tableClasses = "w-full border-separate whitespace-nowrap border-spacing-0";
const wrapperClasses = "flex-1 overflow-x-auto";
const containerClasses = "flex flex-col overflow-scroll";
const Fallback = () => /* @__PURE__ */ jsx("div", {
  className: "flex min-h-screen flex-row items-center justify-center",
  children: /* @__PURE__ */ jsx(FormHelperText, {
    type: "error",
    display: "Something went wrong",
    visible: true
  })
});
function TableContent(props) {
  const {
    height,
    enablePagination
  } = props;
  const {
    tableContainerRef
  } = useTable();
  return /* @__PURE__ */ jsxs("div", {
    className: containerClasses,
    style: {
      height
    },
    children: [/* @__PURE__ */ jsx("div", {
      ref: tableContainerRef,
      className: wrapperClasses,
      children: /* @__PURE__ */ jsx("table", {
        className: tableClasses,
        children: /* @__PURE__ */ jsxs(ErrorBoundary, {
          fallbackRender: Fallback,
          children: [/* @__PURE__ */ jsx(Header, {}), /* @__PURE__ */ jsx(Body, {})]
        })
      })
    }), enablePagination && /* @__PURE__ */ jsx("div", {
      children: /* @__PURE__ */ jsx(Pagination, {})
    })]
  });
}
function TableV2({
  stickyColumns,
  enableColumnOrdering,
  totalRowCount,
  isLoading,
  enableRowVirtualization = {
    minRows: 200
  },
  estimateRowHeight,
  onRowSelect,
  onRowDeselect,
  groupBy: groupBy2,
  hideGroupByColumn,
  getCoreRowModel: getCoreRowModel$1 = getCoreRowModel(),
  getSortedRowModel: getSortedRowModel$1 = getSortedRowModel(),
  ...tableOptions
}) {
  return /* @__PURE__ */ jsx(TableStateProvider, {
    stickyColumns,
    options: {
      ...tableOptions,
      getCoreRowModel: getCoreRowModel$1,
      getSortedRowModel: getSortedRowModel$1
    },
    enableColumnOrdering,
    totalRowCount,
    isLoading,
    enableRowVirtualization,
    estimateRowHeight,
    onRowSelect,
    onRowDeselect,
    groupBy: groupBy2,
    hideGroupByColumn,
    children: /* @__PURE__ */ jsx(TableContent, {
      enablePagination: tableOptions.enablePagination,
      height: tableOptions.height
    })
  });
}
const TableSubviewStateContext = createContext(void 0);
const TableSubviewStateProvider = (props) => {
  const {
    children,
    onSelectionChanged
  } = props;
  const [selectedId, setSelectedId] = useState(props.selectedId);
  const value = useMemo(() => {
    return {
      selectedId,
      onSelectionChanged: (id) => {
        setSelectedId(id);
        onSelectionChanged(id);
      }
    };
  }, [selectedId, onSelectionChanged]);
  return /* @__PURE__ */ jsx(TableSubviewStateContext.Provider, {
    value,
    children
  });
};
const useTableSubviewState = () => {
  const context = useContext(TableSubviewStateContext);
  if (context === void 0) {
    throw new Error("useTableSubviewState must be within TableSubviewStateProvider");
  }
  return context;
};
const TableSubview = (props) => {
  const {
    children,
    defaultSelection,
    className,
    onSelect
  } = props;
  return /* @__PURE__ */ jsx(TableSubviewStateProvider, {
    selectedId: defaultSelection,
    onSelectionChanged: onSelect,
    children: /* @__PURE__ */ jsx("div", {
      className: `flex basis-0 gap-2 ${className}`,
      children
    })
  });
};
const baseStyles = {
  button: "px-4 py-2 border-t border-x border-b-2 rounded-lg grow shrink w-0",
  text: "text-left font-semibold text-sm text-clip whitespace-nowrap fill-current",
  quantity: {
    container: "text-left mt-1",
    number: "text-md font-medium",
    unit: "text-sm"
  }
};
const selectedStyles = {
  button: `${baseStyles.button} bg-jungle-50 border-primary`,
  text: `${baseStyles.text} text-jungle-800`,
  quantity: {
    container: `${baseStyles.quantity.container}`,
    number: `${baseStyles.quantity.number} text-jungle-900`,
    unit: `${baseStyles.quantity.unit} text-primary`
  }
};
const unselectedStyles = {
  button: `${baseStyles.button} bg-white border-transparent hover:bg-gray-50`,
  text: `${baseStyles.text} text-gray-800`,
  quantity: {
    container: `${baseStyles.quantity.container}`,
    number: `${baseStyles.quantity.number} text-gray-900`,
    unit: `${baseStyles.quantity.unit} text-gray-700`
  }
};
const formatQuantity = (quantity, quantityType) => {
  const options2 = quantityType === "currency" ? {
    style: "currency",
    currency: "USD",
    notation: "compact"
  } : {};
  return /* @__PURE__ */ jsx(FormattedNumber, {
    ...options2,
    children: quantity
  });
};
const TableSubviewButton = (props) => {
  const {
    id,
    text: text2,
    description,
    quantity,
    unitOfMeasure,
    quantityType = "unit",
    quantityTextOverride
  } = props;
  const {
    selectedId,
    onSelectionChanged
  } = useTableSubviewState();
  const styles2 = selectedId === id ? selectedStyles : unselectedStyles;
  const formatted = quantityTextOverride ?? formatQuantity(quantity, quantityType);
  return /* @__PURE__ */ jsxs("button", {
    className: styles2.button,
    onClick: () => onSelectionChanged(id),
    children: [/* @__PURE__ */ jsxs("div", {
      className: styles2.text,
      children: [text2, " ", /* @__PURE__ */ jsx(Popover, {
        placement: "top",
        trigger: "hover",
        offsetOptions: {
          mainAxis: 5,
          crossAxis: 6
        },
        arrowPointAtCenter: true,
        content: /* @__PURE__ */ jsx("div", {
          className: "w-72",
          children: description
        }),
        children: /* @__PURE__ */ jsx(SvgCircleInfo, {
          className: "mb-px inline-block size-4"
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: styles2.quantity.container,
      children: [/* @__PURE__ */ jsx("span", {
        className: styles2.quantity.number,
        children: formatted
      }), /* @__PURE__ */ jsxs("span", {
        className: styles2.quantity.unit,
        children: [" ", unitOfMeasure]
      })]
    })]
  });
};
const style = {
  container: "flex flex-col shadow rounded overflow-hidden inline-block relative"
};
const itemStyles = {
  base: "box-border cursor-pointer leading-6 px-2 py-1 border border-1 border-solid hover:bg-gray-50 hover:border-gray-100",
  unselected: "border-white bg-white focus:bg-white focus:border-gray-900",
  selected: "bg-gray-50 border-gray-50"
};
const TagMenuItem = (props) => {
  const {
    item,
    onSelect
  } = props;
  const defaultSelected = Boolean(item == null ? void 0 : item.isSelected);
  const [isSelected, setIsSelected] = useState(defaultSelected);
  const ref = useRef(null);
  const itemValue = JSON.stringify(item);
  useEffect(() => {
    setIsSelected(defaultSelected);
  }, [itemValue, defaultSelected]);
  const onClick = useCallback((e) => {
    onSelect(item);
    setIsSelected((curr) => !curr);
    e.stopPropagation();
  }, [item, onSelect]);
  return /* @__PURE__ */ jsx("div", {
    role: "menuitem",
    tabIndex: 0,
    ref,
    onClick,
    className: addStyles([itemStyles.base, itemStyles[isSelected ? "selected" : "unselected"]]),
    children: /* @__PURE__ */ jsx("span", {
      className: "select-none",
      children: /* @__PURE__ */ jsx(Tag, {
        onClick,
        ...item.tag
      })
    })
  });
};
const TagMenu = (props) => {
  const {
    options: options2,
    onSelect,
    selected,
    width,
    containerClassName
  } = props;
  const menuItems = useMemo(() => {
    return options2.map((option) => {
      const isSelected = selected === option.value;
      return {
        ...option,
        isSelected,
        label: option.tag.text
      };
    });
  }, [options2, selected]);
  return /* @__PURE__ */ jsx("div", {
    className: containerClassName ?? style.container,
    style: {
      width,
      maxWidth: width
    },
    children: menuItems.map((item) => /* @__PURE__ */ jsx(TagMenuItem, {
      item,
      onSelect
    }, item.value))
  });
};
const TextAreaStyles = {
  default: "border rounded-t-lg rounded-bl-lg rounded-br-sm bg-white text-gray-900 resize max-w-full",
  hover: "hover:border-jungle-500",
  focus: "focus:shadow-[0_0_4px_0_rgba(9,138,127,0.5)]",
  disabled: "disabled:bg-gray-100 disabled:text-gray-300",
  placeholder: "placeholder:text-gray-600",
  error: "border-red-600"
};
const TextAreaSizes = {
  default: 3,
  small: 2,
  xsmall: 1,
  medium: 5,
  large: 7
};
const TextArea = forwardRef(({
  size = "default",
  ...props
}, ref) => {
  const {
    onChange,
    disabled,
    placeholder,
    error,
    label,
    helperText,
    name,
    value,
    ...rest
  } = props;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col text-gray-900",
    children: [label ? /* @__PURE__ */ jsxs("label", {
      className: "flex flex-col pb-2",
      children: [/* @__PURE__ */ jsx("span", {
        className: "font-medium",
        children: label
      }), helperText && /* @__PURE__ */ jsx("span", {
        className: "text-xs",
        children: helperText
      })]
    }) : /* @__PURE__ */ jsx(Fragment, {}), /* @__PURE__ */ jsx("textarea", {
      ...rest,
      ref,
      value,
      className: addStyles([TextAreaStyles.default, error ? TextAreaStyles.error : "border-gray-300", TextAreaStyles.focus, TextAreaStyles.hover, TextAreaStyles.disabled, TextAreaStyles.placeholder]),
      onChange,
      disabled,
      placeholder,
      rows: TextAreaSizes[size],
      name
    }), error && /* @__PURE__ */ jsx("span", {
      className: "pt-1 text-red-600",
      children: error
    })]
  });
});
TextArea.displayName = "TextArea";
const styles = {
  default: {
    default: "font-medium text-primary underline-offset-4 decoration-current",
    hover: "hover:underline hover:text-jungle-800 hover:cursor-pointer",
    focus: "focus:outline-2 focus:outline-black focus:outline-offset-2"
  },
  popover: {
    default: "font-medium text-gray-900 underline decoration-dotted underline-offset-4 decoration-gray-600",
    hover: "hover:text-black hover:cursor-pointer",
    focus: "focus:outline-2 focus:outline-black focus:outline-offset-2"
  }
};
const sizes = {
  small: "text-xs leading-5",
  medium: "text-sm leading-6",
  large: "text-base leading-7"
};
const TextLink = (props) => {
  const {
    children,
    size = "small",
    className,
    tabIndex = 0,
    linkStyle = "default",
    ...rest
  } = props;
  const classes2 = useMemo(() => `${styles[linkStyle].default} ${sizes[size]} ${styles[linkStyle].hover} ${styles[linkStyle].focus} ${className}`, [className, size, linkStyle]);
  return /* @__PURE__ */ jsx("a", {
    ...rest,
    className: classes2,
    tabIndex,
    children
  });
};
const DefaultMenuIcon = (theme) => /* @__PURE__ */ jsx(SvgChevronDown, {
  className: `ml-2 h-auto w-6 ${theme === "dark" && "fill-white"} ${theme === "primary" && "fill-primary"}`
});
const DropdownMenu = (props) => {
  const {
    menuIcon,
    menuContent,
    buttonContent,
    width = "max-content",
    defaultOpen = false,
    theme = "light",
    position = "bottom-start",
    closeOnSelect = false
  } = props;
  const [visible, setVisible] = useState(defaultOpen);
  const iconToUse = menuIcon ?? DefaultMenuIcon(theme);
  return /* @__PURE__ */ jsx(Popover, {
    open: visible,
    showArrow: false,
    trigger: "click",
    placement: position,
    innerContentClassName: "",
    autoPlacementOptions: {
      allowedPlacements: ["top", "bottom"]
    },
    onOpenChange: (isOpen) => {
      setVisible(isOpen);
    },
    content: /* @__PURE__ */ jsx("div", {
      style: {
        width
      },
      onClick: () => {
        if (closeOnSelect) {
          setVisible(false);
        }
      },
      children: menuContent
    }),
    children: /* @__PURE__ */ jsxs("div", {
      className: addStyles(["inline-flex justify-between items-center hover:cursor-pointer", theme === "dark" ? "text-white" : void 0]),
      children: [/* @__PURE__ */ jsx("span", {
        className: `${theme === "primary" && "text-primary"}`,
        children: buttonContent
      }), iconToUse]
    })
  });
};
const CheckboxAccordion = (props) => {
  const {
    checkboxData,
    defaultOpen,
    ...checkboxProps
  } = props;
  const [open, setOpen] = useState(defaultOpen);
  const [boxes, setBoxes] = useState(checkboxData);
  const noneChecked = useMemo(() => boxes.every((box) => !box.isChecked), [boxes]);
  const allChecked = useMemo(() => boxes.every((box) => box.isChecked), [boxes]);
  const isPartiallyChecked = !noneChecked && !allChecked;
  useEffect(() => {
    setBoxes(checkboxData);
  }, [checkboxData]);
  const onMainCheckboxChange = (e) => {
    const checked = e.target.checked;
    setBoxes(updateBoxState(checked));
    checkboxProps.onCheckboxChange(checkboxProps.value, checked ? boxes.map((box) => {
      return box.value;
    }) : []);
  };
  const onCheckboxChange = (e) => {
    e.stopPropagation();
    setBoxes((curr) => {
      return curr.map((box) => {
        if (e.target.value !== box.value) return box;
        return {
          ...box,
          isChecked: e.target.checked
        };
      });
    });
    checkboxProps.onCheckboxChange(checkboxProps.value, boxes.filter((box) => {
      return box.isChecked ? e.target.value !== box.value : e.target.value === box.value;
    }).map((box) => box.value));
  };
  useEffect(() => {
    setOpen(!noneChecked);
  }, [noneChecked]);
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col",
    children: [/* @__PURE__ */ jsxs("div", {
      className: "flex cursor-pointer flex-row",
      children: [/* @__PURE__ */ jsx("div", {
        className: "flex-1",
        children: /* @__PURE__ */ jsx(Checkbox, {
          ...checkboxProps,
          isChecked: allChecked,
          isPartiallyChecked,
          onChange: onMainCheckboxChange
        })
      }), /* @__PURE__ */ jsx(SvgChevronDown, {
        onClick: () => {
          setOpen((curr) => !curr);
        },
        className: `max-h-6 max-w-6 transition-all ${open ? "rotate-180	" : "rotate-0"}`
      })]
    }), open && /* @__PURE__ */ jsx("div", {
      className: "ml-10 mt-4 space-y-4",
      children: boxes.map((props2, index2) => {
        return /* @__PURE__ */ jsx(Checkbox, {
          ...props2,
          hideLabel: false,
          onChange: onCheckboxChange
        }, index2);
      })
    })]
  });
};
CheckboxAccordion.displayName = "CheckboxAccordion";
const options = {
  listItem: {
    base: "flex space-x-2 items-center px-4 py-2 cursor-pointer border-r-4 hover:bg-jungle-50 hover:border-r-4 hover:border-primary",
    active: "bg-jungle-50 text-primary fill-primary border-r-4 border-primary",
    inactive: "border-white"
  }
};
const MenuList = (props) => {
  const {
    listItems,
    className = "w-full",
    handleClickItem,
    handleLoadMore
  } = props;
  const intersectionRef = useRef(null);
  useEffect(() => {
    if (!handleLoadMore) return;
    if (intersectionRef.current) {
      const element = intersectionRef.current;
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          handleLoadMore();
        }
      });
      observer.observe(element);
      return () => {
        observer.unobserve(element);
      };
    }
    return;
  }, [intersectionRef, handleLoadMore]);
  return /* @__PURE__ */ jsx("ul", {
    className: addStyles(className),
    children: listItems.map(({
      key,
      body,
      active
    }, index2) => /* @__PURE__ */ jsx("li", {
      "aria-current": active,
      onClick: () => handleClickItem && handleClickItem(key ?? index2),
      className: addStyles([options.listItem.base, active ? options.listItem.active : options.listItem.inactive]),
      ref: index2 === listItems.length - 1 ? intersectionRef : void 0,
      children: body
    }, key ?? index2))
  });
};
const SvgLeaves = (props) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 18, viewBox: "0 0 14 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.9252 8.53906C10.8752 9.10906 10.7752 9.68906 10.5952 10.2491C9.05516 14.9291 2.79516 16.9491 2.78516 16.9491C2.78516 16.9491 7.58516 18.5491 10.6652 16.3491C13.7452 14.1491 13.9352 8.98906 13.9352 8.98906C13.9352 8.98906 12.6152 8.61906 10.9252 8.53906Z", fill: "#42EDBF" }), /* @__PURE__ */ React.createElement("path", { d: "M5.76564 9.74C7.28564 8.66 9.27564 8.46 10.9256 8.54C11.2756 4.31 8.34564 0 8.34564 0C8.34564 0 1.89564 2.4 0.355641 7.08C-1.18436 11.76 2.77564 16.95 2.77564 16.95C2.78564 16.94 2.69564 11.94 5.76564 9.74Z", fill: "#B0E55C" }), /* @__PURE__ */ React.createElement("path", { d: "M10.5957 10.2394C10.7757 9.67938 10.8857 9.10938 10.9257 8.52938C9.28567 8.44938 7.28566 8.64938 5.76566 9.72938C2.68566 11.9294 2.77567 16.9294 2.77567 16.9394C2.79567 16.9394 9.05566 14.9194 10.5957 10.2394Z", fill: "#0D8720" }));
const SvgLogoDark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 720, height: 129, viewBox: "0 0 720 129", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1702_13995)" }, /* @__PURE__ */ React.createElement("path", { d: "M4.12582 110.062H23.4201L4.12582 75.8604V110.062Z", fill: "#00FFFF" }), /* @__PURE__ */ React.createElement("path", { d: "M23.4807 52.4105C23.4807 52.3206 23.4807 52.2308 23.4807 52.1709C23.4807 52.111 23.4807 51.9912 23.4807 51.9014H1.21347C1.21347 51.9912 1.21347 52.0811 1.21347 52.1709C1.21347 52.2608 1.21347 52.3506 1.21347 52.4105H23.4807Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M24.5122 44.3842L2.85168 39.203C2.76067 39.5923 2.66965 39.9817 2.57864 40.3411L24.2392 45.5222C24.3302 45.1329 24.4212 44.7435 24.5122 44.3842Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M27.3032 37.5559L7.43253 27.6428C7.12916 28.1819 6.85613 28.721 6.5831 29.29L26.4538 39.2031C26.6965 38.634 26.9998 38.095 27.3032 37.5559Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M31.611 31.6858L14.501 17.6099C13.9246 18.2388 13.3786 18.8677 12.8628 19.5266L29.9728 33.6025C30.4886 32.9437 31.0346 32.2848 31.611 31.6858Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M37.193 26.9839L23.6931 9.49377C22.8133 10.0928 21.9336 10.7516 21.1145 11.4105L34.6144 28.8707C35.4335 28.2118 36.2829 27.5829 37.193 26.9839Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M43.7761 23.7195L34.5841 3.65381C33.3706 4.13299 32.1571 4.64212 31.0043 5.21115L40.1964 25.2469C41.3492 24.6779 42.5323 24.1388 43.7761 23.7195Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M51.0873 22.1022L46.8401 0.479126C45.293 0.688768 43.8065 0.958307 42.3199 1.28774L46.5671 22.8808C48.0233 22.5215 49.5401 22.2519 51.0873 22.1022Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M58.8839 22.3119L59.9154 0.299488C58.1862 0.119795 56.4266 0 54.6367 0L53.6053 21.9824C53.757 21.9824 53.9087 21.9824 54.0907 21.9824C55.7289 21.9525 57.3064 22.0723 58.8839 22.3119Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M72.4142 3.20456C70.5636 2.51574 68.6524 1.94671 66.7108 1.46753L60.4918 22.6114C62.4637 23.0307 64.3749 23.6297 66.1648 24.4083L72.4142 3.20456Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M72.5962 28.1219L83.5781 8.86481C81.7579 7.6369 79.8163 6.5288 77.8444 5.57043L66.9232 24.7676C68.9254 25.6661 70.8366 26.8042 72.5962 28.1219Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M106.907 50.4938C106.816 47.3491 106.422 44.2644 105.785 41.2995L91.405 43.3659L104.966 38.0351C104.177 35.2498 103.145 32.5544 101.932 29.9788L86.5208 36.0584L100.203 26.6545C98.8679 24.3484 97.4118 22.1322 95.7432 20.0658L79.9074 30.9671L92.9522 16.8013C91.2837 15.0344 89.5242 13.3572 87.6129 11.8298L72.6265 28.122C79.968 33.6326 84.7006 42.3776 84.7006 52.1409C84.7006 59.3886 82.0006 66.4864 77.177 71.9671C71.8074 78.0467 64.6176 81.2213 56.6086 82.2395C44.8076 83.707 34.22 79.1548 23.3594 75.1416C23.3594 75.1416 55.1221 128.061 55.5165 128.271C55.8805 128.451 56.3053 128.271 56.73 128.271C64.6176 128.271 72.5052 128.271 80.4231 128.271C74.9625 120.005 69.5018 111.709 64.0412 103.443C75.8422 101.197 86.7938 94.848 94.4994 85.7735L94.6814 85.5938C97.1084 82.7187 99.232 79.5441 101.022 76.1898L101.507 75.2614C103.085 72.1168 104.359 68.7925 105.269 65.3184L97.1084 62.5931L105.724 63.3718C106.422 60.1672 106.847 56.8729 106.938 53.4886L94.196 52.3206L106.907 50.4938Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M185.732 71.8755H191.153C192.894 71.8755 194.239 71.9938 195.228 72.27C196.217 72.5068 197.009 72.9803 197.642 73.651C198.235 74.3218 198.829 75.2293 199.422 76.3736L205.08 87.8951H220.392L214.536 76.0974C213.626 74.3218 212.677 72.8224 211.609 71.6387C210.54 70.455 208.799 69.5475 206.346 68.9162V68.2059C209.353 67.8508 211.806 67.1011 213.666 65.9963C215.565 64.8915 216.91 63.4316 217.781 61.6166C218.651 59.8016 219.087 57.6709 219.087 55.1851C219.087 52.1074 218.374 49.4638 216.95 47.3331C215.526 45.2024 213.389 43.5847 210.58 42.4404C207.771 41.3356 204.249 40.7438 200.055 40.7438H172.478V87.8556H185.732V71.8755ZM185.732 52.6993H199.897C201.836 52.6993 203.181 53.0149 203.972 53.6068C204.764 54.1987 205.159 55.4613 205.159 57.3158C205.159 59.3281 204.764 60.6302 203.972 61.1826C203.181 61.735 201.796 62.0112 199.897 62.0112H185.732V52.6993Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M237.366 85.6462C241.283 87.6585 245.992 88.6449 251.452 88.6449C256.912 88.6449 261.858 87.6585 265.814 85.6462C269.731 83.6339 272.738 80.8324 274.796 77.2024C276.853 73.5723 277.882 69.2715 277.882 64.3788C277.882 59.4861 276.853 55.1853 274.796 51.5552C272.738 47.9252 269.731 45.1237 265.814 43.1114C261.897 41.0991 257.11 40.1127 251.452 40.1127C245.794 40.1127 241.323 41.0991 237.366 43.1114C233.41 45.1237 230.442 47.9252 228.385 51.5552C226.327 55.1853 225.299 59.4467 225.299 64.3393C225.299 69.232 226.327 73.5329 228.385 77.1629C230.482 80.8324 233.449 83.6339 237.366 85.6462ZM240.413 57.1581C241.086 55.5009 242.312 54.3567 244.053 53.7254C245.794 53.0941 248.247 52.7784 251.452 52.7784C254.657 52.7784 257.149 53.0941 258.93 53.7254C260.71 54.3567 261.976 55.5009 262.689 57.1581C263.401 58.8153 263.796 61.2222 263.796 64.3788C263.796 67.5354 263.44 69.8633 262.689 71.56C261.976 73.2567 260.71 74.4009 258.93 75.0322C257.149 75.6635 254.657 75.9792 251.452 75.9792C248.247 75.9792 245.794 75.6635 244.053 75.0322C242.312 74.4009 241.086 73.2172 240.413 71.56C239.74 69.8633 239.384 67.4959 239.384 64.3788C239.384 61.2617 239.74 58.8153 240.413 57.1581Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M298.573 79.2147H321.007L324.607 87.9347H339.84L319.385 40.8229H300.433L280.056 87.9347H294.933L298.573 79.2147ZM309.335 52.7389H310.245L313.331 60.6698L316.061 67.2986H303.519L306.288 60.6698L309.335 52.7389Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M358.083 87.9347H368.726C373.949 87.9347 378.459 86.9877 382.258 85.1727C386.056 83.3182 389.023 80.6351 391.081 77.1234C393.138 73.6117 394.167 69.3504 394.167 64.3788C394.167 59.4072 393.138 55.1458 391.081 51.6341C389.023 48.1224 386.056 45.4394 382.258 43.5849C378.459 41.7304 373.949 40.8229 368.726 40.8229H344.828V87.9347H358.083ZM368.726 52.6995C371.535 52.6995 373.79 52.9362 375.413 53.4097C377.074 53.8832 378.222 54.9485 378.934 56.5663C379.646 58.184 380.002 60.8276 380.002 64.3788C380.002 67.9299 379.646 70.4946 378.934 72.1518C378.222 73.809 377.035 74.8744 375.413 75.3479C373.751 75.8213 371.535 76.0581 368.726 76.0581H358.083V52.6995H368.726Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M415.929 71.8755H421.349C423.09 71.8755 424.435 71.9938 425.424 72.27C426.414 72.5068 427.205 72.9803 427.838 73.651C428.431 74.3218 429.025 75.2293 429.579 76.3736L435.237 87.8951H450.549L444.693 76.0974C443.783 74.3218 442.833 72.8224 441.765 71.6387C440.697 70.455 438.956 69.5475 436.503 68.9162V68.2059C439.51 67.8508 441.963 67.1011 443.823 65.9963C445.722 64.8915 447.067 63.4316 447.938 61.6166C448.808 59.8016 449.243 57.6709 449.243 55.1851C449.243 52.1074 448.531 49.4638 447.107 47.3331C445.682 45.2024 443.546 43.5847 440.736 42.4404C437.927 41.3356 434.406 40.7438 430.212 40.7438H402.634V87.8556H415.889L415.929 71.8755ZM415.929 52.6993H430.093C432.032 52.6993 433.377 53.0149 434.169 53.6068C434.96 54.1987 435.356 55.4613 435.356 57.3158C435.356 59.3281 434.96 60.6302 434.169 61.1826C433.377 61.735 431.992 62.0112 430.093 62.0112H415.929V52.6993Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M466.454 86.1197C470.015 87.7769 474.525 88.6055 480.025 88.6055C485.524 88.6055 490.035 87.7769 493.596 86.1197C497.157 84.4625 499.808 82.095 501.549 79.0174C503.29 75.9397 504.16 72.3097 504.16 68.1667V40.8229H490.905V67.1408C490.905 69.3898 490.628 71.1654 490.075 72.428C489.521 73.6907 488.452 74.5982 486.909 75.1111C485.366 75.6241 483.071 75.9003 480.064 75.9003C477.057 75.9003 474.842 75.6635 473.259 75.1111C471.676 74.5982 470.608 73.6907 470.054 72.428C469.5 71.1654 469.223 69.3898 469.223 67.1408V40.8229H455.969V68.1667C455.969 72.3491 456.839 75.9792 458.58 79.0174C460.242 82.095 462.893 84.4625 466.454 86.1197Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M525.567 69.5081L525.013 60.4724H525.923L531.897 69.7843L545.864 87.9346H559.989V40.7833H546.735V59.0125L547.368 69.2714H546.458L539.533 58.4601L526.398 40.7833H512.312V87.9346H525.567V69.5081Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M580.284 69.5081L579.731 60.4724H580.641L586.615 69.7843L600.582 87.9346H614.707V40.7833H601.452V59.0125L602.085 69.2714H601.175L594.251 58.4601L581.115 40.7833H567.03V87.9346H580.284V69.5081Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M626.062 40.7833H622.461V87.9346H626.062H635.716H664.401V76.0185H635.716V70.1394H663.373V58.3023H635.716V52.6994H664.401V40.7833H635.716H626.062Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M710.774 71.6387C709.705 70.455 707.965 69.5475 705.511 68.9162V68.2059C708.518 67.8508 710.972 67.1011 712.831 65.9963C714.73 64.8915 716.076 63.4316 716.946 61.6166C717.816 59.8016 718.252 57.6709 718.252 55.1851C718.252 52.1074 717.54 49.4638 716.115 47.3331C714.691 45.2024 712.554 43.5847 709.745 42.4404C706.936 41.3356 703.414 40.7438 699.22 40.7438H671.643V87.8556H684.898V71.836H690.318C692.059 71.836 693.404 71.9544 694.393 72.2306C695.383 72.4673 696.174 72.9408 696.807 73.6116C697.4 74.2823 697.994 75.1898 698.548 76.3341L704.206 87.8556H719.518L713.662 76.0579C712.831 74.3218 711.842 72.8224 710.774 71.6387ZM703.217 61.1826C702.425 61.735 701.04 62.0112 699.141 62.0112H684.977V52.6598H699.141C701.08 52.6598 702.425 52.9755 703.217 53.5673C704.008 54.1592 704.404 55.4218 704.404 57.2763C704.404 59.3281 704.008 60.6302 703.217 61.1826Z", fill: "white" })));
const SvgLogoTinyDark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 47, height: 56, viewBox: "0 0 47 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1625_6830)" }, /* @__PURE__ */ React.createElement("path", { d: "M1.77695 48.0168H10.0868L1.77695 33.0957V48.0168Z", fill: "#00FFFF" }), /* @__PURE__ */ React.createElement("path", { d: "M10.1129 22.8652C10.1129 22.826 10.1129 22.7868 10.1129 22.7607C10.1129 22.7345 10.1129 22.6823 10.1129 22.6431H0.522644C0.522644 22.6823 0.522644 22.7215 0.522644 22.7607C0.522644 22.7999 0.522644 22.8391 0.522644 22.8652H10.1129Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M10.5572 19.3635L1.22819 17.1031C1.18899 17.273 1.14979 17.4429 1.1106 17.5997L10.4396 19.86C10.4788 19.6902 10.518 19.5203 10.5572 19.3635Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M11.7592 16.3845L3.20111 12.0597C3.07045 12.2949 2.95286 12.5301 2.83527 12.7783L11.3934 17.1031C11.4979 16.8548 11.6285 16.6197 11.7592 16.3845Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M13.6145 13.8237L6.24544 7.68274C5.99719 7.95712 5.76201 8.2315 5.53989 8.51895L12.909 14.6599C13.1311 14.3724 13.3663 14.085 13.6145 13.8237Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M16.0187 11.7723L10.2044 4.14185C9.82547 4.40316 9.44656 4.69061 9.09378 4.97806L14.9081 12.5954C15.2608 12.308 15.6267 12.0336 16.0187 11.7723Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M18.8539 10.3481L14.895 1.59399C14.3724 1.80305 13.8497 2.02517 13.3532 2.27342L17.3122 11.0144C17.8087 10.7662 18.3182 10.531 18.8539 10.3481Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M22.0028 9.64261L20.1736 0.209106C19.5072 0.300567 18.867 0.418159 18.2268 0.561883L20.056 9.98232C20.6831 9.82553 21.3364 9.70794 22.0028 9.64261Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M25.3607 9.73402L25.8049 0.130658C25.0602 0.0522632 24.3024 0 23.5315 0L23.0872 9.59029C23.1526 9.59029 23.2179 9.59029 23.2963 9.59029C24.0019 9.57723 24.6813 9.62949 25.3607 9.73402Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M31.1881 1.39807C30.391 1.09756 29.5679 0.849312 28.7317 0.640259L26.0532 9.86471C26.9025 10.0476 27.7256 10.3089 28.4965 10.6487L31.1881 1.39807Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M31.2665 12.2688L35.9963 3.86754C35.2123 3.33184 34.3761 2.8484 33.5268 2.4303L28.8232 10.8055C29.6855 11.1974 30.5086 11.6939 31.2665 12.2688Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M46.0439 22.029C46.0047 20.657 45.8348 19.3113 45.5604 18.0178L39.3672 18.9193L45.2077 16.5936C44.8679 15.3785 44.4237 14.2025 43.9011 13.0789L37.2637 15.7312L43.1563 11.6286C42.5814 10.6225 41.9543 9.65564 41.2357 8.7541L34.4153 13.5101L40.0336 7.32993C39.315 6.55905 38.5572 5.82737 37.734 5.16101L31.2795 12.2688C34.4414 14.6729 36.4797 18.4881 36.4797 22.7476C36.4797 25.9095 35.3169 29.0061 33.2394 31.3971C30.9267 34.0495 27.8302 35.4345 24.3808 35.8787C19.2982 36.5189 14.7382 34.5329 10.0607 32.7821C10.0607 32.7821 23.7406 55.8694 23.9104 55.9608C24.0672 56.0392 24.2501 55.9608 24.433 55.9608C27.8302 55.9608 31.2273 55.9608 34.6374 55.9608C32.2856 52.3547 29.9337 48.7354 27.5819 45.1293C32.6645 44.1493 37.3812 41.3794 40.7 37.4205L40.7784 37.3421C41.8236 36.0877 42.7382 34.7028 43.5091 33.2394L43.7182 32.8344C44.3976 31.4625 44.9463 30.0122 45.3383 28.4965L41.8236 27.3075L45.5343 27.6472C45.8348 26.2492 46.0177 24.812 46.0569 23.3355L40.5693 22.826L46.0439 22.029Z", fill: "white" })));
const SvgLogoWithTaglineDark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 720, height: 165, viewBox: "0 0 720 165", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M218.213 133.753H221.925V117.039H216.862L213.075 125.264L211.575 129.188H211.313L209.737 125.264L205.838 117.039H200.812V133.753H204.525V125.264L204.375 122.623H204.638L205.612 125.264L209.1 132.772H213.6L217.088 125.264L218.063 122.623H218.325L218.213 125.264V133.753Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M238.725 117.831C237.375 117.114 235.762 116.775 233.887 116.775C232.012 116.775 230.475 117.114 229.125 117.831C227.775 118.548 226.725 119.529 226.012 120.812C225.3 122.095 224.925 123.604 224.925 125.377C224.925 127.151 225.3 128.66 226.012 129.943C226.725 131.225 227.775 132.244 229.125 132.923C230.475 133.602 232.05 133.98 233.887 133.98C235.725 133.98 237.375 133.64 238.725 132.923C240.075 132.206 241.088 131.225 241.838 129.943C242.588 128.66 242.925 127.151 242.925 125.377C242.925 123.604 242.55 122.095 241.838 120.812C241.125 119.529 240.075 118.548 238.725 117.831ZM238.463 128.32C238.125 129.037 237.6 129.565 236.85 129.905C236.1 130.244 235.125 130.395 233.925 130.395C232.725 130.395 231.75 130.244 231.037 129.905C230.325 129.565 229.763 129.037 229.463 128.32C229.125 127.603 228.975 126.622 228.975 125.377C228.975 124.132 229.125 123.151 229.463 122.434C229.8 121.717 230.325 121.189 231.037 120.85C231.75 120.51 232.725 120.359 233.925 120.359C235.125 120.359 236.137 120.51 236.85 120.85C237.6 121.189 238.125 121.68 238.463 122.434C238.8 123.189 238.95 124.132 238.95 125.377C238.95 126.622 238.8 127.603 238.463 128.32Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M249.938 133.753H254.213C256.013 133.753 257.55 133.414 258.825 132.772C260.1 132.131 261.113 131.15 261.825 129.905C262.538 128.66 262.875 127.151 262.875 125.415C262.875 123.679 262.538 122.17 261.825 120.925C261.113 119.68 260.1 118.737 258.825 118.058C257.513 117.379 255.975 117.077 254.213 117.077H246.188V133.791L249.938 133.753ZM254.213 120.397C255.338 120.397 256.275 120.548 256.95 120.812C257.625 121.076 258.15 121.567 258.45 122.283C258.75 123 258.938 124.019 258.938 125.377C258.938 126.736 258.788 127.717 258.45 128.471C258.113 129.226 257.625 129.679 256.95 129.98C256.275 130.244 255.338 130.395 254.213 130.395H249.938V120.397H254.213Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M280.088 120.397V117.039H269.737H267.037H265.987V133.753H267.037H269.737H280.088V130.395H269.737V127H279.713V123.679H269.737V120.397H280.088Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M292.388 117.039H283.2V133.753H286.912V127.679H289.35C289.987 127.679 290.513 127.717 290.888 127.83C291.263 127.943 291.6 128.132 291.825 128.358C292.088 128.622 292.312 128.962 292.537 129.377L294.825 133.716H299.138L296.738 129.226C296.438 128.66 296.1 128.132 295.725 127.754C295.35 127.339 294.788 127.037 294.075 126.849V126.66C295.125 126.547 295.987 126.321 296.662 125.906C297.375 125.528 297.863 125 298.238 124.359C298.575 123.717 298.763 122.925 298.763 122.019C298.763 120.963 298.5 120.057 298.013 119.303C297.525 118.548 296.775 117.982 295.838 117.605C294.9 117.228 293.775 117.039 292.388 117.039ZM294.3 124.396C293.888 124.698 293.25 124.849 292.35 124.849H286.912V120.397H292.35C293.212 120.397 293.888 120.548 294.3 120.887C294.713 121.227 294.938 121.793 294.938 122.623C294.938 123.491 294.713 124.094 294.3 124.396Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M311.775 124.925L305.813 117.039H301.875V133.753H305.588V125.679L305.438 122.623H305.662L307.8 125.755L313.912 133.753H317.888V117.039H314.175V125.075L314.325 128.471H314.063L311.775 124.925Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M337.875 125.377L339.037 120.586H339.3L340.5 125.377L342.975 133.753H348.487L352.425 117.039H348.375L346.35 126.509L345.787 130.169H345.525L344.737 126.509L342 117.039H336.45L333.675 126.509L332.925 130.169H332.625L332.062 126.509L330.075 117.039H325.875L329.812 133.753H335.362L337.875 125.377Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M359.812 130.056H368.1L369.675 133.753H373.95L366.637 117.039H361.312L354.037 133.753H358.2L359.812 130.056ZM362.85 123.038L363.862 120.435H364.125L365.137 123.038L366.675 126.698H361.237L362.85 123.038Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M389.137 125.075C388.387 124.623 387.412 124.321 386.175 124.094L381.525 123.34C381.075 123.264 380.7 123.151 380.4 123.038C380.1 122.925 379.912 122.774 379.762 122.548C379.612 122.359 379.575 122.095 379.575 121.755C379.575 121.378 379.687 121.076 379.912 120.85C380.137 120.623 380.475 120.435 381 120.321C381.487 120.208 382.2 120.133 383.1 120.133C384.225 120.133 385.05 120.208 385.65 120.359C386.25 120.51 386.662 120.774 386.887 121.114C387.112 121.453 387.225 121.868 387.225 122.397V122.736H390.975V122.585C390.975 121.416 390.712 120.397 390.15 119.491C389.587 118.586 388.762 117.907 387.675 117.416C386.587 116.926 385.162 116.662 383.475 116.662C382.05 116.662 380.887 116.813 379.912 117.114C378.937 117.416 378.15 117.794 377.55 118.284C376.95 118.775 376.537 119.34 376.237 119.944C375.937 120.548 375.825 121.189 375.825 121.831C375.825 122.736 376.012 123.529 376.387 124.17C376.762 124.811 377.325 125.34 378 125.717C378.675 126.094 379.537 126.358 380.55 126.547L385.2 127.226C386.025 127.377 386.625 127.566 386.962 127.792C387.3 128.018 387.45 128.396 387.45 128.924C387.45 129.301 387.337 129.603 387.15 129.829C386.962 130.056 386.587 130.244 386.062 130.358C385.537 130.471 384.787 130.509 383.775 130.509C382.65 130.509 381.787 130.433 381.187 130.282C380.587 130.131 380.175 129.905 379.95 129.565C379.725 129.226 379.612 128.848 379.612 128.32V127.867H375.9V128.018C375.9 129.301 376.2 130.395 376.837 131.263C377.437 132.131 378.337 132.81 379.5 133.225C380.662 133.64 382.087 133.904 383.775 133.904C385.537 133.904 386.962 133.678 388.05 133.187C389.137 132.697 389.925 132.056 390.45 131.263C390.937 130.471 391.2 129.641 391.2 128.735C391.2 127.981 391.05 127.264 390.712 126.622C390.412 126.094 389.887 125.528 389.137 125.075Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M399.75 117.039H393.562V120.397H399.75V133.753H403.463V120.397H409.65V117.039H403.463H399.75Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M416.175 133.753H426.525V130.395H416.175V127H426.15V123.679H416.175V120.397H426.525V117.039H416.175H413.512H412.463V133.753H413.512H416.175Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M441.9 130.961V126.924H445.838V123.83H441.9V119.831H438.713V123.83H434.738V126.924H438.713V130.961H441.9Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M454.387 133.753H458.1V127.679H460.575C461.212 127.679 461.737 127.717 462.112 127.83C462.487 127.943 462.825 128.132 463.087 128.358C463.35 128.622 463.575 128.962 463.8 129.377L466.087 133.716H470.4L468 129.226C467.7 128.66 467.362 128.132 466.987 127.754C466.612 127.339 466.087 127.037 465.337 126.849V126.66C466.387 126.547 467.25 126.321 467.925 125.906C468.637 125.528 469.125 125 469.5 124.359C469.837 123.717 470.025 122.925 470.025 122.019C470.025 120.963 469.762 120.057 469.275 119.303C468.787 118.548 468.037 117.982 467.1 117.605C466.125 117.228 464.962 117.039 463.612 117.039H454.425L454.387 133.753ZM458.1 120.397H463.537C464.4 120.397 465.075 120.548 465.487 120.887C465.9 121.227 466.125 121.793 466.125 122.623C466.125 123.491 465.9 124.094 465.487 124.396C465.075 124.698 464.437 124.849 463.537 124.849H458.1V120.397Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M487.088 120.397V117.039H476.738H474.075H473.025V133.753H474.075H476.738H487.088V130.395H476.738V127H486.713V123.679H476.738V120.397H487.088Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M507.225 123.981V123.604C507.225 122.17 506.888 120.963 506.175 119.944C505.463 118.925 504.488 118.133 503.25 117.605C501.975 117.039 500.475 116.775 498.75 116.775C497.025 116.775 495.338 117.114 494.025 117.831C492.675 118.548 491.663 119.529 490.95 120.812C490.238 122.095 489.863 123.604 489.863 125.377C489.863 127.151 490.238 128.66 490.95 129.943C491.663 131.225 492.713 132.244 494.025 132.923C495.375 133.64 496.95 133.98 498.75 133.98C500.55 133.98 501.975 133.716 503.25 133.15C504.525 132.584 505.5 131.829 506.175 130.81C506.85 129.792 507.225 128.584 507.225 127.151V126.773H503.063V127.151C503.063 128.245 502.725 129.075 502.05 129.603C501.375 130.131 500.288 130.395 498.788 130.395C497.588 130.395 496.613 130.244 495.863 129.905C495.113 129.565 494.588 129.037 494.25 128.32C493.913 127.603 493.763 126.622 493.763 125.377C493.763 124.132 493.913 123.151 494.25 122.434C494.588 121.717 495.113 121.189 495.863 120.85C496.613 120.51 497.588 120.359 498.788 120.359C500.288 120.359 501.375 120.623 502.05 121.151C502.725 121.68 503.063 122.51 503.063 123.604V123.981H507.225Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M516.413 128.207V133.753H520.163V128.207L527.663 117.039H523.05L519.863 121.906L518.475 124.17H518.175L516.788 121.906L513.637 117.039H509.025L516.413 128.207Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M546.825 123.981V123.604C546.825 122.17 546.488 120.963 545.775 119.944C545.063 118.925 544.088 118.133 542.85 117.605C541.575 117.039 540.075 116.775 538.35 116.775C536.625 116.775 534.938 117.114 533.625 117.831C532.275 118.548 531.263 119.529 530.55 120.812C529.838 122.095 529.463 123.604 529.463 125.377C529.463 127.151 529.838 128.66 530.55 129.943C531.263 131.225 532.313 132.244 533.625 132.923C534.975 133.64 536.55 133.98 538.35 133.98C540.15 133.98 541.575 133.716 542.85 133.15C544.125 132.584 545.1 131.829 545.775 130.81C546.45 129.792 546.825 128.584 546.825 127.151V126.773H542.663V127.151C542.663 128.245 542.325 129.075 541.65 129.603C540.975 130.131 539.887 130.395 538.387 130.395C537.187 130.395 536.213 130.244 535.463 129.905C534.713 129.565 534.188 129.037 533.85 128.32C533.513 127.603 533.363 126.622 533.363 125.377C533.363 124.132 533.513 123.151 533.85 122.434C534.188 121.717 534.713 121.189 535.463 120.85C536.213 120.51 537.187 120.359 538.387 120.359C539.887 120.359 540.975 120.623 541.65 121.151C542.325 121.68 542.663 122.51 542.663 123.604V123.981H546.825Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M549.9 117.039V133.753H550.95H553.612H563.512V130.395H553.612V117.039H549.9Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M570.187 117.039H566.475V133.753H570.187V117.039Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M579.525 125.755L585.675 133.753H589.65V117.039H585.937V125.075L586.087 128.471H585.825L583.537 124.925L577.575 117.039H573.6V133.753H577.35V125.679L577.2 122.623H577.425L579.525 125.755Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M610.5 133.753V124.924H601.125V127.679H606.713C606.675 128.32 606.563 128.848 606.3 129.226C606 129.641 605.475 129.98 604.762 130.131C604.012 130.32 603 130.395 601.65 130.395C600.45 130.395 599.475 130.244 598.725 129.905C597.975 129.565 597.45 129.037 597.113 128.32C596.775 127.603 596.625 126.622 596.625 125.377C596.625 124.132 596.813 123.151 597.15 122.434C597.488 121.717 598.05 121.189 598.8 120.85C599.55 120.51 600.563 120.359 601.8 120.359C603.375 120.359 604.538 120.586 605.213 121.076C605.888 121.529 606.262 122.246 606.262 123.264V123.453H610.425V123.264C610.425 121.906 610.087 120.774 609.375 119.793C608.7 118.85 607.687 118.095 606.412 117.567C605.137 117.039 603.637 116.775 601.912 116.775C600 116.775 598.387 117.114 597 117.831C595.612 118.548 594.562 119.529 593.812 120.812C593.062 122.095 592.688 123.604 592.688 125.377C592.688 127.151 593.025 128.66 593.7 129.943C594.375 131.225 595.313 132.244 596.55 132.923C597.788 133.64 599.25 133.98 600.938 133.98C602.137 133.98 603.15 133.829 603.938 133.489C604.725 133.15 605.362 132.697 605.85 132.131C606.3 131.565 606.638 130.886 606.863 130.169H607.05V133.753H610.5Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M213.375 77.1581H218.513C220.163 77.1581 221.438 77.2713 222.375 77.5354C223.312 77.7618 224.062 78.2146 224.662 78.856C225.225 79.4974 225.787 80.3652 226.35 81.4594L231.713 92.4766H246.225L240.675 81.1952C239.812 79.4974 238.913 78.0636 237.9 76.9317C236.888 75.7998 235.237 74.932 232.912 74.3284V73.6492C235.762 73.3096 238.087 72.5928 239.85 71.5363C241.65 70.4799 242.925 69.0839 243.75 67.3483C244.575 65.6127 244.987 63.5753 244.987 61.1983C244.987 58.2553 244.313 55.7274 242.963 53.69C241.613 51.6525 239.587 50.1056 236.925 49.0114C234.262 47.955 230.925 47.389 226.95 47.389H200.812V92.4388H213.375V77.1581ZM213.375 58.8213H226.8C228.637 58.8213 229.912 59.1231 230.662 59.6891C231.412 60.255 231.787 61.4624 231.787 63.2357C231.787 65.1599 231.412 66.405 230.662 66.9332C229.912 67.4615 228.6 67.7256 226.8 67.7256H213.375V58.8213Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M262.312 90.326C266.025 92.2502 270.487 93.1935 275.662 93.1935C280.837 93.1935 285.525 92.2502 289.275 90.326C292.988 88.4017 295.837 85.7229 297.787 82.2517C299.737 78.7806 300.713 74.668 300.713 69.9894C300.713 65.3109 299.737 61.1983 297.787 57.7271C295.837 54.256 292.988 51.5771 289.275 49.6529C285.563 47.7287 281.025 46.7854 275.662 46.7854C270.3 46.7854 266.062 47.7287 262.312 49.6529C258.562 51.5771 255.75 54.256 253.8 57.7271C251.85 61.1983 250.875 65.2732 250.875 69.9517C250.875 74.6302 251.85 78.7428 253.8 82.214C255.787 85.7229 258.6 88.4017 262.312 90.326ZM265.2 63.0848C265.838 61.5002 267 60.406 268.65 59.8023C270.3 59.1986 272.625 58.8968 275.662 58.8968C278.7 58.8968 281.062 59.1986 282.75 59.8023C284.438 60.406 285.638 61.5002 286.312 63.0848C286.987 64.6695 287.362 66.971 287.362 69.9894C287.362 73.0078 287.025 75.2339 286.312 76.8563C285.638 78.4787 284.438 79.5729 282.75 80.1766C281.062 80.7803 278.7 81.0821 275.662 81.0821C272.625 81.0821 270.3 80.7803 268.65 80.1766C267 79.5729 265.838 78.441 265.2 76.8563C264.563 75.2339 264.225 72.9701 264.225 69.9894C264.225 67.0088 264.563 64.6695 265.2 63.0848Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M320.325 84.1759H341.588L345 92.5143H359.438L340.05 47.4645H322.088L302.775 92.5143H316.875L320.325 84.1759ZM330.525 58.859H331.388L334.313 66.4427L336.9 72.7814H325.013L327.638 66.4427L330.525 58.859Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M376.725 92.5143H386.812C391.762 92.5143 396.037 91.6087 399.637 89.8732C403.237 88.0998 406.05 85.5342 408 82.1762C409.95 78.8182 410.925 74.7434 410.925 69.9894C410.925 65.2354 409.95 61.1605 408 57.8025C406.05 54.4446 403.237 51.8789 399.637 50.1056C396.037 48.3323 391.762 47.4645 386.812 47.4645H364.162V92.5143H376.725ZM386.812 58.8212C389.475 58.8212 391.612 59.0476 393.15 59.5004C394.725 59.9532 395.813 60.9719 396.488 62.5188C397.163 64.0657 397.5 66.5937 397.5 69.9894C397.5 73.3851 397.163 75.8375 396.488 77.4222C395.813 79.0069 394.687 80.0256 393.15 80.4784C391.575 80.9311 389.475 81.1575 386.812 81.1575H376.725V58.8212H386.812Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M431.55 77.1581H436.688C438.338 77.1581 439.613 77.2713 440.55 77.5354C441.488 77.7618 442.238 78.2146 442.838 78.856C443.4 79.4974 443.963 80.3652 444.488 81.4594L449.85 92.4766H464.363L458.813 81.1952C457.95 79.4974 457.05 78.0636 456.038 76.9317C455.025 75.7998 453.375 74.932 451.05 74.3284V73.6492C453.9 73.3096 456.225 72.5928 457.988 71.5363C459.788 70.4799 461.063 69.0839 461.888 67.3483C462.713 65.6127 463.125 63.5753 463.125 61.1983C463.125 58.2553 462.45 55.7274 461.1 53.69C459.75 51.6525 457.725 50.1056 455.063 49.0114C452.4 47.955 449.063 47.389 445.088 47.389H418.95V92.4388H431.513L431.55 77.1581ZM431.55 58.8213H444.975C446.813 58.8213 448.088 59.1231 448.838 59.6891C449.588 60.255 449.963 61.4624 449.963 63.2357C449.963 65.1599 449.588 66.405 448.838 66.9332C448.088 67.4615 446.775 67.7256 444.975 67.7256H431.55V58.8213Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M479.438 90.7787C482.812 92.3633 487.088 93.1557 492.3 93.1557C497.513 93.1557 501.787 92.3633 505.162 90.7787C508.537 89.194 511.05 86.9302 512.7 83.9873C514.35 81.0443 515.175 77.5731 515.175 73.6115V47.4645H502.613V72.6305C502.613 74.7811 502.35 76.479 501.825 77.6863C501.3 78.8937 500.287 79.7615 498.825 80.252C497.362 80.7425 495.188 81.0066 492.338 81.0066C489.488 81.0066 487.387 80.7802 485.887 80.252C484.387 79.7615 483.375 78.8937 482.85 77.6863C482.325 76.479 482.062 74.7811 482.062 72.6305V47.4645H469.5V73.6115C469.5 77.6109 470.325 81.082 471.975 83.9873C473.55 86.9302 476.062 89.194 479.438 90.7787Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M535.462 74.8943L534.937 66.2541H535.8L541.462 75.1584L554.7 92.5143H568.087V47.4268H555.525V64.8581L556.125 74.6679H555.262L548.7 64.3299L536.25 47.4268H522.9V92.5143H535.462V74.8943Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M587.325 74.8943L586.8 66.2541H587.663L593.325 75.1584L606.563 92.5143H619.95V47.4268H607.388V64.8581L607.988 74.6679H607.125L600.563 64.3299L588.113 47.4268H574.763V92.5143H587.325V74.8943Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M630.712 47.4268H627.3V92.5143H630.712H639.862H667.05V81.1198H639.862V75.498H666.075V64.1789H639.862V58.8213H667.05V47.4268H639.862H630.712Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M711 76.9317C709.988 75.7998 708.338 74.932 706.013 74.3284V73.6492C708.863 73.3097 711.188 72.5928 712.95 71.5363C714.75 70.4799 716.025 69.0839 716.85 67.3483C717.675 65.6127 718.088 63.5753 718.088 61.1983C718.088 58.2553 717.413 55.7274 716.063 53.69C714.713 51.6525 712.688 50.1056 710.025 49.0114C707.363 47.955 704.025 47.389 700.05 47.389H673.913V92.4388H686.475V77.1204H691.613C693.263 77.1204 694.538 77.2336 695.475 77.4977C696.413 77.7241 697.163 78.1768 697.763 78.8183C698.325 79.4597 698.888 80.3275 699.413 81.4216L704.775 92.4388H719.288L713.738 81.1575C712.95 79.4974 712.013 78.0636 711 76.9317ZM703.838 66.9333C703.088 67.4615 701.775 67.7256 699.975 67.7256H686.55V58.7835H699.975C701.813 58.7835 703.088 59.0854 703.838 59.6513C704.588 60.2173 704.963 61.4247 704.963 63.198C704.963 65.1599 704.588 66.405 703.838 66.9333Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M4.27499 140.167H28.125L4.27499 97.0796V140.167Z", fill: "#00FFFF" }), /* @__PURE__ */ React.createElement("path", { d: "M28.2 67.5369C28.2 67.4237 28.2 67.3105 28.2 67.2351C28.2 67.1596 28.2 67.0087 28.2 66.8955H0.674988C0.674988 67.0087 0.674988 67.1219 0.674988 67.2351C0.674988 67.3483 0.674988 67.4615 0.674988 67.5369H28.2Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M29.475 57.4253L2.69999 50.8979C2.58749 51.3884 2.47499 51.8789 2.36249 52.3317L29.1375 58.859C29.25 58.3685 29.3625 57.878 29.475 57.4253Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M32.925 48.8228L8.3625 36.3341C7.9875 37.0132 7.65 37.6924 7.3125 38.4093L31.875 50.8979C32.175 50.1811 32.55 49.5019 32.925 48.8228Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M38.25 41.4278L17.1 23.6946C16.3875 24.4869 15.7125 25.2792 15.075 26.1093L36.225 43.8425C36.8625 43.0124 37.5375 42.1824 38.25 41.4278Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M45.15 35.504L28.4625 13.4696C27.375 14.2242 26.2875 15.0543 25.275 15.8843L41.9625 37.881C42.975 37.0509 44.025 36.2586 45.15 35.504Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M53.2875 31.3915L41.925 6.1123C40.425 6.71599 38.925 7.3574 37.5 8.07427L48.8625 33.3157C50.2875 32.5989 51.75 31.9197 53.2875 31.3915Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M62.325 29.3541L57.075 2.11292C55.1625 2.37703 53.325 2.7166 51.4875 3.13163L56.7375 30.3351C58.5375 29.8823 60.4125 29.5427 62.325 29.3541Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M71.9625 29.6181L73.2375 1.88646C71.1 1.66008 68.925 1.50916 66.7125 1.50916L65.4375 29.2031C65.625 29.2031 65.8125 29.2031 66.0375 29.2031C68.0625 29.1654 70.0125 29.3163 71.9625 29.6181Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M88.6875 5.54638C86.4 4.67859 84.0375 3.96171 81.6375 3.35803L73.95 29.9955C76.3875 30.5237 78.75 31.2783 80.9625 32.2593L88.6875 5.54638Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M88.9125 36.9378L102.487 12.6773C100.237 11.1304 97.8375 9.73434 95.4 8.52698L81.9 32.712C84.375 33.8439 86.7375 35.2776 88.9125 36.9378Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M131.325 65.1222C131.212 61.1606 130.725 57.2743 129.937 53.5391L112.162 56.1424L128.925 49.4265C127.95 45.9176 126.675 42.5219 125.175 39.2771L106.125 46.9363L123.037 35.089C121.387 32.1838 119.587 29.3918 117.525 26.7884L97.95 40.5222L114.075 22.6758C112.012 20.4497 109.837 18.3368 107.475 16.4126L88.95 36.9378C98.025 43.8801 103.875 54.8974 103.875 67.1974C103.875 76.3281 100.537 85.2701 94.575 92.1747C87.9375 99.834 79.05 103.833 69.15 105.116C54.5625 106.965 41.475 101.23 28.05 96.1741C28.05 96.1741 67.3125 162.843 67.8 163.107C68.25 163.334 68.775 163.107 69.3 163.107C79.05 163.107 88.8 163.107 98.5875 163.107C91.8375 152.694 85.0875 142.243 78.3375 131.829C92.925 128.999 106.462 121.001 115.987 109.568L116.212 109.342C119.212 105.72 121.837 101.72 124.05 97.4947L124.65 96.3251C126.6 92.3634 128.175 88.1753 129.3 83.7986L119.212 80.3652L129.862 81.3462C130.725 77.3091 131.25 73.1587 131.362 68.8952L115.612 67.4238L131.325 65.1222Z", fill: "white" }));
const SvgLogoLight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 720, height: 129, viewBox: "0 0 720 129", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1703_14014)" }, /* @__PURE__ */ React.createElement("path", { d: "M4.12582 110.062H23.4201L4.12582 75.8604V110.062Z", fill: "#00FFFF" }), /* @__PURE__ */ React.createElement("path", { d: "M23.4807 52.4105C23.4807 52.3206 23.4807 52.2308 23.4807 52.1709C23.4807 52.111 23.4807 51.9912 23.4807 51.9014H1.21347C1.21347 51.9912 1.21347 52.0811 1.21347 52.1709C1.21347 52.2608 1.21347 52.3506 1.21347 52.4105H23.4807Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M24.5122 44.3842L2.85168 39.203C2.76067 39.5923 2.66965 39.9817 2.57864 40.3411L24.2392 45.5222C24.3302 45.1329 24.4212 44.7435 24.5122 44.3842Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M27.3032 37.5559L7.43253 27.6428C7.12916 28.1819 6.85613 28.721 6.5831 29.29L26.4538 39.2031C26.6965 38.634 26.9998 38.095 27.3032 37.5559Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M31.611 31.6858L14.501 17.6099C13.9246 18.2388 13.3786 18.8677 12.8628 19.5266L29.9728 33.6025C30.4886 32.9437 31.0346 32.2848 31.611 31.6858Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M37.193 26.9839L23.6931 9.49377C22.8133 10.0928 21.9336 10.7516 21.1145 11.4105L34.6144 28.8707C35.4335 28.2118 36.2829 27.5829 37.193 26.9839Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M43.7761 23.7195L34.5841 3.65381C33.3706 4.13299 32.1571 4.64212 31.0043 5.21115L40.1964 25.2469C41.3492 24.6779 42.5323 24.1388 43.7761 23.7195Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M51.0873 22.1022L46.8401 0.479126C45.293 0.688768 43.8065 0.958307 42.3199 1.28774L46.5671 22.8808C48.0233 22.5215 49.5401 22.2519 51.0873 22.1022Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M58.8839 22.3119L59.9154 0.299488C58.1862 0.119795 56.4266 0 54.6367 0L53.6053 21.9824C53.757 21.9824 53.9087 21.9824 54.0907 21.9824C55.7289 21.9525 57.3064 22.0723 58.8839 22.3119Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M72.4142 3.20456C70.5636 2.51574 68.6524 1.94671 66.7108 1.46753L60.4918 22.6114C62.4637 23.0307 64.3749 23.6297 66.1648 24.4083L72.4142 3.20456Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M72.5962 28.1219L83.5781 8.8648C81.7579 7.6369 79.8163 6.5288 77.8444 5.57043L66.9232 24.7676C68.9254 25.6661 70.8366 26.8041 72.5962 28.1219Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M106.907 50.4938C106.816 47.3491 106.422 44.2644 105.785 41.2995L91.405 43.3659L104.966 38.0351C104.177 35.2498 103.145 32.5544 101.932 29.9788L86.5208 36.0584L100.203 26.6545C98.8679 24.3484 97.4118 22.1322 95.7432 20.0658L79.9074 30.9671L92.9522 16.8013C91.2837 15.0344 89.5242 13.3572 87.6129 11.8298L72.6265 28.122C79.968 33.6326 84.7006 42.3776 84.7006 52.1409C84.7006 59.3886 82.0006 66.4864 77.177 71.9671C71.8074 78.0467 64.6176 81.2213 56.6086 82.2395C44.8076 83.707 34.22 79.1548 23.3594 75.1416C23.3594 75.1416 55.1221 128.061 55.5165 128.271C55.8805 128.451 56.3053 128.271 56.73 128.271C64.6176 128.271 72.5052 128.271 80.4231 128.271C74.9625 120.005 69.5018 111.709 64.0412 103.443C75.8422 101.197 86.7938 94.848 94.4994 85.7735L94.6814 85.5938C97.1084 82.7187 99.232 79.5441 101.022 76.1898L101.507 75.2614C103.085 72.1168 104.359 68.7925 105.269 65.3184L97.1084 62.5931L105.724 63.3718C106.422 60.1672 106.847 56.8729 106.938 53.4886L94.196 52.3206L106.907 50.4938Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M185.732 71.8755H191.153C192.894 71.8755 194.239 71.9938 195.228 72.27C196.217 72.5068 197.009 72.9803 197.642 73.651C198.235 74.3218 198.829 75.2293 199.422 76.3736L205.08 87.8951H220.392L214.536 76.0974C213.626 74.3218 212.677 72.8224 211.609 71.6387C210.54 70.455 208.799 69.5475 206.346 68.9162V68.2059C209.353 67.8508 211.806 67.1011 213.666 65.9963C215.565 64.8915 216.91 63.4316 217.781 61.6166C218.651 59.8016 219.087 57.6709 219.087 55.1851C219.087 52.1074 218.374 49.4638 216.95 47.3331C215.526 45.2024 213.389 43.5847 210.58 42.4404C207.771 41.3356 204.249 40.7438 200.055 40.7438H172.478V87.8556H185.732V71.8755ZM185.732 52.6993H199.897C201.836 52.6993 203.181 53.0149 203.972 53.6068C204.764 54.1987 205.159 55.4613 205.159 57.3158C205.159 59.3281 204.764 60.6302 203.972 61.1826C203.181 61.735 201.796 62.0112 199.897 62.0112H185.732V52.6993Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M237.366 85.6462C241.283 87.6585 245.992 88.6449 251.452 88.6449C256.912 88.6449 261.858 87.6585 265.814 85.6462C269.731 83.6339 272.738 80.8324 274.796 77.2024C276.853 73.5723 277.882 69.2715 277.882 64.3788C277.882 59.4861 276.853 55.1853 274.796 51.5552C272.738 47.9252 269.731 45.1237 265.814 43.1114C261.897 41.0991 257.11 40.1127 251.452 40.1127C245.794 40.1127 241.323 41.0991 237.366 43.1114C233.41 45.1237 230.442 47.9252 228.385 51.5552C226.327 55.1853 225.299 59.4467 225.299 64.3393C225.299 69.232 226.327 73.5329 228.385 77.1629C230.482 80.8324 233.449 83.6339 237.366 85.6462ZM240.413 57.1581C241.086 55.5009 242.312 54.3567 244.053 53.7254C245.794 53.0941 248.247 52.7784 251.452 52.7784C254.657 52.7784 257.149 53.0941 258.93 53.7254C260.71 54.3567 261.976 55.5009 262.689 57.1581C263.401 58.8153 263.796 61.2222 263.796 64.3788C263.796 67.5354 263.44 69.8633 262.689 71.56C261.976 73.2567 260.71 74.4009 258.93 75.0322C257.149 75.6635 254.657 75.9792 251.452 75.9792C248.247 75.9792 245.794 75.6635 244.053 75.0322C242.312 74.4009 241.086 73.2172 240.413 71.56C239.74 69.8633 239.384 67.4959 239.384 64.3788C239.384 61.2617 239.74 58.8153 240.413 57.1581Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M298.573 79.2147H321.007L324.607 87.9347H339.84L319.385 40.8229H300.433L280.056 87.9347H294.933L298.573 79.2147ZM309.335 52.7389H310.245L313.331 60.6698L316.061 67.2986H303.519L306.288 60.6698L309.335 52.7389Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M358.083 87.9347H368.726C373.949 87.9347 378.459 86.9877 382.258 85.1727C386.056 83.3182 389.023 80.6351 391.081 77.1234C393.138 73.6117 394.167 69.3504 394.167 64.3788C394.167 59.4072 393.138 55.1458 391.081 51.6341C389.023 48.1224 386.056 45.4394 382.258 43.5849C378.459 41.7304 373.949 40.8229 368.726 40.8229H344.828V87.9347H358.083ZM368.726 52.6995C371.535 52.6995 373.79 52.9362 375.413 53.4097C377.074 53.8832 378.222 54.9485 378.934 56.5663C379.646 58.184 380.002 60.8276 380.002 64.3788C380.002 67.9299 379.646 70.4946 378.934 72.1518C378.222 73.809 377.035 74.8744 375.413 75.3479C373.751 75.8213 371.535 76.0581 368.726 76.0581H358.083V52.6995H368.726Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M415.929 71.8755H421.349C423.09 71.8755 424.435 71.9938 425.424 72.27C426.414 72.5068 427.205 72.9803 427.838 73.651C428.431 74.3218 429.025 75.2293 429.579 76.3736L435.237 87.8951H450.549L444.693 76.0974C443.783 74.3218 442.833 72.8224 441.765 71.6387C440.697 70.455 438.956 69.5475 436.503 68.9162V68.2059C439.51 67.8508 441.963 67.1011 443.823 65.9963C445.722 64.8915 447.067 63.4316 447.938 61.6166C448.808 59.8016 449.243 57.6709 449.243 55.1851C449.243 52.1074 448.531 49.4638 447.107 47.3331C445.682 45.2024 443.546 43.5847 440.736 42.4404C437.927 41.3356 434.406 40.7438 430.212 40.7438H402.634V87.8556H415.889L415.929 71.8755ZM415.929 52.6993H430.093C432.032 52.6993 433.377 53.0149 434.169 53.6068C434.96 54.1987 435.356 55.4613 435.356 57.3158C435.356 59.3281 434.96 60.6302 434.169 61.1826C433.377 61.735 431.992 62.0112 430.093 62.0112H415.929V52.6993Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M466.454 86.1197C470.015 87.7769 474.525 88.6055 480.025 88.6055C485.524 88.6055 490.035 87.7769 493.596 86.1197C497.157 84.4625 499.808 82.095 501.549 79.0174C503.29 75.9397 504.16 72.3097 504.16 68.1667V40.8229H490.905V67.1408C490.905 69.3898 490.628 71.1654 490.075 72.428C489.521 73.6907 488.452 74.5982 486.909 75.1111C485.366 75.6241 483.071 75.9003 480.064 75.9003C477.057 75.9003 474.842 75.6635 473.259 75.1111C471.676 74.5982 470.608 73.6907 470.054 72.428C469.5 71.1654 469.223 69.3898 469.223 67.1408V40.8229H455.969V68.1667C455.969 72.3491 456.839 75.9792 458.58 79.0174C460.242 82.095 462.893 84.4625 466.454 86.1197Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M525.567 69.5081L525.013 60.4724H525.923L531.897 69.7843L545.864 87.9346H559.989V40.7833H546.735V59.0125L547.368 69.2714H546.458L539.533 58.4601L526.398 40.7833H512.312V87.9346H525.567V69.5081Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M580.284 69.5081L579.731 60.4724H580.641L586.615 69.7843L600.582 87.9346H614.707V40.7833H601.452V59.0125L602.085 69.2714H601.175L594.251 58.4601L581.115 40.7833H567.03V87.9346H580.284V69.5081Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M626.062 40.7833H622.461V87.9346H626.062H635.716H664.401V76.0185H635.716V70.1394H663.373V58.3023H635.716V52.6994H664.401V40.7833H635.716H626.062Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M710.774 71.6387C709.705 70.455 707.965 69.5475 705.511 68.9162V68.2059C708.518 67.8508 710.972 67.1011 712.831 65.9963C714.73 64.8915 716.076 63.4316 716.946 61.6166C717.816 59.8016 718.252 57.6709 718.252 55.1851C718.252 52.1074 717.54 49.4638 716.115 47.3331C714.691 45.2024 712.554 43.5847 709.745 42.4404C706.936 41.3356 703.414 40.7438 699.22 40.7438H671.643V87.8556H684.898V71.836H690.318C692.059 71.836 693.404 71.9544 694.393 72.2306C695.383 72.4673 696.174 72.9408 696.807 73.6116C697.4 74.2823 697.994 75.1898 698.548 76.3341L704.206 87.8556H719.518L713.662 76.0579C712.831 74.3218 711.842 72.8224 710.774 71.6387ZM703.217 61.1826C702.425 61.735 701.04 62.0112 699.141 62.0112H684.977V52.6598H699.141C701.08 52.6598 702.425 52.9755 703.217 53.5673C704.008 54.1592 704.404 55.4218 704.404 57.2763C704.404 59.3281 704.008 60.6302 703.217 61.1826Z", fill: "#0E1C14" })));
const SvgLogoTinyLight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 47, height: 56, viewBox: "0 0 47 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1625_6827)" }, /* @__PURE__ */ React.createElement("path", { d: "M1.77707 47.7586H10.0875L1.77707 33.0299V47.7586Z", fill: "#00FFFF" }), /* @__PURE__ */ React.createElement("path", { d: "M10.1137 22.9314C10.1137 22.8927 10.1137 22.854 10.1137 22.8282C10.1137 22.8024 10.1137 22.7509 10.1137 22.7122H0.522675C0.522675 22.7509 0.522675 22.7895 0.522675 22.8282C0.522675 22.8669 0.522675 22.9056 0.522675 22.9314H10.1137Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M10.558 19.4749L1.22829 17.2437C1.18909 17.4113 1.14989 17.579 1.11069 17.7337L10.4404 19.965C10.4796 19.7973 10.5188 19.6296 10.558 19.4749Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M11.7601 16.5343L3.20135 12.2653C3.07068 12.4974 2.95308 12.7296 2.83548 12.9746L11.3942 17.2436C11.4988 16.9986 11.6294 16.7664 11.7601 16.5343Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M13.6156 14.0064L6.24592 7.9447C5.99765 8.21555 5.76245 8.48639 5.54031 8.77013L12.91 14.8319C13.1321 14.5481 13.3673 14.2644 13.6156 14.0064Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M16.0199 11.9816L10.2052 4.44958C9.82622 4.70753 9.44729 4.99127 9.09448 5.27501L14.9092 12.7941C15.262 12.5104 15.6279 12.2395 16.0199 11.9816Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M18.8554 10.5757L14.8961 1.93457C14.3735 2.14093 13.8508 2.36018 13.3542 2.60523L17.3135 11.2335C17.81 10.9885 18.3196 10.7563 18.8554 10.5757Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M22.0044 9.87934L20.1751 0.567505C19.5087 0.657786 18.8684 0.773861 18.2281 0.915731L20.0575 10.2147C20.6847 10.0599 21.338 9.94383 22.0044 9.87934Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M25.3626 9.96956L25.8069 0.490057C25.0621 0.412673 24.3042 0.361084 23.5333 0.361084L23.089 9.82769C23.1543 9.82769 23.2197 9.82769 23.2981 9.82769C24.0037 9.81479 24.6831 9.86638 25.3626 9.96956Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M31.1904 1.74108C30.3933 1.44445 29.5701 1.1994 28.7338 0.993042L26.0551 10.0985C26.9045 10.2791 27.7277 10.537 28.4986 10.8724L31.1904 1.74108Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M31.2688 12.4717L35.999 4.17871C35.215 3.64992 34.3787 3.17272 33.5294 2.76001L28.8253 11.0272C29.6877 11.4141 30.5109 11.9042 31.2688 12.4717Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M46.0473 22.106C46.0081 20.7517 45.8383 19.4233 45.5639 18.1465L39.3702 19.0364L45.2111 16.7407C44.8713 15.5412 44.4271 14.3805 43.9044 13.2713L37.2665 15.8895L43.1596 11.8397C42.5846 10.8466 41.9574 9.89223 41.2388 9.00232L34.4179 13.6969L40.0366 7.59652C39.3179 6.83558 38.5601 6.11333 37.7369 5.45557L31.2819 12.4717C34.444 14.8448 36.4825 18.6108 36.4825 22.8153C36.4825 25.9364 35.3195 28.9931 33.2419 31.3533C30.9291 33.9715 27.8323 35.3386 24.3826 35.7771C19.2996 36.409 14.7393 34.4487 10.0614 32.7204C10.0614 32.7204 23.7423 55.5099 23.9122 55.6002C24.069 55.6776 24.252 55.6002 24.4349 55.6002C27.8323 55.6002 31.2296 55.6002 34.64 55.6002C32.288 52.0406 29.936 48.468 27.584 44.9084C32.667 43.9411 37.3841 41.2068 40.703 37.299L40.7814 37.2216C41.8268 35.9834 42.7414 34.6163 43.5124 33.1718L43.7215 32.772C44.4009 31.4178 44.9497 29.9862 45.3417 28.4901L41.8268 27.3165L45.5377 27.6518C45.8383 26.2718 46.0212 24.8531 46.0604 23.3957L40.5724 22.8927L46.0473 22.106Z", fill: "#0E1C14" })));
const SvgLogoWithTaglineLight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 579, height: 132, viewBox: "0 0 579 132", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M175.479 107.203H178.465V93.8062H174.394L171.348 100.399L170.142 103.544H169.93L168.664 100.399L165.528 93.8062H161.487V107.203H164.472V100.399L164.352 98.2818H164.563L165.347 100.399L168.151 106.416H171.77L174.575 100.399L175.359 98.2818H175.57L175.479 100.399V107.203Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M191.975 94.4415C190.889 93.8669 189.592 93.5947 188.085 93.5947C186.577 93.5947 185.34 93.8669 184.255 94.4415C183.169 95.016 182.325 95.8023 181.752 96.8305C181.179 97.8586 180.877 99.0683 180.877 100.49C180.877 101.911 181.179 103.12 181.752 104.149C182.325 105.177 183.169 105.993 184.255 106.538C185.34 107.082 186.607 107.384 188.085 107.384C189.562 107.384 190.889 107.112 191.975 106.538C193.06 105.963 193.875 105.177 194.478 104.149C195.081 103.12 195.352 101.911 195.352 100.49C195.352 99.0683 195.051 97.8586 194.478 96.8305C193.905 95.8023 193.06 95.016 191.975 94.4415ZM191.764 102.848C191.492 103.423 191.07 103.846 190.467 104.118C189.864 104.391 189.08 104.512 188.115 104.512C187.15 104.512 186.366 104.391 185.793 104.118C185.22 103.846 184.767 103.423 184.526 102.848C184.255 102.274 184.134 101.488 184.134 100.49C184.134 99.4916 184.255 98.7054 184.526 98.1308C184.798 97.5562 185.22 97.1329 185.793 96.8607C186.366 96.5885 187.15 96.4676 188.115 96.4676C189.08 96.4676 189.894 96.5885 190.467 96.8607C191.07 97.1329 191.492 97.526 191.764 98.1308C192.035 98.7356 192.156 99.4916 192.156 100.49C192.156 101.488 192.035 102.274 191.764 102.848Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M200.991 107.203H204.429C205.877 107.203 207.113 106.931 208.138 106.416C209.164 105.902 209.978 105.116 210.551 104.118C211.124 103.12 211.395 101.911 211.395 100.52C211.395 99.1285 211.124 97.9189 210.551 96.921C209.978 95.923 209.164 95.167 208.138 94.6227C207.083 94.0784 205.847 93.8364 204.429 93.8364H197.976V107.233L200.991 107.203ZM204.429 96.4976C205.334 96.4976 206.088 96.6186 206.631 96.8302C207.173 97.0419 207.596 97.4351 207.837 98.0096C208.078 98.5842 208.229 99.4007 208.229 100.489C208.229 101.578 208.108 102.364 207.837 102.969C207.565 103.574 207.173 103.937 206.631 104.179C206.088 104.39 205.334 104.511 204.429 104.511H200.991V96.4976H204.429Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M225.237 96.4976V93.8062H216.914H214.743H213.898V107.203H214.743H216.914H225.237V104.511H216.914V101.79H224.935V99.1285H216.914V96.4976H225.237Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M235.128 93.8062H227.74V107.203H230.725V102.334H232.686C233.198 102.334 233.62 102.364 233.922 102.455C234.224 102.546 234.495 102.697 234.676 102.878C234.887 103.09 235.068 103.362 235.249 103.695L237.088 107.172H240.556L238.626 103.574C238.385 103.12 238.114 102.697 237.812 102.394C237.511 102.062 237.058 101.82 236.485 101.669V101.517C237.33 101.427 238.023 101.245 238.566 100.913C239.139 100.61 239.531 100.187 239.833 99.6728C240.104 99.1587 240.255 98.5237 240.255 97.7979C240.255 96.9512 240.044 96.2254 239.652 95.6206C239.26 95.0158 238.657 94.5622 237.903 94.2598C237.149 93.9574 236.244 93.8062 235.128 93.8062ZM236.666 99.7031C236.335 99.945 235.822 100.066 235.098 100.066H230.725V96.4976H235.098C235.792 96.4976 236.335 96.6185 236.666 96.8907C236.998 97.1628 237.179 97.6165 237.179 98.2818C237.179 98.9773 236.998 99.4611 236.666 99.7031Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M250.719 100.126L245.924 93.8062H242.758V107.203H245.743V100.731L245.623 98.2818H245.804L247.522 100.792L252.438 107.203H255.635V93.8062H252.649V100.247L252.77 102.969H252.559L250.719 100.126Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M271.708 100.489L272.643 96.6488H272.854L273.819 100.489L275.809 107.203H280.242L283.408 93.8062H280.152L278.523 101.397L278.071 104.33H277.86L277.226 101.397L275.025 93.8062H270.562L268.33 101.397L267.727 104.33H267.486L267.034 101.397L265.435 93.8062H262.058L265.224 107.203H269.687L271.708 100.489Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M289.349 104.239H296.014L297.28 107.203H300.718L294.838 93.8062H290.555L284.705 107.203H288.053L289.349 104.239ZM291.792 98.6144L292.606 96.5278H292.817L293.631 98.6144L294.868 101.548H290.495L291.792 98.6144Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M312.931 100.247C312.328 99.8845 311.544 99.6426 310.549 99.4612L306.81 98.8564C306.448 98.7959 306.146 98.7052 305.905 98.6144C305.664 98.5237 305.513 98.4027 305.392 98.2213C305.272 98.0701 305.242 97.8584 305.242 97.5863C305.242 97.2839 305.332 97.0419 305.513 96.8605C305.694 96.679 305.965 96.5278 306.387 96.4371C306.78 96.3464 307.352 96.2859 308.076 96.2859C308.981 96.2859 309.644 96.3464 310.127 96.4674C310.609 96.5883 310.941 96.8 311.122 97.0722C311.303 97.3443 311.393 97.677 311.393 98.1003V98.3725H314.409V98.2515C314.409 97.3141 314.198 96.4976 313.746 95.7718C313.293 95.0461 312.63 94.5017 311.755 94.1086C310.881 93.7155 309.735 93.5038 308.378 93.5038C307.232 93.5038 306.297 93.6247 305.513 93.8667C304.729 94.1086 304.096 94.411 303.613 94.8041C303.131 95.1973 302.799 95.6509 302.558 96.1347C302.316 96.6186 302.226 97.1326 302.226 97.6467C302.226 98.3725 302.377 99.0076 302.678 99.5217C302.98 100.036 303.432 100.459 303.975 100.762C304.518 101.064 305.211 101.276 306.026 101.427L309.765 101.971C310.428 102.092 310.911 102.243 311.182 102.425C311.454 102.606 311.574 102.909 311.574 103.332C311.574 103.634 311.484 103.876 311.333 104.058C311.182 104.239 310.881 104.39 310.459 104.481C310.036 104.572 309.433 104.602 308.619 104.602C307.714 104.602 307.021 104.542 306.538 104.421C306.056 104.3 305.724 104.118 305.543 103.846C305.362 103.574 305.272 103.271 305.272 102.848V102.485H302.286V102.606C302.286 103.634 302.528 104.511 303.04 105.207C303.523 105.902 304.246 106.447 305.181 106.779C306.116 107.112 307.262 107.324 308.619 107.324C310.036 107.324 311.182 107.142 312.057 106.749C312.931 106.356 313.565 105.842 313.987 105.207C314.379 104.572 314.59 103.907 314.59 103.181C314.59 102.576 314.469 102.001 314.198 101.487C313.957 101.064 313.535 100.61 312.931 100.247Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M321.466 93.8062H316.49V96.4976H321.466V107.203H324.451V96.4976H329.427V93.8062H324.451H321.466Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M334.674 107.203H342.997V104.511H334.674V101.79H342.696V99.1285H334.674V96.4976H342.997V93.8062H334.674H332.533H331.689V107.203H332.533H334.674Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M355.361 104.965V101.729H358.528V99.2494H355.361V96.0439H352.798V99.2494H349.601V101.729H352.798V104.965H355.361Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M365.403 107.203H368.389V102.334H370.379C370.892 102.334 371.314 102.364 371.615 102.455C371.917 102.546 372.188 102.697 372.4 102.878C372.611 103.09 372.792 103.362 372.973 103.695L374.812 107.172H378.28L376.35 103.574C376.109 103.12 375.837 102.697 375.536 102.394C375.234 102.062 374.812 101.82 374.209 101.669V101.517C375.053 101.427 375.747 101.245 376.29 100.913C376.863 100.61 377.255 100.187 377.556 99.6728C377.828 99.1587 377.978 98.5237 377.978 97.7979C377.978 96.9512 377.767 96.2254 377.375 95.6206C376.983 95.0158 376.38 94.5622 375.626 94.2598C374.842 93.9574 373.907 93.8062 372.822 93.8062H365.433L365.403 107.203ZM368.389 96.4976H372.761C373.455 96.4976 373.998 96.6185 374.33 96.8907C374.661 97.1628 374.842 97.6165 374.842 98.2818C374.842 98.9773 374.661 99.4611 374.33 99.7031C373.998 99.945 373.485 100.066 372.761 100.066H368.389V96.4976Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M391.7 96.4976V93.8062H383.376H381.235H380.391V107.203H381.235H383.376H391.7V104.511H383.376V101.79H391.398V99.1285H383.376V96.4976H391.7Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M407.893 99.3707V99.0683C407.893 97.9191 407.622 96.9514 407.049 96.1349C406.476 95.3184 405.692 94.6834 404.697 94.26C403.672 93.8064 402.465 93.5947 401.078 93.5947C399.691 93.5947 398.334 93.8669 397.278 94.4415C396.193 95.016 395.379 95.8023 394.806 96.8305C394.233 97.8586 393.931 99.0683 393.931 100.49C393.931 101.911 394.233 103.12 394.806 104.149C395.379 105.177 396.223 105.993 397.278 106.538C398.364 107.112 399.631 107.384 401.078 107.384C402.526 107.384 403.672 107.173 404.697 106.719C405.722 106.266 406.506 105.661 407.049 104.844C407.592 104.028 407.893 103.06 407.893 101.911V101.608H404.546V101.911C404.546 102.788 404.275 103.453 403.732 103.877C403.189 104.3 402.315 104.512 401.108 104.512C400.143 104.512 399.359 104.391 398.756 104.118C398.153 103.846 397.731 103.423 397.459 102.848C397.188 102.274 397.067 101.488 397.067 100.49C397.067 99.4916 397.188 98.7054 397.459 98.1308C397.731 97.5562 398.153 97.1329 398.756 96.8607C399.359 96.5885 400.143 96.4676 401.108 96.4676C402.315 96.4676 403.189 96.6793 403.732 97.1026C404.275 97.526 404.546 98.1913 404.546 99.0683V99.3707H407.893Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M415.282 102.757V107.203H418.297V102.757L424.329 93.8062H420.619L418.056 97.7072L416.94 99.5216H416.699L415.583 97.7072L413.05 93.8062H409.341L415.282 102.757Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M439.738 99.3707V99.0683C439.738 97.9191 439.467 96.9514 438.894 96.1349C438.321 95.3184 437.537 94.6834 436.542 94.26C435.517 93.8064 434.31 93.5947 432.923 93.5947C431.536 93.5947 430.179 93.8669 429.123 94.4415C428.038 95.016 427.224 95.8023 426.651 96.8305C426.078 97.8586 425.776 99.0683 425.776 100.49C425.776 101.911 426.078 103.12 426.651 104.149C427.224 105.177 428.068 105.993 429.123 106.538C430.209 107.112 431.476 107.384 432.923 107.384C434.371 107.384 435.517 107.173 436.542 106.719C437.567 106.266 438.351 105.661 438.894 104.844C439.437 104.028 439.738 103.06 439.738 101.911V101.608H436.391V101.911C436.391 102.788 436.12 103.453 435.577 103.877C435.034 104.3 434.16 104.512 432.953 104.512C431.988 104.512 431.204 104.391 430.601 104.118C429.998 103.846 429.576 103.423 429.304 102.848C429.033 102.274 428.912 101.488 428.912 100.49C428.912 99.4916 429.033 98.7054 429.304 98.1308C429.576 97.5562 429.998 97.1329 430.601 96.8607C431.204 96.5885 431.988 96.4676 432.953 96.4676C434.16 96.4676 435.034 96.6793 435.577 97.1026C436.12 97.526 436.391 98.1913 436.391 99.0683V99.3707H439.738Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M442.211 93.8062V107.203H443.056H445.197H453.158V104.511H445.197V93.8062H442.211Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M458.526 93.8062H455.54V107.203H458.526V93.8062Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M466.035 100.792L470.98 107.203H474.177V93.8062H471.191V100.247L471.312 102.969H471.101L469.261 100.126L464.467 93.8062H461.27V107.203H464.286V100.731L464.165 98.2818H464.346L466.035 100.792Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M490.944 107.203V100.127H483.405V102.334H487.898C487.868 102.848 487.777 103.272 487.566 103.574C487.325 103.907 486.903 104.179 486.33 104.3C485.727 104.451 484.912 104.512 483.827 104.512C482.862 104.512 482.078 104.391 481.475 104.118C480.872 103.846 480.449 103.423 480.178 102.848C479.907 102.274 479.786 101.488 479.786 100.49C479.786 99.4916 479.937 98.7054 480.208 98.1308C480.48 97.5562 480.932 97.1329 481.535 96.8607C482.138 96.5885 482.952 96.4676 483.947 96.4676C485.214 96.4676 486.149 96.649 486.692 97.0421C487.235 97.405 487.536 97.9796 487.536 98.7961V98.9473H490.883V98.7961C490.883 97.7074 490.612 96.8002 490.039 96.014C489.496 95.258 488.682 94.6531 487.657 94.2298C486.631 93.8064 485.425 93.5947 484.038 93.5947C482.5 93.5947 481.203 93.8669 480.087 94.4415C478.972 95.016 478.127 95.8023 477.524 96.8305C476.921 97.8586 476.62 99.0683 476.62 100.49C476.62 101.911 476.891 103.12 477.434 104.149C477.977 105.177 478.73 105.993 479.726 106.538C480.721 107.112 481.897 107.384 483.254 107.384C484.219 107.384 485.033 107.263 485.666 106.991C486.3 106.719 486.812 106.356 487.204 105.903C487.566 105.449 487.838 104.905 488.019 104.33H488.169V107.203H490.944Z", fill: "#2C4030" }), /* @__PURE__ */ React.createElement("path", { d: "M171.589 61.842H175.72C177.047 61.842 178.073 61.9327 178.827 62.1444C179.58 62.3258 180.184 62.6887 180.666 63.2028C181.118 63.7169 181.571 64.4124 182.023 65.2894L186.335 74.1196H198.006L193.543 65.0777C192.849 63.7169 192.125 62.5677 191.311 61.6605C190.497 60.7533 189.17 60.0578 187.3 59.5739V59.0296C189.592 58.7574 191.462 58.1829 192.879 57.3361C194.327 56.4894 195.352 55.3705 196.016 53.9794C196.679 52.5884 197.011 50.9554 197.011 49.0502C197.011 46.6915 196.468 44.6653 195.382 43.0324C194.297 41.3994 192.668 40.1595 190.527 39.2825C188.386 38.4358 185.702 37.9822 182.506 37.9822H161.487V74.0894H171.589V61.842ZM171.589 47.1451H182.385C183.863 47.1451 184.888 47.387 185.491 47.8406C186.094 48.2942 186.396 49.2619 186.396 50.6832C186.396 52.2255 186.094 53.2234 185.491 53.6468C184.888 54.0701 183.833 54.2818 182.385 54.2818H171.589V47.1451Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M210.943 72.3959C213.928 73.9381 217.517 74.6942 221.679 74.6942C225.84 74.6942 229.61 73.9381 232.625 72.3959C235.611 70.8536 237.903 68.7065 239.471 65.9244C241.039 63.1423 241.823 59.8461 241.823 56.0962C241.823 52.3464 241.039 49.0502 239.471 46.2681C237.903 43.4859 235.611 41.3388 232.625 39.7966C229.64 38.2543 225.991 37.4983 221.679 37.4983C217.366 37.4983 213.959 38.2543 210.943 39.7966C207.927 41.3388 205.666 43.4859 204.097 46.2681C202.529 49.0502 201.745 52.3162 201.745 56.066C201.745 59.8158 202.529 63.112 204.097 65.8942C205.696 68.7065 207.957 70.8536 210.943 72.3959ZM213.265 50.5622C213.778 49.2921 214.712 48.4151 216.039 47.9313C217.366 47.4474 219.236 47.2055 221.679 47.2055C224.121 47.2055 226.021 47.4474 227.378 47.9313C228.735 48.4151 229.7 49.2921 230.243 50.5622C230.786 51.8323 231.087 53.677 231.087 56.0962C231.087 58.5155 230.816 60.2997 230.243 61.6C229.7 62.9004 228.735 63.7773 227.378 64.2612C226.021 64.745 224.121 64.9869 221.679 64.9869C219.236 64.9869 217.366 64.745 216.039 64.2612C214.712 63.7773 213.778 62.8701 213.265 61.6C212.752 60.2997 212.481 58.4852 212.481 56.0962C212.481 53.7072 212.752 51.8323 213.265 50.5622Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M257.595 67.4667H274.693L277.437 74.1498H289.048L273.457 38.0426H259.012L243.482 74.1498H254.82L257.595 67.4667ZM265.797 47.1752H266.491L268.843 53.2536L270.924 58.334H261.364L263.475 53.2536L265.797 47.1752Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M302.95 74.1498H311.062C315.042 74.1498 318.48 73.424 321.375 72.033C324.27 70.6117 326.532 68.5553 328.1 65.8639C329.668 63.1725 330.452 59.9065 330.452 56.0962C330.452 52.2859 329.668 49.0199 328.1 46.3285C326.532 43.6371 324.27 41.5807 321.375 40.1594C318.48 38.7381 315.042 38.0426 311.062 38.0426H292.847V74.1498H302.95ZM311.062 47.145C313.203 47.145 314.922 47.3264 316.158 47.6893C317.425 48.0522 318.299 48.8687 318.842 50.1086C319.385 51.3484 319.656 53.3746 319.656 56.0962C319.656 58.8179 319.385 60.7835 318.842 62.0536C318.299 63.3237 317.395 64.1402 316.158 64.5031C314.892 64.866 313.203 65.0474 311.062 65.0474H302.95V47.145H311.062Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M347.038 61.842H351.17C352.496 61.842 353.522 61.9327 354.276 62.1444C355.03 62.3258 355.633 62.6887 356.115 63.2028C356.568 63.7169 357.02 64.4124 357.442 65.2894L361.754 74.1196H373.425L368.962 65.0777C368.268 63.7169 367.544 62.5677 366.73 61.6605C365.916 60.7533 364.589 60.0578 362.719 59.5739V59.0296C365.011 58.7574 366.881 58.1829 368.298 57.3361C369.746 56.4894 370.771 55.3705 371.435 53.9794C372.098 52.5884 372.43 50.9554 372.43 49.0502C372.43 46.6915 371.887 44.6653 370.801 43.0324C369.716 41.3994 368.087 40.1595 365.946 39.2825C363.805 38.4358 361.121 37.9822 357.925 37.9822H336.906V74.0894H347.008L347.038 61.842ZM347.038 47.1451H357.834C359.312 47.1451 360.337 47.387 360.94 47.8406C361.543 48.2942 361.845 49.2619 361.845 50.6832C361.845 52.2255 361.543 53.2234 360.94 53.6468C360.337 54.0701 359.282 54.2818 357.834 54.2818H347.038V47.1451Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M385.548 72.7588C388.262 74.0289 391.7 74.6639 395.891 74.6639C400.083 74.6639 403.521 74.0289 406.235 72.7588C408.949 71.4887 410.969 69.6742 412.296 67.3155C413.623 64.9567 414.287 62.1746 414.287 58.9993V38.0426H404.184V58.213C404.184 59.9368 403.973 61.2976 403.551 62.2653C403.129 63.233 402.315 63.9285 401.138 64.3216C399.962 64.7148 398.213 64.9265 395.921 64.9265C393.63 64.9265 391.941 64.745 390.735 64.3216C389.528 63.9285 388.714 63.233 388.292 62.2653C387.87 61.2976 387.659 59.9368 387.659 58.213V38.0426H377.556V58.9993C377.556 62.2048 378.22 64.9869 379.547 67.3155C380.813 69.6742 382.834 71.4887 385.548 72.7588Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M430.601 60.0274L430.179 53.1024H430.873L435.426 60.2391L446.071 74.1498H456.837V38.0123H446.735V51.9835L447.217 59.846H446.524L441.246 51.5601L431.234 38.0123H420.499V74.1498H430.601V60.0274Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M472.307 60.0274L471.885 53.1024H472.579L477.132 60.2391L487.777 74.1498H498.543V38.0123H488.441V51.9835L488.923 59.846H488.23L482.952 51.5601L472.94 38.0123H462.205V74.1498H472.307V60.0274Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M507.198 38.0123H504.454V74.1498H507.198H514.556H536.419V65.0171H514.556V60.5113H535.635V51.4391H514.556V47.145H536.419V38.0123H514.556H507.198Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M571.763 61.6605C570.948 60.7533 569.621 60.0578 567.752 59.5739V59.0296C570.044 58.7574 571.913 58.1829 573.331 57.3361C574.778 56.4894 575.803 55.3705 576.467 53.9794C577.13 52.5884 577.462 50.9554 577.462 49.0502C577.462 46.6915 576.919 44.6653 575.834 43.0324C574.748 41.3994 573.12 40.1595 570.978 39.2825C568.837 38.4358 566.153 37.9822 562.957 37.9822H541.938V74.0894H552.04V61.8117H556.172C557.499 61.8117 558.524 61.9025 559.278 62.1141C560.032 62.2956 560.635 62.6585 561.117 63.1726C561.57 63.6866 562.022 64.3822 562.444 65.2592L566.757 74.0894H578.427L573.964 65.0475C573.331 63.7169 572.577 62.5677 571.763 61.6605ZM566.003 53.6468C565.4 54.0701 564.344 54.2818 562.897 54.2818H552.101V47.1148H562.897C564.374 47.1148 565.4 47.3568 566.003 47.8104C566.606 48.264 566.907 49.2317 566.907 50.653C566.907 52.2255 566.606 53.2234 566.003 53.6468Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M3.43781 112.344H22.6172L3.43781 77.809V112.344Z", fill: "#00FFFF" }), /* @__PURE__ */ React.createElement("path", { d: "M22.6775 54.1314C22.6775 54.0406 22.6775 53.9497 22.6775 53.8891C22.6775 53.8285 22.6775 53.7073 22.6775 53.6165H0.542816C0.542816 53.7073 0.542816 53.7982 0.542816 53.8891C0.542816 53.98 0.542816 54.0708 0.542816 54.1314H22.6775Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M23.7028 46.0262L2.17125 40.7946C2.08078 41.1877 1.99031 41.5808 1.89984 41.9437L23.4314 47.1753C23.5219 46.7822 23.6123 46.3891 23.7028 46.0262Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M26.4772 39.1313L6.72484 29.1217C6.42327 29.666 6.15187 30.2104 5.88046 30.7849L25.6328 40.7946C25.8741 40.22 26.1756 39.6757 26.4772 39.1313Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M30.7594 33.2041L13.7512 18.9911C13.1783 19.6261 12.6355 20.2612 12.1228 20.9265L29.1309 35.1395C29.6436 34.4742 30.1864 33.809 30.7594 33.2041Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M36.3081 28.4564L22.8886 10.7959C22.0141 11.4007 21.1395 12.066 20.3253 12.7313L33.7448 30.3615C34.5591 29.6962 35.4034 29.0612 36.3081 28.4564Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M42.852 25.1601L33.7147 4.89893C32.5084 5.38277 31.3022 5.89686 30.1562 6.47143L39.2936 26.7024C40.4395 26.1278 41.6156 25.5835 42.852 25.1601Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M50.1197 23.5272L45.8978 1.69348C44.3599 1.90517 42.8822 2.17733 41.4045 2.50998L45.6264 24.3134C47.0739 23.9505 48.5817 23.6784 50.1197 23.5272Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M57.8698 23.7388L58.8952 1.512C57.1762 1.33056 55.4272 1.20959 53.648 1.20959L52.6227 23.4062C52.7734 23.4062 52.9242 23.4062 53.1052 23.4062C54.7336 23.3759 56.3017 23.4969 57.8698 23.7388Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M71.3195 4.44536C69.48 3.74983 67.5802 3.17526 65.6502 2.69141L59.4681 24.0412C61.4283 24.4646 63.3281 25.0694 65.1074 25.8557L71.3195 4.44536Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M71.5005 29.6055L82.417 10.1608C80.6077 8.92095 78.6777 7.80205 76.7175 6.83435L65.8613 26.2185C67.8516 27.1258 69.7514 28.2749 71.5005 29.6055Z", fill: "#0E1C14" }), /* @__PURE__ */ React.createElement("path", { d: "M105.607 52.1952C105.517 49.02 105.125 45.9052 104.491 42.9114L90.1973 44.998L103.677 39.6151C102.893 36.8028 101.868 34.0811 100.662 31.4804L85.3422 37.6193L98.9427 28.1237C97.6158 25.7952 96.1683 23.5574 94.5097 21.4708L78.7681 32.4784L91.7353 18.1746C90.0767 16.3904 88.3277 14.6969 86.4278 13.1547L71.5306 29.6055C78.8284 35.1698 83.5328 44 83.5328 53.8584C83.5328 61.1767 80.8489 68.3437 76.0541 73.8777C70.7164 80.0165 63.5694 83.222 55.6081 84.2502C43.8773 85.732 33.3528 81.1354 22.5569 77.0832C22.5569 77.0832 54.1305 130.518 54.5225 130.73C54.8844 130.911 55.3066 130.73 55.7288 130.73C63.5694 130.73 71.41 130.73 79.2808 130.73C73.8527 122.384 68.4245 114.007 62.9964 105.661C74.7272 103.392 85.6136 96.9815 93.2733 87.8186L93.4542 87.6371C95.8667 84.734 97.9777 81.5285 99.7569 78.1416L100.239 77.2041C101.808 74.0289 103.074 70.6722 103.979 67.1643L95.8667 64.4124L104.431 65.1987C105.125 61.9629 105.547 58.6365 105.637 55.2193L92.9717 54.0399L105.607 52.1952Z", fill: "#0E1C14" }));
const SvgEmptyServices = (props) => /* @__PURE__ */ React.createElement("svg", { width: 329, height: 136, viewBox: "0 0 329 136", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_922_59657)" }, /* @__PURE__ */ React.createElement("path", { d: "M203.818 47C206.968 47 209.949 48.4062 211.955 50.8438L222.812 64.325C224.068 65.6562 224.668 67.3438 224.668 69.0688V86C224.668 87.65 223.993 89.15 222.905 90.2375C220.018 84.1813 213.83 80 206.668 80C198.83 80 192.155 85.0062 189.699 92H169.637C167.18 85.0062 160.505 80 152.668 80C146.405 80 140.893 83.1875 137.668 88.0437C134.443 83.1875 128.93 80 122.668 80C115.505 80 109.32 84.1813 106.422 90.2375C105.338 89.15 104.668 87.65 104.668 86V83C104.668 79.6813 107.355 77 110.668 77H185.668V51.5C185.668 49.0062 187.674 47 190.168 47H203.818ZM204.98 56.5437C204.699 56.2062 204.268 56 203.818 56H194.668V68H214.187L204.98 56.5437Z", fill: "#E0E0E0" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.4, d: "M134.668 98C134.668 104.619 129.287 110 122.668 110C116.04 110 110.668 104.619 110.668 98C110.668 91.3813 116.04 86 122.668 86C129.287 86 134.668 91.3813 134.668 98ZM164.668 98C164.668 104.619 159.287 110 152.668 110C146.049 110 140.668 104.619 140.668 98C140.668 91.3813 146.049 86 152.668 86C159.287 86 164.668 91.3813 164.668 98ZM218.668 98C218.668 104.619 213.287 110 206.668 110C200.049 110 194.668 104.619 194.668 98C194.668 91.3813 200.049 86 206.668 86C213.287 86 218.668 91.3813 218.668 98Z", fill: "#E0E0E0" })), /* @__PURE__ */ React.createElement("g", { style: {
  mixBlendMode: "luminosity"
}, opacity: 0.5 }, /* @__PURE__ */ React.createElement("path", { d: "M264.593 100.539C264.543 101.109 264.443 101.689 264.263 102.249C262.723 106.929 256.463 108.949 256.453 108.949C256.453 108.949 261.253 110.549 264.333 108.349C267.413 106.149 267.603 100.989 267.603 100.989C267.603 100.989 266.283 100.619 264.593 100.539Z", fill: "#42EDBF" }), /* @__PURE__ */ React.createElement("path", { d: "M259.434 101.74C260.954 100.66 262.944 100.46 264.594 100.54C264.944 96.31 262.014 92 262.014 92C262.014 92 255.564 94.4 254.024 99.08C252.484 103.76 256.444 108.95 256.444 108.95C256.454 108.94 256.364 103.94 259.434 101.74Z", fill: "#B0E55C" }), /* @__PURE__ */ React.createElement("path", { d: "M264.264 102.239C264.444 101.679 264.554 101.109 264.594 100.529C262.954 100.449 260.954 100.649 259.434 101.729C256.354 103.929 256.444 108.929 256.444 108.939C256.464 108.939 262.724 106.919 264.264 102.239Z", fill: "#0D8720" })), /* @__PURE__ */ React.createElement("g", { style: {
  mixBlendMode: "luminosity"
}, opacity: 0.5 }, /* @__PURE__ */ React.createElement("path", { d: "M81.2924 103.828C81.253 104.284 81.174 104.748 81.032 105.195C79.8164 108.937 74.8751 110.552 74.8672 110.552C74.8672 110.552 78.656 111.831 81.0872 110.072C83.5184 108.313 83.6684 104.188 83.6684 104.188C83.6684 104.188 82.6264 103.892 81.2924 103.828Z", fill: "#42EDBF" }), /* @__PURE__ */ React.createElement("path", { d: "M77.219 104.787C78.4188 103.923 79.9896 103.763 81.292 103.827C81.5683 100.446 79.2555 97 79.2555 97C79.2555 97 74.1643 98.9187 72.9487 102.66C71.7331 106.402 74.8589 110.551 74.8589 110.551C74.8668 110.543 74.7958 106.546 77.219 104.787Z", fill: "#B0E55C" }), /* @__PURE__ */ React.createElement("path", { d: "M81.0323 105.186C81.1743 104.739 81.2612 104.283 81.2927 103.819C79.9982 103.755 78.4195 103.915 77.2197 104.779C74.7886 106.537 74.8596 110.535 74.8596 110.543C74.8754 110.543 79.8167 108.928 81.0323 105.186Z", fill: "#0D8720" })), /* @__PURE__ */ React.createElement("g", { style: {
  mixBlendMode: "luminosity"
}, opacity: 0.5 }, /* @__PURE__ */ React.createElement("path", { d: "M46.942 95.8736C46.8159 96.6807 46.756 97.519 46.8145 98.3571C47.3527 105.374 55.3795 110.334 55.3934 110.337C55.3934 110.337 48.1574 110.897 44.6223 106.786C41.0872 102.674 42.5944 95.4581 42.5944 95.4581C42.5944 95.4581 44.5603 95.4011 46.942 95.8736Z", fill: "#42EDBF" }), /* @__PURE__ */ React.createElement("path", { d: "M53.7174 99.3168C51.9709 97.2956 49.2674 96.3315 46.9415 95.8728C47.9064 89.8905 53.468 84.9296 53.468 84.9296C53.468 84.9296 61.6289 90.4818 62.1672 97.4985C62.7054 104.515 55.4068 110.34 55.4068 110.34C55.3963 110.323 57.2386 103.425 53.7174 99.3168Z", fill: "#B0E55C" }), /* @__PURE__ */ React.createElement("path", { d: "M46.8182 98.3421C46.7597 97.504 46.8022 96.6761 46.9457 95.8586C49.2577 96.3139 51.9751 97.2815 53.7217 99.3027C57.2568 103.414 55.4145 110.312 55.411 110.326C55.3832 110.319 47.3564 105.359 46.8182 98.3421Z", fill: "#0D8720" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_922_59657" }, /* @__PURE__ */ React.createElement("rect", { width: 120, height: 96, fill: "white", transform: "translate(104.668 20)" }))));
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M56.9016 31.9999C56.9016 33.4491 55.7247 34.6259 54.2755 34.6259H17.1766L31.6906 48.4728C32.7434 49.4743 32.781 51.1427 31.7795 52.185C30.7781 53.2344 29.1173 53.272 28.0673 52.2739L8.81731 33.8989C8.29477 33.4108 8.00085 32.7217 8.00085 31.9999C8.00085 31.278 8.29477 30.5999 8.8143 30.0967L28.0643 11.7217C29.1094 10.7275 30.7719 10.7647 31.7781 11.8147C32.7796 12.8538 32.7419 14.5217 31.6893 15.5269L17.1752 29.3738H54.3736C55.8187 29.3749 56.9016 30.5561 56.9016 31.9999Z" }));
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1824_85)" }, /* @__PURE__ */ React.createElement("path", { d: "M36.9406 11.7252L56.1906 30.1002C56.7102 30.5957 57.0042 31.2825 57.0042 32.0011C57.0042 32.7197 56.7102 33.4055 56.1906 33.902L36.9406 52.2771C35.8913 53.2751 34.2303 53.2375 33.2284 52.1882C32.227 51.1491 32.2646 49.4812 33.3173 48.476L47.8314 34.6291H10.6261C9.17687 34.6291 8 33.4522 8 32.003C8 30.5538 9.17687 29.3791 10.6261 29.3791H47.8245L33.3105 15.5322C32.2594 14.5252 32.2266 12.8572 33.2219 11.8149C34.2281 10.7649 35.7922 10.7277 36.9406 11.7252Z" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1824_85" }, /* @__PURE__ */ React.createElement("rect", { width: 49, height: 56, transform: "translate(8 4)" }))));
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M33.9031 8.30938C33.4 7.79531 32.7219 7.5 32 7.5C31.2781 7.5 30.6 7.79531 30.0969 8.30938L11.7219 27.5594C10.7156 28.6094 10.7594 30.2719 11.8094 31.2672C12.8594 32.2625 14.5219 32.2297 15.5172 31.1797L29.375 16.6766V53.875C29.375 55.3297 30.5453 56.5 32 56.5C33.4547 56.5 34.625 55.3297 34.625 53.875V16.6766L48.4719 31.1906C49.4781 32.2406 51.1297 32.2734 52.1797 31.2781C53.2297 30.2828 53.2625 28.6203 52.2672 27.5703L33.8922 8.32031L33.9031 8.30938Z" }));
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M30.0969 55.6906C30.5891 56.2047 31.2781 56.5 32 56.5C32.7219 56.5 33.4 56.2047 33.9031 55.6906L52.2781 36.4406C53.2844 35.3906 53.2406 33.7281 52.1906 32.7328C51.1406 31.7375 49.4781 31.7703 48.4828 32.8203L34.625 47.3234V10.125C34.625 8.67031 33.4547 7.5 32 7.5C30.5453 7.5 29.375 8.67031 29.375 10.125V47.3234L15.5281 32.8094C14.5219 31.7594 12.8703 31.7266 11.8203 32.7219C10.7703 33.7172 10.7375 35.3797 11.7328 36.4297L30.1078 55.6797L30.0969 55.6906Z" }));
const SvgArrowRightFromBracket = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_110_125)" }, /* @__PURE__ */ React.createElement("path", { d: "M26.6667 48.6666C26.6667 49.7749 25.775 50.6666 24.6667 50.6666H18.6667C14.2483 50.6666 10.6667 47.0849 10.6667 42.6666V21.3333C10.6667 16.9149 14.2483 13.3333 18.6667 13.3333H24.6667C25.775 13.3333 26.6667 14.2283 26.6667 15.3333C26.6667 16.4374 25.775 17.3333 24.6667 17.3333H18.6667C16.4667 17.3333 14.6667 19.1333 14.6667 21.3333V42.6666C14.6667 44.8666 16.4667 46.6666 18.6667 46.6666H24.6667C25.775 46.6666 26.6667 47.5582 26.6667 48.6666ZM52.7917 30.6332L42.2 19.2999C41.4422 18.4926 40.1767 18.4566 39.3742 19.214C38.5695 19.9692 38.5308 21.2348 39.2883 22.0398L46.7 29.9999H25.925C24.8917 29.9999 24 30.8999 24 31.9999C24 33.0999 24.8958 33.9999 25.925 33.9999H46.625L39.1317 41.9632C38.3738 42.7679 38.4129 44.0332 39.2176 44.7891C39.6833 45.1499 40.175 45.3332 40.5917 45.3332C41.1229 45.3332 41.6542 45.1223 42.0475 44.7031L52.6392 33.3697C53.5167 32.5999 53.5167 31.3999 52.7917 30.6332Z" })));
const SvgBarsProgress = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1853_17)" }, /* @__PURE__ */ React.createElement("path", { d: "M54.75 11C57.6484 11 60 13.3505 60 16.25V23.25C60 26.1484 57.6484 28.5 54.75 28.5H9.25C6.35047 28.5 4 26.1484 4 23.25V16.25C4 13.3505 6.35047 11 9.25 11H54.75ZM54.75 16.25H39V23.25H54.75V16.25ZM54.75 35.5C57.6484 35.5 60 37.8516 60 40.75V47.75C60 50.6484 57.6484 53 54.75 53H9.25C6.35047 53 4 50.6484 4 47.75V40.75C4 37.8516 6.35047 35.5 9.25 35.5H54.75ZM54.75 40.75H25V47.75H54.75V40.75Z" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1853_17" }, /* @__PURE__ */ React.createElement("rect", { width: 56, height: 42, transform: "translate(4 11)" }))));
const SvgBarsSolid = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_110_95)" }, /* @__PURE__ */ React.createElement("path", { d: "M13.3333 18.6667C13.3333 17.1942 14.5275 16 16 16H48C49.475 16 50.6667 17.1942 50.6667 18.6667C50.6667 20.1417 49.475 21.3333 48 21.3333H16C14.5275 21.3333 13.3333 20.1417 13.3333 18.6667ZM13.3333 32C13.3333 30.525 14.5275 29.3333 16 29.3333H48C49.475 29.3333 50.6667 30.525 50.6667 32C50.6667 33.475 49.475 34.6667 48 34.6667H16C14.5275 34.6667 13.3333 33.475 13.3333 32ZM48 48H16C14.5275 48 13.3333 46.8083 13.3333 45.3333C13.3333 43.8583 14.5275 42.6667 16 42.6667H48C49.475 42.6667 50.6667 43.8583 50.6667 45.3333C50.6667 46.8083 49.475 48 48 48Z" })));
const SvgCalculator = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_913_1554)" }, /* @__PURE__ */ React.createElement("path", { d: "M46 4H18C14.1347 4 11 7.13469 11 11V53C11 56.8653 14.1347 60 18 60H46C49.8653 60 53 56.8653 53 53V11C53 7.13469 49.8609 4 46 4ZM49.5 53C49.5 54.9294 47.9294 56.5 46 56.5H18C16.0706 56.5 14.5 54.9294 14.5 53V21.5H49.5V53ZM49.5 18H14.5V11C14.5 9.07063 16.0706 7.5 18 7.5H46C47.9294 7.5 49.5 9.07063 49.5 11V18ZM19.75 51.25H33.75C34.7173 51.25 35.5 50.4673 35.5 49.5C35.5 48.5327 34.7173 47.75 33.75 47.75H19.75C18.7831 47.75 18 48.5375 18 49.5C18 50.4625 18.7831 51.25 19.75 51.25ZM42.5 52.125C43.9492 52.125 45.125 50.9492 45.125 49.5C45.125 48.0508 43.9492 46.875 42.5 46.875C41.0508 46.875 39.875 48.0508 39.875 49.5C39.875 50.9492 41.0453 52.125 42.5 52.125ZM42.5 41.625C43.9492 41.625 45.125 40.4492 45.125 39C45.125 37.5508 43.9547 36.375 42.5 36.375C41.0453 36.375 39.875 37.5453 39.875 39C39.875 40.4547 41.0453 41.625 42.5 41.625ZM42.5 31.125C43.9492 31.125 45.125 29.9492 45.125 28.5C45.125 27.0508 43.9547 25.875 42.5 25.875C41.0453 25.875 39.875 27.0453 39.875 28.5C39.875 29.9547 41.0453 31.125 42.5 31.125ZM32 41.625C33.4492 41.625 34.625 40.4492 34.625 39C34.625 37.5508 33.4547 36.375 32 36.375C30.5453 36.375 29.375 37.5453 29.375 39C29.375 40.4547 30.5453 41.625 32 41.625ZM32 31.125C33.4492 31.125 34.625 29.9492 34.625 28.5C34.625 27.0508 33.4547 25.875 32 25.875C30.5453 25.875 29.375 27.0453 29.375 28.5C29.375 29.9547 30.5453 31.125 32 31.125ZM21.5 41.625C22.9492 41.625 24.125 40.4492 24.125 39C24.125 37.5508 22.9547 36.375 21.5 36.375C20.0453 36.375 18.875 37.5453 18.875 39C18.875 40.4547 20.0508 41.625 21.5 41.625ZM21.5 31.125C22.9492 31.125 24.125 29.9492 24.125 28.5C24.125 27.0508 22.9547 25.875 21.5 25.875C20.0453 25.875 18.875 27.0453 18.875 28.5C18.875 29.9547 20.0508 31.125 21.5 31.125Z" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_913_1554" }, /* @__PURE__ */ React.createElement("rect", { width: 42, height: 56, transform: "translate(11 4)" }))));
const SvgCalendar = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_110_134)" }, /* @__PURE__ */ React.createElement("path", { d: "M23.625 11H39.375V6.625C39.375 5.17578 40.5453 4 42 4C43.4547 4 44.625 5.17578 44.625 6.625V11H49C52.8609 11 56 14.1336 56 18V53C56 56.8609 52.8609 60 49 60H14C10.1336 60 7 56.8609 7 53V18C7 14.1336 10.1336 11 14 11H18.375V6.625C18.375 5.17578 19.5453 4 21 4C22.4547 4 23.625 5.17578 23.625 6.625V11ZM12.25 53C12.25 53.9625 13.0331 54.75 14 54.75H49C49.9625 54.75 50.75 53.9625 50.75 53V25H12.25V53Z" })));
const SvgCalendarRange = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M23 3C23 1.3375 21.6625 0 20 0C18.3375 0 17 1.3375 17 3V8H12C7.5875 8 4 11.5875 4 16V18V24V56C4 60.4125 7.5875 64 12 64H52C56.4125 64 60 60.4125 60 56V24V18V16C60 11.5875 56.4125 8 52 8H47V3C47 1.3375 45.6625 0 44 0C42.3375 0 41 1.3375 41 3V8H23V3ZM10 24H54V56C54 57.1 53.1 58 52 58H12C10.9 58 10 57.1 10 56V24ZM16 36C16 37.0609 16.4214 38.0783 17.1716 38.8284C17.9217 39.5786 18.9391 40 20 40C21.0609 40 22.0783 39.5786 22.8284 38.8284C23.5786 38.0783 24 37.0609 24 36C24 34.9391 23.5786 33.9217 22.8284 33.1716C22.0783 32.4214 21.0609 32 20 32C18.9391 32 17.9217 32.4214 17.1716 33.1716C16.4214 33.9217 16 34.9391 16 36ZM44 44C42.9391 44 41.9217 44.4214 41.1716 45.1716C40.4214 45.9217 40 46.9391 40 48C40 49.0609 40.4214 50.0783 41.1716 50.8284C41.9217 51.5786 42.9391 52 44 52C45.0609 52 46.0783 51.5786 46.8284 50.8284C47.5786 50.0783 48 49.0609 48 48C48 46.9391 47.5786 45.9217 46.8284 45.1716C46.0783 44.4214 45.0609 44 44 44ZM28 36C28 37.6625 29.3375 39 31 39H45C46.6625 39 48 37.6625 48 36C48 34.3375 46.6625 33 45 33H31C29.3375 33 28 34.3375 28 36ZM33 45H19C17.3375 45 16 46.3375 16 48C16 49.6625 17.3375 51 19 51H33C34.6625 51 36 49.6625 36 48C36 46.3375 34.6625 45 33 45Z" }));
const SvgCalendarPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_110_137)" }, /* @__PURE__ */ React.createElement("path", { d: "M31.5 29.375C32.9547 29.375 34.125 30.5453 34.125 32V37.25H39.375C40.8297 37.25 42 38.4203 42 39.875C42 41.3297 40.8297 42.5 39.375 42.5H34.125V47.75C34.125 49.2047 32.9547 50.375 31.5 50.375C30.0453 50.375 28.875 49.2047 28.875 47.75V42.5H23.625C22.1703 42.5 21 41.3297 21 39.875C21 38.4203 22.1703 37.25 23.625 37.25H28.875V32C28.875 30.5453 30.0453 29.375 31.5 29.375ZM23.625 11H39.375V6.625C39.375 5.17578 40.5453 4 42 4C43.4547 4 44.625 5.17578 44.625 6.625V11H49C52.8609 11 56 14.1336 56 18V53C56 56.8609 52.8609 60 49 60H14C10.1336 60 7 56.8609 7 53V18C7 14.1336 10.1336 11 14 11H18.375V6.625C18.375 5.17578 19.5453 4 21 4C22.4547 4 23.625 5.17578 23.625 6.625V11ZM12.25 53C12.25 53.9625 13.0331 54.75 14 54.75H49C49.9625 54.75 50.75 53.9625 50.75 53V25H12.25V53Z" })));
const SvgCameraSlash = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1899_127)" }, /* @__PURE__ */ React.createElement("path", { d: "M3.87995 6.50983C2.83995 5.68983 1.32995 5.87983 0.509952 6.91983C-0.310048 7.95983 -0.120048 9.46983 0.919952 10.2898L60.1199 56.6898C61.16 57.5098 62.6699 57.3198 63.4899 56.2798C64.31 55.2398 64.1199 53.7298 63.0799 52.9098L57.5299 48.5598C57.5799 48.2498 57.5999 47.9298 57.5999 47.5998V21.9998C57.5999 18.4698 54.7299 15.5998 51.1999 15.5998H43.86L43 13.0298C42.2399 10.7398 40.0999 9.19983 37.6899 9.19983H26.3099C23.9 9.19983 21.76 10.7398 21 13.0298L20.1399 15.5998H15.48L3.87995 6.50983ZM21.6 20.3998H21.8699C22.9 20.3998 23.82 19.7398 24.15 18.7598L25.5499 14.5498C25.66 14.2198 25.9599 13.9998 26.3099 13.9998H37.6899C38.0299 13.9998 38.34 14.2198 38.4499 14.5498L39.8499 18.7598C40.1799 19.7398 41.0899 20.3998 42.1299 20.3998H51.1999C52.0799 20.3998 52.7999 21.1198 52.7999 21.9998V44.8498L42.9599 37.1298C43.1199 36.3798 43.1999 35.5898 43.1999 34.7898C43.1999 28.5998 38.1899 23.5898 32 23.5898C30.2499 23.5898 28.59 23.9898 27.11 24.7098L21.6 20.3998ZM38.2599 33.4598L31.8099 28.3998C31.8699 28.3998 31.9399 28.3998 32 28.3998C35.07 28.3998 37.6399 30.5698 38.2599 33.4598ZM48.7399 53.9998L42.6499 49.1998H12.8C11.92 49.1998 11.2 48.4798 11.2 47.5998V24.4198L6.51995 20.7398C6.43995 21.1498 6.39995 21.5698 6.39995 21.9998V47.5998C6.39995 51.1298 9.26995 53.9998 12.8 53.9998H48.7399ZM37.0599 44.7998L32.47 41.1898C32.31 41.1998 32.16 41.2098 32 41.2098C28.82 41.2098 26.1799 38.8898 25.6799 35.8498L21.1 32.2198C20.91 33.0498 20.7999 33.9098 20.7999 34.7998C20.7999 40.9898 25.8099 45.9998 32 45.9998C33.82 45.9998 35.54 45.5698 37.0599 44.7998Z" })));
const SvgCaretDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_943_1550)" }, /* @__PURE__ */ React.createElement("path", { d: "M29.0281 44.9718C30.3953 46.339 32.6156 46.339 33.9828 44.9718L47.9828 30.9718C48.989 29.9656 49.2844 28.4671 48.7375 27.1546C48.1906 25.8421 46.9219 24.989 45.5 24.989L17.5 25C16.089 25 14.8094 25.8531 14.2625 27.1656C13.7156 28.4781 14.0219 29.9765 15.0172 30.9828L29.0172 44.9828L29.0281 44.9718Z" })));
const SvgCheckMark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M62.6085 10.3994C64.4638 12.1217 64.4638 15.1357 62.6085 16.858L26.078 53.6008C24.3656 55.4664 21.369 55.4664 19.6566 53.6008L1.3913 35.2295C-0.463767 33.5072 -0.463767 30.493 1.3913 28.7706C3.10367 26.9046 6.10032 26.9046 7.81269 28.7706L22.7959 43.8411L56.1869 10.3994C57.8993 8.53354 60.8962 8.53354 62.6085 10.3994Z" }));
const SvgChevronLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M35.8917 49.3833L20.6333 33.4583C20.185 32.925 20 32.425 20 32C20 31.575 20.1849 31.0025 20.5573 30.6175L35.8157 14.6925C36.5783 13.893 37.844 13.867 38.6407 14.6326C39.4428 15.393 39.4688 16.6634 38.7006 17.4584L24.77 32L38.77 46.6166C39.5383 47.4083 39.5122 48.6816 38.7101 49.4425C37.9167 50.2083 36.65 50.1833 35.8917 49.3833Z" }));
const SvgChevronRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M28.1083 14.6174L43.3667 30.5424C43.7391 30.9279 43.924 31.4274 43.924 31.9249C43.924 32.4224 43.7391 32.9224 43.3667 33.3074L28.1083 49.2324C27.3457 50.0319 26.08 50.0579 25.2833 49.2923C24.4813 48.5319 24.4552 47.2607 25.2234 46.4665L39.2234 31.8498L25.2258 17.3833C24.4576 16.5916 24.4837 15.3183 25.2857 14.5574C26.0825 13.7916 27.35 13.8183 28.1083 14.6174Z" }));
const SvgCircleCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_467_1195)" }, /* @__PURE__ */ React.createElement("path", { d: "M30.6656 41.1656C29.4734 42.3578 27.5266 42.3578 26.3344 41.1656L19.3344 34.1656C18.1422 32.9734 18.1422 31.0266 19.3344 29.8344C20.5266 28.6422 22.4734 28.6422 23.6656 29.8344L28.5 34.6687L40.3344 22.8344C41.5266 21.6422 43.4734 21.6422 44.6656 22.8344C45.8578 24.0266 45.8578 25.9734 44.6656 27.1656L30.6656 41.1656ZM60 32C60 47.4656 47.4656 60 32 60C16.5344 60 4 47.4656 4 32C4 16.5344 16.5344 4 32 4C47.4656 4 60 16.5344 60 32ZM32 9.25C19.4328 9.25 9.25 19.4328 9.25 32C9.25 44.5672 19.4328 54.75 32 54.75C44.5672 54.75 54.75 44.5672 54.75 32C54.75 19.4328 44.5672 9.25 32 9.25Z" })));
const SvgCircleCheckSolid = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_493_1190)" }, /* @__PURE__ */ React.createElement("path", { d: "M4 32C4 16.5344 16.5344 4 32 4C47.4656 4 60 16.5344 60 32C60 47.4656 47.4656 60 32 60C16.5344 60 4 47.4656 4 32ZM44.6656 27.1656C45.8578 25.9734 45.8578 24.0266 44.6656 22.8344C43.4734 21.6422 41.5266 21.6422 40.3344 22.8344L28.5 34.6687L23.6656 29.8344C22.4734 28.6422 20.5266 28.6422 19.3344 29.8344C18.1422 31.0266 18.1422 32.9734 19.3344 34.1656L26.3344 41.1656C27.5266 42.3578 29.4734 42.3578 30.6656 41.1656L44.6656 27.1656Z" })));
const SvgCircleExclamationSolid = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M32 4C16.5344 4 4 16.5344 4 32C4 47.4656 16.5344 60 32 60C47.4656 60 60 47.4656 60 32C60 16.5344 47.4656 4 32 4ZM29.375 20.625C29.375 19.1812 30.5562 18 32 18C33.4438 18 34.625 19.1758 34.625 20.625V34.625C34.625 36.0742 33.4492 37.25 32 37.25C30.5508 37.25 29.375 36.0797 29.375 34.625V20.625ZM32 47.75C30.1012 47.75 28.5612 46.21 28.5612 44.3112C28.5612 42.4125 30.1002 40.8725 32 40.8725C33.8998 40.8725 35.4388 42.4125 35.4388 44.3112C35.4344 46.2078 33.9031 47.75 32 47.75Z" }));
const SvgCircleInfo = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1603_1561)" }, /* @__PURE__ */ React.createElement("path", { d: "M32 9.25C38.0337 9.25 43.8202 11.6469 48.0867 15.9133C52.3531 20.1798 54.75 25.9663 54.75 32C54.75 38.0337 52.3531 43.8202 48.0867 48.0867C43.8202 52.3531 38.0337 54.75 32 54.75C25.9663 54.75 20.1798 52.3531 15.9133 48.0867C11.6469 43.8202 9.25 38.0337 9.25 32C9.25 25.9663 11.6469 20.1798 15.9133 15.9133C20.1798 11.6469 25.9663 9.25 32 9.25ZM32 60C39.4261 60 46.548 57.05 51.799 51.799C57.05 46.548 60 39.4261 60 32C60 24.5739 57.05 17.452 51.799 12.201C46.548 6.94999 39.4261 4 32 4C24.5739 4 17.452 6.94999 12.201 12.201C6.94999 17.452 4 24.5739 4 32C4 39.4261 6.94999 46.548 12.201 51.799C17.452 57.05 24.5739 60 32 60ZM27.625 40.75C26.1703 40.75 25 41.9203 25 43.375C25 44.8297 26.1703 46 27.625 46H36.375C37.8297 46 39 44.8297 39 43.375C39 41.9203 37.8297 40.75 36.375 40.75H35.5V31.125C35.5 29.6703 34.3297 28.5 32.875 28.5H27.625C26.1703 28.5 25 29.6703 25 31.125C25 32.5797 26.1703 33.75 27.625 33.75H30.25V40.75H27.625ZM32 25C32.9283 25 33.8185 24.6313 34.4749 23.9749C35.1313 23.3185 35.5 22.4283 35.5 21.5C35.5 20.5717 35.1313 19.6815 34.4749 19.0251C33.8185 18.3687 32.9283 18 32 18C31.0717 18 30.1815 18.3687 29.5251 19.0251C28.8687 19.6815 28.5 20.5717 28.5 21.5C28.5 22.4283 28.8687 23.3185 29.5251 23.9749C30.1815 24.6313 31.0717 25 32 25Z" })));
const SvgCircleInfoSolid = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1932_15)" }, /* @__PURE__ */ React.createElement("path", { d: "M32 60C39.4261 60 46.548 57.05 51.799 51.799C57.05 46.548 60 39.4261 60 32C60 24.5739 57.05 17.452 51.799 12.201C46.548 6.94999 39.4261 4 32 4C24.5739 4 17.452 6.94999 12.201 12.201C6.94999 17.452 4 24.5739 4 32C4 39.4261 6.94999 46.548 12.201 51.799C17.452 57.05 24.5739 60 32 60ZM27.625 40.75H30.25V33.75H27.625C26.1703 33.75 25 32.5797 25 31.125C25 29.6703 26.1703 28.5 27.625 28.5H32.875C34.3297 28.5 35.5 29.6703 35.5 31.125V40.75H36.375C37.8297 40.75 39 41.9203 39 43.375C39 44.8297 37.8297 46 36.375 46H27.625C26.1703 46 25 44.8297 25 43.375C25 41.9203 26.1703 40.75 27.625 40.75ZM32 18C32.9283 18 33.8185 18.3687 34.4749 19.0251C35.1313 19.6815 35.5 20.5717 35.5 21.5C35.5 22.4283 35.1313 23.3185 34.4749 23.9749C33.8185 24.6313 32.9283 25 32 25C31.0717 25 30.1815 24.6313 29.5251 23.9749C28.8687 23.3185 28.5 22.4283 28.5 21.5C28.5 20.5717 28.8687 19.6815 29.5251 19.0251C30.1815 18.3687 31.0717 18 32 18Z" })));
const SvgCircleXmark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1939_1575)" }, /* @__PURE__ */ React.createElement("path", { d: "M23.1406 23.1406C24.1688 22.1234 25.8313 22.1234 26.7609 23.1406L31.9016 28.2922L37.1406 23.1406C38.1688 22.1234 39.8312 22.1234 40.7609 23.1406C41.8766 24.1688 41.8766 25.8313 40.7609 26.7609L35.7078 31.9016L40.7609 37.1406C41.8766 38.1688 41.8766 39.8312 40.7609 40.7609C39.8312 41.8766 38.1688 41.8766 37.1406 40.7609L31.9016 35.7078L26.7609 40.7609C25.8313 41.8766 24.1688 41.8766 23.1406 40.7609C22.1234 39.8312 22.1234 38.1688 23.1406 37.1406L28.2922 31.9016L23.1406 26.7609C22.1234 25.8313 22.1234 24.1688 23.1406 23.1406ZM60 32C60 47.4656 47.4656 60 32 60C16.5344 60 4 47.4656 4 32C4 16.5344 16.5344 4 32 4C47.4656 4 60 16.5344 60 32ZM32 9.25C19.4328 9.25 9.25 19.4328 9.25 32C9.25 44.5672 19.4328 54.75 32 54.75C44.5672 54.75 54.75 44.5672 54.75 32C54.75 19.4328 44.5672 9.25 32 9.25Z" })));
const SvgClockRotateLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1835_1575)" }, /* @__PURE__ */ React.createElement("path", { d: "M32 4C47.4656 4 60 16.5344 60 32C60 47.4656 47.4656 60 32 60C26.2906 60 20.975 58.2938 16.5453 55.3516C15.3422 54.5531 15.0141 52.9234 15.7141 51.7203C16.6109 50.5062 18.2406 50.1781 19.4547 50.9766C23.0422 53.3609 27.3516 54.75 32 54.75C44.5672 54.75 54.75 44.5672 54.75 32C54.75 19.4328 44.5672 9.25 32 9.25C23.95 9.25 16.8734 13.4325 12.8255 19.75H18.875C20.3297 19.75 21.5 20.9203 21.5 22.375C21.5 23.8297 20.3297 25 18.875 25H6.625C5.17578 25 4 23.8297 4 22.375V10.125C4 8.67578 5.17578 7.5 6.625 7.5C8.07422 7.5 9.25 8.67578 9.25 10.125V15.6703C14.3305 8.60687 22.6266 4 32 4ZM32 18C33.4547 18 34.625 19.1703 34.625 20.625V30.9172L41.6359 38.0156C42.7516 39.0438 42.7516 40.7062 41.6359 41.6359C40.7062 42.7516 39.0438 42.7516 38.0156 41.6359L30.1406 33.7609C29.6484 33.3672 29.375 32.7 29.375 32V20.625C29.375 19.1703 30.5453 18 32 18Z" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1835_1575" }, /* @__PURE__ */ React.createElement("rect", { width: 56, height: 56, transform: "translate(4 4)" }))));
const SvgComment = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1542_1662)" }, /* @__PURE__ */ React.createElement("path", { d: "M16.4844 47.8555C17.9962 46.7539 19.9532 46.4727 21.711 47.1055C24.8165 48.2305 28.2969 48.875 32.0001 48.875C46.6133 48.875 56.3751 39.4414 56.3751 30.125C56.3751 20.8086 46.6133 11.375 32.0001 11.375C17.3868 11.375 7.62506 20.8086 7.62506 30.125C7.62506 33.875 9.07818 37.4844 11.8087 40.5781C12.8165 41.7148 13.3087 43.2148 13.1915 44.7383C13.0274 46.8594 12.5235 48.8047 11.8672 50.5273C13.8594 49.6016 15.5118 48.5703 16.4844 47.8672V47.8555ZM4.48443 52.6133C4.69537 52.2969 4.89459 51.9805 5.08209 51.6641C6.25396 49.7188 7.36724 47.1641 7.5899 44.293C4.07428 40.2969 2.00006 35.4102 2.00006 30.125C2.00006 16.6602 15.4297 5.75 32.0001 5.75C48.5704 5.75 62.0001 16.6602 62.0001 30.125C62.0001 43.5898 48.5704 54.5 32.0001 54.5C27.6524 54.5 23.5274 53.75 19.8008 52.4023C18.4063 53.4219 16.1329 54.8164 13.4376 55.9883C11.668 56.7617 9.6524 57.4648 7.56646 57.875C7.47271 57.8984 7.37896 57.9102 7.28521 57.9336C6.76959 58.0273 6.26568 58.1094 5.73834 58.1562C5.7149 58.1562 5.67974 58.168 5.65631 58.168C5.05865 58.2266 4.46099 58.2617 3.86334 58.2617C3.10162 58.2617 2.42193 57.8047 2.12896 57.1016C1.83599 56.3984 2.00006 55.6016 2.5274 55.0625C3.00787 54.5703 3.44146 54.043 3.85162 53.4805C4.05084 53.2109 4.23834 52.9414 4.41412 52.6719C4.42584 52.6484 4.43756 52.6367 4.44928 52.6133H4.48443Z" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1542_1662" }, /* @__PURE__ */ React.createElement("rect", { width: 60, height: 60, transform: "translate(2 2)" }))));
const SvgCompologyLogo = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 40, height: 40, viewBox: "0 0 40 40", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#008CFA", fillRule: "evenodd", d: "M38.445 10.372l-12.023 7.42-4.58-2.826c-1.606-.991-3.633-.991-5.24 0L8.447 20l8.158 5.034c1.605.992 3.632.992 5.237.002L38.445 14.8v12.05c0 1.73-.896 3.338-2.368 4.246l-12.363 7.632c-2.754 1.697-6.23 1.697-8.983 0L2.368 31.095C.896 30.187 0 28.58 0 26.85v-13.7c0-1.731.896-3.337 2.368-4.245l12.363-7.63c2.752-1.7 6.23-1.7 8.983 0l14.73 9.097z" }));
const SvgCopy = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1016_1561)" }, /* @__PURE__ */ React.createElement("path", { d: "M58.9719 11.7252L52.2727 5.02594C51.6219 4.3687 50.725 4 49.7953 4H31.9016C28.0352 4 24.9016 7.13469 24.9016 11L24.9037 39C25 42.8719 28.1391 46 32 46H53C56.85 46 60 42.85 60 39V14.1992C60 13.2717 59.6281 12.3814 58.9719 11.7252ZM54.75 39C54.75 39.9664 53.9664 40.75 53 40.75H31.9016C30.9349 40.75 30.1516 39.9664 30.1516 39V11.0142C30.1516 10.0478 30.9351 9.26422 31.9016 9.26422H45.9016L46 14.5C46 16.4327 47.5673 18 49.5 18H54.6516V39H54.75ZM33.75 53C33.75 53.9664 32.9664 54.75 32 54.75H10.9016C9.9349 54.75 9.15156 53.9664 9.15156 53L9.24781 25.0109C9.24781 24.0445 10.0314 23.2609 10.9978 23.2609H21.5V18H10.9989C7.1325 18 3.9989 21.1336 3.9989 25L3.99997 53C4.00021 56.8609 7.13468 60 11 60H32C35.85 60 39 56.85 39 53V49.5H33.8484L33.75 53Z" })));
const SvgDelete = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22.5 11.5H22C22.275 11.5 22.5 11.275 22.5 11V11.5H41.5V11C41.5 11.275 41.725 11.5 42 11.5H41.5V16H46V11C46 8.79375 44.2062 7 42 7H22C19.7938 7 18 8.79375 18 11V16H22.5V11.5ZM54 16H10C8.89375 16 8 16.8937 8 18V20C8 20.275 8.225 20.5 8.5 20.5H12.275L13.8188 53.1875C13.9188 55.3187 15.6813 57 17.8125 57H46.1875C48.325 57 50.0813 55.325 50.1813 53.1875L51.725 20.5H55.5C55.775 20.5 56 20.275 56 20V18C56 16.8937 55.1063 16 54 16ZM45.7062 52.5H18.2938L16.7812 20.5H47.2188L45.7062 52.5Z" }));
const SvgDiamondExclamation = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_941_1560)" }, /* @__PURE__ */ React.createElement("path", { d: "M58.4357 28.3466L35.6638 5.47625C33.5846 3.50531 30.1896 3.50531 28.2198 5.47625L5.56053 28.3466C3.47803 30.3131 3.47803 33.7092 5.56053 35.6758L28.3324 58.4367C30.3033 60.5192 33.6973 60.5192 35.6682 58.4367L58.4401 35.6758C60.5247 33.7059 60.5248 30.3153 58.4357 28.3466ZM29.3748 20.5263C29.3748 19.077 30.5505 17.9012 31.9998 17.9012C33.449 17.9012 34.6248 19.077 34.6248 20.5263V32.7763C34.6248 34.2255 33.449 35.4013 31.9998 35.4013C30.5505 35.4013 29.3748 34.2255 29.3748 32.7763V20.5263ZM31.9998 45.9013C30.0682 45.9013 28.4998 44.3328 28.4998 42.4013C28.4998 40.4697 30.0682 38.9013 31.9998 38.9013C33.9313 38.9013 35.4998 40.4697 35.4998 42.4013C35.4998 44.3328 33.9357 45.9013 31.9998 45.9013Z" })));
const SvgDumpster = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.43594 7.5C5.2875 7.5 4.27031 8.25469 3.93125 9.34844L1.09844 18.5469C1.03281 18.7656 1 18.9953 1 19.2141C1 20.4828 2.01719 21.5 3.28594 21.5H13.5672L16.3672 7.5H6.43594ZM30.75 21.5V7.5H19.9328L17.1328 21.5H30.75ZM34.25 21.5H47.8672L45.0672 7.5H34.25V21.5ZM51.4328 21.5H61.7141C62.9719 21.5 64 20.4828 64 19.2141C64 18.9844 63.9672 18.7656 63.9016 18.5469L61.0688 9.34844C60.7297 8.25469 59.7125 7.5 58.5641 7.5H48.6328L51.4328 21.5ZM10.45 30.25H54.55L52.3625 47.75H12.6375L10.45 30.25ZM13.25 53H51.75V53.875C51.75 55.3297 52.9203 56.5 54.375 56.5C55.8297 56.5 57 55.3297 57 53.875V53L59.4062 33.75H61.375C62.8297 33.75 64 32.5797 64 31.125C64 29.6703 62.8297 28.5 61.375 28.5H60.0625L60.5 25H55.2062H9.79375H4.5L4.9375 28.5H3.625C2.17031 28.5 1 29.6703 1 31.125C1 32.5797 2.17031 33.75 3.625 33.75H5.59375L8 53V53.875C8 55.3297 9.17031 56.5 10.625 56.5C12.0797 56.5 13.25 55.3297 13.25 53.875V53Z" }));
const SvgEllipsisVertical = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M32 44.25C34.8995 44.25 37.25 46.6016 37.25 49.5C37.25 52.3984 34.8995 54.75 32 54.75C29.1005 54.75 26.75 52.3984 26.75 49.5C26.75 46.6016 29.1005 44.25 32 44.25ZM32 26.75C34.8995 26.75 37.25 29.1016 37.25 32C37.25 34.8984 34.8995 37.25 32 37.25C29.1005 37.25 26.75 34.8984 26.75 32C26.75 29.1016 29.1005 26.75 32 26.75ZM32 19.75C29.1005 19.75 26.75 17.3984 26.75 14.5C26.75 11.6005 29.1005 9.25 32 9.25C34.8995 9.25 37.25 11.6005 37.25 14.5C37.25 17.3984 34.8995 19.75 32 19.75Z" }));
const SvgEnvelope = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_217_24)" }, /* @__PURE__ */ React.createElement("path", { d: "M48 16H16C13.0542 16 10.6667 18.3875 10.6667 21.3333V42.6667C10.6667 45.6125 13.0542 48 16 48H48C50.9458 48 53.3333 45.6125 53.3333 42.6667V21.3333C53.3333 18.3875 50.9417 16 48 16ZM16 20H48C48.7352 20 49.3333 20.5982 49.3333 21.3333V23.18L35.4333 34.6883C33.5008 36.295 30.4883 36.2942 28.5608 34.6896L14.6667 23.1833V21.3333C14.6667 20.6 15.265 20 16 20ZM48 44H16C15.2648 44 14.6667 43.4018 14.6667 42.6667V28.3917L26.0083 37.8417C27.6917 39.2333 29.8167 40 32 40C34.1833 40 36.3125 39.2343 37.9975 37.835L49.3333 28.3917V42.6667C49.3333 43.4 48.7333 44 48 44Z" })));
const SvgArrowUpRightFromSquare = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M38.625 12.7499C37.1703 12.7499 36 11.5741 36 10.1249C36 8.67566 37.1703 7.49988 38.625 7.49988H54.375C55.8297 7.49988 57 8.67566 57 10.1249V25.8749C57 27.3296 55.8297 28.4999 54.375 28.4999C52.9203 28.4999 51.75 27.3296 51.75 25.8749V16.4577L29.8859 38.1358C28.9562 39.2514 27.2937 39.2514 26.2656 38.1358C25.2484 37.2061 25.2484 35.5436 26.2656 34.5155L48.0422 12.7499H38.625ZM8 17.1249C8 13.7419 10.742 10.9999 14.125 10.9999H26.375C27.8297 10.9999 29 12.1757 29 13.6249C29 15.0796 27.8297 16.2499 26.375 16.2499H14.125C13.6416 16.2499 13.25 16.6436 13.25 17.1249V50.3749C13.25 50.8561 13.6416 51.2499 14.125 51.2499H47.375C47.8562 51.2499 48.25 50.8561 48.25 50.3749V38.1249C48.25 36.6702 49.4203 35.4999 50.875 35.4999C52.3297 35.4999 53.5 36.6702 53.5 38.1249V50.3749C53.5 53.7546 50.7547 56.4999 47.375 56.4999H14.125C10.742 56.4999 8 53.7546 8 50.3749V17.1249Z" }));
const SvgEye = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_427_1212)" }, /* @__PURE__ */ React.createElement("path", { d: "M21.3333 32.0002C21.3333 26.1085 26.1083 21.3335 32 21.3335C37.8917 21.3335 42.6667 26.1085 42.6667 32.0002C42.6667 37.8918 37.8917 42.6668 32 42.6668C26.1083 42.6668 21.3333 37.8918 21.3333 32.0002ZM32 38.6668C35.6833 38.6668 38.6667 35.6835 38.6667 32.0002C38.6667 28.3168 35.6833 25.3335 32 25.3335C31.9417 25.3335 31.8917 25.3335 31.7583 25.3335C31.9417 25.7585 32 26.2085 32 26.6668C32 29.6085 29.6083 32.0002 26.6667 32.0002C26.2083 32.0002 25.7583 31.9418 25.3333 31.7585C25.3333 31.8918 25.3333 31.9418 25.3333 31.9252C25.3333 35.6835 28.3167 38.6668 32 38.6668ZM15.9517 20.0502C19.875 16.4035 25.2667 13.3335 32 13.3335C38.7333 13.3335 44.125 16.4035 48.05 20.0502C51.95 23.6668 54.5583 27.9252 55.7917 30.9752C56.0667 31.6335 56.0667 32.3668 55.7917 33.0252C54.5583 36.0002 51.95 40.2585 48.05 43.9502C44.125 47.6002 38.7333 50.6668 32 50.6668C25.2667 50.6668 19.875 47.6002 15.9517 43.9502C12.0517 40.2585 9.445 36.0002 8.20508 33.0252C7.93162 32.3668 7.93162 31.6335 8.20508 30.9752C9.445 27.9252 12.0517 23.6668 15.9517 20.0502ZM32 17.3335C26.5667 17.3335 22.1 19.8002 18.675 22.9752C15.4667 25.9585 13.2517 29.4252 12.12 32.0002C13.2517 34.5002 15.4667 38.0418 18.675 41.0252C22.1 44.2002 26.5667 46.6668 32 46.6668C37.4333 46.6668 41.9 44.2002 45.325 41.0252C48.5333 38.0418 50.675 34.5002 51.8833 32.0002C50.675 29.4252 48.5333 25.9585 45.325 22.9752C41.9 19.8002 37.4333 17.3335 32 17.3335Z" })));
const SvgEyeInvisible = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_427_1200)" }, /* @__PURE__ */ React.createElement("path", { d: "M17.8921 18.3981C21.5838 15.5231 26.3171 13.3339 32.0005 13.3339C38.7338 13.3339 44.1255 16.4039 48.0505 20.0506C51.9505 23.6672 54.5588 27.9256 55.7921 30.9756C56.0671 31.6339 56.0671 32.3672 55.7921 33.0256C54.6755 35.7172 52.4338 39.5089 49.1338 42.8922L57.9005 49.7589C58.7671 50.4422 58.9255 51.7006 58.2421 52.5672C57.5588 53.4339 56.3005 53.5922 55.4338 52.9089L6.10012 14.2414C5.23079 13.5597 5.07837 12.3031 5.75979 11.4336C6.44129 10.5642 7.69795 10.4118 8.56795 11.0932L17.8921 18.3981ZM21.1505 20.9589L24.9838 23.9589C26.8588 22.3256 29.3171 21.3339 32.0005 21.3339C37.8921 21.3339 42.6671 26.1089 42.6671 32.0006C42.6671 33.7672 42.2421 35.4256 41.4838 36.8922L45.9671 40.4089C48.7588 37.5672 50.8255 34.2589 51.8838 32.0006C50.6755 29.4256 48.5338 25.9589 45.3255 22.9756C41.9005 19.8006 37.4338 17.2589 32.0005 17.2589C27.7921 17.2589 24.0921 18.8114 21.1505 20.9589ZM38.2421 34.3506C38.5171 33.6172 38.6671 32.8256 38.6671 31.9256C38.6671 28.3172 35.6838 25.2589 32.0005 25.2589C31.9421 25.2589 31.8921 25.3339 31.7588 25.3339C31.9421 25.7589 32.0005 26.2089 32.0005 26.5922C32.0005 27.5172 31.8005 28.3172 31.4505 29.0256L38.2421 34.3506ZM39.0255 45.2089L42.5171 47.9589C39.4921 49.5922 35.9838 50.6672 32.0005 50.6672C25.2671 50.6672 19.8755 47.6006 15.9505 43.9506C12.0521 40.2589 9.44545 36.0006 8.20545 33.0256C7.93212 32.3672 7.93212 31.6339 8.20545 30.9756C9.00045 29.0672 10.358 26.6006 12.258 24.1256L15.4005 26.6006C13.8421 28.5422 12.8138 30.4672 12.1213 31.9256C13.2521 34.5006 15.4671 38.0422 18.6755 41.0256C22.1005 44.2006 26.5671 46.6672 32.0005 46.6672C34.5588 46.6672 36.9005 46.1172 39.0255 45.2089ZM21.3338 31.9256C21.3338 31.7589 21.3421 31.5256 21.3588 31.2922L26.0338 34.9756C26.9088 36.7339 28.5421 38.0506 30.5005 38.4256L35.1838 42.1839C34.1755 42.4256 33.1088 42.6672 31.9255 42.6672C26.1088 42.6672 21.2588 37.8922 21.2588 31.9256H21.3338Z" })));
const SvgFileCircleInfo = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10.1347 52.3125H31.6597C32.8264 54.1094 34.3236 55.6816 36.0542 56.9316C35.7528 56.9707 35.4319 57 35.1111 57H10.2222C6.78542 57 4 54.1973 4 50.75V13.25C4 9.79785 6.78542 7 10.2222 7H26.3125C27.9653 7 29.5403 7.6585 30.7069 8.83105L39.5153 17.6738C40.6819 18.8457 41.3333 20.4277 41.3333 22.0879V26.3945C39.6611 26.873 38.0861 27.5957 36.6667 28.5332V22.625H28.8889C27.1681 22.625 25.7778 21.2285 25.7778 19.5V11.6875H10.2222C9.36278 11.6875 8.66667 12.3867 8.66667 13.25V50.75C8.66667 51.6094 9.36278 52.3125 10.2222 52.3125H10.1347ZM31.9125 42.9375C31.9125 35.1738 38.2708 28.875 46 28.875C53.7292 28.875 60 35.1738 60 42.9375C60 50.7012 53.7292 57 46 57C38.2708 57 31.9125 50.7012 31.9125 42.9375ZM46 38.25C47.2931 38.25 48.3333 37.2051 48.3333 35.9062C48.3333 34.6074 47.2931 33.5625 46 33.5625C44.7069 33.5625 43.6667 34.6074 43.6667 35.9062C43.6667 37.2051 44.7069 38.25 46 38.25ZM44.4444 44.5V49.1875C43.5889 49.1875 42.8889 49.8906 42.8889 50.75C42.8889 51.6094 43.5889 52.3125 44.4444 52.3125H47.5556C48.4111 52.3125 49.1111 51.6094 49.1111 50.75C49.1111 49.8906 48.4111 49.1875 47.5556 49.1875V42.9375C47.5556 42.0781 46.8556 41.375 46 41.375H44.4444C43.5889 41.375 42.8889 42.0781 42.8889 42.9375C42.8889 43.7969 43.5889 44.5 44.4444 44.5Z", fill: "#212121" }));
const SvgFileExport = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1016_1586)" }, /* @__PURE__ */ React.createElement("path", { d: "M63.1359 37.1406L54.3859 28.3906C53.3605 27.3652 51.6997 27.3652 50.6738 28.3906C49.6478 29.416 49.6484 31.0769 50.6738 32.1028L55.0422 36.375H24.625C23.1812 36.375 22 37.5563 22 39C22 40.4437 23.1758 41.625 24.625 41.625H55.0422L50.7733 45.8939C50.2516 46.4047 50 47.0719 50 47.75C50 48.4281 50.2564 49.0931 50.769 49.6061C51.7944 50.6315 53.4553 50.6315 54.4812 49.6061L63.2312 40.8561C64.2516 39.8312 64.2516 38.1688 63.1359 37.1406ZM40.375 46C38.9258 46 37.75 47.1747 37.75 48.625V53C37.75 53.9664 36.9664 54.75 36 54.75H8.00219C7.03575 54.75 6.25219 53.9664 6.25219 53L6.25 11.0142C6.25 10.0478 7.03356 9.26422 8 9.26422H25.5V18C25.5 19.9327 27.0673 21.5 29 21.5H37.6516V29.375C37.6516 30.8242 38.8263 32 40.1781 32C41.53 32 43 30.8297 43 29.375V19.1594C43 17.3022 42.2626 15.5216 40.9492 14.2091L32.7866 6.04531C31.4719 4.73741 29.6891 4 27.8406 4H7.90156C4.13359 4 0.999781 7.13469 1 11L1.00071 53C1.00093 56.8653 4.13431 60 8.00071 60H36C39.85 60 43 56.85 43 53V48.625C43 47.1703 41.8297 46 40.375 46Z" })));
const SvgFileInvoiceDollar = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_110_152)" }, /* @__PURE__ */ React.createElement("path", { d: "M37.3333 10.6666V21.3333H48L37.3333 10.6666ZM32.4583 37.0666L31.925 36.9333C30.025 36.35 30.0667 36.0083 30.1333 35.7083C30.2479 35.0573 31.5158 34.8984 32.6558 35.0729C33.122 35.1432 33.6333 35.3072 34.1217 35.4765C34.9875 35.776 35.9408 35.315 36.2425 34.4482C36.5446 33.5782 36.0849 32.6282 35.215 32.3257C34.6134 32.1187 34.1225 31.9859 33.6683 31.8863V31.3333C33.6683 30.4141 32.9223 29.6666 32.0017 29.6666C31.0811 29.6666 30.335 30.414 30.335 31.3333V31.8326C28.4667 32.2333 27.15 33.4 26.85 35.1416C26.2328 38.7116 29.6158 39.7041 31.06 40.1283L31.5443 40.269C33.9843 40.9669 33.9443 41.2015 33.871 41.6256C33.7564 42.2766 32.4885 42.4381 31.3452 42.261C30.767 42.1751 30.0277 41.9095 29.3735 41.6751L29.0011 41.5397C28.1336 41.2402 27.1819 41.6907 26.8744 42.558C26.5684 43.4255 27.0228 44.378 27.8911 44.6855L28.2466 44.8105C28.8931 45.043 29.6116 45.2764 30.3349 45.4365V46C30.3349 46.9191 31.081 47.6666 32.0016 47.6666C32.9222 47.6666 33.6683 46.9192 33.6683 46V45.4788C35.5316 45.0794 36.8524 43.9346 37.1541 42.193C37.775 38.5833 34.3167 37.5916 32.4583 37.0666Z" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.4, d: "M37.3333 21.3333V10.6666H20C17.7908 10.6666 16 12.4575 16 14.6666V49.3333C16 51.5416 17.7908 53.3333 20 53.3333H44C46.2092 53.3333 48 51.5425 48 49.3333V21.3333H37.3333ZM21.3333 16.6666C21.3333 16.3025 21.6358 16 22 16H28.6667C29.0333 16 29.3333 16.3025 29.3333 16.6666V18C29.3333 18.365 29.0333 18.6666 28.6667 18.6666H22C21.6358 18.6666 21.3333 18.365 21.3333 18V16.6666ZM21.3333 23.3333V22C21.3333 21.6333 21.6358 21.3333 22 21.3333H28.6667C29.0333 21.3333 29.3333 21.6333 29.3333 22V23.3333C29.3333 23.7 29.0333 24 28.6667 24H22C21.6358 24 21.3333 23.7 21.3333 23.3333ZM37.15 42.1916C36.8481 43.9341 35.5275 45.0783 33.6642 45.4775V46C33.6642 46.9191 32.9181 47.6666 31.9975 47.6666C31.0769 47.6666 30.3308 46.9192 30.3308 46V45.4358C29.6073 45.2756 28.8892 45.0422 28.2425 44.8098L27.887 44.6848C27.0187 44.3775 26.5637 43.4248 26.8703 42.5573C27.1777 41.6898 28.1295 41.2398 28.997 41.539L29.3694 41.6744C30.0231 41.9087 30.7628 42.1744 31.3411 42.2603C32.4844 42.4374 33.7528 42.2759 33.8669 41.6249C33.9398 41.2004 33.9802 40.966 31.5403 40.2682L31.0559 40.1275C29.6118 39.703 26.2292 38.7109 26.8459 35.1409C27.15 33.4 28.4667 32.2333 30.3333 31.7583V31.3333C30.3333 30.4141 31.0794 29.6666 32 29.6666C32.9206 29.6666 33.6667 30.414 33.6667 31.3333V31.886C34.1211 31.9856 34.6117 32.1185 35.2133 32.3255C36.0833 32.6275 36.5425 33.578 36.2408 34.448C35.9388 35.3155 34.9858 35.7763 34.12 35.4763C33.6318 35.307 33.12 35.143 32.6542 35.0726C31.5167 34.9 30.175 35.0583 30.1333 35.7083C30.0667 36.0083 30.025 36.35 31.925 36.9333L32.3873 37.0661C34.3167 37.5916 37.775 38.5833 37.15 42.1916Z" })));
const SvgFileInvoice = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_110_156)" }, /* @__PURE__ */ React.createElement("path", { d: "M37.3333 10.6666V21.3333H48L37.3333 10.6666ZM41.3333 29.3333H22.6667C21.9275 29.3333 21.3333 29.925 21.3333 30.6666V38.6666C21.3333 39.4083 21.9275 40 22.6667 40H41.3333C42.0729 40 42.6667 39.4062 42.6667 38.6666V30.6666C42.6667 29.925 42.075 29.3333 41.3333 29.3333ZM40 37.3333H24V32H40V37.3333ZM42 45.3333H35.3333C34.9667 45.3333 34.6667 45.6333 34.6667 46V47.3333C34.6667 47.6979 34.9688 48 35.3333 48H42C42.3646 48 42.6667 47.6979 42.6667 47.3333V46C42.6667 45.6333 42.3667 45.3333 42 45.3333Z" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.4, d: "M37.3333 21.3333V10.6666H20C17.7908 10.6666 16 12.4575 16 14.6666V49.3333C16 51.5416 17.7908 53.3333 20 53.3333H44C46.2092 53.3333 48 51.5425 48 49.3333V21.3333H37.3333ZM21.3333 16.6666C21.3333 16.3025 21.6358 16 22 16H28.6667C29.0333 16 29.3333 16.3025 29.3333 16.6666V18C29.3333 18.365 29.0333 18.6666 28.6667 18.6666H22C21.6358 18.6666 21.3333 18.365 21.3333 18V16.6666ZM21.3333 22C21.3333 21.6333 21.6358 21.3333 22 21.3333H28.6667C29.0333 21.3333 29.3333 21.6333 29.3333 22V23.3333C29.3333 23.7 29.0333 24 28.6667 24H22C21.6358 24 21.3333 23.7 21.3333 23.3333V22ZM42.6667 47.3333C42.6667 47.6979 42.3646 48 42 48H35.3333C34.9667 48 34.6667 47.7 34.6667 47.3333V46C34.6667 45.6354 34.9688 45.3333 35.3333 45.3333H42C42.3646 45.3333 42.6667 45.6354 42.6667 46V47.3333ZM42.6667 38.6666C42.6667 39.4062 42.0729 40 41.3333 40H22.6667C21.9275 40 21.3333 39.4083 21.3333 38.6666V30.6666C21.3333 29.925 21.9275 29.3333 22.6667 29.3333H41.3333C42.075 29.3333 42.6667 29.925 42.6667 30.6666V38.6666Z" })));
const SvgFilePdf = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 58H12V64H8C3.5875 64 0 60.4125 0 56V8C0 3.5875 3.5875 0 8 0H28.6875C30.8125 0 32.85 0.8375 34.35 2.3375L45.6625 13.65C47.1625 15.15 48 17.1875 48 19.3125V36H42V20H32C29.7875 20 28 18.2125 28 16V6H8C6.9 6 6 6.9 6 8V56C6 57.1 6.9 58 8 58ZM22 44H26C29.8625 44 33 47.1375 33 51C33 54.8625 29.8625 58 26 58H24V62C24 63.1 23.1 64 22 64C20.9 64 20 63.1 20 62V56V46C20 44.9 20.9 44 22 44ZM26 54C27.6625 54 29 52.6625 29 51C29 49.3375 27.6625 48 26 48H24V54H26ZM38 44H42C45.3125 44 48 46.6875 48 50V58C48 61.3125 45.3125 64 42 64H38C36.9 64 36 63.1 36 62V46C36 44.9 36.9 44 38 44ZM42 60C43.1 60 44 59.1 44 58V50C44 48.9 43.1 48 42 48H40V60H42ZM52 46C52 44.9 52.9 44 54 44H60C61.1 44 62 44.9 62 46C62 47.1 61.1 48 60 48H56V52H60C61.1 52 62 52.9 62 54C62 55.1 61.1 56 60 56H56V62C56 63.1 55.1 64 54 64C52.9 64 52 63.1 52 62V54V46Z" }));
const SvgFileXmark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2278_94)" }, /* @__PURE__ */ React.createElement("path", { d: "M50.9547 14.2134L42.792 6.04969C41.4719 4.73741 39.6891 4 37.8406 4H18C14.1347 4 11 7.13359 11 11L11.0007 53C11.0007 56.8653 14.1343 60 18.0007 60H46C49.85 60 53 56.85 53 53V19.1594C53 17.3109 52.2672 15.5281 50.9547 14.2134ZM47.75 53C47.75 53.9664 46.9664 54.75 46 54.75H18.0022C17.0357 54.75 16.2522 53.9664 16.2522 53L16.25 11.0142C16.25 10.0478 17.0336 9.26422 18 9.26422H35.5V18C35.5 19.9327 37.0673 21.5 39 21.5H47.75V53ZM37.1406 30.1406L32 35.2922L26.7609 30.1406C25.7355 29.1152 24.0747 29.1152 23.0487 30.1406C22.0228 31.166 22.0234 32.8269 23.0487 33.8528L28.2922 39L23.1483 44.1439C22.1229 45.1693 22.1229 46.8302 23.1483 47.8561C24.1737 48.881 25.8334 48.8819 26.8605 47.8561L32 42.7078L37.1439 47.8517C38.1693 48.8767 39.8291 48.8775 40.8561 47.8517C41.8815 46.8263 41.8815 45.1655 40.8561 44.1395L35.7078 39L40.8517 33.8561C41.8771 32.8307 41.8771 31.1698 40.8517 30.1439C39.8263 29.118 38.1688 29.1234 37.1406 30.1406Z" })));
const SvgFilter = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11 16.509C11 14.5711 12.5349 13 14.4284 13H49.6656C51.5565 13 53.094 14.5711 53.094 16.509C53.094 17.3168 52.8227 18.0994 52.3211 18.7221L38.6242 35.9305V47.9806C38.6242 49.4785 37.432 50.6986 35.9686 50.6986C35.3685 50.6986 34.7847 50.4883 34.3161 50.0339L26.7112 43.9331C25.9302 43.2935 25.4698 42.3258 25.4698 41.2992V35.9305L11.7706 18.7221C11.2722 18.0994 11 17.3168 11 16.509ZM15.5185 17.0391L28.9721 33.9362C29.2599 34.298 29.4161 34.7524 29.4161 35.2153V40.971L34.6779 45.2458V35.2153C34.6779 34.7524 34.8341 34.298 35.1218 33.9362L48.5721 17.0391H15.5185Z" }));
const SvgFloppyDisk = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.25 14.5V49.5C13.25 50.4625 14.0375 51.25 15 51.25H50C50.9625 51.25 51.75 50.4625 51.75 49.5V22.6484C51.75 22.1891 51.5641 21.7406 51.2359 21.4125L54.9438 17.7047C56.2563 19.0172 56.9891 20.8 56.9891 22.6594V49.5C56.9891 53.3609 53.85 56.5 49.9891 56.5H15C11.1391 56.5 8 53.3609 8 49.5V14.5C8 10.6391 11.1391 7.5 15 7.5H41.8516C43.7109 7.5 45.4937 8.23281 46.8062 9.54531L54.9547 17.6937L51.2469 21.4016L43.0875 13.2641C43.0547 13.2312 43.0328 13.2094 43 13.1766V24.125C43 25.5797 41.8297 26.75 40.375 26.75H19.375C17.9203 26.75 16.75 25.5797 16.75 24.125V12.75H15C14.0375 12.75 13.25 13.5375 13.25 14.5ZM22 12.75V21.5H37.75V12.75H22ZM25.5 39C25.5 37.1435 26.2375 35.363 27.5503 34.0503C28.863 32.7375 30.6435 32 32.5 32C34.3565 32 36.137 32.7375 37.4497 34.0503C38.7625 35.363 39.5 37.1435 39.5 39C39.5 40.8565 38.7625 42.637 37.4497 43.9497C36.137 45.2625 34.3565 46 32.5 46C30.6435 46 28.863 45.2625 27.5503 43.9497C26.2375 42.637 25.5 40.8565 25.5 39Z", fill: "#087a6f" }));
const SvgGoogle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "64px", height: "64px", viewBox: "0 0 64 64", ...props }, /* @__PURE__ */ React.createElement("g", { id: "surface1" }, /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(98.431373%,75.294118%,17.647059%)",
  fillOpacity: 1
}, d: "M 58.148438 26.777344 L 56 26.777344 L 56 26.667969 L 32 26.667969 L 32 37.332031 L 47.070312 37.332031 C 44.871094 43.542969 38.964844 48 32 48 C 23.164062 48 16 40.835938 16 32 C 16 23.164062 23.164062 16 32 16 C 36.078125 16 39.789062 17.539062 42.613281 20.050781 L 50.15625 12.507812 C 45.394531 8.070312 39.023438 5.332031 32 5.332031 C 17.273438 5.332031 5.332031 17.273438 5.332031 32 C 5.332031 46.726562 17.273438 58.667969 32 58.667969 C 46.726562 58.667969 58.667969 46.726562 58.667969 32 C 58.667969 30.210938 58.484375 28.464844 58.148438 26.777344 Z M 58.148438 26.777344 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(89.803922%,22.352941%,20.784314%)",
  fillOpacity: 1
}, d: "M 8.40625 19.589844 L 17.167969 26.011719 C 19.539062 20.144531 25.28125 16 32 16 C 36.078125 16 39.789062 17.539062 42.613281 20.050781 L 50.15625 12.507812 C 45.394531 8.070312 39.023438 5.332031 32 5.332031 C 21.757812 5.332031 12.875 11.117188 8.40625 19.589844 Z M 8.40625 19.589844 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(29.803922%,68.627451%,31.372549%)",
  fillOpacity: 1
}, d: "M 32 58.667969 C 38.886719 58.667969 45.148438 56.03125 49.878906 51.742188 L 41.625 44.761719 C 38.949219 46.789062 35.621094 48 32 48 C 25.0625 48 19.175781 43.578125 16.957031 37.40625 L 8.261719 44.105469 C 12.671875 52.742188 21.636719 58.667969 32 58.667969 Z M 32 58.667969 " }), /* @__PURE__ */ React.createElement("path", { style: {
  stroke: "none",
  fillRule: "nonzero",
  fill: "rgb(8.235294%,39.607843%,75.294118%)",
  fillOpacity: 1
}, d: "M 58.148438 26.777344 L 58.125 26.667969 L 32 26.667969 L 32 37.332031 L 47.070312 37.332031 C 46.015625 40.316406 44.097656 42.886719 41.621094 44.761719 C 41.621094 44.761719 41.625 44.761719 41.625 44.757812 L 49.878906 51.742188 C 49.292969 52.273438 58.667969 45.332031 58.667969 32 C 58.667969 30.210938 58.484375 28.464844 58.148438 26.777344 Z M 58.148438 26.777344 " })));
const SvgHouse = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_110_104)" }, /* @__PURE__ */ React.createElement("path", { d: "M55.2914 29.8084C56.1331 30.525 56.2414 31.7834 55.5248 32.625C54.8081 33.4667 53.5498 33.575 52.7081 32.8584L50.6664 31.125V46.6667C50.6664 50.35 47.6831 53.3334 43.9998 53.3334H19.9998C16.3181 53.3334 13.3331 50.35 13.3331 46.6667V31.125L11.2939 32.8584C10.4514 33.575 9.18976 33.4667 8.47476 32.625C7.76009 31.7834 7.86359 30.525 8.70584 29.8084L30.7081 11.1417C31.4498 10.5084 32.5498 10.5084 33.2914 11.1417L55.2914 29.8084ZM19.9998 49.3334H23.9998V36.6667C23.9998 34.825 25.4914 33.3334 27.3331 33.3334H36.6664C38.5081 33.3334 39.9998 34.825 39.9998 36.6667V49.3334H43.9998C45.4748 49.3334 46.6664 48.1417 46.6664 46.6667V27.7334L31.9998 15.2892L17.3331 27.7334V46.6667C17.3331 48.1417 18.5248 49.3334 19.9998 49.3334ZM27.9998 49.3334H35.9998V37.3334H27.9998V49.3334Z" })));
const SvgHouseSolid = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1016_1606)" }, /* @__PURE__ */ React.createElement("path", { d: "M62.9781 31.9453C62.9781 33.9141 61.3375 35.4563 59.4781 35.4563H55.9781L56.0547 52.9781C56.0547 53.2734 56.0328 53.5687 56 53.8641V55.625C56 58.0422 54.0422 60 51.625 60H49.875C49.7547 60 49.6344 60 49.5141 59.9891C49.3609 60 49.2078 60 49.0547 60H45.5H42.875C40.4578 60 38.5 58.0422 38.5 55.625V53V46C38.5 44.0641 36.9359 42.5 35 42.5H28C26.0641 42.5 24.5 44.0641 24.5 46V53V55.625C24.5 58.0422 22.5422 60 20.125 60H17.5H14.0109C13.8469 60 13.6828 59.9891 13.5188 59.9781C13.3875 59.9891 13.2563 60 13.125 60H11.375C8.95781 60 7 58.0422 7 55.625V43.375C7 43.2766 7 43.1672 7.01094 43.0688V35.4563H3.5C1.53125 35.4563 0 33.925 0 31.9453C0 30.9609 0.328125 30.0859 1.09375 29.3203L29.1375 4.875C29.9031 4.10938 30.7781 4 31.5437 4C32.3094 4 33.1844 4.21875 33.8406 4.76562L61.775 29.3203C62.65 30.0859 63.0875 30.9609 62.9781 31.9453Z" })));
const SvgHouseUser = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1414_1567)" }, /* @__PURE__ */ React.createElement("path", { d: "M63.9781 31.9453C63.9781 33.9141 62.3375 35.4563 60.4781 35.4563H56.9781L57.0547 52.9781C57.0766 56.8609 53.9375 60.0109 50.0547 60.0109H15.0109C11.15 60.0109 8.01094 56.8719 8.01094 53.0109V35.4563H4.5C2.53125 35.4563 1 33.925 1 31.9453C1 30.9609 1.32812 30.0859 2.09375 29.3203L30.1375 4.875C30.9031 4.10938 31.7781 4 32.5437 4C33.3094 4 34.1844 4.21875 34.8406 4.76562L62.775 29.3203C63.65 30.0859 64.0875 30.9609 63.9781 31.9453ZM39.5 28.5C39.5 26.6435 38.7625 24.863 37.4497 23.5503C36.137 22.2375 34.3565 21.5 32.5 21.5C30.6435 21.5 28.863 22.2375 27.5503 23.5503C26.2375 24.863 25.5 26.6435 25.5 28.5C25.5 30.3565 26.2375 32.137 27.5503 33.4497C28.863 34.7625 30.6435 35.5 32.5 35.5C34.3565 35.5 36.137 34.7625 37.4497 33.4497C38.7625 32.137 39.5 30.3565 39.5 28.5ZM29 39C24.1656 39 20.25 42.9156 20.25 47.75C20.25 48.7125 21.0375 49.5 22 49.5H43C43.9625 49.5 44.75 48.7125 44.75 47.75C44.75 42.9156 40.8344 39 36 39H29Z" })));
const SvgHouseUserRegular = (props) => /* @__PURE__ */ React.createElement("svg", { width: 72, height: 64, viewBox: "0 0 72 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M34.2701 4.63125C35.27 3.78958 36.7254 3.78958 37.7253 4.63125L67.056 29.4383C68.1781 30.3907 68.3226 32.0629 67.3671 33.1815C66.4116 34.3 64.734 34.4329 63.6119 33.4916L60.8788 31.188V51.8421C60.8788 56.7371 56.9014 60.7018 51.9907 60.7018H19.9936C15.0829 60.7018 11.1055 56.7371 11.1055 51.8421V31.188L8.38355 33.4916C7.26143 34.444 5.57269 34.3 4.62833 33.1815C3.68398 32.0629 3.8173 30.3796 4.93942 29.4383L34.2701 4.63125ZM16.4384 26.6807V51.8421C16.4384 53.8023 18.0271 55.386 19.9936 55.386H51.9907C53.9572 55.386 55.5459 53.8023 55.5459 51.8421V26.6807L35.9922 10.1464L16.4384 26.6807ZM28.8817 28.807C28.8817 26.9272 29.6308 25.1244 30.9643 23.7952C32.2978 22.466 34.1063 21.7193 35.9922 21.7193C37.878 21.7193 39.6866 22.466 41.02 23.7952C42.3535 25.1244 43.1026 26.9272 43.1026 28.807C43.1026 30.6868 42.3535 32.4896 41.02 33.8188C39.6866 35.148 37.878 35.8947 35.9922 35.8947C34.1063 35.8947 32.2978 35.148 30.9643 33.8188C29.6308 32.4896 28.8817 30.6868 28.8817 28.807ZM32.4369 39.4386H39.5474C44.4581 39.4386 48.4355 43.4033 48.4355 48.2982C48.4355 49.2728 47.6356 50.0702 46.6579 50.0702H25.3265C24.3488 50.0702 23.5488 49.2728 23.5488 48.2982C23.5488 43.4033 27.5263 39.4386 32.4369 39.4386Z" }));
const SvgKey = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1993_26)" }, /* @__PURE__ */ React.createElement("path", { d: "M26.75 23.25C26.75 15.5172 33.0172 9.25 40.75 9.25C48.4828 9.25 54.75 15.5172 54.75 23.25C54.75 30.9828 48.4828 37.25 40.75 37.25C39.6125 37.25 38.5078 37.1187 37.4578 36.8563C36.5719 36.6375 35.6312 36.9 34.9859 37.5562L31.7922 40.75H25.875C24.4203 40.75 23.25 41.9203 23.25 43.375V47.75H18.875C17.4203 47.75 16.25 48.9203 16.25 50.375V54.75H9.25V46.2078L26.4438 29.0141C27.0891 28.3687 27.3516 27.4281 27.1438 26.5422C26.8922 25.4922 26.75 24.3875 26.75 23.25ZM40.75 4C30.1187 4 21.5 12.6188 21.5 23.25C21.5 24.2891 21.5766 25.3062 21.7406 26.3016L4.76562 43.2656C4.27344 43.7578 4 44.425 4 45.125V57.375C4 58.8297 5.17031 60 6.625 60H18.875C20.3297 60 21.5 58.8297 21.5 57.375V53H25.875C27.3297 53 28.5 51.8297 28.5 50.375V46H32.875C33.575 46 34.2422 45.7266 34.7344 45.2344L37.7094 42.2594C38.7047 42.4125 39.7219 42.5 40.7609 42.5C51.3922 42.5 60.0109 33.8813 60.0109 23.25C60.0109 12.6188 51.3812 4 40.75 4ZM44.25 23.25C45.1783 23.25 46.0685 22.8813 46.7249 22.2249C47.3812 21.5685 47.75 20.6783 47.75 19.75C47.75 18.8217 47.3812 17.9315 46.7249 17.2751C46.0685 16.6187 45.1783 16.25 44.25 16.25C43.3217 16.25 42.4315 16.6187 41.7751 17.2751C41.1188 17.9315 40.75 18.8217 40.75 19.75C40.75 20.6783 41.1188 21.5685 41.7751 22.2249C42.4315 22.8813 43.3217 23.25 44.25 23.25Z" })));
const SvgLeaf = (props) => /* @__PURE__ */ React.createElement("svg", { width: 9, height: 12, viewBox: "0 0 9 12", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.05585 5.85156C7.02356 6.24215 6.95898 6.6396 6.84273 7.02334C5.84816 10.2303 1.80529 11.6145 1.79883 11.6145C1.79883 11.6145 4.89879 12.7109 6.88794 11.2034C8.87708 9.69581 8.99979 6.15992 8.99979 6.15992C8.99979 6.15992 8.1473 5.90638 7.05585 5.85156Z", fill: "#0DA67C" }), /* @__PURE__ */ React.createElement("path", { d: "M3.7236 6.67433C4.70526 5.93426 5.99045 5.79721 7.05606 5.85203C7.2821 2.95343 5.38983 0 5.38983 0C5.38983 0 1.22425 1.6446 0.229682 4.85157C-0.76489 8.05854 1.79258 11.615 1.79258 11.615C1.79904 11.6081 1.74091 8.18188 3.7236 6.67433Z", fill: "#B0E55C" }), /* @__PURE__ */ React.createElement("path", { d: "M6.84302 7.01652C6.95927 6.63278 7.03031 6.24219 7.05614 5.84475C5.99698 5.78993 4.70533 5.92698 3.72368 6.66704C1.73453 8.17459 1.79266 11.6008 1.79266 11.6077C1.80557 11.6077 5.84844 10.2235 6.84302 7.01652Z", fill: "#0D8720" }));
const SvgLink = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.9219 18.3828C22.0688 12.2326 32.0328 12.2326 38.1797 18.3828C44.0313 24.2343 44.3484 33.6296 38.8906 39.864L38.3109 40.5312C37.3484 41.6249 35.6969 41.7343 34.6031 40.7828C33.5094 39.8312 33.4 38.1687 34.3516 37.0749L34.9422 36.4078C38.5734 32.2515 38.3656 25.9953 34.4609 22.0906C30.3703 17.9015 23.7313 17.9015 19.5422 22.0906L7.24079 34.4828C3.14579 38.5843 3.14579 45.2234 7.24079 49.314C11.1422 53.1203 17.4094 53.4265 21.5547 49.7953L22.2328 49.2046C23.3156 48.2531 24.9781 48.3624 25.9297 49.4562C26.8922 50.539 26.7719 52.2015 25.6891 53.1531L25.0109 53.7437C18.7766 59.1906 9.38126 58.8843 3.5286 53.0218C-2.61663 46.8859 -2.61663 36.8234 3.5286 30.7749L15.9219 18.3828ZM48.0781 45.6171C41.9313 51.764 31.9672 51.764 25.8203 45.6171C19.8703 39.6671 19.6516 30.3703 25.0984 24.1359L25.6125 23.5453C26.5641 22.4515 28.2266 22.3421 29.3203 23.2937C30.4141 24.2453 30.5234 25.9078 29.5719 27.0015L29.0578 27.5921C25.4156 31.7484 25.6344 38.0046 29.5281 41.9093C33.6297 45.9999 40.2688 45.9999 44.3703 41.9093L56.7625 29.5171C60.8531 25.4156 60.8531 18.7765 56.7625 14.6859C52.8578 10.7834 46.5906 10.5745 42.4453 14.2101L41.7672 14.7953C40.6844 15.7468 39.0219 15.6374 38.0703 14.5481C37.1078 13.4576 37.2281 11.7984 38.3109 10.8446L38.9891 10.2584C45.2234 4.80363 54.6188 5.11666 60.4703 10.9737C66.6172 17.114 66.6172 27.0781 60.4703 33.2249L48.0781 45.6171Z" }));
const SvgLinkSimpleSlash = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1802_16)" }, /* @__PURE__ */ React.createElement("path", { d: "M15.4901 15.6081C15.6601 15.6031 15.8301 15.6001 16.0001 15.6001H26.4001C27.7301 15.6001 28.8001 16.6701 28.8001 18.0001C28.8001 19.3301 27.7301 20.4001 26.4001 20.4001H21.6001L32.8301 29.2001H42.4001C43.7301 29.2001 44.8001 30.2701 44.8001 31.6001C44.8001 32.9301 43.7301 34.0001 42.4001 34.0001H38.9501L49.9601 42.6301C55.2101 41.7001 59.2001 37.1201 59.2001 31.6001C59.2001 25.4101 54.1901 20.4001 48.0001 20.4001H37.6001C36.2701 20.4001 35.2001 19.3301 35.2001 18.0001C35.2001 16.6701 36.2701 15.6001 37.6001 15.6001H48.0001C56.8401 15.6001 64.0001 22.7601 64.0001 31.6001C64.0001 38.1101 60.1101 43.7101 54.5301 46.2101L63.0801 52.9101C64.1201 53.7301 64.3101 55.2401 63.4901 56.2801C62.6701 57.3201 61.1601 57.5101 60.1201 56.6901L0.919704 10.2891C-0.123496 9.4711 -0.306396 7.9631 0.511304 6.9197C1.3291 5.8765 2.8371 5.6936 3.8811 6.5113L15.4901 15.6081ZM0.000204113 31.6001C0.000204113 26.8101 2.0281 22.6701 5.2581 19.7401L9.1051 22.7701C6.4841 24.8201 4.8001 28.0201 4.8001 31.6001C4.8001 37.7901 9.8141 42.8001 16.0001 42.8001H26.4001C27.7301 42.8001 28.8001 43.8701 28.8001 45.2001C28.8001 46.5301 27.7301 47.6001 26.4001 47.6001H16.0001C7.1641 47.6001 0.000204113 40.4401 0.000204113 31.6001Z" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1802_16" }, /* @__PURE__ */ React.createElement("rect", { width: 64, height: 51.2, transform: "translate(0 6)" }))));
const SvgLinkSimple = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 32.4444C0 22.6222 7.95556 14.6666 17.7778 14.6666H25.7778C27.2556 14.6666 28.4444 15.8555 28.4444 17.3333C28.4444 18.8111 27.2556 20 25.7778 20H17.7778C10.9 20 5.33333 25.5666 5.33333 32.4444C5.33333 39.3222 10.9 44.8889 17.7778 44.8889H25.7778C27.2556 44.8889 28.4444 46.0777 28.4444 47.5555C28.4444 49.0333 27.2556 50.2222 25.7778 50.2222H17.7778C7.95556 50.2222 0 42.2666 0 32.4444ZM64 32.4444C64 42.2666 56.0444 50.2222 46.2222 50.2222H38.2222C36.7444 50.2222 35.5556 49.0333 35.5556 47.5555C35.5556 46.0777 36.7444 44.8889 38.2222 44.8889H46.2222C53.1 44.8889 58.6667 39.3222 58.6667 32.4444C58.6667 25.5666 53.1 20 46.2222 20H38.2222C36.7444 20 35.5556 18.8111 35.5556 17.3333C35.5556 15.8555 36.7444 14.6666 38.2222 14.6666H46.2222C56.0444 14.6666 64 22.6222 64 32.4444ZM20.4444 29.7777H43.5556C45.0333 29.7777 46.2222 30.9666 46.2222 32.4444C46.2222 33.9222 45.0333 35.1111 43.5556 35.1111H20.4444C18.9667 35.1111 17.7778 33.9222 17.7778 32.4444C17.7778 30.9666 18.9667 29.7777 20.4444 29.7777Z" }));
const SvgListCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12.9513 22.6359C12.4689 23.1609 11.7886 23.4781 11.0689 23.4016C10.3492 23.5219 9.65359 23.2375 9.14391 22.6359L4.7688 18.2609C3.74373 17.3312 3.74373 15.6687 4.7688 14.6439C5.79375 13.6191 7.45625 13.6191 8.48109 14.6439L10.8994 17.0578L16.9281 10.3684C17.8906 9.29109 19.5531 9.20359 20.6359 10.1737C21.7078 11.1439 21.7953 12.8031 20.8219 13.8816L12.9513 22.6359ZM12.9513 40.1359C12.4689 40.6609 11.7886 40.9781 11.0689 40.9016C10.3492 41.0219 9.65359 40.7375 9.14391 40.1359L4.7688 35.7609C3.74373 34.8312 3.74373 33.1687 4.7688 32.1406C5.79375 31.1234 7.45625 31.1234 8.48109 32.1406L10.8994 34.5578L16.9281 27.8641C17.8906 26.7922 19.5531 26.7047 20.6359 27.6781C21.7078 28.6406 21.7953 30.3031 20.8219 31.3859L12.9513 40.1359ZM27.625 19.125C26.1703 19.125 25 17.9547 25 16.5C25 15.0508 26.1703 13.875 27.625 13.875H57.375C58.8297 13.875 60 15.0508 60 16.5C60 17.9547 58.8297 19.125 57.375 19.125H27.625ZM25 34C25 32.5453 26.1703 31.375 27.625 31.375H57.375C58.8297 31.375 60 32.5453 60 34C60 35.4547 58.8297 36.625 57.375 36.625H27.625C26.1703 36.625 25 35.4547 25 34ZM21.5 51.5C21.5 50.0453 22.6703 48.875 24.125 48.875H57.375C58.8297 48.875 60 50.0453 60 51.5C60 52.9547 58.8297 54.125 57.375 54.125H24.125C22.6703 54.125 21.5 52.9547 21.5 51.5ZM11 55C9.06734 55 7.5 53.4359 7.5 51.5C7.5 49.5641 9.06734 48 11 48C12.9327 48 14.5 49.5641 14.5 51.5C14.5 53.4359 12.9327 55 11 55Z" }));
const SvgListTree = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6.625 9.25C5.17031 9.25 4 10.4203 4 11.875V17.125C4 18.5797 5.17031 19.75 6.625 19.75V32V46C6.625 49.3797 9.37031 52.125 12.75 52.125H18C18 53.5797 19.1703 54.75 20.625 54.75H25.875C27.3297 54.75 28.5 53.5797 28.5 52.125V46.875C28.5 45.4203 27.3297 44.25 25.875 44.25H20.625C19.1703 44.25 18 45.4203 18 46.875H12.75C12.2688 46.875 11.875 46.4813 11.875 46V34.625H18C18 36.0797 19.1703 37.25 20.625 37.25H25.875C27.3297 37.25 28.5 36.0797 28.5 34.625V29.375C28.5 27.9203 27.3297 26.75 25.875 26.75H20.625C19.1703 26.75 18 27.9203 18 29.375H11.875V19.75C13.3297 19.75 14.5 18.5797 14.5 17.125V11.875C14.5 10.4203 13.3297 9.25 11.875 9.25H6.625ZM21.5 14.5C21.5 15.9547 22.6703 17.125 24.125 17.125H57.375C58.8297 17.125 60 15.9547 60 14.5C60 13.0453 58.8297 11.875 57.375 11.875H24.125C22.6703 11.875 21.5 13.0453 21.5 14.5ZM35.5 32C35.5 33.4547 36.6703 34.625 38.125 34.625H57.375C58.8297 34.625 60 33.4547 60 32C60 30.5453 58.8297 29.375 57.375 29.375H38.125C36.6703 29.375 35.5 30.5453 35.5 32ZM35.5 49.5C35.5 50.9547 36.6703 52.125 38.125 52.125H57.375C58.8297 52.125 60 50.9547 60 49.5C60 48.0453 58.8297 46.875 57.375 46.875H38.125C36.6703 46.875 35.5 48.0453 35.5 49.5Z" }));
const SvgLocationDot = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1016_1556)" }, /* @__PURE__ */ React.createElement("path", { d: "M34.5922 58.6C40.2031 51.5781 53 34.5594 53 25C53 13.4062 43.5938 4 32 4C20.4062 4 11 13.4062 11 25C11 34.5594 23.7969 51.5781 29.4078 58.6C30.7531 60.2734 33.2469 60.2734 34.5922 58.6ZM32 32C28.1391 32 25 28.8609 25 25C25 21.1391 28.1391 18 32 18C35.8609 18 39 21.1391 39 25C39 28.8609 35.8609 32 32 32Z" })));
const SvgMagnifyingGlassDollar = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2011_330)" }, /* @__PURE__ */ React.createElement("path", { d: "M26.75 9.25C31.3913 9.25 35.8425 11.0937 39.1244 14.3756C42.4063 17.6575 44.25 22.1087 44.25 26.75C44.25 31.3913 42.4063 35.8425 39.1244 39.1244C35.8425 42.4063 31.3913 44.25 26.75 44.25C22.1087 44.25 17.6575 42.4063 14.3756 39.1244C11.0937 35.8425 9.25 31.3913 9.25 26.75C9.25 22.1087 11.0937 17.6575 14.3756 14.3756C17.6575 11.0937 22.1087 9.25 26.75 9.25ZM26.75 49.5C32.0875 49.5 36.9984 47.6625 40.8703 44.5891L55.5156 59.2344C56.5438 60.2625 58.2062 60.2625 59.2234 59.2344C60.2406 58.2062 60.2516 56.5438 59.2234 55.5266L44.5891 40.8703C47.6625 36.9984 49.5 32.0875 49.5 26.75C49.5 14.1828 39.3172 4 26.75 4C14.1828 4 4 14.1828 4 26.75C4 39.3172 14.1828 49.5 26.75 49.5ZM28.9375 15.375C28.9375 14.1719 27.9531 13.1875 26.75 13.1875C25.5469 13.1875 24.5625 14.1719 24.5625 15.375V16.9062C23.7313 17.0922 22.9 17.3875 22.1344 17.8359C20.6141 18.7437 19.3016 20.3297 19.3125 22.6375C19.3234 24.8578 20.625 26.2578 22.0141 27.0891C23.2172 27.8109 24.7156 28.2703 25.9078 28.6203L26.0938 28.675C27.4719 29.0906 28.4781 29.4188 29.1562 29.8453C29.7141 30.1953 29.7906 30.4359 29.8016 30.7422C29.8125 31.2891 29.6047 31.6172 29.1562 31.8906C28.6094 32.2297 27.7453 32.4375 26.8156 32.4047C25.6016 32.3609 24.4641 31.9781 22.9766 31.475C22.725 31.3875 22.4625 31.3 22.1891 31.2125C21.0406 30.8297 19.8047 31.4531 19.4219 32.5906C19.0391 33.7281 19.6625 34.975 20.8 35.3578C21.0078 35.4234 21.2375 35.5 21.4672 35.5875C22.375 35.9047 23.425 36.2656 24.5516 36.5063V38.125C24.5516 39.3281 25.5359 40.3125 26.7391 40.3125C27.9422 40.3125 28.9266 39.3281 28.9266 38.125V36.6156C29.8016 36.4297 30.6766 36.1234 31.4641 35.6313C33.0281 34.6578 34.2094 32.9953 34.1766 30.7094C34.1437 28.4891 32.8969 27.0563 31.4859 26.1594C30.2281 25.3719 28.6531 24.8906 27.4281 24.5188L27.3516 24.4969C25.9516 24.0703 24.9562 23.7641 24.2563 23.3484C23.6875 23.0094 23.6766 22.8125 23.6766 22.6156C23.6766 22.2109 23.8297 21.9047 24.3547 21.5984C24.9453 21.2484 25.8422 21.0406 26.7063 21.0516C27.7563 21.0625 28.9156 21.2922 30.1187 21.6203C31.2891 21.9266 32.4812 21.2375 32.7984 20.0672C33.1156 18.8969 32.4156 17.7047 31.2453 17.3875C30.5344 17.2016 29.7469 17.0156 28.9375 16.8734V15.375Z", fill: "#212121" })));
const SvgMagnifyingGlass = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1018_1552)" }, /* @__PURE__ */ React.createElement("path", { d: "M59.136 55.5156L44.4797 40.8594C47.6516 36.9766 49.4016 32.0875 49.4016 26.75C49.4016 14.1828 39.2155 4 26.6516 4C14.0877 4 4 14.1861 4 26.75C4 39.3139 14.185 49.5 26.6516 49.5C31.988 49.5 36.8836 47.6505 40.761 44.5737L55.4172 59.23C56.0297 59.7484 56.7078 60 57.375 60C58.0422 60 58.7181 59.7436 59.2311 59.231C60.2516 58.2062 60.2516 56.5438 59.136 55.5156ZM9.25002 26.75C9.25002 17.1009 17.101 9.25 26.75 9.25C36.3991 9.25 44.25 17.1009 44.25 26.75C44.25 36.3991 36.3991 44.25 26.75 44.25C17.101 44.25 9.25002 36.3969 9.25002 26.75Z" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1018_1552" }, /* @__PURE__ */ React.createElement("rect", { width: 56, height: 56, fill: "white", transform: "translate(4 4)" }))));
const SvgMemo = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2309_477)" }, /* @__PURE__ */ React.createElement("path", { d: "M39.875 28.5H24.125C22.6812 28.5 21.5 29.6812 21.5 31.125C21.5 32.5688 22.6812 33.75 24.125 33.75H39.875C41.3297 33.75 42.5 32.5797 42.5 31.125C42.5 29.6703 41.3297 28.5 39.875 28.5ZM29.375 39H24.125C22.6812 39 21.5 40.1813 21.5 41.625C21.5 43.0687 22.6758 44.25 24.125 44.25H29.375C30.8242 44.25 32 43.0742 32 41.625C32 40.1758 30.8297 39 29.375 39ZM39.875 18H24.125C22.6812 18 21.5 19.1812 21.5 20.625C21.5 22.0688 22.6812 23.25 24.125 23.25H39.875C41.3297 23.25 42.5 22.0797 42.5 20.625C42.5 19.1703 41.3297 18 39.875 18ZM46 4H18C14.1336 4 11 7.13359 11 11V53C11 56.8664 14.1336 60 18 60H46C49.8664 60 53 56.8664 53 53V11C53 7.13359 49.8609 4 46 4ZM47.75 53C47.75 53.9649 46.9649 54.75 46 54.75H18C17.0351 54.75 16.25 53.9649 16.25 53V11C16.25 10.0351 17.0351 9.25 18 9.25H46C46.9649 9.25 47.75 10.0351 47.75 11V53Z" })));
const SvgMessages = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_110_172)" }, /* @__PURE__ */ React.createElement("path", { d: "M58.6667 26.1493V41.6319C58.6667 44.4878 56.2709 46.7442 53.3334 46.7442H50.6667V51.1386C50.6667 51.7866 49.9063 52.1611 49.375 51.7765L42.4792 46.7436L31.925 46.89C29.0584 46.89 26.6667 44.6296 26.6667 41.7048V39.1138L34.6667 39.1137C39.0734 39.1137 42.6667 35.6202 42.6667 31.3367V21.037H53.3334C56.275 21.037 58.6667 23.3622 58.6667 26.1493Z" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.4, d: "M34.6667 10.6666H10.6667C7.72918 10.6666 5.33334 12.9959 5.33334 15.7789V31.4074C5.33334 34.2592 7.72918 36.5926 10.6667 36.5926L13.3333 36.5933V40.9886C13.3333 41.6366 14.0938 42.0111 14.625 41.6266L21.5208 36.5938L34.6667 36.5844C37.6042 36.5946 40 34.2608 40 31.4057V15.7789C40 12.9959 37.6083 10.6666 34.6667 10.6666Z" })));
const SvgMessageQuestion = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_669_1554)" }, /* @__PURE__ */ React.createElement("path", { d: "M53 4H11C7.14453 4 4 7.14453 4 10.9016V42.3031C4 46.35 7.14453 49.4016 11 49.4016H21.5V58.4906C21.5 59.5664 22.7053 60.1859 23.5912 59.546L37.25 49.4016H53C56.8555 49.4016 60 46.257 60 42.5V10.9016C60 7.14453 56.8609 4 53 4ZM54.75 42.5C54.75 43.457 53.957 44.25 53 44.25H35.5L26.75 50.8125V44.25H11C10.043 44.25 9.25 43.457 9.25 42.5V11C9.25 10.043 10.043 9.25 11 9.25H53C53.957 9.25 54.75 10.043 54.75 11V42.5ZM31.2453 33.3125C29.7469 33.3125 28.5 34.5594 28.5 36.1562C28.5 37.7531 29.7469 39 31.2453 39C32.9406 39 34.1875 37.7531 34.1875 36.1562C34.1875 34.5594 32.9406 33.3125 31.2453 33.3125ZM34.3734 14.5H29.6266C26.0719 14.5 23.25 17.3 23.25 20.8219C23.25 21.9966 24.2525 22.9908 25.4375 22.9908C26.6225 22.9908 27.625 22.0031 27.625 20.8219C27.625 19.7375 28.5365 18.8345 29.6298 18.8345H34.3691C35.4628 18.8345 36.3739 19.738 36.3739 20.8219C36.3739 21.5445 36.0093 22.177 35.3714 22.5391L30.1734 25.6125C29.4441 26.0643 29.0797 26.7872 29.0797 27.5102V28.9561C29.0797 30.1308 30.0822 31.125 31.2672 31.125C32.4517 31.125 33.4547 30.131 33.4547 28.9561V28.7734L37.647 26.2436C39.5688 25.0766 40.75 22.9984 40.75 20.8219C40.75 17.3 37.9281 14.5 34.3734 14.5Z" })));
const SvgMessagesQuestionDuotone = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_110_168)" }, /* @__PURE__ */ React.createElement("path", { d: "M24.875 18.9217C25.6396 18.9217 26.2766 19.5776 26.2766 20.3646C26.2766 20.8893 26.0217 21.3485 25.5756 21.611L21.9431 23.8414C21.4333 24.1691 21.175 24.6924 21.175 25.2157V26.2648C21.175 27.1176 21.8758 27.839 22.7041 27.839C23.5325 27.839 24.2333 27.1174 24.2333 26.2648V26.1422L27.165 24.3055C28.5083 23.4486 29.3333 21.9387 29.3333 20.3689C29.3333 17.8108 27.3575 15.7769 24.8725 15.7769H21.5583C19.0733 15.7769 17.0975 17.8108 17.0975 20.3689C17.0975 21.2217 17.7985 21.943 18.6266 21.943C19.4549 21.943 20.1558 21.2214 20.1558 20.3689C20.1558 19.5816 20.793 18.926 21.5575 18.926H24.875V18.9217ZM53.3333 21.6471H42.6666V32.6275C42.6666 37.1629 39.0725 40.8619 34.6666 40.8619L26.6666 40.862V43.6054C26.6666 46.6293 29.0625 49.0184 31.925 49.0184L42.4083 49.0178L49.3041 54.3467C49.9083 54.8285 50.6666 54.4339 50.6666 53.7476V49.0946H53.3333C56.2708 49.0946 58.6666 46.6283 58.6666 43.6816V27.0601C58.6666 24.1091 56.275 21.6471 53.3333 21.6471ZM22.7083 29.4963C21.5583 29.4963 20.6666 30.4142 20.6666 31.5981C20.6666 32.7785 21.5591 33.6972 22.7058 33.6972C23.8533 33.6972 24.745 32.7785 24.745 31.5981C24.7416 30.4142 23.85 29.4963 22.7083 29.4963Z" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.4, d: "M34.6666 10.6666H10.6666C7.72915 10.6666 5.33331 13.1329 5.33331 16.0796V32.5502C5.33331 35.647 7.72915 38.1176 10.6666 38.1176L13.3333 38.1185V42.7723C13.3333 43.4584 14.0937 43.8549 14.625 43.4479L21.5208 38.1189L34.6666 38.109C37.6041 38.1198 40 35.6487 40 32.6257V16.0796C40 13.1329 37.6083 10.6666 34.6666 10.6666ZM22.7083 33.6997C21.5583 33.6997 20.6666 32.7818 20.6666 31.598C20.6666 30.4167 21.5591 29.4989 22.7058 29.4989C23.8533 29.4989 24.745 30.4176 24.745 31.598C24.7416 32.7818 23.85 33.6997 22.7083 33.6997ZM27.0916 24.2978L24.16 26.1344V26.2656C24.16 27.1183 23.459 27.8397 22.6308 27.8397C21.8026 27.8397 21.175 27.1201 21.175 26.2708V25.2156C21.175 24.6909 21.4299 24.1665 21.9396 23.8379L25.5721 21.6076C26.0183 21.3451 26.2731 20.8859 26.2731 20.3611C26.2731 19.5738 25.6358 18.9182 24.8715 18.9182H21.5583C20.7935 18.9182 20.1566 19.5741 20.1566 20.3611C20.1566 21.2139 19.4556 21.9353 18.6275 21.9353C17.7991 21.9353 17.0983 21.2136 17.0983 20.3611C17.0983 17.803 19.0741 15.7691 21.5591 15.7691H24.8725C27.3583 15.7734 29.3333 17.8065 29.3333 20.3688C29.3333 21.9387 28.5083 23.4485 27.0916 24.2978Z" })));
const SvgMessagesQuestionRegular = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_110_149)" }, /* @__PURE__ */ React.createElement("path", { d: "M21 29.3333C21 28.3416 21.675 27.6666 22.6667 27.6666C23.5833 27.6666 24.3333 28.3416 24.3333 29.3333C24.3333 30.25 23.5833 31 22.6667 31C21.675 31 21 30.25 21 29.3333ZM21.2583 16.6666H23.8167C25.9917 16.6666 27.7667 18.4391 27.7667 20.6166C27.7667 22.125 26.925 23.4833 25.5083 24.15L23.925 24.9416V25.3333C23.925 26.0666 23.4 26.6666 22.5917 26.6666C21.9333 26.6666 21.2583 26.0666 21.2583 25.3333V24.1166C21.2583 23.6083 21.6167 23.15 22.0667 22.925L24.3917 21.7666C24.825 21.55 25.1 21.1083 25.1 20.6166C25.1 19.9083 24.525 19.3333 23.8167 19.3333H21.2583C20.6917 19.3333 20.2333 19.7916 20.2333 20.35C20.2333 21.0916 19.6417 21.6833 18.9 21.6833C18.0917 21.6833 17.5667 21.0916 17.5667 20.35C17.5667 18.32 19.225 16.6666 21.2583 16.6666ZM34.6667 37.325L24 37.3333L14.925 42.4666C14.7417 42.6083 14.5333 42.6666 14.3333 42.6666C13.8167 42.6666 13.3333 42.2583 13.3333 41.6666V37.3333H10.6667C7.72916 37.3333 5.33333 34.9416 5.33333 32V15.925C5.33333 13.0625 7.72916 10.6666 10.6667 10.6666H34.6667C37.6083 10.6666 40 13.0625 40 15.925V32C40 34.9416 37.6083 37.325 34.6667 37.325ZM34.6667 33.3333C35.3917 33.3333 36 32.7333 36 32V16C36 15.2708 35.3917 14.6666 34.6667 14.6666H10.6667C9.9375 14.6666 9.33333 15.2708 9.33333 16V32C9.33333 32.7333 9.9375 33.3333 10.6667 33.3333H17.3333V36.5083L22.95 33.3333H34.6667ZM30.6667 40V42.6666C30.6667 43.3916 31.2667 44 32 44H41.05L46.6667 47.175V44H53.3333C54.0583 44 54.6667 43.3916 54.6667 42.6666V26.6666C54.6667 25.9333 54.0583 25.3333 53.3333 25.3333H42.6667V21.3333H53.3333C56.275 21.3333 58.6667 23.725 58.6667 26.5916V42.6666C58.6667 45.6083 56.275 48 53.3333 48H50.6667V52.3333C50.6667 52.925 50.1833 53.3333 49.6667 53.3333C49.4667 53.3333 49.2583 53.275 49.075 53.1333L40 48L32 47.9916C29.0667 47.9916 26.6667 45.6083 26.6667 42.6666V40H30.6667Z" })));
const SvgMoneyCheckPen = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4.8 16.375V41.875C4.8 42.7516 5.516 43.4688 6.4 43.4688H34.83C34.27 44.176 33.87 44.9928 33.65 45.8693L33.05 48.25H6.4C2.865 48.25 0 45.3912 0 41.875V16.375C0 12.8538 2.865 10 6.4 10H51.2C54.73 10 57.6 12.8538 57.6 16.375V22.8098C56.08 23.009 54.62 23.6863 53.46 24.8518L52.8 25.4992V16.375C52.8 15.4984 52.08 14.7812 51.2 14.7812H6.4C5.516 14.7812 4.8 15.4984 4.8 16.375ZM32.8 30.7188C34.13 30.7188 35.2 31.7846 35.2 33.1094C35.2 34.4342 34.13 35.5 32.8 35.5H12C10.67 35.5 9.6 34.4342 9.6 33.1094C9.6 31.7846 10.67 30.7188 12 30.7188H32.8ZM9.6 23.5469C9.6 22.2221 10.67 21.1562 12 21.1562H42.4C43.73 21.1562 44.8 22.2221 44.8 23.5469C44.8 24.8717 43.73 25.9375 42.4 25.9375H12C10.67 25.9375 9.6 24.8717 9.6 23.5469ZM62.81 28.5373C64.38 30.0912 64.38 32.6113 62.81 34.1752L59.87 37.1037L52.78 30.0314L55.72 27.1029C57.28 25.549 59.81 25.549 61.38 27.1029L62.81 28.5373ZM37.59 45.0725L50.51 32.2926L57.61 39.3549L44.69 52.2244C44.28 52.6328 43.76 52.9217 43.2 53.0611L37.19 54.5652C36.64 54.6947 36.07 54.5354 35.67 54.1469C35.27 53.7484 35.11 53.1707 35.25 52.5432L36.75 46.6363C36.89 46.0785 37.18 45.5705 37.59 45.0725Z" }));
const SvgPaperPlaneTop = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2131_462)" }, /* @__PURE__ */ React.createElement("path", { d: "M57.8771 28.3824L8.87803 7.38171C8.43398 7.1914 7.96586 7 7.50212 7C6.559 7 5.63185 7.3827 4.95373 8.0992C3.9455 9.26511 3.71312 10.8499 4.36935 12.1635L14.4998 31.598L4.36968 51.0335C3.71345 52.3482 3.94586 53.9319 4.95417 55.0005C5.63097 55.7165 6.55758 56.0997 7.50037 56.0997C7.96521 56.0997 8.43343 56.0074 8.87738 55.816L57.8771 34.8135C59.1655 34.2633 60 32.9968 60 31.5969C59.9005 30.198 59.1677 28.9293 57.8771 28.3824ZM11.3192 14.1399L45.9336 28.973H19.0497L11.3192 14.1399ZM19.0497 34.2229H45.9226L11.317 49.0539L19.0497 34.2229Z" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2131_462" }, /* @__PURE__ */ React.createElement("rect", { width: 56, height: 50, fill: "white", transform: "translate(4 7)" }))));
const SvgPenToSquare = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_307_11)" }, /* @__PURE__ */ React.createElement("path", { d: "M44.8078 6.73103C47.8813 3.65574 52.8687 3.65574 55.9422 6.73103L57.2656 8.05666C60.3391 11.1323 60.3391 16.1187 57.2656 19.1921L35.6969 40.7718C34.7453 41.7124 33.575 42.4015 32.2844 42.7734L21.3469 45.9015C20.4281 46.164 19.4438 45.9015 18.7656 45.1359C18.0984 44.5562 17.8359 43.5718 18.0984 42.6531L21.2266 31.7156C21.5984 30.4249 22.2875 29.2546 23.2281 28.3031L44.8078 6.73103ZM52.1359 10.4432C51.2062 9.41838 49.5438 9.41838 48.5156 10.4432L45.3328 13.6249L50.375 18.6671L53.5578 15.3859C54.5859 14.4562 54.5859 12.7937 53.5578 11.7688L52.1359 10.4432ZM26.2797 33.1593L24.4422 39.5577L30.8406 37.7202C31.2781 37.5999 31.6609 37.3702 31.9781 37.0531L46.6672 22.3749L41.625 17.3328L26.9469 32.0218C26.6297 32.339 26.4 32.7218 26.2797 33.1593ZM25.875 10.9999C27.3297 10.9999 28.5 12.1757 28.5 13.6249C28.5 15.0796 27.3297 16.2499 25.875 16.2499H13.625C11.2089 16.2499 9.25 18.2078 9.25 20.6249V50.3749C9.25 52.7921 11.2089 54.7499 13.625 54.7499H43.375C45.7922 54.7499 47.75 52.7921 47.75 50.3749V38.1249C47.75 36.6702 48.9203 35.4999 50.375 35.4999C51.8297 35.4999 53 36.6702 53 38.1249V50.3749C53 55.6906 48.6906 59.9999 43.375 59.9999H13.625C8.30938 59.9999 4 55.6906 4 50.3749V20.6249C4 15.3093 8.30938 10.9999 13.625 10.9999H25.875Z" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_307_11" }, /* @__PURE__ */ React.createElement("rect", { width: 56, height: 56, transform: "translate(4 4)" }))));
const SvgPersonSign = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2033_123)" }, /* @__PURE__ */ React.createElement("path", { d: "M51.9172 7.52181C52.4094 6.15463 51.7094 4.65619 50.3532 4.15306C48.9969 3.64994 47.4766 4.36088 46.9844 5.72806L46.4813 7.11713L39.9516 4.73275C38.5844 4.24056 37.086 4.94056 36.5829 6.29681L32.3938 17.814C31.9016 19.1812 32.6016 20.6796 33.9579 21.1828L40.4876 23.5562L38.6172 28.7187L36.5063 27.9312C35.1829 27.4281 34.0126 26.5859 33.1266 25.4812L30.0313 21.6093C28.2047 19.3234 25.4376 17.9999 22.5172 17.9999H18.1751C14.3688 17.9999 10.9235 20.2421 9.38131 23.7203L4.22975 35.314C3.63912 36.6374 4.24068 38.1906 5.56412 38.7812C6.88756 39.3718 8.44068 38.7702 9.03131 37.4468L12.7501 29.0578V57.3749C12.7501 58.8296 13.9204 59.9999 15.3751 59.9999C16.8297 59.9999 18.0001 58.8296 18.0001 57.3749V42.4999H23.7094L26.6735 49.0187C26.7282 49.1281 26.7501 49.2593 26.7501 49.3796V57.3749C26.7501 58.8296 27.9204 59.9999 29.3751 59.9999C30.8297 59.9999 32.0001 58.8296 32.0001 57.3749V49.3796C32.0001 48.5046 31.8141 47.6406 31.4532 46.8421L27.6251 38.4202V27.0124L29.0141 28.7515C30.4907 30.5999 32.4376 32.0109 34.6579 32.8421L36.8126 33.6515L35.6094 36.9656C35.1172 38.3327 35.8172 39.8312 37.1735 40.3343C38.5297 40.8374 40.0391 40.1265 40.5422 38.7702L45.4204 25.3609L52.0485 27.7671C53.4157 28.2593 54.9141 27.5593 55.4172 26.2031L59.6063 14.6859C60.0985 13.3187 59.3985 11.8203 58.0422 11.3171L51.4141 8.91088L51.9172 7.52181ZM40.6188 10.5624L53.7766 15.3531L51.3813 21.9374L38.2235 17.1468L40.6188 10.5624ZM19.7501 14.4999C21.1424 14.4999 22.4778 13.9468 23.4624 12.9622C24.4469 11.9777 25.0001 10.6423 25.0001 9.24994C25.0001 7.85755 24.4469 6.52219 23.4624 5.53763C22.4778 4.55306 21.1424 3.99994 19.7501 3.99994C18.3577 3.99994 17.0223 4.55306 16.0377 5.53763C15.0532 6.52219 14.5001 7.85755 14.5001 9.24994C14.5001 10.6423 15.0532 11.9777 16.0377 12.9622C17.0223 13.9468 18.3577 14.4999 19.7501 14.4999ZM18.1751 23.2499H22.3751V37.2499H18.0001V23.2499C18.0547 23.2499 18.1204 23.2499 18.1751 23.2499Z" })), /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2033_123" }, /* @__PURE__ */ React.createElement("rect", { width: 56, height: 56, transform: "translate(4 4)" })));
const SvgPhone = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_217_27)" }, /* @__PURE__ */ React.createElement("path", { d: "M50.6917 37.3583L42.5083 33.85C40.7242 33.0765 38.6217 33.5909 37.4083 35.0958L35.1217 37.8875C31.39 35.7416 28.2642 32.6166 26.1217 28.9625L28.9175 26.6725C30.41 25.4541 30.925 23.3641 30.1692 21.585L26.6417 13.2941C25.795 11.3608 23.6967 10.3058 21.6525 10.7783L14.0483 12.5333C12.0583 12.9883 10.6667 14.7358 10.6667 16.7825C10.6667 36.9408 27.0583 53.3325 47.2167 53.3325C49.2633 53.3325 51.0108 51.9416 51.3917 49.955L53.1467 42.3433C53.7 40.2916 52.6333 38.1916 50.6917 37.3583ZM49.325 41.4416L47.5675 49.0591C47.5284 49.1508 47.3918 49.3325 47.2159 49.3325C29.2659 49.3325 14.6659 34.7325 14.6659 16.7825C14.6659 16.608 14.774 16.4714 14.9446 16.4323L22.5563 14.6756C22.5823 14.6691 22.6096 14.6665 22.6357 14.6665C22.7802 14.6665 22.9156 14.7538 22.9729 14.8839L26.4846 23.0781C26.5471 23.2253 26.5054 23.3971 26.3804 23.4999L22.3167 26.7583C21.5979 27.3468 21.3792 28.3533 21.788 29.1866C24.5388 34.7891 29.143 39.395 34.7463 42.145C35.5047 42.5538 36.5872 42.335 37.1763 41.6163L40.5105 37.5438C40.6029 37.4266 40.7761 37.3823 40.9207 37.45L49.109 40.9575C49.2667 41.1 49.3583 41.275 49.325 41.4416Z" })));
const SvgPhotoCamera = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19.75 35.647C19.75 29.275 25.2297 24.1176 32 24.1176C38.7703 24.1176 44.25 29.275 44.25 35.647C44.25 42.0191 38.7703 47.1764 32 47.1764C25.2297 47.1764 19.75 42.0191 19.75 35.647ZM32 29.0588C28.1391 29.0588 25 32.0132 25 35.647C25 39.2808 28.1391 42.2352 32 42.2352C35.8609 42.2352 39 39.2808 39 35.647C39 32.0132 35.8609 29.0588 32 29.0588ZM43.6922 12.6726L44.8297 15.8823H53C56.8609 15.8823 60 18.8367 60 22.4705V48.8235C60 52.4573 56.8609 55.4117 53 55.4117H11C7.13359 55.4117 4 52.4573 4 48.8235V22.4705C4 18.8367 7.13359 15.8823 11 15.8823H19.1703L20.3078 12.6726C21.0188 10.6549 23.0203 9.29407 25.2844 9.29407H38.7156C40.9797 9.29407 42.9813 10.6549 43.6922 12.6726ZM11 20.8235C10.0331 20.8235 9.25 21.5647 9.25 22.4705V48.8235C9.25 49.7294 10.0331 50.4705 11 50.4705H53C53.9625 50.4705 54.75 49.7294 54.75 48.8235V22.4705C54.75 21.5647 53.9625 20.8235 53 20.8235H41.0453L38.7156 14.2352H25.2844L22.9547 20.8235H11Z" }));
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M58 32C58 34.2113 56.2088 36.0013 54 36.0013H36V54.0013C36 56.2125 34.2088 58 32 58C29.7912 58 28 56.2125 28 54.0013V36.0013H10C7.79125 36.0013 6 34.2113 6 32C6 29.7887 7.79125 28.0012 10 28.0012H28V10.0013C28 7.79 29.7912 6 32 6C34.2088 6 36 7.79 36 10.0013V28.0012H54C56.2125 28 58 29.7875 58 32Z" }));
const SvgRecycle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22.4187 20.8766C22.2437 20.1547 21.7625 19.5312 21.0953 19.1813C20.439 18.8313 19.6515 18.7766 18.9515 19.0391L9.08263 22.725C7.72528 23.2281 7.03513 24.7484 7.54153 26.1047C8.05013 27.4609 9.55731 28.15 10.9212 27.6469L14.0515 26.4766L6.99466 38.2453C5.43606 40.843 5.31685 44.0083 6.66992 46.712L6.94336 47.2589C8.44388 50.2547 11.4615 52.125 14.8215 52.125H18.875C20.3242 52.125 21.5 50.9503 21.5 49.5011C21.5 48.0519 20.3297 46.875 18.875 46.875H14.8215C13.4642 46.875 12.2447 46.123 11.6398 44.9095L11.3653 44.3594C10.8184 43.269 10.8663 41.9903 11.4986 40.9414L18.9044 28.593L19.8247 32.3566C20.1187 33.5564 21.1919 34.3592 22.3709 34.3592C22.5794 34.3592 22.7879 34.3353 22.9964 34.284C24.4052 33.9388 25.2693 32.5209 24.9236 31.1121L22.4187 20.8766ZM23.4797 15.8781C24.7265 16.6219 26.3343 16.2172 27.0781 14.9703L28.9506 11.8466C30.2215 9.72031 33.7697 9.72031 35.0483 11.8466L41.3843 22.4056L37.4961 21.2703C36.1158 20.8669 34.649 21.6599 34.2422 23.0542C33.8375 24.3547 34.6359 25.9078 36.025 26.3125L46.1389 29.2689C46.3828 29.3422 46.6343 29.375 46.875 29.375C47.3638 29.375 47.8457 29.2383 48.2695 28.9751C48.9093 28.5766 49.3359 27.9312 49.4672 27.1875L51.2172 16.7969C51.4578 15.3641 50.4953 14.0111 49.0625 13.7716C47.5892 13.5049 46.2767 14.4928 46.0372 15.9219L45.5061 19.0719L39.5529 9.15156C37.9718 6.51234 35.0734 4.875 32 4.875C28.9265 4.875 26.0281 6.51234 24.4422 9.15047L22.5718 12.2753C21.8281 13.5189 22.2328 15.1344 23.4797 15.8781ZM57.0031 38.2453L54.5487 34.1536C53.8037 32.9133 52.1972 32.5064 50.9459 33.2513C49.7012 33.9998 49.2987 35.6094 50.0436 36.8541L52.4979 40.9458C53.1302 41.9951 53.1781 43.2733 52.6313 44.367L52.3578 44.9139C51.7531 46.1203 50.539 46.875 49.1828 46.875H35.4125L38.1272 44.4622C39.2106 43.4984 39.3095 41.8405 38.3459 40.7566C37.3752 39.6662 35.7176 39.5775 34.6403 40.5378L26.7653 47.5378C26.1922 48.0344 25.875 48.7562 25.875 49.5C25.875 50.2438 26.1963 50.9634 26.7568 51.4622L34.6318 58.4622C35.1281 58.9062 35.7515 59.125 36.375 59.125C37.0962 59.125 37.8176 58.8276 38.3372 58.2432C39.301 57.1597 39.2019 55.5023 38.1184 54.5376L35.4015 52.125H49.1718C52.5318 52.125 55.5495 50.2591 57.0501 47.2545L57.3236 46.711C58.589 44.0094 58.5672 40.8375 57.0031 38.2453Z" }));
const SvgScrewdriverWrench = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2033_19)" }, /* @__PURE__ */ React.createElement("path", { d: "M12.5969 4.54685C11.5579 3.73747 10.0813 3.83591 9.14067 4.7656L4.76567 9.1406C3.83599 10.0703 3.73755 11.5468 4.53599 12.5968L13.286 23.9718C13.7782 24.6172 14.5547 25 15.3641 25H21.2813L33.2032 36.9218C31.5954 40.0937 32.1094 44.075 34.7672 46.7218L47.0172 58.9718C48.3844 60.339 50.6047 60.339 51.9719 58.9718L58.9719 51.9718C60.3391 50.6047 60.3391 48.3843 58.9719 47.0172L46.7219 34.7672C44.0751 32.1203 40.0938 31.5953 36.9219 33.2031L25 21.2812V15.375C25 14.5547 24.6172 13.789 23.9719 13.2968L12.5969 4.54685ZM6.53755 45.2125C4.90786 46.8422 4.00005 49.0406 4.00005 51.3375C4.00005 56.1172 7.88286 60 12.6625 60C14.9594 60 17.1579 59.0922 18.7875 57.4625L30.086 46.164C29.1125 44.239 28.686 42.1062 28.8172 40.0062L15.0797 53.7547C14.4344 54.389 13.5704 54.75 12.6625 54.75C10.7813 54.75 9.25005 53.2187 9.25005 51.3375C9.25005 50.4297 9.61099 49.5656 10.2454 48.9203L25.2516 33.914L21.5438 30.2062L6.53755 45.2125ZM54.7391 21.9375C54.586 26.1922 52.2672 29.9 48.8547 31.9781C48.975 32.0875 49.0844 32.1968 49.1938 32.3062L52.65 35.7625C57.1016 32.5906 60 27.3843 60 21.5109C60 18.7984 59.3766 16.2281 58.2829 13.9312C57.8016 12.925 56.4782 12.7828 55.6907 13.5703L48.2641 20.9968C47.936 21.325 47.4875 21.5109 47.0282 21.5109H44.25C43.2875 21.5109 42.5 20.7234 42.5 19.7609V16.9718C42.5 16.5125 42.686 16.064 43.0141 15.7359L50.4407 8.30935C51.2282 7.52185 51.086 6.19841 50.0797 5.71716C47.7829 4.62341 45.2125 3.99997 42.5 3.99997C36.2329 3.99997 30.7313 7.29216 27.6469 12.2468C28.1938 13.1875 28.5 14.2593 28.5 15.375V19.8375L30.25 21.5875V21.5C30.25 14.8828 35.5 9.47966 42.0625 9.26091L39.2954 12.0281C37.9829 13.3406 37.25 15.1234 37.25 16.9828V19.75C37.25 23.6109 40.3891 26.75 44.25 26.75H47.0282C48.8876 26.75 50.6704 26.0172 51.9829 24.7047L54.7391 21.9375Z" })));
const SvgScrollOld = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M58.6667 37.25H53.3333V16.25C53.3333 11.4255 49.3444 7.5 44.4444 7.5H8.88889C3.98778 7.5 0 11.4255 0 16.25V21.5C0 24.3995 2.38778 26.75 5.33333 26.75H8.88889V21.5H5.33333V16.25C5.33333 14.3228 6.93111 12.75 8.88889 12.75C10.8467 12.75 12.4444 14.3228 12.4444 16.25V47.75C12.4444 52.5745 16.4322 56.5 21.3333 56.5H50.9556C58.1444 56.5 64 50.7359 64 43.6594V42.5C64 39.6016 61.6111 37.25 58.6667 37.25ZM24.8889 40.75V47.75C24.8889 49.6772 23.2911 51.25 21.3333 51.25C19.3756 51.25 17.7778 49.6772 17.7778 47.75V32H23.1111C24.0889 32 24.8889 31.2125 24.8889 30.25C24.8889 29.2875 24.0889 28.5 23.1111 28.5H17.7778V16.25C17.7778 15.0042 17.503 13.8241 17.0243 12.75H44.4444C46.4 12.75 48 14.325 48 16.25V18H44.4444C43.4667 18 42.6667 18.7875 42.6667 19.75C42.6667 20.7125 43.4667 21.5 44.4444 21.5H48V28.5H44.4444C43.4667 28.5 42.6667 29.2875 42.6667 30.25C42.6667 31.2125 43.4667 32 44.4444 32H48V37.25H28.4444C26.4778 37.25 24.8889 38.8141 24.8889 40.75ZM58.6667 43.6594C58.6667 47.8484 55.2111 51.25 50.9556 51.25H29.4667C29.9444 50.1781 30.2222 48.9969 30.2222 47.75V42.5H40.8889V46C40.8889 46.9673 41.684 47.75 42.6667 47.75C43.6493 47.75 44.4444 46.9673 44.4444 46V42.5H58.6667V43.6594Z" }));
const SvgSecurityCamera = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M50 4H15C11.0625 4 8 7.17188 8 11V42.5C8 46.4376 11.0625 49.5 15 49.5H19.4844L15.3281 56.0624C14.8906 56.828 14.7812 57.8124 15.2188 58.6876C15.7656 59.5624 16.6406 60 17.625 60H47.2656C48.1408 60 49.0156 59.5624 49.5624 58.6876C50 57.8124 50 56.828 49.4532 56.0624L45.4064 49.5H49.8908C53.828 49.5 56.8908 46.4376 56.8908 42.5V11C57 7.17188 53.828 4 50 4ZM22.3281 54.75L25.7188 49.5H39.1719L42.5625 54.75H22.3281ZM51.75 42.5C51.75 43.4844 50.8752 44.25 50 44.25H15C14.0156 44.25 13.25 43.4844 13.25 42.5V11C13.25 10.125 14.0156 9.25 15 9.25H50C50.8752 9.25 51.75 10.125 51.75 11V42.5ZM32.5 14.5C25.7188 14.5 20.25 20.0781 20.25 26.75C20.25 33.5312 25.7188 39 32.5 39C39.1719 39 44.75 33.5312 44.75 26.75C44.75 20.0781 39.1719 14.5 32.5 14.5ZM32.5 33.75C28.5625 33.75 25.5 30.6875 25.5 26.75C25.5 22.9219 28.5625 19.75 32.5 19.75C36.3281 19.75 39.5 22.9219 39.5 26.75C39.5 30.6875 36.3281 33.75 32.5 33.75Z" }));
const SvgTable = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M53 7.5C56.8609 7.5 60 10.6336 60 14.5V49.5C60 53.3609 56.8609 56.5 53 56.5H11C7.13359 56.5 4 53.3609 4 49.5V14.5C4 10.6336 7.13359 7.5 11 7.5H53ZM29.375 32.875V21.5H9.25V32.875H29.375ZM9.25 38.125V49.5C9.25 50.4625 10.0331 51.25 11 51.25H29.375V38.125H9.25ZM34.625 51.25H53C53.9625 51.25 54.75 50.4625 54.75 49.5V38.125H34.625V51.25ZM54.75 32.875V21.5H34.625V32.875H54.75Z" }));
const SvgTag = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 18C14 15.875 15.75 14 18 14C20.125 14 22 15.875 22 18C22 20.25 20.125 22 18 22C15.75 22 14 20.25 14 18ZM28.625 4C30.75 4 32.75 4.875 34.25 6.375L56.25 28.375C59.375 31.5 59.375 36.625 56.25 39.75L39.625 56.375C36.5 59.5 31.375 59.5 28.25 56.375L6.25 34.375C4.75 32.875 4 30.875 4 28.75V10C4 6.75 6.625 4 10 4H28.625ZM10.5 30.125L32.5 52.125C33.25 53 34.625 53 35.375 52.125L52 35.5C52.875 34.75 52.875 33.375 52 32.625L30 10.625C29.625 10.25 29.125 10 28.625 10H10V28.75C10 29.25 10.125 29.75 10.5 30.125Z" }));
const SvgThumbsDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M39.475 59.6501C34.7 61.0126 29.7125 58.2501 28.35 53.4751L27.6375 50.9751C27.175 49.3501 26.3375 47.8501 25.2 46.6001L18.7875 39.5501C17.675 38.3251 17.7625 36.4251 18.9875 35.3126C20.2125 34.2001 22.1125 34.2876 23.225 35.5126L29.6375 42.5626C31.4 44.5001 32.6875 46.8126 33.4 49.3251L34.1125 51.8251C34.5625 53.4126 36.225 54.3376 37.825 53.8876C39.425 53.4376 40.3375 51.7751 39.8875 50.1751L39.175 47.6751C38.4625 45.1876 37.3375 42.8376 35.85 40.7376C35.2 39.8251 35.125 38.6251 35.6375 37.6251C36.15 36.6251 37.175 36.0001 38.3 36.0001H55C56.1 36.0001 57 35.1001 57 34.0001C57 33.1501 56.4625 32.4126 55.7 32.1251C54.775 31.7751 54.075 31.0001 53.8375 30.0376C53.6 29.0751 53.85 28.0626 54.5 27.3251C54.8125 26.9751 55 26.5126 55 26.0001C55 25.0251 54.3 24.2126 53.375 24.0376C52.35 23.8376 51.4875 23.1251 51.125 22.1376C50.7625 21.1501 50.925 20.0501 51.575 19.2251C51.8375 18.8876 52 18.4626 52 17.9876C52 17.1501 51.475 16.4126 50.725 16.1251C49.2875 15.5626 48.5125 14.0126 48.925 12.5251C48.975 12.3626 49 12.1751 49 11.9876C49 10.8876 48.1 9.9876 47 9.9876H34.8125C33.2375 9.9876 31.6875 10.4501 30.375 11.3251L22.6625 16.4626C21.2875 17.3876 19.425 17.0126 18.5 15.6251C17.575 14.2376 17.95 12.3876 19.3375 11.4626L27.05 6.3251C29.35 4.7876 32.05 3.9751 34.8125 3.9751H47C51.3375 3.9751 54.8625 7.4251 55 11.7251C56.825 13.1876 58 15.4376 58 17.9751C58 18.5376 57.9375 19.0751 57.8375 19.6001C59.7625 21.0626 61 23.3751 61 25.9751C61 26.7876 60.875 27.5751 60.65 28.3126C62.1 29.7876 63 31.7876 63 34.0001C63 38.4126 59.425 42.0001 55 42.0001H43.4625C44.05 43.3001 44.55 44.6501 44.9375 46.0251L45.65 48.5251C47.0125 53.3001 44.25 58.2876 39.475 59.6501ZM3 48.0001C0.7875 48.0001 -1 46.2126 -1 44.0001V16.0001C-1 13.7876 0.7875 12.0001 3 12.0001H11C13.2125 12.0001 15 13.7876 15 16.0001V44.0001C15 46.2126 13.2125 48.0001 11 48.0001H3Z" }));
const SvgThumbsUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M39.475 4.3499C34.7 2.9874 29.7125 5.7499 28.35 10.5249L27.6375 13.0249C27.175 14.6499 26.3375 16.1499 25.2 17.3999L18.7875 24.4499C17.675 25.6749 17.7625 27.5749 18.9875 28.6874C20.2125 29.7999 22.1125 29.7124 23.225 28.4874L29.6375 21.4374C31.4 19.4999 32.6875 17.1874 33.4 14.6749L34.1125 12.1749C34.5625 10.5874 36.225 9.6624 37.825 10.1124C39.425 10.5624 40.3375 12.2249 39.8875 13.8249L39.175 16.3249C38.4625 18.8124 37.3375 21.1624 35.85 23.2624C35.2 24.1749 35.125 25.3749 35.6375 26.3749C36.15 27.3749 37.175 27.9999 38.3 27.9999H55C56.1 27.9999 57 28.8999 57 29.9999C57 30.8499 56.4625 31.5874 55.7 31.8749C54.775 32.2249 54.075 32.9999 53.8375 33.9624C53.6 34.9249 53.85 35.9374 54.5 36.6749C54.8125 37.0249 55 37.4874 55 37.9999C55 38.9749 54.3 39.7874 53.375 39.9624C52.35 40.1624 51.4875 40.8749 51.125 41.8499C50.7625 42.8249 50.925 43.9374 51.575 44.7624C51.8375 45.0999 52 45.5249 52 45.9999C52 46.8374 51.475 47.5749 50.725 47.8624C49.2875 48.4249 48.5125 49.9749 48.925 51.4624C48.975 51.6249 49 51.8124 49 51.9999C49 53.0999 48.1 53.9999 47 53.9999H34.8125C33.2375 53.9999 31.6875 53.5374 30.375 52.6624L22.6625 47.5249C21.2875 46.5999 19.425 46.9749 18.5 48.3624C17.575 49.7499 17.95 51.5999 19.3375 52.5249L27.05 57.6624C29.35 59.1999 32.05 60.0124 34.8125 60.0124H47C51.3375 60.0124 54.8625 56.5624 55 52.2624C56.825 50.7999 58 48.5499 58 46.0124C58 45.4499 57.9375 44.9124 57.8375 44.3874C59.7625 42.9249 61 40.6124 61 38.0124C61 37.1999 60.875 36.4124 60.65 35.6749C62.1 34.2124 63 32.2124 63 29.9999C63 25.5874 59.425 21.9999 55 21.9999H43.4625C44.05 20.6999 44.55 19.3499 44.9375 17.9749L45.65 15.4749C47.0125 10.6999 44.25 5.7124 39.475 4.3499ZM3 23.9999C0.7875 23.9999 -1 25.7874 -1 27.9999V55.9999C-1 58.2124 0.7875 59.9999 3 59.9999H11C13.2125 59.9999 15 58.2124 15 55.9999V27.9999C15 25.7874 13.2125 23.9999 11 23.9999H3Z" }));
const SvgTrashCan = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1542_1677)" }, /* @__PURE__ */ React.createElement("path", { d: "M25.3125 6.45L22.9375 10H41.0625L38.6875 6.45C38.5 6.175 38.1875 6 37.85 6H26.1375C25.8 6 25.4875 6.1625 25.3 6.45H25.3125ZM43.6875 3.125L48.275 10H50H56H57C58.6625 10 60 11.3375 60 13C60 14.6625 58.6625 16 57 16H56V54C56 59.525 51.525 64 46 64H18C12.475 64 8 59.525 8 54V16H7C5.3375 16 4 14.6625 4 13C4 11.3375 5.3375 10 7 10H8H14H15.725L20.3125 3.1125C21.6125 1.175 23.8 0 26.1375 0H37.85C40.1875 0 42.375 1.175 43.675 3.1125L43.6875 3.125ZM14 16V54C14 56.2125 15.7875 58 18 58H46C48.2125 58 50 56.2125 50 54V16H14ZM24 24V50C24 51.1 23.1 52 22 52C20.9 52 20 51.1 20 50V24C20 22.9 20.9 22 22 22C23.1 22 24 22.9 24 24ZM34 24V50C34 51.1 33.1 52 32 52C30.9 52 30 51.1 30 50V24C30 22.9 30.9 22 32 22C33.1 22 34 22.9 34 24ZM44 24V50C44 51.1 43.1 52 42 52C40.9 52 40 51.1 40 50V24C40 22.9 40.9 22 42 22C43.1 22 44 22.9 44 24Z" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_1542_1677" }, /* @__PURE__ */ React.createElement("rect", { width: 56, height: 64, transform: "translate(4)" }))));
const SvgTrashClock = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_669_1559)" }, /* @__PURE__ */ React.createElement("path", { d: "M47.375 12.75C48.8297 12.75 50 13.9258 50 15.375C50 16.8297 48.8297 18 47.375 18H46.1063L45.5812 25.1859C43.6781 25.4484 41.8734 25.9844 40.2 26.7609L40.8453 18H10.1536L12.7578 53.1313C12.8234 54.0391 13.5891 54.75 14.4969 54.75H32.1172C33.4406 56.7953 35.1469 58.5672 37.1375 59.9672C36.9297 59.9891 36.7109 60 36.5031 60H14.4969C10.835 60 7.79109 57.1672 7.51984 53.5141L4.88938 18H3.625C2.17578 18 1 16.8297 1 15.375C1 13.9258 2.17578 12.75 3.625 12.75H11.2616L15.2734 6.72781C16.4109 5.02342 18.325 4 20.3703 4H30.6297C32.675 4 34.5891 5.02353 35.7266 6.72781L39.7406 12.75H47.375ZM20.3703 9.25C20.0859 9.25 19.7141 9.39656 19.6484 9.63938L17.5703 12.75H33.4297L31.3516 9.63938C31.1875 9.39656 30.9141 9.25 30.6297 9.25H20.3703ZM64 44.25C64 52.9453 56.9453 60 48.25 60C39.5547 60 32.5 52.9453 32.5 44.25C32.5 35.5547 39.5547 28.5 48.25 28.5C56.9453 28.5 64 35.5547 64 44.25ZM46.4016 37.25V44.25C46.4016 45.2125 47.2875 46 48.1516 46H53.5C54.4625 46 55.25 45.2125 55.25 44.25C55.25 43.2875 54.4625 42.5 53.5 42.5H49.9016V37.25C49.9016 36.2875 49.2125 35.5 48.1516 35.5C47.2875 35.5 46.4016 36.2875 46.4016 37.25Z" })));
const SvgTriangleExclamation = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1009_1554)" }, /* @__PURE__ */ React.createElement("path", { d: "M32 7.5C33.5531 7.5 34.9859 8.32031 35.7734 9.66562L59.3984 49.9156C60.1969 51.2719 60.1969 52.9453 59.4203 54.3016C58.6437 55.6578 57.1891 56.5 55.625 56.5H8.37499C6.81093 56.5 5.35624 55.6578 4.57968 54.3016C3.80312 52.9453 3.81405 51.2609 4.60155 49.9156L28.2266 9.66562C29.0141 8.32031 30.4469 7.5 32 7.5ZM32 21.5C30.5453 21.5 29.375 22.6703 29.375 24.125V36.375C29.375 37.8297 30.5453 39 32 39C33.4547 39 34.625 37.8297 34.625 36.375V24.125C34.625 22.6703 33.4547 21.5 32 21.5ZM35.5 46C35.5 44.0641 33.9359 42.5 32 42.5C30.0641 42.5 28.5 44.0641 28.5 46C28.5 47.9359 30.0641 49.5 32 49.5C33.9359 49.5 35.5 47.9359 35.5 46Z" })));
const SvgTruckContainerRegular = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_110_146)" }, /* @__PURE__ */ React.createElement("path", { d: "M5.33333 19.3333C5.33333 16.0199 8.02 13.3333 11.3333 13.3333H32.6667C35.9833 13.3333 38.6667 16.0199 38.6667 19.3333V34.6666C38.6667 35.7749 37.775 36.6666 36.6667 36.6666C35.5583 36.6666 34.6667 35.7749 34.6667 34.6666V19.3333C34.6667 18.2291 33.775 17.3333 32.6667 17.3333H11.3333C10.2292 17.3333 9.33333 18.2291 9.33333 19.3333V34.6666C9.33333 35.7749 8.43749 36.6666 7.33333 36.6666C6.22916 36.6666 5.33333 35.7749 5.33333 34.6666V19.3333ZM56 43.9999C56 47.6832 53.0167 50.6666 49.3333 50.6666C45.65 50.6666 42.6667 47.6832 42.6667 43.9999H29.3333C29.3333 47.6832 26.35 50.6666 22.6667 50.6666C20.4833 50.6666 18.55 49.6166 17.3333 47.9999C16.1167 49.6166 14.1833 50.6666 12 50.6666C8.31833 50.6666 5.33333 47.6832 5.33333 43.9999C5.33333 40.3166 8.31833 37.3332 12 37.3332C14.1833 37.3332 16.1167 38.3832 17.3333 39.9249C18.55 38.3832 20.4833 37.3332 22.6667 37.3332C24.85 37.3332 26.7833 38.3832 28 39.9999H41.3333V24.6666C41.3333 23.5583 42.225 22.6666 43.3333 22.6666H49.4C50.8 22.6666 52.125 23.2916 53.0167 24.3749L57.8417 30.3666C58.4 30.9582 58.6667 31.7083 58.6667 32.4749V41.3332C58.6667 42.8082 57.475 43.9999 56 43.9999ZM49.9167 26.9082C49.7917 26.7582 49.6 26.6666 49.4 26.6666H45.3333V31.9999H54.0083L49.9167 26.9082ZM49.3333 46.6666C50.8083 46.6666 52 45.4749 52 43.9999C52 42.5249 50.8083 41.3332 49.3333 41.3332C47.8583 41.3332 46.6667 42.5249 46.6667 43.9999C46.6667 45.4749 47.8583 46.6666 49.3333 46.6666ZM22.6667 41.3332C21.1917 41.3332 20 42.5249 20 43.9999C20 45.4749 21.1917 46.6666 22.6667 46.6666C24.1417 46.6666 25.3333 45.4749 25.3333 43.9999C25.3333 42.5249 24.1417 41.3332 22.6667 41.3332ZM12 46.6666C13.4725 46.6666 14.6667 45.4749 14.6667 43.9999C14.6667 42.5249 13.4725 41.3332 12 41.3332C10.5275 41.3332 9.33333 42.5249 9.33333 43.9999C9.33333 45.4749 10.5275 46.6666 12 46.6666ZM16.6667 32.6666C16.6667 33.7749 15.775 34.6666 14.6667 34.6666C13.5625 34.6666 12.6667 33.7749 12.6667 32.6666V21.9999C12.6667 20.8916 13.5625 19.9999 14.6667 19.9999C15.775 19.9999 16.6667 20.8916 16.6667 21.9999V32.6666ZM24 32.6666C24 33.7749 23.1083 34.6666 22 34.6666C20.8917 34.6666 20 33.7749 20 32.6666V21.9999C20 20.8916 20.8917 19.9999 22 19.9999C23.1083 19.9999 24 20.8916 24 21.9999V32.6666ZM31.3333 32.6666C31.3333 33.7749 30.4417 34.6666 29.3333 34.6666C28.225 34.6666 27.3333 33.7749 27.3333 32.6666V21.9999C27.3333 20.8916 28.225 19.9999 29.3333 19.9999C30.4417 19.9999 31.3333 20.8916 31.3333 21.9999V32.6666Z" })));
const SvgTruckContainerDuotone = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_110_160)" }, /* @__PURE__ */ React.createElement("path", { d: "M49.4 22.3333C50.8 22.3333 52.125 22.9409 53.0166 23.9941L57.8416 29.8194C58.4 30.3946 58.6666 31.1238 58.6666 31.8691V39.1851C58.6666 39.8981 58.3666 40.5462 57.8833 41.0161C56.6 38.3992 53.85 36.5925 50.6666 36.5925C47.1833 36.5925 44.2166 38.7557 43.125 41.7777H34.2083C33.1166 38.7557 30.15 36.5925 26.6666 36.5925C23.8833 36.5925 21.4333 37.9698 20 40.0682C18.5666 37.9698 16.1166 36.5925 13.3333 36.5925C10.15 36.5925 7.40081 38.3992 6.11298 41.0161C5.63123 40.5462 5.33331 39.8981 5.33331 39.1851V37.8888C5.33331 36.4548 6.52748 35.2962 7.99998 35.2962H41.3333V24.2777C41.3333 23.2001 42.225 22.3333 43.3333 22.3333H49.4ZM49.9166 26.4571C49.7916 26.3113 49.6 26.2221 49.4 26.2221H45.3333V31.4073H54.0083L49.9166 26.4571Z" }), /* @__PURE__ */ React.createElement("path", { opacity: 0.4, d: "M34.6666 13.2593C36.875 13.2593 38.6666 15.0004 38.6666 17.1482V28.8148C38.6666 30.9618 36.875 32.7037 34.6666 32.7037H9.33331C7.12415 32.7037 5.33331 30.9618 5.33331 28.8148V17.1482C5.33331 15.0004 7.12415 13.2593 9.33331 13.2593H34.6666ZM12 16.5C11.2633 16.5 10.6666 17.0801 10.6666 17.7963V28.1667C10.6666 28.8796 11.2633 29.463 12 29.463C12.7366 29.463 13.3333 28.8796 13.3333 28.1667V17.7963C13.3333 17.0801 12.7366 16.5 12 16.5ZM24 28.1667C24 28.8796 24.6 29.463 25.3333 29.463C26.0666 29.463 26.6666 28.8796 26.6666 28.1667V17.7963C26.6666 17.0801 26.0666 16.5 25.3333 16.5C24.6 16.5 24 17.0801 24 17.7963V28.1667ZM18.6666 16.5C17.9333 16.5 17.3333 17.0801 17.3333 17.7963V28.1667C17.3333 28.8796 17.9333 29.463 18.6666 29.463C19.4 29.463 20 28.8796 20 28.1667V17.7963C20 17.0801 19.4 16.5 18.6666 16.5ZM30.6666 28.1667C30.6666 28.8796 31.2666 29.463 32 29.463C32.7333 29.463 33.3333 28.8796 33.3333 28.1667V17.7963C33.3333 17.0801 32.7333 16.5 32 16.5C31.2666 16.5 30.6666 17.0801 30.6666 17.7963V28.1667ZM7.99998 44.3704C7.99998 41.5104 10.3875 39.1852 13.3333 39.1852C16.275 39.1852 18.6666 41.5104 18.6666 44.3704C18.6666 47.2303 16.275 49.5556 13.3333 49.5556C10.3875 49.5556 7.99998 47.2303 7.99998 44.3704ZM21.3333 44.3704C21.3333 41.5104 23.725 39.1852 26.6666 39.1852C29.6083 39.1852 32 41.5104 32 44.3704C32 47.2303 29.6083 49.5556 26.6666 49.5556C23.725 49.5556 21.3333 47.2303 21.3333 44.3704ZM45.3333 44.3704C45.3333 41.5104 47.725 39.1852 50.6666 39.1852C53.6083 39.1852 56 41.5104 56 44.3704C56 47.2303 53.6083 49.5556 50.6666 49.5556C47.725 49.5556 45.3333 47.2303 45.3333 44.3704Z" })));
const SvgUpload = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M25 19.8584H29.6187V41.0021C29.6187 41.2771 29.8437 41.5021 30.1187 41.5021H33.8688C34.1438 41.5021 34.3688 41.2771 34.3688 41.0021V19.8584H39C39.4187 19.8584 39.65 19.3771 39.3937 19.0521L32.3937 10.1896C32.347 10.1299 32.2872 10.0816 32.219 10.0483C32.1508 10.0151 32.0759 9.9978 32 9.9978C31.9241 9.9978 31.8492 10.0151 31.781 10.0483C31.7128 10.0816 31.653 10.1299 31.6063 10.1896L24.6063 19.0459C24.35 19.3771 24.5813 19.8584 25 19.8584V19.8584ZM54.875 39.1271H51.125C50.85 39.1271 50.625 39.3521 50.625 39.6271V49.2521H13.375V39.6271C13.375 39.3521 13.15 39.1271 12.875 39.1271H9.125C8.85 39.1271 8.625 39.3521 8.625 39.6271V52.0021C8.625 53.1084 9.51875 54.0021 10.625 54.0021H53.375C54.4813 54.0021 55.375 53.1084 55.375 52.0021V39.6271C55.375 39.3521 55.15 39.1271 54.875 39.1271Z" }));
const SvgUserRegular = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_110_122)" }, /* @__PURE__ */ React.createElement("path", { d: "M36.75 37.25H26.25C15.6188 37.25 7 45.8688 7 56.5C7 58.4327 8.56734 60 10.5 60H52.5C54.4327 60 56 58.4327 56 56.5C56 45.8688 47.3813 37.25 36.75 37.25ZM12.3583 54.75C13.2223 47.8484 19.1188 42.5 26.25 42.5H36.75C43.8769 42.5 49.7766 47.8539 50.6406 54.75H12.3583ZM31.5 32C39.2317 32 45.5 25.7317 45.5 18C45.5 10.2683 39.2317 4 31.5 4C23.7683 4 17.5 10.2683 17.5 18C17.5 25.7328 23.7672 32 31.5 32ZM31.5 9.25C36.3245 9.25 40.25 13.1755 40.25 18C40.25 22.8245 36.3245 26.75 31.5 26.75C26.6755 26.75 22.75 22.8234 22.75 18C22.75 13.1755 26.6766 9.25 31.5 9.25Z" })));
const SvgUserSolid = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_1016_1611)" }, /* @__PURE__ */ React.createElement("path", { d: "M31.5 32C39.2328 32 45.5 25.7328 45.5 18C45.5 10.2672 39.2328 4 31.5 4C23.7672 4 17.5 10.2672 17.5 18C17.5 25.7328 23.7672 32 31.5 32ZM26.5016 37.25C15.7281 37.25 7 45.9781 7 56.7516C7 58.5453 8.45469 60 10.2484 60H52.7516C54.5453 60 56 58.5453 56 56.7516C56 45.9781 47.2719 37.25 36.4984 37.25H26.5016Z" })));
const SvgXmark = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_202_23)" }, /* @__PURE__ */ React.createElement("path", { d: "M44.675 41.9166C45.4557 42.6974 45.4557 43.9641 44.675 44.745C43.8942 45.5258 42.6275 45.5257 41.8467 44.745L32 34.825L22.0833 44.7416C21.3026 45.5224 20.0358 45.5224 19.255 44.7416C18.4742 43.9609 18.4742 42.6941 19.255 41.9133L29.175 32L19.2522 22.0083C18.4715 21.2275 18.4715 19.9608 19.2522 19.18C20.033 18.3991 21.2997 18.3992 22.0806 19.18L32 29.175L41.9167 19.2583C42.6974 18.4775 43.9642 18.4775 44.745 19.2583C45.5258 20.039 45.5257 21.3058 44.745 22.0866L34.825 32L44.675 41.9166Z" })));
const SvgFilterList = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.50625 11C6.02344 11 4 13.0234 4 15.5062C4 16.6437 4.42656 17.7375 5.20312 18.5797L15.375 29.5281V43.3094C15.375 44.775 16.1078 46.1531 17.3438 46.9625L25.6016 52.4094C26.1812 52.7922 26.8703 53 27.5703 53C29.5391 53 31.1359 51.4031 31.1359 49.4344V29.5281L41.3078 18.5797C42.0844 17.7484 42.5109 16.6547 42.5109 15.5062C42.5 13.0234 40.4766 11 37.9937 11H8.50625ZM19.925 26.7172L10.2125 16.25H36.2875L26.575 26.7172C26.1266 27.1984 25.875 27.8438 25.875 28.5V46.3062L20.625 42.8391V28.5C20.625 27.8328 20.3734 27.1984 19.925 26.7172ZM41.625 46.875C40.1703 46.875 39 48.0453 39 49.5C39 50.9547 40.1703 52.125 41.625 52.125H57.375C58.8297 52.125 60 50.9547 60 49.5C60 48.0453 58.8297 46.875 57.375 46.875H41.625ZM39 32C39 33.4547 40.1703 34.625 41.625 34.625H57.375C58.8297 34.625 60 33.4547 60 32C60 30.5453 58.8297 29.375 57.375 29.375H41.625C40.1703 29.375 39 30.5453 39 32ZM48.625 11.875C47.1703 11.875 46 13.0453 46 14.5C46 15.9547 47.1703 17.125 48.625 17.125H57.375C58.8297 17.125 60 15.9547 60 14.5C60 13.0453 58.8297 11.875 57.375 11.875H48.625Z" }));
const SvgRepeat = (props) => /* @__PURE__ */ React.createElement("svg", { width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2169_13)" }, /* @__PURE__ */ React.createElement("path", { d: "M4 28.5C4 30.4359 5.56406 32 7.5 32C9.43594 32 11 30.4359 11 28.5C11 22.7031 15.7031 18 21.5 18H39V21.5C39 22.9109 39.8531 24.1906 41.1656 24.7375C42.4781 25.2844 43.9766 24.9781 44.9828 23.9828L51.9828 16.9828C53.35 15.6156 53.35 13.3953 51.9828 12.0281L44.9828 5.02814C43.9766 4.02189 42.4781 3.72657 41.1656 4.27345C39.8531 4.82032 39 6.08907 39 7.50001V11H21.5C11.8312 11 4 18.8313 4 28.5ZM60 35.5C60 33.5641 58.4359 32 56.5 32C54.5641 32 53 33.5641 53 35.5C53 41.2969 48.2969 46 42.5 46H25V42.5C25 41.0891 24.1469 39.8094 22.8344 39.2625C21.5219 38.7156 20.0234 39.0219 19.0172 40.0172L12.0172 47.0172C10.65 48.3844 10.65 50.6047 12.0172 51.9719L19.0172 58.9719C20.0234 59.9781 21.5219 60.2734 22.8344 59.7266C24.1469 59.1797 25 57.9109 25 56.4891V52.9891H42.5C52.1688 52.9891 60 45.1578 60 35.4891V35.5Z" })));
const focusClasses = "outline-none focus-visible:ring-2 focus-visible:ring-midnight-900 focus-visible:ring-offset-2";
const classes = {
  base: "flex flex-row h-min w-fit rounded-lg items-center justify-center fill-current",
  sizes: {
    large: {
      withLabel: "py-2.5 px-5 gap-x-2",
      withoutLabel: "p-2.5",
      icon: "h-5 w-5 m-px"
    },
    medium: {
      withLabel: "py-2 px-4 gap-x-2",
      withoutLabel: "p-2",
      icon: "h-5 w-5 m-px"
    },
    small: {
      withLabel: "py-1 px-2 gap-x-2",
      withoutLabel: "p-1",
      icon: "h-5 w-5 m-px"
    }
  },
  loading: `bg-jungle-50 text-primary ${focusClasses}`,
  variants: {
    default: `bg-white text-black border border-gray-600 hover:bg-jungle-50 hover:text-primary active:text-jungle-900 active:bg-jungle-100 active:border-jungle-900 ${focusClasses} focus-visible:text-gray-900 disabled:bg-white disabled:text-gray-600 disabled:border-gray-600`,
    primary: `bg-primary border border-primary hover:bg-jungle-800 active:bg-jungle-900 text-white ${focusClasses} disabled:bg-jungle-400`,
    action: `text-primary hover:bg-jungle-200 active:bg-jungle-300 fill-jungle-900 hover:fill-gray-900 ${focusClasses} active:fill-gray-900 hover:text-gray-900 active:text-gray-900 border hover:border-jungle-200 active:border-transparent border-transparent disabled:bg-transparent disabled:border-transparent disabled:text-gray-600`,
    text: `text-gray-900 hover:bg-gray-100 border border-transparent active:bg-gray-200 ${focusClasses} disabled:bg-transparent`,
    inherit: "",
    danger: `bg-red-500 border border-red-500 hover:bg-red-600 active:bg-red-700 text-white ${focusClasses} disabled:bg-red-400`
  }
};
const Button = (props) => {
  const {
    children,
    htmlType,
    icon,
    isDisabled,
    isLoading,
    size = "medium",
    title,
    variant = "default",
    onClick = () => {
      return;
    }
  } = props;
  const sizeClasses = children ? classes.sizes[size].withLabel : classes.sizes[size].withoutLabel;
  const colorClasses = isLoading ? classes.loading : classes.variants[variant];
  const className = [classes.base, colorClasses, sizeClasses].join(" ");
  const buttonContent = /* @__PURE__ */ jsxs(Fragment, {
    children: [!isLoading && (icon == null ? void 0 : icon({
      className: classes.sizes[size].icon,
      title: "ButtonIcon"
    })), isLoading && /* @__PURE__ */ jsx(Spinner, {
      size: "small"
    }), children]
  });
  return /* @__PURE__ */ jsx("button", {
    title,
    className,
    type: htmlType,
    disabled: isDisabled || isLoading,
    onClick,
    children: buttonContent
  });
};
const Input = React.forwardRef(({
  className,
  type = "text",
  label,
  errorProps,
  helperProps,
  required,
  name,
  ...props
}, ref) => {
  const hasError = errorProps == null ? void 0 : errorProps.visible;
  return /* @__PURE__ */ jsxs("div", {
    className: "flex flex-col space-y-2",
    children: [label && /* @__PURE__ */ jsxs("label", {
      htmlFor: name,
      className: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      children: [label, required && /* @__PURE__ */ jsx("span", {
        className: "ml-1 text-red-500",
        children: "*"
      })]
    }), /* @__PURE__ */ jsx("input", {
      id: name,
      type,
      name,
      className: cn(
        // base shadcn styles - keeping most original except file classes
        "flex h-10 w-full rounded-md border bg-background px-3 py-2 text-base ring-offset-background placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        // dsl focus style - border outline directly on field, no spacing, midnight-900 color
        "focus:border-midnight-900 focus:ring-midnight-900",
        // conditional border state
        {
          "border-red-500": hasError,
          "border-input": !hasError
        },
        className
      ),
      ref,
      ...props
    }), (helperProps == null ? void 0 : helperProps.display) && /* @__PURE__ */ jsx(FormHelperText, {
      type: "helper",
      display: helperProps.display,
      visible: helperProps.visible,
      size: "large"
    }), (errorProps == null ? void 0 : errorProps.display) && /* @__PURE__ */ jsx(FormHelperText, {
      type: "error",
      display: errorProps.display,
      visible: errorProps.visible,
      size: "large"
    })]
  });
});
Input.displayName = "Input";
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button,
  Input
}, Symbol.toStringTag, { value: "Module" }));
export {
  Accordion,
  ActionBar,
  Alert,
  SvgArrowDown as ArrowDown,
  SvgArrowLeft as ArrowLeftIcon,
  SvgArrowRightFromBracket as ArrowRightFromBracket,
  SvgArrowRight as ArrowRightIcon,
  SvgArrowUp as ArrowUp,
  SvgBaler as BalerIcon,
  SvgBarsProgress as BarsProgressIcon,
  SvgBarsSolid as BarsSolidIcon,
  BatchAction,
  Breadcrumb,
  Button$1 as Button,
  CLEARED_FILTER,
  CLEARED_FILTER_STATE,
  SvgCalculator as CalculatorIcon,
  SvgCalendar as CalendarIcon,
  CalendarMenuType,
  SvgCalendarPlus as CalendarPlusIcon,
  SvgCalendarRange as CalendarRangeIcon,
  SvgCameraSlash as CameraSlashIcon,
  Card,
  SvgCaretDown as CaretDownIcon,
  SvgCart as CartIcon,
  SvgCheckMark as CheckMark,
  Checkbox,
  CheckboxAccordion,
  CheckboxGroup,
  SvgChevronDown as ChevronDownIcon,
  SvgChevronLeft as ChevronLeftIcon,
  SvgChevronRight as ChevronRightIcon,
  Chip,
  SvgCircleCheck as CircleCheckIcon,
  SvgCircleCheckSolid as CircleCheckSolidIcon,
  SvgCircleExclamationSolid as CircleExclamationIcon,
  SvgCircleInfo as CircleInfoIcon,
  SvgCircleInfoSolid as CircleInfoSolidIcon,
  SvgCircleXmark as CircleXmarkIcon,
  SvgClockRotateLeft as ClockRotateLeftIcon,
  ComboBox,
  ComboBoxMenuItem,
  SvgComment as CommentIcon,
  SvgCompologyLogo as CompologyIcon,
  SvgCopy as CopyIcon,
  CopyToClipboardButton,
  DateFilterChip,
  DateFilterDropdown,
  DateFilterMenuContent,
  DatePicker,
  DatePickerActionType,
  DatePickerCalendar,
  SvgDelete as DeleteIcon,
  DescriptionList,
  SvgDiamondExclamation as DiamondExclamationIcon,
  Drawer,
  Dropdown,
  DropdownMenu,
  SvgDrum as DrumIcon,
  SvgDumpster as DumpsterIcon,
  SvgEllipsisVertical as EllipsisVerticalIcon,
  SvgEmptyServices as EmptyServicesImage,
  SvgEnvelope as EnvelopeIcon,
  SvgArrowUpRightFromSquare as ExternalLinkIcon,
  SvgEye as EyeIcon,
  SvgEyeInvisible as EyeInvisibleIcon,
  Fallback,
  SvgFileCircleInfo as FileCircleInfo,
  SvgFileExport as FileExportIcon,
  SvgFileInvoiceDollar as FileInvoiceDollarIcon,
  SvgFileInvoice as FileInvoiceIcon,
  SvgFilePdf as FilePdfIcon,
  FileUpload,
  SvgFileXmark as FileXMarkIcon,
  FilterChip,
  FilterComboBox,
  FilterComboBoxWrapper,
  SvgFilter as FilterIcon,
  SvgFilterList as FilterListIcon,
  SvgFloppyDisk as FloppyDisk,
  FormHelperText,
  FormattedDateTime,
  FormattedNumber,
  SvgFrontLoadContainer as FrontLoadContainerIcon,
  SvgGoogle as GoogleIcon,
  SvgHandPickup as HandPickupIcon,
  SvgHouse as HouseIcon,
  SvgHouseSolid as HouseSolidIcon,
  SvgHouseUser as HouseUserIcon,
  SvgHouseUserRegular as HouseUserRegularIcon,
  Input$1 as Input,
  InputContext,
  SvgKey as KeyIcon,
  SvgLeaf as LeafIcon,
  SvgLeaves as LeavesImage,
  SvgLink as LinkIcon,
  SvgLinkSimple as LinkSimpleIcon,
  SvgLinkSimpleSlash as LinkSimpleSlashIcon,
  SvgListCheck as ListCheckIcon,
  SvgListTree as ListTreeIcon,
  SvgLocationDot as LocationDotIcon,
  SvgLogoDark as LogoDarkImage,
  SvgLogoLight as LogoLightImage,
  SvgLogoTinyDark as LogoTinyDarkImage,
  SvgLogoTinyLight as LogoTinyLightImage,
  SvgLogoWithTaglineDark as LogoWithTaglineDarkImage,
  SvgLogoWithTaglineLight as LogoWithTaglineLightImage,
  SvgMagnifyingGlassDollar as MagnifyingGlassDollarIcon,
  SvgMagnifyingGlass as MagnifyingGlassIcon,
  Map$1 as Map,
  SvgMemo as MemoIcon,
  MenuList,
  SvgMessageQuestion as MessageQuestionIcon,
  SvgMessages as MessagesIcon,
  SvgMessagesQuestionDuotone as MessagesQuestionDuotoneIcon,
  SvgMessagesQuestionRegular as MessagesQuestionRegularIcon,
  Modal,
  SvgMoneyCheckPen as MoneyCheckPenIcon,
  MultiSelectDropdown,
  NumberRange,
  SvgOtherCompactor as OtherCompactorIcon,
  SvgOtherContainer as OtherContainerIcon,
  PALFilter,
  Pagination$1 as Pagination,
  SvgPaperPlaneTop as PaperPlaneTopIcon,
  SvgPenToSquare as PenToSquareIcon,
  SvgPersonSign as PersonSignIcon,
  SvgPhone as PhoneIcon,
  SvgPhotoCamera as PhotoCameraIcon,
  SvgPlus as PlusIcon,
  Popover,
  ProgressBar,
  QuickFilterButton,
  RadioAccordion,
  RadioButton,
  RadioButtonGroup,
  RadioDropdown,
  RadioInput,
  RangePicker,
  SvgRearLoadContainer as RearLoadContainerIcon,
  SvgRecycle as RecycleIcon,
  SvgRepeat as RepeatIcon,
  SvgRollOffCompactor as RollOffCompactorIcon,
  SvgRollOffOpenTop as RollOffOpenTopIcon,
  SvgScrewdriverWrench as ScrewdriverWrenchIcon,
  SvgScrollOld as ScrollOldIcon,
  SvgSecurityCamera as SecurityCameraIcon,
  SegmentedButton,
  Select,
  ServiceIcon,
  Spinner,
  SvgTable as TableIcon,
  TableLink,
  TablePagination,
  TableSubview,
  TableSubviewButton,
  TableTag,
  TableV2,
  Tag,
  SvgTag as TagIcon,
  TagMenu,
  TextArea,
  TextLink,
  SvgThumbsDown as ThumbsDownIcon,
  SvgThumbsUp as ThumbsUpIcon,
  Toast,
  Tooltip,
  SvgToter as ToterIcon,
  SvgTrashCan as TrashCanIcon,
  SvgTrashClock as TrashClockIcon,
  Tree,
  TreeComboBox,
  SvgTriangleExclamation as TriangleExclamationIcon,
  SvgTruckContainerDuotone as TruckContainerDuotoneIcon,
  SvgTruckContainerRegular as TruckContainerRegularIcon,
  SvgUpload as UploadIcon,
  SvgUserSolid as UserIcon,
  SvgUserRegular as UserRegularIcon,
  SvgXmark as XmarkIcon,
  addStyles,
  clsx,
  cn,
  dateFilterReducer,
  debounce,
  getBoundingBox,
  getFormatted,
  getTreeData,
  getWidth,
  isCompleteFilter,
  isDisabledDate,
  mergeStyles,
  portalElement,
  relativeToAbsoluteUrl,
  removeRedundantKeys,
  renderListItemWithTag,
  setHTMLObjectValue,
  setInputValue,
  stopKeyboardEventHandler,
  stopMousePropagation,
  toVal,
  triggerOnChange,
  useChildrenWithProps,
  useDateFilterState,
  useFilterComboboxSelection,
  useInputContext,
  useWindowSize,
  index as v2
};
